import type * as DateTypes from "../common/dates/index"
import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '../apollo/hooks/customApolloHooks/customApolloHooks';
export type Maybe<T> = T;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  CountryCode: { input: string; output: string; }
  Currency: { input: string; output: string; }
  Date: { input: string; output: string; }
  DateTime: { input: DateTypes.TimestampTZString; output: DateTypes.TimestampTZString; }
  EmailAddress: { input: string; output: string; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  LocalDate: { input: DateTypes.LocalDateString; output: DateTypes.LocalDateString; }
  LocalDateRange: { input: DateTypes.LocalDateRangeString; output: DateTypes.LocalDateRangeString; }
  NonEmptyString: { input: string; output: string; }
  NonNegativeFloat: { input: number; output: number; }
  NonNegativeInt: { input: number; output: number; }
  NumericRange: { input: string; output: string; }
  PhoneNumber: { input: string; output: string; }
  PositiveInt: { input: number; output: number; }
  PostalCode: { input: string; output: string; }
  URL: { input: string; output: string; }
  _numeric: { input: number[]; output: number[]; }
  _text: { input: string[]; output: string[]; }
  _uuid: { input: string; output: string; }
  _varchar: { input: string[]; output: string[]; }
  bpchar: { input: string; output: string; }
  citext: { input: string; output: string; }
  cms_DateTime_content: { input: string; output: string; }
  cms_I18NLocaleCode_content: { input: string; output: string; }
  cms_JSON_content: { input: string; output: string; }
  cms_Upload_content: { input: string; output: string; }
  date: { input: string; output: string; }
  daterange: { input: string; output: string; }
  file_type_enum: { input: {"PDF":"pdf","AUDIO":"audio","VIDEO":"video"}; output: {"PDF":"pdf","AUDIO":"audio","VIDEO":"video"}; }
  int4range: { input: string; output: string; }
  interval: { input: string; output: string; }
  json: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: number; output: number; }
  numrange: { input: string; output: string; }
  sex: { input: string; output: string; }
  smallint: { input: number; output: number; }
  timestamp: { input: DateTypes.LocalDateTimeString | string; output: DateTypes.LocalDateTimeString | string; }
  timestamptz: { input: DateTypes.TimestampTZString | string; output: DateTypes.TimestampTZString | string; }
  tstzrange: { input: string; output: string; }
  uuid: { input: string; output: string; }
};

export enum ACTION_PLAN_SUGGESTION_TYPE {
  DETERMINISTIC = 'DETERMINISTIC',
  GPT4_1106_PREVIEW = 'GPT4_1106_PREVIEW',
  GPT_3 = 'GPT_3',
  GPT_4 = 'GPT_4'
}

export type ActionItemSupplementInput = {
  servings?: Scalars['NonNegativeFloat']['input'];
  supplementId: Scalars['uuid']['input'];
};

export type ActionPlanProfileCategoryRating = {
  action_item_id: Scalars['uuid']['input'];
  instance_value: Scalars['NonNegativeInt']['input'];
  value?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_comparison_exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type CartItemInput = {
  /** product id */
  id: Scalars['uuid']['input'];
  quantity: Scalars['Float']['input'];
};

export type ClearActionItemUserInstanceInput = {
  actionItemUserId: Scalars['uuid']['input'];
  /** The calendar date (eg 2022-01-02) on which this ocurred. Automatically adds to the correct period */
  date: Scalars['LocalDate']['input'];
};

export enum CombinedIntegrationTypes {
  apple_healthkit = 'apple_healthkit',
  body_metrix = 'body_metrix',
  brain_upgrade = 'brain_upgrade',
  bridge = 'bridge',
  fitbit = 'fitbit',
  garmin = 'garmin',
  oura = 'oura',
  strava = 'strava',
  vald = 'vald',
  whoop = 'whoop',
  withings = 'withings',
  zenoti = 'zenoti'
}

export type CreateLabProfileInput = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  partial?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
  sex?: InputMaybe<enum_selfdecode_sex_enum>;
  shipToAddress?: InputMaybe<Scalars['NonEmptyString']['input']>;
  shipToAddress1?: InputMaybe<Scalars['String']['input']>;
  shipToCity?: InputMaybe<Scalars['NonEmptyString']['input']>;
  shipToCountry?: InputMaybe<Scalars['CountryCode']['input']>;
  shipToPostalCode?: InputMaybe<Scalars['PostalCode']['input']>;
  shipToState?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type CreateSupplementRecordInput = {
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Number of servings */
  servings: Scalars['Float']['input'];
  /** If true, sets the supplement value for the timeframe instead of adding to it */
  setValue?: Scalars['Boolean']['input'];
  supplementId: Scalars['uuid']['input'];
  timeframe?: InputMaybe<enum_timeframe_enum>;
};

export type CreateUserMetricInputType = {
  default_weekly_rollup_type?: InputMaybe<enum_metric_rollup_type_enum>;
  measure_type?: InputMaybe<measure_type>;
  metric_type?: InputMaybe<metric_type_enum>;
  name: Scalars['String']['input'];
  scale_label_high?: InputMaybe<Scalars['String']['input']>;
  scale_label_low?: InputMaybe<Scalars['String']['input']>;
  unit: Scalars['String']['input'];
};

export type CustomPackageTestInput = {
  /** Lab test product id */
  id: Scalars['uuid']['input'];
  quantity: Scalars['Float']['input'];
};

export enum FranchiseCountryEnum {
  CA = 'CA',
  US = 'US'
}

export type GoalSurveyOption = {
  optionId: Scalars['String']['input'];
  score: GoalSurveyOptionScore;
};

export type GoalSurveyOptionScore = {
  Cardiovascular_Fitness?: InputMaybe<Scalars['Float']['input']>;
  Enhanced_Brain_Function?: InputMaybe<Scalars['Float']['input']>;
  Improved_Energy?: InputMaybe<Scalars['Float']['input']>;
  Libido?: InputMaybe<Scalars['Float']['input']>;
  Longevity?: InputMaybe<Scalars['Float']['input']>;
  Manage_Stress_Better?: InputMaybe<Scalars['Float']['input']>;
  Muscle_Mass_And_More_Strength?: InputMaybe<Scalars['Float']['input']>;
  Sleep?: InputMaybe<Scalars['Float']['input']>;
  Vision?: InputMaybe<Scalars['Float']['input']>;
  Weight_Loss?: InputMaybe<Scalars['Float']['input']>;
};

export type GoalSurveyQuestion = {
  questionId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type GoalsSurveyResponse = {
  question: GoalSurveyQuestion;
  response: GoalSurveyOption;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_comparison_exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type LabMetricResultInput = {
  datetime: Scalars['timestamptz']['input'];
  results: Array<LabMetricResultItemInput>;
  user_vault_file_id: Scalars['uuid']['input'];
};

export type LabMetricResultItemInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  loincNumber?: InputMaybe<Scalars['String']['input']>;
  markerId: Scalars['uuid']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  referenceRange?: InputMaybe<ReferenceRangeFullInput>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type MetricRecordCreateInputType = {
  datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  day?: InputMaybe<Scalars['LocalDate']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  metric_id?: InputMaybe<Scalars['uuid']['input']>;
  namespace?: InputMaybe<enum_metric_namespace_enum>;
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_array?: InputMaybe<Array<Scalars['Float']['input']>>;
  value_range?: InputMaybe<Scalars['String']['input']>;
  value_string?: InputMaybe<Scalars['String']['input']>;
  value_time_series?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type MetricRecordUpdateWithIdInputType = {
  datetime?: InputMaybe<Scalars['timestamptz']['input']>;
  id: Scalars['uuid']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
  value_array?: InputMaybe<Array<Scalars['Float']['input']>>;
  value_range?: InputMaybe<Scalars['String']['input']>;
  value_string?: InputMaybe<Scalars['String']['input']>;
  value_time_series?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type MetricTargetCreateInputType = {
  aggregate_type?: enum_aggregate_type_enum;
  interval_count?: InputMaybe<Scalars['Float']['input']>;
  interval_type?: InputMaybe<enum_rollup_interval_type_enum>;
  metric_id: Scalars['uuid']['input'];
  target: Scalars['String']['input'];
};

export type PhlebotomyAppointmentAvailabilityInput = {
  city: Scalars['String']['input'];
  first_line: Scalars['String']['input'];
  second_line?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zip_code: Scalars['PostalCode']['input'];
};

export enum RECOMMENDATION_ITEM_TYPE {
  LIFESTYLE = 'LIFESTYLE',
  MEASURE = 'MEASURE',
  SUPPLEMENT = 'SUPPLEMENT'
}

export type RecordActionItemUserInstanceInput = {
  actionItemUserId: Scalars['uuid']['input'];
  /** Mark action as complete/incomplete regardless of passed value */
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ISO calendar date (eg 2022-01-02) on which this ocurred. Defaults to today. Future values are not allowed */
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Required if `completed` is NULL */
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type ReferenceRangeFullInput = {
  dataSource?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  ranges: Array<ReferenceRangeTargetInput>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type ReferenceRangeTargetInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  optimal?: InputMaybe<Scalars['Boolean']['input']>;
  range: Scalars['String']['input'];
};

export type RunMetricCalculatorInput = {
  key: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type SaveContactEnquiryInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  orderNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_comparison_exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type SyncRequestInput = {
  integrations: Array<CombinedIntegrationTypes>;
};

export type UserCloneDashboardInputDto = {
  id: Scalars['uuid']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UserGoalInput = {
  focus?: InputMaybe<Scalars['Boolean']['input']>;
  goalId: Scalars['uuid']['input'];
  priority: Scalars['Float']['input'];
};

export enum ZenotiPackageTypeEnum {
  DayPackage = 'DayPackage',
  PromoPackage = 'PromoPackage',
  SeriesPackage = 'SeriesPackage'
}

/** Boolean expression to compare columns of type "_numeric". All fields are combined with logical 'AND'. */
export type _numeric_comparison_exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Scalars['_numeric']['input']>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Scalars['_numeric']['input']>;
  _eq?: InputMaybe<Scalars['_numeric']['input']>;
  _gt?: InputMaybe<Scalars['_numeric']['input']>;
  _gte?: InputMaybe<Scalars['_numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['_numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['_numeric']['input']>;
  _lte?: InputMaybe<Scalars['_numeric']['input']>;
  _neq?: InputMaybe<Scalars['_numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['_numeric']['input']>>;
};

/** Boolean expression to compare columns of type "_text". All fields are combined with logical 'AND'. */
export type _text_comparison_exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Scalars['_text']['input']>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Scalars['_text']['input']>;
  _eq?: InputMaybe<Scalars['_text']['input']>;
  _gt?: InputMaybe<Scalars['_text']['input']>;
  _gte?: InputMaybe<Scalars['_text']['input']>;
  _in?: InputMaybe<Array<Scalars['_text']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['_text']['input']>;
  _lte?: InputMaybe<Scalars['_text']['input']>;
  _neq?: InputMaybe<Scalars['_text']['input']>;
  _nin?: InputMaybe<Array<Scalars['_text']['input']>>;
};

/** order by aggregate values of table "action_item" */
export type action_item_aggregate_order_by = {
  avg?: InputMaybe<action_item_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<action_item_max_order_by>;
  min?: InputMaybe<action_item_min_order_by>;
  stddev?: InputMaybe<action_item_stddev_order_by>;
  stddev_pop?: InputMaybe<action_item_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<action_item_stddev_samp_order_by>;
  sum?: InputMaybe<action_item_sum_order_by>;
  var_pop?: InputMaybe<action_item_var_pop_order_by>;
  var_samp?: InputMaybe<action_item_var_samp_order_by>;
  variance?: InputMaybe<action_item_variance_order_by>;
};

/** order by avg() on columns of table "action_item" */
export type action_item_avg_order_by = {
  interval_count?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "action_item". All fields are combined with a logical 'AND'. */
export type action_item_bool_exp = {
  _and?: InputMaybe<Array<action_item_bool_exp>>;
  _not?: InputMaybe<action_item_bool_exp>;
  _or?: InputMaybe<Array<action_item_bool_exp>>;
  action_item_inputs?: InputMaybe<action_item_input_bool_exp>;
  action_item_users?: InputMaybe<action_item_user_bool_exp>;
  action_plan_suggestion_items?: InputMaybe<action_plan_suggestion_item_bool_exp>;
  action_type?: InputMaybe<enum_action_item_type_enum_comparison_exp>;
  circle_visible_action_items?: InputMaybe<circle_action_items_flat_bool_exp>;
  configs?: InputMaybe<action_item_config_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  hero_image?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  instance_target?: InputMaybe<int4range_comparison_exp>;
  instance_target_type?: InputMaybe<enum_action_item_instance_target_type_enum_comparison_exp>;
  interval?: InputMaybe<interval_comparison_exp>;
  interval_count?: InputMaybe<Int_comparison_exp>;
  interval_type?: InputMaybe<enum_rollup_interval_type_enum_comparison_exp>;
  is_owner?: InputMaybe<Boolean_comparison_exp>;
  is_public?: InputMaybe<Boolean_comparison_exp>;
  is_visible?: InputMaybe<Boolean_comparison_exp>;
  kpi_snapshot_priority?: InputMaybe<kpi_snapshot_action_item_priority_bool_exp>;
  kpis?: InputMaybe<kpi_action_item_bool_exp>;
  labels?: InputMaybe<action_item_label_bool_exp>;
  logger_type?: InputMaybe<enum_action_item_logger_type_enum_comparison_exp>;
  metric_id?: InputMaybe<uuid_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  name_show_placeholders?: InputMaybe<Boolean_comparison_exp>;
  preference_unit?: InputMaybe<unit_bool_exp>;
  preference_value_target?: InputMaybe<String_comparison_exp>;
  prevent_add_to_circle?: InputMaybe<Boolean_comparison_exp>;
  prevent_add_to_circle_reason?: InputMaybe<String_comparison_exp>;
  summary?: InputMaybe<String_comparison_exp>;
  thumbnail_image?: InputMaybe<String_comparison_exp>;
  timeframe?: InputMaybe<enum_timeframe_enum_comparison_exp>;
  unit_id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
  value_rollup_interval_type?: InputMaybe<enum_rollup_interval_type_enum_comparison_exp>;
  value_rollup_type?: InputMaybe<enum_metric_rollup_type_enum_comparison_exp>;
  value_target?: InputMaybe<numrange_comparison_exp>;
};

/** Boolean expression to filter rows from the table "action_item_config". All fields are combined with a logical 'AND'. */
export type action_item_config_bool_exp = {
  _and?: InputMaybe<Array<action_item_config_bool_exp>>;
  _not?: InputMaybe<action_item_config_bool_exp>;
  _or?: InputMaybe<Array<action_item_config_bool_exp>>;
  action_item?: InputMaybe<action_item_bool_exp>;
  action_item_id?: InputMaybe<uuid_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  external_id?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  instance_target?: InputMaybe<int4range_comparison_exp>;
  instance_target_type?: InputMaybe<enum_action_item_instance_target_type_enum_comparison_exp>;
  interval?: InputMaybe<interval_comparison_exp>;
  interval_count?: InputMaybe<Int_comparison_exp>;
  interval_type?: InputMaybe<enum_rollup_interval_type_enum_comparison_exp>;
  logger_type?: InputMaybe<enum_action_item_logger_type_enum_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  sort_order?: InputMaybe<Int_comparison_exp>;
  supplements?: InputMaybe<action_item_config_supplement_bool_exp>;
  template_item?: InputMaybe<action_plan_template_item_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  value_rollup_interval_type?: InputMaybe<enum_rollup_interval_type_enum_comparison_exp>;
  value_rollup_type?: InputMaybe<enum_metric_rollup_type_enum_comparison_exp>;
  value_target?: InputMaybe<numrange_comparison_exp>;
  weekly_instance_target?: InputMaybe<int4range_comparison_exp>;
};

/** Boolean expression to filter rows from the table "action_item_config_supplement". All fields are combined with a logical 'AND'. */
export type action_item_config_supplement_bool_exp = {
  _and?: InputMaybe<Array<action_item_config_supplement_bool_exp>>;
  _not?: InputMaybe<action_item_config_supplement_bool_exp>;
  _or?: InputMaybe<Array<action_item_config_supplement_bool_exp>>;
  action_item_config?: InputMaybe<action_item_config_bool_exp>;
  action_item_config_id?: InputMaybe<uuid_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  servings?: InputMaybe<numeric_comparison_exp>;
  supplement?: InputMaybe<supplement_bool_exp>;
  supplement_id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "action_item" */
export enum action_item_constraint {
  /** unique or primary key constraint on columns "id" */
  action_item_pkey = 'action_item_pkey'
}

/** input type for inserting array relation for remote table "action_item_input" */
export type action_item_input_arr_rel_insert_input = {
  data: Array<action_item_input_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<action_item_input_on_conflict>;
};

/** Boolean expression to filter rows from the table "action_item_input". All fields are combined with a logical 'AND'. */
export type action_item_input_bool_exp = {
  _and?: InputMaybe<Array<action_item_input_bool_exp>>;
  _not?: InputMaybe<action_item_input_bool_exp>;
  _or?: InputMaybe<Array<action_item_input_bool_exp>>;
  action_item?: InputMaybe<action_item_bool_exp>;
  action_item_id?: InputMaybe<uuid_comparison_exp>;
  action_item_user_inputs?: InputMaybe<action_item_user_input_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  data_source?: InputMaybe<enum_data_source_enum_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  input_type?: InputMaybe<enum_action_item_input_type_enum_comparison_exp>;
  metric?: InputMaybe<metric_bool_exp>;
  metric_id?: InputMaybe<uuid_comparison_exp>;
  scale_high?: InputMaybe<smallint_comparison_exp>;
  scale_low?: InputMaybe<smallint_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  variants?: InputMaybe<_text_comparison_exp>;
};

/** unique or primary key constraints on table "action_item_input" */
export enum action_item_input_constraint {
  /** unique or primary key constraint on columns "id" */
  action_item_input_pkey = 'action_item_input_pkey'
}

/** input type for inserting data into table "action_item_input" */
export type action_item_input_insert_input = {
  action_item?: InputMaybe<action_item_obj_rel_insert_input>;
  action_item_id?: InputMaybe<Scalars['uuid']['input']>;
  data_source?: InputMaybe<enum_data_source_enum>;
  input_type?: InputMaybe<enum_action_item_input_type_enum>;
  metric?: InputMaybe<metric_obj_rel_insert_input>;
  metric_id?: InputMaybe<Scalars['uuid']['input']>;
  scale_high?: InputMaybe<Scalars['smallint']['input']>;
  scale_low?: InputMaybe<Scalars['smallint']['input']>;
  variants?: InputMaybe<Scalars['_text']['input']>;
};

/** on_conflict condition type for table "action_item_input" */
export type action_item_input_on_conflict = {
  constraint: action_item_input_constraint;
  update_columns?: Array<action_item_input_update_column>;
  where?: InputMaybe<action_item_input_bool_exp>;
};

/** placeholder for update columns of table "action_item_input" (current role has no relevant permissions) */
export enum action_item_input_update_column {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** input type for inserting data into table "action_item" */
export type action_item_insert_input = {
  action_item_inputs?: InputMaybe<action_item_input_arr_rel_insert_input>;
  description?: InputMaybe<Scalars['String']['input']>;
  hero_image?: InputMaybe<Scalars['String']['input']>;
  instance_target?: InputMaybe<Scalars['int4range']['input']>;
  interval_count?: InputMaybe<Scalars['Int']['input']>;
  interval_type?: InputMaybe<enum_rollup_interval_type_enum>;
  labels?: InputMaybe<action_item_label_arr_rel_insert_input>;
  logger_type?: InputMaybe<enum_action_item_logger_type_enum>;
  metric_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_show_placeholders?: InputMaybe<Scalars['Boolean']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  thumbnail_image?: InputMaybe<Scalars['String']['input']>;
  timeframe?: InputMaybe<enum_timeframe_enum>;
  unit_id?: InputMaybe<Scalars['uuid']['input']>;
  value_rollup_interval_type?: InputMaybe<enum_rollup_interval_type_enum>;
  value_rollup_type?: InputMaybe<enum_metric_rollup_type_enum>;
  value_target?: InputMaybe<Scalars['numrange']['input']>;
};

/** input type for inserting array relation for remote table "action_item_label" */
export type action_item_label_arr_rel_insert_input = {
  data: Array<action_item_label_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<action_item_label_on_conflict>;
};

/** Boolean expression to filter rows from the table "action_item_label". All fields are combined with a logical 'AND'. */
export type action_item_label_bool_exp = {
  _and?: InputMaybe<Array<action_item_label_bool_exp>>;
  _not?: InputMaybe<action_item_label_bool_exp>;
  _or?: InputMaybe<Array<action_item_label_bool_exp>>;
  action_item?: InputMaybe<action_item_bool_exp>;
  action_item_id?: InputMaybe<uuid_comparison_exp>;
  label?: InputMaybe<label_bool_exp>;
  label_id?: InputMaybe<uuid_comparison_exp>;
  sort_order?: InputMaybe<Int_comparison_exp>;
};

/** unique or primary key constraints on table "action_item_label" */
export enum action_item_label_constraint {
  /** unique or primary key constraint on columns "label_id", "action_item_id" */
  action_item_label_pkey = 'action_item_label_pkey'
}

/** input type for inserting data into table "action_item_label" */
export type action_item_label_insert_input = {
  action_item?: InputMaybe<action_item_obj_rel_insert_input>;
  action_item_id?: InputMaybe<Scalars['uuid']['input']>;
  label_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "action_item_label" */
export type action_item_label_on_conflict = {
  constraint: action_item_label_constraint;
  update_columns?: Array<action_item_label_update_column>;
  where?: InputMaybe<action_item_label_bool_exp>;
};

/** placeholder for update columns of table "action_item_label" (current role has no relevant permissions) */
export enum action_item_label_update_column {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** order by max() on columns of table "action_item" */
export type action_item_max_order_by = {
  created_at?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  hero_image?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  interval_count?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  prevent_add_to_circle_reason?: InputMaybe<order_by>;
  summary?: InputMaybe<order_by>;
  thumbnail_image?: InputMaybe<order_by>;
  unit_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "action_item" */
export type action_item_min_order_by = {
  created_at?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  hero_image?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  interval_count?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  prevent_add_to_circle_reason?: InputMaybe<order_by>;
  summary?: InputMaybe<order_by>;
  thumbnail_image?: InputMaybe<order_by>;
  unit_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** input type for inserting object relation for remote table "action_item" */
export type action_item_obj_rel_insert_input = {
  data: action_item_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<action_item_on_conflict>;
};

/** on_conflict condition type for table "action_item" */
export type action_item_on_conflict = {
  constraint: action_item_constraint;
  update_columns?: Array<action_item_update_column>;
  where?: InputMaybe<action_item_bool_exp>;
};

/** order by stddev() on columns of table "action_item" */
export type action_item_stddev_order_by = {
  interval_count?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "action_item" */
export type action_item_stddev_pop_order_by = {
  interval_count?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "action_item" */
export type action_item_stddev_samp_order_by = {
  interval_count?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "action_item" */
export type action_item_sum_order_by = {
  interval_count?: InputMaybe<order_by>;
};

/** update columns of table "action_item" */
export enum action_item_update_column {
  /** column name */
  description = 'description',
  /** column name */
  hero_image = 'hero_image',
  /** column name */
  instance_target = 'instance_target',
  /** column name */
  interval_count = 'interval_count',
  /** column name */
  interval_type = 'interval_type',
  /** column name */
  logger_type = 'logger_type',
  /** column name */
  metric_id = 'metric_id',
  /** column name */
  name = 'name',
  /** column name */
  name_show_placeholders = 'name_show_placeholders',
  /** column name */
  summary = 'summary',
  /** column name */
  thumbnail_image = 'thumbnail_image',
  /** column name */
  timeframe = 'timeframe',
  /** column name */
  unit_id = 'unit_id',
  /** column name */
  value_rollup_interval_type = 'value_rollup_interval_type',
  /** column name */
  value_rollup_type = 'value_rollup_type',
  /** column name */
  value_target = 'value_target'
}

/** order by aggregate values of table "action_item_user" */
export type action_item_user_aggregate_order_by = {
  avg?: InputMaybe<action_item_user_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<action_item_user_max_order_by>;
  min?: InputMaybe<action_item_user_min_order_by>;
  stddev?: InputMaybe<action_item_user_stddev_order_by>;
  stddev_pop?: InputMaybe<action_item_user_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<action_item_user_stddev_samp_order_by>;
  sum?: InputMaybe<action_item_user_sum_order_by>;
  var_pop?: InputMaybe<action_item_user_var_pop_order_by>;
  var_samp?: InputMaybe<action_item_user_var_samp_order_by>;
  variance?: InputMaybe<action_item_user_variance_order_by>;
};

/** order by avg() on columns of table "action_item_user" */
export type action_item_user_avg_order_by = {
  interval_count?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "action_item_user". All fields are combined with a logical 'AND'. */
export type action_item_user_bool_exp = {
  _and?: InputMaybe<Array<action_item_user_bool_exp>>;
  _not?: InputMaybe<action_item_user_bool_exp>;
  _or?: InputMaybe<Array<action_item_user_bool_exp>>;
  action_item?: InputMaybe<action_item_bool_exp>;
  action_item_id?: InputMaybe<uuid_comparison_exp>;
  action_item_user_inputs?: InputMaybe<action_item_user_input_bool_exp>;
  action_item_user_periods?: InputMaybe<action_item_user_period_bool_exp>;
  action_item_user_supplements?: InputMaybe<action_item_user_supplement_bool_exp>;
  added_by_user?: InputMaybe<Boolean_comparison_exp>;
  circle_action_items?: InputMaybe<circle_action_item_bool_exp>;
  circle_membership_action_items?: InputMaybe<circle_membership_action_item_bool_exp>;
  circle_visible_action_items?: InputMaybe<circle_action_items_flat_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  disabled?: InputMaybe<Boolean_comparison_exp>;
  end?: InputMaybe<date_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  instance_target?: InputMaybe<int4range_comparison_exp>;
  instance_target_type?: InputMaybe<enum_action_item_instance_target_type_enum_comparison_exp>;
  interval?: InputMaybe<interval_comparison_exp>;
  interval_count?: InputMaybe<Int_comparison_exp>;
  interval_type?: InputMaybe<enum_rollup_interval_type_enum_comparison_exp>;
  is_owner?: InputMaybe<Boolean_comparison_exp>;
  logger_type?: InputMaybe<enum_action_item_logger_type_enum_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  personalized_name?: InputMaybe<String_comparison_exp>;
  preference_value_target?: InputMaybe<String_comparison_exp>;
  sort_order?: InputMaybe<Int_comparison_exp>;
  start?: InputMaybe<date_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
  value_rollup_interval_type?: InputMaybe<enum_rollup_interval_type_enum_comparison_exp>;
  value_rollup_type?: InputMaybe<enum_metric_rollup_type_enum_comparison_exp>;
  value_target?: InputMaybe<numrange_comparison_exp>;
  weekly_instance_target?: InputMaybe<int4range_comparison_exp>;
};

/** input type for incrementing numeric columns in table "action_item_user" */
export type action_item_user_inc_input = {
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** Boolean expression to filter rows from the table "action_item_user_input". All fields are combined with a logical 'AND'. */
export type action_item_user_input_bool_exp = {
  _and?: InputMaybe<Array<action_item_user_input_bool_exp>>;
  _not?: InputMaybe<action_item_user_input_bool_exp>;
  _or?: InputMaybe<Array<action_item_user_input_bool_exp>>;
  action_item_input?: InputMaybe<action_item_input_bool_exp>;
  action_item_input_id?: InputMaybe<uuid_comparison_exp>;
  action_item_user?: InputMaybe<action_item_user_bool_exp>;
  action_item_user_id?: InputMaybe<uuid_comparison_exp>;
  action_item_user_records?: InputMaybe<action_item_user_record_bool_exp>;
  action_item_user_supplements?: InputMaybe<action_item_user_supplement_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  disabled?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by max() on columns of table "action_item_user" */
export type action_item_user_max_order_by = {
  action_item_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  end?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  interval_count?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  personalized_name?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
  start?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "action_item_user" */
export type action_item_user_min_order_by = {
  action_item_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  end?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  interval_count?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  personalized_name?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
  start?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "action_item_user_period". All fields are combined with a logical 'AND'. */
export type action_item_user_period_bool_exp = {
  _and?: InputMaybe<Array<action_item_user_period_bool_exp>>;
  _not?: InputMaybe<action_item_user_period_bool_exp>;
  _or?: InputMaybe<Array<action_item_user_period_bool_exp>>;
  action_item_user?: InputMaybe<action_item_user_bool_exp>;
  action_item_user_id?: InputMaybe<uuid_comparison_exp>;
  action_item_user_records?: InputMaybe<action_item_user_record_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  instance_target?: InputMaybe<int4range_comparison_exp>;
  instance_target_type?: InputMaybe<enum_action_item_instance_target_type_enum_comparison_exp>;
  period?: InputMaybe<daterange_comparison_exp>;
  period_end?: InputMaybe<date_comparison_exp>;
  period_start?: InputMaybe<date_comparison_exp>;
  preference_value_target?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  value_target?: InputMaybe<numrange_comparison_exp>;
  week?: InputMaybe<date_comparison_exp>;
  weekly_instance_target?: InputMaybe<int4range_comparison_exp>;
};

/** Boolean expression to filter rows from the table "action_item_user_record". All fields are combined with a logical 'AND'. */
export type action_item_user_record_bool_exp = {
  _and?: InputMaybe<Array<action_item_user_record_bool_exp>>;
  _not?: InputMaybe<action_item_user_record_bool_exp>;
  _or?: InputMaybe<Array<action_item_user_record_bool_exp>>;
  action_item_user_input?: InputMaybe<action_item_user_input_bool_exp>;
  action_item_user_input_id?: InputMaybe<uuid_comparison_exp>;
  action_item_user_period?: InputMaybe<action_item_user_period_bool_exp>;
  action_item_user_period_id?: InputMaybe<uuid_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  date?: InputMaybe<date_comparison_exp>;
  datetime?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  metric_record?: InputMaybe<metric_record_bool_exp>;
  metric_record_id?: InputMaybe<uuid_comparison_exp>;
  preference_value?: InputMaybe<String_comparison_exp>;
  single?: InputMaybe<Boolean_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_provided?: InputMaybe<Boolean_comparison_exp>;
  value?: InputMaybe<numeric_comparison_exp>;
  value_override?: InputMaybe<Boolean_comparison_exp>;
  week?: InputMaybe<date_comparison_exp>;
};

/** input type for updating data in table "action_item_user" */
export type action_item_user_set_input = {
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** order by stddev() on columns of table "action_item_user" */
export type action_item_user_stddev_order_by = {
  interval_count?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "action_item_user" */
export type action_item_user_stddev_pop_order_by = {
  interval_count?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "action_item_user" */
export type action_item_user_stddev_samp_order_by = {
  interval_count?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "action_item_user" */
export type action_item_user_sum_order_by = {
  interval_count?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "action_item_user_supplement". All fields are combined with a logical 'AND'. */
export type action_item_user_supplement_bool_exp = {
  _and?: InputMaybe<Array<action_item_user_supplement_bool_exp>>;
  _not?: InputMaybe<action_item_user_supplement_bool_exp>;
  _or?: InputMaybe<Array<action_item_user_supplement_bool_exp>>;
  action_item_user?: InputMaybe<action_item_user_bool_exp>;
  action_item_user_id?: InputMaybe<uuid_comparison_exp>;
  action_item_user_input?: InputMaybe<action_item_user_input_bool_exp>;
  action_item_user_input_id?: InputMaybe<uuid_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  servings?: InputMaybe<numeric_comparison_exp>;
  supplement?: InputMaybe<supplement_bool_exp>;
  supplement_id?: InputMaybe<uuid_comparison_exp>;
  supplement_records?: InputMaybe<supplement_record_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

export type action_item_user_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<action_item_user_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<action_item_user_set_input>;
  /** filter the rows which have to be updated */
  where: action_item_user_bool_exp;
};

/** order by var_pop() on columns of table "action_item_user" */
export type action_item_user_var_pop_order_by = {
  interval_count?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "action_item_user" */
export type action_item_user_var_samp_order_by = {
  interval_count?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "action_item_user" */
export type action_item_user_variance_order_by = {
  interval_count?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "action_item" */
export type action_item_var_pop_order_by = {
  interval_count?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "action_item" */
export type action_item_var_samp_order_by = {
  interval_count?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "action_item" */
export type action_item_variance_order_by = {
  interval_count?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "action_plan_suggestion". All fields are combined with a logical 'AND'. */
export type action_plan_suggestion_bool_exp = {
  _and?: InputMaybe<Array<action_plan_suggestion_bool_exp>>;
  _not?: InputMaybe<action_plan_suggestion_bool_exp>;
  _or?: InputMaybe<Array<action_plan_suggestion_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  items?: InputMaybe<action_plan_suggestion_item_bool_exp>;
  kpi_snapshot?: InputMaybe<kpi_snapshot_bool_exp>;
  kpi_snapshot_id?: InputMaybe<uuid_comparison_exp>;
  kpis?: InputMaybe<action_plan_suggestion_kpi_bool_exp>;
  openai_completion?: InputMaybe<openai_completion_bool_exp>;
  openai_completion_id?: InputMaybe<uuid_comparison_exp>;
  template?: InputMaybe<action_plan_template_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** Boolean expression to filter rows from the table "action_plan_suggestion_item". All fields are combined with a logical 'AND'. */
export type action_plan_suggestion_item_bool_exp = {
  _and?: InputMaybe<Array<action_plan_suggestion_item_bool_exp>>;
  _not?: InputMaybe<action_plan_suggestion_item_bool_exp>;
  _or?: InputMaybe<Array<action_plan_suggestion_item_bool_exp>>;
  action_item?: InputMaybe<action_item_bool_exp>;
  action_item_config?: InputMaybe<action_item_config_bool_exp>;
  action_item_config_id?: InputMaybe<uuid_comparison_exp>;
  action_item_id?: InputMaybe<uuid_comparison_exp>;
  action_plan_suggestion?: InputMaybe<action_plan_suggestion_bool_exp>;
  action_plan_suggestion_id?: InputMaybe<uuid_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** Boolean expression to filter rows from the table "action_plan_suggestion_kpi". All fields are combined with a logical 'AND'. */
export type action_plan_suggestion_kpi_bool_exp = {
  _and?: InputMaybe<Array<action_plan_suggestion_kpi_bool_exp>>;
  _not?: InputMaybe<action_plan_suggestion_kpi_bool_exp>;
  _or?: InputMaybe<Array<action_plan_suggestion_kpi_bool_exp>>;
  action_plan_suggestion_id?: InputMaybe<uuid_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  kpi?: InputMaybe<kpi_bool_exp>;
  kpi_id?: InputMaybe<uuid_comparison_exp>;
  rank?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** Boolean expression to filter rows from the table "action_plan_template". All fields are combined with a logical 'AND'. */
export type action_plan_template_bool_exp = {
  _and?: InputMaybe<Array<action_plan_template_bool_exp>>;
  _not?: InputMaybe<action_plan_template_bool_exp>;
  _or?: InputMaybe<Array<action_plan_template_bool_exp>>;
  category?: InputMaybe<enum_action_plan_template_category_enum_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  items?: InputMaybe<action_plan_template_item_bool_exp>;
  level?: InputMaybe<String_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** Boolean expression to filter rows from the table "action_plan_template_item". All fields are combined with a logical 'AND'. */
export type action_plan_template_item_bool_exp = {
  _and?: InputMaybe<Array<action_plan_template_item_bool_exp>>;
  _not?: InputMaybe<action_plan_template_item_bool_exp>;
  _or?: InputMaybe<Array<action_plan_template_item_bool_exp>>;
  action_item_config?: InputMaybe<action_item_config_bool_exp>;
  action_item_config_id?: InputMaybe<uuid_comparison_exp>;
  action_item_priority?: InputMaybe<kpi_snapshot_action_item_priority_bool_exp>;
  action_plan_template?: InputMaybe<action_plan_template_bool_exp>;
  action_plan_template_id?: InputMaybe<uuid_comparison_exp>;
  category?: InputMaybe<enum_action_plan_template_item_category_enum_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** Boolean expression to compare columns of type "bpchar". All fields are combined with logical 'AND'. */
export type bpchar_comparison_exp = {
  _eq?: InputMaybe<Scalars['bpchar']['input']>;
  _gt?: InputMaybe<Scalars['bpchar']['input']>;
  _gte?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['bpchar']['input']>;
  _in?: InputMaybe<Array<Scalars['bpchar']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['bpchar']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['bpchar']['input']>;
  _lt?: InputMaybe<Scalars['bpchar']['input']>;
  _lte?: InputMaybe<Scalars['bpchar']['input']>;
  _neq?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['bpchar']['input']>;
  _nin?: InputMaybe<Array<Scalars['bpchar']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['bpchar']['input']>;
};

/** order by aggregate values of table "bridge_user" */
export type bridge_user_aggregate_order_by = {
  avg?: InputMaybe<bridge_user_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<bridge_user_max_order_by>;
  min?: InputMaybe<bridge_user_min_order_by>;
  stddev?: InputMaybe<bridge_user_stddev_order_by>;
  stddev_pop?: InputMaybe<bridge_user_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<bridge_user_stddev_samp_order_by>;
  sum?: InputMaybe<bridge_user_sum_order_by>;
  var_pop?: InputMaybe<bridge_user_var_pop_order_by>;
  var_samp?: InputMaybe<bridge_user_var_samp_order_by>;
  variance?: InputMaybe<bridge_user_variance_order_by>;
};

/** order by avg() on columns of table "bridge_user" */
export type bridge_user_avg_order_by = {
  bridge_user_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "bridge_user". All fields are combined with a logical 'AND'. */
export type bridge_user_bool_exp = {
  _and?: InputMaybe<Array<bridge_user_bool_exp>>;
  _not?: InputMaybe<bridge_user_bool_exp>;
  _or?: InputMaybe<Array<bridge_user_bool_exp>>;
  bridge_user_id?: InputMaybe<Int_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "bridge_user" */
export type bridge_user_max_order_by = {
  bridge_user_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "bridge_user" */
export type bridge_user_min_order_by = {
  bridge_user_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by stddev() on columns of table "bridge_user" */
export type bridge_user_stddev_order_by = {
  bridge_user_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "bridge_user" */
export type bridge_user_stddev_pop_order_by = {
  bridge_user_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "bridge_user" */
export type bridge_user_stddev_samp_order_by = {
  bridge_user_id?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "bridge_user" */
export type bridge_user_sum_order_by = {
  bridge_user_id?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "bridge_user" */
export type bridge_user_var_pop_order_by = {
  bridge_user_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "bridge_user" */
export type bridge_user_var_samp_order_by = {
  bridge_user_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "bridge_user" */
export type bridge_user_variance_order_by = {
  bridge_user_id?: InputMaybe<order_by>;
};

/** input type for inserting array relation for remote table "circle_action_item" */
export type circle_action_item_arr_rel_insert_input = {
  data: Array<circle_action_item_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<circle_action_item_on_conflict>;
};

/** Boolean expression to filter rows from the table "circle_action_item". All fields are combined with a logical 'AND'. */
export type circle_action_item_bool_exp = {
  _and?: InputMaybe<Array<circle_action_item_bool_exp>>;
  _not?: InputMaybe<circle_action_item_bool_exp>;
  _or?: InputMaybe<Array<circle_action_item_bool_exp>>;
  action_item_user?: InputMaybe<action_item_user_bool_exp>;
  action_item_user_id?: InputMaybe<uuid_comparison_exp>;
  circle?: InputMaybe<circle_bool_exp>;
  circle_id?: InputMaybe<uuid_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  disabled?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  sort_order?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  version?: InputMaybe<Int_comparison_exp>;
};

/** unique or primary key constraints on table "circle_action_item" */
export enum circle_action_item_constraint {
  /** unique or primary key constraint on columns "circle_id", "action_item_user_id" */
  circle_action_item_circle_id_action_item_user_id_idx = 'circle_action_item_circle_id_action_item_user_id_idx',
  /** unique or primary key constraint on columns "id" */
  circle_action_item_pkey = 'circle_action_item_pkey'
}

/** input type for inserting data into table "circle_action_item" */
export type circle_action_item_insert_input = {
  action_item_user_id?: InputMaybe<Scalars['uuid']['input']>;
  circle?: InputMaybe<circle_obj_rel_insert_input>;
  circle_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** on_conflict condition type for table "circle_action_item" */
export type circle_action_item_on_conflict = {
  constraint: circle_action_item_constraint;
  update_columns?: Array<circle_action_item_update_column>;
  where?: InputMaybe<circle_action_item_bool_exp>;
};

/** input type for updating data in table "circle_action_item" */
export type circle_action_item_set_input = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "circle_action_item" */
export enum circle_action_item_update_column {
  /** column name */
  disabled = 'disabled'
}

export type circle_action_item_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<circle_action_item_set_input>;
  /** filter the rows which have to be updated */
  where: circle_action_item_bool_exp;
};

/** Boolean expression to filter rows from the table "circle_action_items_flat". All fields are combined with a logical 'AND'. */
export type circle_action_items_flat_bool_exp = {
  _and?: InputMaybe<Array<circle_action_items_flat_bool_exp>>;
  _not?: InputMaybe<circle_action_items_flat_bool_exp>;
  _or?: InputMaybe<Array<circle_action_items_flat_bool_exp>>;
  action_item?: InputMaybe<action_item_bool_exp>;
  action_item_id?: InputMaybe<uuid_comparison_exp>;
  action_item_user_id?: InputMaybe<uuid_comparison_exp>;
  circle?: InputMaybe<circle_bool_exp>;
  circle_id?: InputMaybe<uuid_comparison_exp>;
  template_action_item_user?: InputMaybe<action_item_user_bool_exp>;
};

/** order by aggregate values of table "circle" */
export type circle_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<circle_max_order_by>;
  min?: InputMaybe<circle_min_order_by>;
};

/** Boolean expression to filter rows from the table "circle". All fields are combined with a logical 'AND'. */
export type circle_bool_exp = {
  _and?: InputMaybe<Array<circle_bool_exp>>;
  _not?: InputMaybe<circle_bool_exp>;
  _or?: InputMaybe<Array<circle_bool_exp>>;
  action_items?: InputMaybe<circle_action_item_bool_exp>;
  action_items_v2?: InputMaybe<circle_action_items_flat_bool_exp>;
  checkout_bundle?: InputMaybe<stripe_checkout_bundle_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  enable_member_invites?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  invites?: InputMaybe<circle_invite_bool_exp>;
  is_owner?: InputMaybe<Boolean_comparison_exp>;
  membership_action_item_summary?: InputMaybe<circle_membership_action_item_summary_bool_exp>;
  memberships?: InputMaybe<circle_membership_bool_exp>;
  name?: InputMaybe<String_comparison_exp>;
  owner?: InputMaybe<user_profile_bool_exp>;
  owner_id?: InputMaybe<String_comparison_exp>;
  public?: InputMaybe<Boolean_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "circle" */
export enum circle_constraint {
  /** unique or primary key constraint on columns "id" */
  circle_pkey = 'circle_pkey',
  /** unique or primary key constraint on columns "slug" */
  circle_slug_key = 'circle_slug_key'
}

/** input type for inserting data into table "circle" */
export type circle_insert_input = {
  action_items?: InputMaybe<circle_action_item_arr_rel_insert_input>;
  enable_member_invites?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "circle_invite" */
export type circle_invite_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<circle_invite_max_order_by>;
  min?: InputMaybe<circle_invite_min_order_by>;
};

/** Boolean expression to filter rows from the table "circle_invite". All fields are combined with a logical 'AND'. */
export type circle_invite_bool_exp = {
  _and?: InputMaybe<Array<circle_invite_bool_exp>>;
  _not?: InputMaybe<circle_invite_bool_exp>;
  _or?: InputMaybe<Array<circle_invite_bool_exp>>;
  circle?: InputMaybe<circle_bool_exp>;
  circle_id?: InputMaybe<uuid_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  enabled?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  inviter?: InputMaybe<user_profile_bool_exp>;
  short_id?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "circle_invite" */
export type circle_invite_max_order_by = {
  circle_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  short_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "circle_invite" */
export type circle_invite_min_order_by = {
  circle_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  short_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by max() on columns of table "circle" */
export type circle_max_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  owner_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "circle_membership_action_item". All fields are combined with a logical 'AND'. */
export type circle_membership_action_item_bool_exp = {
  _and?: InputMaybe<Array<circle_membership_action_item_bool_exp>>;
  _not?: InputMaybe<circle_membership_action_item_bool_exp>;
  _or?: InputMaybe<Array<circle_membership_action_item_bool_exp>>;
  action_item_user?: InputMaybe<action_item_user_bool_exp>;
  action_item_user_id?: InputMaybe<uuid_comparison_exp>;
  circle_action_item?: InputMaybe<circle_action_item_bool_exp>;
  circle_action_item_id?: InputMaybe<uuid_comparison_exp>;
  circle_membership?: InputMaybe<circle_membership_bool_exp>;
  circle_membership_id?: InputMaybe<uuid_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  latest_circle_action_item_version?: InputMaybe<Int_comparison_exp>;
  new_version_available?: InputMaybe<Boolean_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  version?: InputMaybe<Int_comparison_exp>;
};

/** Boolean expression to filter rows from the table "circle_membership_action_item_summary". All fields are combined with a logical 'AND'. */
export type circle_membership_action_item_summary_bool_exp = {
  _and?: InputMaybe<Array<circle_membership_action_item_summary_bool_exp>>;
  _not?: InputMaybe<circle_membership_action_item_summary_bool_exp>;
  _or?: InputMaybe<Array<circle_membership_action_item_summary_bool_exp>>;
  action_item?: InputMaybe<action_item_bool_exp>;
  action_item_id?: InputMaybe<uuid_comparison_exp>;
  action_item_user?: InputMaybe<action_item_user_bool_exp>;
  action_item_user_disabled?: InputMaybe<Boolean_comparison_exp>;
  action_item_user_id?: InputMaybe<uuid_comparison_exp>;
  change_type?: InputMaybe<String_comparison_exp>;
  circle?: InputMaybe<circle_bool_exp>;
  circle_action_item?: InputMaybe<circle_action_item_bool_exp>;
  circle_action_item_disabled?: InputMaybe<Boolean_comparison_exp>;
  circle_action_item_id?: InputMaybe<uuid_comparison_exp>;
  circle_id?: InputMaybe<uuid_comparison_exp>;
  circle_membership?: InputMaybe<circle_membership_bool_exp>;
  circle_membership_action_item?: InputMaybe<circle_membership_action_item_bool_exp>;
  circle_membership_action_item_id?: InputMaybe<uuid_comparison_exp>;
  circle_membership_id?: InputMaybe<uuid_comparison_exp>;
  circle_version?: InputMaybe<Int_comparison_exp>;
  member_version?: InputMaybe<Int_comparison_exp>;
  new_version_available?: InputMaybe<Boolean_comparison_exp>;
  template_action_item_user?: InputMaybe<action_item_user_bool_exp>;
  template_action_item_user_id?: InputMaybe<uuid_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by aggregate values of table "circle_membership" */
export type circle_membership_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<circle_membership_max_order_by>;
  min?: InputMaybe<circle_membership_min_order_by>;
};

/** Boolean expression to filter rows from the table "circle_membership". All fields are combined with a logical 'AND'. */
export type circle_membership_bool_exp = {
  _and?: InputMaybe<Array<circle_membership_bool_exp>>;
  _not?: InputMaybe<circle_membership_bool_exp>;
  _or?: InputMaybe<Array<circle_membership_bool_exp>>;
  active?: InputMaybe<Boolean_comparison_exp>;
  active_range?: InputMaybe<daterange_comparison_exp>;
  circle?: InputMaybe<circle_bool_exp>;
  circle_id?: InputMaybe<uuid_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  joined_at?: InputMaybe<date_comparison_exp>;
  left_at?: InputMaybe<date_comparison_exp>;
  left_reason?: InputMaybe<enum_circle_membership_left_reason_enum_comparison_exp>;
  membership_action_item?: InputMaybe<circle_membership_action_item_bool_exp>;
  profile?: InputMaybe<user_profile_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "circle_membership" */
export type circle_membership_max_order_by = {
  circle_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  joined_at?: InputMaybe<order_by>;
  left_at?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "circle_membership" */
export type circle_membership_min_order_by = {
  circle_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  joined_at?: InputMaybe<order_by>;
  left_at?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "circle" */
export type circle_min_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  owner_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** input type for inserting object relation for remote table "circle" */
export type circle_obj_rel_insert_input = {
  data: circle_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<circle_on_conflict>;
};

/** on_conflict condition type for table "circle" */
export type circle_on_conflict = {
  constraint: circle_constraint;
  update_columns?: Array<circle_update_column>;
  where?: InputMaybe<circle_bool_exp>;
};

/** input type for updating data in table "circle" */
export type circle_set_input = {
  enable_member_invites?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "circle" */
export enum circle_update_column {
  /** column name */
  enable_member_invites = 'enable_member_invites',
  /** column name */
  name = 'name',
  /** column name */
  public = 'public'
}

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type citext_comparison_exp = {
  _eq?: InputMaybe<Scalars['citext']['input']>;
  _gt?: InputMaybe<Scalars['citext']['input']>;
  _gte?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['citext']['input']>;
  _in?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['citext']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['citext']['input']>;
  _lt?: InputMaybe<Scalars['citext']['input']>;
  _lte?: InputMaybe<Scalars['citext']['input']>;
  _neq?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['citext']['input']>;
  _nin?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['citext']['input']>;
};

export type cms_BooleanFilterInput_content = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<cms_BooleanFilterInput_content>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum cms_ENUM_COMPONENTSHOPMODULEPRODUCTSHOPMODULEPRODUCT_LAYOUT_content {
  No_Square_Image_Full_Width_Background_Image = 'No_Square_Image_Full_Width_Background_Image',
  Single_Square_Image_Left_Side = 'Single_Square_Image_Left_Side',
  Three_Image_Mosaic_Left_Side = 'Three_Image_Mosaic_Left_Side',
  Two_Square_Images_RIght_Side = 'Two_Square_Images_RIght_Side'
}

/** Boolean expression to filter rows from the table "connected_device". All fields are combined with a logical 'AND'. */
export type connected_device_bool_exp = {
  _and?: InputMaybe<Array<connected_device_bool_exp>>;
  _not?: InputMaybe<connected_device_bool_exp>;
  _or?: InputMaybe<Array<connected_device_bool_exp>>;
  connected_device_users?: InputMaybe<connected_device_user_bool_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  manufacturer?: InputMaybe<enum_connected_device_manufacturer_enum_comparison_exp>;
  model?: InputMaybe<String_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
};

/** order by aggregate values of table "connected_device_user" */
export type connected_device_user_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<connected_device_user_max_order_by>;
  min?: InputMaybe<connected_device_user_min_order_by>;
};

/** Boolean expression to filter rows from the table "connected_device_user". All fields are combined with a logical 'AND'. */
export type connected_device_user_bool_exp = {
  _and?: InputMaybe<Array<connected_device_user_bool_exp>>;
  _not?: InputMaybe<connected_device_user_bool_exp>;
  _or?: InputMaybe<Array<connected_device_user_bool_exp>>;
  connected_device?: InputMaybe<connected_device_bool_exp>;
  connected_device_id?: InputMaybe<uuid_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "connected_device_user" */
export type connected_device_user_max_order_by = {
  connected_device_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "connected_device_user" */
export type connected_device_user_min_order_by = {
  connected_device_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by aggregate values of table "dashboard" */
export type dashboard_aggregate_order_by = {
  avg?: InputMaybe<dashboard_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<dashboard_max_order_by>;
  min?: InputMaybe<dashboard_min_order_by>;
  stddev?: InputMaybe<dashboard_stddev_order_by>;
  stddev_pop?: InputMaybe<dashboard_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<dashboard_stddev_samp_order_by>;
  sum?: InputMaybe<dashboard_sum_order_by>;
  var_pop?: InputMaybe<dashboard_var_pop_order_by>;
  var_samp?: InputMaybe<dashboard_var_samp_order_by>;
  variance?: InputMaybe<dashboard_variance_order_by>;
};

/** order by avg() on columns of table "dashboard" */
export type dashboard_avg_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "dashboard". All fields are combined with a logical 'AND'. */
export type dashboard_bool_exp = {
  _and?: InputMaybe<Array<dashboard_bool_exp>>;
  _not?: InputMaybe<dashboard_bool_exp>;
  _or?: InputMaybe<Array<dashboard_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  experiment?: InputMaybe<experiment_bool_exp>;
  experiment_id?: InputMaybe<uuid_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  is_staging_dashboard?: InputMaybe<Boolean_comparison_exp>;
  is_template?: InputMaybe<Boolean_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  sort_order?: InputMaybe<Int_comparison_exp>;
  tabs?: InputMaybe<dashboard_tab_bool_exp>;
  target_cards?: InputMaybe<dashboard_target_card_bool_exp>;
  template_version?: InputMaybe<template_dashboard_version_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** input type for inserting array relation for remote table "dashboard_chart" */
export type dashboard_chart_arr_rel_insert_input = {
  data: Array<dashboard_chart_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<dashboard_chart_on_conflict>;
};

/** Boolean expression to filter rows from the table "dashboard_chart". All fields are combined with a logical 'AND'. */
export type dashboard_chart_bool_exp = {
  _and?: InputMaybe<Array<dashboard_chart_bool_exp>>;
  _not?: InputMaybe<dashboard_chart_bool_exp>;
  _or?: InputMaybe<Array<dashboard_chart_bool_exp>>;
  chart_tabs?: InputMaybe<dashboard_chart_tab_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  dashboard_tab?: InputMaybe<dashboard_tab_bool_exp>;
  dashboard_tab_id?: InputMaybe<uuid_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  sort_order?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "dashboard_chart" */
export enum dashboard_chart_constraint {
  /** unique or primary key constraint on columns "id" */
  dashboard_chart_pkey = 'dashboard_chart_pkey'
}

/** input type for incrementing numeric columns in table "dashboard_chart" */
export type dashboard_chart_inc_input = {
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "dashboard_chart" */
export type dashboard_chart_insert_input = {
  chart_tabs?: InputMaybe<dashboard_chart_tab_arr_rel_insert_input>;
  dashboard_tab?: InputMaybe<dashboard_tab_obj_rel_insert_input>;
  dashboard_tab_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting array relation for remote table "dashboard_chart_metric" */
export type dashboard_chart_metric_arr_rel_insert_input = {
  data: Array<dashboard_chart_metric_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<dashboard_chart_metric_on_conflict>;
};

/** Boolean expression to filter rows from the table "dashboard_chart_metric". All fields are combined with a logical 'AND'. */
export type dashboard_chart_metric_bool_exp = {
  _and?: InputMaybe<Array<dashboard_chart_metric_bool_exp>>;
  _not?: InputMaybe<dashboard_chart_metric_bool_exp>;
  _or?: InputMaybe<Array<dashboard_chart_metric_bool_exp>>;
  alt_name?: InputMaybe<String_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  dashboard_chart_view_id?: InputMaybe<uuid_comparison_exp>;
  data_source?: InputMaybe<enum_data_source_enum_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  interval_count?: InputMaybe<Int_comparison_exp>;
  interval_type?: InputMaybe<enum_rollup_interval_type_enum_comparison_exp>;
  metric?: InputMaybe<metric_bool_exp>;
  metric_filters?: InputMaybe<dashboard_metric_filter_bool_exp>;
  metric_id?: InputMaybe<uuid_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  rollup_type?: InputMaybe<enum_metric_rollup_type_enum_comparison_exp>;
  sort_order?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  variant?: InputMaybe<String_comparison_exp>;
  view?: InputMaybe<dashboard_chart_view_bool_exp>;
};

/** unique or primary key constraints on table "dashboard_chart_metric" */
export enum dashboard_chart_metric_constraint {
  /** unique or primary key constraint on columns "id" */
  dashboard_chart_metric_pkey = 'dashboard_chart_metric_pkey'
}

/** input type for incrementing numeric columns in table "dashboard_chart_metric" */
export type dashboard_chart_metric_inc_input = {
  interval_count?: InputMaybe<Scalars['Int']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "dashboard_chart_metric" */
export type dashboard_chart_metric_insert_input = {
  alt_name?: InputMaybe<Scalars['String']['input']>;
  dashboard_chart_view_id?: InputMaybe<Scalars['uuid']['input']>;
  data_source?: InputMaybe<enum_data_source_enum>;
  interval_count?: InputMaybe<Scalars['Int']['input']>;
  interval_type?: InputMaybe<enum_rollup_interval_type_enum>;
  metric?: InputMaybe<metric_obj_rel_insert_input>;
  metric_filters?: InputMaybe<dashboard_metric_filter_arr_rel_insert_input>;
  metric_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rollup_type?: InputMaybe<enum_metric_rollup_type_enum>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<dashboard_chart_view_obj_rel_insert_input>;
};

/** input type for inserting object relation for remote table "dashboard_chart_metric" */
export type dashboard_chart_metric_obj_rel_insert_input = {
  data: dashboard_chart_metric_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<dashboard_chart_metric_on_conflict>;
};

/** on_conflict condition type for table "dashboard_chart_metric" */
export type dashboard_chart_metric_on_conflict = {
  constraint: dashboard_chart_metric_constraint;
  update_columns?: Array<dashboard_chart_metric_update_column>;
  where?: InputMaybe<dashboard_chart_metric_bool_exp>;
};

/** input type for updating data in table "dashboard_chart_metric" */
export type dashboard_chart_metric_set_input = {
  alt_name?: InputMaybe<Scalars['String']['input']>;
  dashboard_chart_view_id?: InputMaybe<Scalars['uuid']['input']>;
  data_source?: InputMaybe<enum_data_source_enum>;
  interval_count?: InputMaybe<Scalars['Int']['input']>;
  interval_type?: InputMaybe<enum_rollup_interval_type_enum>;
  metric_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rollup_type?: InputMaybe<enum_metric_rollup_type_enum>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "dashboard_chart_metric" */
export enum dashboard_chart_metric_update_column {
  /** column name */
  alt_name = 'alt_name',
  /** column name */
  dashboard_chart_view_id = 'dashboard_chart_view_id',
  /** column name */
  data_source = 'data_source',
  /** column name */
  interval_count = 'interval_count',
  /** column name */
  interval_type = 'interval_type',
  /** column name */
  metric_id = 'metric_id',
  /** column name */
  name = 'name',
  /** column name */
  rollup_type = 'rollup_type',
  /** column name */
  sort_order = 'sort_order',
  /** column name */
  variant = 'variant'
}

export type dashboard_chart_metric_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<dashboard_chart_metric_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<dashboard_chart_metric_set_input>;
  /** filter the rows which have to be updated */
  where: dashboard_chart_metric_bool_exp;
};

/** input type for inserting object relation for remote table "dashboard_chart" */
export type dashboard_chart_obj_rel_insert_input = {
  data: dashboard_chart_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<dashboard_chart_on_conflict>;
};

/** on_conflict condition type for table "dashboard_chart" */
export type dashboard_chart_on_conflict = {
  constraint: dashboard_chart_constraint;
  update_columns?: Array<dashboard_chart_update_column>;
  where?: InputMaybe<dashboard_chart_bool_exp>;
};

/** input type for updating data in table "dashboard_chart" */
export type dashboard_chart_set_input = {
  name?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting array relation for remote table "dashboard_chart_tab" */
export type dashboard_chart_tab_arr_rel_insert_input = {
  data: Array<dashboard_chart_tab_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<dashboard_chart_tab_on_conflict>;
};

/** Boolean expression to filter rows from the table "dashboard_chart_tab". All fields are combined with a logical 'AND'. */
export type dashboard_chart_tab_bool_exp = {
  _and?: InputMaybe<Array<dashboard_chart_tab_bool_exp>>;
  _not?: InputMaybe<dashboard_chart_tab_bool_exp>;
  _or?: InputMaybe<Array<dashboard_chart_tab_bool_exp>>;
  chart?: InputMaybe<dashboard_chart_bool_exp>;
  chart_type?: InputMaybe<enum_chart_type_enum_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  dashboard_chart_id?: InputMaybe<uuid_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  sort_order?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  views?: InputMaybe<dashboard_chart_view_bool_exp>;
};

/** unique or primary key constraints on table "dashboard_chart_tab" */
export enum dashboard_chart_tab_constraint {
  /** unique or primary key constraint on columns "id" */
  dashboard_chart_tab_pkey = 'dashboard_chart_tab_pkey'
}

/** input type for incrementing numeric columns in table "dashboard_chart_tab" */
export type dashboard_chart_tab_inc_input = {
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "dashboard_chart_tab" */
export type dashboard_chart_tab_insert_input = {
  chart?: InputMaybe<dashboard_chart_obj_rel_insert_input>;
  chart_type?: InputMaybe<enum_chart_type_enum>;
  dashboard_chart_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  views?: InputMaybe<dashboard_chart_view_arr_rel_insert_input>;
};

/** input type for inserting object relation for remote table "dashboard_chart_tab" */
export type dashboard_chart_tab_obj_rel_insert_input = {
  data: dashboard_chart_tab_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<dashboard_chart_tab_on_conflict>;
};

/** on_conflict condition type for table "dashboard_chart_tab" */
export type dashboard_chart_tab_on_conflict = {
  constraint: dashboard_chart_tab_constraint;
  update_columns?: Array<dashboard_chart_tab_update_column>;
  where?: InputMaybe<dashboard_chart_tab_bool_exp>;
};

/** input type for updating data in table "dashboard_chart_tab" */
export type dashboard_chart_tab_set_input = {
  chart_type?: InputMaybe<enum_chart_type_enum>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** update columns of table "dashboard_chart_tab" */
export enum dashboard_chart_tab_update_column {
  /** column name */
  chart_type = 'chart_type',
  /** column name */
  name = 'name',
  /** column name */
  sort_order = 'sort_order'
}

export type dashboard_chart_tab_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<dashboard_chart_tab_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<dashboard_chart_tab_set_input>;
  /** filter the rows which have to be updated */
  where: dashboard_chart_tab_bool_exp;
};

/** update columns of table "dashboard_chart" */
export enum dashboard_chart_update_column {
  /** column name */
  name = 'name',
  /** column name */
  sort_order = 'sort_order'
}

export type dashboard_chart_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<dashboard_chart_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<dashboard_chart_set_input>;
  /** filter the rows which have to be updated */
  where: dashboard_chart_bool_exp;
};

/** input type for inserting array relation for remote table "dashboard_chart_view" */
export type dashboard_chart_view_arr_rel_insert_input = {
  data: Array<dashboard_chart_view_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<dashboard_chart_view_on_conflict>;
};

/** Boolean expression to filter rows from the table "dashboard_chart_view". All fields are combined with a logical 'AND'. */
export type dashboard_chart_view_bool_exp = {
  _and?: InputMaybe<Array<dashboard_chart_view_bool_exp>>;
  _not?: InputMaybe<dashboard_chart_view_bool_exp>;
  _or?: InputMaybe<Array<dashboard_chart_view_bool_exp>>;
  chart_tab?: InputMaybe<dashboard_chart_tab_bool_exp>;
  chart_type?: InputMaybe<enum_chart_type_enum_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  dashboard_chart_tab_id?: InputMaybe<uuid_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  sort_order?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  view_metrics?: InputMaybe<dashboard_chart_metric_bool_exp>;
};

/** unique or primary key constraints on table "dashboard_chart_view" */
export enum dashboard_chart_view_constraint {
  /** unique or primary key constraint on columns "id" */
  dashboard_chart_view_pkey = 'dashboard_chart_view_pkey'
}

/** input type for incrementing numeric columns in table "dashboard_chart_view" */
export type dashboard_chart_view_inc_input = {
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "dashboard_chart_view" */
export type dashboard_chart_view_insert_input = {
  chart_tab?: InputMaybe<dashboard_chart_tab_obj_rel_insert_input>;
  chart_type?: InputMaybe<enum_chart_type_enum>;
  dashboard_chart_tab_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  view_metrics?: InputMaybe<dashboard_chart_metric_arr_rel_insert_input>;
};

/** input type for inserting object relation for remote table "dashboard_chart_view" */
export type dashboard_chart_view_obj_rel_insert_input = {
  data: dashboard_chart_view_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<dashboard_chart_view_on_conflict>;
};

/** on_conflict condition type for table "dashboard_chart_view" */
export type dashboard_chart_view_on_conflict = {
  constraint: dashboard_chart_view_constraint;
  update_columns?: Array<dashboard_chart_view_update_column>;
  where?: InputMaybe<dashboard_chart_view_bool_exp>;
};

/** input type for updating data in table "dashboard_chart_view" */
export type dashboard_chart_view_set_input = {
  chart_type?: InputMaybe<enum_chart_type_enum>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** update columns of table "dashboard_chart_view" */
export enum dashboard_chart_view_update_column {
  /** column name */
  chart_type = 'chart_type',
  /** column name */
  name = 'name',
  /** column name */
  sort_order = 'sort_order'
}

export type dashboard_chart_view_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<dashboard_chart_view_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<dashboard_chart_view_set_input>;
  /** filter the rows which have to be updated */
  where: dashboard_chart_view_bool_exp;
};

/** unique or primary key constraints on table "dashboard" */
export enum dashboard_constraint {
  /** unique or primary key constraint on columns "experiment_id" */
  dashboard_experiment_id_key = 'dashboard_experiment_id_key',
  /** unique or primary key constraint on columns "id" */
  dashboard_pkey = 'dashboard_pkey',
  /** unique or primary key constraint on columns "user_id" */
  dashboard_user_id_idx = 'dashboard_user_id_idx'
}

/** input type for incrementing numeric columns in table "dashboard" */
export type dashboard_inc_input = {
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "dashboard" */
export type dashboard_insert_input = {
  experiment?: InputMaybe<experiment_obj_rel_insert_input>;
  experiment_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  tabs?: InputMaybe<dashboard_tab_arr_rel_insert_input>;
  target_cards?: InputMaybe<dashboard_target_card_arr_rel_insert_input>;
};

/** order by max() on columns of table "dashboard" */
export type dashboard_max_order_by = {
  created_at?: InputMaybe<order_by>;
  experiment_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** input type for inserting array relation for remote table "dashboard_metric_filter" */
export type dashboard_metric_filter_arr_rel_insert_input = {
  data: Array<dashboard_metric_filter_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<dashboard_metric_filter_on_conflict>;
};

/** Boolean expression to filter rows from the table "dashboard_metric_filter". All fields are combined with a logical 'AND'. */
export type dashboard_metric_filter_bool_exp = {
  _and?: InputMaybe<Array<dashboard_metric_filter_bool_exp>>;
  _not?: InputMaybe<dashboard_metric_filter_bool_exp>;
  _or?: InputMaybe<Array<dashboard_metric_filter_bool_exp>>;
  chart_metric?: InputMaybe<dashboard_chart_metric_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  dashboard_chart_metric_id?: InputMaybe<uuid_comparison_exp>;
  data_source?: InputMaybe<enum_data_source_enum_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  metric?: InputMaybe<metric_bool_exp>;
  metric_id?: InputMaybe<uuid_comparison_exp>;
  overlap_post_hours?: InputMaybe<numeric_comparison_exp>;
  overlap_prev_hours?: InputMaybe<numeric_comparison_exp>;
  overlap_use_day?: InputMaybe<Boolean_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  value_ranges?: InputMaybe<jsonb_comparison_exp>;
  variant?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "dashboard_metric_filter" */
export enum dashboard_metric_filter_constraint {
  /** unique or primary key constraint on columns "id" */
  dashboard_metric_filter_pkey = 'dashboard_metric_filter_pkey'
}

/** input type for inserting data into table "dashboard_metric_filter" */
export type dashboard_metric_filter_insert_input = {
  chart_metric?: InputMaybe<dashboard_chart_metric_obj_rel_insert_input>;
  dashboard_chart_metric_id?: InputMaybe<Scalars['uuid']['input']>;
  data_source?: InputMaybe<enum_data_source_enum>;
  metric?: InputMaybe<metric_obj_rel_insert_input>;
  metric_id?: InputMaybe<Scalars['uuid']['input']>;
  overlap_post_hours?: InputMaybe<Scalars['numeric']['input']>;
  overlap_prev_hours?: InputMaybe<Scalars['numeric']['input']>;
  overlap_use_day?: InputMaybe<Scalars['Boolean']['input']>;
  value_ranges?: InputMaybe<Scalars['jsonb']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** on_conflict condition type for table "dashboard_metric_filter" */
export type dashboard_metric_filter_on_conflict = {
  constraint: dashboard_metric_filter_constraint;
  update_columns?: Array<dashboard_metric_filter_update_column>;
  where?: InputMaybe<dashboard_metric_filter_bool_exp>;
};

/** update columns of table "dashboard_metric_filter" */
export enum dashboard_metric_filter_update_column {
  /** column name */
  data_source = 'data_source',
  /** column name */
  metric_id = 'metric_id',
  /** column name */
  overlap_post_hours = 'overlap_post_hours',
  /** column name */
  overlap_prev_hours = 'overlap_prev_hours',
  /** column name */
  overlap_use_day = 'overlap_use_day',
  /** column name */
  value_ranges = 'value_ranges',
  /** column name */
  variant = 'variant'
}

/** order by min() on columns of table "dashboard" */
export type dashboard_min_order_by = {
  created_at?: InputMaybe<order_by>;
  experiment_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** input type for inserting object relation for remote table "dashboard" */
export type dashboard_obj_rel_insert_input = {
  data: dashboard_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<dashboard_on_conflict>;
};

/** on_conflict condition type for table "dashboard" */
export type dashboard_on_conflict = {
  constraint: dashboard_constraint;
  update_columns?: Array<dashboard_update_column>;
  where?: InputMaybe<dashboard_bool_exp>;
};

/** input type for updating data in table "dashboard" */
export type dashboard_set_input = {
  experiment_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** order by stddev() on columns of table "dashboard" */
export type dashboard_stddev_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "dashboard" */
export type dashboard_stddev_pop_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "dashboard" */
export type dashboard_stddev_samp_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "dashboard" */
export type dashboard_sum_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** input type for inserting array relation for remote table "dashboard_tab" */
export type dashboard_tab_arr_rel_insert_input = {
  data: Array<dashboard_tab_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<dashboard_tab_on_conflict>;
};

/** Boolean expression to filter rows from the table "dashboard_tab". All fields are combined with a logical 'AND'. */
export type dashboard_tab_bool_exp = {
  _and?: InputMaybe<Array<dashboard_tab_bool_exp>>;
  _not?: InputMaybe<dashboard_tab_bool_exp>;
  _or?: InputMaybe<Array<dashboard_tab_bool_exp>>;
  charts?: InputMaybe<dashboard_chart_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  dashboard?: InputMaybe<dashboard_bool_exp>;
  dashboard_id?: InputMaybe<uuid_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  sort_order?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "dashboard_tab" */
export enum dashboard_tab_constraint {
  /** unique or primary key constraint on columns "id" */
  dashboard_tab_pkey = 'dashboard_tab_pkey'
}

/** input type for incrementing numeric columns in table "dashboard_tab" */
export type dashboard_tab_inc_input = {
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "dashboard_tab" */
export type dashboard_tab_insert_input = {
  charts?: InputMaybe<dashboard_chart_arr_rel_insert_input>;
  dashboard?: InputMaybe<dashboard_obj_rel_insert_input>;
  dashboard_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting object relation for remote table "dashboard_tab" */
export type dashboard_tab_obj_rel_insert_input = {
  data: dashboard_tab_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<dashboard_tab_on_conflict>;
};

/** on_conflict condition type for table "dashboard_tab" */
export type dashboard_tab_on_conflict = {
  constraint: dashboard_tab_constraint;
  update_columns?: Array<dashboard_tab_update_column>;
  where?: InputMaybe<dashboard_tab_bool_exp>;
};

/** input type for updating data in table "dashboard_tab" */
export type dashboard_tab_set_input = {
  name?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** update columns of table "dashboard_tab" */
export enum dashboard_tab_update_column {
  /** column name */
  name = 'name',
  /** column name */
  sort_order = 'sort_order'
}

export type dashboard_tab_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<dashboard_tab_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<dashboard_tab_set_input>;
  /** filter the rows which have to be updated */
  where: dashboard_tab_bool_exp;
};

/** input type for inserting array relation for remote table "dashboard_target_card" */
export type dashboard_target_card_arr_rel_insert_input = {
  data: Array<dashboard_target_card_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<dashboard_target_card_on_conflict>;
};

/** Boolean expression to filter rows from the table "dashboard_target_card". All fields are combined with a logical 'AND'. */
export type dashboard_target_card_bool_exp = {
  _and?: InputMaybe<Array<dashboard_target_card_bool_exp>>;
  _not?: InputMaybe<dashboard_target_card_bool_exp>;
  _or?: InputMaybe<Array<dashboard_target_card_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  dashboard?: InputMaybe<dashboard_bool_exp>;
  dashboard_id?: InputMaybe<uuid_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  metric?: InputMaybe<metric_bool_exp>;
  metric_id?: InputMaybe<uuid_comparison_exp>;
  sort_order?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "dashboard_target_card" */
export enum dashboard_target_card_constraint {
  /** unique or primary key constraint on columns "metric_id", "dashboard_id" */
  dashboard_target_card_dashboard_id_metric_id_key = 'dashboard_target_card_dashboard_id_metric_id_key',
  /** unique or primary key constraint on columns "id" */
  dashboard_target_card_pkey = 'dashboard_target_card_pkey'
}

/** input type for inserting data into table "dashboard_target_card" */
export type dashboard_target_card_insert_input = {
  dashboard?: InputMaybe<dashboard_obj_rel_insert_input>;
  dashboard_id?: InputMaybe<Scalars['uuid']['input']>;
  metric?: InputMaybe<metric_obj_rel_insert_input>;
  metric_id?: InputMaybe<Scalars['uuid']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** on_conflict condition type for table "dashboard_target_card" */
export type dashboard_target_card_on_conflict = {
  constraint: dashboard_target_card_constraint;
  update_columns?: Array<dashboard_target_card_update_column>;
  where?: InputMaybe<dashboard_target_card_bool_exp>;
};

/** update columns of table "dashboard_target_card" */
export enum dashboard_target_card_update_column {
  /** column name */
  sort_order = 'sort_order'
}

/** update columns of table "dashboard" */
export enum dashboard_update_column {
  /** column name */
  experiment_id = 'experiment_id',
  /** column name */
  name = 'name',
  /** column name */
  sort_order = 'sort_order'
}

export type dashboard_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<dashboard_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<dashboard_set_input>;
  /** filter the rows which have to be updated */
  where: dashboard_bool_exp;
};

/** order by var_pop() on columns of table "dashboard" */
export type dashboard_var_pop_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "dashboard" */
export type dashboard_var_samp_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "dashboard" */
export type dashboard_variance_order_by = {
  sort_order?: InputMaybe<order_by>;
};

export enum data_source {
  apple_healthkit = 'apple_healthkit',
  body_metrix = 'body_metrix',
  brain_upgrade = 'brain_upgrade',
  bridge = 'bridge',
  fasting_log = 'fasting_log',
  fitbit = 'fitbit',
  garmin = 'garmin',
  hydration_log = 'hydration_log',
  inBody = 'inBody',
  internal = 'internal',
  labcorp = 'labcorp',
  levels_cgm = 'levels_cgm',
  manual_entry_log = 'manual_entry_log',
  none = 'none',
  nutrisense = 'nutrisense',
  nutrition_log = 'nutrition_log',
  oura = 'oura',
  pheno_age = 'pheno_age',
  quest_labs = 'quest_labs',
  selfdecode = 'selfdecode',
  strava = 'strava',
  supplements_log = 'supplements_log',
  user_provided = 'user_provided',
  vald = 'vald',
  wellness_log = 'wellness_log',
  whoop = 'whoop',
  withings = 'withings'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type date_comparison_exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** Boolean expression to compare columns of type "daterange". All fields are combined with logical 'AND'. */
export type daterange_comparison_exp = {
  _eq?: InputMaybe<Scalars['daterange']['input']>;
  _gt?: InputMaybe<Scalars['daterange']['input']>;
  _gte?: InputMaybe<Scalars['daterange']['input']>;
  _in?: InputMaybe<Array<Scalars['daterange']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['daterange']['input']>;
  _lte?: InputMaybe<Scalars['daterange']['input']>;
  _neq?: InputMaybe<Scalars['daterange']['input']>;
  _nin?: InputMaybe<Array<Scalars['daterange']['input']>>;
};

/** Boolean expression to filter rows from the table "dynamic_metric". All fields are combined with a logical 'AND'. */
export type dynamic_metric_bool_exp = {
  _and?: InputMaybe<Array<dynamic_metric_bool_exp>>;
  _not?: InputMaybe<dynamic_metric_bool_exp>;
  _or?: InputMaybe<Array<dynamic_metric_bool_exp>>;
  formula_ref?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "dynamic_metric". */
export type dynamic_metric_order_by = {
  formula_ref?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "email_notification_type". All fields are combined with a logical 'AND'. */
export type email_notification_type_bool_exp = {
  _and?: InputMaybe<Array<email_notification_type_bool_exp>>;
  _not?: InputMaybe<email_notification_type_bool_exp>;
  _or?: InputMaybe<Array<email_notification_type_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  default_frequency?: InputMaybe<enum_email_frequency_option_enum_comparison_exp>;
  frequency_options?: InputMaybe<_text_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  key?: InputMaybe<String_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  ses_topic?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_preferences?: InputMaybe<user_email_notification_type_preference_bool_exp>;
};

export enum enum_action_item_input_type_enum {
  boolean = 'boolean',
  increment = 'increment',
  metric = 'metric',
  scale = 'scale',
  supplement = 'supplement'
}

/** Boolean expression to compare columns of type "enum_action_item_input_type_enum". All fields are combined with logical 'AND'. */
export type enum_action_item_input_type_enum_comparison_exp = {
  _eq?: InputMaybe<enum_action_item_input_type_enum>;
  _in?: InputMaybe<Array<enum_action_item_input_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_action_item_input_type_enum>;
  _nin?: InputMaybe<Array<enum_action_item_input_type_enum>>;
};

export enum enum_action_item_instance_target_type_enum {
  PER_DAY = 'PER_DAY',
  PER_WEEK = 'PER_WEEK'
}

/** Boolean expression to compare columns of type "enum_action_item_instance_target_type_enum". All fields are combined with logical 'AND'. */
export type enum_action_item_instance_target_type_enum_comparison_exp = {
  _eq?: InputMaybe<enum_action_item_instance_target_type_enum>;
  _in?: InputMaybe<Array<enum_action_item_instance_target_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_action_item_instance_target_type_enum>;
  _nin?: InputMaybe<Array<enum_action_item_instance_target_type_enum>>;
};

export enum enum_action_item_logger_type_enum {
  DEFAULT = 'DEFAULT',
  FASTING = 'FASTING',
  GLUCOSE = 'GLUCOSE',
  HYDRATION = 'HYDRATION',
  NUTRITION = 'NUTRITION',
  SUPPLEMENT = 'SUPPLEMENT',
  WELLNESS = 'WELLNESS'
}

/** Boolean expression to compare columns of type "enum_action_item_logger_type_enum". All fields are combined with logical 'AND'. */
export type enum_action_item_logger_type_enum_comparison_exp = {
  _eq?: InputMaybe<enum_action_item_logger_type_enum>;
  _in?: InputMaybe<Array<enum_action_item_logger_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_action_item_logger_type_enum>;
  _nin?: InputMaybe<Array<enum_action_item_logger_type_enum>>;
};

export enum enum_action_item_type_enum {
  ACTIVITY = 'ACTIVITY',
  HAIR = 'HAIR',
  MINDFULNESS = 'MINDFULNESS',
  MONITOR = 'MONITOR',
  NUTRITION = 'NUTRITION',
  OTHER = 'OTHER',
  RECOVERY = 'RECOVERY',
  SLEEP = 'SLEEP',
  SUPPLEMENTS = 'SUPPLEMENTS'
}

/** Boolean expression to compare columns of type "enum_action_item_type_enum". All fields are combined with logical 'AND'. */
export type enum_action_item_type_enum_comparison_exp = {
  _eq?: InputMaybe<enum_action_item_type_enum>;
  _in?: InputMaybe<Array<enum_action_item_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_action_item_type_enum>;
  _nin?: InputMaybe<Array<enum_action_item_type_enum>>;
};

export enum enum_action_plan_template_category_enum {
  DEMO = 'DEMO',
  EXERCISE = 'EXERCISE',
  FROM_AI_SUGGESTION = 'FROM_AI_SUGGESTION',
  NUTRITION = 'NUTRITION',
  SLEEP = 'SLEEP',
  SUPPLEMENT = 'SUPPLEMENT'
}

/** Boolean expression to compare columns of type "enum_action_plan_template_category_enum". All fields are combined with logical 'AND'. */
export type enum_action_plan_template_category_enum_comparison_exp = {
  _eq?: InputMaybe<enum_action_plan_template_category_enum>;
  _in?: InputMaybe<Array<enum_action_plan_template_category_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_action_plan_template_category_enum>;
  _nin?: InputMaybe<Array<enum_action_plan_template_category_enum>>;
};

export enum enum_action_plan_template_item_category_enum {
  ALCOHOL = 'ALCOHOL',
  CARBOHYDRATE_INTAKE = 'CARBOHYDRATE_INTAKE',
  CARDIO = 'CARDIO',
  FAT_INTAKE = 'FAT_INTAKE',
  HYDRATION = 'HYDRATION',
  MINDFULNESS_MEDITATION = 'MINDFULNESS_MEDITATION',
  PROTEIN_INTAKE = 'PROTEIN_INTAKE',
  STRENGTH_TRAINING = 'STRENGTH_TRAINING',
  SUPPLEMENTATION = 'SUPPLEMENTATION',
  VEGETABLE_INTAKE = 'VEGETABLE_INTAKE'
}

/** Boolean expression to compare columns of type "enum_action_plan_template_item_category_enum". All fields are combined with logical 'AND'. */
export type enum_action_plan_template_item_category_enum_comparison_exp = {
  _eq?: InputMaybe<enum_action_plan_template_item_category_enum>;
  _in?: InputMaybe<Array<enum_action_plan_template_item_category_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_action_plan_template_item_category_enum>;
  _nin?: InputMaybe<Array<enum_action_plan_template_item_category_enum>>;
};

export enum enum_aggregate_type_enum {
  avg = 'avg',
  max = 'max',
  min = 'min',
  sum = 'sum'
}

export enum enum_chart_type_enum {
  bar = 'bar',
  line = 'line',
  stacked_area = 'stacked_area',
  stacked_bar = 'stacked_bar'
}

/** Boolean expression to compare columns of type "enum_chart_type_enum". All fields are combined with logical 'AND'. */
export type enum_chart_type_enum_comparison_exp = {
  _eq?: InputMaybe<enum_chart_type_enum>;
  _in?: InputMaybe<Array<enum_chart_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_chart_type_enum>;
  _nin?: InputMaybe<Array<enum_chart_type_enum>>;
};

export enum enum_circle_membership_left_reason_enum {
  LEFT = 'LEFT',
  REMOVED_BY_ADMIN = 'REMOVED_BY_ADMIN'
}

/** Boolean expression to compare columns of type "enum_circle_membership_left_reason_enum". All fields are combined with logical 'AND'. */
export type enum_circle_membership_left_reason_enum_comparison_exp = {
  _eq?: InputMaybe<enum_circle_membership_left_reason_enum>;
  _in?: InputMaybe<Array<enum_circle_membership_left_reason_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_circle_membership_left_reason_enum>;
  _nin?: InputMaybe<Array<enum_circle_membership_left_reason_enum>>;
};

export enum enum_connected_device_manufacturer_enum {
  apple = 'apple',
  fitbit = 'fitbit',
  oura = 'oura',
  whoop = 'whoop',
  withings = 'withings'
}

/** Boolean expression to compare columns of type "enum_connected_device_manufacturer_enum". All fields are combined with logical 'AND'. */
export type enum_connected_device_manufacturer_enum_comparison_exp = {
  _eq?: InputMaybe<enum_connected_device_manufacturer_enum>;
  _in?: InputMaybe<Array<enum_connected_device_manufacturer_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_connected_device_manufacturer_enum>;
  _nin?: InputMaybe<Array<enum_connected_device_manufacturer_enum>>;
};

export enum enum_consent_policy_type_enum {
  PRODUCT = 'PRODUCT',
  SERVICE_LEVEL = 'SERVICE_LEVEL'
}

export enum enum_data_source_enum {
  apple = 'apple',
  apple_healthkit = 'apple_healthkit',
  body_metrix = 'body_metrix',
  brain_upgrade = 'brain_upgrade',
  bridge = 'bridge',
  fasting_log = 'fasting_log',
  fitbit = 'fitbit',
  garmin = 'garmin',
  hydration_log = 'hydration_log',
  inBody = 'inBody',
  internal = 'internal',
  labcorp = 'labcorp',
  levels_cgm = 'levels_cgm',
  manual_entry_log = 'manual_entry_log',
  none = 'none',
  nutrisense = 'nutrisense',
  nutrition_log = 'nutrition_log',
  oura = 'oura',
  pdf_import = 'pdf_import',
  pheno_age = 'pheno_age',
  quest_labs = 'quest_labs',
  quest_pdf = 'quest_pdf',
  selfdecode = 'selfdecode',
  strava = 'strava',
  supplements_log = 'supplements_log',
  user = 'user',
  user_provided = 'user_provided',
  vald = 'vald',
  wellness_log = 'wellness_log',
  whoop = 'whoop',
  withings = 'withings'
}

/** Boolean expression to compare columns of type "enum_data_source_enum". All fields are combined with logical 'AND'. */
export type enum_data_source_enum_comparison_exp = {
  _eq?: InputMaybe<enum_data_source_enum>;
  _in?: InputMaybe<Array<enum_data_source_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_data_source_enum>;
  _nin?: InputMaybe<Array<enum_data_source_enum>>;
};

export enum enum_email_frequency_option_enum {
  daily = 'daily',
  mwf = 'mwf',
  weekly = 'weekly',
  ws = 'ws'
}

/** Boolean expression to compare columns of type "enum_email_frequency_option_enum". All fields are combined with logical 'AND'. */
export type enum_email_frequency_option_enum_comparison_exp = {
  _eq?: InputMaybe<enum_email_frequency_option_enum>;
  _in?: InputMaybe<Array<enum_email_frequency_option_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_email_frequency_option_enum>;
  _nin?: InputMaybe<Array<enum_email_frequency_option_enum>>;
};

export enum enum_file_vault_file_type_enum {
  AUDIO_MP3 = 'AUDIO_MP3',
  LABCORP_REQUISITION_PDF = 'LABCORP_REQUISITION_PDF',
  LABCORP_RESULT_PDF = 'LABCORP_RESULT_PDF',
  QUEST_LABS_PDF = 'QUEST_LABS_PDF',
  SELFDECODE_LAB_REQUISITION_PDF = 'SELFDECODE_LAB_REQUISITION_PDF',
  SELFDECODE_LAB_RESULT_PDF = 'SELFDECODE_LAB_RESULT_PDF',
  UNKNOWN = 'UNKNOWN'
}

export enum enum_fulfillment_provider_enum {
  fulfillment_provider = 'fulfillment_provider',
  labcorp = 'labcorp',
  quest = 'quest',
  realize = 'realize',
  suppgrade_labs = 'suppgrade_labs',
  supplements_ag = 'supplements_ag',
  supplements_danger_coffee = 'supplements_danger_coffee',
  supplements_dfs = 'supplements_dfs',
  supplements_dna = 'supplements_dna',
  supplements_do_not_age = 'supplements_do_not_age',
  supplements_double_wood = 'supplements_double_wood',
  supplements_integrative_therapeutics = 'supplements_integrative_therapeutics',
  supplements_jarrow = 'supplements_jarrow',
  supplements_lmnt = 'supplements_lmnt',
  supplements_nutricost = 'supplements_nutricost',
  supplements_suppgrade = 'supplements_suppgrade',
  supplements_suppgrade_labs = 'supplements_suppgrade_labs',
  supplements_thorne = 'supplements_thorne',
  trudiagnostic = 'trudiagnostic'
}

/** Boolean expression to compare columns of type "enum_fulfillment_provider_enum". All fields are combined with logical 'AND'. */
export type enum_fulfillment_provider_enum_comparison_exp = {
  _eq?: InputMaybe<enum_fulfillment_provider_enum>;
  _in?: InputMaybe<Array<enum_fulfillment_provider_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_fulfillment_provider_enum>;
  _nin?: InputMaybe<Array<enum_fulfillment_provider_enum>>;
};

export enum enum_fulfillment_status_enum {
  FULFILLED = 'FULFILLED',
  PARTIAL = 'PARTIAL',
  UNFULFILLED = 'UNFULFILLED'
}

/** Boolean expression to compare columns of type "enum_fulfillment_status_enum". All fields are combined with logical 'AND'. */
export type enum_fulfillment_status_enum_comparison_exp = {
  _eq?: InputMaybe<enum_fulfillment_status_enum>;
  _in?: InputMaybe<Array<enum_fulfillment_status_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_fulfillment_status_enum>;
  _nin?: InputMaybe<Array<enum_fulfillment_status_enum>>;
};

export enum enum_home_tile_category_enum {
  LOGGING = 'LOGGING',
  METRICS = 'METRICS'
}

/** Boolean expression to compare columns of type "enum_home_tile_category_enum". All fields are combined with logical 'AND'. */
export type enum_home_tile_category_enum_comparison_exp = {
  _eq?: InputMaybe<enum_home_tile_category_enum>;
  _in?: InputMaybe<Array<enum_home_tile_category_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_home_tile_category_enum>;
  _nin?: InputMaybe<Array<enum_home_tile_category_enum>>;
};

export enum enum_integration_backfill_status_enum {
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
  IN_PROGRESS = 'IN_PROGRESS'
}

export enum enum_kpi_snapshot_item_position_enum {
  ABOVE_OPTIMAL = 'ABOVE_OPTIMAL',
  BELOW_OPTIMAL = 'BELOW_OPTIMAL',
  OPTIMAL = 'OPTIMAL'
}

/** Boolean expression to compare columns of type "enum_kpi_snapshot_item_position_enum". All fields are combined with logical 'AND'. */
export type enum_kpi_snapshot_item_position_enum_comparison_exp = {
  _eq?: InputMaybe<enum_kpi_snapshot_item_position_enum>;
  _in?: InputMaybe<Array<enum_kpi_snapshot_item_position_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_kpi_snapshot_item_position_enum>;
  _nin?: InputMaybe<Array<enum_kpi_snapshot_item_position_enum>>;
};

export enum enum_lab_enum {
  labcorp = 'labcorp',
  quest = 'quest'
}

/** Boolean expression to compare columns of type "enum_lab_enum". All fields are combined with logical 'AND'. */
export type enum_lab_enum_comparison_exp = {
  _eq?: InputMaybe<enum_lab_enum>;
  _in?: InputMaybe<Array<enum_lab_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_lab_enum>;
  _nin?: InputMaybe<Array<enum_lab_enum>>;
};

export enum enum_lab_order_status_enum {
  cancelled = 'cancelled',
  collecting_sample = 'collecting_sample',
  completed = 'completed',
  failed = 'failed',
  received = 'received',
  sample_with_lab = 'sample_with_lab'
}

/** Boolean expression to compare columns of type "enum_lab_order_status_enum". All fields are combined with logical 'AND'. */
export type enum_lab_order_status_enum_comparison_exp = {
  _eq?: InputMaybe<enum_lab_order_status_enum>;
  _in?: InputMaybe<Array<enum_lab_order_status_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_lab_order_status_enum>;
  _nin?: InputMaybe<Array<enum_lab_order_status_enum>>;
};

export enum enum_lab_result_status_enum {
  complete = 'complete',
  ingest_error = 'ingest_error',
  partial = 'partial'
}

/** Boolean expression to compare columns of type "enum_lab_result_status_enum". All fields are combined with logical 'AND'. */
export type enum_lab_result_status_enum_comparison_exp = {
  _eq?: InputMaybe<enum_lab_result_status_enum>;
  _in?: InputMaybe<Array<enum_lab_result_status_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_lab_result_status_enum>;
  _nin?: InputMaybe<Array<enum_lab_result_status_enum>>;
};

export enum enum_life_event_category_enum {
  ILLNESS = 'ILLNESS',
  INJURY = 'INJURY',
  OTHER = 'OTHER',
  VACATION = 'VACATION'
}

/** Boolean expression to compare columns of type "enum_life_event_category_enum". All fields are combined with logical 'AND'. */
export type enum_life_event_category_enum_comparison_exp = {
  _eq?: InputMaybe<enum_life_event_category_enum>;
  _in?: InputMaybe<Array<enum_life_event_category_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_life_event_category_enum>;
  _nin?: InputMaybe<Array<enum_life_event_category_enum>>;
};

export enum enum_measure_type_enum {
  measurement = 'measurement',
  quantity = 'quantity'
}

/** Boolean expression to compare columns of type "enum_measure_type_enum". All fields are combined with logical 'AND'. */
export type enum_measure_type_enum_comparison_exp = {
  _eq?: InputMaybe<enum_measure_type_enum>;
  _in?: InputMaybe<Array<enum_measure_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_measure_type_enum>;
  _nin?: InputMaybe<Array<enum_measure_type_enum>>;
};

export enum enum_media_upload_type {
  AVATAR = 'AVATAR',
  SUPPLEMENT_NUTRITION_LABEL = 'SUPPLEMENT_NUTRITION_LABEL',
  SUPPLEMENT_PRODUCT_IMAGE = 'SUPPLEMENT_PRODUCT_IMAGE',
  USER_SHARE = 'USER_SHARE'
}

export enum enum_membership_tier_enum {
  ACTION_PLAN_ONLY = 'ACTION_PLAN_ONLY',
  EMPLOYEE = 'EMPLOYEE',
  FREE_MEMBER = 'FREE_MEMBER',
  LABS_ONLY = 'LABS_ONLY',
  MEMBER = 'MEMBER',
  NON_MEMBER = 'NON_MEMBER',
  PAID_MEMBER = 'PAID_MEMBER'
}

/** Boolean expression to compare columns of type "enum_membership_tier_enum". All fields are combined with logical 'AND'. */
export type enum_membership_tier_enum_comparison_exp = {
  _eq?: InputMaybe<enum_membership_tier_enum>;
  _in?: InputMaybe<Array<enum_membership_tier_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_membership_tier_enum>;
  _nin?: InputMaybe<Array<enum_membership_tier_enum>>;
};

export enum enum_metric_namespace_enum {
  ACTIVITY = 'ACTIVITY',
  APPLE_HEALTHKIT = 'APPLE_HEALTHKIT',
  APPLE_HEALTHKIT_SUMMARY = 'APPLE_HEALTHKIT_SUMMARY',
  APPLE_HEALTHKIT_WORKOUT = 'APPLE_HEALTHKIT_WORKOUT',
  BODY_MEASUREMENT = 'BODY_MEASUREMENT',
  BRIDGE = 'BRIDGE',
  CSV_IMPORT = 'CSV_IMPORT',
  GARMIN = 'GARMIN',
  IN_BODY = 'IN_BODY',
  LAB_RESULT = 'LAB_RESULT',
  NUTRIENT = 'NUTRIENT',
  OURA = 'OURA',
  OURA_ACTIVITY = 'OURA_ACTIVITY',
  OURA_READINESS = 'OURA_READINESS',
  OURA_SLEEP = 'OURA_SLEEP',
  PHENO_AGE = 'PHENO_AGE',
  QUALITATIVE = 'QUALITATIVE',
  REALIZE = 'REALIZE',
  SLEEP = 'SLEEP',
  SUPPLEMENT = 'SUPPLEMENT',
  VALD_BORD = 'VALD_BORD',
  VALD_FORCEDECK = 'VALD_FORCEDECK',
  WHOOP = 'WHOOP',
  WITHINGS = 'WITHINGS',
  WORKOUT = 'WORKOUT'
}

export enum enum_metric_rollup_type_enum {
  avg = 'avg',
  max = 'max',
  min = 'min',
  none = 'none',
  sum = 'sum'
}

/** Boolean expression to compare columns of type "enum_metric_rollup_type_enum". All fields are combined with logical 'AND'. */
export type enum_metric_rollup_type_enum_comparison_exp = {
  _eq?: InputMaybe<enum_metric_rollup_type_enum>;
  _in?: InputMaybe<Array<enum_metric_rollup_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_metric_rollup_type_enum>;
  _nin?: InputMaybe<Array<enum_metric_rollup_type_enum>>;
};

export enum enum_metric_snapshot_item_position_enum {
  ABOVE_OPTIMAL = 'ABOVE_OPTIMAL',
  BELOW_OPTIMAL = 'BELOW_OPTIMAL',
  OPTIMAL = 'OPTIMAL'
}

/** Boolean expression to compare columns of type "enum_metric_snapshot_item_position_enum". All fields are combined with logical 'AND'. */
export type enum_metric_snapshot_item_position_enum_comparison_exp = {
  _eq?: InputMaybe<enum_metric_snapshot_item_position_enum>;
  _in?: InputMaybe<Array<enum_metric_snapshot_item_position_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_metric_snapshot_item_position_enum>;
  _nin?: InputMaybe<Array<enum_metric_snapshot_item_position_enum>>;
};

export enum enum_order_mode_enum {
  CART = 'CART',
  EXPIRED_CART = 'EXPIRED_CART',
  ORDER = 'ORDER'
}

/** Boolean expression to compare columns of type "enum_order_mode_enum". All fields are combined with logical 'AND'. */
export type enum_order_mode_enum_comparison_exp = {
  _eq?: InputMaybe<enum_order_mode_enum>;
  _in?: InputMaybe<Array<enum_order_mode_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_order_mode_enum>;
  _nin?: InputMaybe<Array<enum_order_mode_enum>>;
};

export enum enum_reference_range_type {
  AXO_RANGE = 'AXO_RANGE',
  AXO_RATING = 'AXO_RATING',
  KPI_RATING = 'KPI_RATING',
  LAB_RANGE = 'LAB_RANGE',
  LAB_RESULT = 'LAB_RESULT',
  REALIZE_RANGE = 'REALIZE_RANGE',
  REALIZE_RATING = 'REALIZE_RATING'
}

export enum enum_rollup_interval_type_enum {
  day = 'day',
  month = 'month',
  none = 'none',
  week = 'week',
  year = 'year'
}

/** Boolean expression to compare columns of type "enum_rollup_interval_type_enum". All fields are combined with logical 'AND'. */
export type enum_rollup_interval_type_enum_comparison_exp = {
  _eq?: InputMaybe<enum_rollup_interval_type_enum>;
  _in?: InputMaybe<Array<enum_rollup_interval_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_rollup_interval_type_enum>;
  _nin?: InputMaybe<Array<enum_rollup_interval_type_enum>>;
};

export enum enum_selfdecode_sex_enum {
  Female = 'Female',
  Male = 'Male'
}

export enum enum_sex_enum {
  DECLINE_TO_ANSWER = 'DECLINE_TO_ANSWER',
  FEMALE = 'FEMALE',
  MALE = 'MALE'
}

/** Boolean expression to compare columns of type "enum_sex_enum". All fields are combined with logical 'AND'. */
export type enum_sex_enum_comparison_exp = {
  _eq?: InputMaybe<enum_sex_enum>;
  _in?: InputMaybe<Array<enum_sex_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_sex_enum>;
  _nin?: InputMaybe<Array<enum_sex_enum>>;
};

export enum enum_shipping_status_enum {
  FULFILLED = 'FULFILLED',
  ORDERED = 'ORDERED',
  SHIPPED = 'SHIPPED',
  UNFULFILLED = 'UNFULFILLED'
}

/** Boolean expression to compare columns of type "enum_shipping_status_enum". All fields are combined with logical 'AND'. */
export type enum_shipping_status_enum_comparison_exp = {
  _eq?: InputMaybe<enum_shipping_status_enum>;
  _in?: InputMaybe<Array<enum_shipping_status_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_shipping_status_enum>;
  _nin?: InputMaybe<Array<enum_shipping_status_enum>>;
};

export enum enum_stripe_product_type_enum {
  ADDON = 'ADDON',
  BUNDLE = 'BUNDLE',
  FEE = 'FEE',
  LAB_PANEL = 'LAB_PANEL',
  LAB_TEST = 'LAB_TEST',
  MEMBERSHIP = 'MEMBERSHIP',
  PACKAGE = 'PACKAGE',
  PRESCRIPTION = 'PRESCRIPTION',
  PRODUCT = 'PRODUCT',
  SHIPPING_FEE = 'SHIPPING_FEE',
  SUPPLEMENT = 'SUPPLEMENT'
}

/** Boolean expression to compare columns of type "enum_stripe_product_type_enum". All fields are combined with logical 'AND'. */
export type enum_stripe_product_type_enum_comparison_exp = {
  _eq?: InputMaybe<enum_stripe_product_type_enum>;
  _in?: InputMaybe<Array<enum_stripe_product_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_stripe_product_type_enum>;
  _nin?: InputMaybe<Array<enum_stripe_product_type_enum>>;
};

export enum enum_subscription_request_status_enum {
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  DENIED = 'DENIED',
  PENDING = 'PENDING'
}

/** Boolean expression to compare columns of type "enum_subscription_request_status_enum". All fields are combined with logical 'AND'. */
export type enum_subscription_request_status_enum_comparison_exp = {
  _eq?: InputMaybe<enum_subscription_request_status_enum>;
  _in?: InputMaybe<Array<enum_subscription_request_status_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_subscription_request_status_enum>;
  _nin?: InputMaybe<Array<enum_subscription_request_status_enum>>;
};

export enum enum_timeframe_enum {
  /** 12-18 */
  AFTERNOON = 'AFTERNOON',
  /** 18-22 */
  EVENING = 'EVENING',
  /** 4-12 */
  MORNING = 'MORNING',
  /** 22-24,0-4 */
  NIGHTTIME = 'NIGHTTIME',
  POST_WORKOUT = 'POST_WORKOUT',
  PRE_WORKOUT = 'PRE_WORKOUT'
}

/** Boolean expression to compare columns of type "enum_timeframe_enum". All fields are combined with logical 'AND'. */
export type enum_timeframe_enum_comparison_exp = {
  _eq?: InputMaybe<enum_timeframe_enum>;
  _in?: InputMaybe<Array<enum_timeframe_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_timeframe_enum>;
  _nin?: InputMaybe<Array<enum_timeframe_enum>>;
};

export enum enum_tracked_metric_group_enum {
  qualitative = 'qualitative'
}

/** Boolean expression to compare columns of type "enum_tracked_metric_group_enum". All fields are combined with logical 'AND'. */
export type enum_tracked_metric_group_enum_comparison_exp = {
  _eq?: InputMaybe<enum_tracked_metric_group_enum>;
  _in?: InputMaybe<Array<enum_tracked_metric_group_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<enum_tracked_metric_group_enum>;
  _nin?: InputMaybe<Array<enum_tracked_metric_group_enum>>;
};

/** order by aggregate values of table "experiment" */
export type experiment_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<experiment_max_order_by>;
  min?: InputMaybe<experiment_min_order_by>;
};

/** Boolean expression to filter rows from the table "experiment". All fields are combined with a logical 'AND'. */
export type experiment_bool_exp = {
  _and?: InputMaybe<Array<experiment_bool_exp>>;
  _not?: InputMaybe<experiment_bool_exp>;
  _or?: InputMaybe<Array<experiment_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  dashboard?: InputMaybe<dashboard_bool_exp>;
  description?: InputMaybe<String_comparison_exp>;
  end_date?: InputMaybe<timestamptz_comparison_exp>;
  experiment_metrics?: InputMaybe<experiment_metric_bool_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  start_date?: InputMaybe<timestamptz_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "experiment" */
export enum experiment_constraint {
  /** unique or primary key constraint on columns "id" */
  experiment_pkey = 'experiment_pkey'
}

/** input type for inserting data into table "experiment" */
export type experiment_insert_input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dashboard?: InputMaybe<dashboard_obj_rel_insert_input>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  experiment_metrics?: InputMaybe<experiment_metric_arr_rel_insert_input>;
  name?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "experiment" */
export type experiment_max_order_by = {
  created_at?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  end_date?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  start_date?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by aggregate values of table "experiment_metric" */
export type experiment_metric_aggregate_order_by = {
  avg?: InputMaybe<experiment_metric_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<experiment_metric_max_order_by>;
  min?: InputMaybe<experiment_metric_min_order_by>;
  stddev?: InputMaybe<experiment_metric_stddev_order_by>;
  stddev_pop?: InputMaybe<experiment_metric_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<experiment_metric_stddev_samp_order_by>;
  sum?: InputMaybe<experiment_metric_sum_order_by>;
  var_pop?: InputMaybe<experiment_metric_var_pop_order_by>;
  var_samp?: InputMaybe<experiment_metric_var_samp_order_by>;
  variance?: InputMaybe<experiment_metric_variance_order_by>;
};

/** input type for inserting array relation for remote table "experiment_metric" */
export type experiment_metric_arr_rel_insert_input = {
  data: Array<experiment_metric_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<experiment_metric_on_conflict>;
};

/** order by avg() on columns of table "experiment_metric" */
export type experiment_metric_avg_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "experiment_metric". All fields are combined with a logical 'AND'. */
export type experiment_metric_bool_exp = {
  _and?: InputMaybe<Array<experiment_metric_bool_exp>>;
  _not?: InputMaybe<experiment_metric_bool_exp>;
  _or?: InputMaybe<Array<experiment_metric_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  experiment?: InputMaybe<experiment_bool_exp>;
  experiment_id?: InputMaybe<uuid_comparison_exp>;
  metric?: InputMaybe<metric_bool_exp>;
  metric_id?: InputMaybe<uuid_comparison_exp>;
  primary?: InputMaybe<Boolean_comparison_exp>;
  sort_order?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "experiment_metric" */
export enum experiment_metric_constraint {
  /** unique or primary key constraint on columns "metric_id", "experiment_id" */
  experiment_metric_pkey = 'experiment_metric_pkey'
}

/** input type for incrementing numeric columns in table "experiment_metric" */
export type experiment_metric_inc_input = {
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "experiment_metric" */
export type experiment_metric_insert_input = {
  experiment?: InputMaybe<experiment_obj_rel_insert_input>;
  experiment_id?: InputMaybe<Scalars['uuid']['input']>;
  metric?: InputMaybe<metric_obj_rel_insert_input>;
  metric_id?: InputMaybe<Scalars['uuid']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** order by max() on columns of table "experiment_metric" */
export type experiment_metric_max_order_by = {
  created_at?: InputMaybe<order_by>;
  experiment_id?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "experiment_metric" */
export type experiment_metric_min_order_by = {
  created_at?: InputMaybe<order_by>;
  experiment_id?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "experiment_metric" */
export type experiment_metric_on_conflict = {
  constraint: experiment_metric_constraint;
  update_columns?: Array<experiment_metric_update_column>;
  where?: InputMaybe<experiment_metric_bool_exp>;
};

/** input type for updating data in table "experiment_metric" */
export type experiment_metric_set_input = {
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** order by stddev() on columns of table "experiment_metric" */
export type experiment_metric_stddev_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "experiment_metric" */
export type experiment_metric_stddev_pop_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "experiment_metric" */
export type experiment_metric_stddev_samp_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "experiment_metric" */
export type experiment_metric_sum_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** update columns of table "experiment_metric" */
export enum experiment_metric_update_column {
  /** column name */
  primary = 'primary',
  /** column name */
  sort_order = 'sort_order'
}

export type experiment_metric_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<experiment_metric_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<experiment_metric_set_input>;
  /** filter the rows which have to be updated */
  where: experiment_metric_bool_exp;
};

/** order by var_pop() on columns of table "experiment_metric" */
export type experiment_metric_var_pop_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "experiment_metric" */
export type experiment_metric_var_samp_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "experiment_metric" */
export type experiment_metric_variance_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** order by min() on columns of table "experiment" */
export type experiment_min_order_by = {
  created_at?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  end_date?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  start_date?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** input type for inserting object relation for remote table "experiment" */
export type experiment_obj_rel_insert_input = {
  data: experiment_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<experiment_on_conflict>;
};

/** on_conflict condition type for table "experiment" */
export type experiment_on_conflict = {
  constraint: experiment_constraint;
  update_columns?: Array<experiment_update_column>;
  where?: InputMaybe<experiment_bool_exp>;
};

/** input type for updating data in table "experiment" */
export type experiment_set_input = {
  description?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "experiment" */
export enum experiment_update_column {
  /** column name */
  description = 'description',
  /** column name */
  end_date = 'end_date',
  /** column name */
  name = 'name',
  /** column name */
  start_date = 'start_date'
}

/** order by aggregate values of table "expert_user_access" */
export type expert_user_access_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<expert_user_access_max_order_by>;
  min?: InputMaybe<expert_user_access_min_order_by>;
};

/** Boolean expression to filter rows from the table "expert_user_access". All fields are combined with a logical 'AND'. */
export type expert_user_access_bool_exp = {
  _and?: InputMaybe<Array<expert_user_access_bool_exp>>;
  _not?: InputMaybe<expert_user_access_bool_exp>;
  _or?: InputMaybe<Array<expert_user_access_bool_exp>>;
  expert?: InputMaybe<user_bool_exp>;
  expert_user_id?: InputMaybe<String_comparison_exp>;
  member?: InputMaybe<user_bool_exp>;
  member_user_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "expert_user_access" */
export type expert_user_access_max_order_by = {
  expert_user_id?: InputMaybe<order_by>;
  member_user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "expert_user_access" */
export type expert_user_access_min_order_by = {
  expert_user_id?: InputMaybe<order_by>;
  member_user_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "feature_request". All fields are combined with a logical 'AND'. */
export type feature_request_bool_exp = {
  _and?: InputMaybe<Array<feature_request_bool_exp>>;
  _not?: InputMaybe<feature_request_bool_exp>;
  _or?: InputMaybe<Array<feature_request_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  slug?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_feature_requests?: InputMaybe<user_feature_request_bool_exp>;
};

/** Boolean expression to filter rows from the table "goal". All fields are combined with a logical 'AND'. */
export type goal_bool_exp = {
  _and?: InputMaybe<Array<goal_bool_exp>>;
  _not?: InputMaybe<goal_bool_exp>;
  _or?: InputMaybe<Array<goal_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  slug?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_goals?: InputMaybe<user_goal_bool_exp>;
};

/** Boolean expression to filter rows from the table "home_tile". All fields are combined with a logical 'AND'. */
export type home_tile_bool_exp = {
  _and?: InputMaybe<Array<home_tile_bool_exp>>;
  _not?: InputMaybe<home_tile_bool_exp>;
  _or?: InputMaybe<Array<home_tile_bool_exp>>;
  category?: InputMaybe<enum_home_tile_category_enum_comparison_exp>;
  data_source?: InputMaybe<enum_data_source_enum_comparison_exp>;
  default_sort_order?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  is_default?: InputMaybe<Boolean_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
};

/** Boolean expression to compare columns of type "int4range". All fields are combined with logical 'AND'. */
export type int4range_comparison_exp = {
  _eq?: InputMaybe<Scalars['int4range']['input']>;
  _gt?: InputMaybe<Scalars['int4range']['input']>;
  _gte?: InputMaybe<Scalars['int4range']['input']>;
  _in?: InputMaybe<Array<Scalars['int4range']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['int4range']['input']>;
  _lte?: InputMaybe<Scalars['int4range']['input']>;
  _neq?: InputMaybe<Scalars['int4range']['input']>;
  _nin?: InputMaybe<Array<Scalars['int4range']['input']>>;
};

export type integration_sync_event_aggregate_bool_exp = {
  bool_and?: InputMaybe<integration_sync_event_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<integration_sync_event_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<integration_sync_event_aggregate_bool_exp_count>;
};

export type integration_sync_event_aggregate_bool_exp_bool_and = {
  arguments: integration_sync_event_select_column_integration_sync_event_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<integration_sync_event_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type integration_sync_event_aggregate_bool_exp_bool_or = {
  arguments: integration_sync_event_select_column_integration_sync_event_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<integration_sync_event_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type integration_sync_event_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<integration_sync_event_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<integration_sync_event_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "integration_sync_event" */
export type integration_sync_event_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<integration_sync_event_max_order_by>;
  min?: InputMaybe<integration_sync_event_min_order_by>;
};

/** Boolean expression to filter rows from the table "integration_sync_event". All fields are combined with a logical 'AND'. */
export type integration_sync_event_bool_exp = {
  _and?: InputMaybe<Array<integration_sync_event_bool_exp>>;
  _not?: InputMaybe<integration_sync_event_bool_exp>;
  _or?: InputMaybe<Array<integration_sync_event_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  end_date?: InputMaybe<timestamptz_comparison_exp>;
  errors?: InputMaybe<jsonb_comparison_exp>;
  external_user_id?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  integration?: InputMaybe<String_comparison_exp>;
  start_date?: InputMaybe<timestamptz_comparison_exp>;
  success?: InputMaybe<Boolean_comparison_exp>;
  sync_type?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "integration_sync_event" */
export type integration_sync_event_max_order_by = {
  created_at?: InputMaybe<order_by>;
  end_date?: InputMaybe<order_by>;
  external_user_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  integration?: InputMaybe<order_by>;
  start_date?: InputMaybe<order_by>;
  sync_type?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "integration_sync_event" */
export type integration_sync_event_min_order_by = {
  created_at?: InputMaybe<order_by>;
  end_date?: InputMaybe<order_by>;
  external_user_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  integration?: InputMaybe<order_by>;
  start_date?: InputMaybe<order_by>;
  sync_type?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** select columns of table "integration_sync_event" */
export enum integration_sync_event_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  end_date = 'end_date',
  /** column name */
  errors = 'errors',
  /** column name */
  external_user_id = 'external_user_id',
  /** column name */
  id = 'id',
  /** column name */
  integration = 'integration',
  /** column name */
  start_date = 'start_date',
  /** column name */
  success = 'success',
  /** column name */
  sync_type = 'sync_type',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  user_id = 'user_id'
}

/** select "integration_sync_event_aggregate_bool_exp_bool_and_arguments_columns" columns of table "integration_sync_event" */
export enum integration_sync_event_select_column_integration_sync_event_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  success = 'success'
}

/** select "integration_sync_event_aggregate_bool_exp_bool_or_arguments_columns" columns of table "integration_sync_event" */
export enum integration_sync_event_select_column_integration_sync_event_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  success = 'success'
}

/** Boolean expression to compare columns of type "interval". All fields are combined with logical 'AND'. */
export type interval_comparison_exp = {
  _eq?: InputMaybe<Scalars['interval']['input']>;
  _gt?: InputMaybe<Scalars['interval']['input']>;
  _gte?: InputMaybe<Scalars['interval']['input']>;
  _in?: InputMaybe<Array<Scalars['interval']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['interval']['input']>;
  _lte?: InputMaybe<Scalars['interval']['input']>;
  _neq?: InputMaybe<Scalars['interval']['input']>;
  _nin?: InputMaybe<Array<Scalars['interval']['input']>>;
};

export type jsonb_cast_exp = {
  String?: InputMaybe<String_comparison_exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type jsonb_comparison_exp = {
  _cast?: InputMaybe<jsonb_cast_exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** Boolean expression to filter rows from the table "kpi_action_item". All fields are combined with a logical 'AND'. */
export type kpi_action_item_bool_exp = {
  _and?: InputMaybe<Array<kpi_action_item_bool_exp>>;
  _not?: InputMaybe<kpi_action_item_bool_exp>;
  _or?: InputMaybe<Array<kpi_action_item_bool_exp>>;
  action_item?: InputMaybe<action_item_bool_exp>;
  kpi?: InputMaybe<kpi_bool_exp>;
};

/** Boolean expression to filter rows from the table "kpi". All fields are combined with a logical 'AND'. */
export type kpi_bool_exp = {
  _and?: InputMaybe<Array<kpi_bool_exp>>;
  _not?: InputMaybe<kpi_bool_exp>;
  _or?: InputMaybe<Array<kpi_bool_exp>>;
  action_items?: InputMaybe<kpi_action_item_bool_exp>;
  action_priority_weight?: InputMaybe<numeric_comparison_exp>;
  category?: InputMaybe<kpi_category_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  kpi_category_id?: InputMaybe<uuid_comparison_exp>;
  kpi_subcategory_id?: InputMaybe<uuid_comparison_exp>;
  metrics?: InputMaybe<kpi_metric_bool_exp>;
  name?: InputMaybe<citext_comparison_exp>;
  sex_filter?: InputMaybe<enum_sex_enum_comparison_exp>;
  sort_order?: InputMaybe<Int_comparison_exp>;
  subcategory?: InputMaybe<kpi_category_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** Boolean expression to filter rows from the table "kpi_category". All fields are combined with a logical 'AND'. */
export type kpi_category_bool_exp = {
  _and?: InputMaybe<Array<kpi_category_bool_exp>>;
  _not?: InputMaybe<kpi_category_bool_exp>;
  _or?: InputMaybe<Array<kpi_category_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  kpis?: InputMaybe<kpi_bool_exp>;
  name?: InputMaybe<citext_comparison_exp>;
  sort_order?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** Boolean expression to filter rows from the table "kpi_metric". All fields are combined with a logical 'AND'. */
export type kpi_metric_bool_exp = {
  _and?: InputMaybe<Array<kpi_metric_bool_exp>>;
  _not?: InputMaybe<kpi_metric_bool_exp>;
  _or?: InputMaybe<Array<kpi_metric_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  interval_count?: InputMaybe<Int_comparison_exp>;
  interval_type?: InputMaybe<enum_rollup_interval_type_enum_comparison_exp>;
  kpi?: InputMaybe<kpi_bool_exp>;
  kpi_id?: InputMaybe<uuid_comparison_exp>;
  metric?: InputMaybe<metric_bool_exp>;
  metric_id?: InputMaybe<uuid_comparison_exp>;
  rollup_type?: InputMaybe<enum_metric_rollup_type_enum_comparison_exp>;
  sort_order?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** Boolean expression to filter rows from the table "kpi_snapshot_action_item_priority". All fields are combined with a logical 'AND'. */
export type kpi_snapshot_action_item_priority_bool_exp = {
  _and?: InputMaybe<Array<kpi_snapshot_action_item_priority_bool_exp>>;
  _not?: InputMaybe<kpi_snapshot_action_item_priority_bool_exp>;
  _or?: InputMaybe<Array<kpi_snapshot_action_item_priority_bool_exp>>;
  action_item?: InputMaybe<action_item_bool_exp>;
  action_item_id?: InputMaybe<uuid_comparison_exp>;
  action_plan_template_item_id?: InputMaybe<uuid_comparison_exp>;
  kpi?: InputMaybe<kpi_bool_exp>;
  kpi_id?: InputMaybe<uuid_comparison_exp>;
  kpi_metric_id?: InputMaybe<uuid_comparison_exp>;
  kpi_snapshot_id?: InputMaybe<uuid_comparison_exp>;
  kpi_snapshot_item?: InputMaybe<kpi_snapshot_item_bool_exp>;
  priority?: InputMaybe<numeric_comparison_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** Boolean expression to filter rows from the table "kpi_snapshot". All fields are combined with a logical 'AND'. */
export type kpi_snapshot_bool_exp = {
  _and?: InputMaybe<Array<kpi_snapshot_bool_exp>>;
  _not?: InputMaybe<kpi_snapshot_bool_exp>;
  _or?: InputMaybe<Array<kpi_snapshot_bool_exp>>;
  action_item_priorities?: InputMaybe<kpi_snapshot_action_item_priority_bool_exp>;
  action_plan_suggestions?: InputMaybe<action_plan_suggestion_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  date?: InputMaybe<date_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  items?: InputMaybe<kpi_snapshot_item_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** Boolean expression to filter rows from the table "kpi_snapshot_item". All fields are combined with a logical 'AND'. */
export type kpi_snapshot_item_bool_exp = {
  _and?: InputMaybe<Array<kpi_snapshot_item_bool_exp>>;
  _not?: InputMaybe<kpi_snapshot_item_bool_exp>;
  _or?: InputMaybe<Array<kpi_snapshot_item_bool_exp>>;
  kpi_metric?: InputMaybe<kpi_metric_bool_exp>;
  kpi_metric_id?: InputMaybe<uuid_comparison_exp>;
  kpi_snapshot?: InputMaybe<kpi_snapshot_bool_exp>;
  kpi_snapshot_id?: InputMaybe<uuid_comparison_exp>;
  metric_record?: InputMaybe<metric_record_bool_exp>;
  metric_record_id?: InputMaybe<uuid_comparison_exp>;
  position?: InputMaybe<enum_kpi_snapshot_item_position_enum_comparison_exp>;
  priority?: InputMaybe<numeric_comparison_exp>;
  reference_range_target?: InputMaybe<reference_range_target_bool_exp>;
  reference_range_target_id?: InputMaybe<uuid_comparison_exp>;
};

export type lab_order_aggregate_bool_exp = {
  bool_and?: InputMaybe<lab_order_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<lab_order_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<lab_order_aggregate_bool_exp_count>;
};

export type lab_order_aggregate_bool_exp_bool_and = {
  arguments: lab_order_select_column_lab_order_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<lab_order_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type lab_order_aggregate_bool_exp_bool_or = {
  arguments: lab_order_select_column_lab_order_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<lab_order_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type lab_order_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<lab_order_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<lab_order_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "lab_order" */
export type lab_order_aggregate_order_by = {
  avg?: InputMaybe<lab_order_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<lab_order_max_order_by>;
  min?: InputMaybe<lab_order_min_order_by>;
  stddev?: InputMaybe<lab_order_stddev_order_by>;
  stddev_pop?: InputMaybe<lab_order_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<lab_order_stddev_samp_order_by>;
  sum?: InputMaybe<lab_order_sum_order_by>;
  var_pop?: InputMaybe<lab_order_var_pop_order_by>;
  var_samp?: InputMaybe<lab_order_var_samp_order_by>;
  variance?: InputMaybe<lab_order_variance_order_by>;
};

/** order by avg() on columns of table "lab_order" */
export type lab_order_avg_order_by = {
  order_number?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "lab_order". All fields are combined with a logical 'AND'. */
export type lab_order_bool_exp = {
  _and?: InputMaybe<Array<lab_order_bool_exp>>;
  _not?: InputMaybe<lab_order_bool_exp>;
  _or?: InputMaybe<Array<lab_order_bool_exp>>;
  api_error?: InputMaybe<Boolean_comparison_exp>;
  api_error_message?: InputMaybe<String_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  error_notification_sent?: InputMaybe<Boolean_comparison_exp>;
  external_id?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  lab?: InputMaybe<enum_lab_enum_comparison_exp>;
  lab_order_status?: InputMaybe<enum_lab_order_status_enum_comparison_exp>;
  lab_result?: InputMaybe<lab_result_bool_exp>;
  lab_result_id?: InputMaybe<uuid_comparison_exp>;
  lab_result_status?: InputMaybe<enum_lab_result_status_enum_comparison_exp>;
  order?: InputMaybe<stripe_order_bool_exp>;
  order_fulfillment_group?: InputMaybe<stripe_order_fulfillment_group_bool_exp>;
  order_fulfillment_group_id?: InputMaybe<uuid_comparison_exp>;
  order_id?: InputMaybe<uuid_comparison_exp>;
  order_number?: InputMaybe<Int_comparison_exp>;
  partial_results_notification_sent?: InputMaybe<Boolean_comparison_exp>;
  preparation?: InputMaybe<String_comparison_exp>;
  requisition_notification_sent?: InputMaybe<Boolean_comparison_exp>;
  requisition_number?: InputMaybe<String_comparison_exp>;
  requisition_pdf?: InputMaybe<user_file_vault_bool_exp>;
  requisition_pdf_vault_file_id?: InputMaybe<uuid_comparison_exp>;
  results_notification_sent?: InputMaybe<Boolean_comparison_exp>;
  results_pdf?: InputMaybe<user_file_vault_bool_exp>;
  results_pdf_vault_file_id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "lab_order" */
export type lab_order_max_order_by = {
  api_error_message?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  external_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  lab_result_id?: InputMaybe<order_by>;
  order_fulfillment_group_id?: InputMaybe<order_by>;
  order_id?: InputMaybe<order_by>;
  order_number?: InputMaybe<order_by>;
  preparation?: InputMaybe<order_by>;
  requisition_number?: InputMaybe<order_by>;
  requisition_pdf_vault_file_id?: InputMaybe<order_by>;
  results_pdf_vault_file_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "lab_order" */
export type lab_order_min_order_by = {
  api_error_message?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  external_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  lab_result_id?: InputMaybe<order_by>;
  order_fulfillment_group_id?: InputMaybe<order_by>;
  order_id?: InputMaybe<order_by>;
  order_number?: InputMaybe<order_by>;
  preparation?: InputMaybe<order_by>;
  requisition_number?: InputMaybe<order_by>;
  requisition_pdf_vault_file_id?: InputMaybe<order_by>;
  results_pdf_vault_file_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "lab_order". */
export type lab_order_order_by = {
  api_error?: InputMaybe<order_by>;
  api_error_message?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  error_notification_sent?: InputMaybe<order_by>;
  external_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  lab?: InputMaybe<order_by>;
  lab_order_status?: InputMaybe<order_by>;
  lab_result?: InputMaybe<lab_result_order_by>;
  lab_result_id?: InputMaybe<order_by>;
  lab_result_status?: InputMaybe<order_by>;
  order?: InputMaybe<stripe_order_order_by>;
  order_fulfillment_group?: InputMaybe<stripe_order_fulfillment_group_order_by>;
  order_fulfillment_group_id?: InputMaybe<order_by>;
  order_id?: InputMaybe<order_by>;
  order_number?: InputMaybe<order_by>;
  partial_results_notification_sent?: InputMaybe<order_by>;
  preparation?: InputMaybe<order_by>;
  requisition_notification_sent?: InputMaybe<order_by>;
  requisition_number?: InputMaybe<order_by>;
  requisition_pdf?: InputMaybe<user_file_vault_order_by>;
  requisition_pdf_vault_file_id?: InputMaybe<order_by>;
  results_notification_sent?: InputMaybe<order_by>;
  results_pdf?: InputMaybe<user_file_vault_order_by>;
  results_pdf_vault_file_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user?: InputMaybe<user_order_by>;
  user_id?: InputMaybe<order_by>;
};

/** select columns of table "lab_order" */
export enum lab_order_select_column {
  /** column name */
  api_error = 'api_error',
  /** column name */
  api_error_message = 'api_error_message',
  /** column name */
  created_at = 'created_at',
  /** column name */
  error_notification_sent = 'error_notification_sent',
  /** column name */
  external_id = 'external_id',
  /** column name */
  id = 'id',
  /** column name */
  lab = 'lab',
  /** column name */
  lab_order_status = 'lab_order_status',
  /** column name */
  lab_result_id = 'lab_result_id',
  /** column name */
  lab_result_status = 'lab_result_status',
  /** column name */
  order_fulfillment_group_id = 'order_fulfillment_group_id',
  /** column name */
  order_id = 'order_id',
  /** column name */
  order_number = 'order_number',
  /** column name */
  partial_results_notification_sent = 'partial_results_notification_sent',
  /** column name */
  preparation = 'preparation',
  /** column name */
  requisition_notification_sent = 'requisition_notification_sent',
  /** column name */
  requisition_number = 'requisition_number',
  /** column name */
  requisition_pdf_vault_file_id = 'requisition_pdf_vault_file_id',
  /** column name */
  results_notification_sent = 'results_notification_sent',
  /** column name */
  results_pdf_vault_file_id = 'results_pdf_vault_file_id',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  user_id = 'user_id'
}

/** select "lab_order_aggregate_bool_exp_bool_and_arguments_columns" columns of table "lab_order" */
export enum lab_order_select_column_lab_order_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  api_error = 'api_error',
  /** column name */
  error_notification_sent = 'error_notification_sent',
  /** column name */
  partial_results_notification_sent = 'partial_results_notification_sent',
  /** column name */
  requisition_notification_sent = 'requisition_notification_sent',
  /** column name */
  results_notification_sent = 'results_notification_sent'
}

/** select "lab_order_aggregate_bool_exp_bool_or_arguments_columns" columns of table "lab_order" */
export enum lab_order_select_column_lab_order_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  api_error = 'api_error',
  /** column name */
  error_notification_sent = 'error_notification_sent',
  /** column name */
  partial_results_notification_sent = 'partial_results_notification_sent',
  /** column name */
  requisition_notification_sent = 'requisition_notification_sent',
  /** column name */
  results_notification_sent = 'results_notification_sent'
}

/** order by stddev() on columns of table "lab_order" */
export type lab_order_stddev_order_by = {
  order_number?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "lab_order" */
export type lab_order_stddev_pop_order_by = {
  order_number?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "lab_order" */
export type lab_order_stddev_samp_order_by = {
  order_number?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "lab_order" */
export type lab_order_sum_order_by = {
  order_number?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "lab_order" */
export type lab_order_var_pop_order_by = {
  order_number?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "lab_order" */
export type lab_order_var_samp_order_by = {
  order_number?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "lab_order" */
export type lab_order_variance_order_by = {
  order_number?: InputMaybe<order_by>;
};

/** order by aggregate values of table "lab_profile" */
export type lab_profile_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<lab_profile_max_order_by>;
  min?: InputMaybe<lab_profile_min_order_by>;
};

/** Boolean expression to filter rows from the table "lab_profile". All fields are combined with a logical 'AND'. */
export type lab_profile_bool_exp = {
  _and?: InputMaybe<Array<lab_profile_bool_exp>>;
  _not?: InputMaybe<lab_profile_bool_exp>;
  _or?: InputMaybe<Array<lab_profile_bool_exp>>;
  birth_date?: InputMaybe<date_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  first_name?: InputMaybe<String_comparison_exp>;
  is_complete?: InputMaybe<Boolean_comparison_exp>;
  last_name?: InputMaybe<String_comparison_exp>;
  phone_number?: InputMaybe<String_comparison_exp>;
  sex?: InputMaybe<String_comparison_exp>;
  ship_to_address?: InputMaybe<String_comparison_exp>;
  ship_to_address1?: InputMaybe<String_comparison_exp>;
  ship_to_city?: InputMaybe<String_comparison_exp>;
  ship_to_country?: InputMaybe<String_comparison_exp>;
  ship_to_postal_code?: InputMaybe<bpchar_comparison_exp>;
  ship_to_state?: InputMaybe<bpchar_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "lab_profile" */
export type lab_profile_max_order_by = {
  birth_date?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  first_name?: InputMaybe<order_by>;
  last_name?: InputMaybe<order_by>;
  phone_number?: InputMaybe<order_by>;
  sex?: InputMaybe<order_by>;
  ship_to_address?: InputMaybe<order_by>;
  ship_to_address1?: InputMaybe<order_by>;
  ship_to_city?: InputMaybe<order_by>;
  ship_to_country?: InputMaybe<order_by>;
  ship_to_postal_code?: InputMaybe<order_by>;
  ship_to_state?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "lab_profile" */
export type lab_profile_min_order_by = {
  birth_date?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  first_name?: InputMaybe<order_by>;
  last_name?: InputMaybe<order_by>;
  phone_number?: InputMaybe<order_by>;
  sex?: InputMaybe<order_by>;
  ship_to_address?: InputMaybe<order_by>;
  ship_to_address1?: InputMaybe<order_by>;
  ship_to_city?: InputMaybe<order_by>;
  ship_to_country?: InputMaybe<order_by>;
  ship_to_postal_code?: InputMaybe<order_by>;
  ship_to_state?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by aggregate values of table "lab_result" */
export type lab_result_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<lab_result_max_order_by>;
  min?: InputMaybe<lab_result_min_order_by>;
};

/** Boolean expression to filter rows from the table "lab_result". All fields are combined with a logical 'AND'. */
export type lab_result_bool_exp = {
  _and?: InputMaybe<Array<lab_result_bool_exp>>;
  _not?: InputMaybe<lab_result_bool_exp>;
  _or?: InputMaybe<Array<lab_result_bool_exp>>;
  comments?: InputMaybe<String_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  data_source?: InputMaybe<enum_data_source_enum_comparison_exp>;
  datetime_utc?: InputMaybe<timestamptz_comparison_exp>;
  external_id?: InputMaybe<String_comparison_exp>;
  file_vault?: InputMaybe<user_file_vault_bool_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  impression?: InputMaybe<String_comparison_exp>;
  lab_name?: InputMaybe<String_comparison_exp>;
  lab_order?: InputMaybe<lab_order_bool_exp>;
  metric_record_group?: InputMaybe<metric_record_group_bool_exp>;
  metric_record_group_id?: InputMaybe<uuid_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  narrative?: InputMaybe<String_comparison_exp>;
  tests?: InputMaybe<lab_result_test_bool_exp>;
  transcriptions?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_confirmed?: InputMaybe<Boolean_comparison_exp>;
  user_file_vault_id?: InputMaybe<uuid_comparison_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by aggregate values of table "lab_result_marker" */
export type lab_result_marker_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<lab_result_marker_max_order_by>;
  min?: InputMaybe<lab_result_marker_min_order_by>;
};

/** Boolean expression to filter rows from the table "lab_result_marker". All fields are combined with a logical 'AND'. */
export type lab_result_marker_bool_exp = {
  _and?: InputMaybe<Array<lab_result_marker_bool_exp>>;
  _not?: InputMaybe<lab_result_marker_bool_exp>;
  _or?: InputMaybe<Array<lab_result_marker_bool_exp>>;
  converted_value?: InputMaybe<String_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  incoming_unit?: InputMaybe<String_comparison_exp>;
  incoming_value?: InputMaybe<String_comparison_exp>;
  internal_range_optimal?: InputMaybe<Boolean_comparison_exp>;
  internal_rating_optimal?: InputMaybe<Boolean_comparison_exp>;
  is_optimal?: InputMaybe<Boolean_comparison_exp>;
  lab_range_optimal?: InputMaybe<Boolean_comparison_exp>;
  marker?: InputMaybe<lab_test_marker_bool_exp>;
  metric_record?: InputMaybe<metric_record_bool_exp>;
  test?: InputMaybe<lab_result_test_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by max() on columns of table "lab_result_marker" */
export type lab_result_marker_max_order_by = {
  converted_value?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  incoming_unit?: InputMaybe<order_by>;
  incoming_value?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "lab_result_marker" */
export type lab_result_marker_min_order_by = {
  converted_value?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  incoming_unit?: InputMaybe<order_by>;
  incoming_value?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "lab_result_marker". */
export type lab_result_marker_order_by = {
  converted_value?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  incoming_unit?: InputMaybe<order_by>;
  incoming_value?: InputMaybe<order_by>;
  internal_range_optimal?: InputMaybe<order_by>;
  internal_rating_optimal?: InputMaybe<order_by>;
  is_optimal?: InputMaybe<order_by>;
  lab_range_optimal?: InputMaybe<order_by>;
  marker?: InputMaybe<lab_test_marker_order_by>;
  metric_record?: InputMaybe<metric_record_order_by>;
  test?: InputMaybe<lab_result_test_order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by max() on columns of table "lab_result" */
export type lab_result_max_order_by = {
  comments?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  datetime_utc?: InputMaybe<order_by>;
  external_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  impression?: InputMaybe<order_by>;
  lab_name?: InputMaybe<order_by>;
  metric_record_group_id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  narrative?: InputMaybe<order_by>;
  transcriptions?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_file_vault_id?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "lab_result" */
export type lab_result_min_order_by = {
  comments?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  datetime_utc?: InputMaybe<order_by>;
  external_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  impression?: InputMaybe<order_by>;
  lab_name?: InputMaybe<order_by>;
  metric_record_group_id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  narrative?: InputMaybe<order_by>;
  transcriptions?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_file_vault_id?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "lab_result". */
export type lab_result_order_by = {
  comments?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  data_source?: InputMaybe<order_by>;
  datetime_utc?: InputMaybe<order_by>;
  external_id?: InputMaybe<order_by>;
  file_vault?: InputMaybe<user_file_vault_order_by>;
  id?: InputMaybe<order_by>;
  impression?: InputMaybe<order_by>;
  lab_name?: InputMaybe<order_by>;
  lab_order?: InputMaybe<lab_order_order_by>;
  metric_record_group?: InputMaybe<metric_record_group_order_by>;
  metric_record_group_id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  narrative?: InputMaybe<order_by>;
  tests_aggregate?: InputMaybe<lab_result_test_aggregate_order_by>;
  transcriptions?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user?: InputMaybe<user_order_by>;
  user_confirmed?: InputMaybe<order_by>;
  user_file_vault_id?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by aggregate values of table "lab_result_test" */
export type lab_result_test_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<lab_result_test_max_order_by>;
  min?: InputMaybe<lab_result_test_min_order_by>;
};

/** Boolean expression to filter rows from the table "lab_result_test". All fields are combined with a logical 'AND'. */
export type lab_result_test_bool_exp = {
  _and?: InputMaybe<Array<lab_result_test_bool_exp>>;
  _not?: InputMaybe<lab_result_test_bool_exp>;
  _or?: InputMaybe<Array<lab_result_test_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  lab_item?: InputMaybe<lab_test_item_bool_exp>;
  lab_result?: InputMaybe<lab_result_bool_exp>;
  markers?: InputMaybe<lab_result_marker_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by max() on columns of table "lab_result_test" */
export type lab_result_test_max_order_by = {
  created_at?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "lab_result_test" */
export type lab_result_test_min_order_by = {
  created_at?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "lab_result_test". */
export type lab_result_test_order_by = {
  created_at?: InputMaybe<order_by>;
  lab_item?: InputMaybe<lab_test_item_order_by>;
  lab_result?: InputMaybe<lab_result_order_by>;
  markers_aggregate?: InputMaybe<lab_result_marker_aggregate_order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "lab_test_item". All fields are combined with a logical 'AND'. */
export type lab_test_item_bool_exp = {
  _and?: InputMaybe<Array<lab_test_item_bool_exp>>;
  _not?: InputMaybe<lab_test_item_bool_exp>;
  _or?: InputMaybe<Array<lab_test_item_bool_exp>>;
  description?: InputMaybe<String_comparison_exp>;
  display_name?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  item_type?: InputMaybe<String_comparison_exp>;
  lab?: InputMaybe<enum_lab_enum_comparison_exp>;
  lab_test_code?: InputMaybe<String_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  preparation?: InputMaybe<String_comparison_exp>;
  products?: InputMaybe<stripe_product_lab_test_item_bool_exp>;
  sku?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "lab_test_item". */
export type lab_test_item_order_by = {
  description?: InputMaybe<order_by>;
  display_name?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  item_type?: InputMaybe<order_by>;
  lab?: InputMaybe<order_by>;
  lab_test_code?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  preparation?: InputMaybe<order_by>;
  products_aggregate?: InputMaybe<stripe_product_lab_test_item_aggregate_order_by>;
  sku?: InputMaybe<order_by>;
};

/** order by aggregate values of table "lab_test_marker" */
export type lab_test_marker_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<lab_test_marker_max_order_by>;
  min?: InputMaybe<lab_test_marker_min_order_by>;
};

/** Boolean expression to filter rows from the table "lab_test_marker". All fields are combined with a logical 'AND'. */
export type lab_test_marker_bool_exp = {
  _and?: InputMaybe<Array<lab_test_marker_bool_exp>>;
  _not?: InputMaybe<lab_test_marker_bool_exp>;
  _or?: InputMaybe<Array<lab_test_marker_bool_exp>>;
  component?: InputMaybe<String_comparison_exp>;
  consumer_name?: InputMaybe<String_comparison_exp>;
  display_name?: InputMaybe<String_comparison_exp>;
  display_name_gen?: InputMaybe<String_comparison_exp>;
  example_ucum_units?: InputMaybe<String_comparison_exp>;
  example_units?: InputMaybe<String_comparison_exp>;
  html_description?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  include_in_overview?: InputMaybe<Boolean_comparison_exp>;
  labels?: InputMaybe<lab_test_marker_label_bool_exp>;
  loinc_number?: InputMaybe<String_comparison_exp>;
  long_common_name?: InputMaybe<String_comparison_exp>;
  metric?: InputMaybe<metric_bool_exp>;
  metric_id?: InputMaybe<uuid_comparison_exp>;
  short_name?: InputMaybe<String_comparison_exp>;
  synonyms?: InputMaybe<_text_comparison_exp>;
};

/** order by aggregate values of table "lab_test_marker_label" */
export type lab_test_marker_label_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<lab_test_marker_label_max_order_by>;
  min?: InputMaybe<lab_test_marker_label_min_order_by>;
};

/** Boolean expression to filter rows from the table "lab_test_marker_label". All fields are combined with a logical 'AND'. */
export type lab_test_marker_label_bool_exp = {
  _and?: InputMaybe<Array<lab_test_marker_label_bool_exp>>;
  _not?: InputMaybe<lab_test_marker_label_bool_exp>;
  _or?: InputMaybe<Array<lab_test_marker_label_bool_exp>>;
  lab_test_marker?: InputMaybe<lab_test_marker_bool_exp>;
  lab_test_marker_id?: InputMaybe<uuid_comparison_exp>;
  label?: InputMaybe<label_bool_exp>;
  label_id?: InputMaybe<uuid_comparison_exp>;
};

/** order by max() on columns of table "lab_test_marker_label" */
export type lab_test_marker_label_max_order_by = {
  lab_test_marker_id?: InputMaybe<order_by>;
  label_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "lab_test_marker_label" */
export type lab_test_marker_label_min_order_by = {
  lab_test_marker_id?: InputMaybe<order_by>;
  label_id?: InputMaybe<order_by>;
};

/** order by max() on columns of table "lab_test_marker" */
export type lab_test_marker_max_order_by = {
  component?: InputMaybe<order_by>;
  consumer_name?: InputMaybe<order_by>;
  display_name?: InputMaybe<order_by>;
  display_name_gen?: InputMaybe<order_by>;
  example_ucum_units?: InputMaybe<order_by>;
  example_units?: InputMaybe<order_by>;
  html_description?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  loinc_number?: InputMaybe<order_by>;
  long_common_name?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  short_name?: InputMaybe<order_by>;
  synonyms?: InputMaybe<order_by>;
};

/** order by min() on columns of table "lab_test_marker" */
export type lab_test_marker_min_order_by = {
  component?: InputMaybe<order_by>;
  consumer_name?: InputMaybe<order_by>;
  display_name?: InputMaybe<order_by>;
  display_name_gen?: InputMaybe<order_by>;
  example_ucum_units?: InputMaybe<order_by>;
  example_units?: InputMaybe<order_by>;
  html_description?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  loinc_number?: InputMaybe<order_by>;
  long_common_name?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  short_name?: InputMaybe<order_by>;
  synonyms?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "lab_test_marker". */
export type lab_test_marker_order_by = {
  component?: InputMaybe<order_by>;
  consumer_name?: InputMaybe<order_by>;
  display_name?: InputMaybe<order_by>;
  display_name_gen?: InputMaybe<order_by>;
  example_ucum_units?: InputMaybe<order_by>;
  example_units?: InputMaybe<order_by>;
  html_description?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  include_in_overview?: InputMaybe<order_by>;
  labels_aggregate?: InputMaybe<lab_test_marker_label_aggregate_order_by>;
  loinc_number?: InputMaybe<order_by>;
  long_common_name?: InputMaybe<order_by>;
  metric?: InputMaybe<metric_order_by>;
  metric_id?: InputMaybe<order_by>;
  short_name?: InputMaybe<order_by>;
  synonyms?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "label". All fields are combined with a logical 'AND'. */
export type label_bool_exp = {
  _and?: InputMaybe<Array<label_bool_exp>>;
  _not?: InputMaybe<label_bool_exp>;
  _or?: InputMaybe<Array<label_bool_exp>>;
  action_items?: InputMaybe<action_item_label_bool_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  lab_test_markers?: InputMaybe<lab_test_marker_label_bool_exp>;
  name?: InputMaybe<String_comparison_exp>;
  stripe_products?: InputMaybe<stripe_product_label_bool_exp>;
};

export type latest_rollup_values_metric_args = {
  data_sources?: InputMaybe<Scalars['_text']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  interval_count?: InputMaybe<Scalars['Int']['input']>;
  interval_type?: InputMaybe<Scalars['String']['input']>;
  relative_date?: InputMaybe<Scalars['Boolean']['input']>;
  rollup_type?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
};

/** order by aggregate values of table "life_event" */
export type life_event_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<life_event_max_order_by>;
  min?: InputMaybe<life_event_min_order_by>;
};

/** Boolean expression to filter rows from the table "life_event". All fields are combined with a logical 'AND'. */
export type life_event_bool_exp = {
  _and?: InputMaybe<Array<life_event_bool_exp>>;
  _not?: InputMaybe<life_event_bool_exp>;
  _or?: InputMaybe<Array<life_event_bool_exp>>;
  category?: InputMaybe<enum_life_event_category_enum_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  end?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  start?: InputMaybe<timestamptz_comparison_exp>;
  tags?: InputMaybe<tag_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "life_event" */
export enum life_event_constraint {
  /** unique or primary key constraint on columns "id" */
  life_event_pkey = 'life_event_pkey'
}

/** input type for inserting data into table "life_event" */
export type life_event_insert_input = {
  category?: InputMaybe<enum_life_event_category_enum>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
  tags?: InputMaybe<tag_arr_rel_insert_input>;
};

/** order by max() on columns of table "life_event" */
export type life_event_max_order_by = {
  created_at?: InputMaybe<order_by>;
  end?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  start?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "life_event" */
export type life_event_min_order_by = {
  created_at?: InputMaybe<order_by>;
  end?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  start?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** input type for inserting object relation for remote table "life_event" */
export type life_event_obj_rel_insert_input = {
  data: life_event_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<life_event_on_conflict>;
};

/** on_conflict condition type for table "life_event" */
export type life_event_on_conflict = {
  constraint: life_event_constraint;
  update_columns?: Array<life_event_update_column>;
  where?: InputMaybe<life_event_bool_exp>;
};

/** input type for updating data in table "life_event" */
export type life_event_set_input = {
  category?: InputMaybe<enum_life_event_category_enum>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "life_event" */
export enum life_event_update_column {
  /** column name */
  category = 'category',
  /** column name */
  end = 'end',
  /** column name */
  name = 'name',
  /** column name */
  start = 'start'
}

export enum measure_type {
  measurement = 'measurement',
  quantity = 'quantity'
}

/** order by aggregate values of table "membership_subscription" */
export type membership_subscription_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<membership_subscription_max_order_by>;
  min?: InputMaybe<membership_subscription_min_order_by>;
};

/** Boolean expression to filter rows from the table "membership_subscription". All fields are combined with a logical 'AND'. */
export type membership_subscription_bool_exp = {
  _and?: InputMaybe<Array<membership_subscription_bool_exp>>;
  _not?: InputMaybe<membership_subscription_bool_exp>;
  _or?: InputMaybe<Array<membership_subscription_bool_exp>>;
  cancel_scheduled_at?: InputMaybe<timestamp_comparison_exp>;
  cancellation_reason?: InputMaybe<jsonb_comparison_exp>;
  cancelled_at?: InputMaybe<timestamp_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  current_period_end?: InputMaybe<timestamp_comparison_exp>;
  expires_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  membership_tier?: InputMaybe<enum_membership_tier_enum_comparison_exp>;
  order_line_item?: InputMaybe<stripe_order_line_item_bool_exp>;
  product_line_item_id?: InputMaybe<uuid_comparison_exp>;
  stripe_subscription_id?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "membership_subscription" */
export type membership_subscription_max_order_by = {
  cancel_scheduled_at?: InputMaybe<order_by>;
  cancelled_at?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  current_period_end?: InputMaybe<order_by>;
  expires_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  product_line_item_id?: InputMaybe<order_by>;
  stripe_subscription_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "membership_subscription" */
export type membership_subscription_min_order_by = {
  cancel_scheduled_at?: InputMaybe<order_by>;
  cancelled_at?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  current_period_end?: InputMaybe<order_by>;
  expires_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  product_line_item_id?: InputMaybe<order_by>;
  stripe_subscription_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by aggregate values of table "metric" */
export type metric_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<metric_max_order_by>;
  min?: InputMaybe<metric_min_order_by>;
};

/** Boolean expression to filter rows from the table "metric". All fields are combined with a logical 'AND'. */
export type metric_bool_exp = {
  _and?: InputMaybe<Array<metric_bool_exp>>;
  _not?: InputMaybe<metric_bool_exp>;
  _or?: InputMaybe<Array<metric_bool_exp>>;
  alt_formatted_unit?: InputMaybe<String_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  default_rollup_interval_type?: InputMaybe<enum_rollup_interval_type_enum_comparison_exp>;
  default_weekly_rollup_type?: InputMaybe<enum_metric_rollup_type_enum_comparison_exp>;
  display_name?: InputMaybe<String_comparison_exp>;
  dynamic_record?: InputMaybe<dynamic_metric_bool_exp>;
  experiment_metrics?: InputMaybe<experiment_metric_bool_exp>;
  fresh_duration?: InputMaybe<interval_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  key?: InputMaybe<String_comparison_exp>;
  lab_test_markers?: InputMaybe<lab_test_marker_bool_exp>;
  measure_type?: InputMaybe<enum_measure_type_enum_comparison_exp>;
  metricComponentsByMetricId?: InputMaybe<metric_component_bool_exp>;
  metric_components?: InputMaybe<metric_component_bool_exp>;
  metric_external_codes?: InputMaybe<metric_external_codes_bool_exp>;
  metric_record_by_week?: InputMaybe<metric_record_by_week_bool_exp>;
  metric_record_by_week_aggregate?: InputMaybe<metric_record_by_week_aggregate_bool_exp>;
  metric_records?: InputMaybe<metric_record_bool_exp>;
  metric_records_aggregate?: InputMaybe<metric_record_aggregate_bool_exp>;
  metric_snapshot_items?: InputMaybe<metric_snapshot_item_bool_exp>;
  metric_targets?: InputMaybe<metric_target_bool_exp>;
  metric_type?: InputMaybe<metric_type_enum_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  namespace?: InputMaybe<String_comparison_exp>;
  namespace_key?: InputMaybe<String_comparison_exp>;
  preference_unit?: InputMaybe<String_comparison_exp>;
  preference_unit_details?: InputMaybe<unit_bool_exp>;
  reference_ranges?: InputMaybe<reference_range_bool_exp>;
  scale_label_high?: InputMaybe<String_comparison_exp>;
  scale_label_low?: InputMaybe<String_comparison_exp>;
  supplement?: InputMaybe<supplement_bool_exp>;
  supplement_id?: InputMaybe<uuid_comparison_exp>;
  unitDetails?: InputMaybe<unit_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
  user_unit_preferences?: InputMaybe<user_unit_preference_bool_exp>;
  watched_metric?: InputMaybe<watched_user_metric_bool_exp>;
};

/** order by aggregate values of table "metric_component" */
export type metric_component_aggregate_order_by = {
  avg?: InputMaybe<metric_component_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<metric_component_max_order_by>;
  min?: InputMaybe<metric_component_min_order_by>;
  stddev?: InputMaybe<metric_component_stddev_order_by>;
  stddev_pop?: InputMaybe<metric_component_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<metric_component_stddev_samp_order_by>;
  sum?: InputMaybe<metric_component_sum_order_by>;
  var_pop?: InputMaybe<metric_component_var_pop_order_by>;
  var_samp?: InputMaybe<metric_component_var_samp_order_by>;
  variance?: InputMaybe<metric_component_variance_order_by>;
};

/** order by avg() on columns of table "metric_component" */
export type metric_component_avg_order_by = {
  value?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "metric_component". All fields are combined with a logical 'AND'. */
export type metric_component_bool_exp = {
  _and?: InputMaybe<Array<metric_component_bool_exp>>;
  _not?: InputMaybe<metric_component_bool_exp>;
  _or?: InputMaybe<Array<metric_component_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  metric?: InputMaybe<metric_bool_exp>;
  metric_id?: InputMaybe<uuid_comparison_exp>;
  parent_metric?: InputMaybe<metric_bool_exp>;
  parent_metric_id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  value?: InputMaybe<numeric_comparison_exp>;
};

/** order by max() on columns of table "metric_component" */
export type metric_component_max_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  parent_metric_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** order by min() on columns of table "metric_component" */
export type metric_component_min_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  parent_metric_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** order by stddev() on columns of table "metric_component" */
export type metric_component_stddev_order_by = {
  value?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "metric_component" */
export type metric_component_stddev_pop_order_by = {
  value?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "metric_component" */
export type metric_component_stddev_samp_order_by = {
  value?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "metric_component" */
export type metric_component_sum_order_by = {
  value?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "metric_component" */
export type metric_component_var_pop_order_by = {
  value?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "metric_component" */
export type metric_component_var_samp_order_by = {
  value?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "metric_component" */
export type metric_component_variance_order_by = {
  value?: InputMaybe<order_by>;
};

/** unique or primary key constraints on table "metric" */
export enum metric_constraint {
  /** unique or primary key constraint on columns "key", "namespace" */
  metric_namespace_key_key = 'metric_namespace_key_key',
  /** unique or primary key constraint on columns "namespace_key" */
  metric_namespace_key_key1 = 'metric_namespace_key_key1',
  /** unique or primary key constraint on columns "id" */
  metric_pkey = 'metric_pkey',
  /** unique or primary key constraint on columns "supplement_id" */
  metric_supplement_id_key = 'metric_supplement_id_key'
}

/** order by aggregate values of table "metric_explorer_selection" */
export type metric_explorer_selection_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<metric_explorer_selection_max_order_by>;
  min?: InputMaybe<metric_explorer_selection_min_order_by>;
};

/** Boolean expression to filter rows from the table "metric_explorer_selection". All fields are combined with a logical 'AND'. */
export type metric_explorer_selection_bool_exp = {
  _and?: InputMaybe<Array<metric_explorer_selection_bool_exp>>;
  _not?: InputMaybe<metric_explorer_selection_bool_exp>;
  _or?: InputMaybe<Array<metric_explorer_selection_bool_exp>>;
  chart_name?: InputMaybe<String_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  data_source?: InputMaybe<enum_data_source_enum_comparison_exp>;
  metric?: InputMaybe<metric_bool_exp>;
  metric_id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  variant?: InputMaybe<String_comparison_exp>;
  view_metric_name?: InputMaybe<String_comparison_exp>;
};

/** input type for inserting data into table "metric_explorer_selection" */
export type metric_explorer_selection_insert_input = {
  chart_name?: InputMaybe<Scalars['String']['input']>;
  data_source?: InputMaybe<enum_data_source_enum>;
  metric?: InputMaybe<metric_obj_rel_insert_input>;
  metric_id?: InputMaybe<Scalars['uuid']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  view_metric_name?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "metric_explorer_selection" */
export type metric_explorer_selection_max_order_by = {
  chart_name?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  variant?: InputMaybe<order_by>;
  view_metric_name?: InputMaybe<order_by>;
};

/** order by min() on columns of table "metric_explorer_selection" */
export type metric_explorer_selection_min_order_by = {
  chart_name?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  variant?: InputMaybe<order_by>;
  view_metric_name?: InputMaybe<order_by>;
};

/** order by aggregate values of table "metric_external_codes" */
export type metric_external_codes_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<metric_external_codes_max_order_by>;
  min?: InputMaybe<metric_external_codes_min_order_by>;
};

/** Boolean expression to filter rows from the table "metric_external_codes". All fields are combined with a logical 'AND'. */
export type metric_external_codes_bool_exp = {
  _and?: InputMaybe<Array<metric_external_codes_bool_exp>>;
  _not?: InputMaybe<metric_external_codes_bool_exp>;
  _or?: InputMaybe<Array<metric_external_codes_bool_exp>>;
  code?: InputMaybe<String_comparison_exp>;
  code_system?: InputMaybe<String_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  metric?: InputMaybe<metric_bool_exp>;
  metric_id?: InputMaybe<uuid_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by max() on columns of table "metric_external_codes" */
export type metric_external_codes_max_order_by = {
  code?: InputMaybe<order_by>;
  code_system?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "metric_external_codes" */
export type metric_external_codes_min_order_by = {
  code?: InputMaybe<order_by>;
  code_system?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** input type for inserting data into table "metric" */
export type metric_insert_input = {
  alt_formatted_name?: InputMaybe<Scalars['String']['input']>;
  alt_formatted_unit?: InputMaybe<Scalars['String']['input']>;
  default_weekly_rollup_type?: InputMaybe<enum_metric_rollup_type_enum>;
  experiment_metrics?: InputMaybe<experiment_metric_arr_rel_insert_input>;
  key?: InputMaybe<Scalars['String']['input']>;
  metric_targets?: InputMaybe<metric_target_arr_rel_insert_input>;
  metric_type?: InputMaybe<metric_type_enum>;
  name?: InputMaybe<Scalars['String']['input']>;
  scale_label_high?: InputMaybe<Scalars['String']['input']>;
  scale_label_low?: InputMaybe<Scalars['String']['input']>;
  supplement?: InputMaybe<supplement_obj_rel_insert_input>;
  supplement_id?: InputMaybe<Scalars['uuid']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  user_unit_preferences?: InputMaybe<user_unit_preference_arr_rel_insert_input>;
  watched_metric?: InputMaybe<watched_user_metric_arr_rel_insert_input>;
};

/** order by max() on columns of table "metric" */
export type metric_max_order_by = {
  alt_formatted_unit?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  display_name?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  key?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  namespace?: InputMaybe<order_by>;
  namespace_key?: InputMaybe<order_by>;
  scale_label_high?: InputMaybe<order_by>;
  scale_label_low?: InputMaybe<order_by>;
  supplement_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "metric" */
export type metric_min_order_by = {
  alt_formatted_unit?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  display_name?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  key?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  namespace?: InputMaybe<order_by>;
  namespace_key?: InputMaybe<order_by>;
  scale_label_high?: InputMaybe<order_by>;
  scale_label_low?: InputMaybe<order_by>;
  supplement_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** input type for inserting object relation for remote table "metric" */
export type metric_obj_rel_insert_input = {
  data: metric_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<metric_on_conflict>;
};

/** on_conflict condition type for table "metric" */
export type metric_on_conflict = {
  constraint: metric_constraint;
  update_columns?: Array<metric_update_column>;
  where?: InputMaybe<metric_bool_exp>;
};

/** Ordering options when selecting data from "metric". */
export type metric_order_by = {
  alt_formatted_unit?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  default_rollup_interval_type?: InputMaybe<order_by>;
  default_weekly_rollup_type?: InputMaybe<order_by>;
  display_name?: InputMaybe<order_by>;
  dynamic_record?: InputMaybe<dynamic_metric_order_by>;
  experiment_metrics_aggregate?: InputMaybe<experiment_metric_aggregate_order_by>;
  fresh_duration?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  key?: InputMaybe<order_by>;
  lab_test_markers_aggregate?: InputMaybe<lab_test_marker_aggregate_order_by>;
  measure_type?: InputMaybe<order_by>;
  metricComponentsByMetricId_aggregate?: InputMaybe<metric_component_aggregate_order_by>;
  metric_components_aggregate?: InputMaybe<metric_component_aggregate_order_by>;
  metric_external_codes_aggregate?: InputMaybe<metric_external_codes_aggregate_order_by>;
  metric_record_by_week_aggregate?: InputMaybe<metric_record_by_week_aggregate_order_by>;
  metric_records_aggregate?: InputMaybe<metric_record_aggregate_order_by>;
  metric_snapshot_items_aggregate?: InputMaybe<metric_snapshot_item_aggregate_order_by>;
  metric_targets_aggregate?: InputMaybe<metric_target_aggregate_order_by>;
  metric_type?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  namespace?: InputMaybe<order_by>;
  namespace_key?: InputMaybe<order_by>;
  preference_unit?: InputMaybe<order_by>;
  preference_unit_details_aggregate?: InputMaybe<unit_aggregate_order_by>;
  reference_ranges_aggregate?: InputMaybe<reference_range_aggregate_order_by>;
  scale_label_high?: InputMaybe<order_by>;
  scale_label_low?: InputMaybe<order_by>;
  supplement?: InputMaybe<supplement_order_by>;
  supplement_id?: InputMaybe<order_by>;
  unitDetails?: InputMaybe<unit_order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
  user_unit_preferences_aggregate?: InputMaybe<user_unit_preference_aggregate_order_by>;
  watched_metric_aggregate?: InputMaybe<watched_user_metric_aggregate_order_by>;
};

export type metric_record_aggregate_bool_exp = {
  bool_and?: InputMaybe<metric_record_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<metric_record_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<metric_record_aggregate_bool_exp_count>;
};

export type metric_record_aggregate_bool_exp_bool_and = {
  arguments: metric_record_select_column_metric_record_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<metric_record_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type metric_record_aggregate_bool_exp_bool_or = {
  arguments: metric_record_select_column_metric_record_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<metric_record_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type metric_record_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<metric_record_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<metric_record_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "metric_record" */
export type metric_record_aggregate_order_by = {
  avg?: InputMaybe<metric_record_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<metric_record_max_order_by>;
  min?: InputMaybe<metric_record_min_order_by>;
  stddev?: InputMaybe<metric_record_stddev_order_by>;
  stddev_pop?: InputMaybe<metric_record_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<metric_record_stddev_samp_order_by>;
  sum?: InputMaybe<metric_record_sum_order_by>;
  var_pop?: InputMaybe<metric_record_var_pop_order_by>;
  var_samp?: InputMaybe<metric_record_var_samp_order_by>;
  variance?: InputMaybe<metric_record_variance_order_by>;
};

/** order by avg() on columns of table "metric_record" */
export type metric_record_avg_order_by = {
  preference_value?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "metric_record". All fields are combined with a logical 'AND'. */
export type metric_record_bool_exp = {
  _and?: InputMaybe<Array<metric_record_bool_exp>>;
  _not?: InputMaybe<metric_record_bool_exp>;
  _or?: InputMaybe<Array<metric_record_bool_exp>>;
  child_metric_records?: InputMaybe<metric_record_bool_exp>;
  child_metric_records_aggregate?: InputMaybe<metric_record_aggregate_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  data_source?: InputMaybe<enum_data_source_enum_comparison_exp>;
  datetime_local?: InputMaybe<timestamp_comparison_exp>;
  datetime_utc?: InputMaybe<timestamptz_comparison_exp>;
  duplicates_metric_record_id?: InputMaybe<uuid_comparison_exp>;
  external_id?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  lab_result_marker?: InputMaybe<lab_result_marker_bool_exp>;
  lab_result_markers?: InputMaybe<lab_result_marker_bool_exp>;
  meta?: InputMaybe<jsonb_comparison_exp>;
  metric?: InputMaybe<metric_bool_exp>;
  metric_id?: InputMaybe<uuid_comparison_exp>;
  metric_record_group?: InputMaybe<metric_record_group_bool_exp>;
  metric_record_group_id?: InputMaybe<uuid_comparison_exp>;
  metric_snapshot_items?: InputMaybe<metric_snapshot_item_bool_exp>;
  parent_metric_record?: InputMaybe<metric_record_bool_exp>;
  parent_metric_record_id?: InputMaybe<uuid_comparison_exp>;
  preference_value?: InputMaybe<numeric_comparison_exp>;
  raw_payload?: InputMaybe<jsonb_comparison_exp>;
  reference_range?: InputMaybe<reference_range_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
  user_provided?: InputMaybe<Boolean_comparison_exp>;
  value?: InputMaybe<numeric_comparison_exp>;
  value_array?: InputMaybe<_numeric_comparison_exp>;
  value_range?: InputMaybe<numrange_comparison_exp>;
  value_string?: InputMaybe<String_comparison_exp>;
  value_time_series?: InputMaybe<jsonb_comparison_exp>;
  value_type?: InputMaybe<metric_record_value_type_enum_comparison_exp>;
  variant?: InputMaybe<String_comparison_exp>;
};

export type metric_record_by_week_aggregate_bool_exp = {
  count?: InputMaybe<metric_record_by_week_aggregate_bool_exp_count>;
};

export type metric_record_by_week_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<metric_record_by_week_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<metric_record_by_week_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "metric_record_by_week" */
export type metric_record_by_week_aggregate_order_by = {
  avg?: InputMaybe<metric_record_by_week_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<metric_record_by_week_max_order_by>;
  min?: InputMaybe<metric_record_by_week_min_order_by>;
  stddev?: InputMaybe<metric_record_by_week_stddev_order_by>;
  stddev_pop?: InputMaybe<metric_record_by_week_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<metric_record_by_week_stddev_samp_order_by>;
  sum?: InputMaybe<metric_record_by_week_sum_order_by>;
  var_pop?: InputMaybe<metric_record_by_week_var_pop_order_by>;
  var_samp?: InputMaybe<metric_record_by_week_var_samp_order_by>;
  variance?: InputMaybe<metric_record_by_week_variance_order_by>;
};

/** order by avg() on columns of table "metric_record_by_week" */
export type metric_record_by_week_avg_order_by = {
  daily_avg_avg?: InputMaybe<order_by>;
  daily_max_avg?: InputMaybe<order_by>;
  daily_min_avg?: InputMaybe<order_by>;
  sum_avg_per_day?: InputMaybe<order_by>;
  weekly_sum?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "metric_record_by_week". All fields are combined with a logical 'AND'. */
export type metric_record_by_week_bool_exp = {
  _and?: InputMaybe<Array<metric_record_by_week_bool_exp>>;
  _not?: InputMaybe<metric_record_by_week_bool_exp>;
  _or?: InputMaybe<Array<metric_record_by_week_bool_exp>>;
  daily_avg_avg?: InputMaybe<numeric_comparison_exp>;
  daily_max_avg?: InputMaybe<numeric_comparison_exp>;
  daily_min_avg?: InputMaybe<numeric_comparison_exp>;
  metric?: InputMaybe<metric_bool_exp>;
  metric_id?: InputMaybe<uuid_comparison_exp>;
  sum_avg_per_day?: InputMaybe<numeric_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
  week?: InputMaybe<date_comparison_exp>;
  weekly_sum?: InputMaybe<numeric_comparison_exp>;
};

/** order by max() on columns of table "metric_record_by_week" */
export type metric_record_by_week_max_order_by = {
  daily_avg_avg?: InputMaybe<order_by>;
  daily_max_avg?: InputMaybe<order_by>;
  daily_min_avg?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  sum_avg_per_day?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
  week?: InputMaybe<order_by>;
  weekly_sum?: InputMaybe<order_by>;
};

/** order by min() on columns of table "metric_record_by_week" */
export type metric_record_by_week_min_order_by = {
  daily_avg_avg?: InputMaybe<order_by>;
  daily_max_avg?: InputMaybe<order_by>;
  daily_min_avg?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  sum_avg_per_day?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
  week?: InputMaybe<order_by>;
  weekly_sum?: InputMaybe<order_by>;
};

/** select columns of table "metric_record_by_week" */
export enum metric_record_by_week_select_column {
  /** column name */
  daily_avg_avg = 'daily_avg_avg',
  /** column name */
  daily_max_avg = 'daily_max_avg',
  /** column name */
  daily_min_avg = 'daily_min_avg',
  /** column name */
  metric_id = 'metric_id',
  /** column name */
  sum_avg_per_day = 'sum_avg_per_day',
  /** column name */
  user_id = 'user_id',
  /** column name */
  week = 'week',
  /** column name */
  weekly_sum = 'weekly_sum'
}

/** order by stddev() on columns of table "metric_record_by_week" */
export type metric_record_by_week_stddev_order_by = {
  daily_avg_avg?: InputMaybe<order_by>;
  daily_max_avg?: InputMaybe<order_by>;
  daily_min_avg?: InputMaybe<order_by>;
  sum_avg_per_day?: InputMaybe<order_by>;
  weekly_sum?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "metric_record_by_week" */
export type metric_record_by_week_stddev_pop_order_by = {
  daily_avg_avg?: InputMaybe<order_by>;
  daily_max_avg?: InputMaybe<order_by>;
  daily_min_avg?: InputMaybe<order_by>;
  sum_avg_per_day?: InputMaybe<order_by>;
  weekly_sum?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "metric_record_by_week" */
export type metric_record_by_week_stddev_samp_order_by = {
  daily_avg_avg?: InputMaybe<order_by>;
  daily_max_avg?: InputMaybe<order_by>;
  daily_min_avg?: InputMaybe<order_by>;
  sum_avg_per_day?: InputMaybe<order_by>;
  weekly_sum?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "metric_record_by_week" */
export type metric_record_by_week_sum_order_by = {
  daily_avg_avg?: InputMaybe<order_by>;
  daily_max_avg?: InputMaybe<order_by>;
  daily_min_avg?: InputMaybe<order_by>;
  sum_avg_per_day?: InputMaybe<order_by>;
  weekly_sum?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "metric_record_by_week" */
export type metric_record_by_week_var_pop_order_by = {
  daily_avg_avg?: InputMaybe<order_by>;
  daily_max_avg?: InputMaybe<order_by>;
  daily_min_avg?: InputMaybe<order_by>;
  sum_avg_per_day?: InputMaybe<order_by>;
  weekly_sum?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "metric_record_by_week" */
export type metric_record_by_week_var_samp_order_by = {
  daily_avg_avg?: InputMaybe<order_by>;
  daily_max_avg?: InputMaybe<order_by>;
  daily_min_avg?: InputMaybe<order_by>;
  sum_avg_per_day?: InputMaybe<order_by>;
  weekly_sum?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "metric_record_by_week" */
export type metric_record_by_week_variance_order_by = {
  daily_avg_avg?: InputMaybe<order_by>;
  daily_max_avg?: InputMaybe<order_by>;
  daily_min_avg?: InputMaybe<order_by>;
  sum_avg_per_day?: InputMaybe<order_by>;
  weekly_sum?: InputMaybe<order_by>;
};

export type metric_record_group_aggregate_bool_exp = {
  bool_and?: InputMaybe<metric_record_group_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<metric_record_group_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<metric_record_group_aggregate_bool_exp_count>;
};

export type metric_record_group_aggregate_bool_exp_bool_and = {
  arguments: metric_record_group_select_column_metric_record_group_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<metric_record_group_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type metric_record_group_aggregate_bool_exp_bool_or = {
  arguments: metric_record_group_select_column_metric_record_group_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<metric_record_group_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type metric_record_group_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<metric_record_group_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<metric_record_group_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "metric_record_group" */
export type metric_record_group_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<metric_record_group_max_order_by>;
  min?: InputMaybe<metric_record_group_min_order_by>;
};

/** Boolean expression to filter rows from the table "metric_record_group". All fields are combined with a logical 'AND'. */
export type metric_record_group_bool_exp = {
  _and?: InputMaybe<Array<metric_record_group_bool_exp>>;
  _not?: InputMaybe<metric_record_group_bool_exp>;
  _or?: InputMaybe<Array<metric_record_group_bool_exp>>;
  children?: InputMaybe<metric_record_group_bool_exp>;
  children_aggregate?: InputMaybe<metric_record_group_aggregate_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  data_source?: InputMaybe<enum_data_source_enum_comparison_exp>;
  datetime_utc?: InputMaybe<timestamptz_comparison_exp>;
  external_id?: InputMaybe<String_comparison_exp>;
  group_type?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  lab_results?: InputMaybe<lab_result_bool_exp>;
  local_date?: InputMaybe<date_comparison_exp>;
  metric_records?: InputMaybe<metric_record_bool_exp>;
  metric_records_aggregate?: InputMaybe<metric_record_aggregate_bool_exp>;
  name?: InputMaybe<String_comparison_exp>;
  parent?: InputMaybe<metric_record_group_bool_exp>;
  parent_metric_record_group_id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
  user_provided?: InputMaybe<Boolean_comparison_exp>;
  variant?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "metric_record_group" */
export type metric_record_group_max_order_by = {
  created_at?: InputMaybe<order_by>;
  datetime_utc?: InputMaybe<order_by>;
  external_id?: InputMaybe<order_by>;
  group_type?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  local_date?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  parent_metric_record_group_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
  variant?: InputMaybe<order_by>;
};

/** order by min() on columns of table "metric_record_group" */
export type metric_record_group_min_order_by = {
  created_at?: InputMaybe<order_by>;
  datetime_utc?: InputMaybe<order_by>;
  external_id?: InputMaybe<order_by>;
  group_type?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  local_date?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  parent_metric_record_group_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
  variant?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "metric_record_group". */
export type metric_record_group_order_by = {
  children_aggregate?: InputMaybe<metric_record_group_aggregate_order_by>;
  created_at?: InputMaybe<order_by>;
  data_source?: InputMaybe<order_by>;
  datetime_utc?: InputMaybe<order_by>;
  external_id?: InputMaybe<order_by>;
  group_type?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  lab_results_aggregate?: InputMaybe<lab_result_aggregate_order_by>;
  local_date?: InputMaybe<order_by>;
  metric_records_aggregate?: InputMaybe<metric_record_aggregate_order_by>;
  name?: InputMaybe<order_by>;
  parent?: InputMaybe<metric_record_group_order_by>;
  parent_metric_record_group_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user?: InputMaybe<user_order_by>;
  user_id?: InputMaybe<order_by>;
  user_provided?: InputMaybe<order_by>;
  variant?: InputMaybe<order_by>;
};

/** select columns of table "metric_record_group" */
export enum metric_record_group_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  data_source = 'data_source',
  /** column name */
  datetime_utc = 'datetime_utc',
  /** column name */
  external_id = 'external_id',
  /** column name */
  group_type = 'group_type',
  /** column name */
  id = 'id',
  /** column name */
  local_date = 'local_date',
  /** column name */
  name = 'name',
  /** column name */
  parent_metric_record_group_id = 'parent_metric_record_group_id',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  user_id = 'user_id',
  /** column name */
  user_provided = 'user_provided',
  /** column name */
  variant = 'variant'
}

/** select "metric_record_group_aggregate_bool_exp_bool_and_arguments_columns" columns of table "metric_record_group" */
export enum metric_record_group_select_column_metric_record_group_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  user_provided = 'user_provided'
}

/** select "metric_record_group_aggregate_bool_exp_bool_or_arguments_columns" columns of table "metric_record_group" */
export enum metric_record_group_select_column_metric_record_group_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  user_provided = 'user_provided'
}

/** order by max() on columns of table "metric_record" */
export type metric_record_max_order_by = {
  created_at?: InputMaybe<order_by>;
  datetime_local?: InputMaybe<order_by>;
  datetime_utc?: InputMaybe<order_by>;
  duplicates_metric_record_id?: InputMaybe<order_by>;
  external_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  metric_record_group_id?: InputMaybe<order_by>;
  parent_metric_record_id?: InputMaybe<order_by>;
  preference_value?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
  value_array?: InputMaybe<order_by>;
  value_string?: InputMaybe<order_by>;
  variant?: InputMaybe<order_by>;
};

/** order by min() on columns of table "metric_record" */
export type metric_record_min_order_by = {
  created_at?: InputMaybe<order_by>;
  datetime_local?: InputMaybe<order_by>;
  datetime_utc?: InputMaybe<order_by>;
  duplicates_metric_record_id?: InputMaybe<order_by>;
  external_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  metric_record_group_id?: InputMaybe<order_by>;
  parent_metric_record_id?: InputMaybe<order_by>;
  preference_value?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
  value_array?: InputMaybe<order_by>;
  value_string?: InputMaybe<order_by>;
  variant?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "metric_record". */
export type metric_record_order_by = {
  child_metric_records_aggregate?: InputMaybe<metric_record_aggregate_order_by>;
  created_at?: InputMaybe<order_by>;
  data_source?: InputMaybe<order_by>;
  datetime_local?: InputMaybe<order_by>;
  datetime_utc?: InputMaybe<order_by>;
  duplicates_metric_record_id?: InputMaybe<order_by>;
  external_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  lab_result_marker?: InputMaybe<lab_result_marker_order_by>;
  lab_result_markers_aggregate?: InputMaybe<lab_result_marker_aggregate_order_by>;
  meta?: InputMaybe<order_by>;
  metric?: InputMaybe<metric_order_by>;
  metric_id?: InputMaybe<order_by>;
  metric_record_group?: InputMaybe<metric_record_group_order_by>;
  metric_record_group_id?: InputMaybe<order_by>;
  metric_snapshot_items_aggregate?: InputMaybe<metric_snapshot_item_aggregate_order_by>;
  parent_metric_record?: InputMaybe<metric_record_order_by>;
  parent_metric_record_id?: InputMaybe<order_by>;
  preference_value?: InputMaybe<order_by>;
  raw_payload?: InputMaybe<order_by>;
  reference_range?: InputMaybe<reference_range_order_by>;
  updated_at?: InputMaybe<order_by>;
  user?: InputMaybe<user_order_by>;
  user_id?: InputMaybe<order_by>;
  user_provided?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
  value_array?: InputMaybe<order_by>;
  value_range?: InputMaybe<order_by>;
  value_string?: InputMaybe<order_by>;
  value_time_series?: InputMaybe<order_by>;
  value_type?: InputMaybe<order_by>;
  variant?: InputMaybe<order_by>;
};

/** select columns of table "metric_record" */
export enum metric_record_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  data_source = 'data_source',
  /** column name */
  datetime_local = 'datetime_local',
  /** column name */
  datetime_utc = 'datetime_utc',
  /** column name */
  duplicates_metric_record_id = 'duplicates_metric_record_id',
  /** column name */
  external_id = 'external_id',
  /** column name */
  id = 'id',
  /** column name */
  meta = 'meta',
  /** column name */
  metric_id = 'metric_id',
  /** column name */
  metric_record_group_id = 'metric_record_group_id',
  /** column name */
  parent_metric_record_id = 'parent_metric_record_id',
  /** column name */
  preference_value = 'preference_value',
  /** column name */
  raw_payload = 'raw_payload',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  user_id = 'user_id',
  /** column name */
  user_provided = 'user_provided',
  /** column name */
  value = 'value',
  /** column name */
  value_array = 'value_array',
  /** column name */
  value_range = 'value_range',
  /** column name */
  value_string = 'value_string',
  /** column name */
  value_time_series = 'value_time_series',
  /** column name */
  value_type = 'value_type',
  /** column name */
  variant = 'variant'
}

/** select "metric_record_aggregate_bool_exp_bool_and_arguments_columns" columns of table "metric_record" */
export enum metric_record_select_column_metric_record_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  user_provided = 'user_provided'
}

/** select "metric_record_aggregate_bool_exp_bool_or_arguments_columns" columns of table "metric_record" */
export enum metric_record_select_column_metric_record_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  user_provided = 'user_provided'
}

/** order by stddev() on columns of table "metric_record" */
export type metric_record_stddev_order_by = {
  preference_value?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "metric_record" */
export type metric_record_stddev_pop_order_by = {
  preference_value?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "metric_record" */
export type metric_record_stddev_samp_order_by = {
  preference_value?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "metric_record" */
export type metric_record_sum_order_by = {
  preference_value?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

export enum metric_record_value_type_enum {
  time_series = 'time_series',
  value = 'value',
  value_array = 'value_array',
  value_range = 'value_range',
  value_string = 'value_string'
}

/** Boolean expression to compare columns of type "metric_record_value_type_enum". All fields are combined with logical 'AND'. */
export type metric_record_value_type_enum_comparison_exp = {
  _eq?: InputMaybe<metric_record_value_type_enum>;
  _in?: InputMaybe<Array<metric_record_value_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<metric_record_value_type_enum>;
  _nin?: InputMaybe<Array<metric_record_value_type_enum>>;
};

/** order by var_pop() on columns of table "metric_record" */
export type metric_record_var_pop_order_by = {
  preference_value?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "metric_record" */
export type metric_record_var_samp_order_by = {
  preference_value?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "metric_record" */
export type metric_record_variance_order_by = {
  preference_value?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** input type for updating data in table "metric" */
export type metric_set_input = {
  alt_formatted_name?: InputMaybe<Scalars['String']['input']>;
  alt_formatted_unit?: InputMaybe<Scalars['String']['input']>;
  default_weekly_rollup_type?: InputMaybe<enum_metric_rollup_type_enum>;
  metric_type?: InputMaybe<metric_type_enum>;
  name?: InputMaybe<Scalars['String']['input']>;
  scale_label_high?: InputMaybe<Scalars['String']['input']>;
  scale_label_low?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "metric_snapshot" */
export type metric_snapshot_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<metric_snapshot_max_order_by>;
  min?: InputMaybe<metric_snapshot_min_order_by>;
};

/** Boolean expression to filter rows from the table "metric_snapshot". All fields are combined with a logical 'AND'. */
export type metric_snapshot_bool_exp = {
  _and?: InputMaybe<Array<metric_snapshot_bool_exp>>;
  _not?: InputMaybe<metric_snapshot_bool_exp>;
  _or?: InputMaybe<Array<metric_snapshot_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  date?: InputMaybe<date_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  items?: InputMaybe<metric_snapshot_item_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by aggregate values of table "metric_snapshot_item" */
export type metric_snapshot_item_aggregate_order_by = {
  avg?: InputMaybe<metric_snapshot_item_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<metric_snapshot_item_max_order_by>;
  min?: InputMaybe<metric_snapshot_item_min_order_by>;
  stddev?: InputMaybe<metric_snapshot_item_stddev_order_by>;
  stddev_pop?: InputMaybe<metric_snapshot_item_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<metric_snapshot_item_stddev_samp_order_by>;
  sum?: InputMaybe<metric_snapshot_item_sum_order_by>;
  var_pop?: InputMaybe<metric_snapshot_item_var_pop_order_by>;
  var_samp?: InputMaybe<metric_snapshot_item_var_samp_order_by>;
  variance?: InputMaybe<metric_snapshot_item_variance_order_by>;
};

/** order by avg() on columns of table "metric_snapshot_item" */
export type metric_snapshot_item_avg_order_by = {
  priority?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "metric_snapshot_item". All fields are combined with a logical 'AND'. */
export type metric_snapshot_item_bool_exp = {
  _and?: InputMaybe<Array<metric_snapshot_item_bool_exp>>;
  _not?: InputMaybe<metric_snapshot_item_bool_exp>;
  _or?: InputMaybe<Array<metric_snapshot_item_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  metric?: InputMaybe<metric_bool_exp>;
  metric_id?: InputMaybe<uuid_comparison_exp>;
  metric_record?: InputMaybe<metric_record_bool_exp>;
  metric_record_id?: InputMaybe<uuid_comparison_exp>;
  metric_snapshot?: InputMaybe<metric_snapshot_bool_exp>;
  metric_snapshot_id?: InputMaybe<uuid_comparison_exp>;
  position?: InputMaybe<enum_metric_snapshot_item_position_enum_comparison_exp>;
  priority?: InputMaybe<numeric_comparison_exp>;
  reference_range_target?: InputMaybe<reference_range_target_bool_exp>;
  reference_range_target_id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by max() on columns of table "metric_snapshot_item" */
export type metric_snapshot_item_max_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  metric_record_id?: InputMaybe<order_by>;
  metric_snapshot_id?: InputMaybe<order_by>;
  priority?: InputMaybe<order_by>;
  reference_range_target_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "metric_snapshot_item" */
export type metric_snapshot_item_min_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  metric_record_id?: InputMaybe<order_by>;
  metric_snapshot_id?: InputMaybe<order_by>;
  priority?: InputMaybe<order_by>;
  reference_range_target_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by stddev() on columns of table "metric_snapshot_item" */
export type metric_snapshot_item_stddev_order_by = {
  priority?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "metric_snapshot_item" */
export type metric_snapshot_item_stddev_pop_order_by = {
  priority?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "metric_snapshot_item" */
export type metric_snapshot_item_stddev_samp_order_by = {
  priority?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "metric_snapshot_item" */
export type metric_snapshot_item_sum_order_by = {
  priority?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "metric_snapshot_item" */
export type metric_snapshot_item_var_pop_order_by = {
  priority?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "metric_snapshot_item" */
export type metric_snapshot_item_var_samp_order_by = {
  priority?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "metric_snapshot_item" */
export type metric_snapshot_item_variance_order_by = {
  priority?: InputMaybe<order_by>;
};

/** order by max() on columns of table "metric_snapshot" */
export type metric_snapshot_max_order_by = {
  created_at?: InputMaybe<order_by>;
  date?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "metric_snapshot" */
export type metric_snapshot_min_order_by = {
  created_at?: InputMaybe<order_by>;
  date?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by aggregate values of table "metric_target" */
export type metric_target_aggregate_order_by = {
  avg?: InputMaybe<metric_target_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<metric_target_max_order_by>;
  min?: InputMaybe<metric_target_min_order_by>;
  stddev?: InputMaybe<metric_target_stddev_order_by>;
  stddev_pop?: InputMaybe<metric_target_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<metric_target_stddev_samp_order_by>;
  sum?: InputMaybe<metric_target_sum_order_by>;
  var_pop?: InputMaybe<metric_target_var_pop_order_by>;
  var_samp?: InputMaybe<metric_target_var_samp_order_by>;
  variance?: InputMaybe<metric_target_variance_order_by>;
};

/** input type for inserting array relation for remote table "metric_target" */
export type metric_target_arr_rel_insert_input = {
  data: Array<metric_target_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<metric_target_on_conflict>;
};

/** order by avg() on columns of table "metric_target" */
export type metric_target_avg_order_by = {
  interval_count?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "metric_target". All fields are combined with a logical 'AND'. */
export type metric_target_bool_exp = {
  _and?: InputMaybe<Array<metric_target_bool_exp>>;
  _not?: InputMaybe<metric_target_bool_exp>;
  _or?: InputMaybe<Array<metric_target_bool_exp>>;
  action_item_user?: InputMaybe<action_item_user_bool_exp>;
  aggregate_type?: InputMaybe<enum_metric_rollup_type_enum_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  data_sources?: InputMaybe<_text_comparison_exp>;
  end?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  interval_count?: InputMaybe<Int_comparison_exp>;
  interval_type?: InputMaybe<enum_rollup_interval_type_enum_comparison_exp>;
  metric?: InputMaybe<metric_bool_exp>;
  metric_id?: InputMaybe<uuid_comparison_exp>;
  period?: InputMaybe<String_comparison_exp>;
  preference_target?: InputMaybe<String_comparison_exp>;
  start?: InputMaybe<timestamptz_comparison_exp>;
  target?: InputMaybe<numrange_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "metric_target" */
export enum metric_target_constraint {
  /** unique or primary key constraint on columns "id" */
  metric_target_pkey = 'metric_target_pkey',
  /** unique or primary key constraint on columns "metric_id", "user_id" */
  metric_target_single_current = 'metric_target_single_current'
}

/** input type for inserting data into table "metric_target" */
export type metric_target_insert_input = {
  aggregate_type?: InputMaybe<enum_metric_rollup_type_enum>;
  data_sources?: InputMaybe<Scalars['_text']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  interval_count?: InputMaybe<Scalars['Int']['input']>;
  interval_type?: InputMaybe<enum_rollup_interval_type_enum>;
  metric?: InputMaybe<metric_obj_rel_insert_input>;
  metric_id?: InputMaybe<Scalars['uuid']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
  target?: InputMaybe<Scalars['numrange']['input']>;
};

/** order by max() on columns of table "metric_target" */
export type metric_target_max_order_by = {
  created_at?: InputMaybe<order_by>;
  data_sources?: InputMaybe<order_by>;
  end?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  interval_count?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  period?: InputMaybe<order_by>;
  start?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "metric_target" */
export type metric_target_min_order_by = {
  created_at?: InputMaybe<order_by>;
  data_sources?: InputMaybe<order_by>;
  end?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  interval_count?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  period?: InputMaybe<order_by>;
  start?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "metric_target" */
export type metric_target_on_conflict = {
  constraint: metric_target_constraint;
  update_columns?: Array<metric_target_update_column>;
  where?: InputMaybe<metric_target_bool_exp>;
};

/** order by stddev() on columns of table "metric_target" */
export type metric_target_stddev_order_by = {
  interval_count?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "metric_target" */
export type metric_target_stddev_pop_order_by = {
  interval_count?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "metric_target" */
export type metric_target_stddev_samp_order_by = {
  interval_count?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "metric_target" */
export type metric_target_sum_order_by = {
  interval_count?: InputMaybe<order_by>;
};

/** update columns of table "metric_target" */
export enum metric_target_update_column {
  /** column name */
  aggregate_type = 'aggregate_type',
  /** column name */
  data_sources = 'data_sources',
  /** column name */
  end = 'end',
  /** column name */
  interval_count = 'interval_count',
  /** column name */
  interval_type = 'interval_type',
  /** column name */
  start = 'start',
  /** column name */
  target = 'target'
}

/** order by var_pop() on columns of table "metric_target" */
export type metric_target_var_pop_order_by = {
  interval_count?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "metric_target" */
export type metric_target_var_samp_order_by = {
  interval_count?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "metric_target" */
export type metric_target_variance_order_by = {
  interval_count?: InputMaybe<order_by>;
};

export enum metric_type_enum {
  activity = 'activity',
  body_measurement = 'body_measurement',
  bridge = 'bridge',
  derived = 'derived',
  garmin = 'garmin',
  lab_result = 'lab_result',
  nordic = 'nordic',
  nutrient = 'nutrient',
  oura = 'oura',
  qualitative = 'qualitative',
  sleep = 'sleep',
  supplement = 'supplement',
  unknown = 'unknown',
  withings = 'withings',
  workout = 'workout'
}

/** Boolean expression to compare columns of type "metric_type_enum". All fields are combined with logical 'AND'. */
export type metric_type_enum_comparison_exp = {
  _eq?: InputMaybe<metric_type_enum>;
  _in?: InputMaybe<Array<metric_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<metric_type_enum>;
  _nin?: InputMaybe<Array<metric_type_enum>>;
};

/** update columns of table "metric" */
export enum metric_update_column {
  /** column name */
  alt_formatted_name = 'alt_formatted_name',
  /** column name */
  alt_formatted_unit = 'alt_formatted_unit',
  /** column name */
  default_weekly_rollup_type = 'default_weekly_rollup_type',
  /** column name */
  metric_type = 'metric_type',
  /** column name */
  name = 'name',
  /** column name */
  scale_label_high = 'scale_label_high',
  /** column name */
  scale_label_low = 'scale_label_low',
  /** column name */
  unit = 'unit'
}

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type numeric_comparison_exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** Boolean expression to compare columns of type "numrange". All fields are combined with logical 'AND'. */
export type numrange_comparison_exp = {
  _eq?: InputMaybe<Scalars['numrange']['input']>;
  _gt?: InputMaybe<Scalars['numrange']['input']>;
  _gte?: InputMaybe<Scalars['numrange']['input']>;
  _in?: InputMaybe<Array<Scalars['numrange']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numrange']['input']>;
  _lte?: InputMaybe<Scalars['numrange']['input']>;
  _neq?: InputMaybe<Scalars['numrange']['input']>;
  _nin?: InputMaybe<Array<Scalars['numrange']['input']>>;
};

/** Boolean expression to filter rows from the table "oauth2_provider". All fields are combined with a logical 'AND'. */
export type oauth2_provider_bool_exp = {
  _and?: InputMaybe<Array<oauth2_provider_bool_exp>>;
  _not?: InputMaybe<oauth2_provider_bool_exp>;
  _or?: InputMaybe<Array<oauth2_provider_bool_exp>>;
  name?: InputMaybe<String_comparison_exp>;
  oauth2_tokens?: InputMaybe<oauth2_token_bool_exp>;
};

/** order by aggregate values of table "oauth2_token" */
export type oauth2_token_aggregate_order_by = {
  avg?: InputMaybe<oauth2_token_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<oauth2_token_max_order_by>;
  min?: InputMaybe<oauth2_token_min_order_by>;
  stddev?: InputMaybe<oauth2_token_stddev_order_by>;
  stddev_pop?: InputMaybe<oauth2_token_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<oauth2_token_stddev_samp_order_by>;
  sum?: InputMaybe<oauth2_token_sum_order_by>;
  var_pop?: InputMaybe<oauth2_token_var_pop_order_by>;
  var_samp?: InputMaybe<oauth2_token_var_samp_order_by>;
  variance?: InputMaybe<oauth2_token_variance_order_by>;
};

/** order by avg() on columns of table "oauth2_token" */
export type oauth2_token_avg_order_by = {
  refresh_failure_count?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "oauth2_token". All fields are combined with a logical 'AND'. */
export type oauth2_token_bool_exp = {
  _and?: InputMaybe<Array<oauth2_token_bool_exp>>;
  _not?: InputMaybe<oauth2_token_bool_exp>;
  _or?: InputMaybe<Array<oauth2_token_bool_exp>>;
  expires_at?: InputMaybe<timestamp_comparison_exp>;
  external_user_id?: InputMaybe<String_comparison_exp>;
  oauth2_provider?: InputMaybe<oauth2_provider_bool_exp>;
  provider?: InputMaybe<String_comparison_exp>;
  reconnect_needed?: InputMaybe<Boolean_comparison_exp>;
  refresh_failure_count?: InputMaybe<Int_comparison_exp>;
  refresh_failure_detail?: InputMaybe<jsonb_comparison_exp>;
  scopes?: InputMaybe<_text_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
};

/** order by max() on columns of table "oauth2_token" */
export type oauth2_token_max_order_by = {
  expires_at?: InputMaybe<order_by>;
  external_user_id?: InputMaybe<order_by>;
  provider?: InputMaybe<order_by>;
  refresh_failure_count?: InputMaybe<order_by>;
  scopes?: InputMaybe<order_by>;
};

/** order by min() on columns of table "oauth2_token" */
export type oauth2_token_min_order_by = {
  expires_at?: InputMaybe<order_by>;
  external_user_id?: InputMaybe<order_by>;
  provider?: InputMaybe<order_by>;
  refresh_failure_count?: InputMaybe<order_by>;
  scopes?: InputMaybe<order_by>;
};

/** order by stddev() on columns of table "oauth2_token" */
export type oauth2_token_stddev_order_by = {
  refresh_failure_count?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "oauth2_token" */
export type oauth2_token_stddev_pop_order_by = {
  refresh_failure_count?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "oauth2_token" */
export type oauth2_token_stddev_samp_order_by = {
  refresh_failure_count?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "oauth2_token" */
export type oauth2_token_sum_order_by = {
  refresh_failure_count?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "oauth2_token" */
export type oauth2_token_var_pop_order_by = {
  refresh_failure_count?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "oauth2_token" */
export type oauth2_token_var_samp_order_by = {
  refresh_failure_count?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "oauth2_token" */
export type oauth2_token_variance_order_by = {
  refresh_failure_count?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "openai_completion". All fields are combined with a logical 'AND'. */
export type openai_completion_bool_exp = {
  _and?: InputMaybe<Array<openai_completion_bool_exp>>;
  _not?: InputMaybe<openai_completion_bool_exp>;
  _or?: InputMaybe<Array<openai_completion_bool_exp>>;
  completion?: InputMaybe<jsonb_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  messages?: InputMaybe<jsonb_comparison_exp>;
  params?: InputMaybe<jsonb_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** column ordering options */
export enum order_by {
  /** in ascending order, nulls last */
  asc = 'asc',
  /** in ascending order, nulls first */
  asc_nulls_first = 'asc_nulls_first',
  /** in ascending order, nulls last */
  asc_nulls_last = 'asc_nulls_last',
  /** in descending order, nulls first */
  desc = 'desc',
  /** in descending order, nulls first */
  desc_nulls_first = 'desc_nulls_first',
  /** in descending order, nulls last */
  desc_nulls_last = 'desc_nulls_last'
}

export enum purchase_requirement_status {
  met = 'met',
  pending = 'pending',
  unmet = 'unmet'
}

export enum purchase_requirement_type_enum {
  consent = 'consent',
  patient_details = 'patient_details',
  prescriber_approval = 'prescriber_approval',
  product = 'product',
  product_type = 'product_type',
  realize_account = 'realize_account',
  realize_membership = 'realize_membership',
  shipping_address = 'shipping_address'
}

/** order by aggregate values of table "reference_range" */
export type reference_range_aggregate_order_by = {
  avg?: InputMaybe<reference_range_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<reference_range_max_order_by>;
  min?: InputMaybe<reference_range_min_order_by>;
  stddev?: InputMaybe<reference_range_stddev_order_by>;
  stddev_pop?: InputMaybe<reference_range_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<reference_range_stddev_samp_order_by>;
  sum?: InputMaybe<reference_range_sum_order_by>;
  var_pop?: InputMaybe<reference_range_var_pop_order_by>;
  var_samp?: InputMaybe<reference_range_var_samp_order_by>;
  variance?: InputMaybe<reference_range_variance_order_by>;
};

/** order by avg() on columns of table "reference_range" */
export type reference_range_avg_order_by = {
  bmi?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "reference_range". All fields are combined with a logical 'AND'. */
export type reference_range_bool_exp = {
  _and?: InputMaybe<Array<reference_range_bool_exp>>;
  _not?: InputMaybe<reference_range_bool_exp>;
  _or?: InputMaybe<Array<reference_range_bool_exp>>;
  age?: InputMaybe<int4range_comparison_exp>;
  bmi?: InputMaybe<numeric_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  data_source?: InputMaybe<enum_data_source_enum_comparison_exp>;
  display_name?: InputMaybe<String_comparison_exp>;
  ethnicity?: InputMaybe<String_comparison_exp>;
  external_id?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  label?: InputMaybe<String_comparison_exp>;
  menstrual_phase?: InputMaybe<String_comparison_exp>;
  metric?: InputMaybe<metric_bool_exp>;
  metric_id?: InputMaybe<uuid_comparison_exp>;
  metric_record?: InputMaybe<metric_record_bool_exp>;
  metric_record_id?: InputMaybe<uuid_comparison_exp>;
  range_type?: InputMaybe<String_comparison_exp>;
  sex?: InputMaybe<sex_comparison_exp>;
  targets?: InputMaybe<reference_range_target_bool_exp>;
  time_of_day?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by max() on columns of table "reference_range" */
export type reference_range_max_order_by = {
  bmi?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  display_name?: InputMaybe<order_by>;
  ethnicity?: InputMaybe<order_by>;
  external_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  label?: InputMaybe<order_by>;
  menstrual_phase?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  metric_record_id?: InputMaybe<order_by>;
  range_type?: InputMaybe<order_by>;
  sex?: InputMaybe<order_by>;
  time_of_day?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "reference_range" */
export type reference_range_min_order_by = {
  bmi?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  display_name?: InputMaybe<order_by>;
  ethnicity?: InputMaybe<order_by>;
  external_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  label?: InputMaybe<order_by>;
  menstrual_phase?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  metric_record_id?: InputMaybe<order_by>;
  range_type?: InputMaybe<order_by>;
  sex?: InputMaybe<order_by>;
  time_of_day?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "reference_range". */
export type reference_range_order_by = {
  age?: InputMaybe<order_by>;
  bmi?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  data_source?: InputMaybe<order_by>;
  display_name?: InputMaybe<order_by>;
  ethnicity?: InputMaybe<order_by>;
  external_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  label?: InputMaybe<order_by>;
  menstrual_phase?: InputMaybe<order_by>;
  metric?: InputMaybe<metric_order_by>;
  metric_id?: InputMaybe<order_by>;
  metric_record?: InputMaybe<metric_record_order_by>;
  metric_record_id?: InputMaybe<order_by>;
  range_type?: InputMaybe<order_by>;
  sex?: InputMaybe<order_by>;
  targets_aggregate?: InputMaybe<reference_range_target_aggregate_order_by>;
  time_of_day?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by stddev() on columns of table "reference_range" */
export type reference_range_stddev_order_by = {
  bmi?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "reference_range" */
export type reference_range_stddev_pop_order_by = {
  bmi?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "reference_range" */
export type reference_range_stddev_samp_order_by = {
  bmi?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "reference_range" */
export type reference_range_sum_order_by = {
  bmi?: InputMaybe<order_by>;
};

/** order by aggregate values of table "reference_range_target" */
export type reference_range_target_aggregate_order_by = {
  avg?: InputMaybe<reference_range_target_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<reference_range_target_max_order_by>;
  min?: InputMaybe<reference_range_target_min_order_by>;
  stddev?: InputMaybe<reference_range_target_stddev_order_by>;
  stddev_pop?: InputMaybe<reference_range_target_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<reference_range_target_stddev_samp_order_by>;
  sum?: InputMaybe<reference_range_target_sum_order_by>;
  var_pop?: InputMaybe<reference_range_target_var_pop_order_by>;
  var_samp?: InputMaybe<reference_range_target_var_samp_order_by>;
  variance?: InputMaybe<reference_range_target_variance_order_by>;
};

/** order by avg() on columns of table "reference_range_target" */
export type reference_range_target_avg_order_by = {
  rank?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "reference_range_target". All fields are combined with a logical 'AND'. */
export type reference_range_target_bool_exp = {
  _and?: InputMaybe<Array<reference_range_target_bool_exp>>;
  _not?: InputMaybe<reference_range_target_bool_exp>;
  _or?: InputMaybe<Array<reference_range_target_bool_exp>>;
  color?: InputMaybe<String_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  discrete_targets?: InputMaybe<_text_comparison_exp>;
  health_effects_text?: InputMaybe<String_comparison_exp>;
  health_effects_title?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  label?: InputMaybe<String_comparison_exp>;
  optimal?: InputMaybe<Boolean_comparison_exp>;
  rank?: InputMaybe<Int_comparison_exp>;
  reference_range?: InputMaybe<reference_range_bool_exp>;
  reference_range_id?: InputMaybe<uuid_comparison_exp>;
  suggestions?: InputMaybe<String_comparison_exp>;
  target?: InputMaybe<numrange_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by max() on columns of table "reference_range_target" */
export type reference_range_target_max_order_by = {
  color?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  discrete_targets?: InputMaybe<order_by>;
  health_effects_text?: InputMaybe<order_by>;
  health_effects_title?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  label?: InputMaybe<order_by>;
  rank?: InputMaybe<order_by>;
  reference_range_id?: InputMaybe<order_by>;
  suggestions?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "reference_range_target" */
export type reference_range_target_min_order_by = {
  color?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  discrete_targets?: InputMaybe<order_by>;
  health_effects_text?: InputMaybe<order_by>;
  health_effects_title?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  label?: InputMaybe<order_by>;
  rank?: InputMaybe<order_by>;
  reference_range_id?: InputMaybe<order_by>;
  suggestions?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by stddev() on columns of table "reference_range_target" */
export type reference_range_target_stddev_order_by = {
  rank?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "reference_range_target" */
export type reference_range_target_stddev_pop_order_by = {
  rank?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "reference_range_target" */
export type reference_range_target_stddev_samp_order_by = {
  rank?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "reference_range_target" */
export type reference_range_target_sum_order_by = {
  rank?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "reference_range_target" */
export type reference_range_target_var_pop_order_by = {
  rank?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "reference_range_target" */
export type reference_range_target_var_samp_order_by = {
  rank?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "reference_range_target" */
export type reference_range_target_variance_order_by = {
  rank?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "reference_range" */
export type reference_range_var_pop_order_by = {
  bmi?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "reference_range" */
export type reference_range_var_samp_order_by = {
  bmi?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "reference_range" */
export type reference_range_variance_order_by = {
  bmi?: InputMaybe<order_by>;
};

/** Boolean expression to compare columns of type "sex". All fields are combined with logical 'AND'. */
export type sex_comparison_exp = {
  _eq?: InputMaybe<Scalars['sex']['input']>;
  _gt?: InputMaybe<Scalars['sex']['input']>;
  _gte?: InputMaybe<Scalars['sex']['input']>;
  _in?: InputMaybe<Array<Scalars['sex']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['sex']['input']>;
  _lte?: InputMaybe<Scalars['sex']['input']>;
  _neq?: InputMaybe<Scalars['sex']['input']>;
  _nin?: InputMaybe<Array<Scalars['sex']['input']>>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type smallint_comparison_exp = {
  _eq?: InputMaybe<Scalars['smallint']['input']>;
  _gt?: InputMaybe<Scalars['smallint']['input']>;
  _gte?: InputMaybe<Scalars['smallint']['input']>;
  _in?: InputMaybe<Array<Scalars['smallint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['smallint']['input']>;
  _lte?: InputMaybe<Scalars['smallint']['input']>;
  _neq?: InputMaybe<Scalars['smallint']['input']>;
  _nin?: InputMaybe<Array<Scalars['smallint']['input']>>;
};

/** Boolean expression to filter rows from the table "stripe.checkout_bundle". All fields are combined with a logical 'AND'. */
export type stripe_checkout_bundle_bool_exp = {
  _and?: InputMaybe<Array<stripe_checkout_bundle_bool_exp>>;
  _not?: InputMaybe<stripe_checkout_bundle_bool_exp>;
  _or?: InputMaybe<Array<stripe_checkout_bundle_bool_exp>>;
  id?: InputMaybe<uuid_comparison_exp>;
  key?: InputMaybe<String_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  products?: InputMaybe<stripe_checkout_bundle_product_bool_exp>;
};

/** Ordering options when selecting data from "stripe.checkout_bundle". */
export type stripe_checkout_bundle_order_by = {
  id?: InputMaybe<order_by>;
  key?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  products_aggregate?: InputMaybe<stripe_checkout_bundle_product_aggregate_order_by>;
};

/** order by aggregate values of table "stripe.checkout_bundle_product" */
export type stripe_checkout_bundle_product_aggregate_order_by = {
  avg?: InputMaybe<stripe_checkout_bundle_product_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<stripe_checkout_bundle_product_max_order_by>;
  min?: InputMaybe<stripe_checkout_bundle_product_min_order_by>;
  stddev?: InputMaybe<stripe_checkout_bundle_product_stddev_order_by>;
  stddev_pop?: InputMaybe<stripe_checkout_bundle_product_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<stripe_checkout_bundle_product_stddev_samp_order_by>;
  sum?: InputMaybe<stripe_checkout_bundle_product_sum_order_by>;
  var_pop?: InputMaybe<stripe_checkout_bundle_product_var_pop_order_by>;
  var_samp?: InputMaybe<stripe_checkout_bundle_product_var_samp_order_by>;
  variance?: InputMaybe<stripe_checkout_bundle_product_variance_order_by>;
};

/** order by avg() on columns of table "stripe.checkout_bundle_product" */
export type stripe_checkout_bundle_product_avg_order_by = {
  quantity_max?: InputMaybe<order_by>;
  quantity_min?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "stripe.checkout_bundle_product". All fields are combined with a logical 'AND'. */
export type stripe_checkout_bundle_product_bool_exp = {
  _and?: InputMaybe<Array<stripe_checkout_bundle_product_bool_exp>>;
  _not?: InputMaybe<stripe_checkout_bundle_product_bool_exp>;
  _or?: InputMaybe<Array<stripe_checkout_bundle_product_bool_exp>>;
  checkout_bundle?: InputMaybe<stripe_checkout_bundle_bool_exp>;
  checkout_bundle_id?: InputMaybe<uuid_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  fulfill_alone?: InputMaybe<Boolean_comparison_exp>;
  fulfillment_method?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  price?: InputMaybe<stripe_price_bool_exp>;
  price_id?: InputMaybe<uuid_comparison_exp>;
  quantity_max?: InputMaybe<Int_comparison_exp>;
  quantity_min?: InputMaybe<Int_comparison_exp>;
  sort_order?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by max() on columns of table "stripe.checkout_bundle_product" */
export type stripe_checkout_bundle_product_max_order_by = {
  checkout_bundle_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  fulfillment_method?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  price_id?: InputMaybe<order_by>;
  quantity_max?: InputMaybe<order_by>;
  quantity_min?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "stripe.checkout_bundle_product" */
export type stripe_checkout_bundle_product_min_order_by = {
  checkout_bundle_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  fulfillment_method?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  price_id?: InputMaybe<order_by>;
  quantity_max?: InputMaybe<order_by>;
  quantity_min?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by stddev() on columns of table "stripe.checkout_bundle_product" */
export type stripe_checkout_bundle_product_stddev_order_by = {
  quantity_max?: InputMaybe<order_by>;
  quantity_min?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "stripe.checkout_bundle_product" */
export type stripe_checkout_bundle_product_stddev_pop_order_by = {
  quantity_max?: InputMaybe<order_by>;
  quantity_min?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "stripe.checkout_bundle_product" */
export type stripe_checkout_bundle_product_stddev_samp_order_by = {
  quantity_max?: InputMaybe<order_by>;
  quantity_min?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "stripe.checkout_bundle_product" */
export type stripe_checkout_bundle_product_sum_order_by = {
  quantity_max?: InputMaybe<order_by>;
  quantity_min?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "stripe.checkout_bundle_product" */
export type stripe_checkout_bundle_product_var_pop_order_by = {
  quantity_max?: InputMaybe<order_by>;
  quantity_min?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "stripe.checkout_bundle_product" */
export type stripe_checkout_bundle_product_var_samp_order_by = {
  quantity_max?: InputMaybe<order_by>;
  quantity_min?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "stripe.checkout_bundle_product" */
export type stripe_checkout_bundle_product_variance_order_by = {
  quantity_max?: InputMaybe<order_by>;
  quantity_min?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "stripe.nonmember_price". All fields are combined with a logical 'AND'. */
export type stripe_nonmember_price_bool_exp = {
  _and?: InputMaybe<Array<stripe_nonmember_price_bool_exp>>;
  _not?: InputMaybe<stripe_nonmember_price_bool_exp>;
  _or?: InputMaybe<Array<stripe_nonmember_price_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  price_usd?: InputMaybe<Int_comparison_exp>;
  recurring?: InputMaybe<Boolean_comparison_exp>;
  stripe_product_id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

export type stripe_order_aggregate_bool_exp = {
  count?: InputMaybe<stripe_order_aggregate_bool_exp_count>;
};

export type stripe_order_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<stripe_order_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<stripe_order_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "stripe.order" */
export type stripe_order_aggregate_order_by = {
  avg?: InputMaybe<stripe_order_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<stripe_order_max_order_by>;
  min?: InputMaybe<stripe_order_min_order_by>;
  stddev?: InputMaybe<stripe_order_stddev_order_by>;
  stddev_pop?: InputMaybe<stripe_order_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<stripe_order_stddev_samp_order_by>;
  sum?: InputMaybe<stripe_order_sum_order_by>;
  var_pop?: InputMaybe<stripe_order_var_pop_order_by>;
  var_samp?: InputMaybe<stripe_order_var_samp_order_by>;
  variance?: InputMaybe<stripe_order_variance_order_by>;
};

/** order by avg() on columns of table "stripe.order" */
export type stripe_order_avg_order_by = {
  discount?: InputMaybe<order_by>;
  member_discount?: InputMaybe<order_by>;
  order_number?: InputMaybe<order_by>;
  promotion_discount?: InputMaybe<order_by>;
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  tax?: InputMaybe<order_by>;
  total?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "stripe.order". All fields are combined with a logical 'AND'. */
export type stripe_order_bool_exp = {
  _and?: InputMaybe<Array<stripe_order_bool_exp>>;
  _not?: InputMaybe<stripe_order_bool_exp>;
  _or?: InputMaybe<Array<stripe_order_bool_exp>>;
  checkout_bundle?: InputMaybe<stripe_checkout_bundle_bool_exp>;
  checkout_session_id?: InputMaybe<String_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  discount?: InputMaybe<Int_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  fulfillment_groups?: InputMaybe<stripe_order_fulfillment_group_bool_exp>;
  fulfillment_status?: InputMaybe<enum_fulfillment_status_enum_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  lab_orders?: InputMaybe<lab_order_bool_exp>;
  lab_orders_aggregate?: InputMaybe<lab_order_aggregate_bool_exp>;
  line_items?: InputMaybe<stripe_order_line_item_bool_exp>;
  member_discount?: InputMaybe<Int_comparison_exp>;
  mode?: InputMaybe<enum_order_mode_enum_comparison_exp>;
  order_number?: InputMaybe<Int_comparison_exp>;
  paid_at?: InputMaybe<timestamptz_comparison_exp>;
  payment_intent_id?: InputMaybe<String_comparison_exp>;
  payment_status?: InputMaybe<String_comparison_exp>;
  promotion_discount?: InputMaybe<Int_comparison_exp>;
  shipping?: InputMaybe<Int_comparison_exp>;
  subtotal?: InputMaybe<Int_comparison_exp>;
  tax?: InputMaybe<Int_comparison_exp>;
  total?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_address?: InputMaybe<user_address_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by aggregate values of table "stripe.order_fulfillment_group" */
export type stripe_order_fulfillment_group_aggregate_order_by = {
  avg?: InputMaybe<stripe_order_fulfillment_group_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<stripe_order_fulfillment_group_max_order_by>;
  min?: InputMaybe<stripe_order_fulfillment_group_min_order_by>;
  stddev?: InputMaybe<stripe_order_fulfillment_group_stddev_order_by>;
  stddev_pop?: InputMaybe<stripe_order_fulfillment_group_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<stripe_order_fulfillment_group_stddev_samp_order_by>;
  sum?: InputMaybe<stripe_order_fulfillment_group_sum_order_by>;
  var_pop?: InputMaybe<stripe_order_fulfillment_group_var_pop_order_by>;
  var_samp?: InputMaybe<stripe_order_fulfillment_group_var_samp_order_by>;
  variance?: InputMaybe<stripe_order_fulfillment_group_variance_order_by>;
};

/** order by avg() on columns of table "stripe.order_fulfillment_group" */
export type stripe_order_fulfillment_group_avg_order_by = {
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "stripe.order_fulfillment_group". All fields are combined with a logical 'AND'. */
export type stripe_order_fulfillment_group_bool_exp = {
  _and?: InputMaybe<Array<stripe_order_fulfillment_group_bool_exp>>;
  _not?: InputMaybe<stripe_order_fulfillment_group_bool_exp>;
  _or?: InputMaybe<Array<stripe_order_fulfillment_group_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  fulfillment_error?: InputMaybe<jsonb_comparison_exp>;
  fulfillment_method?: InputMaybe<String_comparison_exp>;
  fulfillment_provider?: InputMaybe<enum_fulfillment_provider_enum_comparison_exp>;
  fulfillment_status?: InputMaybe<enum_fulfillment_status_enum_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  lab_orders?: InputMaybe<lab_order_bool_exp>;
  lab_orders_aggregate?: InputMaybe<lab_order_aggregate_bool_exp>;
  line_items?: InputMaybe<stripe_order_line_item_bool_exp>;
  order?: InputMaybe<stripe_order_bool_exp>;
  order_id?: InputMaybe<uuid_comparison_exp>;
  shipping?: InputMaybe<Int_comparison_exp>;
  subtotal?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by max() on columns of table "stripe.order_fulfillment_group" */
export type stripe_order_fulfillment_group_max_order_by = {
  created_at?: InputMaybe<order_by>;
  fulfillment_method?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  order_id?: InputMaybe<order_by>;
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "stripe.order_fulfillment_group" */
export type stripe_order_fulfillment_group_min_order_by = {
  created_at?: InputMaybe<order_by>;
  fulfillment_method?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  order_id?: InputMaybe<order_by>;
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "stripe.order_fulfillment_group". */
export type stripe_order_fulfillment_group_order_by = {
  created_at?: InputMaybe<order_by>;
  fulfillment_error?: InputMaybe<order_by>;
  fulfillment_method?: InputMaybe<order_by>;
  fulfillment_provider?: InputMaybe<order_by>;
  fulfillment_status?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  lab_orders_aggregate?: InputMaybe<lab_order_aggregate_order_by>;
  line_items_aggregate?: InputMaybe<stripe_order_line_item_aggregate_order_by>;
  order?: InputMaybe<stripe_order_order_by>;
  order_id?: InputMaybe<order_by>;
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by stddev() on columns of table "stripe.order_fulfillment_group" */
export type stripe_order_fulfillment_group_stddev_order_by = {
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "stripe.order_fulfillment_group" */
export type stripe_order_fulfillment_group_stddev_pop_order_by = {
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "stripe.order_fulfillment_group" */
export type stripe_order_fulfillment_group_stddev_samp_order_by = {
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "stripe.order_fulfillment_group" */
export type stripe_order_fulfillment_group_sum_order_by = {
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "stripe.order_fulfillment_group" */
export type stripe_order_fulfillment_group_var_pop_order_by = {
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "stripe.order_fulfillment_group" */
export type stripe_order_fulfillment_group_var_samp_order_by = {
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "stripe.order_fulfillment_group" */
export type stripe_order_fulfillment_group_variance_order_by = {
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
};

/** order by aggregate values of table "stripe.order_line_item" */
export type stripe_order_line_item_aggregate_order_by = {
  avg?: InputMaybe<stripe_order_line_item_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<stripe_order_line_item_max_order_by>;
  min?: InputMaybe<stripe_order_line_item_min_order_by>;
  stddev?: InputMaybe<stripe_order_line_item_stddev_order_by>;
  stddev_pop?: InputMaybe<stripe_order_line_item_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<stripe_order_line_item_stddev_samp_order_by>;
  sum?: InputMaybe<stripe_order_line_item_sum_order_by>;
  var_pop?: InputMaybe<stripe_order_line_item_var_pop_order_by>;
  var_samp?: InputMaybe<stripe_order_line_item_var_samp_order_by>;
  variance?: InputMaybe<stripe_order_line_item_variance_order_by>;
};

/** order by avg() on columns of table "stripe.order_line_item" */
export type stripe_order_line_item_avg_order_by = {
  quantity?: InputMaybe<order_by>;
  quantity_max?: InputMaybe<order_by>;
  quantity_min?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  tax?: InputMaybe<order_by>;
  total?: InputMaybe<order_by>;
  total_member_discount?: InputMaybe<order_by>;
  total_promotion_discount?: InputMaybe<order_by>;
  unit_member_discount?: InputMaybe<order_by>;
  unit_price?: InputMaybe<order_by>;
  unit_promotion_discount?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "stripe.order_line_item". All fields are combined with a logical 'AND'. */
export type stripe_order_line_item_bool_exp = {
  _and?: InputMaybe<Array<stripe_order_line_item_bool_exp>>;
  _not?: InputMaybe<stripe_order_line_item_bool_exp>;
  _or?: InputMaybe<Array<stripe_order_line_item_bool_exp>>;
  added_by_user?: InputMaybe<Boolean_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  from_checkout_bundle?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  is_purchase_request?: InputMaybe<Boolean_comparison_exp>;
  order?: InputMaybe<stripe_order_bool_exp>;
  order_id?: InputMaybe<uuid_comparison_exp>;
  product?: InputMaybe<stripe_product_bool_exp>;
  product_id?: InputMaybe<uuid_comparison_exp>;
  product_type?: InputMaybe<enum_stripe_product_type_enum_comparison_exp>;
  quantity?: InputMaybe<Int_comparison_exp>;
  quantity_max?: InputMaybe<Int_comparison_exp>;
  quantity_min?: InputMaybe<Int_comparison_exp>;
  required_by?: InputMaybe<stripe_order_line_item_required_by_bool_exp>;
  requires?: InputMaybe<stripe_order_line_item_required_by_bool_exp>;
  shipping_status?: InputMaybe<enum_shipping_status_enum_comparison_exp>;
  stripe_id?: InputMaybe<String_comparison_exp>;
  stripe_price_id?: InputMaybe<String_comparison_exp>;
  subscription_request?: InputMaybe<stripe_subscription_request_bool_exp>;
  subtotal?: InputMaybe<Int_comparison_exp>;
  tax?: InputMaybe<Int_comparison_exp>;
  total?: InputMaybe<Int_comparison_exp>;
  total_member_discount?: InputMaybe<Int_comparison_exp>;
  total_promotion_discount?: InputMaybe<Int_comparison_exp>;
  unit_member_discount?: InputMaybe<Int_comparison_exp>;
  unit_price?: InputMaybe<Int_comparison_exp>;
  unit_promotion_discount?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by max() on columns of table "stripe.order_line_item" */
export type stripe_order_line_item_max_order_by = {
  created_at?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  order_id?: InputMaybe<order_by>;
  product_id?: InputMaybe<order_by>;
  quantity?: InputMaybe<order_by>;
  quantity_max?: InputMaybe<order_by>;
  quantity_min?: InputMaybe<order_by>;
  stripe_id?: InputMaybe<order_by>;
  stripe_price_id?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  tax?: InputMaybe<order_by>;
  total?: InputMaybe<order_by>;
  total_member_discount?: InputMaybe<order_by>;
  total_promotion_discount?: InputMaybe<order_by>;
  unit_member_discount?: InputMaybe<order_by>;
  unit_price?: InputMaybe<order_by>;
  unit_promotion_discount?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "stripe.order_line_item" */
export type stripe_order_line_item_min_order_by = {
  created_at?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  order_id?: InputMaybe<order_by>;
  product_id?: InputMaybe<order_by>;
  quantity?: InputMaybe<order_by>;
  quantity_max?: InputMaybe<order_by>;
  quantity_min?: InputMaybe<order_by>;
  stripe_id?: InputMaybe<order_by>;
  stripe_price_id?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  tax?: InputMaybe<order_by>;
  total?: InputMaybe<order_by>;
  total_member_discount?: InputMaybe<order_by>;
  total_promotion_discount?: InputMaybe<order_by>;
  unit_member_discount?: InputMaybe<order_by>;
  unit_price?: InputMaybe<order_by>;
  unit_promotion_discount?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "stripe.order_line_item_required_by". All fields are combined with a logical 'AND'. */
export type stripe_order_line_item_required_by_bool_exp = {
  _and?: InputMaybe<Array<stripe_order_line_item_required_by_bool_exp>>;
  _not?: InputMaybe<stripe_order_line_item_required_by_bool_exp>;
  _or?: InputMaybe<Array<stripe_order_line_item_required_by_bool_exp>>;
  order_line_item?: InputMaybe<stripe_order_line_item_bool_exp>;
  requires_line_item?: InputMaybe<stripe_order_line_item_bool_exp>;
};

/** order by stddev() on columns of table "stripe.order_line_item" */
export type stripe_order_line_item_stddev_order_by = {
  quantity?: InputMaybe<order_by>;
  quantity_max?: InputMaybe<order_by>;
  quantity_min?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  tax?: InputMaybe<order_by>;
  total?: InputMaybe<order_by>;
  total_member_discount?: InputMaybe<order_by>;
  total_promotion_discount?: InputMaybe<order_by>;
  unit_member_discount?: InputMaybe<order_by>;
  unit_price?: InputMaybe<order_by>;
  unit_promotion_discount?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "stripe.order_line_item" */
export type stripe_order_line_item_stddev_pop_order_by = {
  quantity?: InputMaybe<order_by>;
  quantity_max?: InputMaybe<order_by>;
  quantity_min?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  tax?: InputMaybe<order_by>;
  total?: InputMaybe<order_by>;
  total_member_discount?: InputMaybe<order_by>;
  total_promotion_discount?: InputMaybe<order_by>;
  unit_member_discount?: InputMaybe<order_by>;
  unit_price?: InputMaybe<order_by>;
  unit_promotion_discount?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "stripe.order_line_item" */
export type stripe_order_line_item_stddev_samp_order_by = {
  quantity?: InputMaybe<order_by>;
  quantity_max?: InputMaybe<order_by>;
  quantity_min?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  tax?: InputMaybe<order_by>;
  total?: InputMaybe<order_by>;
  total_member_discount?: InputMaybe<order_by>;
  total_promotion_discount?: InputMaybe<order_by>;
  unit_member_discount?: InputMaybe<order_by>;
  unit_price?: InputMaybe<order_by>;
  unit_promotion_discount?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "stripe.order_line_item" */
export type stripe_order_line_item_sum_order_by = {
  quantity?: InputMaybe<order_by>;
  quantity_max?: InputMaybe<order_by>;
  quantity_min?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  tax?: InputMaybe<order_by>;
  total?: InputMaybe<order_by>;
  total_member_discount?: InputMaybe<order_by>;
  total_promotion_discount?: InputMaybe<order_by>;
  unit_member_discount?: InputMaybe<order_by>;
  unit_price?: InputMaybe<order_by>;
  unit_promotion_discount?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "stripe.order_line_item" */
export type stripe_order_line_item_var_pop_order_by = {
  quantity?: InputMaybe<order_by>;
  quantity_max?: InputMaybe<order_by>;
  quantity_min?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  tax?: InputMaybe<order_by>;
  total?: InputMaybe<order_by>;
  total_member_discount?: InputMaybe<order_by>;
  total_promotion_discount?: InputMaybe<order_by>;
  unit_member_discount?: InputMaybe<order_by>;
  unit_price?: InputMaybe<order_by>;
  unit_promotion_discount?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "stripe.order_line_item" */
export type stripe_order_line_item_var_samp_order_by = {
  quantity?: InputMaybe<order_by>;
  quantity_max?: InputMaybe<order_by>;
  quantity_min?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  tax?: InputMaybe<order_by>;
  total?: InputMaybe<order_by>;
  total_member_discount?: InputMaybe<order_by>;
  total_promotion_discount?: InputMaybe<order_by>;
  unit_member_discount?: InputMaybe<order_by>;
  unit_price?: InputMaybe<order_by>;
  unit_promotion_discount?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "stripe.order_line_item" */
export type stripe_order_line_item_variance_order_by = {
  quantity?: InputMaybe<order_by>;
  quantity_max?: InputMaybe<order_by>;
  quantity_min?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  tax?: InputMaybe<order_by>;
  total?: InputMaybe<order_by>;
  total_member_discount?: InputMaybe<order_by>;
  total_promotion_discount?: InputMaybe<order_by>;
  unit_member_discount?: InputMaybe<order_by>;
  unit_price?: InputMaybe<order_by>;
  unit_promotion_discount?: InputMaybe<order_by>;
};

/** order by max() on columns of table "stripe.order" */
export type stripe_order_max_order_by = {
  checkout_session_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  discount?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  member_discount?: InputMaybe<order_by>;
  order_number?: InputMaybe<order_by>;
  paid_at?: InputMaybe<order_by>;
  payment_intent_id?: InputMaybe<order_by>;
  payment_status?: InputMaybe<order_by>;
  promotion_discount?: InputMaybe<order_by>;
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  tax?: InputMaybe<order_by>;
  total?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "stripe.order" */
export type stripe_order_min_order_by = {
  checkout_session_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  discount?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  member_discount?: InputMaybe<order_by>;
  order_number?: InputMaybe<order_by>;
  paid_at?: InputMaybe<order_by>;
  payment_intent_id?: InputMaybe<order_by>;
  payment_status?: InputMaybe<order_by>;
  promotion_discount?: InputMaybe<order_by>;
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  tax?: InputMaybe<order_by>;
  total?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "stripe.order". */
export type stripe_order_order_by = {
  checkout_bundle?: InputMaybe<stripe_checkout_bundle_order_by>;
  checkout_session_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  discount?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  fulfillment_groups_aggregate?: InputMaybe<stripe_order_fulfillment_group_aggregate_order_by>;
  fulfillment_status?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  lab_orders_aggregate?: InputMaybe<lab_order_aggregate_order_by>;
  line_items_aggregate?: InputMaybe<stripe_order_line_item_aggregate_order_by>;
  member_discount?: InputMaybe<order_by>;
  mode?: InputMaybe<order_by>;
  order_number?: InputMaybe<order_by>;
  paid_at?: InputMaybe<order_by>;
  payment_intent_id?: InputMaybe<order_by>;
  payment_status?: InputMaybe<order_by>;
  promotion_discount?: InputMaybe<order_by>;
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  tax?: InputMaybe<order_by>;
  total?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user?: InputMaybe<user_order_by>;
  user_address?: InputMaybe<user_address_order_by>;
  user_id?: InputMaybe<order_by>;
};

/** select columns of table "stripe.order" */
export enum stripe_order_select_column {
  /** column name */
  checkout_session_id = 'checkout_session_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  discount = 'discount',
  /** column name */
  email = 'email',
  /** column name */
  fulfillment_status = 'fulfillment_status',
  /** column name */
  id = 'id',
  /** column name */
  member_discount = 'member_discount',
  /** column name */
  mode = 'mode',
  /** column name */
  order_number = 'order_number',
  /** column name */
  paid_at = 'paid_at',
  /** column name */
  payment_intent_id = 'payment_intent_id',
  /** column name */
  payment_status = 'payment_status',
  /** column name */
  promotion_discount = 'promotion_discount',
  /** column name */
  shipping = 'shipping',
  /** column name */
  subtotal = 'subtotal',
  /** column name */
  tax = 'tax',
  /** column name */
  total = 'total',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  user_id = 'user_id'
}

/** order by stddev() on columns of table "stripe.order" */
export type stripe_order_stddev_order_by = {
  discount?: InputMaybe<order_by>;
  member_discount?: InputMaybe<order_by>;
  order_number?: InputMaybe<order_by>;
  promotion_discount?: InputMaybe<order_by>;
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  tax?: InputMaybe<order_by>;
  total?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "stripe.order" */
export type stripe_order_stddev_pop_order_by = {
  discount?: InputMaybe<order_by>;
  member_discount?: InputMaybe<order_by>;
  order_number?: InputMaybe<order_by>;
  promotion_discount?: InputMaybe<order_by>;
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  tax?: InputMaybe<order_by>;
  total?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "stripe.order" */
export type stripe_order_stddev_samp_order_by = {
  discount?: InputMaybe<order_by>;
  member_discount?: InputMaybe<order_by>;
  order_number?: InputMaybe<order_by>;
  promotion_discount?: InputMaybe<order_by>;
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  tax?: InputMaybe<order_by>;
  total?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "stripe.order" */
export type stripe_order_sum_order_by = {
  discount?: InputMaybe<order_by>;
  member_discount?: InputMaybe<order_by>;
  order_number?: InputMaybe<order_by>;
  promotion_discount?: InputMaybe<order_by>;
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  tax?: InputMaybe<order_by>;
  total?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "stripe.order" */
export type stripe_order_var_pop_order_by = {
  discount?: InputMaybe<order_by>;
  member_discount?: InputMaybe<order_by>;
  order_number?: InputMaybe<order_by>;
  promotion_discount?: InputMaybe<order_by>;
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  tax?: InputMaybe<order_by>;
  total?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "stripe.order" */
export type stripe_order_var_samp_order_by = {
  discount?: InputMaybe<order_by>;
  member_discount?: InputMaybe<order_by>;
  order_number?: InputMaybe<order_by>;
  promotion_discount?: InputMaybe<order_by>;
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  tax?: InputMaybe<order_by>;
  total?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "stripe.order" */
export type stripe_order_variance_order_by = {
  discount?: InputMaybe<order_by>;
  member_discount?: InputMaybe<order_by>;
  order_number?: InputMaybe<order_by>;
  promotion_discount?: InputMaybe<order_by>;
  shipping?: InputMaybe<order_by>;
  subtotal?: InputMaybe<order_by>;
  tax?: InputMaybe<order_by>;
  total?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "stripe.package_product". All fields are combined with a logical 'AND'. */
export type stripe_package_product_bool_exp = {
  _and?: InputMaybe<Array<stripe_package_product_bool_exp>>;
  _not?: InputMaybe<stripe_package_product_bool_exp>;
  _or?: InputMaybe<Array<stripe_package_product_bool_exp>>;
  package?: InputMaybe<stripe_product_bool_exp>;
  package_id?: InputMaybe<uuid_comparison_exp>;
  product?: InputMaybe<stripe_product_bool_exp>;
  product_id?: InputMaybe<uuid_comparison_exp>;
};

/** Boolean expression to filter rows from the table "stripe.price". All fields are combined with a logical 'AND'. */
export type stripe_price_bool_exp = {
  _and?: InputMaybe<Array<stripe_price_bool_exp>>;
  _not?: InputMaybe<stripe_price_bool_exp>;
  _or?: InputMaybe<Array<stripe_price_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  enabled?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  membership_tier?: InputMaybe<enum_membership_tier_enum_comparison_exp>;
  metadata?: InputMaybe<jsonb_comparison_exp>;
  price_usd?: InputMaybe<Int_comparison_exp>;
  product?: InputMaybe<stripe_product_bool_exp>;
  recurring?: InputMaybe<Boolean_comparison_exp>;
  stripe_id?: InputMaybe<String_comparison_exp>;
  stripe_product_id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** Boolean expression to filter rows from the table "stripe.price_free_member". All fields are combined with a logical 'AND'. */
export type stripe_price_free_member_bool_exp = {
  _and?: InputMaybe<Array<stripe_price_free_member_bool_exp>>;
  _not?: InputMaybe<stripe_price_free_member_bool_exp>;
  _or?: InputMaybe<Array<stripe_price_free_member_bool_exp>>;
  price_usd?: InputMaybe<Int_comparison_exp>;
  recurring?: InputMaybe<Boolean_comparison_exp>;
};

/** Boolean expression to filter rows from the table "stripe.price_paid_member". All fields are combined with a logical 'AND'. */
export type stripe_price_paid_member_bool_exp = {
  _and?: InputMaybe<Array<stripe_price_paid_member_bool_exp>>;
  _not?: InputMaybe<stripe_price_paid_member_bool_exp>;
  _or?: InputMaybe<Array<stripe_price_paid_member_bool_exp>>;
  id?: InputMaybe<uuid_comparison_exp>;
  membership_tier?: InputMaybe<String_comparison_exp>;
  price_usd?: InputMaybe<Int_comparison_exp>;
  recurring?: InputMaybe<Boolean_comparison_exp>;
};

/** Boolean expression to filter rows from the table "stripe.product_addon". All fields are combined with a logical 'AND'. */
export type stripe_product_addon_bool_exp = {
  _and?: InputMaybe<Array<stripe_product_addon_bool_exp>>;
  _not?: InputMaybe<stripe_product_addon_bool_exp>;
  _or?: InputMaybe<Array<stripe_product_addon_bool_exp>>;
  addon?: InputMaybe<stripe_product_bool_exp>;
  addon_product_id?: InputMaybe<uuid_comparison_exp>;
  product_id?: InputMaybe<uuid_comparison_exp>;
};

/** Boolean expression to filter rows from the table "stripe.product". All fields are combined with a logical 'AND'. */
export type stripe_product_bool_exp = {
  _and?: InputMaybe<Array<stripe_product_bool_exp>>;
  _not?: InputMaybe<stripe_product_bool_exp>;
  _or?: InputMaybe<Array<stripe_product_bool_exp>>;
  addons?: InputMaybe<stripe_product_addon_bool_exp>;
  country_availability?: InputMaybe<_text_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  direct_lab_items?: InputMaybe<stripe_product_lab_test_item_bool_exp>;
  enabled?: InputMaybe<Boolean_comparison_exp>;
  fulfillment_provider?: InputMaybe<enum_fulfillment_provider_enum_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  is_custom?: InputMaybe<Boolean_comparison_exp>;
  lab_items?: InputMaybe<stripe_product_lab_test_item_flat_bool_exp>;
  labels?: InputMaybe<stripe_product_label_bool_exp>;
  marker_counts?: InputMaybe<stripe_product_marker_counts_bool_exp>;
  markers?: InputMaybe<stripe_product_lab_test_marker_flat_new_bool_exp>;
  markers_aggregate?: InputMaybe<stripe_product_lab_test_marker_flat_new_aggregate_bool_exp>;
  metadata?: InputMaybe<jsonb_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  nonmember_price?: InputMaybe<stripe_nonmember_price_bool_exp>;
  package_products?: InputMaybe<stripe_package_product_bool_exp>;
  price?: InputMaybe<stripe_price_bool_exp>;
  price_current?: InputMaybe<stripe_price_bool_exp>;
  price_free_member?: InputMaybe<stripe_price_free_member_bool_exp>;
  price_paid_member?: InputMaybe<stripe_price_paid_member_bool_exp>;
  product_type?: InputMaybe<enum_stripe_product_type_enum_comparison_exp>;
  retail_price?: InputMaybe<Int_comparison_exp>;
  slug?: InputMaybe<String_comparison_exp>;
  stripe_id?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by aggregate values of table "stripe.product_lab_test_item" */
export type stripe_product_lab_test_item_aggregate_order_by = {
  count?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "stripe.product_lab_test_item". All fields are combined with a logical 'AND'. */
export type stripe_product_lab_test_item_bool_exp = {
  _and?: InputMaybe<Array<stripe_product_lab_test_item_bool_exp>>;
  _not?: InputMaybe<stripe_product_lab_test_item_bool_exp>;
  _or?: InputMaybe<Array<stripe_product_lab_test_item_bool_exp>>;
  lab_test_item?: InputMaybe<lab_test_item_bool_exp>;
  product?: InputMaybe<stripe_product_bool_exp>;
};

/** Boolean expression to filter rows from the table "stripe.product_lab_test_item_flat". All fields are combined with a logical 'AND'. */
export type stripe_product_lab_test_item_flat_bool_exp = {
  _and?: InputMaybe<Array<stripe_product_lab_test_item_flat_bool_exp>>;
  _not?: InputMaybe<stripe_product_lab_test_item_flat_bool_exp>;
  _or?: InputMaybe<Array<stripe_product_lab_test_item_flat_bool_exp>>;
  lab_test?: InputMaybe<lab_test_item_bool_exp>;
  lab_test_item_id?: InputMaybe<uuid_comparison_exp>;
  product?: InputMaybe<stripe_product_bool_exp>;
  product_id?: InputMaybe<uuid_comparison_exp>;
};

export type stripe_product_lab_test_marker_flat_new_aggregate_bool_exp = {
  bool_and?: InputMaybe<stripe_product_lab_test_marker_flat_new_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<stripe_product_lab_test_marker_flat_new_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<stripe_product_lab_test_marker_flat_new_aggregate_bool_exp_count>;
};

export type stripe_product_lab_test_marker_flat_new_aggregate_bool_exp_bool_and = {
  arguments: stripe_product_lab_test_marker_flat_new_select_column_stripe_product_lab_test_marker_flat_new_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<stripe_product_lab_test_marker_flat_new_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type stripe_product_lab_test_marker_flat_new_aggregate_bool_exp_bool_or = {
  arguments: stripe_product_lab_test_marker_flat_new_select_column_stripe_product_lab_test_marker_flat_new_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<stripe_product_lab_test_marker_flat_new_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type stripe_product_lab_test_marker_flat_new_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<stripe_product_lab_test_marker_flat_new_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<stripe_product_lab_test_marker_flat_new_bool_exp>;
  predicate: Int_comparison_exp;
};

/** Boolean expression to filter rows from the table "stripe.product_lab_test_marker_flat_new". All fields are combined with a logical 'AND'. */
export type stripe_product_lab_test_marker_flat_new_bool_exp = {
  _and?: InputMaybe<Array<stripe_product_lab_test_marker_flat_new_bool_exp>>;
  _not?: InputMaybe<stripe_product_lab_test_marker_flat_new_bool_exp>;
  _or?: InputMaybe<Array<stripe_product_lab_test_marker_flat_new_bool_exp>>;
  lab_test_marker?: InputMaybe<lab_test_marker_bool_exp>;
  lab_test_marker_id?: InputMaybe<uuid_comparison_exp>;
  product_id?: InputMaybe<uuid_comparison_exp>;
  required?: InputMaybe<Boolean_comparison_exp>;
};

/** select columns of table "stripe.product_lab_test_marker_flat_new" */
export enum stripe_product_lab_test_marker_flat_new_select_column {
  /** column name */
  lab_test_marker_id = 'lab_test_marker_id',
  /** column name */
  product_id = 'product_id',
  /** column name */
  required = 'required'
}

/** select "stripe_product_lab_test_marker_flat_new_aggregate_bool_exp_bool_and_arguments_columns" columns of table "stripe.product_lab_test_marker_flat_new" */
export enum stripe_product_lab_test_marker_flat_new_select_column_stripe_product_lab_test_marker_flat_new_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  required = 'required'
}

/** select "stripe_product_lab_test_marker_flat_new_aggregate_bool_exp_bool_or_arguments_columns" columns of table "stripe.product_lab_test_marker_flat_new" */
export enum stripe_product_lab_test_marker_flat_new_select_column_stripe_product_lab_test_marker_flat_new_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  required = 'required'
}

/** Boolean expression to filter rows from the table "stripe.product_label". All fields are combined with a logical 'AND'. */
export type stripe_product_label_bool_exp = {
  _and?: InputMaybe<Array<stripe_product_label_bool_exp>>;
  _not?: InputMaybe<stripe_product_label_bool_exp>;
  _or?: InputMaybe<Array<stripe_product_label_bool_exp>>;
  label?: InputMaybe<label_bool_exp>;
  label_id?: InputMaybe<uuid_comparison_exp>;
  product?: InputMaybe<stripe_product_bool_exp>;
  product_id?: InputMaybe<uuid_comparison_exp>;
};

/** Boolean expression to filter rows from the table "stripe.product_marker_counts". All fields are combined with a logical 'AND'. */
export type stripe_product_marker_counts_bool_exp = {
  _and?: InputMaybe<Array<stripe_product_marker_counts_bool_exp>>;
  _not?: InputMaybe<stripe_product_marker_counts_bool_exp>;
  _or?: InputMaybe<Array<stripe_product_marker_counts_bool_exp>>;
  label?: InputMaybe<label_bool_exp>;
  label_id?: InputMaybe<uuid_comparison_exp>;
  product_id?: InputMaybe<uuid_comparison_exp>;
  quantity?: InputMaybe<numeric_comparison_exp>;
};

/** Boolean expression to filter rows from the table "stripe.subscription_request". All fields are combined with a logical 'AND'. */
export type stripe_subscription_request_bool_exp = {
  _and?: InputMaybe<Array<stripe_subscription_request_bool_exp>>;
  _not?: InputMaybe<stripe_subscription_request_bool_exp>;
  _or?: InputMaybe<Array<stripe_subscription_request_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  denied_reason?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  order_line_item?: InputMaybe<stripe_order_line_item_bool_exp>;
  order_line_item_id?: InputMaybe<uuid_comparison_exp>;
  orders?: InputMaybe<stripe_order_bool_exp>;
  price?: InputMaybe<stripe_price_bool_exp>;
  price_id?: InputMaybe<uuid_comparison_exp>;
  status?: InputMaybe<enum_subscription_request_status_enum_comparison_exp>;
  stripe_subscription_id?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by aggregate values of table "supplement" */
export type supplement_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<supplement_max_order_by>;
  min?: InputMaybe<supplement_min_order_by>;
};

/** Boolean expression to filter rows from the table "supplement". All fields are combined with a logical 'AND'. */
export type supplement_bool_exp = {
  _and?: InputMaybe<Array<supplement_bool_exp>>;
  _not?: InputMaybe<supplement_bool_exp>;
  _or?: InputMaybe<Array<supplement_bool_exp>>;
  brand?: InputMaybe<String_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  metric?: InputMaybe<metric_bool_exp>;
  name?: InputMaybe<String_comparison_exp>;
  nutrition_label_image_url?: InputMaybe<String_comparison_exp>;
  product_image_url?: InputMaybe<String_comparison_exp>;
  products?: InputMaybe<supplement_product_bool_exp>;
  serving_size?: InputMaybe<String_comparison_exp>;
  supplement_records?: InputMaybe<supplement_record_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
  user_supplements?: InputMaybe<user_supplement_bool_exp>;
  user_supplements_aggregate?: InputMaybe<user_supplement_aggregate_bool_exp>;
};

/** unique or primary key constraints on table "supplement" */
export enum supplement_constraint {
  /** unique or primary key constraint on columns "id" */
  supplement_pkey = 'supplement_pkey'
}

/** input type for inserting data into table "supplement" */
export type supplement_insert_input = {
  brand?: InputMaybe<Scalars['String']['input']>;
  metric?: InputMaybe<metric_obj_rel_insert_input>;
  name?: InputMaybe<Scalars['String']['input']>;
  nutrition_label_image_url?: InputMaybe<Scalars['String']['input']>;
  product_image_url?: InputMaybe<Scalars['String']['input']>;
  serving_size?: InputMaybe<Scalars['String']['input']>;
  user_supplements?: InputMaybe<user_supplement_arr_rel_insert_input>;
};

/** order by max() on columns of table "supplement" */
export type supplement_max_order_by = {
  brand?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  nutrition_label_image_url?: InputMaybe<order_by>;
  product_image_url?: InputMaybe<order_by>;
  serving_size?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "supplement" */
export type supplement_min_order_by = {
  brand?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  nutrition_label_image_url?: InputMaybe<order_by>;
  product_image_url?: InputMaybe<order_by>;
  serving_size?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** input type for inserting object relation for remote table "supplement" */
export type supplement_obj_rel_insert_input = {
  data: supplement_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<supplement_on_conflict>;
};

/** on_conflict condition type for table "supplement" */
export type supplement_on_conflict = {
  constraint: supplement_constraint;
  update_columns?: Array<supplement_update_column>;
  where?: InputMaybe<supplement_bool_exp>;
};

/** Ordering options when selecting data from "supplement". */
export type supplement_order_by = {
  brand?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  metric?: InputMaybe<metric_order_by>;
  name?: InputMaybe<order_by>;
  nutrition_label_image_url?: InputMaybe<order_by>;
  product_image_url?: InputMaybe<order_by>;
  products_aggregate?: InputMaybe<supplement_product_aggregate_order_by>;
  serving_size?: InputMaybe<order_by>;
  supplement_records_aggregate?: InputMaybe<supplement_record_aggregate_order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
  user_supplements_aggregate?: InputMaybe<user_supplement_aggregate_order_by>;
};

/** order by aggregate values of table "supplement_product" */
export type supplement_product_aggregate_order_by = {
  count?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "supplement_product". All fields are combined with a logical 'AND'. */
export type supplement_product_bool_exp = {
  _and?: InputMaybe<Array<supplement_product_bool_exp>>;
  _not?: InputMaybe<supplement_product_bool_exp>;
  _or?: InputMaybe<Array<supplement_product_bool_exp>>;
  product?: InputMaybe<stripe_product_bool_exp>;
  supplement?: InputMaybe<supplement_bool_exp>;
};

/** order by aggregate values of table "supplement_record" */
export type supplement_record_aggregate_order_by = {
  avg?: InputMaybe<supplement_record_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<supplement_record_max_order_by>;
  min?: InputMaybe<supplement_record_min_order_by>;
  stddev?: InputMaybe<supplement_record_stddev_order_by>;
  stddev_pop?: InputMaybe<supplement_record_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<supplement_record_stddev_samp_order_by>;
  sum?: InputMaybe<supplement_record_sum_order_by>;
  var_pop?: InputMaybe<supplement_record_var_pop_order_by>;
  var_samp?: InputMaybe<supplement_record_var_samp_order_by>;
  variance?: InputMaybe<supplement_record_variance_order_by>;
};

/** order by avg() on columns of table "supplement_record" */
export type supplement_record_avg_order_by = {
  servings?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "supplement_record". All fields are combined with a logical 'AND'. */
export type supplement_record_bool_exp = {
  _and?: InputMaybe<Array<supplement_record_bool_exp>>;
  _not?: InputMaybe<supplement_record_bool_exp>;
  _or?: InputMaybe<Array<supplement_record_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  date?: InputMaybe<date_comparison_exp>;
  datetime?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  metric_record?: InputMaybe<metric_record_bool_exp>;
  metric_record_id?: InputMaybe<uuid_comparison_exp>;
  servings?: InputMaybe<numeric_comparison_exp>;
  supplement?: InputMaybe<supplement_bool_exp>;
  supplement_id?: InputMaybe<uuid_comparison_exp>;
  timeframe?: InputMaybe<enum_timeframe_enum_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "supplement_record" */
export type supplement_record_max_order_by = {
  created_at?: InputMaybe<order_by>;
  date?: InputMaybe<order_by>;
  datetime?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  metric_record_id?: InputMaybe<order_by>;
  servings?: InputMaybe<order_by>;
  supplement_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "supplement_record" */
export type supplement_record_min_order_by = {
  created_at?: InputMaybe<order_by>;
  date?: InputMaybe<order_by>;
  datetime?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  metric_record_id?: InputMaybe<order_by>;
  servings?: InputMaybe<order_by>;
  supplement_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by stddev() on columns of table "supplement_record" */
export type supplement_record_stddev_order_by = {
  servings?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "supplement_record" */
export type supplement_record_stddev_pop_order_by = {
  servings?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "supplement_record" */
export type supplement_record_stddev_samp_order_by = {
  servings?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "supplement_record" */
export type supplement_record_sum_order_by = {
  servings?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "supplement_record" */
export type supplement_record_var_pop_order_by = {
  servings?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "supplement_record" */
export type supplement_record_var_samp_order_by = {
  servings?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "supplement_record" */
export type supplement_record_variance_order_by = {
  servings?: InputMaybe<order_by>;
};

/** update columns of table "supplement" */
export enum supplement_update_column {
  /** column name */
  brand = 'brand',
  /** column name */
  name = 'name',
  /** column name */
  nutrition_label_image_url = 'nutrition_label_image_url',
  /** column name */
  product_image_url = 'product_image_url',
  /** column name */
  serving_size = 'serving_size'
}

/** input type for inserting array relation for remote table "tag" */
export type tag_arr_rel_insert_input = {
  data: Array<tag_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<tag_on_conflict>;
};

/** Boolean expression to filter rows from the table "tag". All fields are combined with a logical 'AND'. */
export type tag_bool_exp = {
  _and?: InputMaybe<Array<tag_bool_exp>>;
  _not?: InputMaybe<tag_bool_exp>;
  _or?: InputMaybe<Array<tag_bool_exp>>;
  category?: InputMaybe<enum_life_event_category_enum_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  datetime_local?: InputMaybe<timestamp_comparison_exp>;
  datetime_utc?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  life_event?: InputMaybe<life_event_bool_exp>;
  life_event_id?: InputMaybe<uuid_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "tag" */
export enum tag_constraint {
  /** unique or primary key constraint on columns "id" */
  tag_pkey = 'tag_pkey'
}

/** input type for inserting data into table "tag" */
export type tag_insert_input = {
  category?: InputMaybe<enum_life_event_category_enum>;
  datetime_local?: InputMaybe<Scalars['timestamp']['input']>;
  datetime_utc?: InputMaybe<Scalars['timestamptz']['input']>;
  life_event?: InputMaybe<life_event_obj_rel_insert_input>;
  life_event_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** on_conflict condition type for table "tag" */
export type tag_on_conflict = {
  constraint: tag_constraint;
  update_columns?: Array<tag_update_column>;
  where?: InputMaybe<tag_bool_exp>;
};

/** update columns of table "tag" */
export enum tag_update_column {
  /** column name */
  name = 'name'
}

/** Boolean expression to filter rows from the table "template_dashboard". All fields are combined with a logical 'AND'. */
export type template_dashboard_bool_exp = {
  _and?: InputMaybe<Array<template_dashboard_bool_exp>>;
  _not?: InputMaybe<template_dashboard_bool_exp>;
  _or?: InputMaybe<Array<template_dashboard_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  enabled_triggers?: InputMaybe<_text_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  image_url?: InputMaybe<String_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_versions?: InputMaybe<template_dashboard_user_bool_exp>;
  versions?: InputMaybe<template_dashboard_version_bool_exp>;
  visible?: InputMaybe<Boolean_comparison_exp>;
};

/** Boolean expression to filter rows from the table "template_dashboard_user". All fields are combined with a logical 'AND'. */
export type template_dashboard_user_bool_exp = {
  _and?: InputMaybe<Array<template_dashboard_user_bool_exp>>;
  _not?: InputMaybe<template_dashboard_user_bool_exp>;
  _or?: InputMaybe<Array<template_dashboard_user_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  template?: InputMaybe<template_dashboard_bool_exp>;
  template_dashboard_id?: InputMaybe<uuid_comparison_exp>;
  template_dashboard_version_id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
  version?: InputMaybe<template_dashboard_version_bool_exp>;
};

/** Boolean expression to filter rows from the table "template_dashboard_version". All fields are combined with a logical 'AND'. */
export type template_dashboard_version_bool_exp = {
  _and?: InputMaybe<Array<template_dashboard_version_bool_exp>>;
  _not?: InputMaybe<template_dashboard_version_bool_exp>;
  _or?: InputMaybe<Array<template_dashboard_version_bool_exp>>;
  active?: InputMaybe<Boolean_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  dashboard?: InputMaybe<dashboard_bool_exp>;
  dashboard_id?: InputMaybe<uuid_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  notes?: InputMaybe<String_comparison_exp>;
  template?: InputMaybe<template_dashboard_bool_exp>;
  template_dashboard_id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  users?: InputMaybe<template_dashboard_user_bool_exp>;
  version?: InputMaybe<Int_comparison_exp>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type timestamp_comparison_exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type timestamptz_comparison_exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** Boolean expression to filter rows from the table "tracked_metric". All fields are combined with a logical 'AND'. */
export type tracked_metric_bool_exp = {
  _and?: InputMaybe<Array<tracked_metric_bool_exp>>;
  _not?: InputMaybe<tracked_metric_bool_exp>;
  _or?: InputMaybe<Array<tracked_metric_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  metric?: InputMaybe<metric_bool_exp>;
  metric_id?: InputMaybe<uuid_comparison_exp>;
  sort_order?: InputMaybe<Int_comparison_exp>;
  tracked_metric_group?: InputMaybe<enum_tracked_metric_group_enum_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** input type for incrementing numeric columns in table "tracked_metric" */
export type tracked_metric_inc_input = {
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for updating data in table "tracked_metric" */
export type tracked_metric_set_input = {
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  tracked_metric_group?: InputMaybe<enum_tracked_metric_group_enum>;
};

export type tracked_metric_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<tracked_metric_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<tracked_metric_set_input>;
  /** filter the rows which have to be updated */
  where: tracked_metric_bool_exp;
};

/** Boolean expression to compare columns of type "tstzrange". All fields are combined with logical 'AND'. */
export type tstzrange_comparison_exp = {
  _eq?: InputMaybe<Scalars['tstzrange']['input']>;
  _gt?: InputMaybe<Scalars['tstzrange']['input']>;
  _gte?: InputMaybe<Scalars['tstzrange']['input']>;
  _in?: InputMaybe<Array<Scalars['tstzrange']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['tstzrange']['input']>;
  _lte?: InputMaybe<Scalars['tstzrange']['input']>;
  _neq?: InputMaybe<Scalars['tstzrange']['input']>;
  _nin?: InputMaybe<Array<Scalars['tstzrange']['input']>>;
};

/** order by aggregate values of table "unit_new" */
export type unit_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<unit_max_order_by>;
  min?: InputMaybe<unit_min_order_by>;
};

/** Boolean expression to filter rows from the table "unit_new". All fields are combined with a logical 'AND'. */
export type unit_bool_exp = {
  _and?: InputMaybe<Array<unit_bool_exp>>;
  _not?: InputMaybe<unit_bool_exp>;
  _or?: InputMaybe<Array<unit_bool_exp>>;
  alt_name?: InputMaybe<String_comparison_exp>;
  alt_name_plural?: InputMaybe<String_comparison_exp>;
  alt_symbol?: InputMaybe<String_comparison_exp>;
  alt_symbol_plural?: InputMaybe<String_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  display_name?: InputMaybe<String_comparison_exp>;
  display_name_plural?: InputMaybe<String_comparison_exp>;
  display_symbol?: InputMaybe<String_comparison_exp>;
  display_symbol_plural?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  name_plural?: InputMaybe<String_comparison_exp>;
  quantity?: InputMaybe<String_comparison_exp>;
  symbol?: InputMaybe<String_comparison_exp>;
  symbol_plural?: InputMaybe<String_comparison_exp>;
  synonyms?: InputMaybe<_text_comparison_exp>;
  to_unit_conversions?: InputMaybe<unit_conversion_bool_exp>;
  ucum_unit?: InputMaybe<String_comparison_exp>;
  unit_synonyms?: InputMaybe<unit_synonym_bool_exp>;
  unit_system?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by aggregate values of table "unit_conversion" */
export type unit_conversion_aggregate_order_by = {
  avg?: InputMaybe<unit_conversion_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<unit_conversion_max_order_by>;
  min?: InputMaybe<unit_conversion_min_order_by>;
  stddev?: InputMaybe<unit_conversion_stddev_order_by>;
  stddev_pop?: InputMaybe<unit_conversion_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<unit_conversion_stddev_samp_order_by>;
  sum?: InputMaybe<unit_conversion_sum_order_by>;
  var_pop?: InputMaybe<unit_conversion_var_pop_order_by>;
  var_samp?: InputMaybe<unit_conversion_var_samp_order_by>;
  variance?: InputMaybe<unit_conversion_variance_order_by>;
};

/** order by avg() on columns of table "unit_conversion" */
export type unit_conversion_avg_order_by = {
  from_offset?: InputMaybe<order_by>;
  scale?: InputMaybe<order_by>;
  to_offset?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "unit_conversion". All fields are combined with a logical 'AND'. */
export type unit_conversion_bool_exp = {
  _and?: InputMaybe<Array<unit_conversion_bool_exp>>;
  _not?: InputMaybe<unit_conversion_bool_exp>;
  _or?: InputMaybe<Array<unit_conversion_bool_exp>>;
  from_offset?: InputMaybe<numeric_comparison_exp>;
  from_unit?: InputMaybe<String_comparison_exp>;
  scale?: InputMaybe<Int_comparison_exp>;
  to_offset?: InputMaybe<numeric_comparison_exp>;
  to_unit?: InputMaybe<String_comparison_exp>;
  user_unit_preferences?: InputMaybe<user_unit_preference_bool_exp>;
  value?: InputMaybe<numeric_comparison_exp>;
};

/** order by max() on columns of table "unit_conversion" */
export type unit_conversion_max_order_by = {
  from_offset?: InputMaybe<order_by>;
  from_unit?: InputMaybe<order_by>;
  scale?: InputMaybe<order_by>;
  to_offset?: InputMaybe<order_by>;
  to_unit?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** order by min() on columns of table "unit_conversion" */
export type unit_conversion_min_order_by = {
  from_offset?: InputMaybe<order_by>;
  from_unit?: InputMaybe<order_by>;
  scale?: InputMaybe<order_by>;
  to_offset?: InputMaybe<order_by>;
  to_unit?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** order by stddev() on columns of table "unit_conversion" */
export type unit_conversion_stddev_order_by = {
  from_offset?: InputMaybe<order_by>;
  scale?: InputMaybe<order_by>;
  to_offset?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "unit_conversion" */
export type unit_conversion_stddev_pop_order_by = {
  from_offset?: InputMaybe<order_by>;
  scale?: InputMaybe<order_by>;
  to_offset?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "unit_conversion" */
export type unit_conversion_stddev_samp_order_by = {
  from_offset?: InputMaybe<order_by>;
  scale?: InputMaybe<order_by>;
  to_offset?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "unit_conversion" */
export type unit_conversion_sum_order_by = {
  from_offset?: InputMaybe<order_by>;
  scale?: InputMaybe<order_by>;
  to_offset?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "unit_conversion" */
export type unit_conversion_var_pop_order_by = {
  from_offset?: InputMaybe<order_by>;
  scale?: InputMaybe<order_by>;
  to_offset?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "unit_conversion" */
export type unit_conversion_var_samp_order_by = {
  from_offset?: InputMaybe<order_by>;
  scale?: InputMaybe<order_by>;
  to_offset?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "unit_conversion" */
export type unit_conversion_variance_order_by = {
  from_offset?: InputMaybe<order_by>;
  scale?: InputMaybe<order_by>;
  to_offset?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** order by max() on columns of table "unit_new" */
export type unit_max_order_by = {
  alt_name?: InputMaybe<order_by>;
  alt_name_plural?: InputMaybe<order_by>;
  alt_symbol?: InputMaybe<order_by>;
  alt_symbol_plural?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  display_name?: InputMaybe<order_by>;
  display_name_plural?: InputMaybe<order_by>;
  display_symbol?: InputMaybe<order_by>;
  display_symbol_plural?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  name_plural?: InputMaybe<order_by>;
  quantity?: InputMaybe<order_by>;
  symbol?: InputMaybe<order_by>;
  symbol_plural?: InputMaybe<order_by>;
  synonyms?: InputMaybe<order_by>;
  ucum_unit?: InputMaybe<order_by>;
  unit_system?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "unit_new" */
export type unit_min_order_by = {
  alt_name?: InputMaybe<order_by>;
  alt_name_plural?: InputMaybe<order_by>;
  alt_symbol?: InputMaybe<order_by>;
  alt_symbol_plural?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  display_name?: InputMaybe<order_by>;
  display_name_plural?: InputMaybe<order_by>;
  display_symbol?: InputMaybe<order_by>;
  display_symbol_plural?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  name_plural?: InputMaybe<order_by>;
  quantity?: InputMaybe<order_by>;
  symbol?: InputMaybe<order_by>;
  symbol_plural?: InputMaybe<order_by>;
  synonyms?: InputMaybe<order_by>;
  ucum_unit?: InputMaybe<order_by>;
  unit_system?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "unit_new". */
export type unit_order_by = {
  alt_name?: InputMaybe<order_by>;
  alt_name_plural?: InputMaybe<order_by>;
  alt_symbol?: InputMaybe<order_by>;
  alt_symbol_plural?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  display_name?: InputMaybe<order_by>;
  display_name_plural?: InputMaybe<order_by>;
  display_symbol?: InputMaybe<order_by>;
  display_symbol_plural?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  name_plural?: InputMaybe<order_by>;
  quantity?: InputMaybe<order_by>;
  symbol?: InputMaybe<order_by>;
  symbol_plural?: InputMaybe<order_by>;
  synonyms?: InputMaybe<order_by>;
  to_unit_conversions_aggregate?: InputMaybe<unit_conversion_aggregate_order_by>;
  ucum_unit?: InputMaybe<order_by>;
  unit_synonyms_aggregate?: InputMaybe<unit_synonym_aggregate_order_by>;
  unit_system?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by aggregate values of table "unit_synonym" */
export type unit_synonym_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<unit_synonym_max_order_by>;
  min?: InputMaybe<unit_synonym_min_order_by>;
};

/** Boolean expression to filter rows from the table "unit_synonym". All fields are combined with a logical 'AND'. */
export type unit_synonym_bool_exp = {
  _and?: InputMaybe<Array<unit_synonym_bool_exp>>;
  _not?: InputMaybe<unit_synonym_bool_exp>;
  _or?: InputMaybe<Array<unit_synonym_bool_exp>>;
  synonym?: InputMaybe<String_comparison_exp>;
  unit_id?: InputMaybe<uuid_comparison_exp>;
};

/** order by max() on columns of table "unit_synonym" */
export type unit_synonym_max_order_by = {
  synonym?: InputMaybe<order_by>;
  unit_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "unit_synonym" */
export type unit_synonym_min_order_by = {
  synonym?: InputMaybe<order_by>;
  unit_id?: InputMaybe<order_by>;
};

/** order by aggregate values of table "user_achievement" */
export type user_achievement_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<user_achievement_max_order_by>;
  min?: InputMaybe<user_achievement_min_order_by>;
};

/** Boolean expression to filter rows from the table "user_achievement". All fields are combined with a logical 'AND'. */
export type user_achievement_bool_exp = {
  _and?: InputMaybe<Array<user_achievement_bool_exp>>;
  _not?: InputMaybe<user_achievement_bool_exp>;
  _or?: InputMaybe<Array<user_achievement_bool_exp>>;
  achievement_id?: InputMaybe<String_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "user_achievement" */
export type user_achievement_max_order_by = {
  achievement_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "user_achievement" */
export type user_achievement_min_order_by = {
  achievement_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "user_address". All fields are combined with a logical 'AND'. */
export type user_address_bool_exp = {
  _and?: InputMaybe<Array<user_address_bool_exp>>;
  _not?: InputMaybe<user_address_bool_exp>;
  _or?: InputMaybe<Array<user_address_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  ship_to_address?: InputMaybe<String_comparison_exp>;
  ship_to_address1?: InputMaybe<String_comparison_exp>;
  ship_to_city?: InputMaybe<String_comparison_exp>;
  ship_to_country?: InputMaybe<String_comparison_exp>;
  ship_to_postal_code?: InputMaybe<String_comparison_exp>;
  ship_to_state?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "user_address". */
export type user_address_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  ship_to_address?: InputMaybe<order_by>;
  ship_to_address1?: InputMaybe<order_by>;
  ship_to_city?: InputMaybe<order_by>;
  ship_to_country?: InputMaybe<order_by>;
  ship_to_postal_code?: InputMaybe<order_by>;
  ship_to_state?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type user_bool_exp = {
  _and?: InputMaybe<Array<user_bool_exp>>;
  _not?: InputMaybe<user_bool_exp>;
  _or?: InputMaybe<Array<user_bool_exp>>;
  achievements?: InputMaybe<user_achievement_bool_exp>;
  action_items?: InputMaybe<action_item_user_bool_exp>;
  bridge_users?: InputMaybe<bridge_user_bool_exp>;
  circle_invites?: InputMaybe<circle_invite_bool_exp>;
  circle_memberships?: InputMaybe<circle_membership_bool_exp>;
  connected_devices?: InputMaybe<connected_device_user_bool_exp>;
  custom_action_items?: InputMaybe<action_item_bool_exp>;
  custom_metrics?: InputMaybe<metric_bool_exp>;
  dashboards?: InputMaybe<dashboard_bool_exp>;
  date_of_birth?: InputMaybe<date_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  email_notification_preferences?: InputMaybe<user_email_notification_type_preference_bool_exp>;
  email_verified?: InputMaybe<Boolean_comparison_exp>;
  experiment_metrics?: InputMaybe<experiment_metric_bool_exp>;
  experiments?: InputMaybe<experiment_bool_exp>;
  expert_access?: InputMaybe<expert_user_access_bool_exp>;
  feature_requests?: InputMaybe<user_feature_request_bool_exp>;
  file_vault_files?: InputMaybe<user_file_vault_bool_exp>;
  gender?: InputMaybe<_text_comparison_exp>;
  goals?: InputMaybe<user_goal_bool_exp>;
  has_accepted_tos?: InputMaybe<Boolean_comparison_exp>;
  home_tiles?: InputMaybe<user_home_tile_bool_exp>;
  id?: InputMaybe<String_comparison_exp>;
  integration_sync_events?: InputMaybe<integration_sync_event_bool_exp>;
  integration_sync_events_aggregate?: InputMaybe<integration_sync_event_aggregate_bool_exp>;
  lab_profiles?: InputMaybe<lab_profile_bool_exp>;
  lab_results?: InputMaybe<lab_result_bool_exp>;
  life_events?: InputMaybe<life_event_bool_exp>;
  membership_subscription?: InputMaybe<membership_subscription_bool_exp>;
  membership_tier?: InputMaybe<enum_membership_tier_enum_comparison_exp>;
  metric_explorer_selections?: InputMaybe<metric_explorer_selection_bool_exp>;
  metric_record_by_week?: InputMaybe<metric_record_by_week_bool_exp>;
  metric_record_by_week_aggregate?: InputMaybe<metric_record_by_week_aggregate_bool_exp>;
  metric_record_groups?: InputMaybe<metric_record_group_bool_exp>;
  metric_record_groups_aggregate?: InputMaybe<metric_record_group_aggregate_bool_exp>;
  metric_records?: InputMaybe<metric_record_bool_exp>;
  metric_records_aggregate?: InputMaybe<metric_record_aggregate_bool_exp>;
  metric_snapshots?: InputMaybe<metric_snapshot_bool_exp>;
  metric_targets?: InputMaybe<metric_target_bool_exp>;
  name?: InputMaybe<String_comparison_exp>;
  oauth2_tokens?: InputMaybe<oauth2_token_bool_exp>;
  onboarding_answers?: InputMaybe<jsonb_comparison_exp>;
  orders?: InputMaybe<stripe_order_bool_exp>;
  orders_aggregate?: InputMaybe<stripe_order_aggregate_bool_exp>;
  owned_circles?: InputMaybe<circle_bool_exp>;
  phone_number?: InputMaybe<String_comparison_exp>;
  phone_number_verified?: InputMaybe<Boolean_comparison_exp>;
  photo?: InputMaybe<String_comparison_exp>;
  profile?: InputMaybe<user_profile_bool_exp>;
  registration?: InputMaybe<user_registration_bool_exp>;
  sex?: InputMaybe<enum_sex_enum_comparison_exp>;
  stream_user_id?: InputMaybe<String_comparison_exp>;
  supplement_records?: InputMaybe<supplement_record_bool_exp>;
  supplements?: InputMaybe<supplement_bool_exp>;
  task_assignments?: InputMaybe<user_task_assignment_bool_exp>;
  timezone?: InputMaybe<String_comparison_exp>;
  timezone_history?: InputMaybe<user_timezone_history_bool_exp>;
  uploaded_photo_url?: InputMaybe<String_comparison_exp>;
  user_group_experts?: InputMaybe<user_group_expert_bool_exp>;
  user_group_members?: InputMaybe<user_group_member_bool_exp>;
  user_supplements?: InputMaybe<user_supplement_bool_exp>;
  user_supplements_aggregate?: InputMaybe<user_supplement_aggregate_bool_exp>;
  user_unit_preferences?: InputMaybe<user_unit_preference_bool_exp>;
  username?: InputMaybe<citext_comparison_exp>;
  vald_users?: InputMaybe<vald_user_bool_exp>;
  watched_metrics?: InputMaybe<watched_user_metric_bool_exp>;
};

/** order by aggregate values of table "user_email_notification_type_preference" */
export type user_email_notification_type_preference_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<user_email_notification_type_preference_max_order_by>;
  min?: InputMaybe<user_email_notification_type_preference_min_order_by>;
};

/** Boolean expression to filter rows from the table "user_email_notification_type_preference". All fields are combined with a logical 'AND'. */
export type user_email_notification_type_preference_bool_exp = {
  _and?: InputMaybe<Array<user_email_notification_type_preference_bool_exp>>;
  _not?: InputMaybe<user_email_notification_type_preference_bool_exp>;
  _or?: InputMaybe<Array<user_email_notification_type_preference_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  email_notification_type_id?: InputMaybe<uuid_comparison_exp>;
  frequency?: InputMaybe<enum_email_frequency_option_enum_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  notification_type?: InputMaybe<email_notification_type_bool_exp>;
  opt_out?: InputMaybe<Boolean_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "user_email_notification_type_preference" */
export type user_email_notification_type_preference_max_order_by = {
  created_at?: InputMaybe<order_by>;
  email_notification_type_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "user_email_notification_type_preference" */
export type user_email_notification_type_preference_min_order_by = {
  created_at?: InputMaybe<order_by>;
  email_notification_type_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by aggregate values of table "user_feature_request" */
export type user_feature_request_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<user_feature_request_max_order_by>;
  min?: InputMaybe<user_feature_request_min_order_by>;
};

/** Boolean expression to filter rows from the table "user_feature_request". All fields are combined with a logical 'AND'. */
export type user_feature_request_bool_exp = {
  _and?: InputMaybe<Array<user_feature_request_bool_exp>>;
  _not?: InputMaybe<user_feature_request_bool_exp>;
  _or?: InputMaybe<Array<user_feature_request_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  feature_request?: InputMaybe<feature_request_bool_exp>;
  feature_request_id?: InputMaybe<uuid_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "user_feature_request" */
export type user_feature_request_max_order_by = {
  created_at?: InputMaybe<order_by>;
  feature_request_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "user_feature_request" */
export type user_feature_request_min_order_by = {
  created_at?: InputMaybe<order_by>;
  feature_request_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by aggregate values of table "user_file_vault" */
export type user_file_vault_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<user_file_vault_max_order_by>;
  min?: InputMaybe<user_file_vault_min_order_by>;
};

/** Boolean expression to filter rows from the table "user_file_vault". All fields are combined with a logical 'AND'. */
export type user_file_vault_bool_exp = {
  _and?: InputMaybe<Array<user_file_vault_bool_exp>>;
  _not?: InputMaybe<user_file_vault_bool_exp>;
  _or?: InputMaybe<Array<user_file_vault_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  file_type?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  s3_bucket?: InputMaybe<String_comparison_exp>;
  s3_path?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "user_file_vault" */
export type user_file_vault_max_order_by = {
  created_at?: InputMaybe<order_by>;
  file_type?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  s3_bucket?: InputMaybe<order_by>;
  s3_path?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "user_file_vault" */
export type user_file_vault_min_order_by = {
  created_at?: InputMaybe<order_by>;
  file_type?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  s3_bucket?: InputMaybe<order_by>;
  s3_path?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "user_file_vault". */
export type user_file_vault_order_by = {
  created_at?: InputMaybe<order_by>;
  file_type?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  s3_bucket?: InputMaybe<order_by>;
  s3_path?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by aggregate values of table "user_goal" */
export type user_goal_aggregate_order_by = {
  avg?: InputMaybe<user_goal_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<user_goal_max_order_by>;
  min?: InputMaybe<user_goal_min_order_by>;
  stddev?: InputMaybe<user_goal_stddev_order_by>;
  stddev_pop?: InputMaybe<user_goal_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<user_goal_stddev_samp_order_by>;
  sum?: InputMaybe<user_goal_sum_order_by>;
  var_pop?: InputMaybe<user_goal_var_pop_order_by>;
  var_samp?: InputMaybe<user_goal_var_samp_order_by>;
  variance?: InputMaybe<user_goal_variance_order_by>;
};

/** order by avg() on columns of table "user_goal" */
export type user_goal_avg_order_by = {
  priority?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "user_goal". All fields are combined with a logical 'AND'. */
export type user_goal_bool_exp = {
  _and?: InputMaybe<Array<user_goal_bool_exp>>;
  _not?: InputMaybe<user_goal_bool_exp>;
  _or?: InputMaybe<Array<user_goal_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  goal?: InputMaybe<goal_bool_exp>;
  goal_id?: InputMaybe<uuid_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  priority?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_guidance_impact_items?: InputMaybe<user_guidance_impact_item_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "user_goal" */
export type user_goal_max_order_by = {
  created_at?: InputMaybe<order_by>;
  goal_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  priority?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "user_goal" */
export type user_goal_min_order_by = {
  created_at?: InputMaybe<order_by>;
  goal_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  priority?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by stddev() on columns of table "user_goal" */
export type user_goal_stddev_order_by = {
  priority?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "user_goal" */
export type user_goal_stddev_pop_order_by = {
  priority?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "user_goal" */
export type user_goal_stddev_samp_order_by = {
  priority?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "user_goal" */
export type user_goal_sum_order_by = {
  priority?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "user_goal" */
export type user_goal_var_pop_order_by = {
  priority?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "user_goal" */
export type user_goal_var_samp_order_by = {
  priority?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "user_goal" */
export type user_goal_variance_order_by = {
  priority?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "user_group". All fields are combined with a logical 'AND'. */
export type user_group_bool_exp = {
  _and?: InputMaybe<Array<user_group_bool_exp>>;
  _not?: InputMaybe<user_group_bool_exp>;
  _or?: InputMaybe<Array<user_group_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  experts?: InputMaybe<user_group_expert_bool_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  members?: InputMaybe<user_group_member_bool_exp>;
  name?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by aggregate values of table "user_group_expert" */
export type user_group_expert_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<user_group_expert_max_order_by>;
  min?: InputMaybe<user_group_expert_min_order_by>;
};

/** Boolean expression to filter rows from the table "user_group_expert". All fields are combined with a logical 'AND'. */
export type user_group_expert_bool_exp = {
  _and?: InputMaybe<Array<user_group_expert_bool_exp>>;
  _not?: InputMaybe<user_group_expert_bool_exp>;
  _or?: InputMaybe<Array<user_group_expert_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_group?: InputMaybe<user_group_bool_exp>;
  user_group_id?: InputMaybe<uuid_comparison_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "user_group_expert" */
export type user_group_expert_max_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_group_id?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "user_group_expert" */
export type user_group_expert_min_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_group_id?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by aggregate values of table "user_group_member" */
export type user_group_member_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<user_group_member_max_order_by>;
  min?: InputMaybe<user_group_member_min_order_by>;
};

/** Boolean expression to filter rows from the table "user_group_member". All fields are combined with a logical 'AND'. */
export type user_group_member_bool_exp = {
  _and?: InputMaybe<Array<user_group_member_bool_exp>>;
  _not?: InputMaybe<user_group_member_bool_exp>;
  _or?: InputMaybe<Array<user_group_member_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_group?: InputMaybe<user_group_bool_exp>;
  user_group_id?: InputMaybe<uuid_comparison_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "user_group_member" */
export type user_group_member_max_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_group_id?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "user_group_member" */
export type user_group_member_min_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_group_id?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "user_guidance_impact_item". All fields are combined with a logical 'AND'. */
export type user_guidance_impact_item_bool_exp = {
  _and?: InputMaybe<Array<user_guidance_impact_item_bool_exp>>;
  _not?: InputMaybe<user_guidance_impact_item_bool_exp>;
  _or?: InputMaybe<Array<user_guidance_impact_item_bool_exp>>;
  guidance_impact_item_id?: InputMaybe<uuid_comparison_exp>;
  metric_snapshot_item?: InputMaybe<metric_snapshot_item_bool_exp>;
  metric_snapshot_item_id?: InputMaybe<uuid_comparison_exp>;
  user_goal?: InputMaybe<user_goal_bool_exp>;
  user_goal_id?: InputMaybe<uuid_comparison_exp>;
  user_guidance_item?: InputMaybe<user_guidance_item_bool_exp>;
  user_guidance_item_id?: InputMaybe<uuid_comparison_exp>;
};

/** Boolean expression to filter rows from the table "user_guidance_item". All fields are combined with a logical 'AND'. */
export type user_guidance_item_bool_exp = {
  _and?: InputMaybe<Array<user_guidance_item_bool_exp>>;
  _not?: InputMaybe<user_guidance_item_bool_exp>;
  _or?: InputMaybe<Array<user_guidance_item_bool_exp>>;
  action_item_config_id?: InputMaybe<uuid_comparison_exp>;
  guidance_custom_item_id?: InputMaybe<uuid_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  impact_items?: InputMaybe<user_guidance_impact_item_bool_exp>;
  impact_total?: InputMaybe<Int_comparison_exp>;
  meta?: InputMaybe<jsonb_comparison_exp>;
  priority?: InputMaybe<Int_comparison_exp>;
  supplement_id?: InputMaybe<uuid_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
  user_guidance_id?: InputMaybe<uuid_comparison_exp>;
};

/** order by aggregate values of table "user_home_tile" */
export type user_home_tile_aggregate_order_by = {
  avg?: InputMaybe<user_home_tile_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<user_home_tile_max_order_by>;
  min?: InputMaybe<user_home_tile_min_order_by>;
  stddev?: InputMaybe<user_home_tile_stddev_order_by>;
  stddev_pop?: InputMaybe<user_home_tile_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<user_home_tile_stddev_samp_order_by>;
  sum?: InputMaybe<user_home_tile_sum_order_by>;
  var_pop?: InputMaybe<user_home_tile_var_pop_order_by>;
  var_samp?: InputMaybe<user_home_tile_var_samp_order_by>;
  variance?: InputMaybe<user_home_tile_variance_order_by>;
};

/** order by avg() on columns of table "user_home_tile" */
export type user_home_tile_avg_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "user_home_tile". All fields are combined with a logical 'AND'. */
export type user_home_tile_bool_exp = {
  _and?: InputMaybe<Array<user_home_tile_bool_exp>>;
  _not?: InputMaybe<user_home_tile_bool_exp>;
  _or?: InputMaybe<Array<user_home_tile_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  home_tile?: InputMaybe<home_tile_bool_exp>;
  home_tile_id?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  sort_order?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** input type for incrementing numeric columns in table "user_home_tile" */
export type user_home_tile_inc_input = {
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_home_tile" */
export type user_home_tile_insert_input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  home_tile_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "user_home_tile" */
export type user_home_tile_max_order_by = {
  created_at?: InputMaybe<order_by>;
  home_tile_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "user_home_tile" */
export type user_home_tile_min_order_by = {
  created_at?: InputMaybe<order_by>;
  home_tile_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** input type for updating data in table "user_home_tile" */
export type user_home_tile_set_input = {
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** order by stddev() on columns of table "user_home_tile" */
export type user_home_tile_stddev_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "user_home_tile" */
export type user_home_tile_stddev_pop_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "user_home_tile" */
export type user_home_tile_stddev_samp_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "user_home_tile" */
export type user_home_tile_sum_order_by = {
  sort_order?: InputMaybe<order_by>;
};

export type user_home_tile_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<user_home_tile_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<user_home_tile_set_input>;
  /** filter the rows which have to be updated */
  where: user_home_tile_bool_exp;
};

/** order by var_pop() on columns of table "user_home_tile" */
export type user_home_tile_var_pop_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "user_home_tile" */
export type user_home_tile_var_samp_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "user_home_tile" */
export type user_home_tile_variance_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "user". */
export type user_order_by = {
  achievements_aggregate?: InputMaybe<user_achievement_aggregate_order_by>;
  action_items_aggregate?: InputMaybe<action_item_user_aggregate_order_by>;
  bridge_users_aggregate?: InputMaybe<bridge_user_aggregate_order_by>;
  circle_invites_aggregate?: InputMaybe<circle_invite_aggregate_order_by>;
  circle_memberships_aggregate?: InputMaybe<circle_membership_aggregate_order_by>;
  connected_devices_aggregate?: InputMaybe<connected_device_user_aggregate_order_by>;
  custom_action_items_aggregate?: InputMaybe<action_item_aggregate_order_by>;
  custom_metrics_aggregate?: InputMaybe<metric_aggregate_order_by>;
  dashboards_aggregate?: InputMaybe<dashboard_aggregate_order_by>;
  date_of_birth?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  email_notification_preferences_aggregate?: InputMaybe<user_email_notification_type_preference_aggregate_order_by>;
  email_verified?: InputMaybe<order_by>;
  experiment_metrics_aggregate?: InputMaybe<experiment_metric_aggregate_order_by>;
  experiments_aggregate?: InputMaybe<experiment_aggregate_order_by>;
  expert_access_aggregate?: InputMaybe<expert_user_access_aggregate_order_by>;
  feature_requests_aggregate?: InputMaybe<user_feature_request_aggregate_order_by>;
  file_vault_files_aggregate?: InputMaybe<user_file_vault_aggregate_order_by>;
  gender?: InputMaybe<order_by>;
  goals_aggregate?: InputMaybe<user_goal_aggregate_order_by>;
  has_accepted_tos?: InputMaybe<order_by>;
  home_tiles_aggregate?: InputMaybe<user_home_tile_aggregate_order_by>;
  id?: InputMaybe<order_by>;
  integration_sync_events_aggregate?: InputMaybe<integration_sync_event_aggregate_order_by>;
  lab_profiles_aggregate?: InputMaybe<lab_profile_aggregate_order_by>;
  lab_results_aggregate?: InputMaybe<lab_result_aggregate_order_by>;
  life_events_aggregate?: InputMaybe<life_event_aggregate_order_by>;
  membership_subscription_aggregate?: InputMaybe<membership_subscription_aggregate_order_by>;
  membership_tier?: InputMaybe<order_by>;
  metric_explorer_selections_aggregate?: InputMaybe<metric_explorer_selection_aggregate_order_by>;
  metric_record_by_week_aggregate?: InputMaybe<metric_record_by_week_aggregate_order_by>;
  metric_record_groups_aggregate?: InputMaybe<metric_record_group_aggregate_order_by>;
  metric_records_aggregate?: InputMaybe<metric_record_aggregate_order_by>;
  metric_snapshots_aggregate?: InputMaybe<metric_snapshot_aggregate_order_by>;
  metric_targets_aggregate?: InputMaybe<metric_target_aggregate_order_by>;
  name?: InputMaybe<order_by>;
  oauth2_tokens_aggregate?: InputMaybe<oauth2_token_aggregate_order_by>;
  onboarding_answers?: InputMaybe<order_by>;
  orders_aggregate?: InputMaybe<stripe_order_aggregate_order_by>;
  owned_circles_aggregate?: InputMaybe<circle_aggregate_order_by>;
  phone_number?: InputMaybe<order_by>;
  phone_number_verified?: InputMaybe<order_by>;
  photo?: InputMaybe<order_by>;
  profile?: InputMaybe<user_profile_order_by>;
  registration?: InputMaybe<user_registration_order_by>;
  sex?: InputMaybe<order_by>;
  stream_user_id?: InputMaybe<order_by>;
  supplement_records_aggregate?: InputMaybe<supplement_record_aggregate_order_by>;
  supplements_aggregate?: InputMaybe<supplement_aggregate_order_by>;
  task_assignments_aggregate?: InputMaybe<user_task_assignment_aggregate_order_by>;
  timezone?: InputMaybe<order_by>;
  timezone_history_aggregate?: InputMaybe<user_timezone_history_aggregate_order_by>;
  uploaded_photo_url?: InputMaybe<order_by>;
  user_group_experts_aggregate?: InputMaybe<user_group_expert_aggregate_order_by>;
  user_group_members_aggregate?: InputMaybe<user_group_member_aggregate_order_by>;
  user_supplements_aggregate?: InputMaybe<user_supplement_aggregate_order_by>;
  user_unit_preferences_aggregate?: InputMaybe<user_unit_preference_aggregate_order_by>;
  username?: InputMaybe<order_by>;
  vald_users_aggregate?: InputMaybe<vald_user_aggregate_order_by>;
  watched_metrics_aggregate?: InputMaybe<watched_user_metric_aggregate_order_by>;
};

/** Boolean expression to filter rows from the table "user_profile". All fields are combined with a logical 'AND'. */
export type user_profile_bool_exp = {
  _and?: InputMaybe<Array<user_profile_bool_exp>>;
  _not?: InputMaybe<user_profile_bool_exp>;
  _or?: InputMaybe<Array<user_profile_bool_exp>>;
  achievements?: InputMaybe<user_achievement_bool_exp>;
  photo_url?: InputMaybe<String_comparison_exp>;
  stream_user_id?: InputMaybe<String_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  username?: InputMaybe<citext_comparison_exp>;
};

/** Ordering options when selecting data from "user_profile". */
export type user_profile_order_by = {
  achievements_aggregate?: InputMaybe<user_achievement_aggregate_order_by>;
  photo_url?: InputMaybe<order_by>;
  stream_user_id?: InputMaybe<order_by>;
  user?: InputMaybe<user_order_by>;
  username?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "user_registration". All fields are combined with a logical 'AND'. */
export type user_registration_bool_exp = {
  _and?: InputMaybe<Array<user_registration_bool_exp>>;
  _not?: InputMaybe<user_registration_bool_exp>;
  _or?: InputMaybe<Array<user_registration_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  login_request_id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
};

/** Ordering options when selecting data from "user_registration". */
export type user_registration_order_by = {
  created_at?: InputMaybe<order_by>;
  login_request_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user?: InputMaybe<user_order_by>;
};

export type user_supplement_aggregate_bool_exp = {
  bool_and?: InputMaybe<user_supplement_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<user_supplement_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<user_supplement_aggregate_bool_exp_count>;
};

export type user_supplement_aggregate_bool_exp_bool_and = {
  arguments: user_supplement_select_column_user_supplement_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<user_supplement_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type user_supplement_aggregate_bool_exp_bool_or = {
  arguments: user_supplement_select_column_user_supplement_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<user_supplement_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type user_supplement_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<user_supplement_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<user_supplement_bool_exp>;
  predicate: Int_comparison_exp;
};

/** order by aggregate values of table "user_supplement" */
export type user_supplement_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<user_supplement_max_order_by>;
  min?: InputMaybe<user_supplement_min_order_by>;
};

/** input type for inserting array relation for remote table "user_supplement" */
export type user_supplement_arr_rel_insert_input = {
  data: Array<user_supplement_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<user_supplement_on_conflict>;
};

/** Boolean expression to filter rows from the table "user_supplement". All fields are combined with a logical 'AND'. */
export type user_supplement_bool_exp = {
  _and?: InputMaybe<Array<user_supplement_bool_exp>>;
  _not?: InputMaybe<user_supplement_bool_exp>;
  _or?: InputMaybe<Array<user_supplement_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  disabled?: InputMaybe<Boolean_comparison_exp>;
  supplement?: InputMaybe<supplement_bool_exp>;
  supplement_id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "user_supplement" */
export enum user_supplement_constraint {
  /** unique or primary key constraint on columns "user_id", "supplement_id" */
  user_supplement_pkey = 'user_supplement_pkey'
}

/** input type for inserting data into table "user_supplement" */
export type user_supplement_insert_input = {
  supplement?: InputMaybe<supplement_obj_rel_insert_input>;
  supplement_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "user_supplement" */
export type user_supplement_max_order_by = {
  created_at?: InputMaybe<order_by>;
  supplement_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "user_supplement" */
export type user_supplement_min_order_by = {
  created_at?: InputMaybe<order_by>;
  supplement_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "user_supplement" */
export type user_supplement_on_conflict = {
  constraint: user_supplement_constraint;
  update_columns?: Array<user_supplement_update_column>;
  where?: InputMaybe<user_supplement_bool_exp>;
};

/** select columns of table "user_supplement" */
export enum user_supplement_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  disabled = 'disabled',
  /** column name */
  supplement_id = 'supplement_id',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  user_id = 'user_id'
}

/** select "user_supplement_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_supplement" */
export enum user_supplement_select_column_user_supplement_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  disabled = 'disabled'
}

/** select "user_supplement_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_supplement" */
export enum user_supplement_select_column_user_supplement_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  disabled = 'disabled'
}

/** placeholder for update columns of table "user_supplement" (current role has no relevant permissions) */
export enum user_supplement_update_column {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** order by aggregate values of table "user_task_assignment" */
export type user_task_assignment_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<user_task_assignment_max_order_by>;
  min?: InputMaybe<user_task_assignment_min_order_by>;
};

/** Boolean expression to filter rows from the table "user_task_assignment". All fields are combined with a logical 'AND'. */
export type user_task_assignment_bool_exp = {
  _and?: InputMaybe<Array<user_task_assignment_bool_exp>>;
  _not?: InputMaybe<user_task_assignment_bool_exp>;
  _or?: InputMaybe<Array<user_task_assignment_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  details?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  is_completed?: InputMaybe<Boolean_comparison_exp>;
  is_dismissed?: InputMaybe<Boolean_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  task?: InputMaybe<user_task_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
  user_task_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "user_task_assignment" */
export type user_task_assignment_max_order_by = {
  created_at?: InputMaybe<order_by>;
  details?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
  user_task_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "user_task_assignment" */
export type user_task_assignment_min_order_by = {
  created_at?: InputMaybe<order_by>;
  details?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
  user_task_id?: InputMaybe<order_by>;
};

/** input type for updating data in table "user_task_assignment" */
export type user_task_assignment_set_input = {
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  is_dismissed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_task". All fields are combined with a logical 'AND'. */
export type user_task_bool_exp = {
  _and?: InputMaybe<Array<user_task_bool_exp>>;
  _not?: InputMaybe<user_task_bool_exp>;
  _or?: InputMaybe<Array<user_task_bool_exp>>;
  details?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<String_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  user_task_assignments?: InputMaybe<user_task_assignment_bool_exp>;
};

/** order by aggregate values of table "user_timezone_history" */
export type user_timezone_history_aggregate_order_by = {
  avg?: InputMaybe<user_timezone_history_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<user_timezone_history_max_order_by>;
  min?: InputMaybe<user_timezone_history_min_order_by>;
  stddev?: InputMaybe<user_timezone_history_stddev_order_by>;
  stddev_pop?: InputMaybe<user_timezone_history_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<user_timezone_history_stddev_samp_order_by>;
  sum?: InputMaybe<user_timezone_history_sum_order_by>;
  var_pop?: InputMaybe<user_timezone_history_var_pop_order_by>;
  var_samp?: InputMaybe<user_timezone_history_var_samp_order_by>;
  variance?: InputMaybe<user_timezone_history_variance_order_by>;
};

/** order by avg() on columns of table "user_timezone_history" */
export type user_timezone_history_avg_order_by = {
  id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "user_timezone_history". All fields are combined with a logical 'AND'. */
export type user_timezone_history_bool_exp = {
  _and?: InputMaybe<Array<user_timezone_history_bool_exp>>;
  _not?: InputMaybe<user_timezone_history_bool_exp>;
  _or?: InputMaybe<Array<user_timezone_history_bool_exp>>;
  active_range?: InputMaybe<tstzrange_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  timezone?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "user_timezone_history" */
export type user_timezone_history_max_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  timezone?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "user_timezone_history" */
export type user_timezone_history_min_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  timezone?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by stddev() on columns of table "user_timezone_history" */
export type user_timezone_history_stddev_order_by = {
  id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "user_timezone_history" */
export type user_timezone_history_stddev_pop_order_by = {
  id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "user_timezone_history" */
export type user_timezone_history_stddev_samp_order_by = {
  id?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "user_timezone_history" */
export type user_timezone_history_sum_order_by = {
  id?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "user_timezone_history" */
export type user_timezone_history_var_pop_order_by = {
  id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "user_timezone_history" */
export type user_timezone_history_var_samp_order_by = {
  id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "user_timezone_history" */
export type user_timezone_history_variance_order_by = {
  id?: InputMaybe<order_by>;
};

/** order by aggregate values of table "user_unit_preference" */
export type user_unit_preference_aggregate_order_by = {
  count?: InputMaybe<order_by>;
  max?: InputMaybe<user_unit_preference_max_order_by>;
  min?: InputMaybe<user_unit_preference_min_order_by>;
};

/** input type for inserting array relation for remote table "user_unit_preference" */
export type user_unit_preference_arr_rel_insert_input = {
  data: Array<user_unit_preference_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<user_unit_preference_on_conflict>;
};

/** Boolean expression to filter rows from the table "user_unit_preference". All fields are combined with a logical 'AND'. */
export type user_unit_preference_bool_exp = {
  _and?: InputMaybe<Array<user_unit_preference_bool_exp>>;
  _not?: InputMaybe<user_unit_preference_bool_exp>;
  _or?: InputMaybe<Array<user_unit_preference_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  from_unit?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  metric?: InputMaybe<metric_bool_exp>;
  metric_id?: InputMaybe<uuid_comparison_exp>;
  to_unit?: InputMaybe<String_comparison_exp>;
  unit_conversion?: InputMaybe<unit_conversion_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "user_unit_preference" */
export enum user_unit_preference_constraint {
  /** unique or primary key constraint on columns "from_unit" */
  user_unit_preference_from_unit_idx = 'user_unit_preference_from_unit_idx',
  /** unique or primary key constraint on columns "metric_id" */
  user_unit_preference_metric_id_idx = 'user_unit_preference_metric_id_idx',
  /** unique or primary key constraint on columns "metric_id", "user_id" */
  user_unit_preference_metric_id_user_id_idx = 'user_unit_preference_metric_id_user_id_idx',
  /** unique or primary key constraint on columns "id" */
  user_unit_preference_pkey = 'user_unit_preference_pkey',
  /** unique or primary key constraint on columns "user_id", "from_unit" */
  user_unit_preference_user_id_from_unit_idx = 'user_unit_preference_user_id_from_unit_idx'
}

/** input type for inserting data into table "user_unit_preference" */
export type user_unit_preference_insert_input = {
  from_unit?: InputMaybe<Scalars['String']['input']>;
  metric?: InputMaybe<metric_obj_rel_insert_input>;
  metric_id?: InputMaybe<Scalars['uuid']['input']>;
  to_unit?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "user_unit_preference" */
export type user_unit_preference_max_order_by = {
  created_at?: InputMaybe<order_by>;
  from_unit?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  to_unit?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "user_unit_preference" */
export type user_unit_preference_min_order_by = {
  created_at?: InputMaybe<order_by>;
  from_unit?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  to_unit?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "user_unit_preference" */
export type user_unit_preference_on_conflict = {
  constraint: user_unit_preference_constraint;
  update_columns?: Array<user_unit_preference_update_column>;
  where?: InputMaybe<user_unit_preference_bool_exp>;
};

/** update columns of table "user_unit_preference" */
export enum user_unit_preference_update_column {
  /** column name */
  from_unit = 'from_unit',
  /** column name */
  metric_id = 'metric_id',
  /** column name */
  to_unit = 'to_unit'
}

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type uuid_comparison_exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** order by aggregate values of table "vald_user" */
export type vald_user_aggregate_order_by = {
  avg?: InputMaybe<vald_user_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<vald_user_max_order_by>;
  min?: InputMaybe<vald_user_min_order_by>;
  stddev?: InputMaybe<vald_user_stddev_order_by>;
  stddev_pop?: InputMaybe<vald_user_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<vald_user_stddev_samp_order_by>;
  sum?: InputMaybe<vald_user_sum_order_by>;
  var_pop?: InputMaybe<vald_user_var_pop_order_by>;
  var_samp?: InputMaybe<vald_user_var_samp_order_by>;
  variance?: InputMaybe<vald_user_variance_order_by>;
};

/** order by avg() on columns of table "vald_user" */
export type vald_user_avg_order_by = {
  vald_legacy_team_id?: InputMaybe<order_by>;
  vald_legacy_user_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "vald_user". All fields are combined with a logical 'AND'. */
export type vald_user_bool_exp = {
  _and?: InputMaybe<Array<vald_user_bool_exp>>;
  _not?: InputMaybe<vald_user_bool_exp>;
  _or?: InputMaybe<Array<vald_user_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
  vald_legacy_team_id?: InputMaybe<Int_comparison_exp>;
  vald_legacy_user_id?: InputMaybe<Int_comparison_exp>;
  vald_team_id?: InputMaybe<String_comparison_exp>;
  vald_user_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "vald_user" */
export type vald_user_max_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
  vald_legacy_team_id?: InputMaybe<order_by>;
  vald_legacy_user_id?: InputMaybe<order_by>;
  vald_team_id?: InputMaybe<order_by>;
  vald_user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "vald_user" */
export type vald_user_min_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
  vald_legacy_team_id?: InputMaybe<order_by>;
  vald_legacy_user_id?: InputMaybe<order_by>;
  vald_team_id?: InputMaybe<order_by>;
  vald_user_id?: InputMaybe<order_by>;
};

/** order by stddev() on columns of table "vald_user" */
export type vald_user_stddev_order_by = {
  vald_legacy_team_id?: InputMaybe<order_by>;
  vald_legacy_user_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "vald_user" */
export type vald_user_stddev_pop_order_by = {
  vald_legacy_team_id?: InputMaybe<order_by>;
  vald_legacy_user_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "vald_user" */
export type vald_user_stddev_samp_order_by = {
  vald_legacy_team_id?: InputMaybe<order_by>;
  vald_legacy_user_id?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "vald_user" */
export type vald_user_sum_order_by = {
  vald_legacy_team_id?: InputMaybe<order_by>;
  vald_legacy_user_id?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "vald_user" */
export type vald_user_var_pop_order_by = {
  vald_legacy_team_id?: InputMaybe<order_by>;
  vald_legacy_user_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "vald_user" */
export type vald_user_var_samp_order_by = {
  vald_legacy_team_id?: InputMaybe<order_by>;
  vald_legacy_user_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "vald_user" */
export type vald_user_variance_order_by = {
  vald_legacy_team_id?: InputMaybe<order_by>;
  vald_legacy_user_id?: InputMaybe<order_by>;
};

/** order by aggregate values of table "watched_user_metric" */
export type watched_user_metric_aggregate_order_by = {
  avg?: InputMaybe<watched_user_metric_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<watched_user_metric_max_order_by>;
  min?: InputMaybe<watched_user_metric_min_order_by>;
  stddev?: InputMaybe<watched_user_metric_stddev_order_by>;
  stddev_pop?: InputMaybe<watched_user_metric_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<watched_user_metric_stddev_samp_order_by>;
  sum?: InputMaybe<watched_user_metric_sum_order_by>;
  var_pop?: InputMaybe<watched_user_metric_var_pop_order_by>;
  var_samp?: InputMaybe<watched_user_metric_var_samp_order_by>;
  variance?: InputMaybe<watched_user_metric_variance_order_by>;
};

/** input type for inserting array relation for remote table "watched_user_metric" */
export type watched_user_metric_arr_rel_insert_input = {
  data: Array<watched_user_metric_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<watched_user_metric_on_conflict>;
};

/** order by avg() on columns of table "watched_user_metric" */
export type watched_user_metric_avg_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "watched_user_metric". All fields are combined with a logical 'AND'. */
export type watched_user_metric_bool_exp = {
  _and?: InputMaybe<Array<watched_user_metric_bool_exp>>;
  _not?: InputMaybe<watched_user_metric_bool_exp>;
  _or?: InputMaybe<Array<watched_user_metric_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  metric?: InputMaybe<metric_bool_exp>;
  metric_id?: InputMaybe<uuid_comparison_exp>;
  sort_order?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "watched_user_metric" */
export enum watched_user_metric_constraint {
  /** unique or primary key constraint on columns "metric_id", "user_id" */
  watched_user_metric_pkey = 'watched_user_metric_pkey'
}

/** input type for inserting data into table "watched_user_metric" */
export type watched_user_metric_insert_input = {
  metric?: InputMaybe<metric_obj_rel_insert_input>;
  metric_id?: InputMaybe<Scalars['uuid']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** order by max() on columns of table "watched_user_metric" */
export type watched_user_metric_max_order_by = {
  created_at?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "watched_user_metric" */
export type watched_user_metric_min_order_by = {
  created_at?: InputMaybe<order_by>;
  metric_id?: InputMaybe<order_by>;
  sort_order?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** on_conflict condition type for table "watched_user_metric" */
export type watched_user_metric_on_conflict = {
  constraint: watched_user_metric_constraint;
  update_columns?: Array<watched_user_metric_update_column>;
  where?: InputMaybe<watched_user_metric_bool_exp>;
};

/** order by stddev() on columns of table "watched_user_metric" */
export type watched_user_metric_stddev_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "watched_user_metric" */
export type watched_user_metric_stddev_pop_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "watched_user_metric" */
export type watched_user_metric_stddev_samp_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** order by sum() on columns of table "watched_user_metric" */
export type watched_user_metric_sum_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** update columns of table "watched_user_metric" */
export enum watched_user_metric_update_column {
  /** column name */
  sort_order = 'sort_order'
}

/** order by var_pop() on columns of table "watched_user_metric" */
export type watched_user_metric_var_pop_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "watched_user_metric" */
export type watched_user_metric_var_samp_order_by = {
  sort_order?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "watched_user_metric" */
export type watched_user_metric_variance_order_by = {
  sort_order?: InputMaybe<order_by>;
};

export type ProductMetadataBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type ProductMetadataBySlugQuery = {
  __typename?: 'query_root',
  product_catalog: Array<{
    __typename?: 'stripe_product',
    name: string,
    content?: {
      __typename?: 'cms_StripeProductEntityResponse_content',
      data?: {
        __typename?: 'cms_StripeProductEntity_content',
        attributes?: {
          __typename?: 'cms_StripeProduct_content',
          description?: string,
          summary?: string
        }
      }
    }
  }>,
  cms?: {
    __typename?: 'cmsQuery',
    productTypeDefaultImage?: {
      __typename?: 'cms_ProductTypeDefaultImageEntityResponse_content',
      data?: {
        __typename?: 'cms_ProductTypeDefaultImageEntity_content',
        attributes?: {
          __typename?: 'cms_ProductTypeDefaultImage_content',
          PACKAGE?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                url: string
              }
            }
          },
          SUPPLEMENT?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                url: string
              }
            }
          }
        }
      }
    }
  }
};

export type ProductIdAndTypeBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  countryAvailability: Scalars['_text']['input'];
}>;


export type ProductIdAndTypeBySlugQuery = {
  __typename?: 'query_root',
  product_catalog: Array<{
    __typename?: 'stripe_product',
    id: string,
    product_type: enum_stripe_product_type_enum,
    name: string
  }>
};

export type TosQueryVariables = Exact<{ [key: string]: never; }>;


export type TosQuery = {
  __typename?: 'query_root',
  terms_of_service: {
    __typename?: 'TermsOfServiceVersion',
    content: string
  }
};

export type DeleteMetricRecordBatchByMetricIdsAndExternalIdMutationVariables = Exact<{
  metricIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  externalId: Scalars['String']['input'];
}>;


export type DeleteMetricRecordBatchByMetricIdsAndExternalIdMutation = {
  __typename?: 'mutation_root',
  delete_metric_record?: {
    __typename?: 'metric_record_mutation_response',
    affected_rows: number,
    returning: Array<{
      __typename?: 'metric_record',
      external_id?: string,
      id: string
    }>
  }
};

export type DeleteMetricRecordByMetricIdAndExternalIdMutationVariables = Exact<{
  metricId: Scalars['uuid']['input'];
  externalId: Scalars['String']['input'];
}>;


export type DeleteMetricRecordByMetricIdAndExternalIdMutation = {
  __typename?: 'mutation_root',
  delete_metric_record?: {
    __typename?: 'metric_record_mutation_response',
    affected_rows: number,
    returning: Array<{
      __typename?: 'metric_record',
      external_id?: string,
      id: string,
      value?: number
    }>
  }
};

export type UpsertMetricRecordMutationVariables = Exact<{
  object: MetricRecordCreateInputType;
  dataSource: data_source;
}>;


export type UpsertMetricRecordMutation = {
  __typename?: 'mutation_root',
  upsert_metric_record_one: {
    __typename?: 'MetricRecord',
    id: string,
    value?: number,
    external_id?: string,
    datetime_utc: DateTypes.TimestampTZString | string
  }
};

export type UpsertMetricRecordBatchMutationVariables = Exact<{
  objects: Array<MetricRecordCreateInputType> | MetricRecordCreateInputType;
  dataSource: data_source;
}>;


export type UpsertMetricRecordBatchMutation = {
  __typename?: 'mutation_root',
  upsert_metric_records: Array<{
    __typename?: 'MetricRecord',
    id: string,
    value?: number,
    external_id?: string,
    datetime_utc: DateTypes.TimestampTZString | string
  }>
};

export type DeleteAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAccountMutation = {
  __typename?: 'mutation_root',
  delete_account: boolean
};

export type MetricWatchStatusQueryVariables = Exact<{
  metricId: Scalars['uuid']['input'];
}>;


export type MetricWatchStatusQuery = {
  __typename?: 'query_root',
  metric_by_pk?: {
    __typename?: 'metric',
    display_name: string,
    watched_metric: Array<{
      __typename?: 'watched_user_metric',
      metric_id: string
    }>
  }
};

export type AddWatchedMetricMutationVariables = Exact<{
  metricId: Scalars['uuid']['input'];
}>;


export type AddWatchedMetricMutation = {
  __typename?: 'mutation_root',
  insert_watched_user_metric?: {
    __typename?: 'watched_user_metric_mutation_response',
    returning: Array<{
      __typename?: 'watched_user_metric',
      metric_id: string
    }>
  }
};

export type DeleteWatchedMetricMutationVariables = Exact<{
  metricId: Scalars['uuid']['input'];
}>;


export type DeleteWatchedMetricMutation = {
  __typename?: 'mutation_root',
  delete_watched_user_metric?: {
    __typename?: 'watched_user_metric_mutation_response',
    affected_rows: number
  }
};

export type CorePackageProductIdQueryVariables = Exact<{
  countryAvailability: Scalars['_text']['input'];
}>;


export type CorePackageProductIdQuery = {
  __typename?: 'query_root',
  product_catalog: Array<{
    __typename?: 'stripe_product',
    id: string,
    name: string
  }>
};

export type TrackQualitativeMetricMutationVariables = Exact<{
  metricId: Scalars['uuid']['input'];
}>;


export type TrackQualitativeMetricMutation = {
  __typename?: 'mutation_root',
  insert_tracked_metric_one?: {
    __typename?: 'tracked_metric',
    user_id: string,
    metric_id: string
  }
};

export type StopTrackingQualitativeMetricMutationVariables = Exact<{
  metricId: Scalars['uuid']['input'];
}>;


export type StopTrackingQualitativeMetricMutation = {
  __typename?: 'mutation_root',
  delete_tracked_metric?: {
    __typename?: 'tracked_metric_mutation_response',
    affected_rows: number
  }
};

export type FranchiseLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type FranchiseLocationsQuery = {
  __typename?: 'query_root',
  franchise: {
    __typename?: 'FranchiseRoot',
    locations: Array<{
      __typename?: 'FranchiseLocationModel',
      id: string,
      name: string,
      country: {
        __typename?: 'FranchiseCountryModel',
        code: FranchiseCountryEnum
      }
    }>
  }
};

export type SetFranchiseLocationMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  country: FranchiseCountryEnum;
}>;


export type SetFranchiseLocationMutation = {
  __typename?: 'mutation_root',
  set_franchise_location: any
};

export type GetFranchiseServicesQueryVariables = Exact<{
  location_id: Scalars['ID']['input'];
  country: FranchiseCountryEnum;
}>;


export type GetFranchiseServicesQuery = {
  __typename?: 'query_root',
  franchise: {
    __typename?: 'FranchiseRoot',
    services: Array<{
      __typename?: 'FranchiseService',
      name: string,
      id: string,
      description: string,
      duration: number,
      price_info: {
        __typename?: 'PriceInfo',
        sale_price: number
      }
    }>
  }
};

export type CreateBookingDateMutationVariables = Exact<{
  date: Scalars['LocalDate']['input'];
  serviceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  location_id: Scalars['ID']['input'];
}>;


export type CreateBookingDateMutation = {
  __typename?: 'mutation_root',
  create_franchise_booking: {
    __typename?: 'ReserveFranchiseAppointmentResponseModel',
    id: string
  }
};

export type RescheduleBookingMutationVariables = Exact<{
  date: Scalars['LocalDate']['input'];
  location_id: Scalars['ID']['input'];
  invoiceId: Scalars['String']['input'];
  invoiceItemId: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
}>;


export type RescheduleBookingMutation = {
  __typename?: 'mutation_root',
  reschedule: {
    __typename?: 'ReserveFranchiseAppointmentResponseModel',
    id: string
  }
};

export type GetBookingSlotsForBookedDateQueryVariables = Exact<{
  bookingId: Scalars['String']['input'];
  country: FranchiseCountryEnum;
}>;


export type GetBookingSlotsForBookedDateQuery = {
  __typename?: 'query_root',
  franchise: {
    __typename?: 'FranchiseRoot',
    get_booking_slots: {
      __typename?: 'GetBookingSlotResponseModel',
      slots: Array<{
        __typename?: 'FranchiseBookingSlot',
        Available: boolean,
        Priority: number,
        SalePrice?: number,
        Time: string
      }>
    }
  }
};

export type ReserveBookingSlotForBookedDateMutationVariables = Exact<{
  bookingId: Scalars['String']['input'];
  time: Scalars['String']['input'];
  country: FranchiseCountryEnum;
}>;


export type ReserveBookingSlotForBookedDateMutation = {
  __typename?: 'mutation_root',
  reserve_franchise_appointment_slot: {
    __typename?: 'ReserveBookingSlotResponseModel',
    reservation_id: string,
    expiry_time: string
  }
};

export type ConfirmBookingSlotForBookedDateMutationVariables = Exact<{
  bookingId: Scalars['String']['input'];
  country: FranchiseCountryEnum;
}>;


export type ConfirmBookingSlotForBookedDateMutation = {
  __typename?: 'mutation_root',
  confirm_franchise_appointment_booking: {
    __typename?: 'ConfirmBookingSlotResponseModel',
    is_confirmed: boolean
  }
};

export type CancelBookingMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  comments: Scalars['String']['input'];
  country: FranchiseCountryEnum;
}>;


export type CancelBookingMutation = {
  __typename?: 'mutation_root',
  cancel_franchise_appointment: {
    __typename?: 'CancelFranchiseAppointmentResponseModel',
    success: boolean
  }
};

export type GetFranchiseMembershipsQueryVariables = Exact<{
  location_id: Scalars['String']['input'];
  country: FranchiseCountryEnum;
}>;


export type GetFranchiseMembershipsQuery = {
  __typename?: 'query_root',
  franchise: {
    __typename?: 'FranchiseRoot',
    get_center_memberships: {
      __typename?: 'FranchiseMembershipsResponseModel',
      memberships: Array<{
        __typename?: 'FranchiseMembershipItem',
        name: string,
        id: string,
        description: string,
        duration_in_months: number,
        price: {
          __typename?: 'FranchiseMembershipItemPrice',
          final: number,
          sales: number,
          tax: number
        },
        payment_details: {
          __typename?: 'FranchiseMembershipItemPaymentDetails',
          setup_fee?: {
            __typename?: 'FranchiseMembershipItemPaymentDetailsFee',
            price: number,
            tax: number
          }
        }
      }>
    }
  }
};

export type CreateMembershipInvoiceMutationVariables = Exact<{
  location_id: Scalars['String']['input'];
  membershipIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  country: FranchiseCountryEnum;
}>;


export type CreateMembershipInvoiceMutation = {
  __typename?: 'mutation_root',
  create_membership_invoice: any
};

export type CreatePackageInvoiceMutationVariables = Exact<{
  location_id: Scalars['String']['input'];
  packageIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  country: FranchiseCountryEnum;
}>;


export type CreatePackageInvoiceMutation = {
  __typename?: 'mutation_root',
  create_package_invoice: any
};

export type GetFranchisePackagesQueryVariables = Exact<{
  location_id: Scalars['String']['input'];
  country: FranchiseCountryEnum;
}>;


export type GetFranchisePackagesQuery = {
  __typename?: 'query_root',
  franchise: {
    __typename?: 'FranchiseRoot',
    center_packages: Array<{
      __typename?: 'FranchiseCenterPackageModel',
      id: string,
      code: string,
      name: string,
      description: string,
      type: ZenotiPackageTypeEnum,
      price: {
        __typename?: 'FranchisePriceInfo',
        currency: string,
        tax: number,
        sales: number,
        final: number
      }
    }>
  }
};

export type PayInvoiceMutationVariables = Exact<{
  location_id: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  paymentAccountId: Scalars['String']['input'];
  country: FranchiseCountryEnum;
}>;


export type PayInvoiceMutation = {
  __typename?: 'mutation_root',
  pay_franchise_invoice_with_stored_card: any
};

export type GetUserCreditsQueryVariables = Exact<{
  location_id?: InputMaybe<Scalars['String']['input']>;
  country: FranchiseCountryEnum;
}>;


export type GetUserCreditsQuery = {
  __typename?: 'query_root',
  franchise: {
    __typename?: 'FranchiseRoot',
    credits_balance: Array<{
      __typename?: 'FranchiseCreditsBalance',
      centerId: string,
      balance: number
    }>
  }
};

export type FranchiseProfileModalDataQueryVariables = Exact<{
  country?: InputMaybe<FranchiseCountryEnum>;
}>;


export type FranchiseProfileModalDataQuery = {
  __typename?: 'query_root',
  me_v2?: {
    __typename?: 'user',
    id: string,
    name?: string,
    phone_number?: string,
    date_of_birth?: string,
    sex?: enum_sex_enum
  },
  franchise_user_profile: Array<{
    __typename?: 'franchise_user_profile',
    id: number,
    zenoti_location_id: string,
    zenoti_country: string
  }>,
  franchise: {
    __typename?: 'FranchiseRoot',
    communication_preferences: {
      __typename?: 'FranchiseCommunicationPreferences',
      receive_marketing_sms: boolean,
      receive_marketing_email: boolean,
      receive_transactional_sms: boolean,
      receive_transactional_email: boolean
    }
  },
  lab_profile: Array<{
    __typename?: 'lab_profile',
    ship_to_address?: string,
    ship_to_city?: string,
    ship_to_country?: string,
    ship_to_postal_code?: string,
    ship_to_state?: string
  }>
};

export type GetFranchisePaymentMethodsQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
  country: FranchiseCountryEnum;
}>;


export type GetFranchisePaymentMethodsQuery = {
  __typename?: 'query_root',
  franchise: {
    __typename?: 'FranchiseRoot',
    saved_payment_methods: Array<{
      __typename?: 'FranchiseSavedPaymentMethodModel',
      is_default: boolean,
      account_id: string,
      card_logo: string,
      last_four: string,
      expiry_on: string,
      payment_account_id: string
    }>
  }
};

export type AddPaymentMethodMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  country: FranchiseCountryEnum;
}>;


export type AddPaymentMethodMutation = {
  __typename?: 'mutation_root',
  franchise_add_stored_card: any
};

export type DeletePaymentMethodMutationVariables = Exact<{
  locationId: Scalars['String']['input'];
  country: FranchiseCountryEnum;
  paymentAccountId: Scalars['String']['input'];
}>;


export type DeletePaymentMethodMutation = {
  __typename?: 'mutation_root',
  franchise_delete_stored_card: {
    __typename?: 'DeleteStoredCardResponseModel',
    success: boolean,
    error?: {
      __typename?: 'ZenotiErrorResponseModel',
      Message: string,
      StatusCode: number,
      InternalMessage?: string
    }
  }
};

export type GetUserBookingsQueryVariables = Exact<{
  country: FranchiseCountryEnum;
}>;


export type GetUserBookingsQuery = {
  __typename?: 'query_root',
  franchise: {
    __typename?: 'FranchiseRoot',
    get_bookings: {
      __typename?: 'FranchiseGetBookingsResponseModel',
      appointments: Array<{
        __typename?: 'FranchiseBookingAppointment',
        invoice_id: string,
        center_id: string,
        appointment_services: Array<{
          __typename?: 'FranchiseBookingAppointmentItem',
          invoice_item_id: string,
          start_time: string,
          end_time: string,
          service: {
            __typename?: 'FranchiseBookingAppointmentItemService',
            name: string,
            id: string,
            price: {
              __typename?: 'FranchiseBookingAppointmentItemPrice',
              final: number
            }
          }
        }>
      }>
    }
  }
};

export type GetUserMembershipsQueryVariables = Exact<{
  country: FranchiseCountryEnum;
}>;


export type GetUserMembershipsQuery = {
  __typename?: 'query_root',
  franchise: {
    __typename?: 'FranchiseRoot',
    get_user_memberships: {
      __typename?: 'FranchiseGetGuestMembershipsResponse',
      guest_memberships: Array<{
        __typename?: 'FranchiseGetGuestMembershipResponseItem',
        invoice_center_id: string,
        services?: Array<{
          __typename?: 'FranchiseGetGuestMembershipServiceElement',
          redeemable_balance: number,
          service: {
            __typename?: 'FranchiseGetGuestMembershipServiceService',
            name: string
          }
        }>,
        membership: {
          __typename?: 'FranchiseGetGuestMembershipMembership',
          id: string,
          name: string
        }
      }>
    }
  }
};

export type UserPackagesQueryVariables = Exact<{
  country: FranchiseCountryEnum;
}>;


export type UserPackagesQuery = {
  __typename?: 'query_root',
  franchise: {
    __typename?: 'FranchiseRoot',
    user_packages: Array<{
      __typename?: 'FranchiseGuestPackageModel',
      id: string,
      centerId: string,
      centerName: string,
      name: string,
      services: string,
      credits: number
    }>
  }
};

export type KpisPageBaseDataQueryVariables = Exact<{
  kpiCategoryWhereClause?: InputMaybe<kpi_category_bool_exp>;
  kpiWhereClause?: InputMaybe<kpi_bool_exp>;
}>;


export type KpisPageBaseDataQuery = {
  __typename?: 'query_root',
  kpi_category: Array<{
    __typename?: 'kpi_category',
    id: string,
    name: string,
    sort_order?: number,
    kpis: Array<{
      __typename?: 'kpi',
      id: string,
      name: string,
      sort_order?: number,
      sex_filter?: enum_sex_enum,
      subcategory?: {
        __typename?: 'kpi_category',
        id: string,
        name: string
      },
      metrics: Array<{
        __typename?: 'kpi_metric',
        id: string,
        sort_order?: number,
        metric_id: string,
        metric: {
          __typename?: 'metric',
          namespace_key: string,
          default_rollup_interval_type: enum_rollup_interval_type_enum,
          name: string,
          id: string
        }
      }>
    }>
  }>
};

export type WatchedUserMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type WatchedUserMetricsQuery = {
  __typename?: 'query_root',
  me_v2?: {
    __typename?: 'user',
    watched_metrics: Array<{
      __typename?: 'watched_user_metric',
      metric: {
        __typename?: 'metric',
        id: string,
        display_name: string
      }
    }>
  }
};

export type MyAchievementsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAchievementsQuery = {
  __typename?: 'query_root',
  me_v2?: {
    __typename?: 'user',
    id: string,
    achievements: Array<{
      __typename?: 'user_achievement',
      id: string,
      achievement_id: string,
      achievement?: {
        __typename?: 'cms_AchievementEntityResponse_content',
        data?: {
          __typename?: 'cms_AchievementEntity_content',
          attributes?: {
            __typename?: 'cms_Achievement_content',
            name: string,
            thumbnail?: {
              __typename?: 'cms_UploadFileEntityResponse_content',
              data?: {
                __typename?: 'cms_UploadFileEntity_content',
                attributes?: {
                  __typename?: 'cms_UploadFile_content',
                  url: string
                }
              }
            }
          }
        }
      }
    }>
  }
};

export type DefaultHomeTilesQueryVariables = Exact<{ [key: string]: never; }>;


export type DefaultHomeTilesQuery = {
  __typename?: 'query_root',
  home_tile: Array<{
    __typename?: 'home_tile',
    id: string,
    name: string,
    data_source?: enum_data_source_enum,
    category: enum_home_tile_category_enum
  }>
};

export type UserHomeTilesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserHomeTilesQuery = {
  __typename?: 'query_root',
  user_home_tile: Array<{
    __typename?: 'user_home_tile',
    id: string,
    sort_order?: number,
    home_tile_id: string,
    home_tile: {
      __typename?: 'home_tile',
      name: string,
      data_source?: enum_data_source_enum,
      category: enum_home_tile_category_enum
    }
  }>
};

export type ShowUserHomeTileMutationVariables = Exact<{
  homeTile: user_home_tile_insert_input;
  homeTileId: Scalars['String']['input'];
}>;


export type ShowUserHomeTileMutation = {
  __typename?: 'mutation_root',
  delete_user_home_tile?: {
    __typename?: 'user_home_tile_mutation_response',
    affected_rows: number
  },
  insert_user_home_tile_one?: {
    __typename?: 'user_home_tile',
    home_tile_id: string
  }
};

export type ShowUserHomeTileBatchMutationVariables = Exact<{
  objects: Array<user_home_tile_insert_input> | user_home_tile_insert_input;
  homeTileIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ShowUserHomeTileBatchMutation = {
  __typename?: 'mutation_root',
  delete_user_home_tile?: {
    __typename?: 'user_home_tile_mutation_response',
    affected_rows: number
  },
  insert_user_home_tile?: {
    __typename?: 'user_home_tile_mutation_response',
    affected_rows: number
  }
};

export type HideUserHomeTileByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type HideUserHomeTileByIdMutation = {
  __typename?: 'mutation_root',
  delete_user_home_tile_by_pk?: {
    __typename?: 'user_home_tile',
    home_tile_id: string,
    user_id: string
  }
};

export type UserMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserMetricsQuery = {
  __typename?: 'query_root',
  metric: Array<{
    __typename?: 'metric',
    display_name: string,
    id: string,
    preference_unit?: string,
    scale_label_low?: string,
    scale_label_high?: string,
    created_at: DateTypes.TimestampTZString | string,
    updated_at: DateTypes.TimestampTZString | string,
    unitDetails?: {
      __typename?: 'unit',
      display_symbol: string
    },
    metric_records: Array<{
      __typename?: 'metric_record',
      value?: number
    }>
  }>
};

export type InsertUserMetricMutationVariables = Exact<{
  input: CreateUserMetricInputType;
}>;


export type InsertUserMetricMutation = {
  __typename?: 'mutation_root',
  create_user_metric: {
    __typename?: '_metric',
    id: string
  }
};

export type UpdateUserMetricByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: metric_set_input;
}>;


export type UpdateUserMetricByIdMutation = {
  __typename?: 'mutation_root',
  update_metric_by_pk?: {
    __typename?: 'metric',
    id: string
  }
};

export type RemoveUserMetricByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RemoveUserMetricByIdMutation = {
  __typename?: 'mutation_root',
  delete_user_metric_by_pk: boolean
};

export type DemoSuggestPlansQueryVariables = Exact<{
  date: Scalars['LocalDate']['input'];
  useV2?: Scalars['Boolean']['input'];
  method: ACTION_PLAN_SUGGESTION_TYPE;
  forceNew?: Scalars['Boolean']['input'];
  ratings?: Array<ActionPlanProfileCategoryRating> | ActionPlanProfileCategoryRating;
}>;


export type DemoSuggestPlansQuery = {
  __typename?: 'query_root',
  kpi_priorities: Array<{
    __typename?: 'KpiPriorityModel',
    rating: string,
    rank: number,
    position?: enum_kpi_snapshot_item_position_enum,
    kpi?: {
      __typename?: 'kpi',
      name: string,
      category: {
        __typename?: 'kpi_category',
        name: string,
        content?: {
          __typename?: 'cms_KpiCategoryEntityResponse_content',
          data?: {
            __typename?: 'cms_KpiCategoryEntity_content',
            attributes?: {
              __typename?: 'cms_KpiCategory_content',
              name?: string,
              description?: string,
              icon?: {
                __typename?: 'cms_UploadFileEntityResponse_content',
                data?: {
                  __typename?: 'cms_UploadFileEntity_content',
                  attributes?: {
                    __typename?: 'cms_UploadFile_content',
                    url: string,
                    width?: number,
                    height?: number
                  }
                }
              }
            }
          }
        }
      }
    }
  }>,
  suggest_action_plans: Array<{
    __typename?: 'ActionPlanSuggestionResponse',
    suggested: {
      __typename?: 'ActionPlanSuggestionResponseItem',
      action_plan_template: Array<{
        __typename?: 'action_plan_template',
        items: Array<{
          __typename?: 'action_plan_template_item',
          id: string,
          action_item_config: {
            __typename?: 'action_item_config',
            id: string,
            value_target: string,
            interval_type: enum_rollup_interval_type_enum,
            weekly_instance_target: string,
            name?: string,
            supplements: Array<{
              __typename?: 'action_item_config_supplement',
              supplement: {
                __typename?: 'supplement',
                name: string,
                brand?: string
              }
            }>,
            action_item: {
              __typename?: 'action_item',
              id: string,
              labels: Array<{
                __typename?: 'action_item_label',
                label: {
                  __typename?: 'label',
                  name: string
                }
              }>,
              content: {
                __typename?: 'cms_ActionItemEntityResponse_content',
                data?: {
                  __typename?: 'cms_ActionItemEntity_content',
                  attributes?: {
                    __typename?: 'cms_ActionItem_content',
                    summary?: string
                  }
                }
              },
              preference_unit?: Array<{
                __typename?: 'unit',
                display_name: string,
                display_name_plural: string,
                display_symbol: string,
                display_symbol_plural: string
              }>,
              action_item_inputs: Array<{
                __typename?: 'action_item_input',
                input_type: enum_action_item_input_type_enum,
                data_source?: enum_data_source_enum
              }>
            }
          }
        }>
      }>
    }
  }>
};

export type SelectActionPlanTemplateItemsAndJoinRecommendedCirclesMutationVariables = Exact<{
  actionPlanTemplateItemIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  cardioCircleId: Scalars['String']['input'];
  sleepCircleId: Scalars['String']['input'];
  skipCardio: Scalars['Boolean']['input'];
  skipSleep: Scalars['Boolean']['input'];
}>;


export type SelectActionPlanTemplateItemsAndJoinRecommendedCirclesMutation = {
  __typename?: 'mutation_root',
  select_action_plan_template_items: boolean,
  joinCardioCircle?: {
    __typename?: 'CircleMembership',
    id: string
  },
  joinSleepCircle?: {
    __typename?: 'CircleMembership',
    id: string
  }
};

export type UserPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPreferencesQuery = {
  __typename?: 'query_root',
  me?: {
    __typename?: 'user',
    id: string,
    name?: string,
    username?: string,
    email?: string,
    timezone?: string,
    date_of_birth?: string,
    membership_tier: enum_membership_tier_enum,
    membership_subscription: Array<{
      __typename?: 'membership_subscription',
      cancel_scheduled_at?: DateTypes.LocalDateTimeString | string,
      membership_tier: enum_membership_tier_enum,
      id: string,
      current_period_end?: DateTypes.LocalDateTimeString | string,
      cancelled_at?: DateTypes.LocalDateTimeString | string,
      product_line_item_id?: string,
      order_line_item?: {
        __typename?: 'stripe_order_line_item',
        subtotal: number,
        product: {
          __typename?: 'stripe_product',
          name: string
        }
      }
    }>
  },
  user_unit_preference: Array<{
    __typename?: 'user_unit_preference',
    to_unit: string,
    from_unit?: string
  }>,
  tracked_metric: Array<{
    __typename?: 'tracked_metric',
    metric: {
      __typename?: 'metric',
      id: string
    }
  }>
};

export type QualitativeMetricsByNamespaceQueryVariables = Exact<{
  namespace: Scalars['String']['input'];
}>;


export type QualitativeMetricsByNamespaceQuery = {
  __typename?: 'query_root',
  metric: Array<{
    __typename?: 'metric',
    id: string,
    name: string
  }>
};

export type QualitativeMetricsByUserQueryVariables = Exact<{
  metricType?: InputMaybe<metric_type_enum>;
}>;


export type QualitativeMetricsByUserQuery = {
  __typename?: 'query_root',
  metric: Array<{
    __typename?: 'metric',
    id: string,
    name: string
  }>
};

export type SetGlobalUnitPreferenceMutationVariables = Exact<{
  fromUnit: Scalars['String']['input'];
  toUnit: Scalars['String']['input'];
}>;


export type SetGlobalUnitPreferenceMutation = {
  __typename?: 'mutation_root',
  set_default_unit_preference: boolean
};

export type TimezoneNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type TimezoneNamesQuery = {
  __typename?: 'query_root',
  iana_timezone: Array<{
    __typename?: 'iana_timezone',
    name: string
  }>
};

export type SetMetricTargetMutationVariables = Exact<{
  input: MetricTargetCreateInputType;
}>;


export type SetMetricTargetMutation = {
  __typename?: 'mutation_root',
  set_metric_target: {
    __typename?: 'MetricTarget',
    id: string
  }
};

export type MetricUnitPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type MetricUnitPreferencesQuery = {
  __typename?: 'query_root',
  user_unit_preference: Array<{
    __typename?: 'user_unit_preference',
    from_unit?: string,
    to_unit: string,
    metric?: {
      __typename?: 'metric',
      id: string,
      display_name: string,
      preference_unit?: string,
      unitDetails?: {
        __typename?: 'unit',
        to_unit_conversions: Array<{
          __typename?: 'unit_conversion',
          from_unit: string,
          to_unit: string
        }>
      }
    }
  }>
};

export type MetricUnitConversionsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type MetricUnitConversionsQuery = {
  __typename?: 'query_root',
  metric: Array<{
    __typename?: 'metric',
    preference_unit?: string,
    name: string,
    unitDetails?: {
      __typename?: 'unit',
      to_unit_conversions: Array<{
        __typename?: 'unit_conversion',
        from_unit: string,
        to_unit: string
      }>
    }
  }>
};

export type UpdateMetricUnitPreferenceMutationVariables = Exact<{
  metricId: Scalars['uuid']['input'];
  unit: Scalars['String']['input'];
}>;


export type UpdateMetricUnitPreferenceMutation = {
  __typename?: 'mutation_root',
  set_metric_unit_preference: boolean
};

export type DeleteMetricUnitPreferenceMutationVariables = Exact<{
  metricId: Scalars['uuid']['input'];
}>;


export type DeleteMetricUnitPreferenceMutation = {
  __typename?: 'mutation_root',
  delete_user_unit_preference?: {
    __typename?: 'user_unit_preference_mutation_response',
    affected_rows: number
  }
};

export type UnitsListQueryVariables = Exact<{ [key: string]: never; }>;


export type UnitsListQuery = {
  __typename?: 'query_root',
  unit: Array<{
    __typename?: 'unit',
    display_symbol: string,
    name: string
  }>
};

export type CurrentChronologicalAgeQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentChronologicalAgeQuery = {
  __typename?: 'query_root',
  metric: Array<{
    __typename?: 'metric',
    dynamic_record?: {
      __typename?: 'dynamic_metric',
      record?: {
        __typename?: 'DynamicMetricRecord',
        value?: number
      }
    }
  }>
};

export type ReferenceRangeFieldsFragment = {
  __typename?: 'ReferenceRange',
  id: string,
  dataSource?: string,
  rangeType: enum_reference_range_type,
  displayName: string,
  targets?: Array<{
    __typename?: 'ReferenceRangeTarget',
    label?: string,
    color?: string,
    optimal: boolean,
    target?: string,
    discreteTargets?: Array<string>,
    healthEffectsTitle?: string
  }>
};

export type MetricMatchedReferenceRangeTargetsV2FieldsFragment = {
  __typename?: 'metric',
  id: string,
  matched_reference_range_targets_v2: {
    __typename?: 'FilteredReferenceRanges',
    matches: Array<{
      __typename?: 'ReferenceRange',
      id: string,
      dataSource?: string,
      rangeType: enum_reference_range_type,
      displayName: string,
      targets?: Array<{
        __typename?: 'ReferenceRangeTarget',
        label?: string,
        color?: string,
        optimal: boolean,
        target?: string,
        discreteTargets?: Array<string>,
        healthEffectsTitle?: string
      }>
    }>
  }
};

export type MetricRecordReferenceRangeFieldsFragment = {
  __typename?: 'metric_record',
  reference_range?: {
    __typename?: 'reference_range',
    id: string,
    data_source?: enum_data_source_enum,
    range_type: string,
    display_name: string,
    targets: Array<{
      __typename?: 'reference_range_target',
      label?: string,
      color?: string,
      optimal: boolean,
      target?: string,
      discrete_targets?: string[],
      health_effects_text?: string
    }>
  }
};

export type MetricReferenceRangeFieldsFragment = {
  __typename?: 'metric',
  id: string,
  metric_records?: Array<{
    __typename?: 'metric_record',
    reference_range?: {
      __typename?: 'reference_range',
      id: string,
      data_source?: enum_data_source_enum,
      range_type: string,
      display_name: string,
      targets: Array<{
        __typename?: 'reference_range_target',
        label?: string,
        color?: string,
        optimal: boolean,
        target?: string,
        discrete_targets?: string[],
        health_effects_text?: string
      }>
    }
  }>,
  matched_reference_range_targets_v2: {
    __typename?: 'FilteredReferenceRanges',
    matches: Array<{
      __typename?: 'ReferenceRange',
      id: string,
      dataSource?: string,
      rangeType: enum_reference_range_type,
      displayName: string,
      targets?: Array<{
        __typename?: 'ReferenceRangeTarget',
        label?: string,
        color?: string,
        optimal: boolean,
        target?: string,
        discreteTargets?: Array<string>,
        healthEffectsTitle?: string
      }>
    }>
  }
};

export type MetricDetailsMatchedReferenceRangesQueryVariables = Exact<{
  metricIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  skipMetricRecordRefRanges?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MetricDetailsMatchedReferenceRangesQuery = {
  __typename?: 'query_root',
  metric: Array<{
    __typename?: 'metric',
    id: string,
    metric_records?: Array<{
      __typename?: 'metric_record',
      reference_range?: {
        __typename?: 'reference_range',
        id: string,
        data_source?: enum_data_source_enum,
        range_type: string,
        display_name: string,
        targets: Array<{
          __typename?: 'reference_range_target',
          label?: string,
          color?: string,
          optimal: boolean,
          target?: string,
          discrete_targets?: string[],
          health_effects_text?: string
        }>
      }
    }>,
    matched_reference_range_targets_v2: {
      __typename?: 'FilteredReferenceRanges',
      matches: Array<{
        __typename?: 'ReferenceRange',
        id: string,
        dataSource?: string,
        rangeType: enum_reference_range_type,
        displayName: string,
        targets?: Array<{
          __typename?: 'ReferenceRangeTarget',
          label?: string,
          color?: string,
          optimal: boolean,
          target?: string,
          discreteTargets?: Array<string>,
          healthEffectsTitle?: string
        }>
      }>
    }
  }>
};

export type MetricDetailsResultsFieldsFragment = {
  __typename?: 'metric',
  id: string,
  display_name: string,
  namespace_key: string,
  default_weekly_rollup_type?: enum_metric_rollup_type_enum,
  default_rollup_interval_type?: enum_rollup_interval_type_enum,
  lab_test_markers: Array<{
    __typename?: 'lab_test_marker',
    labels: Array<{
      __typename?: 'lab_test_marker_label',
      label: {
        __typename?: 'label',
        name: string
      }
    }>
  }>,
  preference_unit_details?: Array<{
    __typename?: 'unit',
    display_symbol: string
  }>,
  latest_rollup_values?: Array<{
    __typename?: 'placeholder_metric_rollup_value',
    interval_start: DateTypes.TimestampTZString | string,
    interval_end: DateTypes.TimestampTZString | string,
    preference_value: number,
    metric_records?: Array<{
      __typename?: 'metric_record',
      value_type: metric_record_value_type_enum,
      lab_result_marker?: {
        __typename?: 'lab_result_marker',
        is_optimal?: boolean,
        converted_value?: string,
        test: {
          __typename?: 'lab_result_test',
          lab_item?: {
            __typename?: 'lab_test_item',
            display_name: string
          }
        }
      }
    }>
  }>,
  latestValues?: Array<{
    __typename?: 'metric_record',
    datetime_utc: DateTypes.TimestampTZString | string,
    preference_value?: number,
    value_string?: string,
    value_type: metric_record_value_type_enum,
    lab_result_marker?: {
      __typename?: 'lab_result_marker',
      is_optimal?: boolean,
      converted_value?: string,
      test: {
        __typename?: 'lab_result_test',
        lab_item?: {
          __typename?: 'lab_test_item',
          display_name: string
        }
      }
    }
  }>
};

export type MetricDetailsCmsContentQueryVariables = Exact<{
  entityId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MetricDetailsCmsContentQuery = {
  __typename?: 'query_root',
  metricDetailsCmsContent?: {
    __typename?: 'cmsQuery',
    labTestMarkers?: {
      __typename?: 'cms_LabTestMarkerEntityResponseCollection_content',
      data: Array<{
        __typename?: 'cms_LabTestMarkerEntity_content',
        attributes?: {
          __typename?: 'cms_LabTestMarker_content',
          summary?: string,
          full_description?: string,
          instructions?: string
        }
      }>
    }
  }
};

export type MetricDetailsResultsQueryVariables = Exact<{
  dataSources: Array<enum_data_source_enum> | enum_data_source_enum;
  metricIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  beforeDate: Scalars['timestamptz']['input'];
  latestValuesLimit?: InputMaybe<Scalars['Int']['input']>;
  skipLatestValues?: InputMaybe<Scalars['Boolean']['input']>;
  skipRollupValues?: InputMaybe<Scalars['Boolean']['input']>;
  latestRollupValuesArgs: latest_rollup_values_metric_args;
  latestRollupLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MetricDetailsResultsQuery = {
  __typename?: 'query_root',
  metric: Array<{
    __typename?: 'metric',
    id: string,
    display_name: string,
    namespace_key: string,
    default_weekly_rollup_type?: enum_metric_rollup_type_enum,
    default_rollup_interval_type?: enum_rollup_interval_type_enum,
    lab_test_markers: Array<{
      __typename?: 'lab_test_marker',
      labels: Array<{
        __typename?: 'lab_test_marker_label',
        label: {
          __typename?: 'label',
          name: string
        }
      }>
    }>,
    preference_unit_details?: Array<{
      __typename?: 'unit',
      display_symbol: string
    }>,
    latest_rollup_values?: Array<{
      __typename?: 'placeholder_metric_rollup_value',
      interval_start: DateTypes.TimestampTZString | string,
      interval_end: DateTypes.TimestampTZString | string,
      preference_value: number,
      metric_records?: Array<{
        __typename?: 'metric_record',
        value_type: metric_record_value_type_enum,
        lab_result_marker?: {
          __typename?: 'lab_result_marker',
          is_optimal?: boolean,
          converted_value?: string,
          test: {
            __typename?: 'lab_result_test',
            lab_item?: {
              __typename?: 'lab_test_item',
              display_name: string
            }
          }
        }
      }>
    }>,
    latestValues?: Array<{
      __typename?: 'metric_record',
      datetime_utc: DateTypes.TimestampTZString | string,
      preference_value?: number,
      value_string?: string,
      value_type: metric_record_value_type_enum,
      lab_result_marker?: {
        __typename?: 'lab_result_marker',
        is_optimal?: boolean,
        converted_value?: string,
        test: {
          __typename?: 'lab_result_test',
          lab_item?: {
            __typename?: 'lab_test_item',
            display_name: string
          }
        }
      }
    }>
  }>
};

export type MetricRecommendationByMetricIdQueryVariables = Exact<{
  metricId: Scalars['String']['input'];
}>;


export type MetricRecommendationByMetricIdQuery = {
  __typename?: 'query_root',
  metric_recommendation_items: Array<{
    __typename: 'LifestyleRecommendationItemModel'
  } | {
    __typename: 'MeasureRecommendationItemModel'
  } | {
    __typename: 'SupplementRecommendationItemModel'
  }>
};

export type MostRecentPhenoAgeChronologicalAgeRecordQueryVariables = Exact<{
  namespaceKeys: Array<Scalars['String']['input']> | Scalars['String']['input'];
  beforeDate: Scalars['timestamptz']['input'];
}>;


export type MostRecentPhenoAgeChronologicalAgeRecordQuery = {
  __typename?: 'query_root',
  metric: Array<{
    __typename?: 'metric',
    namespace_key: string,
    metric_records: Array<{
      __typename?: 'metric_record',
      preference_value?: number
    }>
  }>
};

export type DashboardMetricsQueryVariables = Exact<{
  metricIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DashboardMetricsQuery = {
  __typename?: 'query_root',
  dashboard: Array<{
    __typename?: 'dashboard',
    name: string,
    tabs: Array<{
      __typename?: 'dashboard_tab',
      charts: Array<{
        __typename?: 'dashboard_chart',
        chart_tabs: Array<{
          __typename?: 'dashboard_chart_tab',
          chart: {
            __typename?: 'dashboard_chart',
            chart_tabs: Array<{
              __typename?: 'dashboard_chart_tab',
              views: Array<{
                __typename?: 'dashboard_chart_view',
                view_metrics: Array<{
                  __typename?: 'dashboard_chart_metric',
                  metric_id: string
                }>
              }>
            }>
          }
        }>
      }>
    }>
  }>
};

export type CirclesRecommendationsQueryVariables = Exact<{ [key: string]: never; }>;


export type CirclesRecommendationsQuery = {
  __typename?: 'query_root',
  circle: Array<{
    __typename?: 'circle',
    name: string,
    id: string,
    content: {
      __typename?: 'cms_CircleEntityResponse_content',
      data?: {
        __typename?: 'cms_CircleEntity_content',
        attributes?: {
          __typename?: 'cms_Circle_content',
          hero_image?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          }
        }
      }
    }
  }>
};

export type UpdateUserBirthdayMutationVariables = Exact<{
  date_of_birth?: InputMaybe<Scalars['date']['input']>;
}>;


export type UpdateUserBirthdayMutation = {
  __typename?: 'mutation_root',
  update_user?: {
    __typename?: 'user_mutation_response',
    returning: Array<{
      __typename?: 'user',
      id: string,
      date_of_birth?: string
    }>
  }
};

export type UpdateUsernameMutationVariables = Exact<{
  username: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUsernameMutation = {
  __typename?: 'mutation_root',
  setUserProfile: {
    __typename?: 'SetUserProfileResult',
    profile: {
      __typename?: 'UserProfile',
      userId: string,
      username?: string
    },
    validation_messages?: Array<{
      __typename?: 'Message',
      field: string,
      message: string
    }>
  }
};

export type SetMetricUnitPreferenceMutationVariables = Exact<{
  metricId: Scalars['uuid']['input'];
  unit: Scalars['String']['input'];
}>;


export type SetMetricUnitPreferenceMutation = {
  __typename?: 'mutation_root',
  set_metric_unit_preference: boolean
};

export type SetUserTimezoneMutationVariables = Exact<{
  timezone: Scalars['String']['input'];
}>;


export type SetUserTimezoneMutation = {
  __typename?: 'mutation_root',
  update_timezone: boolean
};

export type UpdateHomeTilesSortOrderMutationVariables = Exact<{
  updates: Array<user_home_tile_updates> | user_home_tile_updates;
}>;


export type UpdateHomeTilesSortOrderMutation = {
  __typename?: 'mutation_root',
  update_user_home_tile_many?: Array<{
    __typename?: 'user_home_tile_mutation_response',
    affected_rows: number,
    returning: Array<{
      __typename?: 'user_home_tile',
      id: string,
      sort_order?: number,
      home_tile: {
        __typename?: 'home_tile',
        name: string
      }
    }>
  }>
};

export type CancelMembershipMutationVariables = Exact<{
  cancellationReason: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
}>;


export type CancelMembershipMutation = {
  __typename?: 'mutation_root',
  cancel_membership: boolean
};

export type CreateSelfdecodeProfileAndAcceptTosProfilePageMutationVariables = Exact<{
  input: CreateLabProfileInput;
  skipRealizeTos: Scalars['Boolean']['input'];
  realizeTosVersion: Scalars['String']['input'];
  isLabAvailableInOrder?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateSelfdecodeProfileAndAcceptTosProfilePageMutation = {
  __typename?: 'mutation_root',
  create_lab_profile: {
    __typename?: 'LabProfileWithValidation',
    birthDate?: DateTypes.LocalDateString,
    sex?: enum_selfdecode_sex_enum
  },
  acceptTermsOfService?: {
    __typename?: 'TermsAcceptance',
    acceptedAt: DateTypes.TimestampTZString | string
  }
};

export type MetricTargetsQueryVariables = Exact<{ [key: string]: never; }>;


export type MetricTargetsQuery = {
  __typename?: 'query_root',
  metric_target: Array<{
    __typename?: 'metric_target',
    id: string,
    preference_target?: string,
    start: DateTypes.TimestampTZString | string,
    end?: DateTypes.TimestampTZString | string,
    interval_count?: number,
    interval_type?: enum_rollup_interval_type_enum,
    aggregate_type: enum_metric_rollup_type_enum,
    metric: {
      __typename?: 'metric',
      id: string,
      display_name: string,
      preference_unit?: string,
      preference_unit_details?: Array<{
        __typename?: 'unit',
        display_symbol: string,
        symbol: string
      }>
    }
  }>
};

export type DeleteMetricTargetByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteMetricTargetByIdMutation = {
  __typename?: 'mutation_root',
  delete_metric_target_by_pk?: {
    __typename?: 'metric_target',
    id: string
  }
};

export type ActionItemInputFieldsFragment = {
  __typename?: 'action_item_input',
  input_type: enum_action_item_input_type_enum,
  id: string,
  data_source?: enum_data_source_enum
};

export type ActionItemLibraryQueryVariables = Exact<{
  actionItemWhereClause?: InputMaybe<action_item_bool_exp>;
}>;


export type ActionItemLibraryQuery = {
  __typename?: 'query_root',
  action_item: Array<{
    __typename?: 'action_item',
    name: string,
    user_id?: string,
    instance_target: string,
    id: string,
    prevent_add_to_circle: boolean,
    prevent_add_to_circle_reason?: string,
    name_show_placeholders: boolean,
    logger_type?: enum_action_item_logger_type_enum,
    interval_type: enum_rollup_interval_type_enum,
    interval_count: number,
    value_rollup_type: enum_metric_rollup_type_enum,
    value_target?: string,
    labels: Array<{
      __typename?: 'action_item_label',
      label: {
        __typename?: 'label',
        name: string
      }
    }>,
    preference_unit?: Array<{
      __typename?: 'unit',
      display_symbol: string,
      display_symbol_plural: string,
      display_name: string,
      display_name_plural: string
    }>,
    action_item_inputs: Array<{
      __typename?: 'action_item_input',
      input_type: enum_action_item_input_type_enum,
      id: string,
      data_source?: enum_data_source_enum
    }>,
    action_item_users: Array<{
      __typename?: 'action_item_user',
      id: string,
      personalized_name: string,
      name: string,
      logger_type: enum_action_item_logger_type_enum,
      weekly_instance_target: string,
      interval_type: enum_rollup_interval_type_enum,
      interval_count: number,
      value_rollup_type: enum_metric_rollup_type_enum,
      instance_target: string,
      sort_order?: number,
      value_target?: string,
      action_item_user_inputs: Array<{
        __typename?: 'action_item_user_input',
        disabled: boolean,
        action_item_user_supplements: Array<{
          __typename?: 'action_item_user_supplement',
          id: string,
          servings: number,
          supplement: {
            __typename?: 'supplement',
            name: string,
            id: string
          }
        }>,
        action_item_input: {
          __typename?: 'action_item_input',
          input_type: enum_action_item_input_type_enum,
          id: string,
          data_source?: enum_data_source_enum
        }
      }>,
      circle_membership_action_items: Array<{
        __typename?: 'circle_membership_action_item',
        circle_membership: {
          __typename?: 'circle_membership',
          circle: {
            __typename?: 'circle',
            is_owner?: boolean,
            name: string,
            content: {
              __typename?: 'cms_CircleEntityResponse_content',
              data?: {
                __typename?: 'cms_CircleEntity_content',
                attributes?: {
                  __typename?: 'cms_Circle_content',
                  thumbnail_image?: {
                    __typename?: 'cms_UploadFileEntityResponse_content',
                    data?: {
                      __typename?: 'cms_UploadFileEntity_content',
                      attributes?: {
                        __typename?: 'cms_UploadFile_content',
                        size: number,
                        width?: number,
                        height?: number,
                        url: string,
                        alternativeText?: string
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }>
    }>
  }>
};

export type CircleMemberDetailQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  weekStart: Scalars['LocalDate']['input'];
  membershipId: Scalars['uuid']['input'];
}>;


export type CircleMemberDetailQuery = {
  __typename?: 'query_root',
  circle_by_pk?: {
    __typename?: 'circle',
    id: string,
    memberships: Array<{
      __typename?: 'circle_membership',
      id: string,
      user_id: string,
      membership_action_item: Array<{
        __typename?: 'circle_membership_action_item',
        action_item_user: {
          __typename?: 'action_item_user',
          id: string,
          name: string,
          interval: string,
          interval_type: enum_rollup_interval_type_enum,
          instance_target: string,
          instance_target_type: enum_action_item_instance_target_type_enum,
          preference_value_target?: string,
          value_rollup_type: enum_metric_rollup_type_enum,
          action_item: {
            __typename?: 'action_item',
            preference_value_target?: string,
            preference_unit?: Array<{
              __typename?: 'unit',
              display_symbol: string,
              display_symbol_plural: string,
              display_name: string,
              display_name_plural: string
            }>
          },
          week: {
            __typename?: 'ActionItemUserPeriod',
            dailies: Array<{
              __typename?: 'ActionItemUserPeriodInstance',
              date: DateTypes.LocalDateString,
              targetMet: boolean,
              hasRecords: boolean
            }>
          }
        }
      }>
    }>
  }
};

export type ActionItemsForPreviousWeekQueryVariables = Exact<{
  week: Scalars['LocalDate']['input'];
}>;


export type ActionItemsForPreviousWeekQuery = {
  __typename?: 'query_root',
  me_v2?: {
    __typename?: 'user',
    id: string,
    action_items: Array<{
      __typename?: 'action_item_user',
      week: {
        __typename?: 'ActionItemUserPeriod',
        dailies: Array<{
          __typename?: 'ActionItemUserPeriodInstance',
          preferenceValue?: number
        }>
      }
    }>
  }
};

export type SleepCircleJoinDateQueryVariables = Exact<{ [key: string]: never; }>;


export type SleepCircleJoinDateQuery = {
  __typename?: 'query_root',
  me_v2?: {
    __typename?: 'user',
    id: string,
    circle_memberships: Array<{
      __typename?: 'circle_membership',
      joined_at: string
    }>
  }
};

export type MetricMetricRecordsRollupFieldsFragment = {
  __typename?: 'metric',
  preference_unit_details?: Array<{
    __typename?: 'unit',
    display_symbol: string
  }>,
  metric_records_rollup: Array<{
    __typename?: 'MetricRecordRollup',
    interval_start: DateTypes.TimestampTZString | string,
    preference_avg?: number
  }>
};

export type SleepImprovementWeeklyComparisonRecordsQueryVariables = Exact<{
  start: Scalars['timestamptz']['input'];
  end: Scalars['timestamptz']['input'];
}>;


export type SleepImprovementWeeklyComparisonRecordsQuery = {
  __typename?: 'query_root',
  Sleep_Score: Array<{
    __typename?: 'metric',
    preference_unit_details?: Array<{
      __typename?: 'unit',
      display_symbol: string
    }>,
    metric_records_rollup: Array<{
      __typename?: 'MetricRecordRollup',
      interval_start: DateTypes.TimestampTZString | string,
      preference_avg?: number
    }>
  }>,
  Average_HRV: Array<{
    __typename?: 'metric',
    preference_unit_details?: Array<{
      __typename?: 'unit',
      display_symbol: string
    }>,
    metric_records_rollup: Array<{
      __typename?: 'MetricRecordRollup',
      interval_start: DateTypes.TimestampTZString | string,
      preference_avg?: number
    }>
  }>,
  Deep_Sleep: Array<{
    __typename?: 'metric',
    preference_unit_details?: Array<{
      __typename?: 'unit',
      display_symbol: string
    }>,
    metric_records_rollup: Array<{
      __typename?: 'MetricRecordRollup',
      interval_start: DateTypes.TimestampTZString | string,
      preference_avg?: number
    }>
  }>,
  REM_Sleep: Array<{
    __typename?: 'metric',
    preference_unit_details?: Array<{
      __typename?: 'unit',
      display_symbol: string
    }>,
    metric_records_rollup: Array<{
      __typename?: 'MetricRecordRollup',
      interval_start: DateTypes.TimestampTZString | string,
      preference_avg?: number
    }>
  }>,
  Total_Sleep: Array<{
    __typename?: 'metric',
    preference_unit_details?: Array<{
      __typename?: 'unit',
      display_symbol: string
    }>,
    metric_records_rollup: Array<{
      __typename?: 'MetricRecordRollup',
      interval_start: DateTypes.TimestampTZString | string,
      preference_avg?: number
    }>
  }>
};

export type LoggedItemAchievementQueryVariables = Exact<{ [key: string]: never; }>;


export type LoggedItemAchievementQuery = {
  __typename?: 'query_root',
  me_v2?: {
    __typename?: 'user',
    achievements: Array<{
      __typename?: 'user_achievement',
      achievement?: {
        __typename?: 'cms_AchievementEntityResponse_content',
        data?: {
          __typename?: 'cms_AchievementEntity_content',
          attributes?: {
            __typename?: 'cms_Achievement_content',
            entity_id: string
          }
        }
      }
    }>
  }
};

export type FeaturedActionitemsQueryVariables = Exact<{ [key: string]: never; }>;


export type FeaturedActionitemsQuery = {
  __typename?: 'query_root',
  cms?: {
    __typename?: 'cmsQuery',
    actionItems?: {
      __typename?: 'cms_ActionItemEntityResponseCollection_content',
      data: Array<{
        __typename?: 'cms_ActionItemEntity_content',
        id?: string,
        attributes?: {
          __typename?: 'cms_ActionItem_content',
          entity_id: string,
          report_summary?: string,
          hero_image?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          }
        }
      }>
    }
  }
};

export type InsertUserAchievementMutationVariables = Exact<{
  achievementId: Scalars['String']['input'];
}>;


export type InsertUserAchievementMutation = {
  __typename?: 'mutation_root',
  insert_user_achievement_one?: {
    __typename?: 'user_achievement',
    id: string
  }
};

export type WeeklyUserActionPlanQueryVariables = Exact<{
  begin: Scalars['date']['input'];
  end: Scalars['date']['input'];
  week: Scalars['LocalDate']['input'];
}>;


export type WeeklyUserActionPlanQuery = {
  __typename?: 'query_root',
  me?: {
    __typename?: 'user',
    id: string,
    action_items: Array<{
      __typename?: 'action_item_user',
      id: string,
      name: string,
      logger_type: enum_action_item_logger_type_enum,
      instance_target_type: enum_action_item_instance_target_type_enum,
      interval_type: enum_rollup_interval_type_enum,
      interval_count: number,
      value_rollup_type: enum_metric_rollup_type_enum,
      instance_target: string,
      sort_order?: number,
      action_item_user_inputs: Array<{
        __typename?: 'action_item_user_input',
        action_item_input: {
          __typename?: 'action_item_input',
          id: string,
          data_source?: enum_data_source_enum,
          metric_id?: string,
          input_type: enum_action_item_input_type_enum,
          metric?: {
            __typename?: 'metric',
            namespace_key: string
          }
        },
        action_item_user_supplements: Array<{
          __typename?: 'action_item_user_supplement',
          id: string,
          servings: number,
          supplement_records: Array<{
            __typename?: 'supplement_record',
            id: string,
            servings: number,
            date: string,
            timeframe: enum_timeframe_enum
          }>,
          supplement: {
            __typename?: 'supplement',
            serving_size?: string,
            name: string,
            id: string,
            brand?: string
          }
        }>
      }>,
      action_item: {
        __typename?: 'action_item',
        timeframe?: enum_timeframe_enum,
        id: string,
        preference_unit?: Array<{
          __typename?: 'unit',
          display_symbol: string,
          display_symbol_plural: string,
          display_name: string,
          display_name_plural: string
        }>
      },
      week: {
        __typename?: 'ActionItemUserPeriod',
        id: string,
        week: DateTypes.LocalDateString,
        periodStart: DateTypes.LocalDateString,
        periodEnd: DateTypes.LocalDateString,
        period: DateTypes.LocalDateRangeString,
        instanceTarget: string,
        instanceTargetType: enum_action_item_instance_target_type_enum,
        weeklyInstanceTarget: string,
        preferenceValueTarget: string,
        dailies: Array<{
          __typename?: 'ActionItemUserPeriodInstance',
          date: DateTypes.LocalDateString,
          targetMet: boolean,
          value?: number,
          target: string,
          records: Array<{
            __typename?: 'ActionItemUserRecord',
            metricRecordId?: string
          }>
        }>
      },
      circle_membership_action_items: Array<{
        __typename?: 'circle_membership_action_item',
        circle_membership: {
          __typename?: 'circle_membership',
          circle: {
            __typename?: 'circle',
            name: string
          }
        }
      }>
    }>
  }
};

export type RecordActionItemMutationVariables = Exact<{
  input: RecordActionItemUserInstanceInput;
}>;


export type RecordActionItemMutation = {
  __typename?: 'mutation_root',
  record_action_item_user_instance: {
    __typename?: 'ActionItemUserPeriodInstance',
    targetMet: boolean
  }
};

export type ClearActionItemRecordsMutationVariables = Exact<{
  input: ClearActionItemUserInstanceInput;
}>;


export type ClearActionItemRecordsMutation = {
  __typename?: 'mutation_root',
  clear_action_item_user_instance: {
    __typename?: 'ActionItemUserPeriodInstance',
    targetMet: boolean
  }
};

export type WorkoutsByMetricRecordIdsQueryVariables = Exact<{
  workoutMetricRecordIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type WorkoutsByMetricRecordIdsQuery = {
  __typename?: 'query_root',
  metric_record_group: Array<{
    __typename?: 'metric_record_group',
    id: string,
    data_source: enum_data_source_enum,
    datetime_utc: DateTypes.TimestampTZString | string,
    variant: string,
    metric_records: Array<{
      __typename?: 'metric_record',
      preference_value?: number,
      metric: {
        __typename?: 'metric',
        namespace_key: string,
        preference_unit?: string
      }
    }>
  }>
};

export type SelectActionItemMutationVariables = Exact<{
  actionItemId: Scalars['uuid']['input'];
  instanceTarget?: InputMaybe<Scalars['NumericRange']['input']>;
  valueTarget?: InputMaybe<Scalars['NumericRange']['input']>;
  actionItemInputIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  intervalType: enum_rollup_interval_type_enum;
  supplements?: InputMaybe<Array<ActionItemSupplementInput> | ActionItemSupplementInput>;
  removedActionItemUserSupplementIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type SelectActionItemMutation = {
  __typename?: 'mutation_root',
  select_action_item: string,
  delete_action_item_user_supplement?: {
    __typename?: 'action_item_user_supplement_mutation_response',
    affected_rows: number
  }
};

export type CreateCustomActionItemMutationVariables = Exact<{
  actionItem: action_item_insert_input;
}>;


export type CreateCustomActionItemMutation = {
  __typename?: 'mutation_root',
  insert_action_item_one?: {
    __typename?: 'action_item',
    id: string,
    interval_type: enum_rollup_interval_type_enum
  }
};

export type UpdateActionItemMutationVariables = Exact<{
  actionItemUserId: Scalars['uuid']['input'];
  instanceTarget?: InputMaybe<Scalars['NumericRange']['input']>;
  valueTarget?: InputMaybe<Scalars['NumericRange']['input']>;
  actionItemInputIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  intervalType: enum_rollup_interval_type_enum;
  supplements?: InputMaybe<Array<ActionItemSupplementInput> | ActionItemSupplementInput>;
  removedActionItemUserSupplementIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateActionItemMutation = {
  __typename?: 'mutation_root',
  update_user_action: {
    __typename?: 'ActionItemUser',
    id: string,
    actionItemId: string
  },
  delete_action_item_user_supplement?: {
    __typename?: 'action_item_user_supplement_mutation_response',
    affected_rows: number
  }
};

export type SupplementStackOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SupplementStackOptionsQuery = {
  __typename?: 'query_root',
  supplement: Array<{
    __typename?: 'supplement',
    id: string,
    name: string,
    brand?: string,
    serving_size?: string,
    metric?: {
      __typename?: 'metric',
      preference_unit_details?: Array<{
        __typename?: 'unit',
        display_symbol: string
      }>
    }
  }>
};

export type ActionPlanWeeksQueryVariables = Exact<{
  end: Scalars['date']['input'];
}>;


export type ActionPlanWeeksQuery = {
  __typename?: 'query_root',
  weeks: Array<{
    __typename?: 'action_item_user_period',
    week: string
  }>
};

export type DisableActionItemUserMutationVariables = Exact<{
  actionItemUserId: Scalars['uuid']['input'];
}>;


export type DisableActionItemUserMutation = {
  __typename?: 'mutation_root',
  disable_action_item_user: boolean
};

export type UpdateActionItemsSortOrderMutationVariables = Exact<{
  updates: Array<action_item_user_updates> | action_item_user_updates;
}>;


export type UpdateActionItemsSortOrderMutation = {
  __typename?: 'mutation_root',
  update_action_item_user_many?: Array<{
    __typename?: 'action_item_user_mutation_response',
    affected_rows: number
  }>
};

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = {
  __typename?: 'query_root',
  me_v2?: {
    __typename?: 'user',
    email?: string,
    name?: string
  }
};

export type CircleIdByInviteShortIdQueryVariables = Exact<{
  inviteShortId: Scalars['String']['input'];
}>;


export type CircleIdByInviteShortIdQuery = {
  __typename?: 'query_root',
  get_circles_by_invite: Array<{
    __typename?: 'circle',
    id: string
  }>
};

export type DeleteCircleMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteCircleMutation = {
  __typename?: 'mutation_root',
  delete_circle_by_pk?: {
    __typename?: 'circle',
    id: string
  }
};

export type CircleNameByIdQueryVariables = Exact<{
  circleId: Scalars['uuid']['input'];
}>;


export type CircleNameByIdQuery = {
  __typename?: 'query_root',
  circle_by_pk?: {
    __typename?: 'circle',
    name: string
  }
};

export type ActionItemDetailsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ActionItemDetailsQuery = {
  __typename?: 'query_root',
  action_item_by_pk?: {
    __typename?: 'action_item',
    id: string,
    name: string,
    content: {
      __typename?: 'cms_ActionItemEntityResponse_content',
      data?: {
        __typename?: 'cms_ActionItemEntity_content',
        attributes?: {
          __typename?: 'cms_ActionItem_content',
          name: string,
          description?: string,
          summary?: string,
          hero_image?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          }
        }
      }
    }
  }
};

export type OuraDataSourceActionItemFragment = {
  __typename?: 'circle',
  memberships: Array<{
    __typename?: 'circle_membership',
    user_id: string
  }>,
  action_items: Array<{
    __typename?: 'circle_action_item',
    id: string
  }>
};

export type CircleUserIdsByInviteShortIdQueryVariables = Exact<{
  shortId: Scalars['String']['input'];
}>;


export type CircleUserIdsByInviteShortIdQuery = {
  __typename?: 'query_root',
  get_circles_by_invite: Array<{
    __typename?: 'circle',
    memberships: Array<{
      __typename?: 'circle_membership',
      user_id: string
    }>,
    action_items: Array<{
      __typename?: 'circle_action_item',
      id: string
    }>
  }>
};

export type CircleUserIdsByCircleIdQueryVariables = Exact<{
  circleId: Scalars['uuid']['input'];
}>;


export type CircleUserIdsByCircleIdQuery = {
  __typename?: 'query_root',
  circle_by_pk?: {
    __typename?: 'circle',
    memberships: Array<{
      __typename?: 'circle_membership',
      user_id: string
    }>,
    action_items: Array<{
      __typename?: 'circle_action_item',
      id: string
    }>
  }
};

export type CirclesListCircleFieldsFragment = {
  __typename?: 'circle',
  id: string,
  name: string,
  is_owner?: boolean,
  content: {
    __typename?: 'cms_CircleEntityResponse_content',
    data?: {
      __typename?: 'cms_CircleEntity_content',
      attributes?: {
        __typename?: 'cms_Circle_content',
        summary?: string,
        thumbnail_image?: {
          __typename?: 'cms_UploadFileEntityResponse_content',
          data?: {
            __typename?: 'cms_UploadFileEntity_content',
            attributes?: {
              __typename?: 'cms_UploadFile_content',
              size: number,
              width?: number,
              height?: number,
              url: string,
              alternativeText?: string
            }
          }
        }
      }
    }
  },
  weekSummary: {
    __typename?: 'CircleWeekSummary',
    memberCount: number
  }
};

export type CirclesListQueryVariables = Exact<{ [key: string]: never; }>;


export type CirclesListQuery = {
  __typename?: 'query_root',
  myCircles?: {
    __typename?: 'user',
    id: string,
    circle_memberships: Array<{
      __typename?: 'circle_membership',
      circle: {
        __typename?: 'circle',
        id: string,
        name: string,
        is_owner?: boolean,
        content: {
          __typename?: 'cms_CircleEntityResponse_content',
          data?: {
            __typename?: 'cms_CircleEntity_content',
            attributes?: {
              __typename?: 'cms_Circle_content',
              summary?: string,
              thumbnail_image?: {
                __typename?: 'cms_UploadFileEntityResponse_content',
                data?: {
                  __typename?: 'cms_UploadFileEntity_content',
                  attributes?: {
                    __typename?: 'cms_UploadFile_content',
                    size: number,
                    width?: number,
                    height?: number,
                    url: string,
                    alternativeText?: string
                  }
                }
              }
            }
          }
        },
        weekSummary: {
          __typename?: 'CircleWeekSummary',
          memberCount: number
        }
      }
    }>
  },
  notMyCircles: Array<{
    __typename?: 'circle',
    id: string,
    name: string,
    is_owner?: boolean,
    memberships: Array<{
      __typename?: 'circle_membership',
      active: boolean,
      user_id: string
    }>,
    content: {
      __typename?: 'cms_CircleEntityResponse_content',
      data?: {
        __typename?: 'cms_CircleEntity_content',
        attributes?: {
          __typename?: 'cms_Circle_content',
          summary?: string,
          thumbnail_image?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          }
        }
      }
    },
    weekSummary: {
      __typename?: 'CircleWeekSummary',
      memberCount: number
    }
  }>
};

export type CircleImageFieldsFragment = {
  __typename?: 'circle',
  content: {
    __typename?: 'cms_CircleEntityResponse_content',
    data?: {
      __typename?: 'cms_CircleEntity_content',
      attributes?: {
        __typename?: 'cms_Circle_content',
        thumbnail_image?: {
          __typename?: 'cms_UploadFileEntityResponse_content',
          data?: {
            __typename?: 'cms_UploadFileEntity_content',
            attributes?: {
              __typename?: 'cms_UploadFile_content',
              size: number,
              width?: number,
              height?: number,
              url: string,
              alternativeText?: string
            }
          }
        },
        hero_image?: {
          __typename?: 'cms_UploadFileEntityResponse_content',
          data?: {
            __typename?: 'cms_UploadFileEntity_content',
            attributes?: {
              __typename?: 'cms_UploadFile_content',
              size: number,
              width?: number,
              height?: number,
              url: string,
              alternativeText?: string
            }
          }
        }
      }
    }
  }
};

export type CircleInviteAndCircleDetailsSharedFieldsFragment = {
  __typename?: 'circle',
  id: string,
  name: string,
  checkout_bundle?: {
    __typename?: 'stripe_checkout_bundle',
    key: string
  },
  content: {
    __typename?: 'cms_CircleEntityResponse_content',
    data?: {
      __typename?: 'cms_CircleEntity_content',
      attributes?: {
        __typename?: 'cms_Circle_content',
        summary?: string,
        description?: string,
        related_contents?: {
          __typename?: 'cms_RelatedContentRelationResponseCollection_content',
          data: Array<{
            __typename?: 'cms_RelatedContentEntity_content',
            attributes?: {
              __typename?: 'cms_RelatedContent_content',
              link?: string,
              title?: string,
              entity_id?: string,
              description?: string,
              thumbnail?: {
                __typename?: 'cms_UploadFileEntityResponse_content',
                data?: {
                  __typename?: 'cms_UploadFileEntity_content',
                  attributes?: {
                    __typename?: 'cms_UploadFile_content',
                    size: number,
                    width?: number,
                    height?: number,
                    url: string,
                    alternativeText?: string
                  }
                }
              }
            }
          }>
        },
        thumbnail_image?: {
          __typename?: 'cms_UploadFileEntityResponse_content',
          data?: {
            __typename?: 'cms_UploadFileEntity_content',
            attributes?: {
              __typename?: 'cms_UploadFile_content',
              size: number,
              width?: number,
              height?: number,
              url: string,
              alternativeText?: string
            }
          }
        },
        hero_image?: {
          __typename?: 'cms_UploadFileEntityResponse_content',
          data?: {
            __typename?: 'cms_UploadFileEntity_content',
            attributes?: {
              __typename?: 'cms_UploadFile_content',
              size: number,
              width?: number,
              height?: number,
              url: string,
              alternativeText?: string
            }
          }
        }
      }
    }
  },
  action_items: Array<{
    __typename?: 'circle_action_items_flat',
    action_item_user?: {
      __typename?: 'action_item_user',
      name: string,
      personalized_name: string,
      preference_value_target?: string,
      instance_target: string,
      instance_target_type: enum_action_item_instance_target_type_enum,
      value_rollup_type: enum_metric_rollup_type_enum,
      weekly_instance_target: string,
      circle_action_items: Array<{
        __typename?: 'circle_action_item',
        sort_order?: number
      }>,
      action_item: {
        __typename?: 'action_item',
        id: string,
        thumbnail_image?: string,
        interval: string,
        interval_type: enum_rollup_interval_type_enum,
        interval_count: number,
        preference_value_target?: string,
        labels: Array<{
          __typename?: 'action_item_label',
          label: {
            __typename?: 'label',
            name: string
          }
        }>,
        preference_unit?: Array<{
          __typename?: 'unit',
          display_symbol: string,
          display_symbol_plural: string,
          display_name: string,
          display_name_plural: string
        }>,
        action_item_inputs: Array<{
          __typename?: 'action_item_input',
          id: string,
          input_type: enum_action_item_input_type_enum,
          data_source?: enum_data_source_enum
        }>,
        content: {
          __typename?: 'cms_ActionItemEntityResponse_content',
          data?: {
            __typename?: 'cms_ActionItemEntity_content',
            attributes?: {
              __typename?: 'cms_ActionItem_content',
              description?: string,
              thumbnail_image?: {
                __typename?: 'cms_UploadFileEntityResponse_content',
                data?: {
                  __typename?: 'cms_UploadFileEntity_content',
                  attributes?: {
                    __typename?: 'cms_UploadFile_content',
                    url: string
                  }
                }
              }
            }
          }
        }
      }
    }
  }>
};

export type CircleDetailQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  weekStart: Scalars['LocalDate']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CircleDetailQuery = {
  __typename?: 'query_root',
  circle_by_pk?: {
    __typename?: 'circle',
    is_owner?: boolean,
    public: boolean,
    id: string,
    name: string,
    memberships: Array<{
      __typename?: 'circle_membership',
      user_id: string
    }>,
    weekSummary: {
      __typename?: 'CircleWeekSummary',
      week: DateTypes.LocalDateString,
      targets: number,
      targetsMet: number,
      memberCount: number,
      members: Array<{
        __typename?: 'CircleMemberSummary',
        targets: number,
        targetsMet: number,
        membership: {
          __typename?: 'CircleMembership',
          id: string,
          active: boolean,
          joinedAt: DateTypes.LocalDateString
        },
        profile?: {
          __typename?: 'user_profile',
          photo_url?: string,
          username?: string,
          user?: {
            __typename?: 'user',
            id: string,
            name?: string
          }
        }
      }>
    },
    checkout_bundle?: {
      __typename?: 'stripe_checkout_bundle',
      key: string
    },
    content: {
      __typename?: 'cms_CircleEntityResponse_content',
      data?: {
        __typename?: 'cms_CircleEntity_content',
        attributes?: {
          __typename?: 'cms_Circle_content',
          summary?: string,
          description?: string,
          related_contents?: {
            __typename?: 'cms_RelatedContentRelationResponseCollection_content',
            data: Array<{
              __typename?: 'cms_RelatedContentEntity_content',
              attributes?: {
                __typename?: 'cms_RelatedContent_content',
                link?: string,
                title?: string,
                entity_id?: string,
                description?: string,
                thumbnail?: {
                  __typename?: 'cms_UploadFileEntityResponse_content',
                  data?: {
                    __typename?: 'cms_UploadFileEntity_content',
                    attributes?: {
                      __typename?: 'cms_UploadFile_content',
                      size: number,
                      width?: number,
                      height?: number,
                      url: string,
                      alternativeText?: string
                    }
                  }
                }
              }
            }>
          },
          thumbnail_image?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          },
          hero_image?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          }
        }
      }
    },
    action_items: Array<{
      __typename?: 'circle_action_items_flat',
      action_item_user?: {
        __typename?: 'action_item_user',
        name: string,
        personalized_name: string,
        preference_value_target?: string,
        instance_target: string,
        instance_target_type: enum_action_item_instance_target_type_enum,
        value_rollup_type: enum_metric_rollup_type_enum,
        weekly_instance_target: string,
        circle_action_items: Array<{
          __typename?: 'circle_action_item',
          sort_order?: number
        }>,
        action_item: {
          __typename?: 'action_item',
          id: string,
          thumbnail_image?: string,
          interval: string,
          interval_type: enum_rollup_interval_type_enum,
          interval_count: number,
          preference_value_target?: string,
          labels: Array<{
            __typename?: 'action_item_label',
            label: {
              __typename?: 'label',
              name: string
            }
          }>,
          preference_unit?: Array<{
            __typename?: 'unit',
            display_symbol: string,
            display_symbol_plural: string,
            display_name: string,
            display_name_plural: string
          }>,
          action_item_inputs: Array<{
            __typename?: 'action_item_input',
            id: string,
            input_type: enum_action_item_input_type_enum,
            data_source?: enum_data_source_enum
          }>,
          content: {
            __typename?: 'cms_ActionItemEntityResponse_content',
            data?: {
              __typename?: 'cms_ActionItemEntity_content',
              attributes?: {
                __typename?: 'cms_ActionItem_content',
                description?: string,
                thumbnail_image?: {
                  __typename?: 'cms_UploadFileEntityResponse_content',
                  data?: {
                    __typename?: 'cms_UploadFileEntity_content',
                    attributes?: {
                      __typename?: 'cms_UploadFile_content',
                      url: string
                    }
                  }
                }
              }
            }
          }
        }
      }
    }>
  }
};

export type LeaveCircleMutationVariables = Exact<{
  circleId: Scalars['uuid']['input'];
  keepActions: Scalars['Boolean']['input'];
}>;


export type LeaveCircleMutation = {
  __typename?: 'mutation_root',
  leaveCircle?: {
    __typename?: 'CircleMembership',
    id: string,
    joinedAt: DateTypes.LocalDateString,
    leftAt?: DateTypes.LocalDateString
  }
};

export type RemoveCircleMemberMutationVariables = Exact<{
  membershipId: Scalars['uuid']['input'];
}>;


export type RemoveCircleMemberMutation = {
  __typename?: 'mutation_root',
  removeCircleMember?: {
    __typename?: 'CircleMembership',
    userId: string
  }
};

export type ActionPlanUpdateActionItemUserSharedFieldsFragment = {
  __typename?: 'action_item_user',
  id: string,
  personalized_name: string,
  interval_type: enum_rollup_interval_type_enum,
  weekly_instance_target: string,
  preference_value_target?: string,
  action_item_user_inputs: Array<{
    __typename?: 'action_item_user_input',
    action_item_input: {
      __typename?: 'action_item_input',
      data_source?: enum_data_source_enum,
      input_type: enum_action_item_input_type_enum
    }
  }>,
  action_item: {
    __typename?: 'action_item',
    id: string,
    name: string,
    preference_unit?: Array<{
      __typename?: 'unit',
      display_symbol: string,
      display_symbol_plural: string,
      display_name: string,
      display_name_plural: string
    }>,
    labels: Array<{
      __typename?: 'action_item_label',
      label: {
        __typename?: 'label',
        id: string,
        name: string
      }
    }>
  }
};

export type MonitorCircleActionItemUpdatesQueryVariables = Exact<{ [key: string]: never; }>;


export type MonitorCircleActionItemUpdatesQuery = {
  __typename?: 'query_root',
  circle: Array<{
    __typename?: 'circle',
    id: string,
    name: string,
    membership_action_item_summary: Array<{
      __typename?: 'circle_membership_action_item_summary',
      change_type?: string,
      circle_action_item_id?: string,
      circle_action_item?: {
        __typename?: 'action_item_user',
        id: string,
        personalized_name: string,
        interval_type: enum_rollup_interval_type_enum,
        weekly_instance_target: string,
        preference_value_target?: string,
        action_item_user_inputs: Array<{
          __typename?: 'action_item_user_input',
          action_item_input: {
            __typename?: 'action_item_input',
            data_source?: enum_data_source_enum,
            input_type: enum_action_item_input_type_enum
          }
        }>,
        action_item: {
          __typename?: 'action_item',
          id: string,
          name: string,
          preference_unit?: Array<{
            __typename?: 'unit',
            display_symbol: string,
            display_symbol_plural: string,
            display_name: string,
            display_name_plural: string
          }>,
          labels: Array<{
            __typename?: 'action_item_label',
            label: {
              __typename?: 'label',
              id: string,
              name: string
            }
          }>
        }
      },
      my_version?: {
        __typename?: 'action_item_user',
        id: string,
        personalized_name: string,
        interval_type: enum_rollup_interval_type_enum,
        weekly_instance_target: string,
        preference_value_target?: string,
        action_item_user_inputs: Array<{
          __typename?: 'action_item_user_input',
          action_item_input: {
            __typename?: 'action_item_input',
            data_source?: enum_data_source_enum,
            input_type: enum_action_item_input_type_enum
          }
        }>,
        action_item: {
          __typename?: 'action_item',
          id: string,
          name: string,
          preference_unit?: Array<{
            __typename?: 'unit',
            display_symbol: string,
            display_symbol_plural: string,
            display_name: string,
            display_name_plural: string
          }>,
          labels: Array<{
            __typename?: 'action_item_label',
            label: {
              __typename?: 'label',
              id: string,
              name: string
            }
          }>
        }
      }
    }>,
    content: {
      __typename?: 'cms_CircleEntityResponse_content',
      data?: {
        __typename?: 'cms_CircleEntity_content',
        attributes?: {
          __typename?: 'cms_Circle_content',
          thumbnail_image?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          },
          hero_image?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          }
        }
      }
    }
  }>
};

export type JoinCircleMutationVariables = Exact<{
  inviteId: Scalars['String']['input'];
}>;


export type JoinCircleMutation = {
  __typename?: 'mutation_root',
  joinCircle: {
    __typename?: 'CircleMembership',
    circleId: string
  }
};

export type CircleMembershipsWithOuraActionItemsQueryVariables = Exact<{
  whereClause?: InputMaybe<circle_membership_bool_exp>;
}>;


export type CircleMembershipsWithOuraActionItemsQuery = {
  __typename?: 'query_root',
  me_v2?: {
    __typename?: 'user',
    id: string,
    circle_memberships: Array<{
      __typename?: 'circle_membership',
      id: string
    }>
  }
};

export type OuraActionItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type OuraActionItemsQuery = {
  __typename?: 'query_root',
  me_v2?: {
    __typename?: 'user',
    action_items: Array<{
      __typename?: 'action_item_user',
      id: string
    }>
  }
};

export type GetStreamChatConfigQueryVariables = Exact<{
  circleId?: InputMaybe<Scalars['uuid']['input']>;
  skipCircleQuery?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetStreamChatConfigQuery = {
  __typename?: 'query_root',
  get_stream_chat_config: {
    __typename?: 'StreamUserConfig',
    appId: string,
    apiKey: string,
    userToken: string,
    streamUserId: string
  },
  circle_by_pk?: {
    __typename?: 'circle',
    content: {
      __typename?: 'cms_CircleEntityResponse_content',
      data?: {
        __typename?: 'cms_CircleEntity_content',
        attributes?: {
          __typename?: 'cms_Circle_content',
          thumbnail_image?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          },
          hero_image?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          }
        }
      }
    }
  }
};

export type GetStreamConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStreamConfigQuery = {
  __typename?: 'query_root',
  get_stream_config: {
    __typename?: 'StreamUserConfig',
    appId: string,
    apiKey: string,
    userToken: string,
    streamUserId: string
  }
};

export type AcceptTosMutationVariables = Exact<{
  version: Scalars['String']['input'];
}>;


export type AcceptTosMutation = {
  __typename?: 'mutation_root',
  acceptTermsOfService: {
    __typename?: 'TermsAcceptance',
    acceptedAt: DateTypes.TimestampTZString | string
  }
};

export type ConfirmActionItemVersionUpdatesMutationVariables = Exact<{
  accepted: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  rejected: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type ConfirmActionItemVersionUpdatesMutation = {
  __typename?: 'mutation_root',
  acceptCircleActionItemChanges: Array<{
    __typename?: 'CircleMembershipActionItem',
    id: string
  }>,
  rejectCircleActionItemChanges: Array<{
    __typename?: 'CircleMembershipActionItem',
    id: string
  }>
};

export type CircleInviteShortIdByCircleIdQueryVariables = Exact<{
  circleId: Scalars['uuid']['input'];
}>;


export type CircleInviteShortIdByCircleIdQuery = {
  __typename?: 'query_root',
  circle_invite: Array<{
    __typename?: 'circle_invite',
    short_id: string
  }>
};

export type CreateCircleInviteShortIdMutationVariables = Exact<{
  circleId: Scalars['uuid']['input'];
}>;


export type CreateCircleInviteShortIdMutation = {
  __typename?: 'mutation_root',
  createCircleInvite: {
    __typename?: 'CircleInvite',
    shortId: string
  }
};

export type CircleDefaultImageQueryVariables = Exact<{ [key: string]: never; }>;


export type CircleDefaultImageQuery = {
  __typename?: 'query_root',
  cms?: {
    __typename?: 'cmsQuery',
    circle: {
      __typename?: 'cms_CircleEntityResponse_content',
      data?: {
        __typename?: 'cms_CircleEntity_content',
        attributes?: {
          __typename?: 'cms_Circle_content',
          thumbnail_image?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          }
        }
      }
    }
  }
};

export type CreateCircleMutationVariables = Exact<{
  input: Array<circle_insert_input> | circle_insert_input;
}>;


export type CreateCircleMutation = {
  __typename?: 'mutation_root',
  insert_circle?: {
    __typename?: 'circle_mutation_response',
    returning: Array<{
      __typename?: 'circle',
      id: string
    }>
  }
};

export type GetCircleByIdQueryVariables = Exact<{
  circleId: Scalars['uuid']['input'];
}>;


export type GetCircleByIdQuery = {
  __typename?: 'query_root',
  circle_by_pk?: {
    __typename?: 'circle',
    id: string,
    name: string,
    checkout_bundle?: {
      __typename?: 'stripe_checkout_bundle',
      key: string
    },
    content: {
      __typename?: 'cms_CircleEntityResponse_content',
      data?: {
        __typename?: 'cms_CircleEntity_content',
        attributes?: {
          __typename?: 'cms_Circle_content',
          summary?: string,
          description?: string,
          related_contents?: {
            __typename?: 'cms_RelatedContentRelationResponseCollection_content',
            data: Array<{
              __typename?: 'cms_RelatedContentEntity_content',
              attributes?: {
                __typename?: 'cms_RelatedContent_content',
                link?: string,
                title?: string,
                entity_id?: string,
                description?: string,
                thumbnail?: {
                  __typename?: 'cms_UploadFileEntityResponse_content',
                  data?: {
                    __typename?: 'cms_UploadFileEntity_content',
                    attributes?: {
                      __typename?: 'cms_UploadFile_content',
                      size: number,
                      width?: number,
                      height?: number,
                      url: string,
                      alternativeText?: string
                    }
                  }
                }
              }
            }>
          },
          thumbnail_image?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          },
          hero_image?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          }
        }
      }
    },
    action_items: Array<{
      __typename?: 'circle_action_items_flat',
      action_item_user?: {
        __typename?: 'action_item_user',
        name: string,
        personalized_name: string,
        preference_value_target?: string,
        instance_target: string,
        instance_target_type: enum_action_item_instance_target_type_enum,
        value_rollup_type: enum_metric_rollup_type_enum,
        weekly_instance_target: string,
        circle_action_items: Array<{
          __typename?: 'circle_action_item',
          sort_order?: number
        }>,
        action_item: {
          __typename?: 'action_item',
          id: string,
          thumbnail_image?: string,
          interval: string,
          interval_type: enum_rollup_interval_type_enum,
          interval_count: number,
          preference_value_target?: string,
          labels: Array<{
            __typename?: 'action_item_label',
            label: {
              __typename?: 'label',
              name: string
            }
          }>,
          preference_unit?: Array<{
            __typename?: 'unit',
            display_symbol: string,
            display_symbol_plural: string,
            display_name: string,
            display_name_plural: string
          }>,
          action_item_inputs: Array<{
            __typename?: 'action_item_input',
            id: string,
            input_type: enum_action_item_input_type_enum,
            data_source?: enum_data_source_enum
          }>,
          content: {
            __typename?: 'cms_ActionItemEntityResponse_content',
            data?: {
              __typename?: 'cms_ActionItemEntity_content',
              attributes?: {
                __typename?: 'cms_ActionItem_content',
                description?: string,
                thumbnail_image?: {
                  __typename?: 'cms_UploadFileEntityResponse_content',
                  data?: {
                    __typename?: 'cms_UploadFileEntity_content',
                    attributes?: {
                      __typename?: 'cms_UploadFile_content',
                      url: string
                    }
                  }
                }
              }
            }
          }
        }
      }
    }>
  }
};

export type GetCirclesByInviteQueryVariables = Exact<{
  invite: Scalars['String']['input'];
}>;


export type GetCirclesByInviteQuery = {
  __typename?: 'query_root',
  get_circles_by_invite: Array<{
    __typename?: 'circle',
    id: string,
    name: string,
    checkout_bundle?: {
      __typename?: 'stripe_checkout_bundle',
      key: string
    },
    content: {
      __typename?: 'cms_CircleEntityResponse_content',
      data?: {
        __typename?: 'cms_CircleEntity_content',
        attributes?: {
          __typename?: 'cms_Circle_content',
          summary?: string,
          description?: string,
          related_contents?: {
            __typename?: 'cms_RelatedContentRelationResponseCollection_content',
            data: Array<{
              __typename?: 'cms_RelatedContentEntity_content',
              attributes?: {
                __typename?: 'cms_RelatedContent_content',
                link?: string,
                title?: string,
                entity_id?: string,
                description?: string,
                thumbnail?: {
                  __typename?: 'cms_UploadFileEntityResponse_content',
                  data?: {
                    __typename?: 'cms_UploadFileEntity_content',
                    attributes?: {
                      __typename?: 'cms_UploadFile_content',
                      size: number,
                      width?: number,
                      height?: number,
                      url: string,
                      alternativeText?: string
                    }
                  }
                }
              }
            }>
          },
          thumbnail_image?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          },
          hero_image?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          }
        }
      }
    },
    action_items: Array<{
      __typename?: 'circle_action_items_flat',
      action_item_user?: {
        __typename?: 'action_item_user',
        name: string,
        personalized_name: string,
        preference_value_target?: string,
        instance_target: string,
        instance_target_type: enum_action_item_instance_target_type_enum,
        value_rollup_type: enum_metric_rollup_type_enum,
        weekly_instance_target: string,
        circle_action_items: Array<{
          __typename?: 'circle_action_item',
          sort_order?: number
        }>,
        action_item: {
          __typename?: 'action_item',
          id: string,
          thumbnail_image?: string,
          interval: string,
          interval_type: enum_rollup_interval_type_enum,
          interval_count: number,
          preference_value_target?: string,
          labels: Array<{
            __typename?: 'action_item_label',
            label: {
              __typename?: 'label',
              name: string
            }
          }>,
          preference_unit?: Array<{
            __typename?: 'unit',
            display_symbol: string,
            display_symbol_plural: string,
            display_name: string,
            display_name_plural: string
          }>,
          action_item_inputs: Array<{
            __typename?: 'action_item_input',
            id: string,
            input_type: enum_action_item_input_type_enum,
            data_source?: enum_data_source_enum
          }>,
          content: {
            __typename?: 'cms_ActionItemEntityResponse_content',
            data?: {
              __typename?: 'cms_ActionItemEntity_content',
              attributes?: {
                __typename?: 'cms_ActionItem_content',
                description?: string,
                thumbnail_image?: {
                  __typename?: 'cms_UploadFileEntityResponse_content',
                  data?: {
                    __typename?: 'cms_UploadFileEntity_content',
                    attributes?: {
                      __typename?: 'cms_UploadFile_content',
                      url: string
                    }
                  }
                }
              }
            }
          }
        }
      }
    }>
  }>
};

export type MyProfileDataQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProfileDataQuery = {
  __typename?: 'query_root',
  me_v2?: {
    __typename?: 'user',
    id: string,
    name?: string,
    profile?: {
      __typename?: 'user_profile',
      username?: string,
      photo_url?: string,
      id?: string
    }
  }
};

export type UpdateCircleByCircleIdMutationVariables = Exact<{
  circleId: Scalars['uuid']['input'];
  changes: circle_set_input;
}>;


export type UpdateCircleByCircleIdMutation = {
  __typename?: 'mutation_root',
  update_circle_by_pk?: {
    __typename?: 'circle',
    id: string
  }
};

export type ActionItemUserFieldsFragment = {
  __typename?: 'action_item_user',
  name: string,
  personalized_name: string,
  id: string,
  action_item_user_inputs: Array<{
    __typename?: 'action_item_user_input',
    action_item_input: {
      __typename?: 'action_item_input',
      data_source?: enum_data_source_enum
    }
  }>,
  action_item: {
    __typename?: 'action_item',
    id: string,
    prevent_add_to_circle: boolean,
    prevent_add_to_circle_reason?: string
  }
};

export type CircleSettingsQueryVariables = Exact<{
  circleId: Scalars['uuid']['input'];
}>;


export type CircleSettingsQuery = {
  __typename?: 'query_root',
  circle_by_pk?: {
    __typename?: 'circle',
    id: string,
    name: string,
    public: boolean,
    content: {
      __typename?: 'cms_CircleEntityResponse_content',
      data?: {
        __typename?: 'cms_CircleEntity_content',
        attributes?: {
          __typename?: 'cms_Circle_content',
          thumbnail_image?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          }
        }
      }
    },
    owner?: {
      __typename?: 'user_profile',
      username?: string
    },
    action_items: Array<{
      __typename?: 'circle_action_item',
      disabled: boolean,
      action_item_user?: {
        __typename?: 'action_item_user',
        name: string,
        personalized_name: string,
        id: string,
        action_item_user_inputs: Array<{
          __typename?: 'action_item_user_input',
          action_item_input: {
            __typename?: 'action_item_input',
            data_source?: enum_data_source_enum
          }
        }>,
        action_item: {
          __typename?: 'action_item',
          id: string,
          prevent_add_to_circle: boolean,
          prevent_add_to_circle_reason?: string
        }
      }
    }>
  },
  me_v2?: {
    __typename?: 'user',
    id: string,
    action_items: Array<{
      __typename?: 'action_item_user',
      name: string,
      personalized_name: string,
      id: string,
      action_item_user_inputs: Array<{
        __typename?: 'action_item_user_input',
        action_item_input: {
          __typename?: 'action_item_input',
          data_source?: enum_data_source_enum
        }
      }>,
      action_item: {
        __typename?: 'action_item',
        id: string,
        prevent_add_to_circle: boolean,
        prevent_add_to_circle_reason?: string
      }
    }>
  }
};

export type UpdateCircleActionItemsMutationVariables = Exact<{
  additions?: InputMaybe<Array<circle_action_item_insert_input> | circle_action_item_insert_input>;
  updates?: InputMaybe<Array<circle_action_item_updates> | circle_action_item_updates>;
}>;


export type UpdateCircleActionItemsMutation = {
  __typename?: 'mutation_root',
  insert_circle_action_item?: {
    __typename?: 'circle_action_item_mutation_response',
    affected_rows: number
  },
  update_circle_action_item_many?: Array<{
    __typename?: 'circle_action_item_mutation_response',
    affected_rows: number
  }>
};

export type IsCurrentCircleMemberQueryVariables = Exact<{
  circleId: Scalars['uuid']['input'];
}>;


export type IsCurrentCircleMemberQuery = {
  __typename?: 'query_root',
  me_v2?: {
    __typename?: 'user',
    circle_memberships: Array<{
      __typename?: 'circle_membership',
      circle: {
        __typename?: 'circle',
        name: string
      }
    }>
  }
};

export type ImageAttributesFragment = {
  __typename?: 'cms_UploadFileEntityResponse_content',
  data?: {
    __typename?: 'cms_UploadFileEntity_content',
    attributes?: {
      __typename?: 'cms_UploadFile_content',
      size: number,
      width?: number,
      height?: number,
      url: string,
      alternativeText?: string
    }
  }
};

export type CircleContentByInviteShortIdQueryVariables = Exact<{
  inviteShortId: Scalars['String']['input'];
}>;


export type CircleContentByInviteShortIdQuery = {
  __typename?: 'query_root',
  get_circles_by_invite: Array<{
    __typename?: 'circle',
    name: string,
    content: {
      __typename?: 'cms_CircleEntityResponse_content',
      data?: {
        __typename?: 'cms_CircleEntity_content',
        attributes?: {
          __typename?: 'cms_Circle_content',
          name: string,
          description?: string,
          summary?: string,
          hero_image?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          }
        }
      }
    }
  }>
};

export type VerifyUpdateEmailMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type VerifyUpdateEmailMutation = {
  __typename?: 'mutation_root',
  verify_update_email: {
    __typename?: 'VerifyUpdateEmail',
    message?: string,
    success: boolean
  }
};

export type VerifyUpdateLinkQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type VerifyUpdateLinkQuery = {
  __typename?: 'query_root',
  verify_update_link: {
    __typename?: 'VerifyUpdateEmail',
    message?: string,
    success: boolean
  }
};

export type SaveContactEnquiryMutationVariables = Exact<{
  input: SaveContactEnquiryInput;
}>;


export type SaveContactEnquiryMutation = {
  __typename?: 'mutation_root',
  saveContactEnquiry: {
    __typename?: 'ContactEnquiry',
    id: string,
    orderNumber?: string,
    message: string,
    userId?: string,
    createdAt: DateTypes.TimestampTZString,
    updatedAt: DateTypes.TimestampTZString
  }
};

export type MetricTextSearchQueryVariables = Exact<{
  text: Scalars['String']['input'];
  metricWhereClause?: InputMaybe<metric_bool_exp>;
}>;


export type MetricTextSearchQuery = {
  __typename?: 'query_root',
  metric: Array<{
    __typename?: 'metric',
    id: string,
    display_name: string,
    preference_unit?: string,
    preference_unit_details?: Array<{
      __typename?: 'unit',
      display_symbol: string,
      symbol: string
    }>,
    metric_records: Array<{
      __typename?: 'metric_record',
      data_source: enum_data_source_enum
    }>,
    metric_records_aggregate: {
      __typename?: 'metric_record_aggregate',
      aggregate?: {
        __typename?: 'metric_record_aggregate_fields',
        count: number
      }
    }
  }>
};

export type InsertDashboardMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  chartTabs?: InputMaybe<dashboard_chart_tab_arr_rel_insert_input>;
}>;


export type InsertDashboardMutation = {
  __typename?: 'mutation_root',
  insert_dashboard_one?: {
    __typename?: 'dashboard',
    id: string,
    name: string,
    tabs: Array<{
      __typename?: 'dashboard_tab',
      name: string,
      id: string,
      charts: Array<{
        __typename?: 'dashboard_chart',
        id: string,
        name: string,
        chart_tabs: Array<{
          __typename?: 'dashboard_chart_tab',
          id: string,
          name: string,
          views: Array<{
            __typename?: 'dashboard_chart_view',
            id: string,
            name: string,
            chart_type: enum_chart_type_enum,
            view_metrics: Array<{
              __typename?: 'dashboard_chart_metric',
              id: string,
              name?: string,
              rollup_type: enum_metric_rollup_type_enum,
              interval_count?: number,
              interval_type: enum_rollup_interval_type_enum,
              variant?: string,
              data_source?: enum_data_source_enum,
              metric_id: string,
              metric: {
                __typename?: 'metric',
                metricDisplayName: string,
                preference_unit_details?: Array<{
                  __typename?: 'unit',
                  display_symbol: string,
                  symbol: string
                }>
              }
            }>
          }>
        }>
      }>
    }>
  }
};

export type UpdateDashboardMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: dashboard_set_input;
}>;


export type UpdateDashboardMutation = {
  __typename?: 'mutation_root',
  update_dashboard_by_pk?: {
    __typename?: 'dashboard',
    id: string,
    name: string,
    sort_order?: number
  }
};

export type UpdateDashboardTabMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: dashboard_tab_set_input;
}>;


export type UpdateDashboardTabMutation = {
  __typename?: 'mutation_root',
  update_dashboard_tab_by_pk?: {
    __typename?: 'dashboard_tab',
    id: string,
    dashboard_id: string,
    name: string,
    sort_order?: number
  }
};

export type UpdateDashboardChartMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: dashboard_chart_set_input;
}>;


export type UpdateDashboardChartMutation = {
  __typename?: 'mutation_root',
  update_dashboard_chart_by_pk?: {
    __typename?: 'dashboard_chart',
    id: string,
    dashboard_tab_id: string,
    name: string,
    sort_order?: number
  }
};

export type UpdateDashboardChartTabMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: dashboard_chart_tab_set_input;
}>;


export type UpdateDashboardChartTabMutation = {
  __typename?: 'mutation_root',
  update_dashboard_chart_tab_by_pk?: {
    __typename?: 'dashboard_chart_tab',
    id: string,
    dashboard_chart_id: string,
    name: string,
    sort_order?: number,
    chart_type: enum_chart_type_enum
  }
};

export type UpdateDashboardChartViewMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: dashboard_chart_view_set_input;
}>;


export type UpdateDashboardChartViewMutation = {
  __typename?: 'mutation_root',
  update_dashboard_chart_view_by_pk?: {
    __typename?: 'dashboard_chart_view',
    id: string,
    dashboard_chart_tab_id: string,
    name: string,
    sort_order?: number
  }
};

export type UpdateDashboardChartMetricMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: dashboard_chart_metric_set_input;
}>;


export type UpdateDashboardChartMetricMutation = {
  __typename?: 'mutation_root',
  update_dashboard_chart_metric_by_pk?: {
    __typename?: 'dashboard_chart_metric',
    name?: string,
    rollup_type: enum_metric_rollup_type_enum
  }
};

export type UpdateChartViewChartTypeMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  chart_type: enum_chart_type_enum;
}>;


export type UpdateChartViewChartTypeMutation = {
  __typename?: 'mutation_root',
  update_dashboard_chart_view_by_pk?: {
    __typename?: 'dashboard_chart_view',
    id: string
  }
};

export type InsertDashboardTabMutationVariables = Exact<{
  object: dashboard_tab_insert_input;
}>;


export type InsertDashboardTabMutation = {
  __typename?: 'mutation_root',
  insert_dashboard_tab_one?: {
    __typename?: 'dashboard_tab',
    name: string,
    id: string
  }
};

export type InsertDashboardChartMutationVariables = Exact<{
  object: dashboard_chart_insert_input;
}>;


export type InsertDashboardChartMutation = {
  __typename?: 'mutation_root',
  insert_dashboard_chart_one?: {
    __typename?: 'dashboard_chart',
    name: string,
    id: string
  }
};

export type InsertDashboardChartTabMutationVariables = Exact<{
  object: dashboard_chart_tab_insert_input;
}>;


export type InsertDashboardChartTabMutation = {
  __typename?: 'mutation_root',
  insert_dashboard_chart_tab_one?: {
    __typename?: 'dashboard_chart_tab',
    name: string,
    id: string
  }
};

export type InsertDashboardChartViewMutationVariables = Exact<{
  object: dashboard_chart_view_insert_input;
}>;


export type InsertDashboardChartViewMutation = {
  __typename?: 'mutation_root',
  insert_dashboard_chart_view_one?: {
    __typename?: 'dashboard_chart_view',
    name: string,
    id: string
  }
};

export type InsertDashboardChartMetricMutationVariables = Exact<{
  object: dashboard_chart_metric_insert_input;
}>;


export type InsertDashboardChartMetricMutation = {
  __typename?: 'mutation_root',
  insert_dashboard_chart_metric_one?: {
    __typename?: 'dashboard_chart_metric',
    id: string,
    rollup_type: enum_metric_rollup_type_enum,
    name?: string
  }
};

export type DeleteDashboardMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteDashboardMutation = {
  __typename?: 'mutation_root',
  delete_dashboard_by_pk?: {
    __typename?: 'dashboard',
    name: string
  }
};

export type DeleteDashboardTabMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteDashboardTabMutation = {
  __typename?: 'mutation_root',
  delete_dashboard_tab_by_pk?: {
    __typename?: 'dashboard_tab',
    name: string
  }
};

export type DeleteDashboardChartMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteDashboardChartMutation = {
  __typename?: 'mutation_root',
  delete_dashboard_chart_by_pk?: {
    __typename?: 'dashboard_chart',
    name: string
  }
};

export type DeleteDashboardChartTabMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteDashboardChartTabMutation = {
  __typename?: 'mutation_root',
  delete_dashboard_chart_tab_by_pk?: {
    __typename?: 'dashboard_chart_tab',
    name: string
  }
};

export type DeleteDashboardChartViewMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteDashboardChartViewMutation = {
  __typename?: 'mutation_root',
  delete_dashboard_chart_view_by_pk?: {
    __typename?: 'dashboard_chart_view',
    name: string
  }
};

export type DeleteDashboardChartMetricMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteDashboardChartMetricMutation = {
  __typename?: 'mutation_root',
  delete_dashboard_chart_metric_by_pk?: {
    __typename?: 'dashboard_chart_metric',
    name?: string
  }
};

export type UpdateDashboardTabManyMutationVariables = Exact<{
  updates: Array<dashboard_tab_updates> | dashboard_tab_updates;
}>;


export type UpdateDashboardTabManyMutation = {
  __typename?: 'mutation_root',
  update_dashboard_tab_many?: Array<{
    __typename?: 'dashboard_tab_mutation_response',
    returning: Array<{
      __typename?: 'dashboard_tab',
      name: string,
      id: string,
      sort_order?: number
    }>
  }>
};

export type UpdateDashboardChartManyMutationVariables = Exact<{
  updates: Array<dashboard_chart_updates> | dashboard_chart_updates;
}>;


export type UpdateDashboardChartManyMutation = {
  __typename?: 'mutation_root',
  update_dashboard_chart_many?: Array<{
    __typename?: 'dashboard_chart_mutation_response',
    returning: Array<{
      __typename?: 'dashboard_chart',
      name: string,
      id: string,
      sort_order?: number
    }>
  }>
};

export type UpdateDashboardChartTabManyMutationVariables = Exact<{
  updates: Array<dashboard_chart_tab_updates> | dashboard_chart_tab_updates;
}>;


export type UpdateDashboardChartTabManyMutation = {
  __typename?: 'mutation_root',
  update_dashboard_chart_tab_many?: Array<{
    __typename?: 'dashboard_chart_tab_mutation_response',
    returning: Array<{
      __typename?: 'dashboard_chart_tab',
      name: string,
      id: string,
      sort_order?: number
    }>
  }>
};

export type UpdateDashboardChartViewManyMutationVariables = Exact<{
  updates: Array<dashboard_chart_view_updates> | dashboard_chart_view_updates;
}>;


export type UpdateDashboardChartViewManyMutation = {
  __typename?: 'mutation_root',
  update_dashboard_chart_view_many?: Array<{
    __typename?: 'dashboard_chart_view_mutation_response',
    returning: Array<{
      __typename?: 'dashboard_chart_view',
      name: string,
      id: string,
      sort_order?: number
    }>
  }>
};

export type UpdateDashboardChartMetricManyMutationVariables = Exact<{
  updates: Array<dashboard_chart_metric_updates> | dashboard_chart_metric_updates;
}>;


export type UpdateDashboardChartMetricManyMutation = {
  __typename?: 'mutation_root',
  update_dashboard_chart_metric_many?: Array<{
    __typename?: 'dashboard_chart_metric_mutation_response',
    returning: Array<{
      __typename?: 'dashboard_chart_metric',
      name?: string,
      id: string,
      sort_order?: number
    }>
  }>
};

export type MetricVariantsAndDataSourcesByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type MetricVariantsAndDataSourcesByIdQuery = {
  __typename?: 'query_root',
  metric: Array<{
    __typename?: 'metric',
    data_sources: Array<{
      __typename?: 'metric_record',
      data_source: enum_data_source_enum
    }>,
    variants: Array<{
      __typename?: 'metric_record',
      variant: string
    }>
  }>
};

export type DashboardTargetCardStatusQueryVariables = Exact<{
  metricId: Scalars['uuid']['input'];
  dashboardId: Scalars['uuid']['input'];
}>;


export type DashboardTargetCardStatusQuery = {
  __typename?: 'query_root',
  dashboard_by_pk?: {
    __typename?: 'dashboard',
    target_cards: Array<{
      __typename?: 'dashboard_target_card',
      metric_id: string,
      id: string
    }>
  },
  metric: Array<{
    __typename?: 'metric',
    id: string,
    preference_unit?: string,
    name: string,
    metric_targets: Array<{
      __typename?: 'metric_target',
      preference_target?: string
    }>
  }>
};

export type InsertDashboardTargetCardMutationVariables = Exact<{
  dashboardId?: InputMaybe<Scalars['uuid']['input']>;
  metricId: Scalars['uuid']['input'];
}>;


export type InsertDashboardTargetCardMutation = {
  __typename?: 'mutation_root',
  insert_dashboard_target_card_one?: {
    __typename?: 'dashboard_target_card',
    id: string
  }
};

export type DeleteDashboardTargetCardByIdMutationVariables = Exact<{
  targetCardId: Scalars['uuid']['input'];
}>;


export type DeleteDashboardTargetCardByIdMutation = {
  __typename?: 'mutation_root',
  delete_dashboard_target_card_by_pk?: {
    __typename?: 'dashboard_target_card',
    id: string
  }
};

export type UserCloneDashboardByIdMutationVariables = Exact<{
  input: UserCloneDashboardInputDto;
}>;


export type UserCloneDashboardByIdMutation = {
  __typename?: 'mutation_root',
  clone_dashboard: string
};

export type DashboardChartDataQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  start: Scalars['timestamptz']['input'];
  end: Scalars['timestamptz']['input'];
}>;


export type DashboardChartDataQuery = {
  __typename?: 'query_root',
  dashboard_chart_view_by_pk?: {
    __typename?: 'dashboard_chart_view',
    view_metrics: Array<{
      __typename?: 'dashboard_chart_metric',
      id: string,
      metric_id: string,
      name?: string,
      metric: {
        __typename?: 'metric',
        preference_unit_details?: Array<{
          __typename?: 'unit',
          display_symbol: string
        }>,
        reference_ranges: Array<{
          __typename?: 'reference_range',
          metric_id: string,
          targets: Array<{
            __typename?: 'reference_range_target',
            label?: string,
            color?: string,
            target?: string,
            optimal: boolean
          }>
        }>,
        metric_targets: Array<{
          __typename?: 'metric_target',
          start: DateTypes.TimestampTZString | string,
          end?: DateTypes.TimestampTZString | string,
          preference_target?: string
        }>
      },
      multi_chart_data: Array<{
        __typename?: 'MetricRecordGraphData',
        name: string,
        data_sources: Array<data_source>,
        entries: Array<{
          __typename?: 'MetricRecordGraphDataPoint',
          x: DateTypes.TimestampTZString | string,
          y?: number
        }>
      }>
    }>
  }
};

export type DashboardTargetsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DashboardTargetsQuery = {
  __typename?: 'query_root',
  dashboard_by_pk?: {
    __typename?: 'dashboard',
    id: string,
    target_cards: Array<{
      __typename?: 'dashboard_target_card',
      metric: {
        __typename?: 'metric',
        display_name: string,
        preference_unit_details?: Array<{
          __typename?: 'unit',
          display_symbol: string
        }>,
        metric_targets: Array<{
          __typename?: 'metric_target',
          preference_target?: string,
          value?: {
            __typename?: 'MetricTargetValue',
            value: number,
            datetime_utc: DateTypes.TimestampTZString | string
          }
        }>
      }
    }>
  }
};

export type DashboardFieldsFragment = {
  __typename?: 'dashboard',
  name: string,
  id: string,
  is_template: boolean,
  tabs: Array<{
    __typename?: 'dashboard_tab',
    id: string,
    name: string,
    charts: Array<{
      __typename?: 'dashboard_chart',
      id: string,
      name: string,
      chart_tabs: Array<{
        __typename?: 'dashboard_chart_tab',
        id: string,
        name: string,
        views: Array<{
          __typename?: 'dashboard_chart_view',
          chart_type: enum_chart_type_enum,
          id: string,
          name: string,
          view_metrics: Array<{
            __typename?: 'dashboard_chart_metric',
            id: string,
            name?: string,
            rollup_type: enum_metric_rollup_type_enum,
            interval_type: enum_rollup_interval_type_enum,
            interval_count?: number,
            variant?: string,
            data_source?: enum_data_source_enum,
            metric_id: string,
            metric: {
              __typename?: 'metric',
              id: string,
              metricDisplayName: string,
              preference_unit_details?: Array<{
                __typename?: 'unit',
                display_symbol: string,
                symbol: string
              }>,
              metric_targets: Array<{
                __typename?: 'metric_target',
                id: string,
                start: DateTypes.TimestampTZString | string,
                end?: DateTypes.TimestampTZString | string,
                period?: string,
                preference_target?: string
              }>,
              experiment_metrics: Array<{
                __typename?: 'experiment_metric',
                experiment: {
                  __typename?: 'experiment',
                  name: string,
                  id: string,
                  start_date: DateTypes.TimestampTZString | string,
                  description?: string,
                  end_date?: DateTypes.TimestampTZString | string
                }
              }>
            }
          }>
        }>
      }>
    }>
  }>
};

export type DashboardViewSubscriptionSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
  uuidComparisonExp?: InputMaybe<uuid_comparison_exp>;
}>;


export type DashboardViewSubscriptionSubscription = {
  __typename?: 'subscription_root',
  dashboard_by_pk?: {
    __typename?: 'dashboard',
    name: string,
    id: string,
    is_template: boolean,
    tabs: Array<{
      __typename?: 'dashboard_tab',
      id: string,
      name: string,
      charts: Array<{
        __typename?: 'dashboard_chart',
        id: string,
        name: string,
        chart_tabs: Array<{
          __typename?: 'dashboard_chart_tab',
          id: string,
          name: string,
          views: Array<{
            __typename?: 'dashboard_chart_view',
            chart_type: enum_chart_type_enum,
            id: string,
            name: string,
            view_metrics: Array<{
              __typename?: 'dashboard_chart_metric',
              id: string,
              name?: string,
              rollup_type: enum_metric_rollup_type_enum,
              interval_type: enum_rollup_interval_type_enum,
              interval_count?: number,
              variant?: string,
              data_source?: enum_data_source_enum,
              metric_id: string,
              metric: {
                __typename?: 'metric',
                id: string,
                metricDisplayName: string,
                preference_unit_details?: Array<{
                  __typename?: 'unit',
                  display_symbol: string,
                  symbol: string
                }>,
                metric_targets: Array<{
                  __typename?: 'metric_target',
                  id: string,
                  start: DateTypes.TimestampTZString | string,
                  end?: DateTypes.TimestampTZString | string,
                  period?: string,
                  preference_target?: string
                }>,
                experiment_metrics: Array<{
                  __typename?: 'experiment_metric',
                  experiment: {
                    __typename?: 'experiment',
                    name: string,
                    id: string,
                    start_date: DateTypes.TimestampTZString | string,
                    description?: string,
                    end_date?: DateTypes.TimestampTZString | string
                  }
                }>
              }
            }>
          }>
        }>
      }>
    }>
  }
};

export type DashboardViewQueryQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  uuidComparisonExp?: InputMaybe<uuid_comparison_exp>;
}>;


export type DashboardViewQueryQuery = {
  __typename?: 'query_root',
  dashboard_by_pk?: {
    __typename?: 'dashboard',
    name: string,
    id: string,
    is_template: boolean,
    tabs: Array<{
      __typename?: 'dashboard_tab',
      id: string,
      name: string,
      charts: Array<{
        __typename?: 'dashboard_chart',
        id: string,
        name: string,
        chart_tabs: Array<{
          __typename?: 'dashboard_chart_tab',
          id: string,
          name: string,
          views: Array<{
            __typename?: 'dashboard_chart_view',
            chart_type: enum_chart_type_enum,
            id: string,
            name: string,
            view_metrics: Array<{
              __typename?: 'dashboard_chart_metric',
              id: string,
              name?: string,
              rollup_type: enum_metric_rollup_type_enum,
              interval_type: enum_rollup_interval_type_enum,
              interval_count?: number,
              variant?: string,
              data_source?: enum_data_source_enum,
              metric_id: string,
              metric: {
                __typename?: 'metric',
                id: string,
                metricDisplayName: string,
                preference_unit_details?: Array<{
                  __typename?: 'unit',
                  display_symbol: string,
                  symbol: string
                }>,
                metric_targets: Array<{
                  __typename?: 'metric_target',
                  id: string,
                  start: DateTypes.TimestampTZString | string,
                  end?: DateTypes.TimestampTZString | string,
                  period?: string,
                  preference_target?: string
                }>,
                experiment_metrics: Array<{
                  __typename?: 'experiment_metric',
                  experiment: {
                    __typename?: 'experiment',
                    name: string,
                    id: string,
                    start_date: DateTypes.TimestampTZString | string,
                    description?: string,
                    end_date?: DateTypes.TimestampTZString | string
                  }
                }>
              }
            }>
          }>
        }>
      }>
    }>
  }
};

export type DashboardListQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardListQuery = {
  __typename?: 'query_root',
  dashboard: Array<{
    __typename?: 'dashboard',
    id: string,
    name: string
  }>
};

export type UpdateDashboardManyMutationVariables = Exact<{
  updates: Array<dashboard_updates> | dashboard_updates;
}>;


export type UpdateDashboardManyMutation = {
  __typename?: 'mutation_root',
  update_dashboard_many?: Array<{
    __typename?: 'dashboard_mutation_response',
    returning: Array<{
      __typename?: 'dashboard',
      name: string,
      id: string,
      sort_order?: number
    }>
  }>
};

export type DataSourceRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type DataSourceRequestsQuery = {
  __typename?: 'query_root',
  user_feature_request: Array<{
    __typename?: 'user_feature_request',
    feature_request: {
      __typename?: 'feature_request',
      slug: string,
      name: string
    }
  }>
};

export type RequestDataSourceMutationVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type RequestDataSourceMutation = {
  __typename?: 'mutation_root',
  request_feature: boolean
};

export type UserIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserIntegrationsQuery = {
  __typename?: 'query_root',
  get_user_integrations: Array<{
    __typename?: 'UserIntegration',
    provider: CombinedIntegrationTypes,
    reconnectNeeded: boolean,
    disabled: boolean,
    disabledReason?: string
  }>
};

export type DisableUserIntegrationMutationVariables = Exact<{
  provider: CombinedIntegrationTypes;
}>;


export type DisableUserIntegrationMutation = {
  __typename?: 'mutation_root',
  disable_user_integration: boolean
};

export type ExperimentDashboardListQueryVariables = Exact<{ [key: string]: never; }>;


export type ExperimentDashboardListQuery = {
  __typename?: 'query_root',
  dashboard: Array<{
    __typename?: 'dashboard',
    id: string,
    experiment_id?: string,
    name: string
  }>
};

export type InsertExperimentOneMutationVariables = Exact<{
  object: experiment_insert_input;
}>;


export type InsertExperimentOneMutation = {
  __typename?: 'mutation_root',
  insert_experiment_one?: {
    __typename?: 'experiment',
    id: string,
    name: string,
    description?: string,
    start_date: DateTypes.TimestampTZString | string,
    end_date?: DateTypes.TimestampTZString | string,
    experiment_metrics: Array<{
      __typename?: 'experiment_metric',
      metric: {
        __typename?: 'metric',
        id: string,
        preference_unit?: string,
        name: string
      }
    }>
  }
};

export type ExperimentByDashboardIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ExperimentByDashboardIdQuery = {
  __typename?: 'query_root',
  experiment: Array<{
    __typename?: 'experiment',
    id: string,
    name: string,
    end_date?: DateTypes.TimestampTZString | string,
    start_date: DateTypes.TimestampTZString | string,
    description?: string,
    experiment_metrics: Array<{
      __typename?: 'experiment_metric',
      metric: {
        __typename?: 'metric',
        id: string,
        preference_unit?: string,
        name: string
      }
    }>
  }>
};

export type UpdateExperimentMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  baseChanges: experiment_set_input;
  experiments: Array<experiment_metric_insert_input> | experiment_metric_insert_input;
}>;


export type UpdateExperimentMutation = {
  __typename?: 'mutation_root',
  update_experiment_by_pk?: {
    __typename?: 'experiment',
    id: string,
    name: string,
    end_date?: DateTypes.TimestampTZString | string,
    start_date: DateTypes.TimestampTZString | string,
    description?: string,
    experiment_metrics: Array<{
      __typename?: 'experiment_metric',
      metric: {
        __typename?: 'metric',
        id: string,
        name: string
      }
    }>
  },
  insert_experiment_metric?: {
    __typename?: 'experiment_metric_mutation_response',
    returning: Array<{
      __typename?: 'experiment_metric',
      experiment: {
        __typename?: 'experiment',
        experiment_metrics: Array<{
          __typename?: 'experiment_metric',
          metric: {
            __typename?: 'metric',
            id: string,
            preference_unit?: string,
            name: string
          }
        }>
      }
    }>
  }
};

export type DeleteExperimentMetricMutationVariables = Exact<{
  experimentId: Scalars['uuid']['input'];
  metricId: Scalars['uuid']['input'];
}>;


export type DeleteExperimentMetricMutation = {
  __typename?: 'mutation_root',
  delete_experiment_metric?: {
    __typename?: 'experiment_metric_mutation_response',
    returning: Array<{
      __typename?: 'experiment_metric',
      metric_id: string
    }>
  }
};

export type DeleteExperimentMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteExperimentMutation = {
  __typename?: 'mutation_root',
  delete_experiment_by_pk?: {
    __typename?: 'experiment',
    name: string
  }
};

export type UpdateExperimentMetricManyMutationVariables = Exact<{
  updates: Array<experiment_metric_updates> | experiment_metric_updates;
}>;


export type UpdateExperimentMetricManyMutation = {
  __typename?: 'mutation_root',
  update_experiment_metric_many?: Array<{
    __typename?: 'experiment_metric_mutation_response',
    returning: Array<{
      __typename?: 'experiment_metric',
      sort_order?: number
    }>
  }>
};

export type FastingMetricQueryVariables = Exact<{
  namespace: Scalars['String']['input'];
  key: Scalars['String']['input'];
  numberOfPreviousFasts?: InputMaybe<Scalars['Int']['input']>;
  end: Scalars['timestamptz']['input'];
}>;


export type FastingMetricQuery = {
  __typename?: 'query_root',
  metric: Array<{
    __typename?: 'metric',
    id: string,
    currentFast: Array<{
      __typename?: 'metric_record',
      id: string,
      datetime_utc: DateTypes.TimestampTZString | string,
      value?: number
    }>,
    previousFasts: Array<{
      __typename?: 'metric_record',
      id: string,
      datetime_utc: DateTypes.TimestampTZString | string,
      value?: number
    }>,
    active_streak?: {
      __typename?: 'Streak',
      period_start: DateTypes.LocalDateTimeString | string,
      period_end: DateTypes.LocalDateTimeString | string,
      is_active: boolean,
      duration: number,
      unit: string,
      preference_target: string,
      period: {
        __typename?: 'Interval',
        days?: number,
        weeks?: number,
        months?: number,
        years?: number
      }
    },
    most_recent_streak?: {
      __typename?: 'Streak',
      period_start: DateTypes.LocalDateTimeString | string,
      period_end: DateTypes.LocalDateTimeString | string,
      is_active: boolean,
      duration: number,
      unit: string,
      preference_target: string,
      period: {
        __typename?: 'Interval',
        days?: number,
        weeks?: number,
        months?: number,
        years?: number
      }
    }
  }>
};

export type CreateAndUpdateMetricRecordsMutationVariables = Exact<{
  createObjects?: Array<InputMaybe<MetricRecordCreateInputType>> | InputMaybe<MetricRecordCreateInputType>;
  updateObjects?: InputMaybe<Array<InputMaybe<MetricRecordUpdateWithIdInputType>> | InputMaybe<MetricRecordUpdateWithIdInputType>>;
  dataSource: data_source;
}>;


export type CreateAndUpdateMetricRecordsMutation = {
  __typename?: 'mutation_root',
  create_metric_records: Array<{
    __typename?: 'MetricRecord',
    id: string
  }>,
  update_metric_records: Array<{
    __typename?: 'MetricRecord',
    id: string
  }>
};

export type DeleteFilevaultFileByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteFilevaultFileByIdMutation = {
  __typename?: 'mutation_root',
  delete_filevault_file_by_id: {
    __typename?: 'FileVaultFileId',
    id: string
  }
};

export type FileVaultFilesQueryVariables = Exact<{ [key: string]: never; }>;


export type FileVaultFilesQuery = {
  __typename?: 'query_root',
  files: Array<{
    __typename?: 'user_file_vault',
    id: string,
    name: string,
    file_type: string,
    s3_bucket: string,
    s3_path: string,
    created_at: DateTypes.TimestampTZString | string,
    updated_at: DateTypes.TimestampTZString | string,
    download: {
      __typename?: 'FileVaultDownloadUrl',
      url?: string
    }
  }>
};

export type GenerateVaultUploadUrlMutationVariables = Exact<{
  filename: Scalars['String']['input'];
  fileUploadType?: InputMaybe<enum_file_vault_file_type_enum>;
}>;


export type GenerateVaultUploadUrlMutation = {
  __typename?: 'mutation_root',
  filevault_upload_url: {
    __typename?: 'FileVaultUploadUrl',
    id: string,
    url: string,
    s3_path: string
  }
};

export type GlucoseChartQueryVariables = Exact<{
  start: Scalars['timestamptz']['input'];
  end: Scalars['timestamptz']['input'];
}>;


export type GlucoseChartQuery = {
  __typename?: 'query_root',
  metric: Array<{
    __typename?: 'metric',
    id: string,
    reference_ranges: Array<{
      __typename?: 'reference_range',
      metric_id: string,
      targets: Array<{
        __typename?: 'reference_range_target',
        label?: string,
        color?: string,
        target?: string,
        optimal: boolean
      }>
    }>,
    metric_targets: Array<{
      __typename?: 'metric_target',
      start: DateTypes.TimestampTZString | string,
      end?: DateTypes.TimestampTZString | string,
      preference_target?: string
    }>,
    metric_chart: {
      __typename?: 'MetricRecordGraphData',
      name: string,
      unit: string,
      data_sources: Array<data_source>,
      entries: Array<{
        __typename?: 'MetricRecordGraphDataPoint',
        x: DateTypes.TimestampTZString | string,
        y?: number
      }>
    }
  }>
};

export type UserGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserGroupsQuery = {
  __typename?: 'query_root',
  user_group: Array<{
    __typename?: 'user_group',
    id: string,
    name: string,
    experts: Array<{
      __typename?: 'user_group_expert',
      user: {
        __typename?: 'user',
        id: string,
        name?: string,
        email?: string
      }
    }>,
    members: Array<{
      __typename?: 'user_group_member',
      user: {
        __typename?: 'user',
        id: string,
        name?: string,
        email?: string
      }
    }>
  }>
};

export type InsertUserTaskAssignmentMutationVariables = Exact<{
  name: Scalars['String']['input'];
  details: Scalars['String']['input'];
}>;


export type InsertUserTaskAssignmentMutation = {
  __typename?: 'mutation_root',
  insert_user_task_assignment_one?: {
    __typename?: 'user_task_assignment',
    id: string
  }
};

export type HelpPageFaqQueryVariables = Exact<{ [key: string]: never; }>;


export type HelpPageFaqQuery = {
  __typename?: 'query_root',
  helpPageFaqCms?: {
    __typename?: 'cmsQuery',
    helpPageFaq?: {
      __typename?: 'cms_HelpPageFaqEntityResponse_content',
      data?: {
        __typename?: 'cms_HelpPageFaqEntity_content',
        attributes?: {
          __typename?: 'cms_HelpPageFaq_content',
          QA_Item?: Array<{
            __typename?: 'cms_ComponentDualMarkdownTextsDualMarkdownTexts_content',
            first?: string,
            second?: string
          }>
        }
      }
    }
  }
};

export type UserDevicesTokensQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDevicesTokensQuery = {
  __typename?: 'query_root',
  oauth2_token: Array<{
    __typename?: 'oauth2_token',
    provider: string
  }>,
  oauth1_token: Array<{
    __typename?: 'oauth1_token',
    provider: string
  }>
};

export type BackfillEventSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type BackfillEventSubscription = {
  __typename?: 'subscription_root',
  integration_backfill_event: Array<{
    __typename?: 'integration_backfill_event',
    status: enum_integration_backfill_status_enum,
    integration: enum_data_source_enum
  }>
};

export type WorkoutHeartRatesCompleteQueryVariables = Exact<{
  metricRecordGroupId: Scalars['uuid']['input'];
}>;


export type WorkoutHeartRatesCompleteQuery = {
  __typename?: 'query_root',
  metric_record_group_by_pk?: {
    __typename?: 'metric_record_group',
    datetime_utc: DateTypes.TimestampTZString | string,
    metric_records: Array<{
      __typename?: 'metric_record',
      value_time_series?: any
    }>
  }
};

export type StreakFieldsFragment = {
  __typename?: 'Streak',
  period_start: DateTypes.LocalDateTimeString | string,
  period_end: DateTypes.LocalDateTimeString | string,
  is_active: boolean,
  duration: number,
  unit: string,
  preference_target: string,
  period: {
    __typename?: 'Interval',
    days?: number,
    weeks?: number,
    months?: number,
    years?: number
  }
};

export type MetricStreaksFieldsFragment = {
  __typename?: 'metric',
  active_streak?: {
    __typename?: 'Streak',
    period_start: DateTypes.LocalDateTimeString | string,
    period_end: DateTypes.LocalDateTimeString | string,
    is_active: boolean,
    duration: number,
    unit: string,
    preference_target: string,
    period: {
      __typename?: 'Interval',
      days?: number,
      weeks?: number,
      months?: number,
      years?: number
    }
  },
  most_recent_streak?: {
    __typename?: 'Streak',
    period_start: DateTypes.LocalDateTimeString | string,
    period_end: DateTypes.LocalDateTimeString | string,
    is_active: boolean,
    duration: number,
    unit: string,
    preference_target: string,
    period: {
      __typename?: 'Interval',
      days?: number,
      weeks?: number,
      months?: number,
      years?: number
    }
  }
};

export type HydrationTileQueryVariables = Exact<{
  start: Scalars['timestamptz']['input'];
  end: Scalars['timestamptz']['input'];
  namespace: Scalars['String']['input'];
  key: Scalars['String']['input'];
}>;


export type HydrationTileQuery = {
  __typename?: 'query_root',
  metric: Array<{
    __typename?: 'metric',
    id: string,
    preference_unit_details?: Array<{
      __typename?: 'unit',
      display_symbol: string,
      symbol: string
    }>,
    metric_records_rollup: Array<{
      __typename?: 'MetricRecordRollup',
      sum?: number,
      day: DateTypes.TimestampTZString | string
    }>,
    active_streak?: {
      __typename?: 'Streak',
      period_start: DateTypes.LocalDateTimeString | string,
      period_end: DateTypes.LocalDateTimeString | string,
      is_active: boolean,
      duration: number,
      unit: string,
      preference_target: string,
      period: {
        __typename?: 'Interval',
        days?: number,
        weeks?: number,
        months?: number,
        years?: number
      }
    },
    most_recent_streak?: {
      __typename?: 'Streak',
      period_start: DateTypes.LocalDateTimeString | string,
      period_end: DateTypes.LocalDateTimeString | string,
      is_active: boolean,
      duration: number,
      unit: string,
      preference_target: string,
      period: {
        __typename?: 'Interval',
        days?: number,
        weeks?: number,
        months?: number,
        years?: number
      }
    }
  }>
};

export type GarminActivityQueryVariables = Exact<{
  timestamp: Scalars['timestamptz']['input'];
}>;


export type GarminActivityQuery = {
  __typename?: 'query_root',
  metric_record_group: Array<{
    __typename?: 'metric_record_group',
    datetime_utc: DateTypes.TimestampTZString | string,
    metric_records: Array<{
      __typename?: 'metric_record',
      value?: number,
      metric: {
        __typename?: 'metric',
        key: string,
        id: string,
        unit?: string
      }
    }>
  }>
};

export type GarminSleepQueryVariables = Exact<{
  date: Scalars['date']['input'];
}>;


export type GarminSleepQuery = {
  __typename?: 'query_root',
  metric_record_group: Array<{
    __typename?: 'metric_record_group',
    local_date?: string,
    metric_records: Array<{
      __typename?: 'metric_record',
      value?: number,
      metric: {
        __typename?: 'metric',
        id: string,
        key: string,
        unit?: string
      }
    }>
  }>
};

export type OuraActivityRecordFragment = {
  __typename?: 'metric_record',
  value?: number,
  metric: {
    __typename?: 'metric',
    id: string
  }
};

export type OuraActivityQueryVariables = Exact<{
  timestamp: Scalars['timestamptz']['input'];
}>;


export type OuraActivityQuery = {
  __typename?: 'query_root',
  latestActivitySummary: Array<{
    __typename?: 'metric_record_group',
    datetime_utc: DateTypes.TimestampTZString | string,
    score: Array<{
      __typename?: 'metric_record',
      value?: number,
      metric: {
        __typename?: 'metric',
        id: string
      }
    }>,
    targetCalories: Array<{
      __typename?: 'metric_record',
      value?: number,
      metric: {
        __typename?: 'metric',
        id: string
      }
    }>,
    inactive: Array<{
      __typename?: 'metric_record',
      value?: number,
      metric: {
        __typename?: 'metric',
        id: string
      }
    }>,
    cal_total: Array<{
      __typename?: 'metric_record',
      value?: number,
      metric: {
        __typename?: 'metric',
        id: string
      }
    }>,
    steps: Array<{
      __typename?: 'metric_record',
      value?: number,
      metric: {
        __typename?: 'metric',
        id: string
      }
    }>,
    daily_movement: Array<{
      __typename?: 'metric_record',
      value?: number,
      metric: {
        __typename?: 'metric',
        id: string
      }
    }>,
    high: Array<{
      __typename?: 'metric_record',
      value?: number,
      metric: {
        __typename?: 'metric',
        id: string
      }
    }>,
    medium: Array<{
      __typename?: 'metric_record',
      value?: number,
      metric: {
        __typename?: 'metric',
        id: string
      }
    }>,
    low: Array<{
      __typename?: 'metric_record',
      value?: number,
      metric: {
        __typename?: 'metric',
        id: string
      }
    }>,
    cal_active: Array<{
      __typename?: 'metric_record',
      value?: number,
      metric: {
        __typename?: 'metric',
        id: string
      }
    }>
  }>
};

export type OuraReadinessQueryVariables = Exact<{
  date?: InputMaybe<Scalars['LocalDate']['input']>;
}>;


export type OuraReadinessQuery = {
  __typename?: 'query_root',
  oura_sleep_summary?: {
    __typename?: 'OuraSleepSummary',
    datetime: DateTypes.TimestampTZString | string,
    id: DateTypes.TimestampTZString | string,
    readiness_score?: {
      __typename?: 'OuraMetric',
      value: number,
      metricId: string
    },
    heart_rate_min?: {
      __typename?: 'OuraMetric',
      value: number,
      unit: string,
      metricId: string
    },
    hrv_average?: {
      __typename?: 'OuraMetric',
      value: number,
      unit: string,
      metricId: string
    },
    temperature_deviation?: {
      __typename?: 'OuraMetric',
      value: number,
      unit: string,
      metricId: string
    },
    respiratory_rate_average?: {
      __typename?: 'OuraMetric',
      value: number,
      unit: string,
      metricId: string
    }
  }
};

export type OuraSleepQueryVariables = Exact<{
  date: Scalars['LocalDate']['input'];
}>;


export type OuraSleepQuery = {
  __typename?: 'query_root',
  oura_sleep_summary?: {
    __typename?: 'OuraSleepSummary',
    datetime: DateTypes.TimestampTZString | string,
    id: DateTypes.TimestampTZString | string,
    score?: {
      __typename?: 'OuraMetric',
      value: number,
      metricId: string
    },
    duration?: {
      __typename?: 'OuraMetric',
      value: number,
      metricId: string
    },
    awake?: {
      __typename?: 'OuraMetric',
      value: number,
      metricId: string
    },
    rem?: {
      __typename?: 'OuraMetric',
      value: number,
      metricId: string
    },
    light?: {
      __typename?: 'OuraMetric',
      value: number,
      metricId: string
    },
    deep?: {
      __typename?: 'OuraMetric',
      value: number,
      metricId: string
    },
    efficiency?: {
      __typename?: 'OuraMetric',
      value: number,
      metricId: string
    },
    hr_average?: {
      __typename?: 'OuraMetric',
      value: number,
      metricId: string
    }
  }
};

export type WithingsMostRecentBodyCompQueryVariables = Exact<{
  namespace: Scalars['String']['input'];
  weightKey: Scalars['String']['input'];
  bodyFatPercentageKey: Scalars['String']['input'];
  muscleMassKey: Scalars['String']['input'];
  boneMassKey: Scalars['String']['input'];
  fatMassKgKey: Scalars['String']['input'];
  timestamp: Scalars['timestamptz']['input'];
}>;


export type WithingsMostRecentBodyCompQuery = {
  __typename?: 'query_root',
  metric: Array<{
    __typename?: 'metric',
    id: string,
    name: string,
    preference_unit_details?: Array<{
      __typename?: 'unit',
      display_symbol: string
    }>,
    metric_records: Array<{
      __typename?: 'metric_record',
      datetime_utc: DateTypes.TimestampTZString | string,
      value?: number
    }>
  }>
};

export type HomePageShopModuleQueryVariables = Exact<{ [key: string]: never; }>;


export type HomePageShopModuleQuery = {
  __typename?: 'query_root',
  cms?: {
    __typename?: 'cmsQuery',
    homePageShopModule?: {
      __typename?: 'cms_HomePageShopModuleEntityResponse_content',
      data?: {
        __typename?: 'cms_HomePageShopModuleEntity_content',
        attributes?: {
          __typename?: 'cms_HomePageShopModule_content',
          Content_Item?: Array<{
            __typename?: 'cms_ComponentShopModuleProductShopModuleProduct_content',
            Layout?: cms_ENUM_COMPONENTSHOPMODULEPRODUCTSHOPMODULEPRODUCT_LAYOUT_content,
            Pill_Text?: string,
            Name?: string,
            Summary?: string,
            Mobile_Summary?: string,
            Cta_Text?: string,
            Link?: string,
            Box_Images?: {
              __typename?: 'cms_UploadFileRelationResponseCollection_content',
              data: Array<{
                __typename?: 'cms_UploadFileEntity_content',
                attributes?: {
                  __typename?: 'cms_UploadFile_content',
                  url: string,
                  alternativeText?: string
                }
              }>
            },
            Mobile_Box_Images?: {
              __typename?: 'cms_UploadFileRelationResponseCollection_content',
              data: Array<{
                __typename?: 'cms_UploadFileEntity_content',
                attributes?: {
                  __typename?: 'cms_UploadFile_content',
                  url: string,
                  alternativeText?: string
                }
              }>
            },
            Background_Image?: {
              __typename?: 'cms_UploadFileEntityResponse_content',
              data?: {
                __typename?: 'cms_UploadFileEntity_content',
                attributes?: {
                  __typename?: 'cms_UploadFile_content',
                  url: string,
                  alternativeText?: string
                }
              }
            }
          }>
        }
      }
    }
  }
};

export type ProductCatalogFieldsFragment = {
  __typename?: 'stripe_product',
  slug?: string,
  id: string,
  name: string,
  price_free_member?: {
    __typename?: 'stripe_price_free_member',
    price_usd?: number
  },
  price_paid_member?: {
    __typename?: 'stripe_price_paid_member',
    price_usd?: number
  },
  price_current?: {
    __typename?: 'stripe_price',
    price_usd: number
  }
};

export type GetFeaturedPackagesQueryVariables = Exact<{
  countryAvailability: Scalars['_text']['input'];
}>;


export type GetFeaturedPackagesQuery = {
  __typename?: 'query_root',
  advanced: Array<{
    __typename?: 'stripe_product',
    slug?: string,
    id: string,
    name: string,
    price_free_member?: {
      __typename?: 'stripe_price_free_member',
      price_usd?: number
    },
    price_paid_member?: {
      __typename?: 'stripe_price_paid_member',
      price_usd?: number
    },
    price_current?: {
      __typename?: 'stripe_price',
      price_usd: number
    }
  }>,
  foundation: Array<{
    __typename?: 'stripe_product',
    slug?: string,
    id: string,
    name: string,
    price_free_member?: {
      __typename?: 'stripe_price_free_member',
      price_usd?: number
    },
    price_paid_member?: {
      __typename?: 'stripe_price_paid_member',
      price_usd?: number
    },
    price_current?: {
      __typename?: 'stripe_price',
      price_usd: number
    }
  }>
};

export type DeleteUserHomeTilesMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteUserHomeTilesMutation = {
  __typename?: 'mutation_root',
  delete_user_home_tile?: {
    __typename?: 'user_home_tile_mutation_response',
    affected_rows: number
  }
};

export type MostRecentAmRecordQueryVariables = Exact<{
  beforeExpression: metric_record_bool_exp;
}>;


export type MostRecentAmRecordQuery = {
  __typename?: 'query_root',
  history: Array<{
    __typename?: 'metric',
    metric_records: Array<{
      __typename?: 'metric_record',
      datetime_utc: DateTypes.TimestampTZString | string
    }>
  }>
};

export type CurrentBloodGlucoseQueryVariables = Exact<{
  afterExpression: metric_record_bool_exp;
  beforeExpression: metric_record_bool_exp;
}>;


export type CurrentBloodGlucoseQuery = {
  __typename?: 'query_root',
  history: Array<{
    __typename?: 'metric',
    metric_records: Array<{
      __typename?: 'metric_record',
      value?: number,
      datetime_utc: DateTypes.TimestampTZString | string,
      data_source: enum_data_source_enum
    }>
  }>,
  current: Array<{
    __typename?: 'metric',
    all: Array<{
      __typename?: 'metric_record',
      value?: number,
      datetime_utc: DateTypes.TimestampTZString | string,
      data_source: enum_data_source_enum
    }>,
    below: {
      __typename?: 'metric_record_aggregate',
      aggregate?: {
        __typename?: 'metric_record_aggregate_fields',
        count: number
      }
    },
    within: {
      __typename?: 'metric_record_aggregate',
      aggregate?: {
        __typename?: 'metric_record_aggregate_fields',
        count: number
      }
    },
    above: {
      __typename?: 'metric_record_aggregate',
      aggregate?: {
        __typename?: 'metric_record_aggregate_fields',
        count: number
      }
    }
  }>
};

export type MostRecentBloodPressureQueryVariables = Exact<{
  namespace: Scalars['String']['input'];
  timestamp: Scalars['timestamptz']['input'];
}>;


export type MostRecentBloodPressureQuery = {
  __typename?: 'query_root',
  metric: Array<{
    __typename?: 'metric',
    name: string,
    unit?: string,
    metric_records: Array<{
      __typename?: 'metric_record',
      datetime_utc: DateTypes.TimestampTZString | string,
      value?: number
    }>
  }>
};

export type LEGACY_MostRecentBodyCompQueryVariables = Exact<{
  namespace: Scalars['String']['input'];
  weightKey: Scalars['String']['input'];
  bodyFatPercentageKey: Scalars['String']['input'];
  muscleMassKey: Scalars['String']['input'];
  boneMassKey: Scalars['String']['input'];
  fatMassKgKey: Scalars['String']['input'];
  timestamp: Scalars['timestamptz']['input'];
}>;


export type LEGACY_MostRecentBodyCompQuery = {
  __typename?: 'query_root',
  weightHistory: Array<{
    __typename?: 'metric_record',
    value?: number
  }>,
  bodyFatHistory: Array<{
    __typename?: 'metric_record',
    value?: number
  }>,
  metric: Array<{
    __typename?: 'metric',
    name: string,
    unit?: string,
    preference_unit_details?: Array<{
      __typename?: 'unit',
      display_symbol: string
    }>,
    metric_records: Array<{
      __typename?: 'metric_record',
      datetime_utc: DateTypes.TimestampTZString | string,
      value?: number
    }>
  }>
};

export type LEGACY_GarminActivityQueryVariables = Exact<{
  timestamp: Scalars['timestamptz']['input'];
}>;


export type LEGACY_GarminActivityQuery = {
  __typename?: 'query_root',
  history: Array<{
    __typename?: 'metric_record',
    value?: number
  }>,
  metric_record_group: Array<{
    __typename?: 'metric_record_group',
    datetime_utc: DateTypes.TimestampTZString | string,
    metric_records: Array<{
      __typename?: 'metric_record',
      value?: number,
      metric: {
        __typename?: 'metric',
        key: string,
        unit?: string
      }
    }>
  }>
};

export type LEGACY_GarminSleepQueryVariables = Exact<{
  date: Scalars['date']['input'];
}>;


export type LEGACY_GarminSleepQuery = {
  __typename?: 'query_root',
  metric_record_group: Array<{
    __typename?: 'metric_record_group',
    local_date?: string,
    metric_records: Array<{
      __typename?: 'metric_record',
      value?: number,
      metric: {
        __typename?: 'metric',
        key: string,
        unit?: string
      }
    }>
  }>
};

export type GarminWorkoutsQueryVariables = Exact<{
  endTime: Scalars['timestamptz']['input'];
  startTime: Scalars['timestamptz']['input'];
  workoutSessionKey: Scalars['String']['input'];
  activitySummaryKey: Scalars['String']['input'];
}>;


export type GarminWorkoutsQuery = {
  __typename?: 'query_root',
  metric_record_group: Array<{
    __typename?: 'metric_record_group',
    datetime_utc: DateTypes.TimestampTZString | string,
    metric_records: Array<{
      __typename?: 'metric_record',
      variant: string,
      value?: number,
      metric: {
        __typename?: 'metric',
        key: string,
        preference_unit_details?: Array<{
          __typename?: 'unit',
          display_symbol: string
        }>
      }
    }>
  }>
};

export type LEGACY_OuraActivityRecordFragment = {
  __typename?: 'metric_record',
  datetime_utc: DateTypes.TimestampTZString | string,
  value?: number,
  metric: {
    __typename?: 'metric',
    key: string,
    name: string,
    unit?: string
  }
};

export type LEGACY_OuraActivityQueryVariables = Exact<{
  timestamp: Scalars['timestamptz']['input'];
}>;


export type LEGACY_OuraActivityQuery = {
  __typename?: 'query_root',
  latestActivitySummary: Array<{
    __typename?: 'metric_record_group',
    datetime_utc: DateTypes.TimestampTZString | string,
    score: Array<{
      __typename?: 'metric_record',
      datetime_utc: DateTypes.TimestampTZString | string,
      value?: number,
      metric: {
        __typename?: 'metric',
        key: string,
        name: string,
        unit?: string
      }
    }>,
    inactive: Array<{
      __typename?: 'metric_record',
      datetime_utc: DateTypes.TimestampTZString | string,
      value?: number,
      metric: {
        __typename?: 'metric',
        key: string,
        name: string,
        unit?: string
      }
    }>,
    cal_total: Array<{
      __typename?: 'metric_record',
      datetime_utc: DateTypes.TimestampTZString | string,
      value?: number,
      metric: {
        __typename?: 'metric',
        key: string,
        name: string,
        unit?: string
      }
    }>,
    steps: Array<{
      __typename?: 'metric_record',
      datetime_utc: DateTypes.TimestampTZString | string,
      value?: number,
      metric: {
        __typename?: 'metric',
        key: string,
        name: string,
        unit?: string
      }
    }>,
    daily_movement: Array<{
      __typename?: 'metric_record',
      datetime_utc: DateTypes.TimestampTZString | string,
      value?: number,
      metric: {
        __typename?: 'metric',
        key: string,
        name: string,
        unit?: string
      }
    }>,
    high: Array<{
      __typename?: 'metric_record',
      datetime_utc: DateTypes.TimestampTZString | string,
      value?: number,
      metric: {
        __typename?: 'metric',
        key: string,
        name: string,
        unit?: string
      }
    }>,
    medium: Array<{
      __typename?: 'metric_record',
      datetime_utc: DateTypes.TimestampTZString | string,
      value?: number,
      metric: {
        __typename?: 'metric',
        key: string,
        name: string,
        unit?: string
      }
    }>,
    low: Array<{
      __typename?: 'metric_record',
      datetime_utc: DateTypes.TimestampTZString | string,
      value?: number,
      metric: {
        __typename?: 'metric',
        key: string,
        name: string,
        unit?: string
      }
    }>,
    cal_active: Array<{
      __typename?: 'metric_record',
      datetime_utc: DateTypes.TimestampTZString | string,
      value?: number,
      metric: {
        __typename?: 'metric',
        key: string,
        name: string,
        unit?: string
      }
    }>
  }>,
  activityScoreHistory: Array<{
    __typename?: 'metric_record',
    datetime_utc: DateTypes.TimestampTZString | string,
    value?: number
  }>
};

export type LEGACY_OuraReadinessQueryVariables = Exact<{
  date?: InputMaybe<Scalars['LocalDate']['input']>;
}>;


export type LEGACY_OuraReadinessQuery = {
  __typename?: 'query_root',
  oura_sleep_summary?: {
    __typename?: 'OuraSleepSummary',
    datetime: DateTypes.TimestampTZString | string,
    day: DateTypes.LocalDateString,
    id: DateTypes.TimestampTZString | string,
    readiness_score?: {
      __typename?: 'OuraMetric',
      value: number
    },
    heart_rate_min?: {
      __typename?: 'OuraMetric',
      value: number,
      unit: string
    },
    hrv_average?: {
      __typename?: 'OuraMetric',
      value: number,
      unit: string
    },
    temperature_deviation?: {
      __typename?: 'OuraMetric',
      value: number,
      unit: string
    },
    respiratory_rate_average?: {
      __typename?: 'OuraMetric',
      value: number,
      unit: string
    },
    readiness_score_history: Array<{
      __typename?: 'OuraScoreHistory',
      value: number,
      datetime: DateTypes.TimestampTZString | string
    }>
  }
};

export type LEGACY_OuraSleepQueryVariables = Exact<{
  date: Scalars['LocalDate']['input'];
}>;


export type LEGACY_OuraSleepQuery = {
  __typename?: 'query_root',
  oura_sleep_summary?: {
    __typename?: 'OuraSleepSummary',
    datetime: DateTypes.TimestampTZString | string,
    day: DateTypes.LocalDateString,
    id: DateTypes.TimestampTZString | string,
    score?: {
      __typename?: 'OuraMetric',
      value: number
    },
    duration?: {
      __typename?: 'OuraMetric',
      value: number
    },
    awake?: {
      __typename?: 'OuraMetric',
      value: number
    },
    rem?: {
      __typename?: 'OuraMetric',
      value: number
    },
    light?: {
      __typename?: 'OuraMetric',
      value: number
    },
    deep?: {
      __typename?: 'OuraMetric',
      value: number
    },
    efficiency?: {
      __typename?: 'OuraMetric',
      value: number
    },
    hr_average?: {
      __typename?: 'OuraMetric',
      value: number
    },
    score_history: Array<{
      __typename?: 'OuraScoreHistory',
      value: number,
      datetime: DateTypes.TimestampTZString | string
    }>
  }
};

export type HomePageFeaturedContentQueryVariables = Exact<{ [key: string]: never; }>;


export type HomePageFeaturedContentQuery = {
  __typename?: 'query_root',
  cms?: {
    __typename?: 'cmsQuery',
    homePageFeaturedContent?: {
      __typename?: 'cms_HomePageFeaturedContentEntityResponse_content',
      data?: {
        __typename?: 'cms_HomePageFeaturedContentEntity_content',
        attributes?: {
          __typename?: 'cms_HomePageFeaturedContent_content',
          related_contents?: {
            __typename?: 'cms_RelatedContentRelationResponseCollection_content',
            data: Array<{
              __typename?: 'cms_RelatedContentEntity_content',
              attributes?: {
                __typename?: 'cms_RelatedContent_content',
                link?: string,
                title?: string,
                description?: string,
                entity_id?: string,
                thumbnail?: {
                  __typename?: 'cms_UploadFileEntityResponse_content',
                  data?: {
                    __typename?: 'cms_UploadFileEntity_content',
                    attributes?: {
                      __typename?: 'cms_UploadFile_content',
                      size: number,
                      width?: number,
                      height?: number,
                      url: string,
                      alternativeText?: string
                    }
                  }
                }
              }
            }>
          }
        }
      }
    }
  }
};

export type NutrientMetricQueryVariables = Exact<{
  timestamptz: Scalars['timestamptz']['input'];
  dateString: Scalars['String']['input'];
  end: Scalars['timestamptz']['input'];
  namespace: Scalars['String']['input'];
  key: Scalars['String']['input'];
  dataSourceFilter?: InputMaybe<enum_data_source_enum_comparison_exp>;
}>;


export type NutrientMetricQuery = {
  __typename?: 'query_root',
  metric: Array<{
    __typename?: 'metric',
    id: string,
    preference_unit_details?: Array<{
      __typename?: 'unit',
      display_symbol: string,
      symbol: string
    }>,
    userProvidedValue: Array<{
      __typename?: 'metric_record',
      value?: number
    }>,
    metric_records_rollup: Array<{
      __typename?: 'MetricRecordRollup',
      day: DateTypes.TimestampTZString | string,
      sum?: number
    }>,
    metric_targets: Array<{
      __typename?: 'metric_target',
      preference_target?: string
    }>,
    active_streak?: {
      __typename?: 'Streak',
      period_start: DateTypes.LocalDateTimeString | string,
      period_end: DateTypes.LocalDateTimeString | string,
      is_active: boolean,
      duration: number,
      unit: string,
      preference_target: string,
      period: {
        __typename?: 'Interval',
        days?: number,
        weeks?: number,
        months?: number,
        years?: number
      }
    },
    most_recent_streak?: {
      __typename?: 'Streak',
      period_start: DateTypes.LocalDateTimeString | string,
      period_end: DateTypes.LocalDateTimeString | string,
      is_active: boolean,
      duration: number,
      unit: string,
      preference_target: string,
      period: {
        __typename?: 'Interval',
        days?: number,
        weeks?: number,
        months?: number,
        years?: number
      }
    }
  }>
};

export type LabImportJobResultsQueryVariables = Exact<{
  fileId: Scalars['uuid']['input'];
}>;


export type LabImportJobResultsQuery = {
  __typename?: 'query_root',
  lab_import_job_results?: {
    __typename?: 'LabImportResults',
    status: string,
    results: Array<{
      __typename?: 'LabMetricResultItemObject',
      loincNumber?: string,
      markerId: string,
      name: string,
      value: string,
      unit: string
    }>
  }
};

export type LabResultMetricRecordGroupFieldsFragment = {
  __typename?: 'metric_record_group',
  name: string,
  metric_records: Array<{
    __typename?: 'metric_record',
    lab_result_markers: Array<{
      __typename?: 'lab_result_marker',
      converted_value?: string,
      is_optimal?: boolean,
      test: {
        __typename?: 'lab_result_test',
        lab_item?: {
          __typename?: 'lab_test_item',
          display_name: string
        }
      }
    }>,
    metric: {
      __typename?: 'metric',
      id: string,
      display_name: string,
      namespace_key: string,
      default_weekly_rollup_type?: enum_metric_rollup_type_enum,
      default_rollup_interval_type?: enum_rollup_interval_type_enum,
      watched_metric: Array<{
        __typename?: 'watched_user_metric',
        metric_id: string
      }>,
      lab_test_markers: Array<{
        __typename?: 'lab_test_marker',
        labels: Array<{
          __typename?: 'lab_test_marker_label',
          label: {
            __typename?: 'label',
            name: string
          }
        }>
      }>,
      preference_unit_details?: Array<{
        __typename?: 'unit',
        display_symbol: string
      }>,
      latest_rollup_values?: Array<{
        __typename?: 'placeholder_metric_rollup_value',
        interval_start: DateTypes.TimestampTZString | string,
        interval_end: DateTypes.TimestampTZString | string,
        preference_value: number,
        metric_records?: Array<{
          __typename?: 'metric_record',
          value_type: metric_record_value_type_enum,
          lab_result_marker?: {
            __typename?: 'lab_result_marker',
            is_optimal?: boolean,
            converted_value?: string,
            test: {
              __typename?: 'lab_result_test',
              lab_item?: {
                __typename?: 'lab_test_item',
                display_name: string
              }
            }
          }
        }>
      }>,
      latestValues?: Array<{
        __typename?: 'metric_record',
        datetime_utc: DateTypes.TimestampTZString | string,
        preference_value?: number,
        value_string?: string,
        value_type: metric_record_value_type_enum,
        lab_result_marker?: {
          __typename?: 'lab_result_marker',
          is_optimal?: boolean,
          converted_value?: string,
          test: {
            __typename?: 'lab_result_test',
            lab_item?: {
              __typename?: 'lab_test_item',
              display_name: string
            }
          }
        }
      }>,
      metric_records?: Array<{
        __typename?: 'metric_record',
        reference_range?: {
          __typename?: 'reference_range',
          id: string,
          data_source?: enum_data_source_enum,
          range_type: string,
          display_name: string,
          targets: Array<{
            __typename?: 'reference_range_target',
            label?: string,
            color?: string,
            optimal: boolean,
            target?: string,
            discrete_targets?: string[],
            health_effects_text?: string
          }>
        }
      }>,
      matched_reference_range_targets_v2: {
        __typename?: 'FilteredReferenceRanges',
        matches: Array<{
          __typename?: 'ReferenceRange',
          id: string,
          dataSource?: string,
          rangeType: enum_reference_range_type,
          displayName: string,
          targets?: Array<{
            __typename?: 'ReferenceRangeTarget',
            label?: string,
            color?: string,
            optimal: boolean,
            target?: string,
            discreteTargets?: Array<string>,
            healthEffectsTitle?: string
          }>
        }>
      }
    },
    reference_range?: {
      __typename?: 'reference_range',
      id: string,
      data_source?: enum_data_source_enum,
      range_type: string,
      display_name: string,
      targets: Array<{
        __typename?: 'reference_range_target',
        label?: string,
        color?: string,
        optimal: boolean,
        target?: string,
        discrete_targets?: string[],
        health_effects_text?: string
      }>
    }
  }>
};

export type PhenoAgeFieldsFragment = {
  __typename?: 'metric_record_group',
  name: string,
  metric_records: Array<{
    __typename?: 'metric_record',
    datetime_utc: DateTypes.TimestampTZString | string,
    metric_id: string,
    value?: number,
    metric: {
      __typename?: 'metric',
      display_name: string,
      preference_unit_details?: Array<{
        __typename?: 'unit',
        display_symbol: string
      }>
    },
    reference_range?: {
      __typename?: 'reference_range',
      id: string,
      data_source?: enum_data_source_enum,
      range_type: string,
      display_name: string,
      targets: Array<{
        __typename?: 'reference_range_target',
        label?: string,
        color?: string,
        optimal: boolean,
        target?: string,
        discrete_targets?: string[],
        health_effects_text?: string
      }>
    }
  }>
};

export type LabResultsByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  beforeDate: Scalars['timestamptz']['input'];
  latestValuesLimit?: InputMaybe<Scalars['Int']['input']>;
  skipLatestValues?: InputMaybe<Scalars['Boolean']['input']>;
  skipRollupValues?: InputMaybe<Scalars['Boolean']['input']>;
  latestRollupValuesArgs?: InputMaybe<latest_rollup_values_metric_args>;
  skipMetricRecordRefRanges?: InputMaybe<Scalars['Boolean']['input']>;
  latestRollupLimit?: InputMaybe<Scalars['Int']['input']>;
  dataSources: Array<enum_data_source_enum> | enum_data_source_enum;
}>;


export type LabResultsByIdQuery = {
  __typename?: 'query_root',
  lab_result_by_pk?: {
    __typename?: 'lab_result',
    data_source?: enum_data_source_enum,
    lab_name?: string,
    datetime_utc: DateTypes.TimestampTZString | string,
    recommendationItems: Array<{
      __typename?: 'LifestyleRecommendationItemModel',
      entityId: string
    } | {
      __typename?: 'MeasureRecommendationItemModel',
      entityId: string
    } | {
      __typename?: 'SupplementRecommendationItemModel',
      entityId: string
    }>,
    file_vault?: {
      __typename?: 'user_file_vault',
      file_type: string,
      download: {
        __typename?: 'FileVaultDownloadUrl',
        url?: string
      }
    },
    lab_order?: {
      __typename?: 'lab_order',
      lab_result_status?: enum_lab_result_status_enum,
      order?: {
        __typename?: 'stripe_order',
        order_number: number,
        receipt_url?: string,
        created_at: DateTypes.TimestampTZString | string,
        id: string,
        line_items: Array<{
          __typename?: 'stripe_order_line_item',
          id: string,
          description: string
        }>
      },
      results_pdf?: {
        __typename?: 'user_file_vault',
        download: {
          __typename?: 'FileVaultDownloadUrl',
          url?: string
        }
      }
    },
    metric_record_group?: {
      __typename?: 'metric_record_group',
      name: string,
      phenoAge: Array<{
        __typename?: 'metric_record_group',
        name: string,
        metric_records: Array<{
          __typename?: 'metric_record',
          datetime_utc: DateTypes.TimestampTZString | string,
          metric_id: string,
          value?: number,
          metric: {
            __typename?: 'metric',
            display_name: string,
            preference_unit_details?: Array<{
              __typename?: 'unit',
              display_symbol: string
            }>
          },
          reference_range?: {
            __typename?: 'reference_range',
            id: string,
            data_source?: enum_data_source_enum,
            range_type: string,
            display_name: string,
            targets: Array<{
              __typename?: 'reference_range_target',
              label?: string,
              color?: string,
              optimal: boolean,
              target?: string,
              discrete_targets?: string[],
              health_effects_text?: string
            }>
          }
        }>
      }>,
      derived: Array<{
        __typename?: 'metric_record_group',
        name: string,
        metric_records: Array<{
          __typename?: 'metric_record',
          lab_result_markers: Array<{
            __typename?: 'lab_result_marker',
            converted_value?: string,
            is_optimal?: boolean,
            test: {
              __typename?: 'lab_result_test',
              lab_item?: {
                __typename?: 'lab_test_item',
                display_name: string
              }
            }
          }>,
          metric: {
            __typename?: 'metric',
            id: string,
            display_name: string,
            namespace_key: string,
            default_weekly_rollup_type?: enum_metric_rollup_type_enum,
            default_rollup_interval_type?: enum_rollup_interval_type_enum,
            watched_metric: Array<{
              __typename?: 'watched_user_metric',
              metric_id: string
            }>,
            lab_test_markers: Array<{
              __typename?: 'lab_test_marker',
              labels: Array<{
                __typename?: 'lab_test_marker_label',
                label: {
                  __typename?: 'label',
                  name: string
                }
              }>
            }>,
            preference_unit_details?: Array<{
              __typename?: 'unit',
              display_symbol: string
            }>,
            latest_rollup_values?: Array<{
              __typename?: 'placeholder_metric_rollup_value',
              interval_start: DateTypes.TimestampTZString | string,
              interval_end: DateTypes.TimestampTZString | string,
              preference_value: number,
              metric_records?: Array<{
                __typename?: 'metric_record',
                value_type: metric_record_value_type_enum,
                lab_result_marker?: {
                  __typename?: 'lab_result_marker',
                  is_optimal?: boolean,
                  converted_value?: string,
                  test: {
                    __typename?: 'lab_result_test',
                    lab_item?: {
                      __typename?: 'lab_test_item',
                      display_name: string
                    }
                  }
                }
              }>
            }>,
            latestValues?: Array<{
              __typename?: 'metric_record',
              datetime_utc: DateTypes.TimestampTZString | string,
              preference_value?: number,
              value_string?: string,
              value_type: metric_record_value_type_enum,
              lab_result_marker?: {
                __typename?: 'lab_result_marker',
                is_optimal?: boolean,
                converted_value?: string,
                test: {
                  __typename?: 'lab_result_test',
                  lab_item?: {
                    __typename?: 'lab_test_item',
                    display_name: string
                  }
                }
              }
            }>,
            metric_records?: Array<{
              __typename?: 'metric_record',
              reference_range?: {
                __typename?: 'reference_range',
                id: string,
                data_source?: enum_data_source_enum,
                range_type: string,
                display_name: string,
                targets: Array<{
                  __typename?: 'reference_range_target',
                  label?: string,
                  color?: string,
                  optimal: boolean,
                  target?: string,
                  discrete_targets?: string[],
                  health_effects_text?: string
                }>
              }
            }>,
            matched_reference_range_targets_v2: {
              __typename?: 'FilteredReferenceRanges',
              matches: Array<{
                __typename?: 'ReferenceRange',
                id: string,
                dataSource?: string,
                rangeType: enum_reference_range_type,
                displayName: string,
                targets?: Array<{
                  __typename?: 'ReferenceRangeTarget',
                  label?: string,
                  color?: string,
                  optimal: boolean,
                  target?: string,
                  discreteTargets?: Array<string>,
                  healthEffectsTitle?: string
                }>
              }>
            }
          },
          reference_range?: {
            __typename?: 'reference_range',
            id: string,
            data_source?: enum_data_source_enum,
            range_type: string,
            display_name: string,
            targets: Array<{
              __typename?: 'reference_range_target',
              label?: string,
              color?: string,
              optimal: boolean,
              target?: string,
              discrete_targets?: string[],
              health_effects_text?: string
            }>
          }
        }>
      }>,
      metric_records: Array<{
        __typename?: 'metric_record',
        lab_result_markers: Array<{
          __typename?: 'lab_result_marker',
          converted_value?: string,
          is_optimal?: boolean,
          test: {
            __typename?: 'lab_result_test',
            lab_item?: {
              __typename?: 'lab_test_item',
              display_name: string
            }
          }
        }>,
        metric: {
          __typename?: 'metric',
          id: string,
          display_name: string,
          namespace_key: string,
          default_weekly_rollup_type?: enum_metric_rollup_type_enum,
          default_rollup_interval_type?: enum_rollup_interval_type_enum,
          watched_metric: Array<{
            __typename?: 'watched_user_metric',
            metric_id: string
          }>,
          lab_test_markers: Array<{
            __typename?: 'lab_test_marker',
            labels: Array<{
              __typename?: 'lab_test_marker_label',
              label: {
                __typename?: 'label',
                name: string
              }
            }>
          }>,
          preference_unit_details?: Array<{
            __typename?: 'unit',
            display_symbol: string
          }>,
          latest_rollup_values?: Array<{
            __typename?: 'placeholder_metric_rollup_value',
            interval_start: DateTypes.TimestampTZString | string,
            interval_end: DateTypes.TimestampTZString | string,
            preference_value: number,
            metric_records?: Array<{
              __typename?: 'metric_record',
              value_type: metric_record_value_type_enum,
              lab_result_marker?: {
                __typename?: 'lab_result_marker',
                is_optimal?: boolean,
                converted_value?: string,
                test: {
                  __typename?: 'lab_result_test',
                  lab_item?: {
                    __typename?: 'lab_test_item',
                    display_name: string
                  }
                }
              }
            }>
          }>,
          latestValues?: Array<{
            __typename?: 'metric_record',
            datetime_utc: DateTypes.TimestampTZString | string,
            preference_value?: number,
            value_string?: string,
            value_type: metric_record_value_type_enum,
            lab_result_marker?: {
              __typename?: 'lab_result_marker',
              is_optimal?: boolean,
              converted_value?: string,
              test: {
                __typename?: 'lab_result_test',
                lab_item?: {
                  __typename?: 'lab_test_item',
                  display_name: string
                }
              }
            }
          }>,
          metric_records?: Array<{
            __typename?: 'metric_record',
            reference_range?: {
              __typename?: 'reference_range',
              id: string,
              data_source?: enum_data_source_enum,
              range_type: string,
              display_name: string,
              targets: Array<{
                __typename?: 'reference_range_target',
                label?: string,
                color?: string,
                optimal: boolean,
                target?: string,
                discrete_targets?: string[],
                health_effects_text?: string
              }>
            }
          }>,
          matched_reference_range_targets_v2: {
            __typename?: 'FilteredReferenceRanges',
            matches: Array<{
              __typename?: 'ReferenceRange',
              id: string,
              dataSource?: string,
              rangeType: enum_reference_range_type,
              displayName: string,
              targets?: Array<{
                __typename?: 'ReferenceRangeTarget',
                label?: string,
                color?: string,
                optimal: boolean,
                target?: string,
                discreteTargets?: Array<string>,
                healthEffectsTitle?: string
              }>
            }>
          }
        },
        reference_range?: {
          __typename?: 'reference_range',
          id: string,
          data_source?: enum_data_source_enum,
          range_type: string,
          display_name: string,
          targets: Array<{
            __typename?: 'reference_range_target',
            label?: string,
            color?: string,
            optimal: boolean,
            target?: string,
            discrete_targets?: string[],
            health_effects_text?: string
          }>
        }
      }>
    }
  }
};

export type LabResultsListQueryVariables = Exact<{ [key: string]: never; }>;


export type LabResultsListQuery = {
  __typename?: 'query_root',
  lab_result: Array<{
    __typename?: 'lab_result',
    id: string,
    name?: string,
    lab_name?: string,
    datetime_utc: DateTypes.TimestampTZString | string,
    metric_record_group?: {
      __typename?: 'metric_record_group',
      metric_records: Array<{
        __typename?: 'metric_record',
        metric: {
          __typename?: 'metric',
          id: string,
          display_name: string,
          lab_test_markers: Array<{
            __typename?: 'lab_test_marker',
            labels: Array<{
              __typename?: 'lab_test_marker_label',
              label: {
                __typename?: 'label',
                id: string,
                name: string
              }
            }>
          }>
        },
        lab_result_marker?: {
          __typename?: 'lab_result_marker',
          is_optimal?: boolean,
          test: {
            __typename?: 'lab_result_test',
            lab_item?: {
              __typename?: 'lab_test_item',
              sku: string,
              display_name: string
            }
          }
        }
      }>
    },
    lab_order?: {
      __typename?: 'lab_order',
      id: string,
      lab_result_status?: enum_lab_result_status_enum,
      order?: {
        __typename?: 'stripe_order',
        id: string,
        line_items: Array<{
          __typename?: 'stripe_order_line_item',
          id: string,
          description: string,
          product: {
            __typename?: 'stripe_product',
            product_type: enum_stripe_product_type_enum
          }
        }>
      }
    }
  }>
};

export type SubmitLabResultsMutationVariables = Exact<{
  input: LabMetricResultInput;
}>;


export type SubmitLabResultsMutation = {
  __typename?: 'mutation_root',
  lab_import_submit_results: {
    __typename?: 'LabId',
    id: string
  }
};

export type WatchedMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type WatchedMetricsQuery = {
  __typename?: 'query_root',
  me_v2?: {
    __typename?: 'user',
    id: string,
    watched_metrics: Array<{
      __typename?: 'watched_user_metric',
      metric: {
        __typename?: 'metric',
        id: string
      }
    }>
  }
};

export type InsertLifeEventMutationVariables = Exact<{
  object: life_event_insert_input;
}>;


export type InsertLifeEventMutation = {
  __typename?: 'mutation_root',
  insert_life_event_one?: {
    __typename?: 'life_event',
    id: string,
    start: DateTypes.TimestampTZString | string,
    end?: DateTypes.TimestampTZString | string,
    name: string,
    category: enum_life_event_category_enum
  }
};

export type UpdateLifeEventByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: life_event_set_input;
}>;


export type UpdateLifeEventByIdMutation = {
  __typename?: 'mutation_root',
  update_life_event_by_pk?: {
    __typename?: 'life_event',
    id: string,
    start: DateTypes.TimestampTZString | string,
    end?: DateTypes.TimestampTZString | string,
    name: string,
    category: enum_life_event_category_enum
  }
};

export type LifeEventsQueryVariables = Exact<{
  start: Scalars['timestamptz']['input'];
  end: Scalars['timestamptz']['input'];
}>;


export type LifeEventsQuery = {
  __typename?: 'query_root',
  life_event: Array<{
    __typename?: 'life_event',
    id: string,
    start: DateTypes.TimestampTZString | string,
    end?: DateTypes.TimestampTZString | string,
    name: string,
    category: enum_life_event_category_enum
  }>
};

export type DeleteLifeEventByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteLifeEventByIdMutation = {
  __typename?: 'mutation_root',
  delete_life_event_by_pk?: {
    __typename?: 'life_event',
    id: string
  }
};

export type LatestMetricEntriesQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestMetricEntriesQuery = {
  __typename?: 'query_root',
  latest_user_provided_metrics: Array<{
    __typename?: 'latest_user_provided_metrics',
    metric?: {
      __typename?: 'metric',
      id: string,
      preference_unit?: string,
      name: string,
      preference_unit_details?: Array<{
        __typename?: 'unit',
        display_symbol: string
      }>
    }
  }>
};

export type GetUploadUrlParamsQueryVariables = Exact<{
  fileName: Scalars['String']['input'];
  upload_type: enum_media_upload_type;
}>;


export type GetUploadUrlParamsQuery = {
  __typename?: 'query_root',
  get_post_upload_params: {
    __typename?: 'GetPostUploadParams',
    fields: any,
    url: string,
    object_url: string
  }
};

export type LabsOnlyMembershipUpgradeMutationVariables = Exact<{ [key: string]: never; }>;


export type LabsOnlyMembershipUpgradeMutation = {
  __typename?: 'mutation_root',
  labs_only_membership_upgrade: {
    __typename?: 'MembershipUpgradeResponse',
    success: boolean,
    membership_tier: enum_membership_tier_enum
  }
};

export type SelectMetricMutationVariables = Exact<{
  objects: Array<metric_explorer_selection_insert_input> | metric_explorer_selection_insert_input;
}>;


export type SelectMetricMutation = {
  __typename?: 'mutation_root',
  insert_metric_explorer_selection?: {
    __typename?: 'metric_explorer_selection_mutation_response',
    returning: Array<{
      __typename?: 'metric_explorer_selection',
      metric_id: string,
      variant?: string,
      data_source?: enum_data_source_enum
    }>
  }
};

export type MetricRecordGroupMetricAggregateQueryVariables = Exact<{
  whereClause: metric_record_bool_exp;
}>;


export type MetricRecordGroupMetricAggregateQuery = {
  __typename?: 'query_root',
  metric_record_aggregate: {
    __typename?: 'metric_record_aggregate',
    aggregate?: {
      __typename?: 'metric_record_aggregate_fields',
      count: number
    }
  }
};

export type MetricRecordGroupMetricRecordsQueryVariables = Exact<{
  metricRecordGroupId: Scalars['uuid']['input'];
}>;


export type MetricRecordGroupMetricRecordsQuery = {
  __typename?: 'query_root',
  metric_record_group_by_pk?: {
    __typename?: 'metric_record_group',
    metric_records: Array<{
      __typename?: 'metric_record',
      datetime_utc: DateTypes.TimestampTZString | string,
      id: string,
      preference_value?: number,
      data_source: enum_data_source_enum,
      variant: string,
      metric: {
        __typename?: 'metric',
        id: string,
        display_name: string,
        preference_unit_details?: Array<{
          __typename?: 'unit',
          display_symbol: string
        }>
      }
    }>
  }
};

export type PreviewDashboardIdSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type PreviewDashboardIdSubscription = {
  __typename?: 'subscription_root',
  dashboard: Array<{
    __typename?: 'dashboard',
    id: string
  }>
};

export type MetricExplorerSelectionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type MetricExplorerSelectionSubscription = {
  __typename?: 'subscription_root',
  metric_explorer_selection: Array<{
    __typename?: 'metric_explorer_selection',
    variant?: string,
    data_source?: enum_data_source_enum,
    id: string,
    metric: {
      __typename?: 'metric',
      id: string,
      display_name: string
    }
  }>
};

export type RemoveMetricExplorerSelectionMutationVariables = Exact<{
  whereClause: metric_explorer_selection_bool_exp;
}>;


export type RemoveMetricExplorerSelectionMutation = {
  __typename?: 'mutation_root',
  delete_metric_explorer_selection?: {
    __typename?: 'metric_explorer_selection_mutation_response',
    returning: Array<{
      __typename?: 'metric_explorer_selection',
      metric: {
        __typename?: 'metric',
        id: string
      }
    }>
  }
};

export type SaveMetricSelectionToDashboardMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type SaveMetricSelectionToDashboardMutation = {
  __typename?: 'mutation_root',
  save_metric_selection_to_dashboard: string
};

export type SaveMetricSelectionToExperimentMutationVariables = Exact<{
  name: Scalars['String']['input'];
  startDate: Scalars['timestamptz']['input'];
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type SaveMetricSelectionToExperimentMutation = {
  __typename?: 'mutation_root',
  save_metric_selection_to_experiment: string
};

export type ExperimentDashboardIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ExperimentDashboardIdQuery = {
  __typename?: 'query_root',
  experiment_by_pk?: {
    __typename?: 'experiment',
    dashboard?: {
      __typename?: 'dashboard',
      id: string
    }
  }
};

export type MetricRecordRowsCountQueryVariables = Exact<{
  whereClause?: InputMaybe<metric_record_bool_exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderByClause?: InputMaybe<Array<metric_record_order_by> | metric_record_order_by>;
}>;


export type MetricRecordRowsCountQuery = {
  __typename?: 'query_root',
  metric_record_aggregate: {
    __typename?: 'metric_record_aggregate',
    aggregate?: {
      __typename?: 'metric_record_aggregate_fields',
      count: number
    }
  }
};

export type MetricRecordGroupRowsCountQueryVariables = Exact<{
  whereClause?: InputMaybe<metric_record_group_bool_exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderByClause?: InputMaybe<Array<metric_record_group_order_by> | metric_record_group_order_by>;
}>;


export type MetricRecordGroupRowsCountQuery = {
  __typename?: 'query_root',
  metric_record_group_aggregate: {
    __typename?: 'metric_record_group_aggregate',
    aggregate?: {
      __typename?: 'metric_record_group_aggregate_fields',
      count: number
    }
  }
};

export type UserDataSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDataSourcesQuery = {
  __typename?: 'query_root',
  metric_record: Array<{
    __typename?: 'metric_record',
    data_source: enum_data_source_enum
  }>
};

export type ProfileAndTosModalDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileAndTosModalDataQuery = {
  __typename?: 'query_root',
  has_accepted_latest_terms: boolean,
  terms_of_service: {
    __typename?: 'TermsOfServiceVersion',
    id: string,
    isLatest: boolean,
    date: DateTypes.LocalDateString,
    content: string
  },
  me_v2?: {
    __typename?: 'user',
    id: string,
    date_of_birth?: string,
    profile?: {
      __typename?: 'user_profile',
      username?: string
    }
  }
};

export type TasksSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type TasksSubscription = {
  __typename?: 'subscription_root',
  user_task_assignment: Array<{
    __typename?: 'user_task_assignment',
    name?: string,
    id: string,
    details?: string,
    is_completed: boolean,
    is_dismissed: boolean,
    user_task_id?: string,
    task?: {
      __typename?: 'user_task',
      id: string,
      name: string,
      details?: string
    }
  }>
};

export type MyTimeZoneQueryVariables = Exact<{ [key: string]: never; }>;


export type MyTimeZoneQuery = {
  __typename?: 'query_root',
  me_v2?: {
    __typename?: 'user',
    timezone?: string,
    id: string
  }
};

export type CreateSyncRequestMutationVariables = Exact<{
  input: SyncRequestInput;
}>;


export type CreateSyncRequestMutation = {
  __typename?: 'mutation_root',
  create_sync_request: {
    __typename?: 'SyncRequestResponse',
    integrations: Array<CombinedIntegrationTypes>
  }
};

export type ReconnectTaskAssignmentsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ReconnectTaskAssignmentsSubscription = {
  __typename?: 'subscription_root',
  user_task_assignment: Array<{
    __typename?: 'user_task_assignment',
    id: string,
    task?: {
      __typename?: 'user_task',
      id: string
    }
  }>
};

export type AchievementsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type AchievementsByIdsQuery = {
  __typename?: 'query_root',
  me_v2?: {
    __typename?: 'user',
    id: string,
    achievements: Array<{
      __typename?: 'user_achievement',
      id: string,
      achievement?: {
        __typename?: 'cms_AchievementEntityResponse_content',
        data?: {
          __typename?: 'cms_AchievementEntity_content',
          attributes?: {
            __typename?: 'cms_Achievement_content',
            description?: string,
            name: string,
            hero?: {
              __typename?: 'cms_UploadFileEntityResponse_content',
              data?: {
                __typename?: 'cms_UploadFileEntity_content',
                attributes?: {
                  __typename?: 'cms_UploadFile_content',
                  size: number,
                  width?: number,
                  height?: number,
                  url: string,
                  alternativeText?: string
                }
              }
            },
            animation_images?: {
              __typename?: 'cms_UploadFileRelationResponseCollection_content',
              data: Array<{
                __typename?: 'cms_UploadFileEntity_content',
                attributes?: {
                  __typename?: 'cms_UploadFile_content',
                  url: string
                }
              }>
            }
          }
        }
      }
    }>
  }
};

export type IntegrationSyncEventSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IntegrationSyncEventSubscription = {
  __typename?: 'subscription_root',
  integration_sync_event: Array<{
    __typename?: 'integration_sync_event',
    integration: string,
    sync_type?: string,
    created_at: DateTypes.TimestampTZString | string
  }>
};

export type SupplementMetricComponentAggregatesQueryVariables = Exact<{
  supplement: Scalars['String']['input'];
}>;


export type SupplementMetricComponentAggregatesQuery = {
  __typename?: 'query_root',
  supplement: Array<{
    __typename?: 'supplement',
    metric?: {
      __typename?: 'metric',
      metric_components: Array<{
        __typename?: 'metric_component',
        metric: {
          __typename?: 'metric',
          name: string,
          unit?: string,
          metric_records_aggregate: {
            __typename?: 'metric_record_aggregate',
            aggregate?: {
              __typename?: 'metric_record_aggregate_fields',
              sum?: {
                __typename?: 'metric_record_sum_fields',
                value?: number
              }
            }
          }
        }
      }>
    }
  }>
};

export type MetricRecordAggregateQueryVariables = Exact<{
  metric: Scalars['String']['input'];
}>;


export type MetricRecordAggregateQuery = {
  __typename?: 'query_root',
  metric_record_aggregate: {
    __typename?: 'metric_record_aggregate',
    aggregate?: {
      __typename?: 'metric_record_aggregate_fields',
      sum?: {
        __typename?: 'metric_record_sum_fields',
        value?: number
      }
    }
  }
};

export type MySupplementsQueryVariables = Exact<{ [key: string]: never; }>;


export type MySupplementsQuery = {
  __typename?: 'query_root',
  supplement: Array<{
    __typename?: 'supplement',
    id: string,
    name: string,
    brand?: string,
    nutritionSrc?: string,
    productSrc?: string
  }>
};

export type NonUserSupplementsQueryVariables = Exact<{
  userSupplementIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type NonUserSupplementsQuery = {
  __typename?: 'query_root',
  supplement: Array<{
    __typename?: 'supplement',
    name: string,
    id: string,
    brand?: string
  }>
};

export type SupplementsTextSearchQueryVariables = Exact<{
  text: Scalars['String']['input'];
  userSupplementIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type SupplementsTextSearchQuery = {
  __typename?: 'query_root',
  search_supplements: Array<{
    __typename?: 'supplement',
    id: string,
    name: string,
    brand?: string
  }>
};

export type InsertUserSupplementByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type InsertUserSupplementByIdMutation = {
  __typename?: 'mutation_root',
  insert_user_supplement_one?: {
    __typename?: 'user_supplement',
    supplement_id: string
  }
};

export type CreateSupplementForUserMutationVariables = Exact<{
  name: Scalars['String']['input'];
  imgUrl: Scalars['String']['input'];
}>;


export type CreateSupplementForUserMutation = {
  __typename?: 'mutation_root',
  insert_supplement_one?: {
    __typename?: 'supplement',
    id: string
  }
};

export type DeleteUserSupplementByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteUserSupplementByIdMutation = {
  __typename?: 'mutation_root',
  delete_user_supplement?: {
    __typename?: 'user_supplement_mutation_response',
    returning: Array<{
      __typename?: 'user_supplement',
      supplement_id: string
    }>
  }
};

export type GetUploadUrlQueryVariables = Exact<{
  fileName: Scalars['String']['input'];
}>;


export type GetUploadUrlQuery = {
  __typename?: 'query_root',
  get_upload_url: {
    __typename?: 'GetUploadUrlOutput',
    upload_url: string,
    url: string
  }
};

export type PendingLabOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type PendingLabOrdersQuery = {
  __typename?: 'query_root',
  lab_order_aggregate: {
    __typename?: 'lab_order_aggregate',
    aggregate?: {
      __typename?: 'lab_order_aggregate_fields',
      count: number
    }
  }
};

export type MostRecentLabIdQueryVariables = Exact<{ [key: string]: never; }>;


export type MostRecentLabIdQuery = {
  __typename?: 'query_root',
  lab_result: Array<{
    __typename?: 'lab_result',
    id: string
  }>
};

export type AiRecommndationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AiRecommndationsQuery = {
  __typename?: 'query_root',
  get_user_goals: Array<{
    __typename?: 'UserGoalEntity',
    focus: boolean,
    score?: number,
    priority: number,
    goal?: {
      __typename?: 'goal',
      id: string,
      slug: string,
      name: string,
      content?: {
        __typename?: 'cms_GoalEntityResponse_content',
        data?: {
          __typename?: 'cms_GoalEntity_content',
          attributes?: {
            __typename?: 'cms_Goal_content',
            name: string,
            description?: string
          }
        }
      }
    }
  }>,
  ai_recommendations: Array<{
    __typename?: 'ai_recommendations',
    id: string,
    audio_text: string,
    user_id: string,
    audio_file_url?: string,
    recommended_content: any,
    recommendations_lifestyles: Array<{
      __typename?: 'ai_recommendations_lifestyle',
      recommendation_id: string,
      lifestyle_id: string,
      interval: string,
      reasoning?: string,
      lifestyle_name: string,
      action_item: {
        __typename?: 'action_item',
        id: string,
        name_show_placeholders: boolean,
        logger_type?: enum_action_item_logger_type_enum,
        labels: Array<{
          __typename?: 'action_item_label',
          label: {
            __typename?: 'label',
            name: string
          }
        }>,
        content: {
          __typename: 'cms_ActionItemEntityResponse_content',
          data?: {
            __typename: 'cms_ActionItemEntity_content',
            attributes?: {
              __typename: 'cms_ActionItem_content',
              name: string,
              hero_image?: {
                __typename: 'cms_UploadFileEntityResponse_content',
                data?: {
                  __typename: 'cms_UploadFileEntity_content',
                  attributes?: {
                    __typename: 'cms_UploadFile_content',
                    url: string
                  }
                }
              }
            }
          }
        },
        preference_unit?: Array<{
          __typename: 'unit',
          display_name: string,
          display_name_plural: string,
          display_symbol: string,
          display_symbol_plural: string
        }>,
        action_item_inputs: Array<{
          __typename: 'action_item_input',
          input_type: enum_action_item_input_type_enum
        }>
      }
    }>,
    recommendations_supplements: Array<{
      __typename?: 'ai_recommendations_supplements',
      reasoning?: string,
      product: {
        __typename: 'stripe_product',
        name: string,
        content?: {
          __typename: 'cms_StripeProductEntityResponse_content',
          data?: {
            __typename: 'cms_StripeProductEntity_content',
            attributes?: {
              __typename: 'cms_StripeProduct_content',
              name?: string,
              slug: string,
              brand?: string,
              images?: {
                __typename: 'cms_UploadFileRelationResponseCollection_content',
                data: Array<{
                  __typename: 'cms_UploadFileEntity_content',
                  attributes?: {
                    __typename: 'cms_UploadFile_content',
                    url: string
                  }
                }>
              }
            }
          }
        }
      }
    }>,
    recommendations_metrics: Array<{
      __typename?: 'ai_recommendations_metric',
      metric_id: string,
      reasoning?: string,
      guidance_custom_item: {
        __typename?: 'guidance_custom_item',
        name?: string,
        slug: string,
        meta?: any,
        content?: {
          __typename?: 'cms_MeasurementRecommendationEntityResponse_content',
          data?: {
            __typename?: 'cms_MeasurementRecommendationEntity_content',
            id?: string,
            attributes?: {
              __typename?: 'cms_MeasurementRecommendation_content',
              cta_link: string,
              cta_text: string,
              description: string,
              display_name?: string,
              summary?: string,
              identifier: string,
              header_img: {
                __typename?: 'cms_UploadFileEntityResponse_content',
                data?: {
                  __typename?: 'cms_UploadFileEntity_content',
                  attributes?: {
                    __typename?: 'cms_UploadFile_content',
                    url: string
                  }
                }
              }
            }
          }
        }
      }
    }>,
    ai_recommendations_contents: Array<{
      __typename?: 'ai_recommendations_content',
      content_id: string,
      id: string,
      ai_recommendation_file: {
        __typename?: 'ai_recommendation_files',
        file_type: {"PDF":"pdf","AUDIO":"audio","VIDEO":"video"},
        id: string,
        url: string,
        created_at?: DateTypes.LocalDateTimeString | string
      }
    }>
  }>
};

export type GetProfileInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileInfoQuery = {
  __typename?: 'query_root',
  lab_profile: Array<{
    __typename?: 'lab_profile',
    birth_date?: string,
    email?: string,
    first_name?: string,
    last_name?: string,
    phone_number?: string,
    sex?: string,
    ship_to_address?: string,
    ship_to_city?: string,
    ship_to_country?: string,
    ship_to_postal_code?: string,
    ship_to_state?: string
  }>
};

export type GoalFieldsFragment = {
  __typename?: 'goal',
  id: string,
  slug: string,
  name: string,
  content?: {
    __typename?: 'cms_GoalEntityResponse_content',
    data?: {
      __typename?: 'cms_GoalEntity_content',
      attributes?: {
        __typename?: 'cms_Goal_content',
        name: string,
        description?: string
      }
    }
  }
};

export type AllGoalsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllGoalsQuery = {
  __typename?: 'query_root',
  goal: Array<{
    __typename?: 'goal',
    id: string,
    slug: string,
    name: string,
    content?: {
      __typename?: 'cms_GoalEntityResponse_content',
      data?: {
        __typename?: 'cms_GoalEntity_content',
        attributes?: {
          __typename?: 'cms_Goal_content',
          name: string,
          description?: string
        }
      }
    }
  }>
};

export type UserGoalEntityFieldsFragment = {
  __typename?: 'UserGoalEntity',
  focus: boolean,
  score?: number,
  priority: number,
  goal?: {
    __typename?: 'goal',
    id: string,
    slug: string,
    name: string,
    content?: {
      __typename?: 'cms_GoalEntityResponse_content',
      data?: {
        __typename?: 'cms_GoalEntity_content',
        attributes?: {
          __typename?: 'cms_Goal_content',
          name: string,
          description?: string
        }
      }
    }
  }
};

export type SubmitSurveyMutationVariables = Exact<{
  surveyResponse: Array<GoalsSurveyResponse> | GoalsSurveyResponse;
}>;


export type SubmitSurveyMutation = {
  __typename?: 'mutation_root',
  process_goals_survey: Array<{
    __typename?: 'UserGoalEntity',
    focus: boolean,
    score?: number,
    priority: number,
    goal?: {
      __typename?: 'goal',
      id: string,
      slug: string,
      name: string,
      content?: {
        __typename?: 'cms_GoalEntityResponse_content',
        data?: {
          __typename?: 'cms_GoalEntity_content',
          attributes?: {
            __typename?: 'cms_Goal_content',
            name: string,
            description?: string
          }
        }
      }
    }
  }>
};

export type SetUserGoalsMutationVariables = Exact<{
  goals: Array<UserGoalInput> | UserGoalInput;
}>;


export type SetUserGoalsMutation = {
  __typename?: 'mutation_root',
  set_user_goals: Array<{
    __typename?: 'UserGoalEntity',
    focus: boolean,
    score?: number,
    priority: number,
    goal?: {
      __typename?: 'goal',
      id: string,
      slug: string,
      name: string,
      content?: {
        __typename?: 'cms_GoalEntityResponse_content',
        data?: {
          __typename?: 'cms_GoalEntity_content',
          attributes?: {
            __typename?: 'cms_Goal_content',
            name: string,
            description?: string
          }
        }
      }
    }
  }>
};

export type UserGoalEntitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserGoalEntitiesQuery = {
  __typename?: 'query_root',
  get_user_goals: Array<{
    __typename?: 'UserGoalEntity',
    focus: boolean,
    score?: number,
    priority: number,
    goal?: {
      __typename?: 'goal',
      id: string,
      slug: string,
      name: string,
      content?: {
        __typename?: 'cms_GoalEntityResponse_content',
        data?: {
          __typename?: 'cms_GoalEntity_content',
          attributes?: {
            __typename?: 'cms_Goal_content',
            name: string,
            description?: string
          }
        }
      }
    }
  }>
};

export type LifestyleRecommendationFragment = {
  __typename?: 'LifestyleRecommendationItemModel',
  action_item_config?: {
    __typename?: 'action_item_config',
    id: string,
    value_target: string,
    interval_type: enum_rollup_interval_type_enum,
    weekly_instance_target: string,
    name?: string,
    value_rollup_type?: enum_metric_rollup_type_enum,
    action_item: {
      __typename?: 'action_item',
      id: string,
      name_show_placeholders: boolean,
      logger_type?: enum_action_item_logger_type_enum,
      labels: Array<{
        __typename?: 'action_item_label',
        label: {
          __typename?: 'label',
          name: string
        }
      }>,
      content: {
        __typename?: 'cms_ActionItemEntityResponse_content',
        data?: {
          __typename?: 'cms_ActionItemEntity_content',
          attributes?: {
            __typename?: 'cms_ActionItem_content',
            name: string,
            hero_image?: {
              __typename?: 'cms_UploadFileEntityResponse_content',
              data?: {
                __typename?: 'cms_UploadFileEntity_content',
                attributes?: {
                  __typename?: 'cms_UploadFile_content',
                  url: string
                }
              }
            }
          }
        }
      },
      preference_unit?: Array<{
        __typename?: 'unit',
        display_name: string,
        display_name_plural: string,
        display_symbol: string,
        display_symbol_plural: string
      }>,
      action_item_inputs: Array<{
        __typename?: 'action_item_input',
        input_type: enum_action_item_input_type_enum
      }>
    }
  }
};

export type SupplementRecommendationFragment = {
  __typename?: 'SupplementRecommendationItemModel',
  supplement?: {
    __typename?: 'supplement',
    brand?: string,
    name: string,
    products: Array<{
      __typename?: 'supplement_product',
      product: {
        __typename?: 'stripe_product',
        content?: {
          __typename?: 'cms_StripeProductEntityResponse_content',
          data?: {
            __typename?: 'cms_StripeProductEntity_content',
            attributes?: {
              __typename?: 'cms_StripeProduct_content',
              name?: string,
              slug: string,
              images?: {
                __typename?: 'cms_UploadFileRelationResponseCollection_content',
                data: Array<{
                  __typename?: 'cms_UploadFileEntity_content',
                  attributes?: {
                    __typename?: 'cms_UploadFile_content',
                    url: string
                  }
                }>
              }
            }
          }
        }
      }
    }>
  }
};

export type CmsGuidanceItemFragment = {
  __typename?: 'CmsContentCustomGuidanceItem',
  content?: {
    __typename?: 'cms_MeasurementRecommendationEntityResponse_content',
    data?: {
      __typename?: 'cms_MeasurementRecommendationEntity_content',
      id?: string,
      attributes?: {
        __typename?: 'cms_MeasurementRecommendation_content',
        cta_link: string,
        cta_text: string,
        identifier: string,
        description: string,
        summary?: string,
        display_name?: string,
        header_img: {
          __typename?: 'cms_UploadFileEntityResponse_content',
          data?: {
            __typename?: 'cms_UploadFileEntity_content',
            attributes?: {
              __typename?: 'cms_UploadFile_content',
              url: string
            }
          }
        }
      }
    }
  }
};

export type LabPackageGuidanceItemFragment = {
  __typename?: 'LabPackageCustomGuidanceItem',
  productSlug: string,
  lab_package?: {
    __typename?: 'stripe_product',
    id: string,
    name: string
  }
};

export type MeasureRecommendationFragment = {
  __typename?: 'MeasureRecommendationItemModel',
  item: {
    __typename: 'CmsContentCustomGuidanceItem',
    name?: string,
    slug: string,
    meta?: any,
    content?: {
      __typename?: 'cms_MeasurementRecommendationEntityResponse_content',
      data?: {
        __typename?: 'cms_MeasurementRecommendationEntity_content',
        id?: string,
        attributes?: {
          __typename?: 'cms_MeasurementRecommendation_content',
          cta_link: string,
          cta_text: string,
          identifier: string,
          description: string,
          summary?: string,
          display_name?: string,
          header_img: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                url: string
              }
            }
          }
        }
      }
    }
  } | {
    __typename: 'LabPackageCustomGuidanceItem',
    name?: string,
    slug: string,
    meta?: any,
    productSlug: string,
    lab_package?: {
      __typename?: 'stripe_product',
      id: string,
      name: string
    }
  }
};

export type GetUserGuidanceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserGuidanceQuery = {
  __typename?: 'query_root',
  get_user_guidance: {
    __typename?: 'GuidanceModel',
    goals: Array<{
      __typename?: 'UserGoalEntity',
      focus: boolean,
      score?: number,
      priority: number,
      goal?: {
        __typename?: 'goal',
        id: string,
        slug: string,
        name: string,
        content?: {
          __typename?: 'cms_GoalEntityResponse_content',
          data?: {
            __typename?: 'cms_GoalEntity_content',
            attributes?: {
              __typename?: 'cms_Goal_content',
              name: string,
              description?: string
            }
          }
        }
      }
    }>,
    recommendationItems: Array<{
      __typename: 'LifestyleRecommendationItemModel',
      type: RECOMMENDATION_ITEM_TYPE,
      priority: number,
      entityId: string,
      impactTotal: number,
      meta?: any,
      goals?: Array<{
        __typename?: 'GoalEntity',
        name: string,
        id: string,
        slug: string
      }>,
      metrics?: Array<{
        __typename?: '_metric',
        id: string,
        display_name: string,
        namespaceKey: string,
        lab_test_marker?: {
          __typename?: 'lab_test_marker',
          display_name?: string,
          labels: Array<{
            __typename?: 'lab_test_marker_label',
            label: {
              __typename?: 'label',
              name: string
            }
          }>
        }
      }>,
      action_item_config?: {
        __typename?: 'action_item_config',
        id: string,
        value_target: string,
        interval_type: enum_rollup_interval_type_enum,
        weekly_instance_target: string,
        name?: string,
        value_rollup_type?: enum_metric_rollup_type_enum,
        action_item: {
          __typename?: 'action_item',
          id: string,
          name_show_placeholders: boolean,
          logger_type?: enum_action_item_logger_type_enum,
          labels: Array<{
            __typename?: 'action_item_label',
            label: {
              __typename?: 'label',
              name: string
            }
          }>,
          content: {
            __typename?: 'cms_ActionItemEntityResponse_content',
            data?: {
              __typename?: 'cms_ActionItemEntity_content',
              attributes?: {
                __typename?: 'cms_ActionItem_content',
                name: string,
                hero_image?: {
                  __typename?: 'cms_UploadFileEntityResponse_content',
                  data?: {
                    __typename?: 'cms_UploadFileEntity_content',
                    attributes?: {
                      __typename?: 'cms_UploadFile_content',
                      url: string
                    }
                  }
                }
              }
            }
          },
          preference_unit?: Array<{
            __typename?: 'unit',
            display_name: string,
            display_name_plural: string,
            display_symbol: string,
            display_symbol_plural: string
          }>,
          action_item_inputs: Array<{
            __typename?: 'action_item_input',
            input_type: enum_action_item_input_type_enum
          }>
        }
      }
    } | {
      __typename: 'MeasureRecommendationItemModel',
      type: RECOMMENDATION_ITEM_TYPE,
      priority: number,
      entityId: string,
      impactTotal: number,
      meta?: any,
      goals?: Array<{
        __typename?: 'GoalEntity',
        name: string,
        id: string,
        slug: string
      }>,
      metrics?: Array<{
        __typename?: '_metric',
        id: string,
        display_name: string,
        namespaceKey: string,
        lab_test_marker?: {
          __typename?: 'lab_test_marker',
          display_name?: string,
          labels: Array<{
            __typename?: 'lab_test_marker_label',
            label: {
              __typename?: 'label',
              name: string
            }
          }>
        }
      }>,
      item: {
        __typename: 'CmsContentCustomGuidanceItem',
        name?: string,
        slug: string,
        meta?: any,
        content?: {
          __typename?: 'cms_MeasurementRecommendationEntityResponse_content',
          data?: {
            __typename?: 'cms_MeasurementRecommendationEntity_content',
            id?: string,
            attributes?: {
              __typename?: 'cms_MeasurementRecommendation_content',
              cta_link: string,
              cta_text: string,
              identifier: string,
              description: string,
              summary?: string,
              display_name?: string,
              header_img: {
                __typename?: 'cms_UploadFileEntityResponse_content',
                data?: {
                  __typename?: 'cms_UploadFileEntity_content',
                  attributes?: {
                    __typename?: 'cms_UploadFile_content',
                    url: string
                  }
                }
              }
            }
          }
        }
      } | {
        __typename: 'LabPackageCustomGuidanceItem',
        name?: string,
        slug: string,
        meta?: any,
        productSlug: string,
        lab_package?: {
          __typename?: 'stripe_product',
          id: string,
          name: string
        }
      }
    } | {
      __typename: 'SupplementRecommendationItemModel',
      type: RECOMMENDATION_ITEM_TYPE,
      priority: number,
      entityId: string,
      impactTotal: number,
      meta?: any,
      goals?: Array<{
        __typename?: 'GoalEntity',
        name: string,
        id: string,
        slug: string
      }>,
      metrics?: Array<{
        __typename?: '_metric',
        id: string,
        display_name: string,
        namespaceKey: string,
        lab_test_marker?: {
          __typename?: 'lab_test_marker',
          display_name?: string,
          labels: Array<{
            __typename?: 'lab_test_marker_label',
            label: {
              __typename?: 'label',
              name: string
            }
          }>
        }
      }>,
      supplement?: {
        __typename?: 'supplement',
        brand?: string,
        name: string,
        products: Array<{
          __typename?: 'supplement_product',
          product: {
            __typename?: 'stripe_product',
            content?: {
              __typename?: 'cms_StripeProductEntityResponse_content',
              data?: {
                __typename?: 'cms_StripeProductEntity_content',
                attributes?: {
                  __typename?: 'cms_StripeProduct_content',
                  name?: string,
                  slug: string,
                  images?: {
                    __typename?: 'cms_UploadFileRelationResponseCollection_content',
                    data: Array<{
                      __typename?: 'cms_UploadFileEntity_content',
                      attributes?: {
                        __typename?: 'cms_UploadFile_content',
                        url: string
                      }
                    }>
                  }
                }
              }
            }
          }
        }>
      }
    }>
  }
};

export type SortedAndFilteredRecEntityIdsQueryVariables = Exact<{
  goalIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  metricIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type SortedAndFilteredRecEntityIdsQuery = {
  __typename?: 'query_root',
  get_user_guidance: {
    __typename?: 'GuidanceModel',
    recommendationItems: Array<{
      __typename?: 'LifestyleRecommendationItemModel',
      entityId: string
    } | {
      __typename?: 'MeasureRecommendationItemModel',
      entityId: string
    } | {
      __typename?: 'SupplementRecommendationItemModel',
      entityId: string
    }>
  }
};

export type OnboardingSurveyQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingSurveyQuery = {
  __typename?: 'query_root',
  cms?: {
    __typename?: 'cmsQuery',
    onboardingSurvey?: {
      __typename?: 'cms_OnboardingSurveyEntityResponse_content',
      data?: {
        __typename?: 'cms_OnboardingSurveyEntity_content',
        attributes?: {
          __typename?: 'cms_OnboardingSurvey_content',
          Screens?: Array<{
            __typename?: 'cms_ComponentSurveyScreenSurveyScreen_content',
            id: string,
            Question_Text?: string,
            Options?: Array<{
              __typename?: 'cms_ComponentSurveyOptionOption_content',
              id: string,
              Option_Text: string,
              Cardiovascular_Fitness: number,
              Enhanced_Brain_Function: number,
              Improved_Energy: number,
              Libido: number,
              Longevity: number,
              Manage_Stress_Better: number,
              Muscle_Mass_And_More_Strength: number,
              Sleep: number,
              Weight_Loss: number
            }>
          }>
        }
      }
    }
  }
};

export type UpdateUserTaskAssignmentMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  changes: user_task_assignment_set_input;
}>;


export type UpdateUserTaskAssignmentMutation = {
  __typename?: 'mutation_root',
  update_user_task_assignment?: {
    __typename?: 'user_task_assignment_mutation_response',
    returning: Array<{
      __typename?: 'user_task_assignment',
      task?: {
        __typename?: 'user_task',
        name: string
      }
    }>
  }
};

export type HasCompletedSurveyQueryVariables = Exact<{ [key: string]: never; }>;


export type HasCompletedSurveyQuery = {
  __typename?: 'query_root',
  goal_survey_response: Array<{
    __typename?: 'goal_survey_response',
    created_at: DateTypes.TimestampTZString | string
  }>
};

export type GetUserGoalIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserGoalIdsQuery = {
  __typename?: 'query_root',
  get_user_guidance: {
    __typename?: 'GuidanceModel',
    goals: Array<{
      __typename?: 'UserGoalEntity',
      id: string
    }>
  }
};

export type GetMetricCalculatorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMetricCalculatorsQuery = {
  __typename?: 'query_root',
  get_metric_calculators: Array<{
    __typename?: 'MetricCalculatorModel',
    type: string,
    inputs: Array<{
      __typename?: 'MetricRefModel',
      key: string,
      metric?: {
        __typename?: 'metric',
        id: string,
        name: string,
        unitDetails?: {
          __typename?: 'unit',
          symbol: string
        }
      }
    }>
  }>,
  calculatorsContent?: {
    __typename?: 'cmsQuery',
    calculators?: {
      __typename?: 'cms_CalculatorEntityResponseCollection_content',
      data: Array<{
        __typename?: 'cms_CalculatorEntity_content',
        attributes?: {
          __typename?: 'cms_Calculator_content',
          sort_order?: number,
          gql_type: string,
          category: string,
          display_name: string,
          short_description?: string,
          long_description?: string,
          html_head_data?: {
            __typename?: 'cms_ComponentHtmlHeaderDataHtmlHeaderData_content',
            title?: string,
            description?: string,
            share_image?: {
              __typename?: 'cms_UploadFileEntityResponse_content',
              data?: {
                __typename?: 'cms_UploadFileEntity_content',
                attributes?: {
                  __typename?: 'cms_UploadFile_content',
                  url: string
                }
              }
            }
          }
        }
      }>
    }
  }
};

export type RunCalculationQueryVariables = Exact<{
  type: Scalars['String']['input'];
  inputs: Array<RunMetricCalculatorInput> | RunMetricCalculatorInput;
}>;


export type RunCalculationQuery = {
  __typename?: 'query_root',
  run_calculation: Array<{
    __typename?: 'MetricCalculatorResultModel',
    value: number,
    output: {
      __typename?: 'MetricRefModel',
      key: string,
      metric?: {
        __typename?: 'metric',
        display_name: string,
        preference_unit_details?: Array<{
          __typename?: 'unit',
          display_symbol: string
        }>
      }
    }
  }>
};

export type StripeProductPriceFieldsFragment = {
  __typename?: 'stripe_product',
  price_free_member?: {
    __typename?: 'stripe_price_free_member',
    price_usd?: number
  },
  price_paid_member?: {
    __typename?: 'stripe_price_paid_member',
    price_usd?: number
  },
  price_current?: {
    __typename?: 'stripe_price',
    price_usd: number
  }
};

export type ProductDetailsFragment = {
  __typename?: 'stripe_product',
  id: string,
  name: string,
  price_free_member?: {
    __typename?: 'stripe_price_free_member',
    price_usd?: number
  },
  price_paid_member?: {
    __typename?: 'stripe_price_paid_member',
    price_usd?: number
  },
  price_current?: {
    __typename?: 'stripe_price',
    price_usd: number
  }
};

export type AddOnsBySlugsQueryVariables = Exact<{
  slugs?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  countryAvailability: Scalars['_text']['input'];
}>;


export type AddOnsBySlugsQuery = {
  __typename?: 'query_root',
  product_catalog: Array<{
    __typename?: 'stripe_product',
    addons: Array<{
      __typename?: 'stripe_product_addon',
      addon: {
        __typename?: 'stripe_product',
        id: string,
        name: string,
        price_free_member?: {
          __typename?: 'stripe_price_free_member',
          price_usd?: number
        },
        price_paid_member?: {
          __typename?: 'stripe_price_paid_member',
          price_usd?: number
        },
        price_current?: {
          __typename?: 'stripe_price',
          price_usd: number
        }
      }
    }>
  }>
};

export type UserSexQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSexQuery = {
  __typename?: 'query_root',
  me_v2?: {
    __typename?: 'user',
    sex?: enum_sex_enum
  }
};

export type LabProductsQueryVariables = Exact<{
  countryAvailability: Scalars['_text']['input'];
}>;


export type LabProductsQuery = {
  __typename?: 'query_root',
  tests: Array<{
    __typename?: 'stripe_product',
    id: string,
    slug?: string,
    name: string,
    product_type: enum_stripe_product_type_enum,
    metadata: any,
    lab_items: Array<{
      __typename?: 'stripe_product_lab_test_item_flat',
      lab_test?: {
        __typename?: 'lab_test_item',
        id: string,
        display_name: string,
        products: Array<{
          __typename?: 'stripe_product_lab_test_item',
          product: {
            __typename?: 'stripe_product',
            id: string,
            slug?: string
          }
        }>
      }
    }>,
    markers: Array<{
      __typename?: 'stripe_product_lab_test_marker_flat_new',
      lab_test_marker?: {
        __typename?: 'lab_test_marker',
        metric_id: string,
        long_common_name?: string,
        synonyms: string[],
        loinc_number?: string,
        display_name: string,
        labels: Array<{
          __typename?: 'lab_test_marker_label',
          label: {
            __typename?: 'label',
            name: string
          }
        }>
      }
    }>,
    labels: Array<{
      __typename?: 'stripe_product_label',
      label: {
        __typename?: 'label',
        name: string
      }
    }>,
    price_free_member?: {
      __typename?: 'stripe_price_free_member',
      price_usd?: number
    },
    price_paid_member?: {
      __typename?: 'stripe_price_paid_member',
      price_usd?: number
    },
    price_current?: {
      __typename?: 'stripe_price',
      price_usd: number
    }
  }>,
  packages: Array<{
    __typename?: 'stripe_product',
    slug?: string,
    id: string,
    name: string,
    metadata: any,
    product_type: enum_stripe_product_type_enum,
    marker_counts: Array<{
      __typename?: 'stripe_product_marker_counts',
      quantity?: number,
      label?: {
        __typename?: 'label',
        name: string
      }
    }>,
    lab_items: Array<{
      __typename?: 'stripe_product_lab_test_item_flat',
      lab_test?: {
        __typename?: 'lab_test_item',
        id: string,
        display_name: string,
        products: Array<{
          __typename?: 'stripe_product_lab_test_item',
          product: {
            __typename?: 'stripe_product',
            id: string,
            slug?: string
          }
        }>
      }
    }>,
    price_free_member?: {
      __typename?: 'stripe_price_free_member',
      price_usd?: number
    },
    price_paid_member?: {
      __typename?: 'stripe_price_paid_member',
      price_usd?: number
    },
    price_current?: {
      __typename?: 'stripe_price',
      price_usd: number
    }
  }>,
  phenoAge?: {
    __typename?: 'metric',
    id: string
  }
};

export type LabContentQueryVariables = Exact<{
  productSlugs: Array<Scalars['String']['input']> | Scalars['String']['input'];
  productLimit?: InputMaybe<Scalars['Int']['input']>;
  markerMetricIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  markerLimit?: InputMaybe<Scalars['Int']['input']>;
  availableCaFilter: cms_BooleanFilterInput_content;
}>;


export type LabContentQuery = {
  __typename?: 'query_root',
  cms?: {
    __typename?: 'cmsQuery',
    products?: {
      __typename?: 'cms_StripeProductEntityResponseCollection_content',
      data: Array<{
        __typename?: 'cms_StripeProductEntity_content',
        attributes?: {
          __typename?: 'cms_StripeProduct_content',
          slug: string,
          summary?: string,
          description?: string
        }
      }>
    },
    markers?: {
      __typename?: 'cms_LabTestMarkerEntityResponseCollection_content',
      data: Array<{
        __typename?: 'cms_LabTestMarkerEntity_content',
        attributes?: {
          __typename?: 'cms_LabTestMarker_content',
          summary?: string,
          full_description?: string,
          metric_id: string
        }
      }>
    }
  }
};

export type MembershipProductsQueryVariables = Exact<{
  countryAvailability: Scalars['_text']['input'];
}>;


export type MembershipProductsQuery = {
  __typename?: 'query_root',
  product_catalog: Array<{
    __typename?: 'stripe_product',
    name: string,
    id: string,
    slug?: string,
    price_free_member?: {
      __typename?: 'stripe_price_free_member',
      price_usd?: number
    },
    price_paid_member?: {
      __typename?: 'stripe_price_paid_member',
      price_usd?: number
    },
    price_current?: {
      __typename?: 'stripe_price',
      price_usd: number
    }
  }>
};

export type ImageFieldsFragment = {
  __typename?: 'cms_UploadFileRelationResponseCollection_content',
  data: Array<{
    __typename?: 'cms_UploadFileEntity_content',
    attributes?: {
      __typename?: 'cms_UploadFile_content',
      url: string,
      alternativeText?: string
    }
  }>
};

export type PartnerProductsListQueryVariables = Exact<{
  availableCaFilter: cms_BooleanFilterInput_content;
}>;


export type PartnerProductsListQuery = {
  __typename?: 'query_root',
  partnerProducts?: {
    __typename?: 'cmsQuery',
    stripeProducts?: {
      __typename?: 'cms_StripeProductEntityResponseCollection_content',
      data: Array<{
        __typename?: 'cms_StripeProductEntity_content',
        attributes?: {
          __typename?: 'cms_StripeProduct_content',
          name?: string,
          slug: string,
          summary?: string,
          brand?: string,
          images?: {
            __typename?: 'cms_UploadFileRelationResponseCollection_content',
            data: Array<{
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                url: string,
                alternativeText?: string
              }
            }>
          },
          product?: {
            __typename?: 'stripe_product',
            id: string,
            price_free_member?: {
              __typename?: 'stripe_price_free_member',
              price_usd?: number
            },
            price_paid_member?: {
              __typename?: 'stripe_price_paid_member',
              price_usd?: number
            },
            price_current?: {
              __typename?: 'stripe_price',
              price_usd: number
            }
          }
        }
      }>
    }
  }
};

export type CommercePageProductFieldsFragment = {
  __typename?: 'cms_StripeProductEntityResponse_content',
  data?: {
    __typename?: 'cms_StripeProductEntity_content',
    attributes?: {
      __typename?: 'cms_StripeProduct_content',
      slug: string,
      summary?: string,
      coming_soon?: boolean,
      out_of_stock?: boolean,
      product?: {
        __typename?: 'stripe_product',
        id: string,
        name: string,
        price?: {
          __typename?: 'stripe_price',
          price_usd: number
        }
      },
      images?: {
        __typename?: 'cms_UploadFileRelationResponseCollection_content',
        data: Array<{
          __typename?: 'cms_UploadFileEntity_content',
          attributes?: {
            __typename?: 'cms_UploadFile_content',
            url: string,
            alternativeText?: string
          }
        }>
      }
    }
  }
};

export type DualProductSectionFieldsFragment = {
  __typename?: 'cms_ComponentDualProductSectionWtfDouble_content',
  id: string,
  is_thumbnail?: boolean,
  left_product?: {
    __typename?: 'cms_StripeProductEntityResponse_content',
    data?: {
      __typename?: 'cms_StripeProductEntity_content',
      attributes?: {
        __typename?: 'cms_StripeProduct_content',
        slug: string,
        summary?: string,
        coming_soon?: boolean,
        out_of_stock?: boolean,
        product?: {
          __typename?: 'stripe_product',
          id: string,
          name: string,
          price?: {
            __typename?: 'stripe_price',
            price_usd: number
          }
        },
        images?: {
          __typename?: 'cms_UploadFileRelationResponseCollection_content',
          data: Array<{
            __typename?: 'cms_UploadFileEntity_content',
            attributes?: {
              __typename?: 'cms_UploadFile_content',
              url: string,
              alternativeText?: string
            }
          }>
        }
      }
    }
  },
  right_product?: {
    __typename?: 'cms_StripeProductEntityResponse_content',
    data?: {
      __typename?: 'cms_StripeProductEntity_content',
      attributes?: {
        __typename?: 'cms_StripeProduct_content',
        slug: string,
        summary?: string,
        coming_soon?: boolean,
        out_of_stock?: boolean,
        product?: {
          __typename?: 'stripe_product',
          id: string,
          name: string,
          price?: {
            __typename?: 'stripe_price',
            price_usd: number
          }
        },
        images?: {
          __typename?: 'cms_UploadFileRelationResponseCollection_content',
          data: Array<{
            __typename?: 'cms_UploadFileEntity_content',
            attributes?: {
              __typename?: 'cms_UploadFile_content',
              url: string,
              alternativeText?: string
            }
          }>
        }
      }
    }
  }
};

export type SingleProductSectionFieldsFragment = {
  __typename?: 'cms_ComponentSingleProductSectionWtf_content',
  id: string,
  image_is_on_left?: boolean,
  stripe_product?: {
    __typename?: 'cms_StripeProductEntityResponse_content',
    data?: {
      __typename?: 'cms_StripeProductEntity_content',
      attributes?: {
        __typename?: 'cms_StripeProduct_content',
        slug: string,
        summary?: string,
        coming_soon?: boolean,
        out_of_stock?: boolean,
        product?: {
          __typename?: 'stripe_product',
          id: string,
          name: string,
          price?: {
            __typename?: 'stripe_price',
            price_usd: number
          }
        },
        images?: {
          __typename?: 'cms_UploadFileRelationResponseCollection_content',
          data: Array<{
            __typename?: 'cms_UploadFileEntity_content',
            attributes?: {
              __typename?: 'cms_UploadFile_content',
              url: string,
              alternativeText?: string
            }
          }>
        }
      }
    }
  }
};

export type CommercePageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type CommercePageQuery = {
  __typename?: 'query_root',
  cms?: {
    __typename?: 'cmsQuery',
    commercePages?: {
      __typename?: 'cms_CommercePageEntityResponseCollection_content',
      data: Array<{
        __typename?: 'cms_CommercePageEntity_content',
        attributes?: {
          __typename?: 'cms_CommercePage_content',
          Header?: Array<{
            __typename?: 'cms_ComponentContentComponentTd_content',
            short_text?: string,
            long_text?: string
          }>,
          sections?: {
            __typename?: 'cms_SectionRelationResponseCollection_content',
            data: Array<{
              __typename?: 'cms_SectionEntity_content',
              attributes?: {
                __typename?: 'cms_Section_content',
                Header?: Array<{
                  __typename?: 'cms_ComponentContentComponentTd_content',
                  short_text?: string,
                  long_text?: string
                }>,
                Rows?: Array<{
                  __typename?: 'cms_ComponentDualProductSectionWtfDouble_content',
                  id: string,
                  is_thumbnail?: boolean,
                  left_product?: {
                    __typename?: 'cms_StripeProductEntityResponse_content',
                    data?: {
                      __typename?: 'cms_StripeProductEntity_content',
                      attributes?: {
                        __typename?: 'cms_StripeProduct_content',
                        slug: string,
                        summary?: string,
                        coming_soon?: boolean,
                        out_of_stock?: boolean,
                        product?: {
                          __typename?: 'stripe_product',
                          id: string,
                          name: string,
                          price?: {
                            __typename?: 'stripe_price',
                            price_usd: number
                          }
                        },
                        images?: {
                          __typename?: 'cms_UploadFileRelationResponseCollection_content',
                          data: Array<{
                            __typename?: 'cms_UploadFileEntity_content',
                            attributes?: {
                              __typename?: 'cms_UploadFile_content',
                              url: string,
                              alternativeText?: string
                            }
                          }>
                        }
                      }
                    }
                  },
                  right_product?: {
                    __typename?: 'cms_StripeProductEntityResponse_content',
                    data?: {
                      __typename?: 'cms_StripeProductEntity_content',
                      attributes?: {
                        __typename?: 'cms_StripeProduct_content',
                        slug: string,
                        summary?: string,
                        coming_soon?: boolean,
                        out_of_stock?: boolean,
                        product?: {
                          __typename?: 'stripe_product',
                          id: string,
                          name: string,
                          price?: {
                            __typename?: 'stripe_price',
                            price_usd: number
                          }
                        },
                        images?: {
                          __typename?: 'cms_UploadFileRelationResponseCollection_content',
                          data: Array<{
                            __typename?: 'cms_UploadFileEntity_content',
                            attributes?: {
                              __typename?: 'cms_UploadFile_content',
                              url: string,
                              alternativeText?: string
                            }
                          }>
                        }
                      }
                    }
                  }
                } | {
                  __typename?: 'cms_ComponentSingleProductSectionWtf_content',
                  id: string,
                  image_is_on_left?: boolean,
                  stripe_product?: {
                    __typename?: 'cms_StripeProductEntityResponse_content',
                    data?: {
                      __typename?: 'cms_StripeProductEntity_content',
                      attributes?: {
                        __typename?: 'cms_StripeProduct_content',
                        slug: string,
                        summary?: string,
                        coming_soon?: boolean,
                        out_of_stock?: boolean,
                        product?: {
                          __typename?: 'stripe_product',
                          id: string,
                          name: string,
                          price?: {
                            __typename?: 'stripe_price',
                            price_usd: number
                          }
                        },
                        images?: {
                          __typename?: 'cms_UploadFileRelationResponseCollection_content',
                          data: Array<{
                            __typename?: 'cms_UploadFileEntity_content',
                            attributes?: {
                              __typename?: 'cms_UploadFile_content',
                              url: string,
                              alternativeText?: string
                            }
                          }>
                        }
                      }
                    }
                  }
                } | {
                  __typename?: 'cms_Error_content'
                }>
              }
            }>
          }
        }
      }>
    }
  }
};

export type StripeOrderByOrderIdQueryVariables = Exact<{
  orderId: Scalars['uuid']['input'];
}>;


export type StripeOrderByOrderIdQuery = {
  __typename?: 'query_root',
  stripe_order: Array<{
    __typename?: 'stripe_order',
    order_number: number,
    created_at: DateTypes.TimestampTZString | string,
    subtotal: number,
    receipt_url?: string,
    tax: number,
    total: number,
    discount: number,
    lab_orders: Array<{
      __typename?: 'lab_order',
      requisition_pdf?: {
        __typename?: 'user_file_vault',
        download: {
          __typename?: 'FileVaultDownloadUrl',
          url?: string
        }
      }
    }>,
    line_items: Array<{
      __typename?: 'stripe_order_line_item',
      total: number,
      is_purchase_request: boolean,
      quantity: number,
      product: {
        __typename?: 'stripe_product',
        is_custom: boolean,
        id: string,
        product_type: enum_stripe_product_type_enum,
        name: string,
        content?: {
          __typename?: 'cms_StripeProductEntityResponse_content',
          data?: {
            __typename?: 'cms_StripeProductEntity_content',
            attributes?: {
              __typename?: 'cms_StripeProduct_content',
              slug: string,
              images?: {
                __typename?: 'cms_UploadFileRelationResponseCollection_content',
                data: Array<{
                  __typename?: 'cms_UploadFileEntity_content',
                  attributes?: {
                    __typename?: 'cms_UploadFile_content',
                    url: string,
                    alternativeText?: string
                  }
                }>
              }
            }
          }
        }
      }
    }>
  }>
};

export type LabShopOrderQueryVariables = Exact<{ [key: string]: never; }>;


export type LabShopOrderQuery = {
  __typename?: 'query_root',
  stripe_order: Array<{
    __typename?: 'stripe_order',
    id: string,
    order_number: number,
    payment_status?: string,
    receipt_url?: string,
    total: number,
    created_at: DateTypes.TimestampTZString | string,
    line_items: Array<{
      __typename?: 'stripe_order_line_item',
      product: {
        __typename?: 'stripe_product',
        product_type: enum_stripe_product_type_enum
      }
    }>,
    lab_orders: Array<{
      __typename?: 'lab_order',
      id: string,
      lab_order_status?: enum_lab_order_status_enum,
      lab_result_status?: enum_lab_result_status_enum,
      order_number: number,
      requisition_pdf?: {
        __typename?: 'user_file_vault',
        download: {
          __typename?: 'FileVaultDownloadUrl',
          url?: string
        }
      },
      results_pdf?: {
        __typename?: 'user_file_vault',
        download: {
          __typename?: 'FileVaultDownloadUrl',
          url?: string
        }
      }
    }>
  }>
};

export type MainSecondaryTextGroupFieldsFragment = {
  __typename?: 'cms_ComponentContentComponentTd_content',
  short_text?: string,
  long_text?: string
};

export type PdpContentQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  skipMedicationFields: Scalars['Boolean']['input'];
  countryAvailability: Scalars['_text']['input'];
}>;


export type PdpContentQuery = {
  __typename?: 'query_root',
  product_catalog: Array<{
    __typename?: 'stripe_product',
    product_type: enum_stripe_product_type_enum,
    id: string,
    purchase_requirements?: Array<{
      __typename?: 'ConsentPurchaseRequirementModel',
      type: purchase_requirement_type_enum,
      status: purchase_requirement_status
    } | {
      __typename?: 'CustomPurchaseRequirementModel',
      type: purchase_requirement_type_enum,
      status: purchase_requirement_status
    } | {
      __typename?: 'MembershipPurchaseRequirementModel',
      type: purchase_requirement_type_enum,
      status: purchase_requirement_status,
      product?: {
        __typename?: 'stripe_product',
        name: string,
        price_free_member?: {
          __typename?: 'stripe_price_free_member',
          price_usd?: number
        },
        price_paid_member?: {
          __typename?: 'stripe_price_paid_member',
          price_usd?: number
        },
        price_current?: {
          __typename?: 'stripe_price',
          price_usd: number
        }
      }
    } | {
      __typename?: 'ProductPurchaseRequirementModel',
      type: purchase_requirement_type_enum,
      status: purchase_requirement_status,
      product?: {
        __typename?: 'stripe_product',
        name: string,
        product_type: enum_stripe_product_type_enum,
        price_free_member?: {
          __typename?: 'stripe_price_free_member',
          price_usd?: number
        },
        price_paid_member?: {
          __typename?: 'stripe_price_paid_member',
          price_usd?: number
        },
        price_current?: {
          __typename?: 'stripe_price',
          price_usd: number
        }
      }
    } | {
      __typename?: 'ProductTypePurchaseRequirementModel',
      type: purchase_requirement_type_enum,
      status: purchase_requirement_status
    }>,
    price_free_member?: {
      __typename?: 'stripe_price_free_member',
      price_usd?: number
    },
    price_paid_member?: {
      __typename?: 'stripe_price_paid_member',
      price_usd?: number
    },
    price_current?: {
      __typename?: 'stripe_price',
      price_usd: number
    }
  }>,
  cms?: {
    __typename?: 'cmsQuery',
    gettingStarted?: {
      __typename?: 'cms_GettingStartedEntityResponse_content',
      data?: {
        __typename?: 'cms_GettingStartedEntity_content',
        attributes?: {
          __typename?: 'cms_GettingStarted_content',
          steps?: Array<{
            __typename?: 'cms_ComponentContentComponentTd_content',
            short_text?: string,
            long_text?: string
          }>
        }
      }
    },
    pricing?: {
      __typename?: 'cms_PricingEntityResponse_content',
      data?: {
        __typename?: 'cms_PricingEntity_content',
        attributes?: {
          __typename?: 'cms_Pricing_content',
          labs?: {
            __typename?: 'cms_ComponentContentComponentTd_content',
            short_text?: string,
            long_text?: string
          },
          membership?: {
            __typename?: 'cms_ComponentContentComponentTd_content',
            short_text?: string,
            long_text?: string
          },
          treatments?: {
            __typename?: 'cms_ComponentContentComponentTd_content',
            short_text?: string,
            long_text?: string
          }
        }
      }
    },
    id?: {
      __typename?: 'cms_StripeProductEntityResponseCollection_content',
      data: Array<{
        __typename?: 'cms_StripeProductEntity_content',
        attributes?: {
          __typename?: 'cms_StripeProduct_content',
          brand?: string,
          coming_soon?: boolean,
          out_of_stock?: boolean,
          summary?: string,
          description?: string,
          product?: {
            __typename?: 'stripe_product',
            name: string
          },
          benefits?: Array<{
            __typename?: 'cms_ComponentContentComponentTd_content',
            short_text?: string,
            long_text?: string
          }>,
          faqs?: Array<{
            __typename?: 'cms_ComponentContentComponentTd_content',
            short_text?: string,
            long_text?: string
          }>,
          safety?: Array<{
            __typename?: 'cms_ComponentContentComponentTd_content',
            short_text?: string,
            long_text?: string
          }>,
          Information?: Array<{
            __typename?: 'cms_ComponentContentComponentTd_content',
            short_text?: string,
            long_text?: string
          }>,
          images?: {
            __typename?: 'cms_UploadFileRelationResponseCollection_content',
            data: Array<{
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                url: string
              }
            }>
          }
        }
      }>
    }
  }
};

export type NewAccountExistingProfileInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type NewAccountExistingProfileInfoQuery = {
  __typename?: 'query_root',
  me_v2?: {
    __typename?: 'user',
    id: string,
    date_of_birth?: string,
    name?: string,
    sex?: enum_sex_enum,
    email?: string
  },
  lab_test_state: Array<{
    __typename?: 'lab_test_state',
    code: string,
    name: string,
    enabled: boolean
  }>,
  lab_profile: Array<{
    __typename?: 'lab_profile',
    birth_date?: string,
    email?: string,
    first_name?: string,
    last_name?: string,
    phone_number?: string,
    sex?: string,
    ship_to_address?: string,
    ship_to_city?: string,
    ship_to_country?: string,
    ship_to_postal_code?: string,
    ship_to_state?: string
  }>,
  user_address: Array<{
    __typename?: 'user_address',
    ship_to_address?: string,
    ship_to_city?: string,
    ship_to_postal_code?: string,
    ship_to_state?: string
  }>
};

export type VitalAppointmentsQueryVariables = Exact<{
  address: PhlebotomyAppointmentAvailabilityInput;
}>;


export type VitalAppointmentsQuery = {
  __typename?: 'query_root',
  get_phlebotomy_appointment_availability?: {
    __typename?: 'PhlebotomyAppointmentAvailabilityResponse',
    timezone?: string
  }
};

export type AcceptConsentPolicyFieldsFragment = {
  __typename?: 'mutation_root',
  accept_consent_policy: Array<{
    __typename?: 'UserConsent',
    consentPolicyVersionId: string,
    acceptedAt: DateTypes.TimestampTZString | string
  }>
};

export type AcceptConsentPoliciesMutationVariables = Exact<{
  consentPolicyIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type AcceptConsentPoliciesMutation = {
  __typename?: 'mutation_root',
  accept_consent_policy: Array<{
    __typename?: 'UserConsent',
    consentPolicyVersionId: string,
    acceptedAt: DateTypes.TimestampTZString | string
  }>
};

export type CreateSelfdecodeProfileAndAcceptTosMutationVariables = Exact<{
  input: CreateLabProfileInput;
  skipRealizeTos: Scalars['Boolean']['input'];
  realizeTosVersion: Scalars['String']['input'];
  isLabAvailableInOrder?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateSelfdecodeProfileAndAcceptTosMutation = {
  __typename?: 'mutation_root',
  create_lab_profile: {
    __typename?: 'LabProfileWithValidation',
    birthDate?: DateTypes.LocalDateString,
    sex?: enum_selfdecode_sex_enum,
    validationMsg?: string
  },
  acceptTermsOfService?: {
    __typename?: 'TermsAcceptance',
    acceptedAt: DateTypes.TimestampTZString | string
  }
};

export type LabTestStateQueryVariables = Exact<{ [key: string]: never; }>;


export type LabTestStateQuery = {
  __typename?: 'query_root',
  lab_test_state: Array<{
    __typename?: 'lab_test_state',
    code: string,
    name: string,
    enabled: boolean
  }>
};

export type UpdateUserDataAcceptTosAndPartiallyUpdateLabProfileMutationVariables = Exact<{
  skipRealizeTos: Scalars['Boolean']['input'];
  version: Scalars['String']['input'];
  id: Scalars['String']['input'];
  rmName: Scalars['String']['input'];
  rmDateOfBirth: Scalars['date']['input'];
  rmSex: enum_sex_enum;
  birthDate: Scalars['Date']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  sex: enum_selfdecode_sex_enum;
  consentPolicyIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UpdateUserDataAcceptTosAndPartiallyUpdateLabProfileMutation = {
  __typename?: 'mutation_root',
  acceptTermsOfService?: {
    __typename?: 'TermsAcceptance',
    acceptedAt: DateTypes.TimestampTZString | string
  },
  update_user_by_pk?: {
    __typename?: 'user',
    id: string
  },
  create_lab_profile: {
    __typename?: 'LabProfileWithValidation',
    isComplete: boolean
  },
  accept_consent_policy: Array<{
    __typename?: 'UserConsent',
    consentPolicyVersionId: string,
    acceptedAt: DateTypes.TimestampTZString | string
  }>
};

export type AtHomeLabsDrawProductInfoQueryVariables = Exact<{
  countryAvailability: Scalars['_text']['input'];
}>;


export type AtHomeLabsDrawProductInfoQuery = {
  __typename?: 'query_root',
  product_catalog: Array<{
    __typename?: 'stripe_product',
    name: string,
    id: string,
    price_free_member?: {
      __typename?: 'stripe_price_free_member',
      price_usd?: number
    },
    price_paid_member?: {
      __typename?: 'stripe_price_paid_member',
      price_usd?: number
    },
    price_current?: {
      __typename?: 'stripe_price',
      price_usd: number
    }
  }>
};

export type SupplementProductsQueryVariables = Exact<{
  countryAvailability: Scalars['_text']['input'];
}>;


export type SupplementProductsQuery = {
  __typename?: 'query_root',
  product_catalog: Array<{
    __typename?: 'stripe_product',
    slug?: string,
    id: string,
    name: string,
    content?: {
      __typename?: 'cms_StripeProductEntityResponse_content',
      data?: {
        __typename?: 'cms_StripeProductEntity_content',
        attributes?: {
          __typename?: 'cms_StripeProduct_content',
          brand?: string,
          out_of_stock?: boolean,
          images?: {
            __typename?: 'cms_UploadFileRelationResponseCollection_content',
            data: Array<{
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                alternativeText?: string,
                url: string
              }
            }>
          }
        }
      }
    },
    price_free_member?: {
      __typename?: 'stripe_price_free_member',
      price_usd?: number
    },
    price_paid_member?: {
      __typename?: 'stripe_price_paid_member',
      price_usd?: number
    },
    price_current?: {
      __typename?: 'stripe_price',
      price_usd: number
    }
  }>
};

export type ProductTypeDefaultImageQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductTypeDefaultImageQuery = {
  __typename?: 'query_root',
  cms?: {
    __typename?: 'cmsQuery',
    productTypeDefaultImage?: {
      __typename?: 'cms_ProductTypeDefaultImageEntityResponse_content',
      data?: {
        __typename?: 'cms_ProductTypeDefaultImageEntity_content',
        attributes?: {
          __typename?: 'cms_ProductTypeDefaultImage_content',
          FEE?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          },
          LAB_PANEL?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          },
          LAB_TEST?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          },
          MEMBERSHIP?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          },
          PACKAGE?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          },
          PRESCRIPTION?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          },
          PRODUCT?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          },
          SUPPLEMENT?: {
            __typename?: 'cms_UploadFileEntityResponse_content',
            data?: {
              __typename?: 'cms_UploadFileEntity_content',
              attributes?: {
                __typename?: 'cms_UploadFile_content',
                size: number,
                width?: number,
                height?: number,
                url: string,
                alternativeText?: string
              }
            }
          }
        }
      }
    }
  }
};

export type ClaimCartMutationVariables = Exact<{
  cartId: Scalars['uuid']['input'];
}>;


export type ClaimCartMutation = {
  __typename?: 'mutation_root',
  claim_cart: {
    __typename?: 'CartModel',
    id: string,
    applied_promo_code?: string,
    appliedMembershipTier: enum_membership_tier_enum,
    total: number,
    cart?: {
      __typename?: 'stripe_order',
      member_discount: number,
      promotion_discount: number,
      tax: number
    },
    purchase_requirements: Array<{
      __typename: 'ConsentPurchaseRequirementModel',
      type: purchase_requirement_type_enum,
      consentPolicyId: string,
      status: purchase_requirement_status,
      consent_policy?: {
        __typename?: 'consent_policy',
        id: string,
        name: string,
        policy_type?: enum_consent_policy_type_enum,
        versions: Array<{
          __typename?: 'consent_policy_version',
          id: string,
          title?: string,
          content?: string,
          external_url?: string
        }>
      }
    } | {
      __typename: 'CustomPurchaseRequirementModel',
      type: purchase_requirement_type_enum,
      status: purchase_requirement_status
    } | {
      __typename?: 'MembershipPurchaseRequirementModel'
    } | {
      __typename?: 'ProductPurchaseRequirementModel'
    } | {
      __typename?: 'ProductTypePurchaseRequirementModel',
      productType: enum_stripe_product_type_enum,
      status: purchase_requirement_status,
      type: purchase_requirement_type_enum
    }>,
    lineItems?: Array<{
      __typename?: 'OrderLineItem',
      quantity: number,
      quantityMin?: number,
      quantityMax?: number,
      productId: string,
      total: number,
      subtotal: number,
      requires?: Array<{
        __typename?: 'OrderLineItemRequiredBy',
        requiresLineItem: {
          __typename?: 'OrderLineItem',
          product?: {
            __typename?: 'stripe_product',
            product_type: enum_stripe_product_type_enum,
            name: string,
            id: string
          }
        }
      }>,
      requiredBy?: Array<{
        __typename?: 'OrderLineItemRequiredBy',
        requiredByLineItem: {
          __typename?: 'OrderLineItem',
          product?: {
            __typename?: 'stripe_product',
            product_type: enum_stripe_product_type_enum,
            name: string,
            id: string
          }
        }
      }>,
      product?: {
        __typename?: 'stripe_product',
        is_custom: boolean,
        slug?: string,
        name: string,
        product_type: enum_stripe_product_type_enum,
        package_products: Array<{
          __typename?: 'stripe_package_product',
          product: {
            __typename?: 'stripe_product',
            id: string,
            name: string,
            product_type: enum_stripe_product_type_enum,
            slug?: string,
            price_free_member?: {
              __typename?: 'stripe_price_free_member',
              price_usd?: number
            },
            price_paid_member?: {
              __typename?: 'stripe_price_paid_member',
              price_usd?: number
            },
            price_current?: {
              __typename?: 'stripe_price',
              price_usd: number
            }
          }
        }>,
        purchase_requirements: Array<{
          __typename: 'ConsentPurchaseRequirementModel',
          type: purchase_requirement_type_enum,
          consentPolicyId: string,
          status: purchase_requirement_status,
          consent_policy?: {
            __typename?: 'consent_policy',
            id: string,
            name: string,
            policy_type?: enum_consent_policy_type_enum,
            versions: Array<{
              __typename?: 'consent_policy_version',
              id: string,
              title?: string,
              content?: string,
              external_url?: string
            }>
          }
        } | {
          __typename: 'CustomPurchaseRequirementModel',
          type: purchase_requirement_type_enum,
          status: purchase_requirement_status
        } | {
          __typename?: 'MembershipPurchaseRequirementModel'
        } | {
          __typename?: 'ProductPurchaseRequirementModel'
        } | {
          __typename?: 'ProductTypePurchaseRequirementModel'
        }>,
        content?: {
          __typename?: 'cms_StripeProductEntityResponse_content',
          data?: {
            __typename?: 'cms_StripeProductEntity_content',
            attributes?: {
              __typename?: 'cms_StripeProduct_content',
              images?: {
                __typename?: 'cms_UploadFileRelationResponseCollection_content',
                data: Array<{
                  __typename?: 'cms_UploadFileEntity_content',
                  attributes?: {
                    __typename?: 'cms_UploadFile_content',
                    alternativeText?: string,
                    url: string
                  }
                }>
              }
            }
          }
        },
        price_free_member?: {
          __typename?: 'stripe_price_free_member',
          price_usd?: number
        },
        price_paid_member?: {
          __typename?: 'stripe_price_paid_member',
          price_usd?: number
        },
        price_current?: {
          __typename?: 'stripe_price',
          price_usd: number
        }
      }
    }>
  }
};

export type CartFieldsFragment = {
  __typename?: 'CartModel',
  id: string,
  applied_promo_code?: string,
  appliedMembershipTier: enum_membership_tier_enum,
  total: number,
  cart?: {
    __typename?: 'stripe_order',
    member_discount: number,
    promotion_discount: number,
    tax: number
  },
  purchase_requirements: Array<{
    __typename: 'ConsentPurchaseRequirementModel',
    type: purchase_requirement_type_enum,
    consentPolicyId: string,
    status: purchase_requirement_status,
    consent_policy?: {
      __typename?: 'consent_policy',
      id: string,
      name: string,
      policy_type?: enum_consent_policy_type_enum,
      versions: Array<{
        __typename?: 'consent_policy_version',
        id: string,
        title?: string,
        content?: string,
        external_url?: string
      }>
    }
  } | {
    __typename: 'CustomPurchaseRequirementModel',
    type: purchase_requirement_type_enum,
    status: purchase_requirement_status
  } | {
    __typename?: 'MembershipPurchaseRequirementModel'
  } | {
    __typename?: 'ProductPurchaseRequirementModel'
  } | {
    __typename?: 'ProductTypePurchaseRequirementModel',
    productType: enum_stripe_product_type_enum,
    status: purchase_requirement_status,
    type: purchase_requirement_type_enum
  }>,
  lineItems?: Array<{
    __typename?: 'OrderLineItem',
    quantity: number,
    quantityMin?: number,
    quantityMax?: number,
    productId: string,
    total: number,
    subtotal: number,
    requires?: Array<{
      __typename?: 'OrderLineItemRequiredBy',
      requiresLineItem: {
        __typename?: 'OrderLineItem',
        product?: {
          __typename?: 'stripe_product',
          product_type: enum_stripe_product_type_enum,
          name: string,
          id: string
        }
      }
    }>,
    requiredBy?: Array<{
      __typename?: 'OrderLineItemRequiredBy',
      requiredByLineItem: {
        __typename?: 'OrderLineItem',
        product?: {
          __typename?: 'stripe_product',
          product_type: enum_stripe_product_type_enum,
          name: string,
          id: string
        }
      }
    }>,
    product?: {
      __typename?: 'stripe_product',
      is_custom: boolean,
      slug?: string,
      name: string,
      product_type: enum_stripe_product_type_enum,
      package_products: Array<{
        __typename?: 'stripe_package_product',
        product: {
          __typename?: 'stripe_product',
          id: string,
          name: string,
          product_type: enum_stripe_product_type_enum,
          slug?: string,
          price_free_member?: {
            __typename?: 'stripe_price_free_member',
            price_usd?: number
          },
          price_paid_member?: {
            __typename?: 'stripe_price_paid_member',
            price_usd?: number
          },
          price_current?: {
            __typename?: 'stripe_price',
            price_usd: number
          }
        }
      }>,
      purchase_requirements: Array<{
        __typename: 'ConsentPurchaseRequirementModel',
        type: purchase_requirement_type_enum,
        consentPolicyId: string,
        status: purchase_requirement_status,
        consent_policy?: {
          __typename?: 'consent_policy',
          id: string,
          name: string,
          policy_type?: enum_consent_policy_type_enum,
          versions: Array<{
            __typename?: 'consent_policy_version',
            id: string,
            title?: string,
            content?: string,
            external_url?: string
          }>
        }
      } | {
        __typename: 'CustomPurchaseRequirementModel',
        type: purchase_requirement_type_enum,
        status: purchase_requirement_status
      } | {
        __typename?: 'MembershipPurchaseRequirementModel'
      } | {
        __typename?: 'ProductPurchaseRequirementModel'
      } | {
        __typename?: 'ProductTypePurchaseRequirementModel'
      }>,
      content?: {
        __typename?: 'cms_StripeProductEntityResponse_content',
        data?: {
          __typename?: 'cms_StripeProductEntity_content',
          attributes?: {
            __typename?: 'cms_StripeProduct_content',
            images?: {
              __typename?: 'cms_UploadFileRelationResponseCollection_content',
              data: Array<{
                __typename?: 'cms_UploadFileEntity_content',
                attributes?: {
                  __typename?: 'cms_UploadFile_content',
                  alternativeText?: string,
                  url: string
                }
              }>
            }
          }
        }
      },
      price_free_member?: {
        __typename?: 'stripe_price_free_member',
        price_usd?: number
      },
      price_paid_member?: {
        __typename?: 'stripe_price_paid_member',
        price_usd?: number
      },
      price_current?: {
        __typename?: 'stripe_price',
        price_usd: number
      }
    }
  }>
};

export type GetCartQueryVariables = Exact<{
  cartId?: InputMaybe<Scalars['uuid']['input']>;
  skipTos: Scalars['Boolean']['input'];
}>;


export type GetCartQuery = {
  __typename?: 'query_root',
  has_accepted_latest_terms?: boolean,
  terms_of_service?: {
    __typename?: 'TermsOfServiceVersion',
    id: string,
    isLatest: boolean,
    date: DateTypes.LocalDateString,
    content: string
  },
  get_cart: {
    __typename?: 'CartModel',
    id: string,
    applied_promo_code?: string,
    appliedMembershipTier: enum_membership_tier_enum,
    total: number,
    cart?: {
      __typename?: 'stripe_order',
      member_discount: number,
      promotion_discount: number,
      tax: number
    },
    purchase_requirements: Array<{
      __typename: 'ConsentPurchaseRequirementModel',
      type: purchase_requirement_type_enum,
      consentPolicyId: string,
      status: purchase_requirement_status,
      consent_policy?: {
        __typename?: 'consent_policy',
        id: string,
        name: string,
        policy_type?: enum_consent_policy_type_enum,
        versions: Array<{
          __typename?: 'consent_policy_version',
          id: string,
          title?: string,
          content?: string,
          external_url?: string
        }>
      }
    } | {
      __typename: 'CustomPurchaseRequirementModel',
      type: purchase_requirement_type_enum,
      status: purchase_requirement_status
    } | {
      __typename?: 'MembershipPurchaseRequirementModel'
    } | {
      __typename?: 'ProductPurchaseRequirementModel'
    } | {
      __typename?: 'ProductTypePurchaseRequirementModel',
      productType: enum_stripe_product_type_enum,
      status: purchase_requirement_status,
      type: purchase_requirement_type_enum
    }>,
    lineItems?: Array<{
      __typename?: 'OrderLineItem',
      quantity: number,
      quantityMin?: number,
      quantityMax?: number,
      productId: string,
      total: number,
      subtotal: number,
      requires?: Array<{
        __typename?: 'OrderLineItemRequiredBy',
        requiresLineItem: {
          __typename?: 'OrderLineItem',
          product?: {
            __typename?: 'stripe_product',
            product_type: enum_stripe_product_type_enum,
            name: string,
            id: string
          }
        }
      }>,
      requiredBy?: Array<{
        __typename?: 'OrderLineItemRequiredBy',
        requiredByLineItem: {
          __typename?: 'OrderLineItem',
          product?: {
            __typename?: 'stripe_product',
            product_type: enum_stripe_product_type_enum,
            name: string,
            id: string
          }
        }
      }>,
      product?: {
        __typename?: 'stripe_product',
        is_custom: boolean,
        slug?: string,
        name: string,
        product_type: enum_stripe_product_type_enum,
        package_products: Array<{
          __typename?: 'stripe_package_product',
          product: {
            __typename?: 'stripe_product',
            id: string,
            name: string,
            product_type: enum_stripe_product_type_enum,
            slug?: string,
            price_free_member?: {
              __typename?: 'stripe_price_free_member',
              price_usd?: number
            },
            price_paid_member?: {
              __typename?: 'stripe_price_paid_member',
              price_usd?: number
            },
            price_current?: {
              __typename?: 'stripe_price',
              price_usd: number
            }
          }
        }>,
        purchase_requirements: Array<{
          __typename: 'ConsentPurchaseRequirementModel',
          type: purchase_requirement_type_enum,
          consentPolicyId: string,
          status: purchase_requirement_status,
          consent_policy?: {
            __typename?: 'consent_policy',
            id: string,
            name: string,
            policy_type?: enum_consent_policy_type_enum,
            versions: Array<{
              __typename?: 'consent_policy_version',
              id: string,
              title?: string,
              content?: string,
              external_url?: string
            }>
          }
        } | {
          __typename: 'CustomPurchaseRequirementModel',
          type: purchase_requirement_type_enum,
          status: purchase_requirement_status
        } | {
          __typename?: 'MembershipPurchaseRequirementModel'
        } | {
          __typename?: 'ProductPurchaseRequirementModel'
        } | {
          __typename?: 'ProductTypePurchaseRequirementModel'
        }>,
        content?: {
          __typename?: 'cms_StripeProductEntityResponse_content',
          data?: {
            __typename?: 'cms_StripeProductEntity_content',
            attributes?: {
              __typename?: 'cms_StripeProduct_content',
              images?: {
                __typename?: 'cms_UploadFileRelationResponseCollection_content',
                data: Array<{
                  __typename?: 'cms_UploadFileEntity_content',
                  attributes?: {
                    __typename?: 'cms_UploadFile_content',
                    alternativeText?: string,
                    url: string
                  }
                }>
              }
            }
          }
        },
        price_free_member?: {
          __typename?: 'stripe_price_free_member',
          price_usd?: number
        },
        price_paid_member?: {
          __typename?: 'stripe_price_paid_member',
          price_usd?: number
        },
        price_current?: {
          __typename?: 'stripe_price',
          price_usd: number
        }
      }
    }>
  }
};

export type UpdateCartMutationVariables = Exact<{
  entries: Array<CartItemInput> | CartItemInput;
  cartId?: InputMaybe<Scalars['uuid']['input']>;
  customPackageTests?: InputMaybe<Array<CustomPackageTestInput> | CustomPackageTestInput>;
}>;


export type UpdateCartMutation = {
  __typename?: 'mutation_root',
  update_cart: {
    __typename?: 'CartModel',
    id: string,
    applied_promo_code?: string,
    appliedMembershipTier: enum_membership_tier_enum,
    total: number,
    cart?: {
      __typename?: 'stripe_order',
      member_discount: number,
      promotion_discount: number,
      tax: number
    },
    purchase_requirements: Array<{
      __typename: 'ConsentPurchaseRequirementModel',
      type: purchase_requirement_type_enum,
      consentPolicyId: string,
      status: purchase_requirement_status,
      consent_policy?: {
        __typename?: 'consent_policy',
        id: string,
        name: string,
        policy_type?: enum_consent_policy_type_enum,
        versions: Array<{
          __typename?: 'consent_policy_version',
          id: string,
          title?: string,
          content?: string,
          external_url?: string
        }>
      }
    } | {
      __typename: 'CustomPurchaseRequirementModel',
      type: purchase_requirement_type_enum,
      status: purchase_requirement_status
    } | {
      __typename?: 'MembershipPurchaseRequirementModel'
    } | {
      __typename?: 'ProductPurchaseRequirementModel'
    } | {
      __typename?: 'ProductTypePurchaseRequirementModel',
      productType: enum_stripe_product_type_enum,
      status: purchase_requirement_status,
      type: purchase_requirement_type_enum
    }>,
    lineItems?: Array<{
      __typename?: 'OrderLineItem',
      quantity: number,
      quantityMin?: number,
      quantityMax?: number,
      productId: string,
      total: number,
      subtotal: number,
      requires?: Array<{
        __typename?: 'OrderLineItemRequiredBy',
        requiresLineItem: {
          __typename?: 'OrderLineItem',
          product?: {
            __typename?: 'stripe_product',
            product_type: enum_stripe_product_type_enum,
            name: string,
            id: string
          }
        }
      }>,
      requiredBy?: Array<{
        __typename?: 'OrderLineItemRequiredBy',
        requiredByLineItem: {
          __typename?: 'OrderLineItem',
          product?: {
            __typename?: 'stripe_product',
            product_type: enum_stripe_product_type_enum,
            name: string,
            id: string
          }
        }
      }>,
      product?: {
        __typename?: 'stripe_product',
        is_custom: boolean,
        slug?: string,
        name: string,
        product_type: enum_stripe_product_type_enum,
        package_products: Array<{
          __typename?: 'stripe_package_product',
          product: {
            __typename?: 'stripe_product',
            id: string,
            name: string,
            product_type: enum_stripe_product_type_enum,
            slug?: string,
            price_free_member?: {
              __typename?: 'stripe_price_free_member',
              price_usd?: number
            },
            price_paid_member?: {
              __typename?: 'stripe_price_paid_member',
              price_usd?: number
            },
            price_current?: {
              __typename?: 'stripe_price',
              price_usd: number
            }
          }
        }>,
        purchase_requirements: Array<{
          __typename: 'ConsentPurchaseRequirementModel',
          type: purchase_requirement_type_enum,
          consentPolicyId: string,
          status: purchase_requirement_status,
          consent_policy?: {
            __typename?: 'consent_policy',
            id: string,
            name: string,
            policy_type?: enum_consent_policy_type_enum,
            versions: Array<{
              __typename?: 'consent_policy_version',
              id: string,
              title?: string,
              content?: string,
              external_url?: string
            }>
          }
        } | {
          __typename: 'CustomPurchaseRequirementModel',
          type: purchase_requirement_type_enum,
          status: purchase_requirement_status
        } | {
          __typename?: 'MembershipPurchaseRequirementModel'
        } | {
          __typename?: 'ProductPurchaseRequirementModel'
        } | {
          __typename?: 'ProductTypePurchaseRequirementModel'
        }>,
        content?: {
          __typename?: 'cms_StripeProductEntityResponse_content',
          data?: {
            __typename?: 'cms_StripeProductEntity_content',
            attributes?: {
              __typename?: 'cms_StripeProduct_content',
              images?: {
                __typename?: 'cms_UploadFileRelationResponseCollection_content',
                data: Array<{
                  __typename?: 'cms_UploadFileEntity_content',
                  attributes?: {
                    __typename?: 'cms_UploadFile_content',
                    alternativeText?: string,
                    url: string
                  }
                }>
              }
            }
          }
        },
        price_free_member?: {
          __typename?: 'stripe_price_free_member',
          price_usd?: number
        },
        price_paid_member?: {
          __typename?: 'stripe_price_paid_member',
          price_usd?: number
        },
        price_current?: {
          __typename?: 'stripe_price',
          price_usd: number
        }
      }
    }>
  }
};

export type SetPromoMutationVariables = Exact<{
  promoCode: Scalars['String']['input'];
  cartId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type SetPromoMutation = {
  __typename?: 'mutation_root',
  set_cart_promo: {
    __typename?: 'CartModel',
    id: string,
    applied_promo_code?: string,
    appliedMembershipTier: enum_membership_tier_enum,
    total: number,
    cart?: {
      __typename?: 'stripe_order',
      member_discount: number,
      promotion_discount: number,
      tax: number
    },
    purchase_requirements: Array<{
      __typename: 'ConsentPurchaseRequirementModel',
      type: purchase_requirement_type_enum,
      consentPolicyId: string,
      status: purchase_requirement_status,
      consent_policy?: {
        __typename?: 'consent_policy',
        id: string,
        name: string,
        policy_type?: enum_consent_policy_type_enum,
        versions: Array<{
          __typename?: 'consent_policy_version',
          id: string,
          title?: string,
          content?: string,
          external_url?: string
        }>
      }
    } | {
      __typename: 'CustomPurchaseRequirementModel',
      type: purchase_requirement_type_enum,
      status: purchase_requirement_status
    } | {
      __typename?: 'MembershipPurchaseRequirementModel'
    } | {
      __typename?: 'ProductPurchaseRequirementModel'
    } | {
      __typename?: 'ProductTypePurchaseRequirementModel',
      productType: enum_stripe_product_type_enum,
      status: purchase_requirement_status,
      type: purchase_requirement_type_enum
    }>,
    lineItems?: Array<{
      __typename?: 'OrderLineItem',
      quantity: number,
      quantityMin?: number,
      quantityMax?: number,
      productId: string,
      total: number,
      subtotal: number,
      requires?: Array<{
        __typename?: 'OrderLineItemRequiredBy',
        requiresLineItem: {
          __typename?: 'OrderLineItem',
          product?: {
            __typename?: 'stripe_product',
            product_type: enum_stripe_product_type_enum,
            name: string,
            id: string
          }
        }
      }>,
      requiredBy?: Array<{
        __typename?: 'OrderLineItemRequiredBy',
        requiredByLineItem: {
          __typename?: 'OrderLineItem',
          product?: {
            __typename?: 'stripe_product',
            product_type: enum_stripe_product_type_enum,
            name: string,
            id: string
          }
        }
      }>,
      product?: {
        __typename?: 'stripe_product',
        is_custom: boolean,
        slug?: string,
        name: string,
        product_type: enum_stripe_product_type_enum,
        package_products: Array<{
          __typename?: 'stripe_package_product',
          product: {
            __typename?: 'stripe_product',
            id: string,
            name: string,
            product_type: enum_stripe_product_type_enum,
            slug?: string,
            price_free_member?: {
              __typename?: 'stripe_price_free_member',
              price_usd?: number
            },
            price_paid_member?: {
              __typename?: 'stripe_price_paid_member',
              price_usd?: number
            },
            price_current?: {
              __typename?: 'stripe_price',
              price_usd: number
            }
          }
        }>,
        purchase_requirements: Array<{
          __typename: 'ConsentPurchaseRequirementModel',
          type: purchase_requirement_type_enum,
          consentPolicyId: string,
          status: purchase_requirement_status,
          consent_policy?: {
            __typename?: 'consent_policy',
            id: string,
            name: string,
            policy_type?: enum_consent_policy_type_enum,
            versions: Array<{
              __typename?: 'consent_policy_version',
              id: string,
              title?: string,
              content?: string,
              external_url?: string
            }>
          }
        } | {
          __typename: 'CustomPurchaseRequirementModel',
          type: purchase_requirement_type_enum,
          status: purchase_requirement_status
        } | {
          __typename?: 'MembershipPurchaseRequirementModel'
        } | {
          __typename?: 'ProductPurchaseRequirementModel'
        } | {
          __typename?: 'ProductTypePurchaseRequirementModel'
        }>,
        content?: {
          __typename?: 'cms_StripeProductEntityResponse_content',
          data?: {
            __typename?: 'cms_StripeProductEntity_content',
            attributes?: {
              __typename?: 'cms_StripeProduct_content',
              images?: {
                __typename?: 'cms_UploadFileRelationResponseCollection_content',
                data: Array<{
                  __typename?: 'cms_UploadFileEntity_content',
                  attributes?: {
                    __typename?: 'cms_UploadFile_content',
                    alternativeText?: string,
                    url: string
                  }
                }>
              }
            }
          }
        },
        price_free_member?: {
          __typename?: 'stripe_price_free_member',
          price_usd?: number
        },
        price_paid_member?: {
          __typename?: 'stripe_price_paid_member',
          price_usd?: number
        },
        price_current?: {
          __typename?: 'stripe_price',
          price_usd: number
        }
      }
    }>
  }
};

export type EmptyCartMutationVariables = Exact<{
  cartId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type EmptyCartMutation = {
  __typename?: 'mutation_root',
  empty_cart: {
    __typename?: 'CartModel',
    id: string,
    applied_promo_code?: string,
    appliedMembershipTier: enum_membership_tier_enum,
    total: number,
    cart?: {
      __typename?: 'stripe_order',
      member_discount: number,
      promotion_discount: number,
      tax: number
    },
    purchase_requirements: Array<{
      __typename: 'ConsentPurchaseRequirementModel',
      type: purchase_requirement_type_enum,
      consentPolicyId: string,
      status: purchase_requirement_status,
      consent_policy?: {
        __typename?: 'consent_policy',
        id: string,
        name: string,
        policy_type?: enum_consent_policy_type_enum,
        versions: Array<{
          __typename?: 'consent_policy_version',
          id: string,
          title?: string,
          content?: string,
          external_url?: string
        }>
      }
    } | {
      __typename: 'CustomPurchaseRequirementModel',
      type: purchase_requirement_type_enum,
      status: purchase_requirement_status
    } | {
      __typename?: 'MembershipPurchaseRequirementModel'
    } | {
      __typename?: 'ProductPurchaseRequirementModel'
    } | {
      __typename?: 'ProductTypePurchaseRequirementModel',
      productType: enum_stripe_product_type_enum,
      status: purchase_requirement_status,
      type: purchase_requirement_type_enum
    }>,
    lineItems?: Array<{
      __typename?: 'OrderLineItem',
      quantity: number,
      quantityMin?: number,
      quantityMax?: number,
      productId: string,
      total: number,
      subtotal: number,
      requires?: Array<{
        __typename?: 'OrderLineItemRequiredBy',
        requiresLineItem: {
          __typename?: 'OrderLineItem',
          product?: {
            __typename?: 'stripe_product',
            product_type: enum_stripe_product_type_enum,
            name: string,
            id: string
          }
        }
      }>,
      requiredBy?: Array<{
        __typename?: 'OrderLineItemRequiredBy',
        requiredByLineItem: {
          __typename?: 'OrderLineItem',
          product?: {
            __typename?: 'stripe_product',
            product_type: enum_stripe_product_type_enum,
            name: string,
            id: string
          }
        }
      }>,
      product?: {
        __typename?: 'stripe_product',
        is_custom: boolean,
        slug?: string,
        name: string,
        product_type: enum_stripe_product_type_enum,
        package_products: Array<{
          __typename?: 'stripe_package_product',
          product: {
            __typename?: 'stripe_product',
            id: string,
            name: string,
            product_type: enum_stripe_product_type_enum,
            slug?: string,
            price_free_member?: {
              __typename?: 'stripe_price_free_member',
              price_usd?: number
            },
            price_paid_member?: {
              __typename?: 'stripe_price_paid_member',
              price_usd?: number
            },
            price_current?: {
              __typename?: 'stripe_price',
              price_usd: number
            }
          }
        }>,
        purchase_requirements: Array<{
          __typename: 'ConsentPurchaseRequirementModel',
          type: purchase_requirement_type_enum,
          consentPolicyId: string,
          status: purchase_requirement_status,
          consent_policy?: {
            __typename?: 'consent_policy',
            id: string,
            name: string,
            policy_type?: enum_consent_policy_type_enum,
            versions: Array<{
              __typename?: 'consent_policy_version',
              id: string,
              title?: string,
              content?: string,
              external_url?: string
            }>
          }
        } | {
          __typename: 'CustomPurchaseRequirementModel',
          type: purchase_requirement_type_enum,
          status: purchase_requirement_status
        } | {
          __typename?: 'MembershipPurchaseRequirementModel'
        } | {
          __typename?: 'ProductPurchaseRequirementModel'
        } | {
          __typename?: 'ProductTypePurchaseRequirementModel'
        }>,
        content?: {
          __typename?: 'cms_StripeProductEntityResponse_content',
          data?: {
            __typename?: 'cms_StripeProductEntity_content',
            attributes?: {
              __typename?: 'cms_StripeProduct_content',
              images?: {
                __typename?: 'cms_UploadFileRelationResponseCollection_content',
                data: Array<{
                  __typename?: 'cms_UploadFileEntity_content',
                  attributes?: {
                    __typename?: 'cms_UploadFile_content',
                    alternativeText?: string,
                    url: string
                  }
                }>
              }
            }
          }
        },
        price_free_member?: {
          __typename?: 'stripe_price_free_member',
          price_usd?: number
        },
        price_paid_member?: {
          __typename?: 'stripe_price_paid_member',
          price_usd?: number
        },
        price_current?: {
          __typename?: 'stripe_price',
          price_usd: number
        }
      }
    }>
  }
};

export type CheckoutMutationVariables = Exact<{
  successUrl: Scalars['URL']['input'];
  cancelUrl: Scalars['URL']['input'];
}>;


export type CheckoutMutation = {
  __typename?: 'mutation_root',
  checkout_cart: {
    __typename?: 'CartCheckoutModel',
    id: string,
    url: string
  }
};

export type RealizeTosDataQueryVariables = Exact<{ [key: string]: never; }>;


export type RealizeTosDataQuery = {
  __typename?: 'query_root',
  has_accepted_latest_terms: boolean,
  terms_of_service: {
    __typename?: 'TermsOfServiceVersion',
    id: string,
    isLatest: boolean,
    date: DateTypes.LocalDateString,
    content: string
  }
};

export type ConsentPurchaseRequirementFieldsFragment = {
  __typename: 'ConsentPurchaseRequirementModel',
  type: purchase_requirement_type_enum,
  consentPolicyId: string,
  status: purchase_requirement_status,
  consent_policy?: {
    __typename?: 'consent_policy',
    id: string,
    name: string,
    policy_type?: enum_consent_policy_type_enum,
    versions: Array<{
      __typename?: 'consent_policy_version',
      id: string,
      title?: string,
      content?: string,
      external_url?: string
    }>
  }
};

export type CustomPurchaseRequirementFieldsFragment = {
  __typename: 'CustomPurchaseRequirementModel',
  type: purchase_requirement_type_enum,
  status: purchase_requirement_status
};

export type ProductTypePurchaseRequirementFieldsFragment = {
  __typename?: 'ProductTypePurchaseRequirementModel',
  productType: enum_stripe_product_type_enum,
  status: purchase_requirement_status,
  type: purchase_requirement_type_enum
};

export type GetPurchaseRequirementsQueryVariables = Exact<{
  productIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetPurchaseRequirementsQuery = {
  __typename?: 'query_root',
  get_purchase_requirements: Array<{
    __typename: 'ConsentPurchaseRequirementModel',
    type: purchase_requirement_type_enum,
    consentPolicyId: string,
    status: purchase_requirement_status,
    consent_policy?: {
      __typename?: 'consent_policy',
      id: string,
      name: string,
      policy_type?: enum_consent_policy_type_enum,
      versions: Array<{
        __typename?: 'consent_policy_version',
        id: string,
        title?: string,
        content?: string,
        external_url?: string
      }>
    }
  } | {
    __typename: 'CustomPurchaseRequirementModel',
    type: purchase_requirement_type_enum,
    status: purchase_requirement_status
  } | {
    __typename?: 'MembershipPurchaseRequirementModel'
  } | {
    __typename?: 'ProductPurchaseRequirementModel'
  } | {
    __typename?: 'ProductTypePurchaseRequirementModel',
    productType: enum_stripe_product_type_enum,
    status: purchase_requirement_status,
    type: purchase_requirement_type_enum
  }>
};

export type ShopPageStripeProductFieldsFragment = {
  __typename?: 'cms_StripeProductEntity_content',
  attributes?: {
    __typename?: 'cms_StripeProduct_content',
    slug: string,
    summary?: string,
    coming_soon?: boolean,
    out_of_stock?: boolean,
    product?: {
      __typename?: 'stripe_product',
      id: string,
      product_type: enum_stripe_product_type_enum,
      name: string,
      price_free_member?: {
        __typename?: 'stripe_price_free_member',
        price_usd?: number
      },
      price_paid_member?: {
        __typename?: 'stripe_price_paid_member',
        price_usd?: number
      },
      price_current?: {
        __typename?: 'stripe_price',
        price_usd: number
      }
    },
    images?: {
      __typename?: 'cms_UploadFileRelationResponseCollection_content',
      data: Array<{
        __typename?: 'cms_UploadFileEntity_content',
        attributes?: {
          __typename?: 'cms_UploadFile_content',
          url: string,
          alternativeText?: string
        }
      }>
    }
  }
};

export type SectionFragment = {
  __typename?: 'cms_ComponentShopSectionShopSection_content',
  id: string,
  Title: string,
  Subtitle?: string,
  Description?: string,
  CTA_Text?: string,
  stripe_products?: {
    __typename?: 'cms_StripeProductRelationResponseCollection_content',
    data: Array<{
      __typename?: 'cms_StripeProductEntity_content',
      attributes?: {
        __typename?: 'cms_StripeProduct_content',
        slug: string,
        summary?: string,
        coming_soon?: boolean,
        out_of_stock?: boolean,
        product?: {
          __typename?: 'stripe_product',
          id: string,
          product_type: enum_stripe_product_type_enum,
          name: string,
          price_free_member?: {
            __typename?: 'stripe_price_free_member',
            price_usd?: number
          },
          price_paid_member?: {
            __typename?: 'stripe_price_paid_member',
            price_usd?: number
          },
          price_current?: {
            __typename?: 'stripe_price',
            price_usd: number
          }
        },
        images?: {
          __typename?: 'cms_UploadFileRelationResponseCollection_content',
          data: Array<{
            __typename?: 'cms_UploadFileEntity_content',
            attributes?: {
              __typename?: 'cms_UploadFile_content',
              url: string,
              alternativeText?: string
            }
          }>
        }
      }
    }>
  }
};

export type ShopPageFeaturedProductsQueryVariables = Exact<{
  availableCaFilter: cms_BooleanFilterInput_content;
}>;


export type ShopPageFeaturedProductsQuery = {
  __typename?: 'query_root',
  cms?: {
    __typename?: 'cmsQuery',
    shopPageFeatured?: {
      __typename?: 'cms_ShopPageFeaturedEntityResponse_content',
      data?: {
        __typename?: 'cms_ShopPageFeaturedEntity_content',
        attributes?: {
          __typename?: 'cms_ShopPageFeatured_content',
          lab_tests?: Array<{
            __typename?: 'cms_ComponentShopSectionShopSection_content',
            id: string,
            Title: string,
            Subtitle?: string,
            Description?: string,
            CTA_Text?: string,
            stripe_products?: {
              __typename?: 'cms_StripeProductRelationResponseCollection_content',
              data: Array<{
                __typename?: 'cms_StripeProductEntity_content',
                attributes?: {
                  __typename?: 'cms_StripeProduct_content',
                  slug: string,
                  summary?: string,
                  coming_soon?: boolean,
                  out_of_stock?: boolean,
                  product?: {
                    __typename?: 'stripe_product',
                    id: string,
                    product_type: enum_stripe_product_type_enum,
                    name: string,
                    price_free_member?: {
                      __typename?: 'stripe_price_free_member',
                      price_usd?: number
                    },
                    price_paid_member?: {
                      __typename?: 'stripe_price_paid_member',
                      price_usd?: number
                    },
                    price_current?: {
                      __typename?: 'stripe_price',
                      price_usd: number
                    }
                  },
                  images?: {
                    __typename?: 'cms_UploadFileRelationResponseCollection_content',
                    data: Array<{
                      __typename?: 'cms_UploadFileEntity_content',
                      attributes?: {
                        __typename?: 'cms_UploadFile_content',
                        url: string,
                        alternativeText?: string
                      }
                    }>
                  }
                }
              }>
            }
          }>,
          supplements?: Array<{
            __typename?: 'cms_ComponentShopSectionShopSection_content',
            id: string,
            Title: string,
            Subtitle?: string,
            Description?: string,
            CTA_Text?: string,
            stripe_products?: {
              __typename?: 'cms_StripeProductRelationResponseCollection_content',
              data: Array<{
                __typename?: 'cms_StripeProductEntity_content',
                attributes?: {
                  __typename?: 'cms_StripeProduct_content',
                  slug: string,
                  summary?: string,
                  coming_soon?: boolean,
                  out_of_stock?: boolean,
                  product?: {
                    __typename?: 'stripe_product',
                    id: string,
                    product_type: enum_stripe_product_type_enum,
                    name: string,
                    price_free_member?: {
                      __typename?: 'stripe_price_free_member',
                      price_usd?: number
                    },
                    price_paid_member?: {
                      __typename?: 'stripe_price_paid_member',
                      price_usd?: number
                    },
                    price_current?: {
                      __typename?: 'stripe_price',
                      price_usd: number
                    }
                  },
                  images?: {
                    __typename?: 'cms_UploadFileRelationResponseCollection_content',
                    data: Array<{
                      __typename?: 'cms_UploadFileEntity_content',
                      attributes?: {
                        __typename?: 'cms_UploadFile_content',
                        url: string,
                        alternativeText?: string
                      }
                    }>
                  }
                }
              }>
            }
          }>
        }
      }
    }
  }
};

export type SupplementSuggestionQueryVariables = Exact<{
  datetime: Scalars['timestamptz']['input'];
}>;


export type SupplementSuggestionQuery = {
  __typename?: 'query_root',
  supplement_suggestion: Array<{
    __typename?: 'SupplementSuggestion',
    name: string,
    brand?: string,
    mostFrequentServing: number,
    servingSize?: string,
    id: string
  }>
};

export type SupplementLogHistoryQueryVariables = Exact<{
  start: Scalars['timestamptz']['input'];
  end: Scalars['timestamptz']['input'];
}>;


export type SupplementLogHistoryQuery = {
  __typename?: 'query_root',
  supplement: Array<{
    __typename?: 'supplement',
    serving_size?: string,
    metric?: {
      __typename?: 'metric',
      metric_records: Array<{
        __typename?: 'metric_record',
        id: string,
        datetime_utc: DateTypes.TimestampTZString | string,
        value?: number,
        metric: {
          __typename?: 'metric',
          name: string
        }
      }>
    }
  }>
};

export type DeleteSupplementLogRecordByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteSupplementLogRecordByIdMutation = {
  __typename?: 'mutation_root',
  delete_metric_record_by_pk?: {
    __typename?: 'metric_record',
    id: string
  }
};

export type CreateSupplementRecordMutationVariables = Exact<{
  input: Array<CreateSupplementRecordInput> | CreateSupplementRecordInput;
}>;


export type CreateSupplementRecordMutation = {
  __typename?: 'mutation_root',
  create_supplement_record: Array<{
    __typename?: 'SupplementRecord',
    id: string,
    supplementId: string,
    servings: number
  }>
};

export type TrackedQualitativeMetricsQueryVariables = Exact<{
  dateString: Scalars['timestamptz']['input'];
  dayAfterDateString: Scalars['timestamptz']['input'];
}>;


export type TrackedQualitativeMetricsQuery = {
  __typename?: 'query_root',
  tracked_metric: Array<{
    __typename?: 'tracked_metric',
    sort_order?: number,
    metric: {
      __typename?: 'metric',
      scale_label_low?: string,
      scale_label_high?: string,
      key: string,
      id: string,
      metric_type: metric_type_enum,
      name: string,
      unit?: string,
      metric_records: Array<{
        __typename?: 'metric_record',
        id: string,
        external_id?: string,
        data_source: enum_data_source_enum,
        value?: number
      }>
    }
  }>
};

export type UpdateTrackedMetricManyMutationVariables = Exact<{
  updates: Array<tracked_metric_updates> | tracked_metric_updates;
}>;


export type UpdateTrackedMetricManyMutation = {
  __typename?: 'mutation_root',
  update_tracked_metric_many?: Array<{
    __typename?: 'tracked_metric_mutation_response',
    returning: Array<{
      __typename?: 'tracked_metric',
      sort_order?: number
    }>
  }>
};

export type RelatedContentsQueryVariables = Exact<{
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type RelatedContentsQuery = {
  __typename?: 'query_root',
  cms?: {
    __typename?: 'cmsQuery',
    relatedContents?: {
      __typename?: 'cms_RelatedContentEntityResponseCollection_content',
      data: Array<{
        __typename?: 'cms_RelatedContentEntity_content',
        attributes?: {
          __typename?: 'cms_RelatedContent_content',
          entity_id?: string,
          link?: string
        }
      }>
    }
  }
};

export const ActionItemInputFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionItemInputFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action_item_input"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"input_type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}}]}}]} as unknown as DocumentNode;
export const MetricMetricRecordsRollupFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricMetricRecordsRollupFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric_records_rollup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"Argument","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"Argument","name":{"kind":"Name","value":"interval_type"},"value":{"kind":"EnumValue","value":"day"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval_start"}},{"kind":"Field","name":{"kind":"Name","value":"preference_avg"}}]}}]}}]} as unknown as DocumentNode;
export const OuraDataSourceActionItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OuraDataSourceActionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"circle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_user_inputs"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"oura"}}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export const ImageAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;
export const CirclesListCircleFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CirclesListCircleFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"circle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_owner"}},{"kind":"Field","name":{"kind":"Name","value":"weekSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;
export const CircleImageFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CircleImageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"circle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hero_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;
export const CircleInviteAndCircleDetailsSharedFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CircleInviteAndCircleDetailsSharedFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"circle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"checkout_bundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"related_contents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"entity_id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CircleImageFields"}},{"kind":"Field","alias":{"kind":"Name","value":"action_items"},"name":{"kind":"Name","value":"action_items_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"action_item_user"},"name":{"kind":"Name","value":"template_action_item_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"personalized_name"}},{"kind":"Field","name":{"kind":"Name","value":"preference_value_target"}},{"kind":"Field","name":{"kind":"Name","value":"instance_target"}},{"kind":"Field","name":{"kind":"Name","value":"instance_target_type"}},{"kind":"Field","name":{"kind":"Name","value":"value_rollup_type"}},{"kind":"Field","name":{"kind":"Name","value":"weekly_instance_target"}},{"kind":"Field","name":{"kind":"Name","value":"circle_action_items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sort_order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_image"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"interval_type"}},{"kind":"Field","name":{"kind":"Name","value":"interval_count"}},{"kind":"Field","name":{"kind":"Name","value":"preference_value_target"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}},{"kind":"Field","name":{"kind":"Name","value":"display_symbol_plural"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name_plural"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_item_inputs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"input_type"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CircleImageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"circle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hero_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;
export const ActionPlanUpdateActionItemUserSharedFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionPlanUpdateActionItemUserSharedFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action_item_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"personalized_name"}},{"kind":"Field","name":{"kind":"Name","value":"interval_type"}},{"kind":"Field","name":{"kind":"Name","value":"weekly_instance_target"}},{"kind":"Field","name":{"kind":"Name","value":"preference_value_target"}},{"kind":"Field","name":{"kind":"Name","value":"action_item_user_inputs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_item_input"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data_source"}},{"kind":"Field","name":{"kind":"Name","value":"input_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}},{"kind":"Field","name":{"kind":"Name","value":"display_symbol_plural"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name_plural"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const ActionItemUserFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionItemUserFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action_item_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"personalized_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"action_item_user_inputs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"manual_entry_log"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_item_input"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data_source"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prevent_add_to_circle"}},{"kind":"Field","name":{"kind":"Name","value":"prevent_add_to_circle_reason"}}]}}]}}]} as unknown as DocumentNode;
export const DashboardFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_template"}},{"kind":"Field","name":{"kind":"Name","value":"tabs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"charts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chart_tabs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chart_type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"view_metrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rollup_type"}},{"kind":"Field","name":{"kind":"Name","value":"interval_type"}},{"kind":"Field","name":{"kind":"Name","value":"interval_count"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}},{"kind":"Field","name":{"kind":"Name","value":"metric_id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"metricDisplayName"},"name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"metric_targets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"preference_target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"experiment_metrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"experiment_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuidComparisonExp"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"experiment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const StreakFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreakFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Streak"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period_start"}},{"kind":"Field","name":{"kind":"Name","value":"period_end"}},{"kind":"Field","name":{"kind":"Name","value":"is_active"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"preference_target"}},{"kind":"Field","name":{"kind":"Name","value":"period"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"weeks"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}}]}}]} as unknown as DocumentNode;
export const MetricStreaksFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricStreaksFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"active_streak"},"name":{"kind":"Name","value":"streak"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"end_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreakFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"most_recent_streak"},"name":{"kind":"Name","value":"streak"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}},{"kind":"Argument","name":{"kind":"Name","value":"end_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreakFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreakFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Streak"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period_start"}},{"kind":"Field","name":{"kind":"Name","value":"period_end"}},{"kind":"Field","name":{"kind":"Name","value":"is_active"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"preference_target"}},{"kind":"Field","name":{"kind":"Name","value":"period"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"weeks"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}}]}}]} as unknown as DocumentNode;
export const OuraActivityRecordFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OuraActivityRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export const StripeProductPriceFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StripeProductPriceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_free_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_paid_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}}]} as unknown as DocumentNode;
export const ProductCatalogFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCatalogFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StripeProductPriceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_free_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_paid_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}}]} as unknown as DocumentNode;
export const LEGACY_OuraActivityRecordFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LEGACY_OuraActivityRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","alias":{"kind":"Name","value":"unit"},"name":{"kind":"Name","value":"preference_unit"}}]}}]}}]} as unknown as DocumentNode;
export const MetricRecordReferenceRangeFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricRecordReferenceRangeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference_range"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}},{"kind":"Field","name":{"kind":"Name","value":"range_type"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"targets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"optimal"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"discrete_targets"}},{"kind":"Field","name":{"kind":"Name","value":"health_effects_text"}}]}}]}}]}}]} as unknown as DocumentNode;
export const MetricDetailsResultsFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricDetailsResultsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"namespace_key"}},{"kind":"Field","name":{"kind":"Name","value":"lab_test_markers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_weekly_rollup_type"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipRollupValues"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"default_rollup_interval_type"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipRollupValues"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"latest_rollup_values"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latestRollupValuesArgs"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latestRollupLimit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"interval_start"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipRollupValues"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval_start"}},{"kind":"Field","name":{"kind":"Name","value":"interval_end"}},{"kind":"Field","name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataSources"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value_type"}},{"kind":"Field","name":{"kind":"Name","value":"lab_result_marker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_optimal"}},{"kind":"Field","name":{"kind":"Name","value":"converted_value"}},{"kind":"Field","name":{"kind":"Name","value":"test"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestValues"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latestValuesLimit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"beforeDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataSources"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipLatestValues"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"value_string"}},{"kind":"Field","name":{"kind":"Name","value":"value_type"}},{"kind":"Field","name":{"kind":"Name","value":"lab_result_marker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_optimal"}},{"kind":"Field","name":{"kind":"Name","value":"converted_value"}},{"kind":"Field","name":{"kind":"Name","value":"test"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const ReferenceRangeFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReferenceRangeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReferenceRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dataSource"}},{"kind":"Field","name":{"kind":"Name","value":"rangeType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"targets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"optimal"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"discreteTargets"}},{"kind":"Field","name":{"kind":"Name","value":"healthEffectsTitle"}}]}}]}}]} as unknown as DocumentNode;
export const MetricMatchedReferenceRangeTargetsV2FieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricMatchedReferenceRangeTargetsV2Fields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matched_reference_range_targets_v2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"include_other_criteria"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReferenceRangeFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReferenceRangeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReferenceRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dataSource"}},{"kind":"Field","name":{"kind":"Name","value":"rangeType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"targets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"optimal"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"discreteTargets"}},{"kind":"Field","name":{"kind":"Name","value":"healthEffectsTitle"}}]}}]}}]} as unknown as DocumentNode;
export const MetricReferenceRangeFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricReferenceRangeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricMatchedReferenceRangeTargetsV2Fields"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipMetricRecordRefRanges"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricRecordReferenceRangeFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReferenceRangeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReferenceRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dataSource"}},{"kind":"Field","name":{"kind":"Name","value":"rangeType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"targets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"optimal"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"discreteTargets"}},{"kind":"Field","name":{"kind":"Name","value":"healthEffectsTitle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricMatchedReferenceRangeTargetsV2Fields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matched_reference_range_targets_v2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"include_other_criteria"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReferenceRangeFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricRecordReferenceRangeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference_range"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}},{"kind":"Field","name":{"kind":"Name","value":"range_type"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"targets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"optimal"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"discrete_targets"}},{"kind":"Field","name":{"kind":"Name","value":"health_effects_text"}}]}}]}}]}}]} as unknown as DocumentNode;
export const LabResultMetricRecordGroupFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LabResultMetricRecordGroupFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricRecordReferenceRangeFields"}},{"kind":"Field","name":{"kind":"Name","value":"lab_result_markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"converted_value"}},{"kind":"Field","name":{"kind":"Name","value":"is_optimal"}},{"kind":"Field","name":{"kind":"Name","value":"test"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"watched_metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricDetailsResultsFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricReferenceRangeFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReferenceRangeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReferenceRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dataSource"}},{"kind":"Field","name":{"kind":"Name","value":"rangeType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"targets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"optimal"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"discreteTargets"}},{"kind":"Field","name":{"kind":"Name","value":"healthEffectsTitle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricMatchedReferenceRangeTargetsV2Fields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matched_reference_range_targets_v2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"include_other_criteria"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReferenceRangeFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricRecordReferenceRangeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference_range"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}},{"kind":"Field","name":{"kind":"Name","value":"range_type"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"targets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"optimal"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"discrete_targets"}},{"kind":"Field","name":{"kind":"Name","value":"health_effects_text"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricReferenceRangeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricMatchedReferenceRangeTargetsV2Fields"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipMetricRecordRefRanges"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricRecordReferenceRangeFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricDetailsResultsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"namespace_key"}},{"kind":"Field","name":{"kind":"Name","value":"lab_test_markers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_weekly_rollup_type"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipRollupValues"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"default_rollup_interval_type"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipRollupValues"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"latest_rollup_values"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latestRollupValuesArgs"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latestRollupLimit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"interval_start"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipRollupValues"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval_start"}},{"kind":"Field","name":{"kind":"Name","value":"interval_end"}},{"kind":"Field","name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataSources"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value_type"}},{"kind":"Field","name":{"kind":"Name","value":"lab_result_marker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_optimal"}},{"kind":"Field","name":{"kind":"Name","value":"converted_value"}},{"kind":"Field","name":{"kind":"Name","value":"test"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestValues"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latestValuesLimit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"beforeDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataSources"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipLatestValues"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"value_string"}},{"kind":"Field","name":{"kind":"Name","value":"value_type"}},{"kind":"Field","name":{"kind":"Name","value":"lab_result_marker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_optimal"}},{"kind":"Field","name":{"kind":"Name","value":"converted_value"}},{"kind":"Field","name":{"kind":"Name","value":"test"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const PhenoAgeFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhenoAgeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"beforeDate"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricRecordReferenceRangeFields"}},{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","name":{"kind":"Name","value":"metric_id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricRecordReferenceRangeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference_range"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}},{"kind":"Field","name":{"kind":"Name","value":"range_type"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"targets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"optimal"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"discrete_targets"}},{"kind":"Field","name":{"kind":"Name","value":"health_effects_text"}}]}}]}}]}}]} as unknown as DocumentNode;
export const GoalFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GoalFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"goal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const UserGoalEntityFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserGoalEntityFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserGoalEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"focus"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"goal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GoalFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GoalFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"goal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const LifestyleRecommendationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LifestyleRecommendation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LifestyleRecommendationItemModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_item_config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value_target"}},{"kind":"Field","name":{"kind":"Name","value":"interval_type"}},{"kind":"Field","name":{"kind":"Name","value":"weekly_instance_target"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value_rollup_type"}},{"kind":"Field","name":{"kind":"Name","value":"action_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name_show_placeholders"}},{"kind":"Field","name":{"kind":"Name","value":"logger_type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hero_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name_plural"}},{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}},{"kind":"Field","name":{"kind":"Name","value":"display_symbol_plural"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_item_inputs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"input_type"}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const SupplementRecommendationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SupplementRecommendation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SupplementRecommendationItemModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const CmsGuidanceItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmsGuidanceItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CmsContentCustomGuidanceItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cta_link"}},{"kind":"Field","name":{"kind":"Name","value":"cta_text"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"header_img"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const LabPackageGuidanceItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LabPackageGuidanceItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LabPackageCustomGuidanceItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productSlug"}},{"kind":"Field","name":{"kind":"Name","value":"lab_package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;
export const MeasureRecommendationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MeasureRecommendation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeasureRecommendationItemModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"meta"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmsGuidanceItem"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LabPackageGuidanceItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmsGuidanceItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CmsContentCustomGuidanceItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cta_link"}},{"kind":"Field","name":{"kind":"Name","value":"cta_text"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"header_img"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LabPackageGuidanceItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LabPackageCustomGuidanceItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productSlug"}},{"kind":"Field","name":{"kind":"Name","value":"lab_package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;
export const ProductDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StripeProductPriceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_free_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_paid_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}}]} as unknown as DocumentNode;
export const ImageFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileRelationResponseCollection_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;
export const CommercePageProductFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommercePageProductFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_StripeProductEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coming_soon"}},{"kind":"Field","name":{"kind":"Name","value":"out_of_stock"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const DualProductSectionFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DualProductSectionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_ComponentDualProductSectionWtfDouble_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"left_product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommercePageProductFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"right_product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommercePageProductFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommercePageProductFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_StripeProductEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coming_soon"}},{"kind":"Field","name":{"kind":"Name","value":"out_of_stock"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const SingleProductSectionFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SingleProductSectionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_ComponentSingleProductSectionWtf_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image_is_on_left"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommercePageProductFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommercePageProductFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_StripeProductEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coming_soon"}},{"kind":"Field","name":{"kind":"Name","value":"out_of_stock"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const MainSecondaryTextGroupFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MainSecondaryTextGroupFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_ComponentContentComponentTd_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"short_text"}},{"kind":"Field","name":{"kind":"Name","value":"long_text"}}]}}]} as unknown as DocumentNode;
export const AcceptConsentPolicyFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AcceptConsentPolicyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"mutation_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accept_consent_policy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"consent_policy_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"consentPolicyIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consentPolicyVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}}]}}]}}]} as unknown as DocumentNode;
export const ConsentPurchaseRequirementFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConsentPurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConsentPurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"consentPolicyId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"consent_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"policy_type"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"external_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode;
export const CustomPurchaseRequirementFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomPurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomPurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode;
export const ProductTypePurchaseRequirementFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTypePurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTypePurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode;
export const CartFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member_discount"}},{"kind":"Field","name":{"kind":"Name","value":"promotion_discount"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}}]}},{"kind":"Field","name":{"kind":"Name","value":"applied_promo_code"}},{"kind":"Field","name":{"kind":"Name","value":"appliedMembershipTier"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsentPurchaseRequirementFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomPurchaseRequirementFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTypePurchaseRequirementFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requires"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiresLineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiredBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiredByLineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMin"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMax"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_custom"}},{"kind":"Field","name":{"kind":"Name","value":"package_products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsentPurchaseRequirementFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomPurchaseRequirementFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StripeProductPriceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_free_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_paid_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConsentPurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConsentPurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"consentPolicyId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"consent_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"policy_type"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"external_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomPurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomPurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTypePurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTypePurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode;
export const ShopPageStripeProductFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShopPageStripeProductFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_StripeProductEntity_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"coming_soon"}},{"kind":"Field","name":{"kind":"Name","value":"out_of_stock"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StripeProductPriceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_free_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_paid_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}}]} as unknown as DocumentNode;
export const SectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Section"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_ComponentShopSectionShopSection_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CTA_Text"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"available_canada"},"value":{"kind":"Variable","name":{"kind":"Name","value":"availableCaFilter"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShopPageStripeProductFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StripeProductPriceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_free_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_paid_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShopPageStripeProductFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_StripeProductEntity_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"coming_soon"}},{"kind":"Field","name":{"kind":"Name","value":"out_of_stock"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const ProductMetadataBySlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductMetadataBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_catalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productTypeDefaultImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PACKAGE"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"SUPPLEMENT"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useProductMetadataBySlugQuery__
 *
 * To run a query within a React component, call `useProductMetadataBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductMetadataBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductMetadataBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useProductMetadataBySlugQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductMetadataBySlugQuery, ProductMetadataBySlugQueryVariables> & ({ variables: ProductMetadataBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductMetadataBySlugQuery, ProductMetadataBySlugQueryVariables>(ProductMetadataBySlugDocument, options);
      }
export function useProductMetadataBySlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductMetadataBySlugQuery, ProductMetadataBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductMetadataBySlugQuery, ProductMetadataBySlugQueryVariables>(ProductMetadataBySlugDocument, options);
        }
export function useProductMetadataBySlugSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductMetadataBySlugQuery, ProductMetadataBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductMetadataBySlugQuery, ProductMetadataBySlugQueryVariables>(ProductMetadataBySlugDocument, options);
        }
export type ProductMetadataBySlugQueryHookResult = ReturnType<typeof useProductMetadataBySlugQuery>;
export type ProductMetadataBySlugLazyQueryHookResult = ReturnType<typeof useProductMetadataBySlugLazyQuery>;
export type ProductMetadataBySlugSuspenseQueryHookResult = ReturnType<typeof useProductMetadataBySlugSuspenseQuery>;
export type ProductMetadataBySlugQueryResult = Apollo.QueryResult<ProductMetadataBySlugQuery, ProductMetadataBySlugQueryVariables>;
export const ProductIdAndTypeBySlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductIdAndTypeBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryAvailability"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"_text"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_catalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"country_availability"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryAvailability"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useProductIdAndTypeBySlugQuery__
 *
 * To run a query within a React component, call `useProductIdAndTypeBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductIdAndTypeBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductIdAndTypeBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      countryAvailability: // value for 'countryAvailability'
 *   },
 * });
 */
export function useProductIdAndTypeBySlugQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductIdAndTypeBySlugQuery, ProductIdAndTypeBySlugQueryVariables> & ({ variables: ProductIdAndTypeBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductIdAndTypeBySlugQuery, ProductIdAndTypeBySlugQueryVariables>(ProductIdAndTypeBySlugDocument, options);
      }
export function useProductIdAndTypeBySlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductIdAndTypeBySlugQuery, ProductIdAndTypeBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductIdAndTypeBySlugQuery, ProductIdAndTypeBySlugQueryVariables>(ProductIdAndTypeBySlugDocument, options);
        }
export function useProductIdAndTypeBySlugSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductIdAndTypeBySlugQuery, ProductIdAndTypeBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductIdAndTypeBySlugQuery, ProductIdAndTypeBySlugQueryVariables>(ProductIdAndTypeBySlugDocument, options);
        }
export type ProductIdAndTypeBySlugQueryHookResult = ReturnType<typeof useProductIdAndTypeBySlugQuery>;
export type ProductIdAndTypeBySlugLazyQueryHookResult = ReturnType<typeof useProductIdAndTypeBySlugLazyQuery>;
export type ProductIdAndTypeBySlugSuspenseQueryHookResult = ReturnType<typeof useProductIdAndTypeBySlugSuspenseQuery>;
export type ProductIdAndTypeBySlugQueryResult = Apollo.QueryResult<ProductIdAndTypeBySlugQuery, ProductIdAndTypeBySlugQueryVariables>;
export const TosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Tos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"terms_of_service"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useTosQuery__
 *
 * To run a query within a React component, call `useTosQuery` and pass it any options that fit your needs.
 * When your component renders, `useTosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTosQuery({
 *   variables: {
 *   },
 * });
 */
export function useTosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TosQuery, TosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TosQuery, TosQueryVariables>(TosDocument, options);
      }
export function useTosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TosQuery, TosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TosQuery, TosQueryVariables>(TosDocument, options);
        }
export function useTosSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TosQuery, TosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TosQuery, TosQueryVariables>(TosDocument, options);
        }
export type TosQueryHookResult = ReturnType<typeof useTosQuery>;
export type TosLazyQueryHookResult = ReturnType<typeof useTosLazyQuery>;
export type TosSuspenseQueryHookResult = ReturnType<typeof useTosSuspenseQuery>;
export type TosQueryResult = Apollo.QueryResult<TosQuery, TosQueryVariables>;
export const DeleteMetricRecordBatchByMetricIdsAndExternalIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMetricRecordBatchByMetricIdsAndExternalId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_metric_record"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"external_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode;
export type DeleteMetricRecordBatchByMetricIdsAndExternalIdMutationFn = Apollo.MutationFunction<DeleteMetricRecordBatchByMetricIdsAndExternalIdMutation, DeleteMetricRecordBatchByMetricIdsAndExternalIdMutationVariables>;

/**
 * __useDeleteMetricRecordBatchByMetricIdsAndExternalIdMutation__
 *
 * To run a mutation, you first call `useDeleteMetricRecordBatchByMetricIdsAndExternalIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMetricRecordBatchByMetricIdsAndExternalIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMetricRecordBatchByMetricIdsAndExternalIdMutation, { data, loading, error }] = useDeleteMetricRecordBatchByMetricIdsAndExternalIdMutation({
 *   variables: {
 *      metricIds: // value for 'metricIds'
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useDeleteMetricRecordBatchByMetricIdsAndExternalIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMetricRecordBatchByMetricIdsAndExternalIdMutation, DeleteMetricRecordBatchByMetricIdsAndExternalIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMetricRecordBatchByMetricIdsAndExternalIdMutation, DeleteMetricRecordBatchByMetricIdsAndExternalIdMutationVariables>(DeleteMetricRecordBatchByMetricIdsAndExternalIdDocument, options);
      }
export type DeleteMetricRecordBatchByMetricIdsAndExternalIdMutationHookResult = ReturnType<typeof useDeleteMetricRecordBatchByMetricIdsAndExternalIdMutation>;
export type DeleteMetricRecordBatchByMetricIdsAndExternalIdMutationResult = Apollo.MutationResult<DeleteMetricRecordBatchByMetricIdsAndExternalIdMutation>;
export type DeleteMetricRecordBatchByMetricIdsAndExternalIdMutationOptions = Apollo.BaseMutationOptions<DeleteMetricRecordBatchByMetricIdsAndExternalIdMutation, DeleteMetricRecordBatchByMetricIdsAndExternalIdMutationVariables>;
export const DeleteMetricRecordByMetricIdAndExternalIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMetricRecordByMetricIdAndExternalId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_metric_record"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"external_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}}]}}]}}]}}]} as unknown as DocumentNode;
export type DeleteMetricRecordByMetricIdAndExternalIdMutationFn = Apollo.MutationFunction<DeleteMetricRecordByMetricIdAndExternalIdMutation, DeleteMetricRecordByMetricIdAndExternalIdMutationVariables>;

/**
 * __useDeleteMetricRecordByMetricIdAndExternalIdMutation__
 *
 * To run a mutation, you first call `useDeleteMetricRecordByMetricIdAndExternalIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMetricRecordByMetricIdAndExternalIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMetricRecordByMetricIdAndExternalIdMutation, { data, loading, error }] = useDeleteMetricRecordByMetricIdAndExternalIdMutation({
 *   variables: {
 *      metricId: // value for 'metricId'
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useDeleteMetricRecordByMetricIdAndExternalIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMetricRecordByMetricIdAndExternalIdMutation, DeleteMetricRecordByMetricIdAndExternalIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMetricRecordByMetricIdAndExternalIdMutation, DeleteMetricRecordByMetricIdAndExternalIdMutationVariables>(DeleteMetricRecordByMetricIdAndExternalIdDocument, options);
      }
export type DeleteMetricRecordByMetricIdAndExternalIdMutationHookResult = ReturnType<typeof useDeleteMetricRecordByMetricIdAndExternalIdMutation>;
export type DeleteMetricRecordByMetricIdAndExternalIdMutationResult = Apollo.MutationResult<DeleteMetricRecordByMetricIdAndExternalIdMutation>;
export type DeleteMetricRecordByMetricIdAndExternalIdMutationOptions = Apollo.BaseMutationOptions<DeleteMetricRecordByMetricIdAndExternalIdMutation, DeleteMetricRecordByMetricIdAndExternalIdMutationVariables>;
export const UpsertMetricRecordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertMetricRecord"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MetricRecordCreateInputType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataSource"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"data_source"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsert_metric_record_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"data_source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataSource"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}}]}}]}}]} as unknown as DocumentNode;
export type UpsertMetricRecordMutationFn = Apollo.MutationFunction<UpsertMetricRecordMutation, UpsertMetricRecordMutationVariables>;

/**
 * __useUpsertMetricRecordMutation__
 *
 * To run a mutation, you first call `useUpsertMetricRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMetricRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMetricRecordMutation, { data, loading, error }] = useUpsertMetricRecordMutation({
 *   variables: {
 *      object: // value for 'object'
 *      dataSource: // value for 'dataSource'
 *   },
 * });
 */
export function useUpsertMetricRecordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertMetricRecordMutation, UpsertMetricRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertMetricRecordMutation, UpsertMetricRecordMutationVariables>(UpsertMetricRecordDocument, options);
      }
export type UpsertMetricRecordMutationHookResult = ReturnType<typeof useUpsertMetricRecordMutation>;
export type UpsertMetricRecordMutationResult = Apollo.MutationResult<UpsertMetricRecordMutation>;
export type UpsertMetricRecordMutationOptions = Apollo.BaseMutationOptions<UpsertMetricRecordMutation, UpsertMetricRecordMutationVariables>;
export const UpsertMetricRecordBatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertMetricRecordBatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MetricRecordCreateInputType"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataSource"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"data_source"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsert_metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"data_source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataSource"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}}]}}]}}]} as unknown as DocumentNode;
export type UpsertMetricRecordBatchMutationFn = Apollo.MutationFunction<UpsertMetricRecordBatchMutation, UpsertMetricRecordBatchMutationVariables>;

/**
 * __useUpsertMetricRecordBatchMutation__
 *
 * To run a mutation, you first call `useUpsertMetricRecordBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMetricRecordBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMetricRecordBatchMutation, { data, loading, error }] = useUpsertMetricRecordBatchMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *      dataSource: // value for 'dataSource'
 *   },
 * });
 */
export function useUpsertMetricRecordBatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertMetricRecordBatchMutation, UpsertMetricRecordBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertMetricRecordBatchMutation, UpsertMetricRecordBatchMutationVariables>(UpsertMetricRecordBatchDocument, options);
      }
export type UpsertMetricRecordBatchMutationHookResult = ReturnType<typeof useUpsertMetricRecordBatchMutation>;
export type UpsertMetricRecordBatchMutationResult = Apollo.MutationResult<UpsertMetricRecordBatchMutation>;
export type UpsertMetricRecordBatchMutationOptions = Apollo.BaseMutationOptions<UpsertMetricRecordBatchMutation, UpsertMetricRecordBatchMutationVariables>;
export const DeleteAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_account"}}]}}]} as unknown as DocumentNode;
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const MetricWatchStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MetricWatchStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"watched_metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_id"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMetricWatchStatusQuery__
 *
 * To run a query within a React component, call `useMetricWatchStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricWatchStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricWatchStatusQuery({
 *   variables: {
 *      metricId: // value for 'metricId'
 *   },
 * });
 */
export function useMetricWatchStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MetricWatchStatusQuery, MetricWatchStatusQueryVariables> & ({ variables: MetricWatchStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MetricWatchStatusQuery, MetricWatchStatusQueryVariables>(MetricWatchStatusDocument, options);
      }
export function useMetricWatchStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetricWatchStatusQuery, MetricWatchStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MetricWatchStatusQuery, MetricWatchStatusQueryVariables>(MetricWatchStatusDocument, options);
        }
export function useMetricWatchStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MetricWatchStatusQuery, MetricWatchStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MetricWatchStatusQuery, MetricWatchStatusQueryVariables>(MetricWatchStatusDocument, options);
        }
export type MetricWatchStatusQueryHookResult = ReturnType<typeof useMetricWatchStatusQuery>;
export type MetricWatchStatusLazyQueryHookResult = ReturnType<typeof useMetricWatchStatusLazyQuery>;
export type MetricWatchStatusSuspenseQueryHookResult = ReturnType<typeof useMetricWatchStatusSuspenseQuery>;
export type MetricWatchStatusQueryResult = Apollo.QueryResult<MetricWatchStatusQuery, MetricWatchStatusQueryVariables>;
export const AddWatchedMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddWatchedMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_watched_user_metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"watched_user_metric_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"sort_order"}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_id"}}]}}]}}]}}]} as unknown as DocumentNode;
export type AddWatchedMetricMutationFn = Apollo.MutationFunction<AddWatchedMetricMutation, AddWatchedMetricMutationVariables>;

/**
 * __useAddWatchedMetricMutation__
 *
 * To run a mutation, you first call `useAddWatchedMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWatchedMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWatchedMetricMutation, { data, loading, error }] = useAddWatchedMetricMutation({
 *   variables: {
 *      metricId: // value for 'metricId'
 *   },
 * });
 */
export function useAddWatchedMetricMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddWatchedMetricMutation, AddWatchedMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddWatchedMetricMutation, AddWatchedMetricMutationVariables>(AddWatchedMetricDocument, options);
      }
export type AddWatchedMetricMutationHookResult = ReturnType<typeof useAddWatchedMetricMutation>;
export type AddWatchedMetricMutationResult = Apollo.MutationResult<AddWatchedMetricMutation>;
export type AddWatchedMetricMutationOptions = Apollo.BaseMutationOptions<AddWatchedMetricMutation, AddWatchedMetricMutationVariables>;
export const DeleteWatchedMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteWatchedMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_watched_user_metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode;
export type DeleteWatchedMetricMutationFn = Apollo.MutationFunction<DeleteWatchedMetricMutation, DeleteWatchedMetricMutationVariables>;

/**
 * __useDeleteWatchedMetricMutation__
 *
 * To run a mutation, you first call `useDeleteWatchedMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWatchedMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWatchedMetricMutation, { data, loading, error }] = useDeleteWatchedMetricMutation({
 *   variables: {
 *      metricId: // value for 'metricId'
 *   },
 * });
 */
export function useDeleteWatchedMetricMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteWatchedMetricMutation, DeleteWatchedMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteWatchedMetricMutation, DeleteWatchedMetricMutationVariables>(DeleteWatchedMetricDocument, options);
      }
export type DeleteWatchedMetricMutationHookResult = ReturnType<typeof useDeleteWatchedMetricMutation>;
export type DeleteWatchedMetricMutationResult = Apollo.MutationResult<DeleteWatchedMetricMutation>;
export type DeleteWatchedMetricMutationOptions = Apollo.BaseMutationOptions<DeleteWatchedMetricMutation, DeleteWatchedMetricMutationVariables>;
export const CorePackageProductIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CorePackageProductId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryAvailability"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"_text"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_catalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"Core","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"country_availability"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryAvailability"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCorePackageProductIdQuery__
 *
 * To run a query within a React component, call `useCorePackageProductIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorePackageProductIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorePackageProductIdQuery({
 *   variables: {
 *      countryAvailability: // value for 'countryAvailability'
 *   },
 * });
 */
export function useCorePackageProductIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CorePackageProductIdQuery, CorePackageProductIdQueryVariables> & ({ variables: CorePackageProductIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CorePackageProductIdQuery, CorePackageProductIdQueryVariables>(CorePackageProductIdDocument, options);
      }
export function useCorePackageProductIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CorePackageProductIdQuery, CorePackageProductIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CorePackageProductIdQuery, CorePackageProductIdQueryVariables>(CorePackageProductIdDocument, options);
        }
export function useCorePackageProductIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CorePackageProductIdQuery, CorePackageProductIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CorePackageProductIdQuery, CorePackageProductIdQueryVariables>(CorePackageProductIdDocument, options);
        }
export type CorePackageProductIdQueryHookResult = ReturnType<typeof useCorePackageProductIdQuery>;
export type CorePackageProductIdLazyQueryHookResult = ReturnType<typeof useCorePackageProductIdLazyQuery>;
export type CorePackageProductIdSuspenseQueryHookResult = ReturnType<typeof useCorePackageProductIdSuspenseQuery>;
export type CorePackageProductIdQueryResult = Apollo.QueryResult<CorePackageProductIdQuery, CorePackageProductIdQueryVariables>;
export const TrackQualitativeMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TrackQualitativeMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_tracked_metric_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tracked_metric_group"},"value":{"kind":"EnumValue","value":"qualitative"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"tracked_metric_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"metric_id"}}]}}]}}]} as unknown as DocumentNode;
export type TrackQualitativeMetricMutationFn = Apollo.MutationFunction<TrackQualitativeMetricMutation, TrackQualitativeMetricMutationVariables>;

/**
 * __useTrackQualitativeMetricMutation__
 *
 * To run a mutation, you first call `useTrackQualitativeMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackQualitativeMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackQualitativeMetricMutation, { data, loading, error }] = useTrackQualitativeMetricMutation({
 *   variables: {
 *      metricId: // value for 'metricId'
 *   },
 * });
 */
export function useTrackQualitativeMetricMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TrackQualitativeMetricMutation, TrackQualitativeMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TrackQualitativeMetricMutation, TrackQualitativeMetricMutationVariables>(TrackQualitativeMetricDocument, options);
      }
export type TrackQualitativeMetricMutationHookResult = ReturnType<typeof useTrackQualitativeMetricMutation>;
export type TrackQualitativeMetricMutationResult = Apollo.MutationResult<TrackQualitativeMetricMutation>;
export type TrackQualitativeMetricMutationOptions = Apollo.BaseMutationOptions<TrackQualitativeMetricMutation, TrackQualitativeMetricMutationVariables>;
export const StopTrackingQualitativeMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StopTrackingQualitativeMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_tracked_metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tracked_metric_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"qualitative"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode;
export type StopTrackingQualitativeMetricMutationFn = Apollo.MutationFunction<StopTrackingQualitativeMetricMutation, StopTrackingQualitativeMetricMutationVariables>;

/**
 * __useStopTrackingQualitativeMetricMutation__
 *
 * To run a mutation, you first call `useStopTrackingQualitativeMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopTrackingQualitativeMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopTrackingQualitativeMetricMutation, { data, loading, error }] = useStopTrackingQualitativeMetricMutation({
 *   variables: {
 *      metricId: // value for 'metricId'
 *   },
 * });
 */
export function useStopTrackingQualitativeMetricMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StopTrackingQualitativeMetricMutation, StopTrackingQualitativeMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StopTrackingQualitativeMetricMutation, StopTrackingQualitativeMetricMutationVariables>(StopTrackingQualitativeMetricDocument, options);
      }
export type StopTrackingQualitativeMetricMutationHookResult = ReturnType<typeof useStopTrackingQualitativeMetricMutation>;
export type StopTrackingQualitativeMetricMutationResult = Apollo.MutationResult<StopTrackingQualitativeMetricMutation>;
export type StopTrackingQualitativeMetricMutationOptions = Apollo.BaseMutationOptions<StopTrackingQualitativeMetricMutation, StopTrackingQualitativeMetricMutationVariables>;
export const FranchiseLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FranchiseLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"franchise"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useFranchiseLocationsQuery__
 *
 * To run a query within a React component, call `useFranchiseLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFranchiseLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFranchiseLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFranchiseLocationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FranchiseLocationsQuery, FranchiseLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FranchiseLocationsQuery, FranchiseLocationsQueryVariables>(FranchiseLocationsDocument, options);
      }
export function useFranchiseLocationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FranchiseLocationsQuery, FranchiseLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FranchiseLocationsQuery, FranchiseLocationsQueryVariables>(FranchiseLocationsDocument, options);
        }
export function useFranchiseLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FranchiseLocationsQuery, FranchiseLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FranchiseLocationsQuery, FranchiseLocationsQueryVariables>(FranchiseLocationsDocument, options);
        }
export type FranchiseLocationsQueryHookResult = ReturnType<typeof useFranchiseLocationsQuery>;
export type FranchiseLocationsLazyQueryHookResult = ReturnType<typeof useFranchiseLocationsLazyQuery>;
export type FranchiseLocationsSuspenseQueryHookResult = ReturnType<typeof useFranchiseLocationsSuspenseQuery>;
export type FranchiseLocationsQueryResult = Apollo.QueryResult<FranchiseLocationsQuery, FranchiseLocationsQueryVariables>;
export const SetFranchiseLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetFranchiseLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FranchiseCountryEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"set_franchise_location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}]}]}}]} as unknown as DocumentNode;
export type SetFranchiseLocationMutationFn = Apollo.MutationFunction<SetFranchiseLocationMutation, SetFranchiseLocationMutationVariables>;

/**
 * __useSetFranchiseLocationMutation__
 *
 * To run a mutation, you first call `useSetFranchiseLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFranchiseLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFranchiseLocationMutation, { data, loading, error }] = useSetFranchiseLocationMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useSetFranchiseLocationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetFranchiseLocationMutation, SetFranchiseLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetFranchiseLocationMutation, SetFranchiseLocationMutationVariables>(SetFranchiseLocationDocument, options);
      }
export type SetFranchiseLocationMutationHookResult = ReturnType<typeof useSetFranchiseLocationMutation>;
export type SetFranchiseLocationMutationResult = Apollo.MutationResult<SetFranchiseLocationMutation>;
export type SetFranchiseLocationMutationOptions = Apollo.BaseMutationOptions<SetFranchiseLocationMutation, SetFranchiseLocationMutationVariables>;
export const GetFranchiseServicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFranchiseServices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FranchiseCountryEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"franchise"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"services"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"price_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sale_price"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetFranchiseServicesQuery__
 *
 * To run a query within a React component, call `useGetFranchiseServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFranchiseServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFranchiseServicesQuery({
 *   variables: {
 *      location_id: // value for 'location_id'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetFranchiseServicesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFranchiseServicesQuery, GetFranchiseServicesQueryVariables> & ({ variables: GetFranchiseServicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFranchiseServicesQuery, GetFranchiseServicesQueryVariables>(GetFranchiseServicesDocument, options);
      }
export function useGetFranchiseServicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFranchiseServicesQuery, GetFranchiseServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFranchiseServicesQuery, GetFranchiseServicesQueryVariables>(GetFranchiseServicesDocument, options);
        }
export function useGetFranchiseServicesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetFranchiseServicesQuery, GetFranchiseServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFranchiseServicesQuery, GetFranchiseServicesQueryVariables>(GetFranchiseServicesDocument, options);
        }
export type GetFranchiseServicesQueryHookResult = ReturnType<typeof useGetFranchiseServicesQuery>;
export type GetFranchiseServicesLazyQueryHookResult = ReturnType<typeof useGetFranchiseServicesLazyQuery>;
export type GetFranchiseServicesSuspenseQueryHookResult = ReturnType<typeof useGetFranchiseServicesSuspenseQuery>;
export type GetFranchiseServicesQueryResult = Apollo.QueryResult<GetFranchiseServicesQuery, GetFranchiseServicesQueryVariables>;
export const CreateBookingDateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBookingDate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_franchise_booking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"serviceIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"centerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type CreateBookingDateMutationFn = Apollo.MutationFunction<CreateBookingDateMutation, CreateBookingDateMutationVariables>;

/**
 * __useCreateBookingDateMutation__
 *
 * To run a mutation, you first call `useCreateBookingDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingDateMutation, { data, loading, error }] = useCreateBookingDateMutation({
 *   variables: {
 *      date: // value for 'date'
 *      serviceIds: // value for 'serviceIds'
 *      location_id: // value for 'location_id'
 *   },
 * });
 */
export function useCreateBookingDateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBookingDateMutation, CreateBookingDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBookingDateMutation, CreateBookingDateMutationVariables>(CreateBookingDateDocument, options);
      }
export type CreateBookingDateMutationHookResult = ReturnType<typeof useCreateBookingDateMutation>;
export type CreateBookingDateMutationResult = Apollo.MutationResult<CreateBookingDateMutation>;
export type CreateBookingDateMutationOptions = Apollo.BaseMutationOptions<CreateBookingDateMutation, CreateBookingDateMutationVariables>;
export const RescheduleBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RescheduleBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"reschedule"},"name":{"kind":"Name","value":"reschedule_franchise_booking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"centerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"invoiceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"invoiceItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceItemId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"serviceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type RescheduleBookingMutationFn = Apollo.MutationFunction<RescheduleBookingMutation, RescheduleBookingMutationVariables>;

/**
 * __useRescheduleBookingMutation__
 *
 * To run a mutation, you first call `useRescheduleBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleBookingMutation, { data, loading, error }] = useRescheduleBookingMutation({
 *   variables: {
 *      date: // value for 'date'
 *      location_id: // value for 'location_id'
 *      invoiceId: // value for 'invoiceId'
 *      invoiceItemId: // value for 'invoiceItemId'
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useRescheduleBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RescheduleBookingMutation, RescheduleBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RescheduleBookingMutation, RescheduleBookingMutationVariables>(RescheduleBookingDocument, options);
      }
export type RescheduleBookingMutationHookResult = ReturnType<typeof useRescheduleBookingMutation>;
export type RescheduleBookingMutationResult = Apollo.MutationResult<RescheduleBookingMutation>;
export type RescheduleBookingMutationOptions = Apollo.BaseMutationOptions<RescheduleBookingMutation, RescheduleBookingMutationVariables>;
export const GetBookingSlotsForBookedDateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBookingSlotsForBookedDate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FranchiseCountryEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"franchise"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_booking_slots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bookingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Available"}},{"kind":"Field","name":{"kind":"Name","value":"Priority"}},{"kind":"Field","name":{"kind":"Name","value":"SalePrice"}},{"kind":"Field","name":{"kind":"Name","value":"Time"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetBookingSlotsForBookedDateQuery__
 *
 * To run a query within a React component, call `useGetBookingSlotsForBookedDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingSlotsForBookedDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingSlotsForBookedDateQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetBookingSlotsForBookedDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBookingSlotsForBookedDateQuery, GetBookingSlotsForBookedDateQueryVariables> & ({ variables: GetBookingSlotsForBookedDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBookingSlotsForBookedDateQuery, GetBookingSlotsForBookedDateQueryVariables>(GetBookingSlotsForBookedDateDocument, options);
      }
export function useGetBookingSlotsForBookedDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookingSlotsForBookedDateQuery, GetBookingSlotsForBookedDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBookingSlotsForBookedDateQuery, GetBookingSlotsForBookedDateQueryVariables>(GetBookingSlotsForBookedDateDocument, options);
        }
export function useGetBookingSlotsForBookedDateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetBookingSlotsForBookedDateQuery, GetBookingSlotsForBookedDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBookingSlotsForBookedDateQuery, GetBookingSlotsForBookedDateQueryVariables>(GetBookingSlotsForBookedDateDocument, options);
        }
export type GetBookingSlotsForBookedDateQueryHookResult = ReturnType<typeof useGetBookingSlotsForBookedDateQuery>;
export type GetBookingSlotsForBookedDateLazyQueryHookResult = ReturnType<typeof useGetBookingSlotsForBookedDateLazyQuery>;
export type GetBookingSlotsForBookedDateSuspenseQueryHookResult = ReturnType<typeof useGetBookingSlotsForBookedDateSuspenseQuery>;
export type GetBookingSlotsForBookedDateQueryResult = Apollo.QueryResult<GetBookingSlotsForBookedDateQuery, GetBookingSlotsForBookedDateQueryVariables>;
export const ReserveBookingSlotForBookedDateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReserveBookingSlotForBookedDate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"time"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FranchiseCountryEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reserve_franchise_appointment_slot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bookingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}}},{"kind":"Argument","name":{"kind":"Name","value":"time"},"value":{"kind":"Variable","name":{"kind":"Name","value":"time"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reservation_id"}},{"kind":"Field","name":{"kind":"Name","value":"expiry_time"}}]}}]}}]} as unknown as DocumentNode;
export type ReserveBookingSlotForBookedDateMutationFn = Apollo.MutationFunction<ReserveBookingSlotForBookedDateMutation, ReserveBookingSlotForBookedDateMutationVariables>;

/**
 * __useReserveBookingSlotForBookedDateMutation__
 *
 * To run a mutation, you first call `useReserveBookingSlotForBookedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReserveBookingSlotForBookedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reserveBookingSlotForBookedDateMutation, { data, loading, error }] = useReserveBookingSlotForBookedDateMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      time: // value for 'time'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useReserveBookingSlotForBookedDateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReserveBookingSlotForBookedDateMutation, ReserveBookingSlotForBookedDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReserveBookingSlotForBookedDateMutation, ReserveBookingSlotForBookedDateMutationVariables>(ReserveBookingSlotForBookedDateDocument, options);
      }
export type ReserveBookingSlotForBookedDateMutationHookResult = ReturnType<typeof useReserveBookingSlotForBookedDateMutation>;
export type ReserveBookingSlotForBookedDateMutationResult = Apollo.MutationResult<ReserveBookingSlotForBookedDateMutation>;
export type ReserveBookingSlotForBookedDateMutationOptions = Apollo.BaseMutationOptions<ReserveBookingSlotForBookedDateMutation, ReserveBookingSlotForBookedDateMutationVariables>;
export const ConfirmBookingSlotForBookedDateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmBookingSlotForBookedDate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FranchiseCountryEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirm_franchise_appointment_booking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bookingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_confirmed"}}]}}]}}]} as unknown as DocumentNode;
export type ConfirmBookingSlotForBookedDateMutationFn = Apollo.MutationFunction<ConfirmBookingSlotForBookedDateMutation, ConfirmBookingSlotForBookedDateMutationVariables>;

/**
 * __useConfirmBookingSlotForBookedDateMutation__
 *
 * To run a mutation, you first call `useConfirmBookingSlotForBookedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmBookingSlotForBookedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmBookingSlotForBookedDateMutation, { data, loading, error }] = useConfirmBookingSlotForBookedDateMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useConfirmBookingSlotForBookedDateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfirmBookingSlotForBookedDateMutation, ConfirmBookingSlotForBookedDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfirmBookingSlotForBookedDateMutation, ConfirmBookingSlotForBookedDateMutationVariables>(ConfirmBookingSlotForBookedDateDocument, options);
      }
export type ConfirmBookingSlotForBookedDateMutationHookResult = ReturnType<typeof useConfirmBookingSlotForBookedDateMutation>;
export type ConfirmBookingSlotForBookedDateMutationResult = Apollo.MutationResult<ConfirmBookingSlotForBookedDateMutation>;
export type ConfirmBookingSlotForBookedDateMutationOptions = Apollo.BaseMutationOptions<ConfirmBookingSlotForBookedDateMutation, ConfirmBookingSlotForBookedDateMutationVariables>;
export const CancelBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comments"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FranchiseCountryEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancel_franchise_appointment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"invoiceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"comments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comments"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode;
export type CancelBookingMutationFn = Apollo.MutationFunction<CancelBookingMutation, CancelBookingMutationVariables>;

/**
 * __useCancelBookingMutation__
 *
 * To run a mutation, you first call `useCancelBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelBookingMutation, { data, loading, error }] = useCancelBookingMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      comments: // value for 'comments'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useCancelBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelBookingMutation, CancelBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelBookingMutation, CancelBookingMutationVariables>(CancelBookingDocument, options);
      }
export type CancelBookingMutationHookResult = ReturnType<typeof useCancelBookingMutation>;
export type CancelBookingMutationResult = Apollo.MutationResult<CancelBookingMutation>;
export type CancelBookingMutationOptions = Apollo.BaseMutationOptions<CancelBookingMutation, CancelBookingMutationVariables>;
export const GetFranchiseMembershipsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFranchiseMemberships"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FranchiseCountryEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"franchise"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_center_memberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"duration_in_months"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"final"}},{"kind":"Field","name":{"kind":"Name","value":"sales"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setup_fee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetFranchiseMembershipsQuery__
 *
 * To run a query within a React component, call `useGetFranchiseMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFranchiseMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFranchiseMembershipsQuery({
 *   variables: {
 *      location_id: // value for 'location_id'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetFranchiseMembershipsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFranchiseMembershipsQuery, GetFranchiseMembershipsQueryVariables> & ({ variables: GetFranchiseMembershipsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFranchiseMembershipsQuery, GetFranchiseMembershipsQueryVariables>(GetFranchiseMembershipsDocument, options);
      }
export function useGetFranchiseMembershipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFranchiseMembershipsQuery, GetFranchiseMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFranchiseMembershipsQuery, GetFranchiseMembershipsQueryVariables>(GetFranchiseMembershipsDocument, options);
        }
export function useGetFranchiseMembershipsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetFranchiseMembershipsQuery, GetFranchiseMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFranchiseMembershipsQuery, GetFranchiseMembershipsQueryVariables>(GetFranchiseMembershipsDocument, options);
        }
export type GetFranchiseMembershipsQueryHookResult = ReturnType<typeof useGetFranchiseMembershipsQuery>;
export type GetFranchiseMembershipsLazyQueryHookResult = ReturnType<typeof useGetFranchiseMembershipsLazyQuery>;
export type GetFranchiseMembershipsSuspenseQueryHookResult = ReturnType<typeof useGetFranchiseMembershipsSuspenseQuery>;
export type GetFranchiseMembershipsQueryResult = Apollo.QueryResult<GetFranchiseMembershipsQuery, GetFranchiseMembershipsQueryVariables>;
export const CreateMembershipInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMembershipInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"membershipIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FranchiseCountryEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_membership_invoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"membershipIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"membershipIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}]}]}}]} as unknown as DocumentNode;
export type CreateMembershipInvoiceMutationFn = Apollo.MutationFunction<CreateMembershipInvoiceMutation, CreateMembershipInvoiceMutationVariables>;

/**
 * __useCreateMembershipInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateMembershipInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMembershipInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMembershipInvoiceMutation, { data, loading, error }] = useCreateMembershipInvoiceMutation({
 *   variables: {
 *      location_id: // value for 'location_id'
 *      membershipIds: // value for 'membershipIds'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useCreateMembershipInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMembershipInvoiceMutation, CreateMembershipInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateMembershipInvoiceMutation, CreateMembershipInvoiceMutationVariables>(CreateMembershipInvoiceDocument, options);
      }
export type CreateMembershipInvoiceMutationHookResult = ReturnType<typeof useCreateMembershipInvoiceMutation>;
export type CreateMembershipInvoiceMutationResult = Apollo.MutationResult<CreateMembershipInvoiceMutation>;
export type CreateMembershipInvoiceMutationOptions = Apollo.BaseMutationOptions<CreateMembershipInvoiceMutation, CreateMembershipInvoiceMutationVariables>;
export const CreatePackageInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePackageInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"packageIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FranchiseCountryEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_package_invoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"packageIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"packageIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}]}]}}]} as unknown as DocumentNode;
export type CreatePackageInvoiceMutationFn = Apollo.MutationFunction<CreatePackageInvoiceMutation, CreatePackageInvoiceMutationVariables>;

/**
 * __useCreatePackageInvoiceMutation__
 *
 * To run a mutation, you first call `useCreatePackageInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePackageInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPackageInvoiceMutation, { data, loading, error }] = useCreatePackageInvoiceMutation({
 *   variables: {
 *      location_id: // value for 'location_id'
 *      packageIds: // value for 'packageIds'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useCreatePackageInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePackageInvoiceMutation, CreatePackageInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePackageInvoiceMutation, CreatePackageInvoiceMutationVariables>(CreatePackageInvoiceDocument, options);
      }
export type CreatePackageInvoiceMutationHookResult = ReturnType<typeof useCreatePackageInvoiceMutation>;
export type CreatePackageInvoiceMutationResult = Apollo.MutationResult<CreatePackageInvoiceMutation>;
export type CreatePackageInvoiceMutationOptions = Apollo.BaseMutationOptions<CreatePackageInvoiceMutation, CreatePackageInvoiceMutationVariables>;
export const GetFranchisePackagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFranchisePackages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FranchiseCountryEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"franchise"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"center_packages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"sales"}},{"kind":"Field","name":{"kind":"Name","value":"final"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetFranchisePackagesQuery__
 *
 * To run a query within a React component, call `useGetFranchisePackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFranchisePackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFranchisePackagesQuery({
 *   variables: {
 *      location_id: // value for 'location_id'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetFranchisePackagesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFranchisePackagesQuery, GetFranchisePackagesQueryVariables> & ({ variables: GetFranchisePackagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFranchisePackagesQuery, GetFranchisePackagesQueryVariables>(GetFranchisePackagesDocument, options);
      }
export function useGetFranchisePackagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFranchisePackagesQuery, GetFranchisePackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFranchisePackagesQuery, GetFranchisePackagesQueryVariables>(GetFranchisePackagesDocument, options);
        }
export function useGetFranchisePackagesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetFranchisePackagesQuery, GetFranchisePackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFranchisePackagesQuery, GetFranchisePackagesQueryVariables>(GetFranchisePackagesDocument, options);
        }
export type GetFranchisePackagesQueryHookResult = ReturnType<typeof useGetFranchisePackagesQuery>;
export type GetFranchisePackagesLazyQueryHookResult = ReturnType<typeof useGetFranchisePackagesLazyQuery>;
export type GetFranchisePackagesSuspenseQueryHookResult = ReturnType<typeof useGetFranchisePackagesSuspenseQuery>;
export type GetFranchisePackagesQueryResult = Apollo.QueryResult<GetFranchisePackagesQuery, GetFranchisePackagesQueryVariables>;
export const PayInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PayInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FranchiseCountryEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pay_franchise_invoice_with_stored_card"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"center_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"invoice_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"redirect_uri"},"value":{"kind":"StringValue","value":"","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"account_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentAccountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}]}]}}]} as unknown as DocumentNode;
export type PayInvoiceMutationFn = Apollo.MutationFunction<PayInvoiceMutation, PayInvoiceMutationVariables>;

/**
 * __usePayInvoiceMutation__
 *
 * To run a mutation, you first call `usePayInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payInvoiceMutation, { data, loading, error }] = usePayInvoiceMutation({
 *   variables: {
 *      location_id: // value for 'location_id'
 *      invoiceId: // value for 'invoiceId'
 *      paymentAccountId: // value for 'paymentAccountId'
 *      country: // value for 'country'
 *   },
 * });
 */
export function usePayInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PayInvoiceMutation, PayInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PayInvoiceMutation, PayInvoiceMutationVariables>(PayInvoiceDocument, options);
      }
export type PayInvoiceMutationHookResult = ReturnType<typeof usePayInvoiceMutation>;
export type PayInvoiceMutationResult = Apollo.MutationResult<PayInvoiceMutation>;
export type PayInvoiceMutationOptions = Apollo.BaseMutationOptions<PayInvoiceMutation, PayInvoiceMutationVariables>;
export const GetUserCreditsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserCredits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FranchiseCountryEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"franchise"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credits_balance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"centerId"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetUserCreditsQuery__
 *
 * To run a query within a React component, call `useGetUserCreditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCreditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCreditsQuery({
 *   variables: {
 *      location_id: // value for 'location_id'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetUserCreditsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserCreditsQuery, GetUserCreditsQueryVariables> & ({ variables: GetUserCreditsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserCreditsQuery, GetUserCreditsQueryVariables>(GetUserCreditsDocument, options);
      }
export function useGetUserCreditsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserCreditsQuery, GetUserCreditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserCreditsQuery, GetUserCreditsQueryVariables>(GetUserCreditsDocument, options);
        }
export function useGetUserCreditsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserCreditsQuery, GetUserCreditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserCreditsQuery, GetUserCreditsQueryVariables>(GetUserCreditsDocument, options);
        }
export type GetUserCreditsQueryHookResult = ReturnType<typeof useGetUserCreditsQuery>;
export type GetUserCreditsLazyQueryHookResult = ReturnType<typeof useGetUserCreditsLazyQuery>;
export type GetUserCreditsSuspenseQueryHookResult = ReturnType<typeof useGetUserCreditsSuspenseQuery>;
export type GetUserCreditsQueryResult = Apollo.QueryResult<GetUserCreditsQuery, GetUserCreditsQueryVariables>;
export const FranchiseProfileModalDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FranchiseProfileModalData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FranchiseCountryEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"date_of_birth"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}}]}},{"kind":"Field","name":{"kind":"Name","value":"franchise_user_profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"zenoti_location_id"}},{"kind":"Field","name":{"kind":"Name","value":"zenoti_country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"franchise"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"communication_preferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receive_marketing_sms"}},{"kind":"Field","name":{"kind":"Name","value":"receive_marketing_email"}},{"kind":"Field","name":{"kind":"Name","value":"receive_transactional_sms"}},{"kind":"Field","name":{"kind":"Name","value":"receive_transactional_email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lab_profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ship_to_address"}},{"kind":"Field","name":{"kind":"Name","value":"ship_to_city"}},{"kind":"Field","name":{"kind":"Name","value":"ship_to_country"}},{"kind":"Field","name":{"kind":"Name","value":"ship_to_postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"ship_to_state"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useFranchiseProfileModalDataQuery__
 *
 * To run a query within a React component, call `useFranchiseProfileModalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFranchiseProfileModalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFranchiseProfileModalDataQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useFranchiseProfileModalDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FranchiseProfileModalDataQuery, FranchiseProfileModalDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FranchiseProfileModalDataQuery, FranchiseProfileModalDataQueryVariables>(FranchiseProfileModalDataDocument, options);
      }
export function useFranchiseProfileModalDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FranchiseProfileModalDataQuery, FranchiseProfileModalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FranchiseProfileModalDataQuery, FranchiseProfileModalDataQueryVariables>(FranchiseProfileModalDataDocument, options);
        }
export function useFranchiseProfileModalDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FranchiseProfileModalDataQuery, FranchiseProfileModalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FranchiseProfileModalDataQuery, FranchiseProfileModalDataQueryVariables>(FranchiseProfileModalDataDocument, options);
        }
export type FranchiseProfileModalDataQueryHookResult = ReturnType<typeof useFranchiseProfileModalDataQuery>;
export type FranchiseProfileModalDataLazyQueryHookResult = ReturnType<typeof useFranchiseProfileModalDataLazyQuery>;
export type FranchiseProfileModalDataSuspenseQueryHookResult = ReturnType<typeof useFranchiseProfileModalDataSuspenseQuery>;
export type FranchiseProfileModalDataQueryResult = Apollo.QueryResult<FranchiseProfileModalDataQuery, FranchiseProfileModalDataQueryVariables>;
export const GetFranchisePaymentMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFranchisePaymentMethods"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FranchiseCountryEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"franchise"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saved_payment_methods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"account_id"}},{"kind":"Field","name":{"kind":"Name","value":"card_logo"}},{"kind":"Field","name":{"kind":"Name","value":"last_four"}},{"kind":"Field","name":{"kind":"Name","value":"expiry_on"}},{"kind":"Field","name":{"kind":"Name","value":"payment_account_id"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetFranchisePaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetFranchisePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFranchisePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFranchisePaymentMethodsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetFranchisePaymentMethodsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFranchisePaymentMethodsQuery, GetFranchisePaymentMethodsQueryVariables> & ({ variables: GetFranchisePaymentMethodsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFranchisePaymentMethodsQuery, GetFranchisePaymentMethodsQueryVariables>(GetFranchisePaymentMethodsDocument, options);
      }
export function useGetFranchisePaymentMethodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFranchisePaymentMethodsQuery, GetFranchisePaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFranchisePaymentMethodsQuery, GetFranchisePaymentMethodsQueryVariables>(GetFranchisePaymentMethodsDocument, options);
        }
export function useGetFranchisePaymentMethodsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetFranchisePaymentMethodsQuery, GetFranchisePaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFranchisePaymentMethodsQuery, GetFranchisePaymentMethodsQueryVariables>(GetFranchisePaymentMethodsDocument, options);
        }
export type GetFranchisePaymentMethodsQueryHookResult = ReturnType<typeof useGetFranchisePaymentMethodsQuery>;
export type GetFranchisePaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetFranchisePaymentMethodsLazyQuery>;
export type GetFranchisePaymentMethodsSuspenseQueryHookResult = ReturnType<typeof useGetFranchisePaymentMethodsSuspenseQuery>;
export type GetFranchisePaymentMethodsQueryResult = Apollo.QueryResult<GetFranchisePaymentMethodsQuery, GetFranchisePaymentMethodsQueryVariables>;
export const AddPaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"redirectUri"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FranchiseCountryEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"franchise_add_stored_card"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"centerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"redirectUri"},"value":{"kind":"Variable","name":{"kind":"Name","value":"redirectUri"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}]}]}}]} as unknown as DocumentNode;
export type AddPaymentMethodMutationFn = Apollo.MutationFunction<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>;

/**
 * __useAddPaymentMethodMutation__
 *
 * To run a mutation, you first call `useAddPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaymentMethodMutation, { data, loading, error }] = useAddPaymentMethodMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      redirectUri: // value for 'redirectUri'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useAddPaymentMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>(AddPaymentMethodDocument, options);
      }
export type AddPaymentMethodMutationHookResult = ReturnType<typeof useAddPaymentMethodMutation>;
export type AddPaymentMethodMutationResult = Apollo.MutationResult<AddPaymentMethodMutation>;
export type AddPaymentMethodMutationOptions = Apollo.BaseMutationOptions<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>;
export const DeletePaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FranchiseCountryEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"franchise_delete_stored_card"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"center_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"account_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentAccountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Message"}},{"kind":"Field","name":{"kind":"Name","value":"StatusCode"}},{"kind":"Field","name":{"kind":"Name","value":"InternalMessage"}}]}}]}}]}}]} as unknown as DocumentNode;
export type DeletePaymentMethodMutationFn = Apollo.MutationFunction<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;

/**
 * __useDeletePaymentMethodMutation__
 *
 * To run a mutation, you first call `useDeletePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentMethodMutation, { data, loading, error }] = useDeletePaymentMethodMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      country: // value for 'country'
 *      paymentAccountId: // value for 'paymentAccountId'
 *   },
 * });
 */
export function useDeletePaymentMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>(DeletePaymentMethodDocument, options);
      }
export type DeletePaymentMethodMutationHookResult = ReturnType<typeof useDeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationResult = Apollo.MutationResult<DeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationOptions = Apollo.BaseMutationOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;
export const GetUserBookingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserBookings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FranchiseCountryEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"franchise"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_bookings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice_id"}},{"kind":"Field","name":{"kind":"Name","value":"center_id"}},{"kind":"Field","name":{"kind":"Name","value":"appointment_services"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice_item_id"}},{"kind":"Field","name":{"kind":"Name","value":"start_time"}},{"kind":"Field","name":{"kind":"Name","value":"end_time"}},{"kind":"Field","name":{"kind":"Name","value":"service"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"final"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetUserBookingsQuery__
 *
 * To run a query within a React component, call `useGetUserBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserBookingsQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetUserBookingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserBookingsQuery, GetUserBookingsQueryVariables> & ({ variables: GetUserBookingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserBookingsQuery, GetUserBookingsQueryVariables>(GetUserBookingsDocument, options);
      }
export function useGetUserBookingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserBookingsQuery, GetUserBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserBookingsQuery, GetUserBookingsQueryVariables>(GetUserBookingsDocument, options);
        }
export function useGetUserBookingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserBookingsQuery, GetUserBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserBookingsQuery, GetUserBookingsQueryVariables>(GetUserBookingsDocument, options);
        }
export type GetUserBookingsQueryHookResult = ReturnType<typeof useGetUserBookingsQuery>;
export type GetUserBookingsLazyQueryHookResult = ReturnType<typeof useGetUserBookingsLazyQuery>;
export type GetUserBookingsSuspenseQueryHookResult = ReturnType<typeof useGetUserBookingsSuspenseQuery>;
export type GetUserBookingsQueryResult = Apollo.QueryResult<GetUserBookingsQuery, GetUserBookingsQueryVariables>;
export const GetUserMembershipsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserMemberships"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FranchiseCountryEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"franchise"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_user_memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guest_memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice_center_id"}},{"kind":"Field","name":{"kind":"Name","value":"services"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"service"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"redeemable_balance"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetUserMembershipsQuery__
 *
 * To run a query within a React component, call `useGetUserMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserMembershipsQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetUserMembershipsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserMembershipsQuery, GetUserMembershipsQueryVariables> & ({ variables: GetUserMembershipsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserMembershipsQuery, GetUserMembershipsQueryVariables>(GetUserMembershipsDocument, options);
      }
export function useGetUserMembershipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserMembershipsQuery, GetUserMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserMembershipsQuery, GetUserMembershipsQueryVariables>(GetUserMembershipsDocument, options);
        }
export function useGetUserMembershipsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserMembershipsQuery, GetUserMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserMembershipsQuery, GetUserMembershipsQueryVariables>(GetUserMembershipsDocument, options);
        }
export type GetUserMembershipsQueryHookResult = ReturnType<typeof useGetUserMembershipsQuery>;
export type GetUserMembershipsLazyQueryHookResult = ReturnType<typeof useGetUserMembershipsLazyQuery>;
export type GetUserMembershipsSuspenseQueryHookResult = ReturnType<typeof useGetUserMembershipsSuspenseQuery>;
export type GetUserMembershipsQueryResult = Apollo.QueryResult<GetUserMembershipsQuery, GetUserMembershipsQueryVariables>;
export const UserPackagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserPackages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FranchiseCountryEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"franchise"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"centerId"}},{"kind":"Field","name":{"kind":"Name","value":"centerName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"credits"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useUserPackagesQuery__
 *
 * To run a query within a React component, call `useUserPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPackagesQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useUserPackagesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserPackagesQuery, UserPackagesQueryVariables> & ({ variables: UserPackagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserPackagesQuery, UserPackagesQueryVariables>(UserPackagesDocument, options);
      }
export function useUserPackagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserPackagesQuery, UserPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserPackagesQuery, UserPackagesQueryVariables>(UserPackagesDocument, options);
        }
export function useUserPackagesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserPackagesQuery, UserPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserPackagesQuery, UserPackagesQueryVariables>(UserPackagesDocument, options);
        }
export type UserPackagesQueryHookResult = ReturnType<typeof useUserPackagesQuery>;
export type UserPackagesLazyQueryHookResult = ReturnType<typeof useUserPackagesLazyQuery>;
export type UserPackagesSuspenseQueryHookResult = ReturnType<typeof useUserPackagesSuspenseQuery>;
export type UserPackagesQueryResult = Apollo.QueryResult<UserPackagesQuery, UserPackagesQueryVariables>;
export const KpisPageBaseDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KpisPageBaseData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kpiCategoryWhereClause"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"kpi_category_bool_exp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kpiWhereClause"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"kpi_bool_exp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kpi_category"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kpiCategoryWhereClause"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}},{"kind":"Field","name":{"kind":"Name","value":"kpis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kpiWhereClause"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subcategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}},{"kind":"Field","name":{"kind":"Name","value":"sex_filter"}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}},{"kind":"Field","name":{"kind":"Name","value":"metric_id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespace_key"}},{"kind":"Field","name":{"kind":"Name","value":"default_rollup_interval_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useKpisPageBaseDataQuery__
 *
 * To run a query within a React component, call `useKpisPageBaseDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useKpisPageBaseDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpisPageBaseDataQuery({
 *   variables: {
 *      kpiCategoryWhereClause: // value for 'kpiCategoryWhereClause'
 *      kpiWhereClause: // value for 'kpiWhereClause'
 *   },
 * });
 */
export function useKpisPageBaseDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<KpisPageBaseDataQuery, KpisPageBaseDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<KpisPageBaseDataQuery, KpisPageBaseDataQueryVariables>(KpisPageBaseDataDocument, options);
      }
export function useKpisPageBaseDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<KpisPageBaseDataQuery, KpisPageBaseDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<KpisPageBaseDataQuery, KpisPageBaseDataQueryVariables>(KpisPageBaseDataDocument, options);
        }
export function useKpisPageBaseDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<KpisPageBaseDataQuery, KpisPageBaseDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<KpisPageBaseDataQuery, KpisPageBaseDataQueryVariables>(KpisPageBaseDataDocument, options);
        }
export type KpisPageBaseDataQueryHookResult = ReturnType<typeof useKpisPageBaseDataQuery>;
export type KpisPageBaseDataLazyQueryHookResult = ReturnType<typeof useKpisPageBaseDataLazyQuery>;
export type KpisPageBaseDataSuspenseQueryHookResult = ReturnType<typeof useKpisPageBaseDataSuspenseQuery>;
export type KpisPageBaseDataQueryResult = Apollo.QueryResult<KpisPageBaseDataQuery, KpisPageBaseDataQueryVariables>;
export const WatchedUserMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WatchedUserMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"watched_metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useWatchedUserMetricsQuery__
 *
 * To run a query within a React component, call `useWatchedUserMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchedUserMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchedUserMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWatchedUserMetricsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WatchedUserMetricsQuery, WatchedUserMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WatchedUserMetricsQuery, WatchedUserMetricsQueryVariables>(WatchedUserMetricsDocument, options);
      }
export function useWatchedUserMetricsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WatchedUserMetricsQuery, WatchedUserMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WatchedUserMetricsQuery, WatchedUserMetricsQueryVariables>(WatchedUserMetricsDocument, options);
        }
export function useWatchedUserMetricsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WatchedUserMetricsQuery, WatchedUserMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WatchedUserMetricsQuery, WatchedUserMetricsQueryVariables>(WatchedUserMetricsDocument, options);
        }
export type WatchedUserMetricsQueryHookResult = ReturnType<typeof useWatchedUserMetricsQuery>;
export type WatchedUserMetricsLazyQueryHookResult = ReturnType<typeof useWatchedUserMetricsLazyQuery>;
export type WatchedUserMetricsSuspenseQueryHookResult = ReturnType<typeof useWatchedUserMetricsSuspenseQuery>;
export type WatchedUserMetricsQueryResult = Apollo.QueryResult<WatchedUserMetricsQuery, WatchedUserMetricsQueryVariables>;
export const MyAchievementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyAchievements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"achievements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"achievement_id"}},{"kind":"Field","name":{"kind":"Name","value":"achievement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMyAchievementsQuery__
 *
 * To run a query within a React component, call `useMyAchievementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAchievementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAchievementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyAchievementsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyAchievementsQuery, MyAchievementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyAchievementsQuery, MyAchievementsQueryVariables>(MyAchievementsDocument, options);
      }
export function useMyAchievementsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyAchievementsQuery, MyAchievementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyAchievementsQuery, MyAchievementsQueryVariables>(MyAchievementsDocument, options);
        }
export function useMyAchievementsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyAchievementsQuery, MyAchievementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyAchievementsQuery, MyAchievementsQueryVariables>(MyAchievementsDocument, options);
        }
export type MyAchievementsQueryHookResult = ReturnType<typeof useMyAchievementsQuery>;
export type MyAchievementsLazyQueryHookResult = ReturnType<typeof useMyAchievementsLazyQuery>;
export type MyAchievementsSuspenseQueryHookResult = ReturnType<typeof useMyAchievementsSuspenseQuery>;
export type MyAchievementsQueryResult = Apollo.QueryResult<MyAchievementsQuery, MyAchievementsQueryVariables>;
export const DefaultHomeTilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DefaultHomeTiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home_tile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useDefaultHomeTilesQuery__
 *
 * To run a query within a React component, call `useDefaultHomeTilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultHomeTilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultHomeTilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDefaultHomeTilesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DefaultHomeTilesQuery, DefaultHomeTilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DefaultHomeTilesQuery, DefaultHomeTilesQueryVariables>(DefaultHomeTilesDocument, options);
      }
export function useDefaultHomeTilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DefaultHomeTilesQuery, DefaultHomeTilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DefaultHomeTilesQuery, DefaultHomeTilesQueryVariables>(DefaultHomeTilesDocument, options);
        }
export function useDefaultHomeTilesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DefaultHomeTilesQuery, DefaultHomeTilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DefaultHomeTilesQuery, DefaultHomeTilesQueryVariables>(DefaultHomeTilesDocument, options);
        }
export type DefaultHomeTilesQueryHookResult = ReturnType<typeof useDefaultHomeTilesQuery>;
export type DefaultHomeTilesLazyQueryHookResult = ReturnType<typeof useDefaultHomeTilesLazyQuery>;
export type DefaultHomeTilesSuspenseQueryHookResult = ReturnType<typeof useDefaultHomeTilesSuspenseQuery>;
export type DefaultHomeTilesQueryResult = Apollo.QueryResult<DefaultHomeTilesQuery, DefaultHomeTilesQueryVariables>;
export const UserHomeTilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserHomeTiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_home_tile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}},{"kind":"Field","name":{"kind":"Name","value":"home_tile_id"}},{"kind":"Field","name":{"kind":"Name","value":"home_tile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useUserHomeTilesQuery__
 *
 * To run a query within a React component, call `useUserHomeTilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserHomeTilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserHomeTilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserHomeTilesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserHomeTilesQuery, UserHomeTilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserHomeTilesQuery, UserHomeTilesQueryVariables>(UserHomeTilesDocument, options);
      }
export function useUserHomeTilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserHomeTilesQuery, UserHomeTilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserHomeTilesQuery, UserHomeTilesQueryVariables>(UserHomeTilesDocument, options);
        }
export function useUserHomeTilesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserHomeTilesQuery, UserHomeTilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserHomeTilesQuery, UserHomeTilesQueryVariables>(UserHomeTilesDocument, options);
        }
export type UserHomeTilesQueryHookResult = ReturnType<typeof useUserHomeTilesQuery>;
export type UserHomeTilesLazyQueryHookResult = ReturnType<typeof useUserHomeTilesLazyQuery>;
export type UserHomeTilesSuspenseQueryHookResult = ReturnType<typeof useUserHomeTilesSuspenseQuery>;
export type UserHomeTilesQueryResult = Apollo.QueryResult<UserHomeTilesQuery, UserHomeTilesQueryVariables>;
export const ShowUserHomeTileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ShowUserHomeTile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"homeTile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_home_tile_insert_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"homeTileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_user_home_tile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"home_tile_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"homeTileId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_user_home_tile_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"homeTile"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"user_home_tile_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home_tile_id"}}]}}]}}]} as unknown as DocumentNode;
export type ShowUserHomeTileMutationFn = Apollo.MutationFunction<ShowUserHomeTileMutation, ShowUserHomeTileMutationVariables>;

/**
 * __useShowUserHomeTileMutation__
 *
 * To run a mutation, you first call `useShowUserHomeTileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShowUserHomeTileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [showUserHomeTileMutation, { data, loading, error }] = useShowUserHomeTileMutation({
 *   variables: {
 *      homeTile: // value for 'homeTile'
 *      homeTileId: // value for 'homeTileId'
 *   },
 * });
 */
export function useShowUserHomeTileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShowUserHomeTileMutation, ShowUserHomeTileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShowUserHomeTileMutation, ShowUserHomeTileMutationVariables>(ShowUserHomeTileDocument, options);
      }
export type ShowUserHomeTileMutationHookResult = ReturnType<typeof useShowUserHomeTileMutation>;
export type ShowUserHomeTileMutationResult = Apollo.MutationResult<ShowUserHomeTileMutation>;
export type ShowUserHomeTileMutationOptions = Apollo.BaseMutationOptions<ShowUserHomeTileMutation, ShowUserHomeTileMutationVariables>;
export const ShowUserHomeTileBatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ShowUserHomeTileBatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_home_tile_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"homeTileIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_user_home_tile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"home_tile_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"homeTileIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_user_home_tile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"user_home_tile_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode;
export type ShowUserHomeTileBatchMutationFn = Apollo.MutationFunction<ShowUserHomeTileBatchMutation, ShowUserHomeTileBatchMutationVariables>;

/**
 * __useShowUserHomeTileBatchMutation__
 *
 * To run a mutation, you first call `useShowUserHomeTileBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShowUserHomeTileBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [showUserHomeTileBatchMutation, { data, loading, error }] = useShowUserHomeTileBatchMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *      homeTileIds: // value for 'homeTileIds'
 *   },
 * });
 */
export function useShowUserHomeTileBatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ShowUserHomeTileBatchMutation, ShowUserHomeTileBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ShowUserHomeTileBatchMutation, ShowUserHomeTileBatchMutationVariables>(ShowUserHomeTileBatchDocument, options);
      }
export type ShowUserHomeTileBatchMutationHookResult = ReturnType<typeof useShowUserHomeTileBatchMutation>;
export type ShowUserHomeTileBatchMutationResult = Apollo.MutationResult<ShowUserHomeTileBatchMutation>;
export type ShowUserHomeTileBatchMutationOptions = Apollo.BaseMutationOptions<ShowUserHomeTileBatchMutation, ShowUserHomeTileBatchMutationVariables>;
export const HideUserHomeTileByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HideUserHomeTileById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_user_home_tile_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home_tile_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]} as unknown as DocumentNode;
export type HideUserHomeTileByIdMutationFn = Apollo.MutationFunction<HideUserHomeTileByIdMutation, HideUserHomeTileByIdMutationVariables>;

/**
 * __useHideUserHomeTileByIdMutation__
 *
 * To run a mutation, you first call `useHideUserHomeTileByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideUserHomeTileByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideUserHomeTileByIdMutation, { data, loading, error }] = useHideUserHomeTileByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHideUserHomeTileByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<HideUserHomeTileByIdMutation, HideUserHomeTileByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<HideUserHomeTileByIdMutation, HideUserHomeTileByIdMutationVariables>(HideUserHomeTileByIdDocument, options);
      }
export type HideUserHomeTileByIdMutationHookResult = ReturnType<typeof useHideUserHomeTileByIdMutation>;
export type HideUserHomeTileByIdMutationResult = Apollo.MutationResult<HideUserHomeTileByIdMutation>;
export type HideUserHomeTileByIdMutationOptions = Apollo.BaseMutationOptions<HideUserHomeTileByIdMutation, HideUserHomeTileByIdMutationVariables>;
export const UserMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"unitDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"}},{"kind":"Field","name":{"kind":"Name","value":"scale_label_low"}},{"kind":"Field","name":{"kind":"Name","value":"scale_label_high"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useUserMetricsQuery__
 *
 * To run a query within a React component, call `useUserMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserMetricsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserMetricsQuery, UserMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserMetricsQuery, UserMetricsQueryVariables>(UserMetricsDocument, options);
      }
export function useUserMetricsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserMetricsQuery, UserMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserMetricsQuery, UserMetricsQueryVariables>(UserMetricsDocument, options);
        }
export function useUserMetricsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserMetricsQuery, UserMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserMetricsQuery, UserMetricsQueryVariables>(UserMetricsDocument, options);
        }
export type UserMetricsQueryHookResult = ReturnType<typeof useUserMetricsQuery>;
export type UserMetricsLazyQueryHookResult = ReturnType<typeof useUserMetricsLazyQuery>;
export type UserMetricsSuspenseQueryHookResult = ReturnType<typeof useUserMetricsSuspenseQuery>;
export type UserMetricsQueryResult = Apollo.QueryResult<UserMetricsQuery, UserMetricsQueryVariables>;
export const InsertUserMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertUserMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserMetricInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_user_metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type InsertUserMetricMutationFn = Apollo.MutationFunction<InsertUserMetricMutation, InsertUserMetricMutationVariables>;

/**
 * __useInsertUserMetricMutation__
 *
 * To run a mutation, you first call `useInsertUserMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUserMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUserMetricMutation, { data, loading, error }] = useInsertUserMetricMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertUserMetricMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertUserMetricMutation, InsertUserMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InsertUserMetricMutation, InsertUserMetricMutationVariables>(InsertUserMetricDocument, options);
      }
export type InsertUserMetricMutationHookResult = ReturnType<typeof useInsertUserMetricMutation>;
export type InsertUserMetricMutationResult = Apollo.MutationResult<InsertUserMetricMutation>;
export type InsertUserMetricMutationOptions = Apollo.BaseMutationOptions<InsertUserMetricMutation, InsertUserMetricMutationVariables>;
export const UpdateUserMetricByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserMetricById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"metric_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_metric_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type UpdateUserMetricByIdMutationFn = Apollo.MutationFunction<UpdateUserMetricByIdMutation, UpdateUserMetricByIdMutationVariables>;

/**
 * __useUpdateUserMetricByIdMutation__
 *
 * To run a mutation, you first call `useUpdateUserMetricByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMetricByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMetricByIdMutation, { data, loading, error }] = useUpdateUserMetricByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      changes: // value for 'changes'
 *   },
 * });
 */
export function useUpdateUserMetricByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserMetricByIdMutation, UpdateUserMetricByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserMetricByIdMutation, UpdateUserMetricByIdMutationVariables>(UpdateUserMetricByIdDocument, options);
      }
export type UpdateUserMetricByIdMutationHookResult = ReturnType<typeof useUpdateUserMetricByIdMutation>;
export type UpdateUserMetricByIdMutationResult = Apollo.MutationResult<UpdateUserMetricByIdMutation>;
export type UpdateUserMetricByIdMutationOptions = Apollo.BaseMutationOptions<UpdateUserMetricByIdMutation, UpdateUserMetricByIdMutationVariables>;
export const RemoveUserMetricByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveUserMetricById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_user_metric_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode;
export type RemoveUserMetricByIdMutationFn = Apollo.MutationFunction<RemoveUserMetricByIdMutation, RemoveUserMetricByIdMutationVariables>;

/**
 * __useRemoveUserMetricByIdMutation__
 *
 * To run a mutation, you first call `useRemoveUserMetricByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMetricByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMetricByIdMutation, { data, loading, error }] = useRemoveUserMetricByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveUserMetricByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveUserMetricByIdMutation, RemoveUserMetricByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveUserMetricByIdMutation, RemoveUserMetricByIdMutationVariables>(RemoveUserMetricByIdDocument, options);
      }
export type RemoveUserMetricByIdMutationHookResult = ReturnType<typeof useRemoveUserMetricByIdMutation>;
export type RemoveUserMetricByIdMutationResult = Apollo.MutationResult<RemoveUserMetricByIdMutation>;
export type RemoveUserMetricByIdMutationOptions = Apollo.BaseMutationOptions<RemoveUserMetricByIdMutation, RemoveUserMetricByIdMutationVariables>;
export const DemoSuggestPlansDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DemoSuggestPlans"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useV2"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"method"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ACTION_PLAN_SUGGESTION_TYPE"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"forceNew"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratings"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionPlanProfileCategoryRating"}}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_id"},"value":{"kind":"StringValue","value":"2a66321b-0e99-452c-8e7b-5c5aa5d5a5c8","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"instance_value"},"value":{"kind":"IntValue","value":"3"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_id"},"value":{"kind":"StringValue","value":"60dba3ac-d16d-4377-a278-a7126bb978d2","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"instance_value"},"value":{"kind":"IntValue","value":"3"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_id"},"value":{"kind":"StringValue","value":"5e670501-26dd-4eb3-acd8-0b1e45586292","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"instance_value"},"value":{"kind":"IntValue","value":"3"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_id"},"value":{"kind":"StringValue","value":"4397dc8d-e5a3-4e90-8ff6-2bc0c65c9ec2","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"instance_value"},"value":{"kind":"IntValue","value":"3"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_id"},"value":{"kind":"StringValue","value":"29e7716a-742e-4125-8c10-219a23eb9f40","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"instance_value"},"value":{"kind":"IntValue","value":"3"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_id"},"value":{"kind":"StringValue","value":"037c13ff-1526-447a-864a-f9f0437f3b90","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"instance_value"},"value":{"kind":"IntValue","value":"3"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_id"},"value":{"kind":"StringValue","value":"8d0a166a-b596-457b-a869-305add898a5e","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"instance_value"},"value":{"kind":"IntValue","value":"3"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_id"},"value":{"kind":"StringValue","value":"a7d3d0d2-3bc2-43a0-b8c9-02acd2abbf79","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"instance_value"},"value":{"kind":"IntValue","value":"3"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_id"},"value":{"kind":"StringValue","value":"6a27f201-cfc6-4361-b558-c5b8543bfe83","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"instance_value"},"value":{"kind":"IntValue","value":"3"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_id"},"value":{"kind":"StringValue","value":"35d4864b-cd57-46ee-9f51-3e988c4a0d75","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"instance_value"},"value":{"kind":"IntValue","value":"3"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_id"},"value":{"kind":"StringValue","value":"1ed7a94f-a359-4397-8a54-d12ac0f2a9dd","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"instance_value"},"value":{"kind":"IntValue","value":"3"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_id"},"value":{"kind":"StringValue","value":"c68d769b-63d7-44aa-bd1c-2e1efedc8da8","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"instance_value"},"value":{"kind":"IntValue","value":"3"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_id"},"value":{"kind":"StringValue","value":"8af0f9f8-07d3-479e-b467-0563a837c2bd","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"instance_value"},"value":{"kind":"IntValue","value":"3"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_id"},"value":{"kind":"StringValue","value":"1d851f65-caf8-4223-9e24-24fb5f6d347b","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"instance_value"},"value":{"kind":"IntValue","value":"3"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_id"},"value":{"kind":"StringValue","value":"d6fa1636-a622-4f5e-b106-60aee37494c2","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"instance_value"},"value":{"kind":"IntValue","value":"3"}}]}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"30"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kpi_priorities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"kpi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"suggest_action_plans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"Argument","name":{"kind":"Name","value":"v2"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useV2"}}},{"kind":"Argument","name":{"kind":"Name","value":"method"},"value":{"kind":"Variable","name":{"kind":"Name","value":"method"}}},{"kind":"Argument","name":{"kind":"Name","value":"forceNew"},"value":{"kind":"Variable","name":{"kind":"Name","value":"forceNew"}}},{"kind":"Argument","name":{"kind":"Name","value":"profile"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ratings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratings"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"planCategory"},"value":{"kind":"EnumValue","value":"DEMO"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggested"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_plan_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_config"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"kpi_snapshot_priority"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"priority"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"action_item_config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value_target"}},{"kind":"Field","name":{"kind":"Name","value":"interval_type"}},{"kind":"Field","name":{"kind":"Name","value":"weekly_instance_target"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"action_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name_plural"}},{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}},{"kind":"Field","name":{"kind":"Name","value":"display_symbol_plural"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_item_inputs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"input_type"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useDemoSuggestPlansQuery__
 *
 * To run a query within a React component, call `useDemoSuggestPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useDemoSuggestPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDemoSuggestPlansQuery({
 *   variables: {
 *      date: // value for 'date'
 *      useV2: // value for 'useV2'
 *      method: // value for 'method'
 *      forceNew: // value for 'forceNew'
 *      ratings: // value for 'ratings'
 *   },
 * });
 */
export function useDemoSuggestPlansQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DemoSuggestPlansQuery, DemoSuggestPlansQueryVariables> & ({ variables: DemoSuggestPlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DemoSuggestPlansQuery, DemoSuggestPlansQueryVariables>(DemoSuggestPlansDocument, options);
      }
export function useDemoSuggestPlansLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DemoSuggestPlansQuery, DemoSuggestPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DemoSuggestPlansQuery, DemoSuggestPlansQueryVariables>(DemoSuggestPlansDocument, options);
        }
export function useDemoSuggestPlansSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DemoSuggestPlansQuery, DemoSuggestPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DemoSuggestPlansQuery, DemoSuggestPlansQueryVariables>(DemoSuggestPlansDocument, options);
        }
export type DemoSuggestPlansQueryHookResult = ReturnType<typeof useDemoSuggestPlansQuery>;
export type DemoSuggestPlansLazyQueryHookResult = ReturnType<typeof useDemoSuggestPlansLazyQuery>;
export type DemoSuggestPlansSuspenseQueryHookResult = ReturnType<typeof useDemoSuggestPlansSuspenseQuery>;
export type DemoSuggestPlansQueryResult = Apollo.QueryResult<DemoSuggestPlansQuery, DemoSuggestPlansQueryVariables>;
export const SelectActionPlanTemplateItemsAndJoinRecommendedCirclesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SelectActionPlanTemplateItemsAndJoinRecommendedCircles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionPlanTemplateItemIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardioCircleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sleepCircleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipCardio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipSleep"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"select_action_plan_template_items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"action_plan_template_item_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionPlanTemplateItemIds"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"joinCardioCircle"},"name":{"kind":"Name","value":"joinCircle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inviteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardioCircleId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipCardio"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"joinSleepCircle"},"name":{"kind":"Name","value":"joinCircle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inviteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sleepCircleId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipSleep"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type SelectActionPlanTemplateItemsAndJoinRecommendedCirclesMutationFn = Apollo.MutationFunction<SelectActionPlanTemplateItemsAndJoinRecommendedCirclesMutation, SelectActionPlanTemplateItemsAndJoinRecommendedCirclesMutationVariables>;

/**
 * __useSelectActionPlanTemplateItemsAndJoinRecommendedCirclesMutation__
 *
 * To run a mutation, you first call `useSelectActionPlanTemplateItemsAndJoinRecommendedCirclesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectActionPlanTemplateItemsAndJoinRecommendedCirclesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectActionPlanTemplateItemsAndJoinRecommendedCirclesMutation, { data, loading, error }] = useSelectActionPlanTemplateItemsAndJoinRecommendedCirclesMutation({
 *   variables: {
 *      actionPlanTemplateItemIds: // value for 'actionPlanTemplateItemIds'
 *      cardioCircleId: // value for 'cardioCircleId'
 *      sleepCircleId: // value for 'sleepCircleId'
 *      skipCardio: // value for 'skipCardio'
 *      skipSleep: // value for 'skipSleep'
 *   },
 * });
 */
export function useSelectActionPlanTemplateItemsAndJoinRecommendedCirclesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SelectActionPlanTemplateItemsAndJoinRecommendedCirclesMutation, SelectActionPlanTemplateItemsAndJoinRecommendedCirclesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SelectActionPlanTemplateItemsAndJoinRecommendedCirclesMutation, SelectActionPlanTemplateItemsAndJoinRecommendedCirclesMutationVariables>(SelectActionPlanTemplateItemsAndJoinRecommendedCirclesDocument, options);
      }
export type SelectActionPlanTemplateItemsAndJoinRecommendedCirclesMutationHookResult = ReturnType<typeof useSelectActionPlanTemplateItemsAndJoinRecommendedCirclesMutation>;
export type SelectActionPlanTemplateItemsAndJoinRecommendedCirclesMutationResult = Apollo.MutationResult<SelectActionPlanTemplateItemsAndJoinRecommendedCirclesMutation>;
export type SelectActionPlanTemplateItemsAndJoinRecommendedCirclesMutationOptions = Apollo.BaseMutationOptions<SelectActionPlanTemplateItemsAndJoinRecommendedCirclesMutation, SelectActionPlanTemplateItemsAndJoinRecommendedCirclesMutationVariables>;
export const UserPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"me"},"name":{"kind":"Name","value":"me_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"date_of_birth"}},{"kind":"Field","name":{"kind":"Name","value":"membership_tier"}},{"kind":"Field","name":{"kind":"Name","value":"membership_subscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"membership_tier"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"FREE_MEMBER"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancel_scheduled_at"}},{"kind":"Field","name":{"kind":"Name","value":"membership_tier"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_end"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled_at"}},{"kind":"Field","name":{"kind":"Name","value":"product_line_item_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_line_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_unit_preference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to_unit"}},{"kind":"Field","name":{"kind":"Name","value":"from_unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracked_metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tracked_metric_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"qualitative"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useUserPreferencesQuery__
 *
 * To run a query within a React component, call `useUserPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserPreferencesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserPreferencesQuery, UserPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserPreferencesQuery, UserPreferencesQueryVariables>(UserPreferencesDocument, options);
      }
export function useUserPreferencesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserPreferencesQuery, UserPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserPreferencesQuery, UserPreferencesQueryVariables>(UserPreferencesDocument, options);
        }
export function useUserPreferencesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserPreferencesQuery, UserPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserPreferencesQuery, UserPreferencesQueryVariables>(UserPreferencesDocument, options);
        }
export type UserPreferencesQueryHookResult = ReturnType<typeof useUserPreferencesQuery>;
export type UserPreferencesLazyQueryHookResult = ReturnType<typeof useUserPreferencesLazyQuery>;
export type UserPreferencesSuspenseQueryHookResult = ReturnType<typeof useUserPreferencesSuspenseQuery>;
export type UserPreferencesQueryResult = Apollo.QueryResult<UserPreferencesQuery, UserPreferencesQueryVariables>;
export const QualitativeMetricsByNamespaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QualitativeMetricsByNamespace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useQualitativeMetricsByNamespaceQuery__
 *
 * To run a query within a React component, call `useQualitativeMetricsByNamespaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useQualitativeMetricsByNamespaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQualitativeMetricsByNamespaceQuery({
 *   variables: {
 *      namespace: // value for 'namespace'
 *   },
 * });
 */
export function useQualitativeMetricsByNamespaceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<QualitativeMetricsByNamespaceQuery, QualitativeMetricsByNamespaceQueryVariables> & ({ variables: QualitativeMetricsByNamespaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<QualitativeMetricsByNamespaceQuery, QualitativeMetricsByNamespaceQueryVariables>(QualitativeMetricsByNamespaceDocument, options);
      }
export function useQualitativeMetricsByNamespaceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QualitativeMetricsByNamespaceQuery, QualitativeMetricsByNamespaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<QualitativeMetricsByNamespaceQuery, QualitativeMetricsByNamespaceQueryVariables>(QualitativeMetricsByNamespaceDocument, options);
        }
export function useQualitativeMetricsByNamespaceSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<QualitativeMetricsByNamespaceQuery, QualitativeMetricsByNamespaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<QualitativeMetricsByNamespaceQuery, QualitativeMetricsByNamespaceQueryVariables>(QualitativeMetricsByNamespaceDocument, options);
        }
export type QualitativeMetricsByNamespaceQueryHookResult = ReturnType<typeof useQualitativeMetricsByNamespaceQuery>;
export type QualitativeMetricsByNamespaceLazyQueryHookResult = ReturnType<typeof useQualitativeMetricsByNamespaceLazyQuery>;
export type QualitativeMetricsByNamespaceSuspenseQueryHookResult = ReturnType<typeof useQualitativeMetricsByNamespaceSuspenseQuery>;
export type QualitativeMetricsByNamespaceQueryResult = Apollo.QueryResult<QualitativeMetricsByNamespaceQuery, QualitativeMetricsByNamespaceQueryVariables>;
export const QualitativeMetricsByUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QualitativeMetricsByUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"metric_type_enum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricType"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useQualitativeMetricsByUserQuery__
 *
 * To run a query within a React component, call `useQualitativeMetricsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useQualitativeMetricsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQualitativeMetricsByUserQuery({
 *   variables: {
 *      metricType: // value for 'metricType'
 *   },
 * });
 */
export function useQualitativeMetricsByUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<QualitativeMetricsByUserQuery, QualitativeMetricsByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<QualitativeMetricsByUserQuery, QualitativeMetricsByUserQueryVariables>(QualitativeMetricsByUserDocument, options);
      }
export function useQualitativeMetricsByUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QualitativeMetricsByUserQuery, QualitativeMetricsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<QualitativeMetricsByUserQuery, QualitativeMetricsByUserQueryVariables>(QualitativeMetricsByUserDocument, options);
        }
export function useQualitativeMetricsByUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<QualitativeMetricsByUserQuery, QualitativeMetricsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<QualitativeMetricsByUserQuery, QualitativeMetricsByUserQueryVariables>(QualitativeMetricsByUserDocument, options);
        }
export type QualitativeMetricsByUserQueryHookResult = ReturnType<typeof useQualitativeMetricsByUserQuery>;
export type QualitativeMetricsByUserLazyQueryHookResult = ReturnType<typeof useQualitativeMetricsByUserLazyQuery>;
export type QualitativeMetricsByUserSuspenseQueryHookResult = ReturnType<typeof useQualitativeMetricsByUserSuspenseQuery>;
export type QualitativeMetricsByUserQueryResult = Apollo.QueryResult<QualitativeMetricsByUserQuery, QualitativeMetricsByUserQueryVariables>;
export const SetGlobalUnitPreferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetGlobalUnitPreference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromUnit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toUnit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"set_default_unit_preference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fromUnit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromUnit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"toUnit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toUnit"}}}]}}]}]}}]} as unknown as DocumentNode;
export type SetGlobalUnitPreferenceMutationFn = Apollo.MutationFunction<SetGlobalUnitPreferenceMutation, SetGlobalUnitPreferenceMutationVariables>;

/**
 * __useSetGlobalUnitPreferenceMutation__
 *
 * To run a mutation, you first call `useSetGlobalUnitPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGlobalUnitPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGlobalUnitPreferenceMutation, { data, loading, error }] = useSetGlobalUnitPreferenceMutation({
 *   variables: {
 *      fromUnit: // value for 'fromUnit'
 *      toUnit: // value for 'toUnit'
 *   },
 * });
 */
export function useSetGlobalUnitPreferenceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetGlobalUnitPreferenceMutation, SetGlobalUnitPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetGlobalUnitPreferenceMutation, SetGlobalUnitPreferenceMutationVariables>(SetGlobalUnitPreferenceDocument, options);
      }
export type SetGlobalUnitPreferenceMutationHookResult = ReturnType<typeof useSetGlobalUnitPreferenceMutation>;
export type SetGlobalUnitPreferenceMutationResult = Apollo.MutationResult<SetGlobalUnitPreferenceMutation>;
export type SetGlobalUnitPreferenceMutationOptions = Apollo.BaseMutationOptions<SetGlobalUnitPreferenceMutation, SetGlobalUnitPreferenceMutationVariables>;
export const TimezoneNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TimezoneNames"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"iana_timezone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useTimezoneNamesQuery__
 *
 * To run a query within a React component, call `useTimezoneNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimezoneNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimezoneNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTimezoneNamesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TimezoneNamesQuery, TimezoneNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TimezoneNamesQuery, TimezoneNamesQueryVariables>(TimezoneNamesDocument, options);
      }
export function useTimezoneNamesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TimezoneNamesQuery, TimezoneNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TimezoneNamesQuery, TimezoneNamesQueryVariables>(TimezoneNamesDocument, options);
        }
export function useTimezoneNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TimezoneNamesQuery, TimezoneNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TimezoneNamesQuery, TimezoneNamesQueryVariables>(TimezoneNamesDocument, options);
        }
export type TimezoneNamesQueryHookResult = ReturnType<typeof useTimezoneNamesQuery>;
export type TimezoneNamesLazyQueryHookResult = ReturnType<typeof useTimezoneNamesLazyQuery>;
export type TimezoneNamesSuspenseQueryHookResult = ReturnType<typeof useTimezoneNamesSuspenseQuery>;
export type TimezoneNamesQueryResult = Apollo.QueryResult<TimezoneNamesQuery, TimezoneNamesQueryVariables>;
export const SetMetricTargetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetMetricTarget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MetricTargetCreateInputType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"set_metric_target"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type SetMetricTargetMutationFn = Apollo.MutationFunction<SetMetricTargetMutation, SetMetricTargetMutationVariables>;

/**
 * __useSetMetricTargetMutation__
 *
 * To run a mutation, you first call `useSetMetricTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMetricTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMetricTargetMutation, { data, loading, error }] = useSetMetricTargetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetMetricTargetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetMetricTargetMutation, SetMetricTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetMetricTargetMutation, SetMetricTargetMutationVariables>(SetMetricTargetDocument, options);
      }
export type SetMetricTargetMutationHookResult = ReturnType<typeof useSetMetricTargetMutation>;
export type SetMetricTargetMutationResult = Apollo.MutationResult<SetMetricTargetMutation>;
export type SetMetricTargetMutationOptions = Apollo.BaseMutationOptions<SetMetricTargetMutation, SetMetricTargetMutationVariables>;
export const MetricUnitPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MetricUnitPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_unit_preference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_unit"}},{"kind":"Field","name":{"kind":"Name","value":"to_unit"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to_unit_conversions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_unit"}},{"kind":"Field","name":{"kind":"Name","value":"to_unit"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMetricUnitPreferencesQuery__
 *
 * To run a query within a React component, call `useMetricUnitPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricUnitPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricUnitPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMetricUnitPreferencesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MetricUnitPreferencesQuery, MetricUnitPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MetricUnitPreferencesQuery, MetricUnitPreferencesQueryVariables>(MetricUnitPreferencesDocument, options);
      }
export function useMetricUnitPreferencesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetricUnitPreferencesQuery, MetricUnitPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MetricUnitPreferencesQuery, MetricUnitPreferencesQueryVariables>(MetricUnitPreferencesDocument, options);
        }
export function useMetricUnitPreferencesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MetricUnitPreferencesQuery, MetricUnitPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MetricUnitPreferencesQuery, MetricUnitPreferencesQueryVariables>(MetricUnitPreferencesDocument, options);
        }
export type MetricUnitPreferencesQueryHookResult = ReturnType<typeof useMetricUnitPreferencesQuery>;
export type MetricUnitPreferencesLazyQueryHookResult = ReturnType<typeof useMetricUnitPreferencesLazyQuery>;
export type MetricUnitPreferencesSuspenseQueryHookResult = ReturnType<typeof useMetricUnitPreferencesSuspenseQuery>;
export type MetricUnitPreferencesQueryResult = Apollo.QueryResult<MetricUnitPreferencesQuery, MetricUnitPreferencesQueryVariables>;
export const MetricUnitConversionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MetricUnitConversions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to_unit_conversions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from_unit"}},{"kind":"Field","name":{"kind":"Name","value":"to_unit"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMetricUnitConversionsQuery__
 *
 * To run a query within a React component, call `useMetricUnitConversionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricUnitConversionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricUnitConversionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMetricUnitConversionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MetricUnitConversionsQuery, MetricUnitConversionsQueryVariables> & ({ variables: MetricUnitConversionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MetricUnitConversionsQuery, MetricUnitConversionsQueryVariables>(MetricUnitConversionsDocument, options);
      }
export function useMetricUnitConversionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetricUnitConversionsQuery, MetricUnitConversionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MetricUnitConversionsQuery, MetricUnitConversionsQueryVariables>(MetricUnitConversionsDocument, options);
        }
export function useMetricUnitConversionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MetricUnitConversionsQuery, MetricUnitConversionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MetricUnitConversionsQuery, MetricUnitConversionsQueryVariables>(MetricUnitConversionsDocument, options);
        }
export type MetricUnitConversionsQueryHookResult = ReturnType<typeof useMetricUnitConversionsQuery>;
export type MetricUnitConversionsLazyQueryHookResult = ReturnType<typeof useMetricUnitConversionsLazyQuery>;
export type MetricUnitConversionsSuspenseQueryHookResult = ReturnType<typeof useMetricUnitConversionsSuspenseQuery>;
export type MetricUnitConversionsQueryResult = Apollo.QueryResult<MetricUnitConversionsQuery, MetricUnitConversionsQueryVariables>;
export const UpdateMetricUnitPreferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMetricUnitPreference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"set_metric_unit_preference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metricId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"preferenceUnit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unit"}}}]}}]}]}}]} as unknown as DocumentNode;
export type UpdateMetricUnitPreferenceMutationFn = Apollo.MutationFunction<UpdateMetricUnitPreferenceMutation, UpdateMetricUnitPreferenceMutationVariables>;

/**
 * __useUpdateMetricUnitPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateMetricUnitPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetricUnitPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMetricUnitPreferenceMutation, { data, loading, error }] = useUpdateMetricUnitPreferenceMutation({
 *   variables: {
 *      metricId: // value for 'metricId'
 *      unit: // value for 'unit'
 *   },
 * });
 */
export function useUpdateMetricUnitPreferenceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMetricUnitPreferenceMutation, UpdateMetricUnitPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMetricUnitPreferenceMutation, UpdateMetricUnitPreferenceMutationVariables>(UpdateMetricUnitPreferenceDocument, options);
      }
export type UpdateMetricUnitPreferenceMutationHookResult = ReturnType<typeof useUpdateMetricUnitPreferenceMutation>;
export type UpdateMetricUnitPreferenceMutationResult = Apollo.MutationResult<UpdateMetricUnitPreferenceMutation>;
export type UpdateMetricUnitPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateMetricUnitPreferenceMutation, UpdateMetricUnitPreferenceMutationVariables>;
export const DeleteMetricUnitPreferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMetricUnitPreference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_user_unit_preference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode;
export type DeleteMetricUnitPreferenceMutationFn = Apollo.MutationFunction<DeleteMetricUnitPreferenceMutation, DeleteMetricUnitPreferenceMutationVariables>;

/**
 * __useDeleteMetricUnitPreferenceMutation__
 *
 * To run a mutation, you first call `useDeleteMetricUnitPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMetricUnitPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMetricUnitPreferenceMutation, { data, loading, error }] = useDeleteMetricUnitPreferenceMutation({
 *   variables: {
 *      metricId: // value for 'metricId'
 *   },
 * });
 */
export function useDeleteMetricUnitPreferenceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMetricUnitPreferenceMutation, DeleteMetricUnitPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMetricUnitPreferenceMutation, DeleteMetricUnitPreferenceMutationVariables>(DeleteMetricUnitPreferenceDocument, options);
      }
export type DeleteMetricUnitPreferenceMutationHookResult = ReturnType<typeof useDeleteMetricUnitPreferenceMutation>;
export type DeleteMetricUnitPreferenceMutationResult = Apollo.MutationResult<DeleteMetricUnitPreferenceMutation>;
export type DeleteMetricUnitPreferenceMutationOptions = Apollo.BaseMutationOptions<DeleteMetricUnitPreferenceMutation, DeleteMetricUnitPreferenceMutationVariables>;
export const UnitsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UnitsList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_symbol"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useUnitsListQuery__
 *
 * To run a query within a React component, call `useUnitsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnitsListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UnitsListQuery, UnitsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UnitsListQuery, UnitsListQueryVariables>(UnitsListDocument, options);
      }
export function useUnitsListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UnitsListQuery, UnitsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UnitsListQuery, UnitsListQueryVariables>(UnitsListDocument, options);
        }
export function useUnitsListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UnitsListQuery, UnitsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UnitsListQuery, UnitsListQueryVariables>(UnitsListDocument, options);
        }
export type UnitsListQueryHookResult = ReturnType<typeof useUnitsListQuery>;
export type UnitsListLazyQueryHookResult = ReturnType<typeof useUnitsListLazyQuery>;
export type UnitsListSuspenseQueryHookResult = ReturnType<typeof useUnitsListSuspenseQuery>;
export type UnitsListQueryResult = Apollo.QueryResult<UnitsListQuery, UnitsListQueryVariables>;
export const CurrentChronologicalAgeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentChronologicalAge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace_key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"PHENO_AGE:CHRONOLOGICAL_AGE","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dynamic_record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCurrentChronologicalAgeQuery__
 *
 * To run a query within a React component, call `useCurrentChronologicalAgeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentChronologicalAgeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentChronologicalAgeQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentChronologicalAgeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentChronologicalAgeQuery, CurrentChronologicalAgeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentChronologicalAgeQuery, CurrentChronologicalAgeQueryVariables>(CurrentChronologicalAgeDocument, options);
      }
export function useCurrentChronologicalAgeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentChronologicalAgeQuery, CurrentChronologicalAgeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentChronologicalAgeQuery, CurrentChronologicalAgeQueryVariables>(CurrentChronologicalAgeDocument, options);
        }
export function useCurrentChronologicalAgeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CurrentChronologicalAgeQuery, CurrentChronologicalAgeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CurrentChronologicalAgeQuery, CurrentChronologicalAgeQueryVariables>(CurrentChronologicalAgeDocument, options);
        }
export type CurrentChronologicalAgeQueryHookResult = ReturnType<typeof useCurrentChronologicalAgeQuery>;
export type CurrentChronologicalAgeLazyQueryHookResult = ReturnType<typeof useCurrentChronologicalAgeLazyQuery>;
export type CurrentChronologicalAgeSuspenseQueryHookResult = ReturnType<typeof useCurrentChronologicalAgeSuspenseQuery>;
export type CurrentChronologicalAgeQueryResult = Apollo.QueryResult<CurrentChronologicalAgeQuery, CurrentChronologicalAgeQueryVariables>;
export const MetricDetailsMatchedReferenceRangesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MetricDetailsMatchedReferenceRanges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipMetricRecordRefRanges"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricReferenceRangeFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReferenceRangeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReferenceRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dataSource"}},{"kind":"Field","name":{"kind":"Name","value":"rangeType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"targets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"optimal"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"discreteTargets"}},{"kind":"Field","name":{"kind":"Name","value":"healthEffectsTitle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricMatchedReferenceRangeTargetsV2Fields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matched_reference_range_targets_v2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"include_other_criteria"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReferenceRangeFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricRecordReferenceRangeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference_range"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}},{"kind":"Field","name":{"kind":"Name","value":"range_type"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"targets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"optimal"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"discrete_targets"}},{"kind":"Field","name":{"kind":"Name","value":"health_effects_text"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricReferenceRangeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricMatchedReferenceRangeTargetsV2Fields"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipMetricRecordRefRanges"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricRecordReferenceRangeFields"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMetricDetailsMatchedReferenceRangesQuery__
 *
 * To run a query within a React component, call `useMetricDetailsMatchedReferenceRangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricDetailsMatchedReferenceRangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricDetailsMatchedReferenceRangesQuery({
 *   variables: {
 *      metricIds: // value for 'metricIds'
 *      skipMetricRecordRefRanges: // value for 'skipMetricRecordRefRanges'
 *   },
 * });
 */
export function useMetricDetailsMatchedReferenceRangesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MetricDetailsMatchedReferenceRangesQuery, MetricDetailsMatchedReferenceRangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MetricDetailsMatchedReferenceRangesQuery, MetricDetailsMatchedReferenceRangesQueryVariables>(MetricDetailsMatchedReferenceRangesDocument, options);
      }
export function useMetricDetailsMatchedReferenceRangesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetricDetailsMatchedReferenceRangesQuery, MetricDetailsMatchedReferenceRangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MetricDetailsMatchedReferenceRangesQuery, MetricDetailsMatchedReferenceRangesQueryVariables>(MetricDetailsMatchedReferenceRangesDocument, options);
        }
export function useMetricDetailsMatchedReferenceRangesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MetricDetailsMatchedReferenceRangesQuery, MetricDetailsMatchedReferenceRangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MetricDetailsMatchedReferenceRangesQuery, MetricDetailsMatchedReferenceRangesQueryVariables>(MetricDetailsMatchedReferenceRangesDocument, options);
        }
export type MetricDetailsMatchedReferenceRangesQueryHookResult = ReturnType<typeof useMetricDetailsMatchedReferenceRangesQuery>;
export type MetricDetailsMatchedReferenceRangesLazyQueryHookResult = ReturnType<typeof useMetricDetailsMatchedReferenceRangesLazyQuery>;
export type MetricDetailsMatchedReferenceRangesSuspenseQueryHookResult = ReturnType<typeof useMetricDetailsMatchedReferenceRangesSuspenseQuery>;
export type MetricDetailsMatchedReferenceRangesQueryResult = Apollo.QueryResult<MetricDetailsMatchedReferenceRangesQuery, MetricDetailsMatchedReferenceRangesQueryVariables>;
export const MetricDetailsCmsContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MetricDetailsCmsContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metricDetailsCmsContent"},"name":{"kind":"Name","value":"cms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labTestMarkers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entity_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"full_description"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMetricDetailsCmsContentQuery__
 *
 * To run a query within a React component, call `useMetricDetailsCmsContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricDetailsCmsContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricDetailsCmsContentQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useMetricDetailsCmsContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MetricDetailsCmsContentQuery, MetricDetailsCmsContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MetricDetailsCmsContentQuery, MetricDetailsCmsContentQueryVariables>(MetricDetailsCmsContentDocument, options);
      }
export function useMetricDetailsCmsContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetricDetailsCmsContentQuery, MetricDetailsCmsContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MetricDetailsCmsContentQuery, MetricDetailsCmsContentQueryVariables>(MetricDetailsCmsContentDocument, options);
        }
export function useMetricDetailsCmsContentSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MetricDetailsCmsContentQuery, MetricDetailsCmsContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MetricDetailsCmsContentQuery, MetricDetailsCmsContentQueryVariables>(MetricDetailsCmsContentDocument, options);
        }
export type MetricDetailsCmsContentQueryHookResult = ReturnType<typeof useMetricDetailsCmsContentQuery>;
export type MetricDetailsCmsContentLazyQueryHookResult = ReturnType<typeof useMetricDetailsCmsContentLazyQuery>;
export type MetricDetailsCmsContentSuspenseQueryHookResult = ReturnType<typeof useMetricDetailsCmsContentSuspenseQuery>;
export type MetricDetailsCmsContentQueryResult = Apollo.QueryResult<MetricDetailsCmsContentQuery, MetricDetailsCmsContentQueryVariables>;
export const MetricDetailsResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MetricDetailsResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataSources"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"enum_data_source_enum"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"beforeDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latestValuesLimit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"6"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipLatestValues"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipRollupValues"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latestRollupValuesArgs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"latest_rollup_values_metric_args"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latestRollupLimit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricDetailsResultsFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricDetailsResultsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"namespace_key"}},{"kind":"Field","name":{"kind":"Name","value":"lab_test_markers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_weekly_rollup_type"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipRollupValues"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"default_rollup_interval_type"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipRollupValues"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"latest_rollup_values"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latestRollupValuesArgs"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latestRollupLimit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"interval_start"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipRollupValues"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval_start"}},{"kind":"Field","name":{"kind":"Name","value":"interval_end"}},{"kind":"Field","name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataSources"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value_type"}},{"kind":"Field","name":{"kind":"Name","value":"lab_result_marker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_optimal"}},{"kind":"Field","name":{"kind":"Name","value":"converted_value"}},{"kind":"Field","name":{"kind":"Name","value":"test"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestValues"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latestValuesLimit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"beforeDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataSources"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipLatestValues"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"value_string"}},{"kind":"Field","name":{"kind":"Name","value":"value_type"}},{"kind":"Field","name":{"kind":"Name","value":"lab_result_marker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_optimal"}},{"kind":"Field","name":{"kind":"Name","value":"converted_value"}},{"kind":"Field","name":{"kind":"Name","value":"test"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMetricDetailsResultsQuery__
 *
 * To run a query within a React component, call `useMetricDetailsResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricDetailsResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricDetailsResultsQuery({
 *   variables: {
 *      dataSources: // value for 'dataSources'
 *      metricIds: // value for 'metricIds'
 *      beforeDate: // value for 'beforeDate'
 *      latestValuesLimit: // value for 'latestValuesLimit'
 *      skipLatestValues: // value for 'skipLatestValues'
 *      skipRollupValues: // value for 'skipRollupValues'
 *      latestRollupValuesArgs: // value for 'latestRollupValuesArgs'
 *      latestRollupLimit: // value for 'latestRollupLimit'
 *   },
 * });
 */
export function useMetricDetailsResultsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MetricDetailsResultsQuery, MetricDetailsResultsQueryVariables> & ({ variables: MetricDetailsResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MetricDetailsResultsQuery, MetricDetailsResultsQueryVariables>(MetricDetailsResultsDocument, options);
      }
export function useMetricDetailsResultsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetricDetailsResultsQuery, MetricDetailsResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MetricDetailsResultsQuery, MetricDetailsResultsQueryVariables>(MetricDetailsResultsDocument, options);
        }
export function useMetricDetailsResultsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MetricDetailsResultsQuery, MetricDetailsResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MetricDetailsResultsQuery, MetricDetailsResultsQueryVariables>(MetricDetailsResultsDocument, options);
        }
export type MetricDetailsResultsQueryHookResult = ReturnType<typeof useMetricDetailsResultsQuery>;
export type MetricDetailsResultsLazyQueryHookResult = ReturnType<typeof useMetricDetailsResultsLazyQuery>;
export type MetricDetailsResultsSuspenseQueryHookResult = ReturnType<typeof useMetricDetailsResultsSuspenseQuery>;
export type MetricDetailsResultsQueryResult = Apollo.QueryResult<MetricDetailsResultsQuery, MetricDetailsResultsQueryVariables>;
export const MetricRecommendationByMetricIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MetricRecommendationByMetricId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_recommendation_items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"metricId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMetricRecommendationByMetricIdQuery__
 *
 * To run a query within a React component, call `useMetricRecommendationByMetricIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricRecommendationByMetricIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricRecommendationByMetricIdQuery({
 *   variables: {
 *      metricId: // value for 'metricId'
 *   },
 * });
 */
export function useMetricRecommendationByMetricIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MetricRecommendationByMetricIdQuery, MetricRecommendationByMetricIdQueryVariables> & ({ variables: MetricRecommendationByMetricIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MetricRecommendationByMetricIdQuery, MetricRecommendationByMetricIdQueryVariables>(MetricRecommendationByMetricIdDocument, options);
      }
export function useMetricRecommendationByMetricIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetricRecommendationByMetricIdQuery, MetricRecommendationByMetricIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MetricRecommendationByMetricIdQuery, MetricRecommendationByMetricIdQueryVariables>(MetricRecommendationByMetricIdDocument, options);
        }
export function useMetricRecommendationByMetricIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MetricRecommendationByMetricIdQuery, MetricRecommendationByMetricIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MetricRecommendationByMetricIdQuery, MetricRecommendationByMetricIdQueryVariables>(MetricRecommendationByMetricIdDocument, options);
        }
export type MetricRecommendationByMetricIdQueryHookResult = ReturnType<typeof useMetricRecommendationByMetricIdQuery>;
export type MetricRecommendationByMetricIdLazyQueryHookResult = ReturnType<typeof useMetricRecommendationByMetricIdLazyQuery>;
export type MetricRecommendationByMetricIdSuspenseQueryHookResult = ReturnType<typeof useMetricRecommendationByMetricIdSuspenseQuery>;
export type MetricRecommendationByMetricIdQueryResult = Apollo.QueryResult<MetricRecommendationByMetricIdQuery, MetricRecommendationByMetricIdQueryVariables>;
export const MostRecentPhenoAgeChronologicalAgeRecordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MostRecentPhenoAgeChronologicalAgeRecord"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"namespaceKeys"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"beforeDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace_key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"namespaceKeys"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespace_key"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"beforeDate"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preference_value"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMostRecentPhenoAgeChronologicalAgeRecordQuery__
 *
 * To run a query within a React component, call `useMostRecentPhenoAgeChronologicalAgeRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useMostRecentPhenoAgeChronologicalAgeRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMostRecentPhenoAgeChronologicalAgeRecordQuery({
 *   variables: {
 *      namespaceKeys: // value for 'namespaceKeys'
 *      beforeDate: // value for 'beforeDate'
 *   },
 * });
 */
export function useMostRecentPhenoAgeChronologicalAgeRecordQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MostRecentPhenoAgeChronologicalAgeRecordQuery, MostRecentPhenoAgeChronologicalAgeRecordQueryVariables> & ({ variables: MostRecentPhenoAgeChronologicalAgeRecordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MostRecentPhenoAgeChronologicalAgeRecordQuery, MostRecentPhenoAgeChronologicalAgeRecordQueryVariables>(MostRecentPhenoAgeChronologicalAgeRecordDocument, options);
      }
export function useMostRecentPhenoAgeChronologicalAgeRecordLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MostRecentPhenoAgeChronologicalAgeRecordQuery, MostRecentPhenoAgeChronologicalAgeRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MostRecentPhenoAgeChronologicalAgeRecordQuery, MostRecentPhenoAgeChronologicalAgeRecordQueryVariables>(MostRecentPhenoAgeChronologicalAgeRecordDocument, options);
        }
export function useMostRecentPhenoAgeChronologicalAgeRecordSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MostRecentPhenoAgeChronologicalAgeRecordQuery, MostRecentPhenoAgeChronologicalAgeRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MostRecentPhenoAgeChronologicalAgeRecordQuery, MostRecentPhenoAgeChronologicalAgeRecordQueryVariables>(MostRecentPhenoAgeChronologicalAgeRecordDocument, options);
        }
export type MostRecentPhenoAgeChronologicalAgeRecordQueryHookResult = ReturnType<typeof useMostRecentPhenoAgeChronologicalAgeRecordQuery>;
export type MostRecentPhenoAgeChronologicalAgeRecordLazyQueryHookResult = ReturnType<typeof useMostRecentPhenoAgeChronologicalAgeRecordLazyQuery>;
export type MostRecentPhenoAgeChronologicalAgeRecordSuspenseQueryHookResult = ReturnType<typeof useMostRecentPhenoAgeChronologicalAgeRecordSuspenseQuery>;
export type MostRecentPhenoAgeChronologicalAgeRecordQueryResult = Apollo.QueryResult<MostRecentPhenoAgeChronologicalAgeRecordQuery, MostRecentPhenoAgeChronologicalAgeRecordQueryVariables>;
export const DashboardMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardMetrics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tabs"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"charts"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"chart_tabs"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"chart"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"chart_tabs"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"views"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"view_metrics"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricIds"}}}]}}]}}]}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tabs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chart_tabs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chart_tabs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"views"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"view_metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_id"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useDashboardMetricsQuery__
 *
 * To run a query within a React component, call `useDashboardMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardMetricsQuery({
 *   variables: {
 *      metricIds: // value for 'metricIds'
 *   },
 * });
 */
export function useDashboardMetricsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DashboardMetricsQuery, DashboardMetricsQueryVariables> & ({ variables: DashboardMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DashboardMetricsQuery, DashboardMetricsQueryVariables>(DashboardMetricsDocument, options);
      }
export function useDashboardMetricsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DashboardMetricsQuery, DashboardMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DashboardMetricsQuery, DashboardMetricsQueryVariables>(DashboardMetricsDocument, options);
        }
export function useDashboardMetricsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DashboardMetricsQuery, DashboardMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DashboardMetricsQuery, DashboardMetricsQueryVariables>(DashboardMetricsDocument, options);
        }
export type DashboardMetricsQueryHookResult = ReturnType<typeof useDashboardMetricsQuery>;
export type DashboardMetricsLazyQueryHookResult = ReturnType<typeof useDashboardMetricsLazyQuery>;
export type DashboardMetricsSuspenseQueryHookResult = ReturnType<typeof useDashboardMetricsSuspenseQuery>;
export type DashboardMetricsQueryResult = Apollo.QueryResult<DashboardMetricsQuery, DashboardMetricsQueryVariables>;
export const CirclesRecommendationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CirclesRecommendations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"bf56e2ee-6733-4c24-a9d5-ea6f8518907b","block":false},{"kind":"StringValue","value":"0115193a-e5c9-4ea5-a98a-145f51951664","block":false},{"kind":"StringValue","value":"b82bf83b-3d68-4e5b-af4c-aae8a5a6fbaa","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hero_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCirclesRecommendationsQuery__
 *
 * To run a query within a React component, call `useCirclesRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCirclesRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCirclesRecommendationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCirclesRecommendationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CirclesRecommendationsQuery, CirclesRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CirclesRecommendationsQuery, CirclesRecommendationsQueryVariables>(CirclesRecommendationsDocument, options);
      }
export function useCirclesRecommendationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CirclesRecommendationsQuery, CirclesRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CirclesRecommendationsQuery, CirclesRecommendationsQueryVariables>(CirclesRecommendationsDocument, options);
        }
export function useCirclesRecommendationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CirclesRecommendationsQuery, CirclesRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CirclesRecommendationsQuery, CirclesRecommendationsQueryVariables>(CirclesRecommendationsDocument, options);
        }
export type CirclesRecommendationsQueryHookResult = ReturnType<typeof useCirclesRecommendationsQuery>;
export type CirclesRecommendationsLazyQueryHookResult = ReturnType<typeof useCirclesRecommendationsLazyQuery>;
export type CirclesRecommendationsSuspenseQueryHookResult = ReturnType<typeof useCirclesRecommendationsSuspenseQuery>;
export type CirclesRecommendationsQueryResult = Apollo.QueryResult<CirclesRecommendationsQuery, CirclesRecommendationsQueryVariables>;
export const UpdateUserBirthdayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserBirthday"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_of_birth"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_of_birth"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_of_birth"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date_of_birth"}}]}}]}}]}}]} as unknown as DocumentNode;
export type UpdateUserBirthdayMutationFn = Apollo.MutationFunction<UpdateUserBirthdayMutation, UpdateUserBirthdayMutationVariables>;

/**
 * __useUpdateUserBirthdayMutation__
 *
 * To run a mutation, you first call `useUpdateUserBirthdayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserBirthdayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserBirthdayMutation, { data, loading, error }] = useUpdateUserBirthdayMutation({
 *   variables: {
 *      date_of_birth: // value for 'date_of_birth'
 *   },
 * });
 */
export function useUpdateUserBirthdayMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserBirthdayMutation, UpdateUserBirthdayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserBirthdayMutation, UpdateUserBirthdayMutationVariables>(UpdateUserBirthdayDocument, options);
      }
export type UpdateUserBirthdayMutationHookResult = ReturnType<typeof useUpdateUserBirthdayMutation>;
export type UpdateUserBirthdayMutationResult = Apollo.MutationResult<UpdateUserBirthdayMutation>;
export type UpdateUserBirthdayMutationOptions = Apollo.BaseMutationOptions<UpdateUserBirthdayMutation, UpdateUserBirthdayMutationVariables>;
export const UpdateUsernameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUsername"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_of_birth"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setUserProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"date_of_birth"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_of_birth"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validation_messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode;
export type UpdateUsernameMutationFn = Apollo.MutationFunction<UpdateUsernameMutation, UpdateUsernameMutationVariables>;

/**
 * __useUpdateUsernameMutation__
 *
 * To run a mutation, you first call `useUpdateUsernameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUsernameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUsernameMutation, { data, loading, error }] = useUpdateUsernameMutation({
 *   variables: {
 *      username: // value for 'username'
 *      email: // value for 'email'
 *      date_of_birth: // value for 'date_of_birth'
 *   },
 * });
 */
export function useUpdateUsernameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUsernameMutation, UpdateUsernameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUsernameMutation, UpdateUsernameMutationVariables>(UpdateUsernameDocument, options);
      }
export type UpdateUsernameMutationHookResult = ReturnType<typeof useUpdateUsernameMutation>;
export type UpdateUsernameMutationResult = Apollo.MutationResult<UpdateUsernameMutation>;
export type UpdateUsernameMutationOptions = Apollo.BaseMutationOptions<UpdateUsernameMutation, UpdateUsernameMutationVariables>;
export const SetMetricUnitPreferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetMetricUnitPreference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"set_metric_unit_preference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metricId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"preferenceUnit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unit"}}}]}}]}]}}]} as unknown as DocumentNode;
export type SetMetricUnitPreferenceMutationFn = Apollo.MutationFunction<SetMetricUnitPreferenceMutation, SetMetricUnitPreferenceMutationVariables>;

/**
 * __useSetMetricUnitPreferenceMutation__
 *
 * To run a mutation, you first call `useSetMetricUnitPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMetricUnitPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMetricUnitPreferenceMutation, { data, loading, error }] = useSetMetricUnitPreferenceMutation({
 *   variables: {
 *      metricId: // value for 'metricId'
 *      unit: // value for 'unit'
 *   },
 * });
 */
export function useSetMetricUnitPreferenceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetMetricUnitPreferenceMutation, SetMetricUnitPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetMetricUnitPreferenceMutation, SetMetricUnitPreferenceMutationVariables>(SetMetricUnitPreferenceDocument, options);
      }
export type SetMetricUnitPreferenceMutationHookResult = ReturnType<typeof useSetMetricUnitPreferenceMutation>;
export type SetMetricUnitPreferenceMutationResult = Apollo.MutationResult<SetMetricUnitPreferenceMutation>;
export type SetMetricUnitPreferenceMutationOptions = Apollo.BaseMutationOptions<SetMetricUnitPreferenceMutation, SetMetricUnitPreferenceMutationVariables>;
export const SetUserTimezoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetUserTimezone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_timezone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"timezone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}}}]}]}}]} as unknown as DocumentNode;
export type SetUserTimezoneMutationFn = Apollo.MutationFunction<SetUserTimezoneMutation, SetUserTimezoneMutationVariables>;

/**
 * __useSetUserTimezoneMutation__
 *
 * To run a mutation, you first call `useSetUserTimezoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserTimezoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserTimezoneMutation, { data, loading, error }] = useSetUserTimezoneMutation({
 *   variables: {
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useSetUserTimezoneMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetUserTimezoneMutation, SetUserTimezoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetUserTimezoneMutation, SetUserTimezoneMutationVariables>(SetUserTimezoneDocument, options);
      }
export type SetUserTimezoneMutationHookResult = ReturnType<typeof useSetUserTimezoneMutation>;
export type SetUserTimezoneMutationResult = Apollo.MutationResult<SetUserTimezoneMutation>;
export type SetUserTimezoneMutationOptions = Apollo.BaseMutationOptions<SetUserTimezoneMutation, SetUserTimezoneMutationVariables>;
export const UpdateHomeTilesSortOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateHomeTilesSortOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_home_tile_updates"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user_home_tile_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}},{"kind":"Field","name":{"kind":"Name","value":"home_tile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export type UpdateHomeTilesSortOrderMutationFn = Apollo.MutationFunction<UpdateHomeTilesSortOrderMutation, UpdateHomeTilesSortOrderMutationVariables>;

/**
 * __useUpdateHomeTilesSortOrderMutation__
 *
 * To run a mutation, you first call `useUpdateHomeTilesSortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHomeTilesSortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHomeTilesSortOrderMutation, { data, loading, error }] = useUpdateHomeTilesSortOrderMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateHomeTilesSortOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateHomeTilesSortOrderMutation, UpdateHomeTilesSortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateHomeTilesSortOrderMutation, UpdateHomeTilesSortOrderMutationVariables>(UpdateHomeTilesSortOrderDocument, options);
      }
export type UpdateHomeTilesSortOrderMutationHookResult = ReturnType<typeof useUpdateHomeTilesSortOrderMutation>;
export type UpdateHomeTilesSortOrderMutationResult = Apollo.MutationResult<UpdateHomeTilesSortOrderMutation>;
export type UpdateHomeTilesSortOrderMutationOptions = Apollo.BaseMutationOptions<UpdateHomeTilesSortOrderMutation, UpdateHomeTilesSortOrderMutationVariables>;
export const CancelMembershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelMembership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cancellationReason"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancel_membership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cancellationReason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cancellationReason"}}},{"kind":"Argument","name":{"kind":"Name","value":"subscriptionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionId"}}}]}]}}]} as unknown as DocumentNode;
export type CancelMembershipMutationFn = Apollo.MutationFunction<CancelMembershipMutation, CancelMembershipMutationVariables>;

/**
 * __useCancelMembershipMutation__
 *
 * To run a mutation, you first call `useCancelMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMembershipMutation, { data, loading, error }] = useCancelMembershipMutation({
 *   variables: {
 *      cancellationReason: // value for 'cancellationReason'
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useCancelMembershipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelMembershipMutation, CancelMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelMembershipMutation, CancelMembershipMutationVariables>(CancelMembershipDocument, options);
      }
export type CancelMembershipMutationHookResult = ReturnType<typeof useCancelMembershipMutation>;
export type CancelMembershipMutationResult = Apollo.MutationResult<CancelMembershipMutation>;
export type CancelMembershipMutationOptions = Apollo.BaseMutationOptions<CancelMembershipMutation, CancelMembershipMutationVariables>;
export const CreateSelfdecodeProfileAndAcceptTosProfilePageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSelfdecodeProfileAndAcceptTosProfilePage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateLabProfileInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipRealizeTos"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"realizeTosVersion"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isLabAvailableInOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_lab_profile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"isLabAvailableInOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isLabAvailableInOrder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"birthDate"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}}]}},{"kind":"Field","name":{"kind":"Name","value":"acceptTermsOfService"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"realizeTosVersion"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipRealizeTos"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}}]}}]}}]} as unknown as DocumentNode;
export type CreateSelfdecodeProfileAndAcceptTosProfilePageMutationFn = Apollo.MutationFunction<CreateSelfdecodeProfileAndAcceptTosProfilePageMutation, CreateSelfdecodeProfileAndAcceptTosProfilePageMutationVariables>;

/**
 * __useCreateSelfdecodeProfileAndAcceptTosProfilePageMutation__
 *
 * To run a mutation, you first call `useCreateSelfdecodeProfileAndAcceptTosProfilePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSelfdecodeProfileAndAcceptTosProfilePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSelfdecodeProfileAndAcceptTosProfilePageMutation, { data, loading, error }] = useCreateSelfdecodeProfileAndAcceptTosProfilePageMutation({
 *   variables: {
 *      input: // value for 'input'
 *      skipRealizeTos: // value for 'skipRealizeTos'
 *      realizeTosVersion: // value for 'realizeTosVersion'
 *      isLabAvailableInOrder: // value for 'isLabAvailableInOrder'
 *   },
 * });
 */
export function useCreateSelfdecodeProfileAndAcceptTosProfilePageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSelfdecodeProfileAndAcceptTosProfilePageMutation, CreateSelfdecodeProfileAndAcceptTosProfilePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSelfdecodeProfileAndAcceptTosProfilePageMutation, CreateSelfdecodeProfileAndAcceptTosProfilePageMutationVariables>(CreateSelfdecodeProfileAndAcceptTosProfilePageDocument, options);
      }
export type CreateSelfdecodeProfileAndAcceptTosProfilePageMutationHookResult = ReturnType<typeof useCreateSelfdecodeProfileAndAcceptTosProfilePageMutation>;
export type CreateSelfdecodeProfileAndAcceptTosProfilePageMutationResult = Apollo.MutationResult<CreateSelfdecodeProfileAndAcceptTosProfilePageMutation>;
export type CreateSelfdecodeProfileAndAcceptTosProfilePageMutationOptions = Apollo.BaseMutationOptions<CreateSelfdecodeProfileAndAcceptTosProfilePageMutation, CreateSelfdecodeProfileAndAcceptTosProfilePageMutationVariables>;
export const MetricTargetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MetricTargets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preference_target"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"interval_count"}},{"kind":"Field","name":{"kind":"Name","value":"interval_type"}},{"kind":"Field","name":{"kind":"Name","value":"aggregate_type"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMetricTargetsQuery__
 *
 * To run a query within a React component, call `useMetricTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricTargetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMetricTargetsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MetricTargetsQuery, MetricTargetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MetricTargetsQuery, MetricTargetsQueryVariables>(MetricTargetsDocument, options);
      }
export function useMetricTargetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetricTargetsQuery, MetricTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MetricTargetsQuery, MetricTargetsQueryVariables>(MetricTargetsDocument, options);
        }
export function useMetricTargetsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MetricTargetsQuery, MetricTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MetricTargetsQuery, MetricTargetsQueryVariables>(MetricTargetsDocument, options);
        }
export type MetricTargetsQueryHookResult = ReturnType<typeof useMetricTargetsQuery>;
export type MetricTargetsLazyQueryHookResult = ReturnType<typeof useMetricTargetsLazyQuery>;
export type MetricTargetsSuspenseQueryHookResult = ReturnType<typeof useMetricTargetsSuspenseQuery>;
export type MetricTargetsQueryResult = Apollo.QueryResult<MetricTargetsQuery, MetricTargetsQueryVariables>;
export const DeleteMetricTargetByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMetricTargetById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_metric_target_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type DeleteMetricTargetByIdMutationFn = Apollo.MutationFunction<DeleteMetricTargetByIdMutation, DeleteMetricTargetByIdMutationVariables>;

/**
 * __useDeleteMetricTargetByIdMutation__
 *
 * To run a mutation, you first call `useDeleteMetricTargetByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMetricTargetByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMetricTargetByIdMutation, { data, loading, error }] = useDeleteMetricTargetByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMetricTargetByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMetricTargetByIdMutation, DeleteMetricTargetByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMetricTargetByIdMutation, DeleteMetricTargetByIdMutationVariables>(DeleteMetricTargetByIdDocument, options);
      }
export type DeleteMetricTargetByIdMutationHookResult = ReturnType<typeof useDeleteMetricTargetByIdMutation>;
export type DeleteMetricTargetByIdMutationResult = Apollo.MutationResult<DeleteMetricTargetByIdMutation>;
export type DeleteMetricTargetByIdMutationOptions = Apollo.BaseMutationOptions<DeleteMetricTargetByIdMutation, DeleteMetricTargetByIdMutationVariables>;
export const ActionItemLibraryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActionItemLibrary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionItemWhereClause"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"action_item_bool_exp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"action_item"},"name":{"kind":"Name","value":"action_item_library"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionItemWhereClause"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","alias":{"kind":"Name","value":"value_target"},"name":{"kind":"Name","value":"preference_value_target"}},{"kind":"Field","name":{"kind":"Name","value":"instance_target"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prevent_add_to_circle"}},{"kind":"Field","name":{"kind":"Name","value":"prevent_add_to_circle_reason"}},{"kind":"Field","name":{"kind":"Name","value":"name_show_placeholders"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logger_type"}},{"kind":"Field","name":{"kind":"Name","value":"interval_type"}},{"kind":"Field","name":{"kind":"Name","value":"interval_count"}},{"kind":"Field","name":{"kind":"Name","value":"value_rollup_type"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}},{"kind":"Field","name":{"kind":"Name","value":"display_symbol_plural"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name_plural"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_item_inputs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActionItemInputFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_item_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"personalized_name"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logger_type"}},{"kind":"Field","name":{"kind":"Name","value":"weekly_instance_target"}},{"kind":"Field","name":{"kind":"Name","value":"interval_type"}},{"kind":"Field","name":{"kind":"Name","value":"interval_count"}},{"kind":"Field","name":{"kind":"Name","value":"value_rollup_type"}},{"kind":"Field","alias":{"kind":"Name","value":"value_target"},"name":{"kind":"Name","value":"preference_value_target"}},{"kind":"Field","name":{"kind":"Name","value":"instance_target"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}},{"kind":"Field","name":{"kind":"Name","value":"action_item_user_inputs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"action_item_user_supplements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"servings"}},{"kind":"Field","name":{"kind":"Name","value":"supplement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_item_input"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActionItemInputFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"circle_membership_action_items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"circle_membership"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circle_membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_owner"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionItemInputFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action_item_input"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"input_type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useActionItemLibraryQuery__
 *
 * To run a query within a React component, call `useActionItemLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionItemLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionItemLibraryQuery({
 *   variables: {
 *      actionItemWhereClause: // value for 'actionItemWhereClause'
 *   },
 * });
 */
export function useActionItemLibraryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActionItemLibraryQuery, ActionItemLibraryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActionItemLibraryQuery, ActionItemLibraryQueryVariables>(ActionItemLibraryDocument, options);
      }
export function useActionItemLibraryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActionItemLibraryQuery, ActionItemLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActionItemLibraryQuery, ActionItemLibraryQueryVariables>(ActionItemLibraryDocument, options);
        }
export function useActionItemLibrarySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ActionItemLibraryQuery, ActionItemLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ActionItemLibraryQuery, ActionItemLibraryQueryVariables>(ActionItemLibraryDocument, options);
        }
export type ActionItemLibraryQueryHookResult = ReturnType<typeof useActionItemLibraryQuery>;
export type ActionItemLibraryLazyQueryHookResult = ReturnType<typeof useActionItemLibraryLazyQuery>;
export type ActionItemLibrarySuspenseQueryHookResult = ReturnType<typeof useActionItemLibrarySuspenseQuery>;
export type ActionItemLibraryQueryResult = Apollo.QueryResult<ActionItemLibraryQuery, ActionItemLibraryQueryVariables>;
export const CircleMemberDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CircleMemberDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weekStart"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"membershipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circle_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"membershipId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"membership_action_item"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"circle_action_item"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_item_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"interval_type"}},{"kind":"Field","name":{"kind":"Name","value":"instance_target"}},{"kind":"Field","name":{"kind":"Name","value":"instance_target_type"}},{"kind":"Field","name":{"kind":"Name","value":"preference_value_target"}},{"kind":"Field","name":{"kind":"Name","value":"value_rollup_type"}},{"kind":"Field","name":{"kind":"Name","value":"action_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preference_value_target"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}},{"kind":"Field","name":{"kind":"Name","value":"display_symbol_plural"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name_plural"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"week"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weekStart"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dailies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"targetMet"}},{"kind":"Field","name":{"kind":"Name","value":"hasRecords"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCircleMemberDetailQuery__
 *
 * To run a query within a React component, call `useCircleMemberDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCircleMemberDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCircleMemberDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      weekStart: // value for 'weekStart'
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useCircleMemberDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CircleMemberDetailQuery, CircleMemberDetailQueryVariables> & ({ variables: CircleMemberDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CircleMemberDetailQuery, CircleMemberDetailQueryVariables>(CircleMemberDetailDocument, options);
      }
export function useCircleMemberDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CircleMemberDetailQuery, CircleMemberDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CircleMemberDetailQuery, CircleMemberDetailQueryVariables>(CircleMemberDetailDocument, options);
        }
export function useCircleMemberDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CircleMemberDetailQuery, CircleMemberDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CircleMemberDetailQuery, CircleMemberDetailQueryVariables>(CircleMemberDetailDocument, options);
        }
export type CircleMemberDetailQueryHookResult = ReturnType<typeof useCircleMemberDetailQuery>;
export type CircleMemberDetailLazyQueryHookResult = ReturnType<typeof useCircleMemberDetailLazyQuery>;
export type CircleMemberDetailSuspenseQueryHookResult = ReturnType<typeof useCircleMemberDetailSuspenseQuery>;
export type CircleMemberDetailQueryResult = Apollo.QueryResult<CircleMemberDetailQuery, CircleMemberDetailQueryVariables>;
export const ActionItemsForPreviousWeekDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActionItemsForPreviousWeek"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"week"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"action_items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"week"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"week"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dailies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preferenceValue"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useActionItemsForPreviousWeekQuery__
 *
 * To run a query within a React component, call `useActionItemsForPreviousWeekQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionItemsForPreviousWeekQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionItemsForPreviousWeekQuery({
 *   variables: {
 *      week: // value for 'week'
 *   },
 * });
 */
export function useActionItemsForPreviousWeekQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ActionItemsForPreviousWeekQuery, ActionItemsForPreviousWeekQueryVariables> & ({ variables: ActionItemsForPreviousWeekQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActionItemsForPreviousWeekQuery, ActionItemsForPreviousWeekQueryVariables>(ActionItemsForPreviousWeekDocument, options);
      }
export function useActionItemsForPreviousWeekLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActionItemsForPreviousWeekQuery, ActionItemsForPreviousWeekQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActionItemsForPreviousWeekQuery, ActionItemsForPreviousWeekQueryVariables>(ActionItemsForPreviousWeekDocument, options);
        }
export function useActionItemsForPreviousWeekSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ActionItemsForPreviousWeekQuery, ActionItemsForPreviousWeekQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ActionItemsForPreviousWeekQuery, ActionItemsForPreviousWeekQueryVariables>(ActionItemsForPreviousWeekDocument, options);
        }
export type ActionItemsForPreviousWeekQueryHookResult = ReturnType<typeof useActionItemsForPreviousWeekQuery>;
export type ActionItemsForPreviousWeekLazyQueryHookResult = ReturnType<typeof useActionItemsForPreviousWeekLazyQuery>;
export type ActionItemsForPreviousWeekSuspenseQueryHookResult = ReturnType<typeof useActionItemsForPreviousWeekSuspenseQuery>;
export type ActionItemsForPreviousWeekQueryResult = Apollo.QueryResult<ActionItemsForPreviousWeekQuery, ActionItemsForPreviousWeekQueryVariables>;
export const SleepCircleJoinDateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SleepCircleJoinDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"circle_memberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"circle"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"StringValue","value":"%Sleep Improvement%","block":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"joined_at"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useSleepCircleJoinDateQuery__
 *
 * To run a query within a React component, call `useSleepCircleJoinDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSleepCircleJoinDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSleepCircleJoinDateQuery({
 *   variables: {
 *   },
 * });
 */
export function useSleepCircleJoinDateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SleepCircleJoinDateQuery, SleepCircleJoinDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SleepCircleJoinDateQuery, SleepCircleJoinDateQueryVariables>(SleepCircleJoinDateDocument, options);
      }
export function useSleepCircleJoinDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SleepCircleJoinDateQuery, SleepCircleJoinDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SleepCircleJoinDateQuery, SleepCircleJoinDateQueryVariables>(SleepCircleJoinDateDocument, options);
        }
export function useSleepCircleJoinDateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SleepCircleJoinDateQuery, SleepCircleJoinDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SleepCircleJoinDateQuery, SleepCircleJoinDateQueryVariables>(SleepCircleJoinDateDocument, options);
        }
export type SleepCircleJoinDateQueryHookResult = ReturnType<typeof useSleepCircleJoinDateQuery>;
export type SleepCircleJoinDateLazyQueryHookResult = ReturnType<typeof useSleepCircleJoinDateLazyQuery>;
export type SleepCircleJoinDateSuspenseQueryHookResult = ReturnType<typeof useSleepCircleJoinDateSuspenseQuery>;
export type SleepCircleJoinDateQueryResult = Apollo.QueryResult<SleepCircleJoinDateQuery, SleepCircleJoinDateQueryVariables>;
export const SleepImprovementWeeklyComparisonRecordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SleepImprovementWeeklyComparisonRecords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"Sleep_Score"},"name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric_records"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"oura"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"namespace_key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_READINESS:SCORE_%","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricMetricRecordsRollupFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"Average_HRV"},"name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric_records"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"oura"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"namespace_key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"SLEEP:HRV_RMSSD_AVERAGE","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricMetricRecordsRollupFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"Deep_Sleep"},"name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric_records"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"oura"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"namespace_key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"SLEEP:DURATION_DEEP","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricMetricRecordsRollupFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"REM_Sleep"},"name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric_records"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"oura"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"namespace_key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"SLEEP:DURATION_REM","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricMetricRecordsRollupFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"Total_Sleep"},"name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric_records"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"oura"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"namespace_key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"SLEEP:DURATION_TOTAL","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricMetricRecordsRollupFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricMetricRecordsRollupFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric_records_rollup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"Argument","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"Argument","name":{"kind":"Name","value":"interval_type"},"value":{"kind":"EnumValue","value":"day"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval_start"}},{"kind":"Field","name":{"kind":"Name","value":"preference_avg"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useSleepImprovementWeeklyComparisonRecordsQuery__
 *
 * To run a query within a React component, call `useSleepImprovementWeeklyComparisonRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSleepImprovementWeeklyComparisonRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSleepImprovementWeeklyComparisonRecordsQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useSleepImprovementWeeklyComparisonRecordsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SleepImprovementWeeklyComparisonRecordsQuery, SleepImprovementWeeklyComparisonRecordsQueryVariables> & ({ variables: SleepImprovementWeeklyComparisonRecordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SleepImprovementWeeklyComparisonRecordsQuery, SleepImprovementWeeklyComparisonRecordsQueryVariables>(SleepImprovementWeeklyComparisonRecordsDocument, options);
      }
export function useSleepImprovementWeeklyComparisonRecordsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SleepImprovementWeeklyComparisonRecordsQuery, SleepImprovementWeeklyComparisonRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SleepImprovementWeeklyComparisonRecordsQuery, SleepImprovementWeeklyComparisonRecordsQueryVariables>(SleepImprovementWeeklyComparisonRecordsDocument, options);
        }
export function useSleepImprovementWeeklyComparisonRecordsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SleepImprovementWeeklyComparisonRecordsQuery, SleepImprovementWeeklyComparisonRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SleepImprovementWeeklyComparisonRecordsQuery, SleepImprovementWeeklyComparisonRecordsQueryVariables>(SleepImprovementWeeklyComparisonRecordsDocument, options);
        }
export type SleepImprovementWeeklyComparisonRecordsQueryHookResult = ReturnType<typeof useSleepImprovementWeeklyComparisonRecordsQuery>;
export type SleepImprovementWeeklyComparisonRecordsLazyQueryHookResult = ReturnType<typeof useSleepImprovementWeeklyComparisonRecordsLazyQuery>;
export type SleepImprovementWeeklyComparisonRecordsSuspenseQueryHookResult = ReturnType<typeof useSleepImprovementWeeklyComparisonRecordsSuspenseQuery>;
export type SleepImprovementWeeklyComparisonRecordsQueryResult = Apollo.QueryResult<SleepImprovementWeeklyComparisonRecordsQuery, SleepImprovementWeeklyComparisonRecordsQueryVariables>;
export const LoggedItemAchievementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoggedItemAchievement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"achievements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"achievement_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"logged-item-1","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"achievement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity_id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useLoggedItemAchievementQuery__
 *
 * To run a query within a React component, call `useLoggedItemAchievementQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoggedItemAchievementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoggedItemAchievementQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoggedItemAchievementQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LoggedItemAchievementQuery, LoggedItemAchievementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LoggedItemAchievementQuery, LoggedItemAchievementQueryVariables>(LoggedItemAchievementDocument, options);
      }
export function useLoggedItemAchievementLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LoggedItemAchievementQuery, LoggedItemAchievementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LoggedItemAchievementQuery, LoggedItemAchievementQueryVariables>(LoggedItemAchievementDocument, options);
        }
export function useLoggedItemAchievementSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LoggedItemAchievementQuery, LoggedItemAchievementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LoggedItemAchievementQuery, LoggedItemAchievementQueryVariables>(LoggedItemAchievementDocument, options);
        }
export type LoggedItemAchievementQueryHookResult = ReturnType<typeof useLoggedItemAchievementQuery>;
export type LoggedItemAchievementLazyQueryHookResult = ReturnType<typeof useLoggedItemAchievementLazyQuery>;
export type LoggedItemAchievementSuspenseQueryHookResult = ReturnType<typeof useLoggedItemAchievementSuspenseQuery>;
export type LoggedItemAchievementQueryResult = Apollo.QueryResult<LoggedItemAchievementQuery, LoggedItemAchievementQueryVariables>;
export const FeaturedActionitemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FeaturedActionitems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"report_featured"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity_id"}},{"kind":"Field","name":{"kind":"Name","value":"report_summary"}},{"kind":"Field","name":{"kind":"Name","value":"hero_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useFeaturedActionitemsQuery__
 *
 * To run a query within a React component, call `useFeaturedActionitemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturedActionitemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturedActionitemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeaturedActionitemsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FeaturedActionitemsQuery, FeaturedActionitemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FeaturedActionitemsQuery, FeaturedActionitemsQueryVariables>(FeaturedActionitemsDocument, options);
      }
export function useFeaturedActionitemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeaturedActionitemsQuery, FeaturedActionitemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FeaturedActionitemsQuery, FeaturedActionitemsQueryVariables>(FeaturedActionitemsDocument, options);
        }
export function useFeaturedActionitemsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FeaturedActionitemsQuery, FeaturedActionitemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FeaturedActionitemsQuery, FeaturedActionitemsQueryVariables>(FeaturedActionitemsDocument, options);
        }
export type FeaturedActionitemsQueryHookResult = ReturnType<typeof useFeaturedActionitemsQuery>;
export type FeaturedActionitemsLazyQueryHookResult = ReturnType<typeof useFeaturedActionitemsLazyQuery>;
export type FeaturedActionitemsSuspenseQueryHookResult = ReturnType<typeof useFeaturedActionitemsSuspenseQuery>;
export type FeaturedActionitemsQueryResult = Apollo.QueryResult<FeaturedActionitemsQuery, FeaturedActionitemsQueryVariables>;
export const InsertUserAchievementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertUserAchievement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"achievementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_user_achievement_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"achievement_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"achievementId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type InsertUserAchievementMutationFn = Apollo.MutationFunction<InsertUserAchievementMutation, InsertUserAchievementMutationVariables>;

/**
 * __useInsertUserAchievementMutation__
 *
 * To run a mutation, you first call `useInsertUserAchievementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUserAchievementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUserAchievementMutation, { data, loading, error }] = useInsertUserAchievementMutation({
 *   variables: {
 *      achievementId: // value for 'achievementId'
 *   },
 * });
 */
export function useInsertUserAchievementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertUserAchievementMutation, InsertUserAchievementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InsertUserAchievementMutation, InsertUserAchievementMutationVariables>(InsertUserAchievementDocument, options);
      }
export type InsertUserAchievementMutationHookResult = ReturnType<typeof useInsertUserAchievementMutation>;
export type InsertUserAchievementMutationResult = Apollo.MutationResult<InsertUserAchievementMutation>;
export type InsertUserAchievementMutationOptions = Apollo.BaseMutationOptions<InsertUserAchievementMutation, InsertUserAchievementMutationVariables>;
export const WeeklyUserActionPlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WeeklyUserActionPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"begin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"week"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"me"},"name":{"kind":"Name","value":"me_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"action_items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logger_type"}},{"kind":"Field","name":{"kind":"Name","value":"instance_target_type"}},{"kind":"Field","name":{"kind":"Name","value":"interval_type"}},{"kind":"Field","name":{"kind":"Name","value":"interval_count"}},{"kind":"Field","name":{"kind":"Name","value":"value_rollup_type"}},{"kind":"Field","name":{"kind":"Name","value":"instance_target"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}},{"kind":"Field","name":{"kind":"Name","value":"action_item_user_inputs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_item_input"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}},{"kind":"Field","name":{"kind":"Name","value":"metric_id"}},{"kind":"Field","name":{"kind":"Name","value":"input_type"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespace_key"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_item_user_supplements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"supplement"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_supplements"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"disabled"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplement_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"begin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"servings"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"timeframe"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"servings"}},{"kind":"Field","name":{"kind":"Name","value":"supplement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serving_size"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeframe"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}},{"kind":"Field","name":{"kind":"Name","value":"display_symbol_plural"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name_plural"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"week"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"week"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"week"}},{"kind":"Field","name":{"kind":"Name","value":"periodStart"}},{"kind":"Field","name":{"kind":"Name","value":"periodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"instanceTarget"}},{"kind":"Field","name":{"kind":"Name","value":"instanceTargetType"}},{"kind":"Field","name":{"kind":"Name","value":"weeklyInstanceTarget"}},{"kind":"Field","name":{"kind":"Name","value":"preferenceValueTarget"}},{"kind":"Field","name":{"kind":"Name","value":"dailies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preferenceValue"}},{"kind":"Field","name":{"kind":"Name","value":"targetMet"}},{"kind":"Field","alias":{"kind":"Name","value":"target"},"name":{"kind":"Name","value":"preferenceTarget"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricRecordId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"circle_membership_action_items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"circle_membership"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circle_membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useWeeklyUserActionPlanQuery__
 *
 * To run a query within a React component, call `useWeeklyUserActionPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeeklyUserActionPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeeklyUserActionPlanQuery({
 *   variables: {
 *      begin: // value for 'begin'
 *      end: // value for 'end'
 *      week: // value for 'week'
 *   },
 * });
 */
export function useWeeklyUserActionPlanQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WeeklyUserActionPlanQuery, WeeklyUserActionPlanQueryVariables> & ({ variables: WeeklyUserActionPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WeeklyUserActionPlanQuery, WeeklyUserActionPlanQueryVariables>(WeeklyUserActionPlanDocument, options);
      }
export function useWeeklyUserActionPlanLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WeeklyUserActionPlanQuery, WeeklyUserActionPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WeeklyUserActionPlanQuery, WeeklyUserActionPlanQueryVariables>(WeeklyUserActionPlanDocument, options);
        }
export function useWeeklyUserActionPlanSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WeeklyUserActionPlanQuery, WeeklyUserActionPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WeeklyUserActionPlanQuery, WeeklyUserActionPlanQueryVariables>(WeeklyUserActionPlanDocument, options);
        }
export type WeeklyUserActionPlanQueryHookResult = ReturnType<typeof useWeeklyUserActionPlanQuery>;
export type WeeklyUserActionPlanLazyQueryHookResult = ReturnType<typeof useWeeklyUserActionPlanLazyQuery>;
export type WeeklyUserActionPlanSuspenseQueryHookResult = ReturnType<typeof useWeeklyUserActionPlanSuspenseQuery>;
export type WeeklyUserActionPlanQueryResult = Apollo.QueryResult<WeeklyUserActionPlanQuery, WeeklyUserActionPlanQueryVariables>;
export const RecordActionItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordActionItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordActionItemUserInstanceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record_action_item_user_instance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetMet"}}]}}]}}]} as unknown as DocumentNode;
export type RecordActionItemMutationFn = Apollo.MutationFunction<RecordActionItemMutation, RecordActionItemMutationVariables>;

/**
 * __useRecordActionItemMutation__
 *
 * To run a mutation, you first call `useRecordActionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordActionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordActionItemMutation, { data, loading, error }] = useRecordActionItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordActionItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RecordActionItemMutation, RecordActionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RecordActionItemMutation, RecordActionItemMutationVariables>(RecordActionItemDocument, options);
      }
export type RecordActionItemMutationHookResult = ReturnType<typeof useRecordActionItemMutation>;
export type RecordActionItemMutationResult = Apollo.MutationResult<RecordActionItemMutation>;
export type RecordActionItemMutationOptions = Apollo.BaseMutationOptions<RecordActionItemMutation, RecordActionItemMutationVariables>;
export const ClearActionItemRecordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClearActionItemRecords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClearActionItemUserInstanceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clear_action_item_user_instance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetMet"}}]}}]}}]} as unknown as DocumentNode;
export type ClearActionItemRecordsMutationFn = Apollo.MutationFunction<ClearActionItemRecordsMutation, ClearActionItemRecordsMutationVariables>;

/**
 * __useClearActionItemRecordsMutation__
 *
 * To run a mutation, you first call `useClearActionItemRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearActionItemRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearActionItemRecordsMutation, { data, loading, error }] = useClearActionItemRecordsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClearActionItemRecordsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ClearActionItemRecordsMutation, ClearActionItemRecordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ClearActionItemRecordsMutation, ClearActionItemRecordsMutationVariables>(ClearActionItemRecordsDocument, options);
      }
export type ClearActionItemRecordsMutationHookResult = ReturnType<typeof useClearActionItemRecordsMutation>;
export type ClearActionItemRecordsMutationResult = Apollo.MutationResult<ClearActionItemRecordsMutation>;
export type ClearActionItemRecordsMutationOptions = Apollo.BaseMutationOptions<ClearActionItemRecordsMutation, ClearActionItemRecordsMutationVariables>;
export const WorkoutsByMetricRecordIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkoutsByMetricRecordIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workoutMetricRecordIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_record_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric_records"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workoutMetricRecordIds"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}},{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespace_key"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useWorkoutsByMetricRecordIdsQuery__
 *
 * To run a query within a React component, call `useWorkoutsByMetricRecordIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkoutsByMetricRecordIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkoutsByMetricRecordIdsQuery({
 *   variables: {
 *      workoutMetricRecordIds: // value for 'workoutMetricRecordIds'
 *   },
 * });
 */
export function useWorkoutsByMetricRecordIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WorkoutsByMetricRecordIdsQuery, WorkoutsByMetricRecordIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkoutsByMetricRecordIdsQuery, WorkoutsByMetricRecordIdsQueryVariables>(WorkoutsByMetricRecordIdsDocument, options);
      }
export function useWorkoutsByMetricRecordIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkoutsByMetricRecordIdsQuery, WorkoutsByMetricRecordIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkoutsByMetricRecordIdsQuery, WorkoutsByMetricRecordIdsQueryVariables>(WorkoutsByMetricRecordIdsDocument, options);
        }
export function useWorkoutsByMetricRecordIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WorkoutsByMetricRecordIdsQuery, WorkoutsByMetricRecordIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WorkoutsByMetricRecordIdsQuery, WorkoutsByMetricRecordIdsQueryVariables>(WorkoutsByMetricRecordIdsDocument, options);
        }
export type WorkoutsByMetricRecordIdsQueryHookResult = ReturnType<typeof useWorkoutsByMetricRecordIdsQuery>;
export type WorkoutsByMetricRecordIdsLazyQueryHookResult = ReturnType<typeof useWorkoutsByMetricRecordIdsLazyQuery>;
export type WorkoutsByMetricRecordIdsSuspenseQueryHookResult = ReturnType<typeof useWorkoutsByMetricRecordIdsSuspenseQuery>;
export type WorkoutsByMetricRecordIdsQueryResult = Apollo.QueryResult<WorkoutsByMetricRecordIdsQuery, WorkoutsByMetricRecordIdsQueryVariables>;
export const SelectActionItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SelectActionItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instanceTarget"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NumericRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"valueTarget"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NumericRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionItemInputIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"intervalType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"enum_rollup_interval_type_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplements"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionItemSupplementInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"removedActionItemUserSupplementIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"select_action_item"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"actionItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionItemId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"instanceTarget"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instanceTarget"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"intervalType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"intervalType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"actionItemInputIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionItemInputIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"valueTarget"},"value":{"kind":"Variable","name":{"kind":"Name","value":"valueTarget"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"supplements"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplements"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"useExisting"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"delete_action_item_user_supplement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"removedActionItemUserSupplementIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode;
export type SelectActionItemMutationFn = Apollo.MutationFunction<SelectActionItemMutation, SelectActionItemMutationVariables>;

/**
 * __useSelectActionItemMutation__
 *
 * To run a mutation, you first call `useSelectActionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectActionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectActionItemMutation, { data, loading, error }] = useSelectActionItemMutation({
 *   variables: {
 *      actionItemId: // value for 'actionItemId'
 *      instanceTarget: // value for 'instanceTarget'
 *      valueTarget: // value for 'valueTarget'
 *      actionItemInputIds: // value for 'actionItemInputIds'
 *      intervalType: // value for 'intervalType'
 *      supplements: // value for 'supplements'
 *      removedActionItemUserSupplementIds: // value for 'removedActionItemUserSupplementIds'
 *   },
 * });
 */
export function useSelectActionItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SelectActionItemMutation, SelectActionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SelectActionItemMutation, SelectActionItemMutationVariables>(SelectActionItemDocument, options);
      }
export type SelectActionItemMutationHookResult = ReturnType<typeof useSelectActionItemMutation>;
export type SelectActionItemMutationResult = Apollo.MutationResult<SelectActionItemMutation>;
export type SelectActionItemMutationOptions = Apollo.BaseMutationOptions<SelectActionItemMutation, SelectActionItemMutationVariables>;
export const CreateCustomActionItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCustomActionItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionItem"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"action_item_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_action_item_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionItem"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"interval_type"}}]}}]}}]} as unknown as DocumentNode;
export type CreateCustomActionItemMutationFn = Apollo.MutationFunction<CreateCustomActionItemMutation, CreateCustomActionItemMutationVariables>;

/**
 * __useCreateCustomActionItemMutation__
 *
 * To run a mutation, you first call `useCreateCustomActionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomActionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomActionItemMutation, { data, loading, error }] = useCreateCustomActionItemMutation({
 *   variables: {
 *      actionItem: // value for 'actionItem'
 *   },
 * });
 */
export function useCreateCustomActionItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCustomActionItemMutation, CreateCustomActionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCustomActionItemMutation, CreateCustomActionItemMutationVariables>(CreateCustomActionItemDocument, options);
      }
export type CreateCustomActionItemMutationHookResult = ReturnType<typeof useCreateCustomActionItemMutation>;
export type CreateCustomActionItemMutationResult = Apollo.MutationResult<CreateCustomActionItemMutation>;
export type CreateCustomActionItemMutationOptions = Apollo.BaseMutationOptions<CreateCustomActionItemMutation, CreateCustomActionItemMutationVariables>;
export const UpdateActionItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateActionItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionItemUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instanceTarget"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NumericRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"valueTarget"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NumericRange"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionItemInputIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"intervalType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"enum_rollup_interval_type_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplements"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionItemSupplementInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"removedActionItemUserSupplementIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user_action"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionItemUserId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"instanceTarget"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instanceTarget"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"intervalType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"intervalType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"actionItemInputIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionItemInputIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"valueTarget"},"value":{"kind":"Variable","name":{"kind":"Name","value":"valueTarget"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"supplements"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplements"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actionItemId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_action_item_user_supplement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"removedActionItemUserSupplementIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode;
export type UpdateActionItemMutationFn = Apollo.MutationFunction<UpdateActionItemMutation, UpdateActionItemMutationVariables>;

/**
 * __useUpdateActionItemMutation__
 *
 * To run a mutation, you first call `useUpdateActionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActionItemMutation, { data, loading, error }] = useUpdateActionItemMutation({
 *   variables: {
 *      actionItemUserId: // value for 'actionItemUserId'
 *      instanceTarget: // value for 'instanceTarget'
 *      valueTarget: // value for 'valueTarget'
 *      actionItemInputIds: // value for 'actionItemInputIds'
 *      intervalType: // value for 'intervalType'
 *      supplements: // value for 'supplements'
 *      removedActionItemUserSupplementIds: // value for 'removedActionItemUserSupplementIds'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateActionItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateActionItemMutation, UpdateActionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateActionItemMutation, UpdateActionItemMutationVariables>(UpdateActionItemDocument, options);
      }
export type UpdateActionItemMutationHookResult = ReturnType<typeof useUpdateActionItemMutation>;
export type UpdateActionItemMutationResult = Apollo.MutationResult<UpdateActionItemMutation>;
export type UpdateActionItemMutationOptions = Apollo.BaseMutationOptions<UpdateActionItemMutation, UpdateActionItemMutationVariables>;
export const SupplementStackOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupplementStackOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_supplements"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"disabled"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"serving_size"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useSupplementStackOptionsQuery__
 *
 * To run a query within a React component, call `useSupplementStackOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplementStackOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplementStackOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSupplementStackOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SupplementStackOptionsQuery, SupplementStackOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SupplementStackOptionsQuery, SupplementStackOptionsQueryVariables>(SupplementStackOptionsDocument, options);
      }
export function useSupplementStackOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SupplementStackOptionsQuery, SupplementStackOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SupplementStackOptionsQuery, SupplementStackOptionsQueryVariables>(SupplementStackOptionsDocument, options);
        }
export function useSupplementStackOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SupplementStackOptionsQuery, SupplementStackOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SupplementStackOptionsQuery, SupplementStackOptionsQueryVariables>(SupplementStackOptionsDocument, options);
        }
export type SupplementStackOptionsQueryHookResult = ReturnType<typeof useSupplementStackOptionsQuery>;
export type SupplementStackOptionsLazyQueryHookResult = ReturnType<typeof useSupplementStackOptionsLazyQuery>;
export type SupplementStackOptionsSuspenseQueryHookResult = ReturnType<typeof useSupplementStackOptionsSuspenseQuery>;
export type SupplementStackOptionsQueryResult = Apollo.QueryResult<SupplementStackOptionsQuery, SupplementStackOptionsQueryVariables>;
export const ActionPlanWeeksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActionPlanWeeks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"weeks"},"name":{"kind":"Name","value":"get_reportable_action_item_periods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"week"}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"week"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"week"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"week"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useActionPlanWeeksQuery__
 *
 * To run a query within a React component, call `useActionPlanWeeksQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionPlanWeeksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionPlanWeeksQuery({
 *   variables: {
 *      end: // value for 'end'
 *   },
 * });
 */
export function useActionPlanWeeksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ActionPlanWeeksQuery, ActionPlanWeeksQueryVariables> & ({ variables: ActionPlanWeeksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActionPlanWeeksQuery, ActionPlanWeeksQueryVariables>(ActionPlanWeeksDocument, options);
      }
export function useActionPlanWeeksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActionPlanWeeksQuery, ActionPlanWeeksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActionPlanWeeksQuery, ActionPlanWeeksQueryVariables>(ActionPlanWeeksDocument, options);
        }
export function useActionPlanWeeksSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ActionPlanWeeksQuery, ActionPlanWeeksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ActionPlanWeeksQuery, ActionPlanWeeksQueryVariables>(ActionPlanWeeksDocument, options);
        }
export type ActionPlanWeeksQueryHookResult = ReturnType<typeof useActionPlanWeeksQuery>;
export type ActionPlanWeeksLazyQueryHookResult = ReturnType<typeof useActionPlanWeeksLazyQuery>;
export type ActionPlanWeeksSuspenseQueryHookResult = ReturnType<typeof useActionPlanWeeksSuspenseQuery>;
export type ActionPlanWeeksQueryResult = Apollo.QueryResult<ActionPlanWeeksQuery, ActionPlanWeeksQueryVariables>;
export const DisableActionItemUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DisableActionItemUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionItemUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disable_action_item_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"actionItemUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionItemUserId"}}}]}}]}]}}]} as unknown as DocumentNode;
export type DisableActionItemUserMutationFn = Apollo.MutationFunction<DisableActionItemUserMutation, DisableActionItemUserMutationVariables>;

/**
 * __useDisableActionItemUserMutation__
 *
 * To run a mutation, you first call `useDisableActionItemUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableActionItemUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableActionItemUserMutation, { data, loading, error }] = useDisableActionItemUserMutation({
 *   variables: {
 *      actionItemUserId: // value for 'actionItemUserId'
 *   },
 * });
 */
export function useDisableActionItemUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisableActionItemUserMutation, DisableActionItemUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisableActionItemUserMutation, DisableActionItemUserMutationVariables>(DisableActionItemUserDocument, options);
      }
export type DisableActionItemUserMutationHookResult = ReturnType<typeof useDisableActionItemUserMutation>;
export type DisableActionItemUserMutationResult = Apollo.MutationResult<DisableActionItemUserMutation>;
export type DisableActionItemUserMutationOptions = Apollo.BaseMutationOptions<DisableActionItemUserMutation, DisableActionItemUserMutationVariables>;
export const UpdateActionItemsSortOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateActionItemsSortOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"action_item_user_updates"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_action_item_user_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode;
export type UpdateActionItemsSortOrderMutationFn = Apollo.MutationFunction<UpdateActionItemsSortOrderMutation, UpdateActionItemsSortOrderMutationVariables>;

/**
 * __useUpdateActionItemsSortOrderMutation__
 *
 * To run a mutation, you first call `useUpdateActionItemsSortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActionItemsSortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActionItemsSortOrderMutation, { data, loading, error }] = useUpdateActionItemsSortOrderMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateActionItemsSortOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateActionItemsSortOrderMutation, UpdateActionItemsSortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateActionItemsSortOrderMutation, UpdateActionItemsSortOrderMutationVariables>(UpdateActionItemsSortOrderDocument, options);
      }
export type UpdateActionItemsSortOrderMutationHookResult = ReturnType<typeof useUpdateActionItemsSortOrderMutation>;
export type UpdateActionItemsSortOrderMutationResult = Apollo.MutationResult<UpdateActionItemsSortOrderMutation>;
export type UpdateActionItemsSortOrderMutationOptions = Apollo.BaseMutationOptions<UpdateActionItemsSortOrderMutation, UpdateActionItemsSortOrderMutationVariables>;
export const CurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export function useCurrentUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const CircleIdByInviteShortIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CircleIdByInviteShortId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteShortId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_circles_by_invite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteShortId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCircleIdByInviteShortIdQuery__
 *
 * To run a query within a React component, call `useCircleIdByInviteShortIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCircleIdByInviteShortIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCircleIdByInviteShortIdQuery({
 *   variables: {
 *      inviteShortId: // value for 'inviteShortId'
 *   },
 * });
 */
export function useCircleIdByInviteShortIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CircleIdByInviteShortIdQuery, CircleIdByInviteShortIdQueryVariables> & ({ variables: CircleIdByInviteShortIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CircleIdByInviteShortIdQuery, CircleIdByInviteShortIdQueryVariables>(CircleIdByInviteShortIdDocument, options);
      }
export function useCircleIdByInviteShortIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CircleIdByInviteShortIdQuery, CircleIdByInviteShortIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CircleIdByInviteShortIdQuery, CircleIdByInviteShortIdQueryVariables>(CircleIdByInviteShortIdDocument, options);
        }
export function useCircleIdByInviteShortIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CircleIdByInviteShortIdQuery, CircleIdByInviteShortIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CircleIdByInviteShortIdQuery, CircleIdByInviteShortIdQueryVariables>(CircleIdByInviteShortIdDocument, options);
        }
export type CircleIdByInviteShortIdQueryHookResult = ReturnType<typeof useCircleIdByInviteShortIdQuery>;
export type CircleIdByInviteShortIdLazyQueryHookResult = ReturnType<typeof useCircleIdByInviteShortIdLazyQuery>;
export type CircleIdByInviteShortIdSuspenseQueryHookResult = ReturnType<typeof useCircleIdByInviteShortIdSuspenseQuery>;
export type CircleIdByInviteShortIdQueryResult = Apollo.QueryResult<CircleIdByInviteShortIdQuery, CircleIdByInviteShortIdQueryVariables>;
export const DeleteCircleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCircle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_circle_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type DeleteCircleMutationFn = Apollo.MutationFunction<DeleteCircleMutation, DeleteCircleMutationVariables>;

/**
 * __useDeleteCircleMutation__
 *
 * To run a mutation, you first call `useDeleteCircleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCircleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCircleMutation, { data, loading, error }] = useDeleteCircleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCircleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCircleMutation, DeleteCircleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCircleMutation, DeleteCircleMutationVariables>(DeleteCircleDocument, options);
      }
export type DeleteCircleMutationHookResult = ReturnType<typeof useDeleteCircleMutation>;
export type DeleteCircleMutationResult = Apollo.MutationResult<DeleteCircleMutation>;
export type DeleteCircleMutationOptions = Apollo.BaseMutationOptions<DeleteCircleMutation, DeleteCircleMutationVariables>;
export const CircleNameByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CircleNameById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"circleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circle_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"circleId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCircleNameByIdQuery__
 *
 * To run a query within a React component, call `useCircleNameByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCircleNameByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCircleNameByIdQuery({
 *   variables: {
 *      circleId: // value for 'circleId'
 *   },
 * });
 */
export function useCircleNameByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CircleNameByIdQuery, CircleNameByIdQueryVariables> & ({ variables: CircleNameByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CircleNameByIdQuery, CircleNameByIdQueryVariables>(CircleNameByIdDocument, options);
      }
export function useCircleNameByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CircleNameByIdQuery, CircleNameByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CircleNameByIdQuery, CircleNameByIdQueryVariables>(CircleNameByIdDocument, options);
        }
export function useCircleNameByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CircleNameByIdQuery, CircleNameByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CircleNameByIdQuery, CircleNameByIdQueryVariables>(CircleNameByIdDocument, options);
        }
export type CircleNameByIdQueryHookResult = ReturnType<typeof useCircleNameByIdQuery>;
export type CircleNameByIdLazyQueryHookResult = ReturnType<typeof useCircleNameByIdLazyQuery>;
export type CircleNameByIdSuspenseQueryHookResult = ReturnType<typeof useCircleNameByIdSuspenseQuery>;
export type CircleNameByIdQueryResult = Apollo.QueryResult<CircleNameByIdQuery, CircleNameByIdQueryVariables>;
export const ActionItemDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActionItemDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_item_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"hero_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useActionItemDetailsQuery__
 *
 * To run a query within a React component, call `useActionItemDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionItemDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionItemDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActionItemDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ActionItemDetailsQuery, ActionItemDetailsQueryVariables> & ({ variables: ActionItemDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActionItemDetailsQuery, ActionItemDetailsQueryVariables>(ActionItemDetailsDocument, options);
      }
export function useActionItemDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActionItemDetailsQuery, ActionItemDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActionItemDetailsQuery, ActionItemDetailsQueryVariables>(ActionItemDetailsDocument, options);
        }
export function useActionItemDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ActionItemDetailsQuery, ActionItemDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ActionItemDetailsQuery, ActionItemDetailsQueryVariables>(ActionItemDetailsDocument, options);
        }
export type ActionItemDetailsQueryHookResult = ReturnType<typeof useActionItemDetailsQuery>;
export type ActionItemDetailsLazyQueryHookResult = ReturnType<typeof useActionItemDetailsLazyQuery>;
export type ActionItemDetailsSuspenseQueryHookResult = ReturnType<typeof useActionItemDetailsSuspenseQuery>;
export type ActionItemDetailsQueryResult = Apollo.QueryResult<ActionItemDetailsQuery, ActionItemDetailsQueryVariables>;
export const CircleUserIdsByInviteShortIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CircleUserIdsByInviteShortId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shortId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_circles_by_invite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shortId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OuraDataSourceActionItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OuraDataSourceActionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"circle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_user_inputs"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"oura"}}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCircleUserIdsByInviteShortIdQuery__
 *
 * To run a query within a React component, call `useCircleUserIdsByInviteShortIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCircleUserIdsByInviteShortIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCircleUserIdsByInviteShortIdQuery({
 *   variables: {
 *      shortId: // value for 'shortId'
 *   },
 * });
 */
export function useCircleUserIdsByInviteShortIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CircleUserIdsByInviteShortIdQuery, CircleUserIdsByInviteShortIdQueryVariables> & ({ variables: CircleUserIdsByInviteShortIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CircleUserIdsByInviteShortIdQuery, CircleUserIdsByInviteShortIdQueryVariables>(CircleUserIdsByInviteShortIdDocument, options);
      }
export function useCircleUserIdsByInviteShortIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CircleUserIdsByInviteShortIdQuery, CircleUserIdsByInviteShortIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CircleUserIdsByInviteShortIdQuery, CircleUserIdsByInviteShortIdQueryVariables>(CircleUserIdsByInviteShortIdDocument, options);
        }
export function useCircleUserIdsByInviteShortIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CircleUserIdsByInviteShortIdQuery, CircleUserIdsByInviteShortIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CircleUserIdsByInviteShortIdQuery, CircleUserIdsByInviteShortIdQueryVariables>(CircleUserIdsByInviteShortIdDocument, options);
        }
export type CircleUserIdsByInviteShortIdQueryHookResult = ReturnType<typeof useCircleUserIdsByInviteShortIdQuery>;
export type CircleUserIdsByInviteShortIdLazyQueryHookResult = ReturnType<typeof useCircleUserIdsByInviteShortIdLazyQuery>;
export type CircleUserIdsByInviteShortIdSuspenseQueryHookResult = ReturnType<typeof useCircleUserIdsByInviteShortIdSuspenseQuery>;
export type CircleUserIdsByInviteShortIdQueryResult = Apollo.QueryResult<CircleUserIdsByInviteShortIdQuery, CircleUserIdsByInviteShortIdQueryVariables>;
export const CircleUserIdsByCircleIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CircleUserIdsByCircleId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"circleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circle_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"circleId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OuraDataSourceActionItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OuraDataSourceActionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"circle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_user_inputs"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"oura"}}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCircleUserIdsByCircleIdQuery__
 *
 * To run a query within a React component, call `useCircleUserIdsByCircleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCircleUserIdsByCircleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCircleUserIdsByCircleIdQuery({
 *   variables: {
 *      circleId: // value for 'circleId'
 *   },
 * });
 */
export function useCircleUserIdsByCircleIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CircleUserIdsByCircleIdQuery, CircleUserIdsByCircleIdQueryVariables> & ({ variables: CircleUserIdsByCircleIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CircleUserIdsByCircleIdQuery, CircleUserIdsByCircleIdQueryVariables>(CircleUserIdsByCircleIdDocument, options);
      }
export function useCircleUserIdsByCircleIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CircleUserIdsByCircleIdQuery, CircleUserIdsByCircleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CircleUserIdsByCircleIdQuery, CircleUserIdsByCircleIdQueryVariables>(CircleUserIdsByCircleIdDocument, options);
        }
export function useCircleUserIdsByCircleIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CircleUserIdsByCircleIdQuery, CircleUserIdsByCircleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CircleUserIdsByCircleIdQuery, CircleUserIdsByCircleIdQueryVariables>(CircleUserIdsByCircleIdDocument, options);
        }
export type CircleUserIdsByCircleIdQueryHookResult = ReturnType<typeof useCircleUserIdsByCircleIdQuery>;
export type CircleUserIdsByCircleIdLazyQueryHookResult = ReturnType<typeof useCircleUserIdsByCircleIdLazyQuery>;
export type CircleUserIdsByCircleIdSuspenseQueryHookResult = ReturnType<typeof useCircleUserIdsByCircleIdSuspenseQuery>;
export type CircleUserIdsByCircleIdQueryResult = Apollo.QueryResult<CircleUserIdsByCircleIdQuery, CircleUserIdsByCircleIdQueryVariables>;
export const CirclesListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CirclesList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"myCircles"},"name":{"kind":"Name","value":"me_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"circle_memberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"circle"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"memberships"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"circle_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CirclesListCircleFields"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"notMyCircles"},"name":{"kind":"Name","value":"circle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"public"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CirclesListCircleFields"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CirclesListCircleFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"circle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_owner"}},{"kind":"Field","name":{"kind":"Name","value":"weekSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCirclesListQuery__
 *
 * To run a query within a React component, call `useCirclesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCirclesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCirclesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useCirclesListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CirclesListQuery, CirclesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CirclesListQuery, CirclesListQueryVariables>(CirclesListDocument, options);
      }
export function useCirclesListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CirclesListQuery, CirclesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CirclesListQuery, CirclesListQueryVariables>(CirclesListDocument, options);
        }
export function useCirclesListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CirclesListQuery, CirclesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CirclesListQuery, CirclesListQueryVariables>(CirclesListDocument, options);
        }
export type CirclesListQueryHookResult = ReturnType<typeof useCirclesListQuery>;
export type CirclesListLazyQueryHookResult = ReturnType<typeof useCirclesListLazyQuery>;
export type CirclesListSuspenseQueryHookResult = ReturnType<typeof useCirclesListSuspenseQuery>;
export type CirclesListQueryResult = Apollo.QueryResult<CirclesListQuery, CirclesListQueryVariables>;
export const CircleDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CircleDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weekStart"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circle_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_owner"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CircleInviteAndCircleDetailsSharedFields"}},{"kind":"Field","name":{"kind":"Name","value":"weekSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"weekStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weekStart"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"week"}},{"kind":"Field","name":{"kind":"Name","value":"targets"}},{"kind":"Field","name":{"kind":"Name","value":"targetsMet"}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targets"}},{"kind":"Field","name":{"kind":"Name","value":"targetsMet"}},{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"joinedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photo_url"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CircleImageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"circle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hero_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CircleInviteAndCircleDetailsSharedFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"circle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"checkout_bundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"related_contents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"entity_id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CircleImageFields"}},{"kind":"Field","alias":{"kind":"Name","value":"action_items"},"name":{"kind":"Name","value":"action_items_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"action_item_user"},"name":{"kind":"Name","value":"template_action_item_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"personalized_name"}},{"kind":"Field","name":{"kind":"Name","value":"preference_value_target"}},{"kind":"Field","name":{"kind":"Name","value":"instance_target"}},{"kind":"Field","name":{"kind":"Name","value":"instance_target_type"}},{"kind":"Field","name":{"kind":"Name","value":"value_rollup_type"}},{"kind":"Field","name":{"kind":"Name","value":"weekly_instance_target"}},{"kind":"Field","name":{"kind":"Name","value":"circle_action_items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sort_order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_image"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"interval_type"}},{"kind":"Field","name":{"kind":"Name","value":"interval_count"}},{"kind":"Field","name":{"kind":"Name","value":"preference_value_target"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}},{"kind":"Field","name":{"kind":"Name","value":"display_symbol_plural"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name_plural"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_item_inputs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"input_type"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCircleDetailQuery__
 *
 * To run a query within a React component, call `useCircleDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCircleDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCircleDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      weekStart: // value for 'weekStart'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCircleDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CircleDetailQuery, CircleDetailQueryVariables> & ({ variables: CircleDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CircleDetailQuery, CircleDetailQueryVariables>(CircleDetailDocument, options);
      }
export function useCircleDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CircleDetailQuery, CircleDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CircleDetailQuery, CircleDetailQueryVariables>(CircleDetailDocument, options);
        }
export function useCircleDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CircleDetailQuery, CircleDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CircleDetailQuery, CircleDetailQueryVariables>(CircleDetailDocument, options);
        }
export type CircleDetailQueryHookResult = ReturnType<typeof useCircleDetailQuery>;
export type CircleDetailLazyQueryHookResult = ReturnType<typeof useCircleDetailLazyQuery>;
export type CircleDetailSuspenseQueryHookResult = ReturnType<typeof useCircleDetailSuspenseQuery>;
export type CircleDetailQueryResult = Apollo.QueryResult<CircleDetailQuery, CircleDetailQueryVariables>;
export const LeaveCircleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LeaveCircle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"circleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keepActions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leaveCircle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"circleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"circleId"}}},{"kind":"Argument","name":{"kind":"Name","value":"keepActions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keepActions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"joinedAt"}},{"kind":"Field","name":{"kind":"Name","value":"leftAt"}}]}}]}}]} as unknown as DocumentNode;
export type LeaveCircleMutationFn = Apollo.MutationFunction<LeaveCircleMutation, LeaveCircleMutationVariables>;

/**
 * __useLeaveCircleMutation__
 *
 * To run a mutation, you first call `useLeaveCircleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveCircleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveCircleMutation, { data, loading, error }] = useLeaveCircleMutation({
 *   variables: {
 *      circleId: // value for 'circleId'
 *      keepActions: // value for 'keepActions'
 *   },
 * });
 */
export function useLeaveCircleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LeaveCircleMutation, LeaveCircleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LeaveCircleMutation, LeaveCircleMutationVariables>(LeaveCircleDocument, options);
      }
export type LeaveCircleMutationHookResult = ReturnType<typeof useLeaveCircleMutation>;
export type LeaveCircleMutationResult = Apollo.MutationResult<LeaveCircleMutation>;
export type LeaveCircleMutationOptions = Apollo.BaseMutationOptions<LeaveCircleMutation, LeaveCircleMutationVariables>;
export const RemoveCircleMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveCircleMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"membershipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCircleMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"circleMembershipId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"membershipId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode;
export type RemoveCircleMemberMutationFn = Apollo.MutationFunction<RemoveCircleMemberMutation, RemoveCircleMemberMutationVariables>;

/**
 * __useRemoveCircleMemberMutation__
 *
 * To run a mutation, you first call `useRemoveCircleMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCircleMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCircleMemberMutation, { data, loading, error }] = useRemoveCircleMemberMutation({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useRemoveCircleMemberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveCircleMemberMutation, RemoveCircleMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveCircleMemberMutation, RemoveCircleMemberMutationVariables>(RemoveCircleMemberDocument, options);
      }
export type RemoveCircleMemberMutationHookResult = ReturnType<typeof useRemoveCircleMemberMutation>;
export type RemoveCircleMemberMutationResult = Apollo.MutationResult<RemoveCircleMemberMutation>;
export type RemoveCircleMemberMutationOptions = Apollo.BaseMutationOptions<RemoveCircleMemberMutation, RemoveCircleMemberMutationVariables>;
export const MonitorCircleActionItemUpdatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MonitorCircleActionItemUpdates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"membership_action_item_summary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"new_version_available"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CircleImageFields"}},{"kind":"Field","name":{"kind":"Name","value":"membership_action_item_summary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"new_version_available"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"change_type"}},{"kind":"Field","name":{"kind":"Name","value":"circle_action_item_id"}},{"kind":"Field","alias":{"kind":"Name","value":"circle_action_item"},"name":{"kind":"Name","value":"template_action_item_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActionPlanUpdateActionItemUserSharedFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"my_version"},"name":{"kind":"Name","value":"action_item_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActionPlanUpdateActionItemUserSharedFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CircleImageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"circle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hero_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionPlanUpdateActionItemUserSharedFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action_item_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"personalized_name"}},{"kind":"Field","name":{"kind":"Name","value":"interval_type"}},{"kind":"Field","name":{"kind":"Name","value":"weekly_instance_target"}},{"kind":"Field","name":{"kind":"Name","value":"preference_value_target"}},{"kind":"Field","name":{"kind":"Name","value":"action_item_user_inputs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_item_input"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data_source"}},{"kind":"Field","name":{"kind":"Name","value":"input_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}},{"kind":"Field","name":{"kind":"Name","value":"display_symbol_plural"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name_plural"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMonitorCircleActionItemUpdatesQuery__
 *
 * To run a query within a React component, call `useMonitorCircleActionItemUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonitorCircleActionItemUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonitorCircleActionItemUpdatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMonitorCircleActionItemUpdatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MonitorCircleActionItemUpdatesQuery, MonitorCircleActionItemUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MonitorCircleActionItemUpdatesQuery, MonitorCircleActionItemUpdatesQueryVariables>(MonitorCircleActionItemUpdatesDocument, options);
      }
export function useMonitorCircleActionItemUpdatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MonitorCircleActionItemUpdatesQuery, MonitorCircleActionItemUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MonitorCircleActionItemUpdatesQuery, MonitorCircleActionItemUpdatesQueryVariables>(MonitorCircleActionItemUpdatesDocument, options);
        }
export function useMonitorCircleActionItemUpdatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MonitorCircleActionItemUpdatesQuery, MonitorCircleActionItemUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MonitorCircleActionItemUpdatesQuery, MonitorCircleActionItemUpdatesQueryVariables>(MonitorCircleActionItemUpdatesDocument, options);
        }
export type MonitorCircleActionItemUpdatesQueryHookResult = ReturnType<typeof useMonitorCircleActionItemUpdatesQuery>;
export type MonitorCircleActionItemUpdatesLazyQueryHookResult = ReturnType<typeof useMonitorCircleActionItemUpdatesLazyQuery>;
export type MonitorCircleActionItemUpdatesSuspenseQueryHookResult = ReturnType<typeof useMonitorCircleActionItemUpdatesSuspenseQuery>;
export type MonitorCircleActionItemUpdatesQueryResult = Apollo.QueryResult<MonitorCircleActionItemUpdatesQuery, MonitorCircleActionItemUpdatesQueryVariables>;
export const JoinCircleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JoinCircle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"joinCircle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inviteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circleId"}}]}}]}}]} as unknown as DocumentNode;
export type JoinCircleMutationFn = Apollo.MutationFunction<JoinCircleMutation, JoinCircleMutationVariables>;

/**
 * __useJoinCircleMutation__
 *
 * To run a mutation, you first call `useJoinCircleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinCircleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinCircleMutation, { data, loading, error }] = useJoinCircleMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useJoinCircleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<JoinCircleMutation, JoinCircleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<JoinCircleMutation, JoinCircleMutationVariables>(JoinCircleDocument, options);
      }
export type JoinCircleMutationHookResult = ReturnType<typeof useJoinCircleMutation>;
export type JoinCircleMutationResult = Apollo.MutationResult<JoinCircleMutation>;
export type JoinCircleMutationOptions = Apollo.BaseMutationOptions<JoinCircleMutation, JoinCircleMutationVariables>;
export const CircleMembershipsWithOuraActionItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CircleMembershipsWithOuraActionItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"circle_membership_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"circle_memberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCircleMembershipsWithOuraActionItemsQuery__
 *
 * To run a query within a React component, call `useCircleMembershipsWithOuraActionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCircleMembershipsWithOuraActionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCircleMembershipsWithOuraActionItemsQuery({
 *   variables: {
 *      whereClause: // value for 'whereClause'
 *   },
 * });
 */
export function useCircleMembershipsWithOuraActionItemsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CircleMembershipsWithOuraActionItemsQuery, CircleMembershipsWithOuraActionItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CircleMembershipsWithOuraActionItemsQuery, CircleMembershipsWithOuraActionItemsQueryVariables>(CircleMembershipsWithOuraActionItemsDocument, options);
      }
export function useCircleMembershipsWithOuraActionItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CircleMembershipsWithOuraActionItemsQuery, CircleMembershipsWithOuraActionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CircleMembershipsWithOuraActionItemsQuery, CircleMembershipsWithOuraActionItemsQueryVariables>(CircleMembershipsWithOuraActionItemsDocument, options);
        }
export function useCircleMembershipsWithOuraActionItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CircleMembershipsWithOuraActionItemsQuery, CircleMembershipsWithOuraActionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CircleMembershipsWithOuraActionItemsQuery, CircleMembershipsWithOuraActionItemsQueryVariables>(CircleMembershipsWithOuraActionItemsDocument, options);
        }
export type CircleMembershipsWithOuraActionItemsQueryHookResult = ReturnType<typeof useCircleMembershipsWithOuraActionItemsQuery>;
export type CircleMembershipsWithOuraActionItemsLazyQueryHookResult = ReturnType<typeof useCircleMembershipsWithOuraActionItemsLazyQuery>;
export type CircleMembershipsWithOuraActionItemsSuspenseQueryHookResult = ReturnType<typeof useCircleMembershipsWithOuraActionItemsSuspenseQuery>;
export type CircleMembershipsWithOuraActionItemsQueryResult = Apollo.QueryResult<CircleMembershipsWithOuraActionItemsQuery, CircleMembershipsWithOuraActionItemsQueryVariables>;
export const OuraActionItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OuraActionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_user_inputs"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"oura"}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useOuraActionItemsQuery__
 *
 * To run a query within a React component, call `useOuraActionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOuraActionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOuraActionItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOuraActionItemsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OuraActionItemsQuery, OuraActionItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OuraActionItemsQuery, OuraActionItemsQueryVariables>(OuraActionItemsDocument, options);
      }
export function useOuraActionItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OuraActionItemsQuery, OuraActionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OuraActionItemsQuery, OuraActionItemsQueryVariables>(OuraActionItemsDocument, options);
        }
export function useOuraActionItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OuraActionItemsQuery, OuraActionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OuraActionItemsQuery, OuraActionItemsQueryVariables>(OuraActionItemsDocument, options);
        }
export type OuraActionItemsQueryHookResult = ReturnType<typeof useOuraActionItemsQuery>;
export type OuraActionItemsLazyQueryHookResult = ReturnType<typeof useOuraActionItemsLazyQuery>;
export type OuraActionItemsSuspenseQueryHookResult = ReturnType<typeof useOuraActionItemsSuspenseQuery>;
export type OuraActionItemsQueryResult = Apollo.QueryResult<OuraActionItemsQuery, OuraActionItemsQueryVariables>;
export const GetStreamChatConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStreamChatConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"circleId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipCircleQuery"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_stream_chat_config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"apiKey"}},{"kind":"Field","name":{"kind":"Name","value":"userToken"}},{"kind":"Field","name":{"kind":"Name","value":"streamUserId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"circle_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"circleId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipCircleQuery"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CircleImageFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CircleImageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"circle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hero_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetStreamChatConfigQuery__
 *
 * To run a query within a React component, call `useGetStreamChatConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStreamChatConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStreamChatConfigQuery({
 *   variables: {
 *      circleId: // value for 'circleId'
 *      skipCircleQuery: // value for 'skipCircleQuery'
 *   },
 * });
 */
export function useGetStreamChatConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStreamChatConfigQuery, GetStreamChatConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStreamChatConfigQuery, GetStreamChatConfigQueryVariables>(GetStreamChatConfigDocument, options);
      }
export function useGetStreamChatConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStreamChatConfigQuery, GetStreamChatConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStreamChatConfigQuery, GetStreamChatConfigQueryVariables>(GetStreamChatConfigDocument, options);
        }
export function useGetStreamChatConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetStreamChatConfigQuery, GetStreamChatConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetStreamChatConfigQuery, GetStreamChatConfigQueryVariables>(GetStreamChatConfigDocument, options);
        }
export type GetStreamChatConfigQueryHookResult = ReturnType<typeof useGetStreamChatConfigQuery>;
export type GetStreamChatConfigLazyQueryHookResult = ReturnType<typeof useGetStreamChatConfigLazyQuery>;
export type GetStreamChatConfigSuspenseQueryHookResult = ReturnType<typeof useGetStreamChatConfigSuspenseQuery>;
export type GetStreamChatConfigQueryResult = Apollo.QueryResult<GetStreamChatConfigQuery, GetStreamChatConfigQueryVariables>;
export const GetStreamConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStreamConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_stream_config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"apiKey"}},{"kind":"Field","name":{"kind":"Name","value":"userToken"}},{"kind":"Field","name":{"kind":"Name","value":"streamUserId"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetStreamConfigQuery__
 *
 * To run a query within a React component, call `useGetStreamConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStreamConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStreamConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStreamConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStreamConfigQuery, GetStreamConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStreamConfigQuery, GetStreamConfigQueryVariables>(GetStreamConfigDocument, options);
      }
export function useGetStreamConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStreamConfigQuery, GetStreamConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStreamConfigQuery, GetStreamConfigQueryVariables>(GetStreamConfigDocument, options);
        }
export function useGetStreamConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetStreamConfigQuery, GetStreamConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetStreamConfigQuery, GetStreamConfigQueryVariables>(GetStreamConfigDocument, options);
        }
export type GetStreamConfigQueryHookResult = ReturnType<typeof useGetStreamConfigQuery>;
export type GetStreamConfigLazyQueryHookResult = ReturnType<typeof useGetStreamConfigLazyQuery>;
export type GetStreamConfigSuspenseQueryHookResult = ReturnType<typeof useGetStreamConfigSuspenseQuery>;
export type GetStreamConfigQueryResult = Apollo.QueryResult<GetStreamConfigQuery, GetStreamConfigQueryVariables>;
export const AcceptTosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptTos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptTermsOfService"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}}]}}]}}]} as unknown as DocumentNode;
export type AcceptTosMutationFn = Apollo.MutationFunction<AcceptTosMutation, AcceptTosMutationVariables>;

/**
 * __useAcceptTosMutation__
 *
 * To run a mutation, you first call `useAcceptTosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTosMutation, { data, loading, error }] = useAcceptTosMutation({
 *   variables: {
 *      version: // value for 'version'
 *   },
 * });
 */
export function useAcceptTosMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptTosMutation, AcceptTosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptTosMutation, AcceptTosMutationVariables>(AcceptTosDocument, options);
      }
export type AcceptTosMutationHookResult = ReturnType<typeof useAcceptTosMutation>;
export type AcceptTosMutationResult = Apollo.MutationResult<AcceptTosMutation>;
export type AcceptTosMutationOptions = Apollo.BaseMutationOptions<AcceptTosMutation, AcceptTosMutationVariables>;
export const ConfirmActionItemVersionUpdatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmActionItemVersionUpdates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accepted"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rejected"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptCircleActionItemChanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"circleActionItemIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accepted"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rejectCircleActionItemChanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"circleActionItemIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rejected"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type ConfirmActionItemVersionUpdatesMutationFn = Apollo.MutationFunction<ConfirmActionItemVersionUpdatesMutation, ConfirmActionItemVersionUpdatesMutationVariables>;

/**
 * __useConfirmActionItemVersionUpdatesMutation__
 *
 * To run a mutation, you first call `useConfirmActionItemVersionUpdatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmActionItemVersionUpdatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmActionItemVersionUpdatesMutation, { data, loading, error }] = useConfirmActionItemVersionUpdatesMutation({
 *   variables: {
 *      accepted: // value for 'accepted'
 *      rejected: // value for 'rejected'
 *   },
 * });
 */
export function useConfirmActionItemVersionUpdatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfirmActionItemVersionUpdatesMutation, ConfirmActionItemVersionUpdatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfirmActionItemVersionUpdatesMutation, ConfirmActionItemVersionUpdatesMutationVariables>(ConfirmActionItemVersionUpdatesDocument, options);
      }
export type ConfirmActionItemVersionUpdatesMutationHookResult = ReturnType<typeof useConfirmActionItemVersionUpdatesMutation>;
export type ConfirmActionItemVersionUpdatesMutationResult = Apollo.MutationResult<ConfirmActionItemVersionUpdatesMutation>;
export type ConfirmActionItemVersionUpdatesMutationOptions = Apollo.BaseMutationOptions<ConfirmActionItemVersionUpdatesMutation, ConfirmActionItemVersionUpdatesMutationVariables>;
export const CircleInviteShortIdByCircleIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CircleInviteShortIdByCircleId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"circleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circle_invite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"circle_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"circleId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"enabled"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"short_id"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCircleInviteShortIdByCircleIdQuery__
 *
 * To run a query within a React component, call `useCircleInviteShortIdByCircleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCircleInviteShortIdByCircleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCircleInviteShortIdByCircleIdQuery({
 *   variables: {
 *      circleId: // value for 'circleId'
 *   },
 * });
 */
export function useCircleInviteShortIdByCircleIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CircleInviteShortIdByCircleIdQuery, CircleInviteShortIdByCircleIdQueryVariables> & ({ variables: CircleInviteShortIdByCircleIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CircleInviteShortIdByCircleIdQuery, CircleInviteShortIdByCircleIdQueryVariables>(CircleInviteShortIdByCircleIdDocument, options);
      }
export function useCircleInviteShortIdByCircleIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CircleInviteShortIdByCircleIdQuery, CircleInviteShortIdByCircleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CircleInviteShortIdByCircleIdQuery, CircleInviteShortIdByCircleIdQueryVariables>(CircleInviteShortIdByCircleIdDocument, options);
        }
export function useCircleInviteShortIdByCircleIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CircleInviteShortIdByCircleIdQuery, CircleInviteShortIdByCircleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CircleInviteShortIdByCircleIdQuery, CircleInviteShortIdByCircleIdQueryVariables>(CircleInviteShortIdByCircleIdDocument, options);
        }
export type CircleInviteShortIdByCircleIdQueryHookResult = ReturnType<typeof useCircleInviteShortIdByCircleIdQuery>;
export type CircleInviteShortIdByCircleIdLazyQueryHookResult = ReturnType<typeof useCircleInviteShortIdByCircleIdLazyQuery>;
export type CircleInviteShortIdByCircleIdSuspenseQueryHookResult = ReturnType<typeof useCircleInviteShortIdByCircleIdSuspenseQuery>;
export type CircleInviteShortIdByCircleIdQueryResult = Apollo.QueryResult<CircleInviteShortIdByCircleIdQuery, CircleInviteShortIdByCircleIdQueryVariables>;
export const CreateCircleInviteShortIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCircleInviteShortId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"circleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCircleInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"circleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"circleId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortId"}}]}}]}}]} as unknown as DocumentNode;
export type CreateCircleInviteShortIdMutationFn = Apollo.MutationFunction<CreateCircleInviteShortIdMutation, CreateCircleInviteShortIdMutationVariables>;

/**
 * __useCreateCircleInviteShortIdMutation__
 *
 * To run a mutation, you first call `useCreateCircleInviteShortIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCircleInviteShortIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCircleInviteShortIdMutation, { data, loading, error }] = useCreateCircleInviteShortIdMutation({
 *   variables: {
 *      circleId: // value for 'circleId'
 *   },
 * });
 */
export function useCreateCircleInviteShortIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCircleInviteShortIdMutation, CreateCircleInviteShortIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCircleInviteShortIdMutation, CreateCircleInviteShortIdMutationVariables>(CreateCircleInviteShortIdDocument, options);
      }
export type CreateCircleInviteShortIdMutationHookResult = ReturnType<typeof useCreateCircleInviteShortIdMutation>;
export type CreateCircleInviteShortIdMutationResult = Apollo.MutationResult<CreateCircleInviteShortIdMutation>;
export type CreateCircleInviteShortIdMutationOptions = Apollo.BaseMutationOptions<CreateCircleInviteShortIdMutation, CreateCircleInviteShortIdMutationVariables>;
export const CircleDefaultImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CircleDefaultImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityId"},"value":{"kind":"StringValue","value":"default","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCircleDefaultImageQuery__
 *
 * To run a query within a React component, call `useCircleDefaultImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCircleDefaultImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCircleDefaultImageQuery({
 *   variables: {
 *   },
 * });
 */
export function useCircleDefaultImageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CircleDefaultImageQuery, CircleDefaultImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CircleDefaultImageQuery, CircleDefaultImageQueryVariables>(CircleDefaultImageDocument, options);
      }
export function useCircleDefaultImageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CircleDefaultImageQuery, CircleDefaultImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CircleDefaultImageQuery, CircleDefaultImageQueryVariables>(CircleDefaultImageDocument, options);
        }
export function useCircleDefaultImageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CircleDefaultImageQuery, CircleDefaultImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CircleDefaultImageQuery, CircleDefaultImageQueryVariables>(CircleDefaultImageDocument, options);
        }
export type CircleDefaultImageQueryHookResult = ReturnType<typeof useCircleDefaultImageQuery>;
export type CircleDefaultImageLazyQueryHookResult = ReturnType<typeof useCircleDefaultImageLazyQuery>;
export type CircleDefaultImageSuspenseQueryHookResult = ReturnType<typeof useCircleDefaultImageSuspenseQuery>;
export type CircleDefaultImageQueryResult = Apollo.QueryResult<CircleDefaultImageQuery, CircleDefaultImageQueryVariables>;
export const CreateCircleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCircle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"circle_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_circle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode;
export type CreateCircleMutationFn = Apollo.MutationFunction<CreateCircleMutation, CreateCircleMutationVariables>;

/**
 * __useCreateCircleMutation__
 *
 * To run a mutation, you first call `useCreateCircleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCircleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCircleMutation, { data, loading, error }] = useCreateCircleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCircleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCircleMutation, CreateCircleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCircleMutation, CreateCircleMutationVariables>(CreateCircleDocument, options);
      }
export type CreateCircleMutationHookResult = ReturnType<typeof useCreateCircleMutation>;
export type CreateCircleMutationResult = Apollo.MutationResult<CreateCircleMutation>;
export type CreateCircleMutationOptions = Apollo.BaseMutationOptions<CreateCircleMutation, CreateCircleMutationVariables>;
export const GetCircleByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCircleById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"circleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circle_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"circleId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CircleInviteAndCircleDetailsSharedFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CircleImageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"circle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hero_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CircleInviteAndCircleDetailsSharedFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"circle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"checkout_bundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"related_contents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"entity_id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CircleImageFields"}},{"kind":"Field","alias":{"kind":"Name","value":"action_items"},"name":{"kind":"Name","value":"action_items_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"action_item_user"},"name":{"kind":"Name","value":"template_action_item_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"personalized_name"}},{"kind":"Field","name":{"kind":"Name","value":"preference_value_target"}},{"kind":"Field","name":{"kind":"Name","value":"instance_target"}},{"kind":"Field","name":{"kind":"Name","value":"instance_target_type"}},{"kind":"Field","name":{"kind":"Name","value":"value_rollup_type"}},{"kind":"Field","name":{"kind":"Name","value":"weekly_instance_target"}},{"kind":"Field","name":{"kind":"Name","value":"circle_action_items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sort_order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_image"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"interval_type"}},{"kind":"Field","name":{"kind":"Name","value":"interval_count"}},{"kind":"Field","name":{"kind":"Name","value":"preference_value_target"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}},{"kind":"Field","name":{"kind":"Name","value":"display_symbol_plural"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name_plural"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_item_inputs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"input_type"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetCircleByIdQuery__
 *
 * To run a query within a React component, call `useGetCircleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCircleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCircleByIdQuery({
 *   variables: {
 *      circleId: // value for 'circleId'
 *   },
 * });
 */
export function useGetCircleByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCircleByIdQuery, GetCircleByIdQueryVariables> & ({ variables: GetCircleByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCircleByIdQuery, GetCircleByIdQueryVariables>(GetCircleByIdDocument, options);
      }
export function useGetCircleByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCircleByIdQuery, GetCircleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCircleByIdQuery, GetCircleByIdQueryVariables>(GetCircleByIdDocument, options);
        }
export function useGetCircleByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCircleByIdQuery, GetCircleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCircleByIdQuery, GetCircleByIdQueryVariables>(GetCircleByIdDocument, options);
        }
export type GetCircleByIdQueryHookResult = ReturnType<typeof useGetCircleByIdQuery>;
export type GetCircleByIdLazyQueryHookResult = ReturnType<typeof useGetCircleByIdLazyQuery>;
export type GetCircleByIdSuspenseQueryHookResult = ReturnType<typeof useGetCircleByIdSuspenseQuery>;
export type GetCircleByIdQueryResult = Apollo.QueryResult<GetCircleByIdQuery, GetCircleByIdQueryVariables>;
export const GetCirclesByInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCirclesByInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invite"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_circles_by_invite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invite"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CircleInviteAndCircleDetailsSharedFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CircleImageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"circle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hero_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CircleInviteAndCircleDetailsSharedFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"circle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"checkout_bundle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"related_contents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"entity_id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CircleImageFields"}},{"kind":"Field","alias":{"kind":"Name","value":"action_items"},"name":{"kind":"Name","value":"action_items_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"action_item_user"},"name":{"kind":"Name","value":"template_action_item_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"personalized_name"}},{"kind":"Field","name":{"kind":"Name","value":"preference_value_target"}},{"kind":"Field","name":{"kind":"Name","value":"instance_target"}},{"kind":"Field","name":{"kind":"Name","value":"instance_target_type"}},{"kind":"Field","name":{"kind":"Name","value":"value_rollup_type"}},{"kind":"Field","name":{"kind":"Name","value":"weekly_instance_target"}},{"kind":"Field","name":{"kind":"Name","value":"circle_action_items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sort_order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_image"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"interval_type"}},{"kind":"Field","name":{"kind":"Name","value":"interval_count"}},{"kind":"Field","name":{"kind":"Name","value":"preference_value_target"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}},{"kind":"Field","name":{"kind":"Name","value":"display_symbol_plural"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name_plural"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_item_inputs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"input_type"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetCirclesByInviteQuery__
 *
 * To run a query within a React component, call `useGetCirclesByInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCirclesByInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCirclesByInviteQuery({
 *   variables: {
 *      invite: // value for 'invite'
 *   },
 * });
 */
export function useGetCirclesByInviteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCirclesByInviteQuery, GetCirclesByInviteQueryVariables> & ({ variables: GetCirclesByInviteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCirclesByInviteQuery, GetCirclesByInviteQueryVariables>(GetCirclesByInviteDocument, options);
      }
export function useGetCirclesByInviteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCirclesByInviteQuery, GetCirclesByInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCirclesByInviteQuery, GetCirclesByInviteQueryVariables>(GetCirclesByInviteDocument, options);
        }
export function useGetCirclesByInviteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCirclesByInviteQuery, GetCirclesByInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCirclesByInviteQuery, GetCirclesByInviteQueryVariables>(GetCirclesByInviteDocument, options);
        }
export type GetCirclesByInviteQueryHookResult = ReturnType<typeof useGetCirclesByInviteQuery>;
export type GetCirclesByInviteLazyQueryHookResult = ReturnType<typeof useGetCirclesByInviteLazyQuery>;
export type GetCirclesByInviteSuspenseQueryHookResult = ReturnType<typeof useGetCirclesByInviteSuspenseQuery>;
export type GetCirclesByInviteQueryResult = Apollo.QueryResult<GetCirclesByInviteQuery, GetCirclesByInviteQueryVariables>;
export const MyProfileDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyProfileData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"photo_url"}},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"stream_user_id"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMyProfileDataQuery__
 *
 * To run a query within a React component, call `useMyProfileDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProfileDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfileDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyProfileDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyProfileDataQuery, MyProfileDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyProfileDataQuery, MyProfileDataQueryVariables>(MyProfileDataDocument, options);
      }
export function useMyProfileDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyProfileDataQuery, MyProfileDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyProfileDataQuery, MyProfileDataQueryVariables>(MyProfileDataDocument, options);
        }
export function useMyProfileDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyProfileDataQuery, MyProfileDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyProfileDataQuery, MyProfileDataQueryVariables>(MyProfileDataDocument, options);
        }
export type MyProfileDataQueryHookResult = ReturnType<typeof useMyProfileDataQuery>;
export type MyProfileDataLazyQueryHookResult = ReturnType<typeof useMyProfileDataLazyQuery>;
export type MyProfileDataSuspenseQueryHookResult = ReturnType<typeof useMyProfileDataSuspenseQuery>;
export type MyProfileDataQueryResult = Apollo.QueryResult<MyProfileDataQuery, MyProfileDataQueryVariables>;
export const UpdateCircleByCircleIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCircleByCircleId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"circleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"circle_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_circle_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"circleId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type UpdateCircleByCircleIdMutationFn = Apollo.MutationFunction<UpdateCircleByCircleIdMutation, UpdateCircleByCircleIdMutationVariables>;

/**
 * __useUpdateCircleByCircleIdMutation__
 *
 * To run a mutation, you first call `useUpdateCircleByCircleIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCircleByCircleIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCircleByCircleIdMutation, { data, loading, error }] = useUpdateCircleByCircleIdMutation({
 *   variables: {
 *      circleId: // value for 'circleId'
 *      changes: // value for 'changes'
 *   },
 * });
 */
export function useUpdateCircleByCircleIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCircleByCircleIdMutation, UpdateCircleByCircleIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCircleByCircleIdMutation, UpdateCircleByCircleIdMutationVariables>(UpdateCircleByCircleIdDocument, options);
      }
export type UpdateCircleByCircleIdMutationHookResult = ReturnType<typeof useUpdateCircleByCircleIdMutation>;
export type UpdateCircleByCircleIdMutationResult = Apollo.MutationResult<UpdateCircleByCircleIdMutation>;
export type UpdateCircleByCircleIdMutationOptions = Apollo.BaseMutationOptions<UpdateCircleByCircleIdMutation, UpdateCircleByCircleIdMutationVariables>;
export const CircleSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CircleSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"circleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circle_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"circleId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"action_item_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActionItemUserFields"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"me_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"action_items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"disabled"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActionItemUserFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionItemUserFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"action_item_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"personalized_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"action_item_user_inputs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"action_item_input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"manual_entry_log"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_item_input"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data_source"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prevent_add_to_circle"}},{"kind":"Field","name":{"kind":"Name","value":"prevent_add_to_circle_reason"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCircleSettingsQuery__
 *
 * To run a query within a React component, call `useCircleSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCircleSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCircleSettingsQuery({
 *   variables: {
 *      circleId: // value for 'circleId'
 *   },
 * });
 */
export function useCircleSettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CircleSettingsQuery, CircleSettingsQueryVariables> & ({ variables: CircleSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CircleSettingsQuery, CircleSettingsQueryVariables>(CircleSettingsDocument, options);
      }
export function useCircleSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CircleSettingsQuery, CircleSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CircleSettingsQuery, CircleSettingsQueryVariables>(CircleSettingsDocument, options);
        }
export function useCircleSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CircleSettingsQuery, CircleSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CircleSettingsQuery, CircleSettingsQueryVariables>(CircleSettingsDocument, options);
        }
export type CircleSettingsQueryHookResult = ReturnType<typeof useCircleSettingsQuery>;
export type CircleSettingsLazyQueryHookResult = ReturnType<typeof useCircleSettingsLazyQuery>;
export type CircleSettingsSuspenseQueryHookResult = ReturnType<typeof useCircleSettingsSuspenseQuery>;
export type CircleSettingsQueryResult = Apollo.QueryResult<CircleSettingsQuery, CircleSettingsQueryVariables>;
export const UpdateCircleActionItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCircleActionItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"additions"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"circle_action_item_insert_input"}}}},"defaultValue":{"kind":"ListValue","values":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"circle_action_item_updates"}}}},"defaultValue":{"kind":"ListValue","values":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_circle_action_item"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"additions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_circle_action_item_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode;
export type UpdateCircleActionItemsMutationFn = Apollo.MutationFunction<UpdateCircleActionItemsMutation, UpdateCircleActionItemsMutationVariables>;

/**
 * __useUpdateCircleActionItemsMutation__
 *
 * To run a mutation, you first call `useUpdateCircleActionItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCircleActionItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCircleActionItemsMutation, { data, loading, error }] = useUpdateCircleActionItemsMutation({
 *   variables: {
 *      additions: // value for 'additions'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateCircleActionItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCircleActionItemsMutation, UpdateCircleActionItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCircleActionItemsMutation, UpdateCircleActionItemsMutationVariables>(UpdateCircleActionItemsDocument, options);
      }
export type UpdateCircleActionItemsMutationHookResult = ReturnType<typeof useUpdateCircleActionItemsMutation>;
export type UpdateCircleActionItemsMutationResult = Apollo.MutationResult<UpdateCircleActionItemsMutation>;
export type UpdateCircleActionItemsMutationOptions = Apollo.BaseMutationOptions<UpdateCircleActionItemsMutation, UpdateCircleActionItemsMutationVariables>;
export const IsCurrentCircleMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IsCurrentCircleMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"circleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circle_memberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"circle_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"circleId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"circle"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"memberships"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"circle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useIsCurrentCircleMemberQuery__
 *
 * To run a query within a React component, call `useIsCurrentCircleMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsCurrentCircleMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsCurrentCircleMemberQuery({
 *   variables: {
 *      circleId: // value for 'circleId'
 *   },
 * });
 */
export function useIsCurrentCircleMemberQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IsCurrentCircleMemberQuery, IsCurrentCircleMemberQueryVariables> & ({ variables: IsCurrentCircleMemberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IsCurrentCircleMemberQuery, IsCurrentCircleMemberQueryVariables>(IsCurrentCircleMemberDocument, options);
      }
export function useIsCurrentCircleMemberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IsCurrentCircleMemberQuery, IsCurrentCircleMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IsCurrentCircleMemberQuery, IsCurrentCircleMemberQueryVariables>(IsCurrentCircleMemberDocument, options);
        }
export function useIsCurrentCircleMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<IsCurrentCircleMemberQuery, IsCurrentCircleMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IsCurrentCircleMemberQuery, IsCurrentCircleMemberQueryVariables>(IsCurrentCircleMemberDocument, options);
        }
export type IsCurrentCircleMemberQueryHookResult = ReturnType<typeof useIsCurrentCircleMemberQuery>;
export type IsCurrentCircleMemberLazyQueryHookResult = ReturnType<typeof useIsCurrentCircleMemberLazyQuery>;
export type IsCurrentCircleMemberSuspenseQueryHookResult = ReturnType<typeof useIsCurrentCircleMemberSuspenseQuery>;
export type IsCurrentCircleMemberQueryResult = Apollo.QueryResult<IsCurrentCircleMemberQuery, IsCurrentCircleMemberQueryVariables>;
export const CircleContentByInviteShortIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CircleContentByInviteShortId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteShortId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_circles_by_invite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"invite"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteShortId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"hero_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCircleContentByInviteShortIdQuery__
 *
 * To run a query within a React component, call `useCircleContentByInviteShortIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCircleContentByInviteShortIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCircleContentByInviteShortIdQuery({
 *   variables: {
 *      inviteShortId: // value for 'inviteShortId'
 *   },
 * });
 */
export function useCircleContentByInviteShortIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CircleContentByInviteShortIdQuery, CircleContentByInviteShortIdQueryVariables> & ({ variables: CircleContentByInviteShortIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CircleContentByInviteShortIdQuery, CircleContentByInviteShortIdQueryVariables>(CircleContentByInviteShortIdDocument, options);
      }
export function useCircleContentByInviteShortIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CircleContentByInviteShortIdQuery, CircleContentByInviteShortIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CircleContentByInviteShortIdQuery, CircleContentByInviteShortIdQueryVariables>(CircleContentByInviteShortIdDocument, options);
        }
export function useCircleContentByInviteShortIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CircleContentByInviteShortIdQuery, CircleContentByInviteShortIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CircleContentByInviteShortIdQuery, CircleContentByInviteShortIdQueryVariables>(CircleContentByInviteShortIdDocument, options);
        }
export type CircleContentByInviteShortIdQueryHookResult = ReturnType<typeof useCircleContentByInviteShortIdQuery>;
export type CircleContentByInviteShortIdLazyQueryHookResult = ReturnType<typeof useCircleContentByInviteShortIdLazyQuery>;
export type CircleContentByInviteShortIdSuspenseQueryHookResult = ReturnType<typeof useCircleContentByInviteShortIdSuspenseQuery>;
export type CircleContentByInviteShortIdQueryResult = Apollo.QueryResult<CircleContentByInviteShortIdQuery, CircleContentByInviteShortIdQueryVariables>;
export const VerifyUpdateEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyUpdateEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verify_update_email"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode;
export type VerifyUpdateEmailMutationFn = Apollo.MutationFunction<VerifyUpdateEmailMutation, VerifyUpdateEmailMutationVariables>;

/**
 * __useVerifyUpdateEmailMutation__
 *
 * To run a mutation, you first call `useVerifyUpdateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyUpdateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyUpdateEmailMutation, { data, loading, error }] = useVerifyUpdateEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyUpdateEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyUpdateEmailMutation, VerifyUpdateEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VerifyUpdateEmailMutation, VerifyUpdateEmailMutationVariables>(VerifyUpdateEmailDocument, options);
      }
export type VerifyUpdateEmailMutationHookResult = ReturnType<typeof useVerifyUpdateEmailMutation>;
export type VerifyUpdateEmailMutationResult = Apollo.MutationResult<VerifyUpdateEmailMutation>;
export type VerifyUpdateEmailMutationOptions = Apollo.BaseMutationOptions<VerifyUpdateEmailMutation, VerifyUpdateEmailMutationVariables>;
export const VerifyUpdateLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VerifyUpdateLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verify_update_link"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useVerifyUpdateLinkQuery__
 *
 * To run a query within a React component, call `useVerifyUpdateLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyUpdateLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyUpdateLinkQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyUpdateLinkQuery(baseOptions: ApolloReactHooks.QueryHookOptions<VerifyUpdateLinkQuery, VerifyUpdateLinkQueryVariables> & ({ variables: VerifyUpdateLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VerifyUpdateLinkQuery, VerifyUpdateLinkQueryVariables>(VerifyUpdateLinkDocument, options);
      }
export function useVerifyUpdateLinkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VerifyUpdateLinkQuery, VerifyUpdateLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VerifyUpdateLinkQuery, VerifyUpdateLinkQueryVariables>(VerifyUpdateLinkDocument, options);
        }
export function useVerifyUpdateLinkSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<VerifyUpdateLinkQuery, VerifyUpdateLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<VerifyUpdateLinkQuery, VerifyUpdateLinkQueryVariables>(VerifyUpdateLinkDocument, options);
        }
export type VerifyUpdateLinkQueryHookResult = ReturnType<typeof useVerifyUpdateLinkQuery>;
export type VerifyUpdateLinkLazyQueryHookResult = ReturnType<typeof useVerifyUpdateLinkLazyQuery>;
export type VerifyUpdateLinkSuspenseQueryHookResult = ReturnType<typeof useVerifyUpdateLinkSuspenseQuery>;
export type VerifyUpdateLinkQueryResult = Apollo.QueryResult<VerifyUpdateLinkQuery, VerifyUpdateLinkQueryVariables>;
export const SaveContactEnquiryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveContactEnquiry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveContactEnquiryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveContactEnquiry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode;
export type SaveContactEnquiryMutationFn = Apollo.MutationFunction<SaveContactEnquiryMutation, SaveContactEnquiryMutationVariables>;

/**
 * __useSaveContactEnquiryMutation__
 *
 * To run a mutation, you first call `useSaveContactEnquiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveContactEnquiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveContactEnquiryMutation, { data, loading, error }] = useSaveContactEnquiryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveContactEnquiryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveContactEnquiryMutation, SaveContactEnquiryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveContactEnquiryMutation, SaveContactEnquiryMutationVariables>(SaveContactEnquiryDocument, options);
      }
export type SaveContactEnquiryMutationHookResult = ReturnType<typeof useSaveContactEnquiryMutation>;
export type SaveContactEnquiryMutationResult = Apollo.MutationResult<SaveContactEnquiryMutation>;
export type SaveContactEnquiryMutationOptions = Apollo.BaseMutationOptions<SaveContactEnquiryMutation, SaveContactEnquiryMutationVariables>;
export const MetricTextSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MetricTextSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricWhereClause"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"metric_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric"},"name":{"kind":"Name","value":"search_metrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricWhereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric_records_aggregate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"count"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"display_name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"300"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"data_source"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data_source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric_records_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMetricTextSearchQuery__
 *
 * To run a query within a React component, call `useMetricTextSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricTextSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricTextSearchQuery({
 *   variables: {
 *      text: // value for 'text'
 *      metricWhereClause: // value for 'metricWhereClause'
 *   },
 * });
 */
export function useMetricTextSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MetricTextSearchQuery, MetricTextSearchQueryVariables> & ({ variables: MetricTextSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MetricTextSearchQuery, MetricTextSearchQueryVariables>(MetricTextSearchDocument, options);
      }
export function useMetricTextSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetricTextSearchQuery, MetricTextSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MetricTextSearchQuery, MetricTextSearchQueryVariables>(MetricTextSearchDocument, options);
        }
export function useMetricTextSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MetricTextSearchQuery, MetricTextSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MetricTextSearchQuery, MetricTextSearchQueryVariables>(MetricTextSearchDocument, options);
        }
export type MetricTextSearchQueryHookResult = ReturnType<typeof useMetricTextSearchQuery>;
export type MetricTextSearchLazyQueryHookResult = ReturnType<typeof useMetricTextSearchLazyQuery>;
export type MetricTextSearchSuspenseQueryHookResult = ReturnType<typeof useMetricTextSearchSuspenseQuery>;
export type MetricTextSearchQueryResult = Apollo.QueryResult<MetricTextSearchQuery, MetricTextSearchQueryVariables>;
export const InsertDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"New Dashboard","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chartTabs"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard_chart_tab_arr_rel_insert_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_dashboard_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tabs"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"New Dashboard Tab","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"charts"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"New Chart","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"chart_tabs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chartTabs"}}}]}]}}]}}]}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tabs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chart_tabs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"views"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chart_type"}},{"kind":"Field","name":{"kind":"Name","value":"view_metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rollup_type"}},{"kind":"Field","name":{"kind":"Name","value":"interval_count"}},{"kind":"Field","name":{"kind":"Name","value":"interval_type"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}},{"kind":"Field","name":{"kind":"Name","value":"metric_id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metricDisplayName"},"name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export type InsertDashboardMutationFn = Apollo.MutationFunction<InsertDashboardMutation, InsertDashboardMutationVariables>;

/**
 * __useInsertDashboardMutation__
 *
 * To run a mutation, you first call `useInsertDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertDashboardMutation, { data, loading, error }] = useInsertDashboardMutation({
 *   variables: {
 *      name: // value for 'name'
 *      chartTabs: // value for 'chartTabs'
 *   },
 * });
 */
export function useInsertDashboardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertDashboardMutation, InsertDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InsertDashboardMutation, InsertDashboardMutationVariables>(InsertDashboardDocument, options);
      }
export type InsertDashboardMutationHookResult = ReturnType<typeof useInsertDashboardMutation>;
export type InsertDashboardMutationResult = Apollo.MutationResult<InsertDashboardMutation>;
export type InsertDashboardMutationOptions = Apollo.BaseMutationOptions<InsertDashboardMutation, InsertDashboardMutationVariables>;
export const UpdateDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_dashboard_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}}]}}]}}]} as unknown as DocumentNode;
export type UpdateDashboardMutationFn = Apollo.MutationFunction<UpdateDashboardMutation, UpdateDashboardMutationVariables>;

/**
 * __useUpdateDashboardMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardMutation, { data, loading, error }] = useUpdateDashboardMutation({
 *   variables: {
 *      id: // value for 'id'
 *      changes: // value for 'changes'
 *   },
 * });
 */
export function useUpdateDashboardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDashboardMutation, UpdateDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDashboardMutation, UpdateDashboardMutationVariables>(UpdateDashboardDocument, options);
      }
export type UpdateDashboardMutationHookResult = ReturnType<typeof useUpdateDashboardMutation>;
export type UpdateDashboardMutationResult = Apollo.MutationResult<UpdateDashboardMutation>;
export type UpdateDashboardMutationOptions = Apollo.BaseMutationOptions<UpdateDashboardMutation, UpdateDashboardMutationVariables>;
export const UpdateDashboardTabDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDashboardTab"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard_tab_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_dashboard_tab_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dashboard_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}}]}}]}}]} as unknown as DocumentNode;
export type UpdateDashboardTabMutationFn = Apollo.MutationFunction<UpdateDashboardTabMutation, UpdateDashboardTabMutationVariables>;

/**
 * __useUpdateDashboardTabMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardTabMutation, { data, loading, error }] = useUpdateDashboardTabMutation({
 *   variables: {
 *      id: // value for 'id'
 *      changes: // value for 'changes'
 *   },
 * });
 */
export function useUpdateDashboardTabMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDashboardTabMutation, UpdateDashboardTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDashboardTabMutation, UpdateDashboardTabMutationVariables>(UpdateDashboardTabDocument, options);
      }
export type UpdateDashboardTabMutationHookResult = ReturnType<typeof useUpdateDashboardTabMutation>;
export type UpdateDashboardTabMutationResult = Apollo.MutationResult<UpdateDashboardTabMutation>;
export type UpdateDashboardTabMutationOptions = Apollo.BaseMutationOptions<UpdateDashboardTabMutation, UpdateDashboardTabMutationVariables>;
export const UpdateDashboardChartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDashboardChart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard_chart_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_dashboard_chart_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dashboard_tab_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}}]}}]}}]} as unknown as DocumentNode;
export type UpdateDashboardChartMutationFn = Apollo.MutationFunction<UpdateDashboardChartMutation, UpdateDashboardChartMutationVariables>;

/**
 * __useUpdateDashboardChartMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardChartMutation, { data, loading, error }] = useUpdateDashboardChartMutation({
 *   variables: {
 *      id: // value for 'id'
 *      changes: // value for 'changes'
 *   },
 * });
 */
export function useUpdateDashboardChartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDashboardChartMutation, UpdateDashboardChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDashboardChartMutation, UpdateDashboardChartMutationVariables>(UpdateDashboardChartDocument, options);
      }
export type UpdateDashboardChartMutationHookResult = ReturnType<typeof useUpdateDashboardChartMutation>;
export type UpdateDashboardChartMutationResult = Apollo.MutationResult<UpdateDashboardChartMutation>;
export type UpdateDashboardChartMutationOptions = Apollo.BaseMutationOptions<UpdateDashboardChartMutation, UpdateDashboardChartMutationVariables>;
export const UpdateDashboardChartTabDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDashboardChartTab"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard_chart_tab_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_dashboard_chart_tab_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dashboard_chart_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}},{"kind":"Field","name":{"kind":"Name","value":"chart_type"}}]}}]}}]} as unknown as DocumentNode;
export type UpdateDashboardChartTabMutationFn = Apollo.MutationFunction<UpdateDashboardChartTabMutation, UpdateDashboardChartTabMutationVariables>;

/**
 * __useUpdateDashboardChartTabMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardChartTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardChartTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardChartTabMutation, { data, loading, error }] = useUpdateDashboardChartTabMutation({
 *   variables: {
 *      id: // value for 'id'
 *      changes: // value for 'changes'
 *   },
 * });
 */
export function useUpdateDashboardChartTabMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDashboardChartTabMutation, UpdateDashboardChartTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDashboardChartTabMutation, UpdateDashboardChartTabMutationVariables>(UpdateDashboardChartTabDocument, options);
      }
export type UpdateDashboardChartTabMutationHookResult = ReturnType<typeof useUpdateDashboardChartTabMutation>;
export type UpdateDashboardChartTabMutationResult = Apollo.MutationResult<UpdateDashboardChartTabMutation>;
export type UpdateDashboardChartTabMutationOptions = Apollo.BaseMutationOptions<UpdateDashboardChartTabMutation, UpdateDashboardChartTabMutationVariables>;
export const UpdateDashboardChartViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDashboardChartView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard_chart_view_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_dashboard_chart_view_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dashboard_chart_tab_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}}]}}]}}]} as unknown as DocumentNode;
export type UpdateDashboardChartViewMutationFn = Apollo.MutationFunction<UpdateDashboardChartViewMutation, UpdateDashboardChartViewMutationVariables>;

/**
 * __useUpdateDashboardChartViewMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardChartViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardChartViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardChartViewMutation, { data, loading, error }] = useUpdateDashboardChartViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      changes: // value for 'changes'
 *   },
 * });
 */
export function useUpdateDashboardChartViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDashboardChartViewMutation, UpdateDashboardChartViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDashboardChartViewMutation, UpdateDashboardChartViewMutationVariables>(UpdateDashboardChartViewDocument, options);
      }
export type UpdateDashboardChartViewMutationHookResult = ReturnType<typeof useUpdateDashboardChartViewMutation>;
export type UpdateDashboardChartViewMutationResult = Apollo.MutationResult<UpdateDashboardChartViewMutation>;
export type UpdateDashboardChartViewMutationOptions = Apollo.BaseMutationOptions<UpdateDashboardChartViewMutation, UpdateDashboardChartViewMutationVariables>;
export const UpdateDashboardChartMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDashboardChartMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard_chart_metric_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_dashboard_chart_metric_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rollup_type"}}]}}]}}]} as unknown as DocumentNode;
export type UpdateDashboardChartMetricMutationFn = Apollo.MutationFunction<UpdateDashboardChartMetricMutation, UpdateDashboardChartMetricMutationVariables>;

/**
 * __useUpdateDashboardChartMetricMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardChartMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardChartMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardChartMetricMutation, { data, loading, error }] = useUpdateDashboardChartMetricMutation({
 *   variables: {
 *      id: // value for 'id'
 *      changes: // value for 'changes'
 *   },
 * });
 */
export function useUpdateDashboardChartMetricMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDashboardChartMetricMutation, UpdateDashboardChartMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDashboardChartMetricMutation, UpdateDashboardChartMetricMutationVariables>(UpdateDashboardChartMetricDocument, options);
      }
export type UpdateDashboardChartMetricMutationHookResult = ReturnType<typeof useUpdateDashboardChartMetricMutation>;
export type UpdateDashboardChartMetricMutationResult = Apollo.MutationResult<UpdateDashboardChartMetricMutation>;
export type UpdateDashboardChartMetricMutationOptions = Apollo.BaseMutationOptions<UpdateDashboardChartMetricMutation, UpdateDashboardChartMetricMutationVariables>;
export const UpdateChartViewChartTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateChartViewChartType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chart_type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"enum_chart_type_enum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_dashboard_chart_view_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"chart_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chart_type"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type UpdateChartViewChartTypeMutationFn = Apollo.MutationFunction<UpdateChartViewChartTypeMutation, UpdateChartViewChartTypeMutationVariables>;

/**
 * __useUpdateChartViewChartTypeMutation__
 *
 * To run a mutation, you first call `useUpdateChartViewChartTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChartViewChartTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChartViewChartTypeMutation, { data, loading, error }] = useUpdateChartViewChartTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      chart_type: // value for 'chart_type'
 *   },
 * });
 */
export function useUpdateChartViewChartTypeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateChartViewChartTypeMutation, UpdateChartViewChartTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateChartViewChartTypeMutation, UpdateChartViewChartTypeMutationVariables>(UpdateChartViewChartTypeDocument, options);
      }
export type UpdateChartViewChartTypeMutationHookResult = ReturnType<typeof useUpdateChartViewChartTypeMutation>;
export type UpdateChartViewChartTypeMutationResult = Apollo.MutationResult<UpdateChartViewChartTypeMutation>;
export type UpdateChartViewChartTypeMutationOptions = Apollo.BaseMutationOptions<UpdateChartViewChartTypeMutation, UpdateChartViewChartTypeMutationVariables>;
export const InsertDashboardTabDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertDashboardTab"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard_tab_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_dashboard_tab_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type InsertDashboardTabMutationFn = Apollo.MutationFunction<InsertDashboardTabMutation, InsertDashboardTabMutationVariables>;

/**
 * __useInsertDashboardTabMutation__
 *
 * To run a mutation, you first call `useInsertDashboardTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertDashboardTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertDashboardTabMutation, { data, loading, error }] = useInsertDashboardTabMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertDashboardTabMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertDashboardTabMutation, InsertDashboardTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InsertDashboardTabMutation, InsertDashboardTabMutationVariables>(InsertDashboardTabDocument, options);
      }
export type InsertDashboardTabMutationHookResult = ReturnType<typeof useInsertDashboardTabMutation>;
export type InsertDashboardTabMutationResult = Apollo.MutationResult<InsertDashboardTabMutation>;
export type InsertDashboardTabMutationOptions = Apollo.BaseMutationOptions<InsertDashboardTabMutation, InsertDashboardTabMutationVariables>;
export const InsertDashboardChartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertDashboardChart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard_chart_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_dashboard_chart_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type InsertDashboardChartMutationFn = Apollo.MutationFunction<InsertDashboardChartMutation, InsertDashboardChartMutationVariables>;

/**
 * __useInsertDashboardChartMutation__
 *
 * To run a mutation, you first call `useInsertDashboardChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertDashboardChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertDashboardChartMutation, { data, loading, error }] = useInsertDashboardChartMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertDashboardChartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertDashboardChartMutation, InsertDashboardChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InsertDashboardChartMutation, InsertDashboardChartMutationVariables>(InsertDashboardChartDocument, options);
      }
export type InsertDashboardChartMutationHookResult = ReturnType<typeof useInsertDashboardChartMutation>;
export type InsertDashboardChartMutationResult = Apollo.MutationResult<InsertDashboardChartMutation>;
export type InsertDashboardChartMutationOptions = Apollo.BaseMutationOptions<InsertDashboardChartMutation, InsertDashboardChartMutationVariables>;
export const InsertDashboardChartTabDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertDashboardChartTab"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard_chart_tab_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_dashboard_chart_tab_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type InsertDashboardChartTabMutationFn = Apollo.MutationFunction<InsertDashboardChartTabMutation, InsertDashboardChartTabMutationVariables>;

/**
 * __useInsertDashboardChartTabMutation__
 *
 * To run a mutation, you first call `useInsertDashboardChartTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertDashboardChartTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertDashboardChartTabMutation, { data, loading, error }] = useInsertDashboardChartTabMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertDashboardChartTabMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertDashboardChartTabMutation, InsertDashboardChartTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InsertDashboardChartTabMutation, InsertDashboardChartTabMutationVariables>(InsertDashboardChartTabDocument, options);
      }
export type InsertDashboardChartTabMutationHookResult = ReturnType<typeof useInsertDashboardChartTabMutation>;
export type InsertDashboardChartTabMutationResult = Apollo.MutationResult<InsertDashboardChartTabMutation>;
export type InsertDashboardChartTabMutationOptions = Apollo.BaseMutationOptions<InsertDashboardChartTabMutation, InsertDashboardChartTabMutationVariables>;
export const InsertDashboardChartViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertDashboardChartView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard_chart_view_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_dashboard_chart_view_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type InsertDashboardChartViewMutationFn = Apollo.MutationFunction<InsertDashboardChartViewMutation, InsertDashboardChartViewMutationVariables>;

/**
 * __useInsertDashboardChartViewMutation__
 *
 * To run a mutation, you first call `useInsertDashboardChartViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertDashboardChartViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertDashboardChartViewMutation, { data, loading, error }] = useInsertDashboardChartViewMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertDashboardChartViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertDashboardChartViewMutation, InsertDashboardChartViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InsertDashboardChartViewMutation, InsertDashboardChartViewMutationVariables>(InsertDashboardChartViewDocument, options);
      }
export type InsertDashboardChartViewMutationHookResult = ReturnType<typeof useInsertDashboardChartViewMutation>;
export type InsertDashboardChartViewMutationResult = Apollo.MutationResult<InsertDashboardChartViewMutation>;
export type InsertDashboardChartViewMutationOptions = Apollo.BaseMutationOptions<InsertDashboardChartViewMutation, InsertDashboardChartViewMutationVariables>;
export const InsertDashboardChartMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertDashboardChartMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard_chart_metric_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_dashboard_chart_metric_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rollup_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;
export type InsertDashboardChartMetricMutationFn = Apollo.MutationFunction<InsertDashboardChartMetricMutation, InsertDashboardChartMetricMutationVariables>;

/**
 * __useInsertDashboardChartMetricMutation__
 *
 * To run a mutation, you first call `useInsertDashboardChartMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertDashboardChartMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertDashboardChartMetricMutation, { data, loading, error }] = useInsertDashboardChartMetricMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertDashboardChartMetricMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertDashboardChartMetricMutation, InsertDashboardChartMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InsertDashboardChartMetricMutation, InsertDashboardChartMetricMutationVariables>(InsertDashboardChartMetricDocument, options);
      }
export type InsertDashboardChartMetricMutationHookResult = ReturnType<typeof useInsertDashboardChartMetricMutation>;
export type InsertDashboardChartMetricMutationResult = Apollo.MutationResult<InsertDashboardChartMetricMutation>;
export type InsertDashboardChartMetricMutationOptions = Apollo.BaseMutationOptions<InsertDashboardChartMetricMutation, InsertDashboardChartMetricMutationVariables>;
export const DeleteDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_dashboard_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;
export type DeleteDashboardMutationFn = Apollo.MutationFunction<DeleteDashboardMutation, DeleteDashboardMutationVariables>;

/**
 * __useDeleteDashboardMutation__
 *
 * To run a mutation, you first call `useDeleteDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDashboardMutation, { data, loading, error }] = useDeleteDashboardMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDashboardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDashboardMutation, DeleteDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDashboardMutation, DeleteDashboardMutationVariables>(DeleteDashboardDocument, options);
      }
export type DeleteDashboardMutationHookResult = ReturnType<typeof useDeleteDashboardMutation>;
export type DeleteDashboardMutationResult = Apollo.MutationResult<DeleteDashboardMutation>;
export type DeleteDashboardMutationOptions = Apollo.BaseMutationOptions<DeleteDashboardMutation, DeleteDashboardMutationVariables>;
export const DeleteDashboardTabDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDashboardTab"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_dashboard_tab_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;
export type DeleteDashboardTabMutationFn = Apollo.MutationFunction<DeleteDashboardTabMutation, DeleteDashboardTabMutationVariables>;

/**
 * __useDeleteDashboardTabMutation__
 *
 * To run a mutation, you first call `useDeleteDashboardTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDashboardTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDashboardTabMutation, { data, loading, error }] = useDeleteDashboardTabMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDashboardTabMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDashboardTabMutation, DeleteDashboardTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDashboardTabMutation, DeleteDashboardTabMutationVariables>(DeleteDashboardTabDocument, options);
      }
export type DeleteDashboardTabMutationHookResult = ReturnType<typeof useDeleteDashboardTabMutation>;
export type DeleteDashboardTabMutationResult = Apollo.MutationResult<DeleteDashboardTabMutation>;
export type DeleteDashboardTabMutationOptions = Apollo.BaseMutationOptions<DeleteDashboardTabMutation, DeleteDashboardTabMutationVariables>;
export const DeleteDashboardChartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDashboardChart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_dashboard_chart_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;
export type DeleteDashboardChartMutationFn = Apollo.MutationFunction<DeleteDashboardChartMutation, DeleteDashboardChartMutationVariables>;

/**
 * __useDeleteDashboardChartMutation__
 *
 * To run a mutation, you first call `useDeleteDashboardChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDashboardChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDashboardChartMutation, { data, loading, error }] = useDeleteDashboardChartMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDashboardChartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDashboardChartMutation, DeleteDashboardChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDashboardChartMutation, DeleteDashboardChartMutationVariables>(DeleteDashboardChartDocument, options);
      }
export type DeleteDashboardChartMutationHookResult = ReturnType<typeof useDeleteDashboardChartMutation>;
export type DeleteDashboardChartMutationResult = Apollo.MutationResult<DeleteDashboardChartMutation>;
export type DeleteDashboardChartMutationOptions = Apollo.BaseMutationOptions<DeleteDashboardChartMutation, DeleteDashboardChartMutationVariables>;
export const DeleteDashboardChartTabDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDashboardChartTab"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_dashboard_chart_tab_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;
export type DeleteDashboardChartTabMutationFn = Apollo.MutationFunction<DeleteDashboardChartTabMutation, DeleteDashboardChartTabMutationVariables>;

/**
 * __useDeleteDashboardChartTabMutation__
 *
 * To run a mutation, you first call `useDeleteDashboardChartTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDashboardChartTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDashboardChartTabMutation, { data, loading, error }] = useDeleteDashboardChartTabMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDashboardChartTabMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDashboardChartTabMutation, DeleteDashboardChartTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDashboardChartTabMutation, DeleteDashboardChartTabMutationVariables>(DeleteDashboardChartTabDocument, options);
      }
export type DeleteDashboardChartTabMutationHookResult = ReturnType<typeof useDeleteDashboardChartTabMutation>;
export type DeleteDashboardChartTabMutationResult = Apollo.MutationResult<DeleteDashboardChartTabMutation>;
export type DeleteDashboardChartTabMutationOptions = Apollo.BaseMutationOptions<DeleteDashboardChartTabMutation, DeleteDashboardChartTabMutationVariables>;
export const DeleteDashboardChartViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDashboardChartView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_dashboard_chart_view_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;
export type DeleteDashboardChartViewMutationFn = Apollo.MutationFunction<DeleteDashboardChartViewMutation, DeleteDashboardChartViewMutationVariables>;

/**
 * __useDeleteDashboardChartViewMutation__
 *
 * To run a mutation, you first call `useDeleteDashboardChartViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDashboardChartViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDashboardChartViewMutation, { data, loading, error }] = useDeleteDashboardChartViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDashboardChartViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDashboardChartViewMutation, DeleteDashboardChartViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDashboardChartViewMutation, DeleteDashboardChartViewMutationVariables>(DeleteDashboardChartViewDocument, options);
      }
export type DeleteDashboardChartViewMutationHookResult = ReturnType<typeof useDeleteDashboardChartViewMutation>;
export type DeleteDashboardChartViewMutationResult = Apollo.MutationResult<DeleteDashboardChartViewMutation>;
export type DeleteDashboardChartViewMutationOptions = Apollo.BaseMutationOptions<DeleteDashboardChartViewMutation, DeleteDashboardChartViewMutationVariables>;
export const DeleteDashboardChartMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDashboardChartMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_dashboard_chart_metric_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;
export type DeleteDashboardChartMetricMutationFn = Apollo.MutationFunction<DeleteDashboardChartMetricMutation, DeleteDashboardChartMetricMutationVariables>;

/**
 * __useDeleteDashboardChartMetricMutation__
 *
 * To run a mutation, you first call `useDeleteDashboardChartMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDashboardChartMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDashboardChartMetricMutation, { data, loading, error }] = useDeleteDashboardChartMetricMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDashboardChartMetricMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDashboardChartMetricMutation, DeleteDashboardChartMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDashboardChartMetricMutation, DeleteDashboardChartMetricMutationVariables>(DeleteDashboardChartMetricDocument, options);
      }
export type DeleteDashboardChartMetricMutationHookResult = ReturnType<typeof useDeleteDashboardChartMetricMutation>;
export type DeleteDashboardChartMetricMutationResult = Apollo.MutationResult<DeleteDashboardChartMetricMutation>;
export type DeleteDashboardChartMetricMutationOptions = Apollo.BaseMutationOptions<DeleteDashboardChartMetricMutation, DeleteDashboardChartMetricMutationVariables>;
export const UpdateDashboardTabManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDashboardTabMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard_tab_updates"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_dashboard_tab_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}}]}}]}}]}}]} as unknown as DocumentNode;
export type UpdateDashboardTabManyMutationFn = Apollo.MutationFunction<UpdateDashboardTabManyMutation, UpdateDashboardTabManyMutationVariables>;

/**
 * __useUpdateDashboardTabManyMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardTabManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardTabManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardTabManyMutation, { data, loading, error }] = useUpdateDashboardTabManyMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateDashboardTabManyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDashboardTabManyMutation, UpdateDashboardTabManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDashboardTabManyMutation, UpdateDashboardTabManyMutationVariables>(UpdateDashboardTabManyDocument, options);
      }
export type UpdateDashboardTabManyMutationHookResult = ReturnType<typeof useUpdateDashboardTabManyMutation>;
export type UpdateDashboardTabManyMutationResult = Apollo.MutationResult<UpdateDashboardTabManyMutation>;
export type UpdateDashboardTabManyMutationOptions = Apollo.BaseMutationOptions<UpdateDashboardTabManyMutation, UpdateDashboardTabManyMutationVariables>;
export const UpdateDashboardChartManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDashboardChartMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard_chart_updates"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_dashboard_chart_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}}]}}]}}]}}]} as unknown as DocumentNode;
export type UpdateDashboardChartManyMutationFn = Apollo.MutationFunction<UpdateDashboardChartManyMutation, UpdateDashboardChartManyMutationVariables>;

/**
 * __useUpdateDashboardChartManyMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardChartManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardChartManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardChartManyMutation, { data, loading, error }] = useUpdateDashboardChartManyMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateDashboardChartManyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDashboardChartManyMutation, UpdateDashboardChartManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDashboardChartManyMutation, UpdateDashboardChartManyMutationVariables>(UpdateDashboardChartManyDocument, options);
      }
export type UpdateDashboardChartManyMutationHookResult = ReturnType<typeof useUpdateDashboardChartManyMutation>;
export type UpdateDashboardChartManyMutationResult = Apollo.MutationResult<UpdateDashboardChartManyMutation>;
export type UpdateDashboardChartManyMutationOptions = Apollo.BaseMutationOptions<UpdateDashboardChartManyMutation, UpdateDashboardChartManyMutationVariables>;
export const UpdateDashboardChartTabManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDashboardChartTabMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard_chart_tab_updates"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_dashboard_chart_tab_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}}]}}]}}]}}]} as unknown as DocumentNode;
export type UpdateDashboardChartTabManyMutationFn = Apollo.MutationFunction<UpdateDashboardChartTabManyMutation, UpdateDashboardChartTabManyMutationVariables>;

/**
 * __useUpdateDashboardChartTabManyMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardChartTabManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardChartTabManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardChartTabManyMutation, { data, loading, error }] = useUpdateDashboardChartTabManyMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateDashboardChartTabManyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDashboardChartTabManyMutation, UpdateDashboardChartTabManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDashboardChartTabManyMutation, UpdateDashboardChartTabManyMutationVariables>(UpdateDashboardChartTabManyDocument, options);
      }
export type UpdateDashboardChartTabManyMutationHookResult = ReturnType<typeof useUpdateDashboardChartTabManyMutation>;
export type UpdateDashboardChartTabManyMutationResult = Apollo.MutationResult<UpdateDashboardChartTabManyMutation>;
export type UpdateDashboardChartTabManyMutationOptions = Apollo.BaseMutationOptions<UpdateDashboardChartTabManyMutation, UpdateDashboardChartTabManyMutationVariables>;
export const UpdateDashboardChartViewManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDashboardChartViewMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard_chart_view_updates"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_dashboard_chart_view_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}}]}}]}}]}}]} as unknown as DocumentNode;
export type UpdateDashboardChartViewManyMutationFn = Apollo.MutationFunction<UpdateDashboardChartViewManyMutation, UpdateDashboardChartViewManyMutationVariables>;

/**
 * __useUpdateDashboardChartViewManyMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardChartViewManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardChartViewManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardChartViewManyMutation, { data, loading, error }] = useUpdateDashboardChartViewManyMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateDashboardChartViewManyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDashboardChartViewManyMutation, UpdateDashboardChartViewManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDashboardChartViewManyMutation, UpdateDashboardChartViewManyMutationVariables>(UpdateDashboardChartViewManyDocument, options);
      }
export type UpdateDashboardChartViewManyMutationHookResult = ReturnType<typeof useUpdateDashboardChartViewManyMutation>;
export type UpdateDashboardChartViewManyMutationResult = Apollo.MutationResult<UpdateDashboardChartViewManyMutation>;
export type UpdateDashboardChartViewManyMutationOptions = Apollo.BaseMutationOptions<UpdateDashboardChartViewManyMutation, UpdateDashboardChartViewManyMutationVariables>;
export const UpdateDashboardChartMetricManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDashboardChartMetricMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard_chart_metric_updates"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_dashboard_chart_metric_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}}]}}]}}]}}]} as unknown as DocumentNode;
export type UpdateDashboardChartMetricManyMutationFn = Apollo.MutationFunction<UpdateDashboardChartMetricManyMutation, UpdateDashboardChartMetricManyMutationVariables>;

/**
 * __useUpdateDashboardChartMetricManyMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardChartMetricManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardChartMetricManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardChartMetricManyMutation, { data, loading, error }] = useUpdateDashboardChartMetricManyMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateDashboardChartMetricManyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDashboardChartMetricManyMutation, UpdateDashboardChartMetricManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDashboardChartMetricManyMutation, UpdateDashboardChartMetricManyMutationVariables>(UpdateDashboardChartMetricManyDocument, options);
      }
export type UpdateDashboardChartMetricManyMutationHookResult = ReturnType<typeof useUpdateDashboardChartMetricManyMutation>;
export type UpdateDashboardChartMetricManyMutationResult = Apollo.MutationResult<UpdateDashboardChartMetricManyMutation>;
export type UpdateDashboardChartMetricManyMutationOptions = Apollo.BaseMutationOptions<UpdateDashboardChartMetricManyMutation, UpdateDashboardChartMetricManyMutationVariables>;
export const MetricVariantsAndDataSourcesByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MetricVariantsAndDataSourcesById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data_sources"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"data_source"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data_source"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"variants"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"variant"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMetricVariantsAndDataSourcesByIdQuery__
 *
 * To run a query within a React component, call `useMetricVariantsAndDataSourcesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricVariantsAndDataSourcesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricVariantsAndDataSourcesByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMetricVariantsAndDataSourcesByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MetricVariantsAndDataSourcesByIdQuery, MetricVariantsAndDataSourcesByIdQueryVariables> & ({ variables: MetricVariantsAndDataSourcesByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MetricVariantsAndDataSourcesByIdQuery, MetricVariantsAndDataSourcesByIdQueryVariables>(MetricVariantsAndDataSourcesByIdDocument, options);
      }
export function useMetricVariantsAndDataSourcesByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetricVariantsAndDataSourcesByIdQuery, MetricVariantsAndDataSourcesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MetricVariantsAndDataSourcesByIdQuery, MetricVariantsAndDataSourcesByIdQueryVariables>(MetricVariantsAndDataSourcesByIdDocument, options);
        }
export function useMetricVariantsAndDataSourcesByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MetricVariantsAndDataSourcesByIdQuery, MetricVariantsAndDataSourcesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MetricVariantsAndDataSourcesByIdQuery, MetricVariantsAndDataSourcesByIdQueryVariables>(MetricVariantsAndDataSourcesByIdDocument, options);
        }
export type MetricVariantsAndDataSourcesByIdQueryHookResult = ReturnType<typeof useMetricVariantsAndDataSourcesByIdQuery>;
export type MetricVariantsAndDataSourcesByIdLazyQueryHookResult = ReturnType<typeof useMetricVariantsAndDataSourcesByIdLazyQuery>;
export type MetricVariantsAndDataSourcesByIdSuspenseQueryHookResult = ReturnType<typeof useMetricVariantsAndDataSourcesByIdSuspenseQuery>;
export type MetricVariantsAndDataSourcesByIdQueryResult = Apollo.QueryResult<MetricVariantsAndDataSourcesByIdQuery, MetricVariantsAndDataSourcesByIdQueryVariables>;
export const DashboardTargetCardStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardTargetCardStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dashboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dashboardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"target_cards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"metric_targets"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"target"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"}},{"kind":"Field","name":{"kind":"Name","value":"metric_targets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preference_target"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useDashboardTargetCardStatusQuery__
 *
 * To run a query within a React component, call `useDashboardTargetCardStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTargetCardStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTargetCardStatusQuery({
 *   variables: {
 *      metricId: // value for 'metricId'
 *      dashboardId: // value for 'dashboardId'
 *   },
 * });
 */
export function useDashboardTargetCardStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DashboardTargetCardStatusQuery, DashboardTargetCardStatusQueryVariables> & ({ variables: DashboardTargetCardStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DashboardTargetCardStatusQuery, DashboardTargetCardStatusQueryVariables>(DashboardTargetCardStatusDocument, options);
      }
export function useDashboardTargetCardStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DashboardTargetCardStatusQuery, DashboardTargetCardStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DashboardTargetCardStatusQuery, DashboardTargetCardStatusQueryVariables>(DashboardTargetCardStatusDocument, options);
        }
export function useDashboardTargetCardStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DashboardTargetCardStatusQuery, DashboardTargetCardStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DashboardTargetCardStatusQuery, DashboardTargetCardStatusQueryVariables>(DashboardTargetCardStatusDocument, options);
        }
export type DashboardTargetCardStatusQueryHookResult = ReturnType<typeof useDashboardTargetCardStatusQuery>;
export type DashboardTargetCardStatusLazyQueryHookResult = ReturnType<typeof useDashboardTargetCardStatusLazyQuery>;
export type DashboardTargetCardStatusSuspenseQueryHookResult = ReturnType<typeof useDashboardTargetCardStatusSuspenseQuery>;
export type DashboardTargetCardStatusQueryResult = Apollo.QueryResult<DashboardTargetCardStatusQuery, DashboardTargetCardStatusQueryVariables>;
export const InsertDashboardTargetCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertDashboardTargetCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dashboardId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_dashboard_target_card_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dashboard_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dashboardId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type InsertDashboardTargetCardMutationFn = Apollo.MutationFunction<InsertDashboardTargetCardMutation, InsertDashboardTargetCardMutationVariables>;

/**
 * __useInsertDashboardTargetCardMutation__
 *
 * To run a mutation, you first call `useInsertDashboardTargetCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertDashboardTargetCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertDashboardTargetCardMutation, { data, loading, error }] = useInsertDashboardTargetCardMutation({
 *   variables: {
 *      dashboardId: // value for 'dashboardId'
 *      metricId: // value for 'metricId'
 *   },
 * });
 */
export function useInsertDashboardTargetCardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertDashboardTargetCardMutation, InsertDashboardTargetCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InsertDashboardTargetCardMutation, InsertDashboardTargetCardMutationVariables>(InsertDashboardTargetCardDocument, options);
      }
export type InsertDashboardTargetCardMutationHookResult = ReturnType<typeof useInsertDashboardTargetCardMutation>;
export type InsertDashboardTargetCardMutationResult = Apollo.MutationResult<InsertDashboardTargetCardMutation>;
export type InsertDashboardTargetCardMutationOptions = Apollo.BaseMutationOptions<InsertDashboardTargetCardMutation, InsertDashboardTargetCardMutationVariables>;
export const DeleteDashboardTargetCardByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDashboardTargetCardById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetCardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_dashboard_target_card_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetCardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type DeleteDashboardTargetCardByIdMutationFn = Apollo.MutationFunction<DeleteDashboardTargetCardByIdMutation, DeleteDashboardTargetCardByIdMutationVariables>;

/**
 * __useDeleteDashboardTargetCardByIdMutation__
 *
 * To run a mutation, you first call `useDeleteDashboardTargetCardByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDashboardTargetCardByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDashboardTargetCardByIdMutation, { data, loading, error }] = useDeleteDashboardTargetCardByIdMutation({
 *   variables: {
 *      targetCardId: // value for 'targetCardId'
 *   },
 * });
 */
export function useDeleteDashboardTargetCardByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDashboardTargetCardByIdMutation, DeleteDashboardTargetCardByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDashboardTargetCardByIdMutation, DeleteDashboardTargetCardByIdMutationVariables>(DeleteDashboardTargetCardByIdDocument, options);
      }
export type DeleteDashboardTargetCardByIdMutationHookResult = ReturnType<typeof useDeleteDashboardTargetCardByIdMutation>;
export type DeleteDashboardTargetCardByIdMutationResult = Apollo.MutationResult<DeleteDashboardTargetCardByIdMutation>;
export type DeleteDashboardTargetCardByIdMutationOptions = Apollo.BaseMutationOptions<DeleteDashboardTargetCardByIdMutation, DeleteDashboardTargetCardByIdMutationVariables>;
export const UserCloneDashboardByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserCloneDashboardById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCloneDashboardInputDto"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clone_dashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode;
export type UserCloneDashboardByIdMutationFn = Apollo.MutationFunction<UserCloneDashboardByIdMutation, UserCloneDashboardByIdMutationVariables>;

/**
 * __useUserCloneDashboardByIdMutation__
 *
 * To run a mutation, you first call `useUserCloneDashboardByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCloneDashboardByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCloneDashboardByIdMutation, { data, loading, error }] = useUserCloneDashboardByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserCloneDashboardByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserCloneDashboardByIdMutation, UserCloneDashboardByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserCloneDashboardByIdMutation, UserCloneDashboardByIdMutationVariables>(UserCloneDashboardByIdDocument, options);
      }
export type UserCloneDashboardByIdMutationHookResult = ReturnType<typeof useUserCloneDashboardByIdMutation>;
export type UserCloneDashboardByIdMutationResult = Apollo.MutationResult<UserCloneDashboardByIdMutation>;
export type UserCloneDashboardByIdMutationOptions = Apollo.BaseMutationOptions<UserCloneDashboardByIdMutation, UserCloneDashboardByIdMutationVariables>;
export const DashboardChartDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardChartData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard_chart_view_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"view_metrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metric_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference_ranges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"metric_id"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"selfdecode"},{"kind":"EnumValue","value":"quest_pdf"},{"kind":"EnumValue","value":"quest_labs"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_id"}},{"kind":"Field","name":{"kind":"Name","value":"targets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"optimal"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric_targets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"preference_target"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"multi_chart_data"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"Argument","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"data_sources"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useDashboardChartDataQuery__
 *
 * To run a query within a React component, call `useDashboardChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardChartDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useDashboardChartDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DashboardChartDataQuery, DashboardChartDataQueryVariables> & ({ variables: DashboardChartDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DashboardChartDataQuery, DashboardChartDataQueryVariables>(DashboardChartDataDocument, options);
      }
export function useDashboardChartDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DashboardChartDataQuery, DashboardChartDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DashboardChartDataQuery, DashboardChartDataQueryVariables>(DashboardChartDataDocument, options);
        }
export function useDashboardChartDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DashboardChartDataQuery, DashboardChartDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DashboardChartDataQuery, DashboardChartDataQueryVariables>(DashboardChartDataDocument, options);
        }
export type DashboardChartDataQueryHookResult = ReturnType<typeof useDashboardChartDataQuery>;
export type DashboardChartDataLazyQueryHookResult = ReturnType<typeof useDashboardChartDataLazyQuery>;
export type DashboardChartDataSuspenseQueryHookResult = ReturnType<typeof useDashboardChartDataSuspenseQuery>;
export type DashboardChartDataQueryResult = Apollo.QueryResult<DashboardChartDataQuery, DashboardChartDataQueryVariables>;
export const DashboardTargetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardTargets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"target_cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric_targets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preference_target"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useDashboardTargetsQuery__
 *
 * To run a query within a React component, call `useDashboardTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTargetsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDashboardTargetsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DashboardTargetsQuery, DashboardTargetsQueryVariables> & ({ variables: DashboardTargetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DashboardTargetsQuery, DashboardTargetsQueryVariables>(DashboardTargetsDocument, options);
      }
export function useDashboardTargetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DashboardTargetsQuery, DashboardTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DashboardTargetsQuery, DashboardTargetsQueryVariables>(DashboardTargetsDocument, options);
        }
export function useDashboardTargetsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DashboardTargetsQuery, DashboardTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DashboardTargetsQuery, DashboardTargetsQueryVariables>(DashboardTargetsDocument, options);
        }
export type DashboardTargetsQueryHookResult = ReturnType<typeof useDashboardTargetsQuery>;
export type DashboardTargetsLazyQueryHookResult = ReturnType<typeof useDashboardTargetsLazyQuery>;
export type DashboardTargetsSuspenseQueryHookResult = ReturnType<typeof useDashboardTargetsSuspenseQuery>;
export type DashboardTargetsQueryResult = Apollo.QueryResult<DashboardTargetsQuery, DashboardTargetsQueryVariables>;
export const DashboardViewSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"DashboardViewSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuidComparisonExp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid_comparison_exp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DashboardFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_template"}},{"kind":"Field","name":{"kind":"Name","value":"tabs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"charts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chart_tabs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chart_type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"view_metrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rollup_type"}},{"kind":"Field","name":{"kind":"Name","value":"interval_type"}},{"kind":"Field","name":{"kind":"Name","value":"interval_count"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}},{"kind":"Field","name":{"kind":"Name","value":"metric_id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"metricDisplayName"},"name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"metric_targets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"preference_target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"experiment_metrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"experiment_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuidComparisonExp"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"experiment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useDashboardViewSubscriptionSubscription__
 *
 * To run a query within a React component, call `useDashboardViewSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDashboardViewSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardViewSubscriptionSubscription({
 *   variables: {
 *      id: // value for 'id'
 *      uuidComparisonExp: // value for 'uuidComparisonExp'
 *   },
 * });
 */
export function useDashboardViewSubscriptionSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<DashboardViewSubscriptionSubscription, DashboardViewSubscriptionSubscriptionVariables> & ({ variables: DashboardViewSubscriptionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<DashboardViewSubscriptionSubscription, DashboardViewSubscriptionSubscriptionVariables>(DashboardViewSubscriptionDocument, options);
      }
export type DashboardViewSubscriptionSubscriptionHookResult = ReturnType<typeof useDashboardViewSubscriptionSubscription>;
export type DashboardViewSubscriptionSubscriptionResult = Apollo.SubscriptionResult<DashboardViewSubscriptionSubscription>;
export const DashboardViewQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardViewQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuidComparisonExp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid_comparison_exp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DashboardFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_template"}},{"kind":"Field","name":{"kind":"Name","value":"tabs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"charts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chart_tabs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"views"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chart_type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"view_metrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rollup_type"}},{"kind":"Field","name":{"kind":"Name","value":"interval_type"}},{"kind":"Field","name":{"kind":"Name","value":"interval_count"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}},{"kind":"Field","name":{"kind":"Name","value":"metric_id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"metricDisplayName"},"name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"metric_targets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"preference_target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"experiment_metrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"experiment_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuidComparisonExp"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"experiment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useDashboardViewQueryQuery__
 *
 * To run a query within a React component, call `useDashboardViewQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardViewQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardViewQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      uuidComparisonExp: // value for 'uuidComparisonExp'
 *   },
 * });
 */
export function useDashboardViewQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DashboardViewQueryQuery, DashboardViewQueryQueryVariables> & ({ variables: DashboardViewQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DashboardViewQueryQuery, DashboardViewQueryQueryVariables>(DashboardViewQueryDocument, options);
      }
export function useDashboardViewQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DashboardViewQueryQuery, DashboardViewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DashboardViewQueryQuery, DashboardViewQueryQueryVariables>(DashboardViewQueryDocument, options);
        }
export function useDashboardViewQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DashboardViewQueryQuery, DashboardViewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DashboardViewQueryQuery, DashboardViewQueryQueryVariables>(DashboardViewQueryDocument, options);
        }
export type DashboardViewQueryQueryHookResult = ReturnType<typeof useDashboardViewQueryQuery>;
export type DashboardViewQueryLazyQueryHookResult = ReturnType<typeof useDashboardViewQueryLazyQuery>;
export type DashboardViewQuerySuspenseQueryHookResult = ReturnType<typeof useDashboardViewQuerySuspenseQuery>;
export type DashboardViewQueryQueryResult = Apollo.QueryResult<DashboardViewQueryQuery, DashboardViewQueryQueryVariables>;
export const DashboardListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"experiment_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_staging_dashboard"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useDashboardListQuery__
 *
 * To run a query within a React component, call `useDashboardListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardListQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DashboardListQuery, DashboardListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DashboardListQuery, DashboardListQueryVariables>(DashboardListDocument, options);
      }
export function useDashboardListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DashboardListQuery, DashboardListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DashboardListQuery, DashboardListQueryVariables>(DashboardListDocument, options);
        }
export function useDashboardListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DashboardListQuery, DashboardListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DashboardListQuery, DashboardListQueryVariables>(DashboardListDocument, options);
        }
export type DashboardListQueryHookResult = ReturnType<typeof useDashboardListQuery>;
export type DashboardListLazyQueryHookResult = ReturnType<typeof useDashboardListLazyQuery>;
export type DashboardListSuspenseQueryHookResult = ReturnType<typeof useDashboardListSuspenseQuery>;
export type DashboardListQueryResult = Apollo.QueryResult<DashboardListQuery, DashboardListQueryVariables>;
export const UpdateDashboardManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDashboardMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dashboard_updates"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_dashboard_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}}]}}]}}]}}]} as unknown as DocumentNode;
export type UpdateDashboardManyMutationFn = Apollo.MutationFunction<UpdateDashboardManyMutation, UpdateDashboardManyMutationVariables>;

/**
 * __useUpdateDashboardManyMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardManyMutation, { data, loading, error }] = useUpdateDashboardManyMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateDashboardManyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDashboardManyMutation, UpdateDashboardManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDashboardManyMutation, UpdateDashboardManyMutationVariables>(UpdateDashboardManyDocument, options);
      }
export type UpdateDashboardManyMutationHookResult = ReturnType<typeof useUpdateDashboardManyMutation>;
export type UpdateDashboardManyMutationResult = Apollo.MutationResult<UpdateDashboardManyMutation>;
export type UpdateDashboardManyMutationOptions = Apollo.BaseMutationOptions<UpdateDashboardManyMutation, UpdateDashboardManyMutationVariables>;
export const DataSourceRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DataSourceRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_feature_request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feature_request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useDataSourceRequestsQuery__
 *
 * To run a query within a React component, call `useDataSourceRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataSourceRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataSourceRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataSourceRequestsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DataSourceRequestsQuery, DataSourceRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DataSourceRequestsQuery, DataSourceRequestsQueryVariables>(DataSourceRequestsDocument, options);
      }
export function useDataSourceRequestsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DataSourceRequestsQuery, DataSourceRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DataSourceRequestsQuery, DataSourceRequestsQueryVariables>(DataSourceRequestsDocument, options);
        }
export function useDataSourceRequestsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DataSourceRequestsQuery, DataSourceRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DataSourceRequestsQuery, DataSourceRequestsQueryVariables>(DataSourceRequestsDocument, options);
        }
export type DataSourceRequestsQueryHookResult = ReturnType<typeof useDataSourceRequestsQuery>;
export type DataSourceRequestsLazyQueryHookResult = ReturnType<typeof useDataSourceRequestsLazyQuery>;
export type DataSourceRequestsSuspenseQueryHookResult = ReturnType<typeof useDataSourceRequestsSuspenseQuery>;
export type DataSourceRequestsQueryResult = Apollo.QueryResult<DataSourceRequestsQuery, DataSourceRequestsQueryVariables>;
export const RequestDataSourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestDataSource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"request_feature"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}]}}]} as unknown as DocumentNode;
export type RequestDataSourceMutationFn = Apollo.MutationFunction<RequestDataSourceMutation, RequestDataSourceMutationVariables>;

/**
 * __useRequestDataSourceMutation__
 *
 * To run a mutation, you first call `useRequestDataSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestDataSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestDataSourceMutation, { data, loading, error }] = useRequestDataSourceMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useRequestDataSourceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestDataSourceMutation, RequestDataSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestDataSourceMutation, RequestDataSourceMutationVariables>(RequestDataSourceDocument, options);
      }
export type RequestDataSourceMutationHookResult = ReturnType<typeof useRequestDataSourceMutation>;
export type RequestDataSourceMutationResult = Apollo.MutationResult<RequestDataSourceMutation>;
export type RequestDataSourceMutationOptions = Apollo.BaseMutationOptions<RequestDataSourceMutation, RequestDataSourceMutationVariables>;
export const UserIntegrationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserIntegrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_user_integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"reconnectNeeded"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"disabledReason"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useUserIntegrationsQuery__
 *
 * To run a query within a React component, call `useUserIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserIntegrationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserIntegrationsQuery, UserIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserIntegrationsQuery, UserIntegrationsQueryVariables>(UserIntegrationsDocument, options);
      }
export function useUserIntegrationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserIntegrationsQuery, UserIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserIntegrationsQuery, UserIntegrationsQueryVariables>(UserIntegrationsDocument, options);
        }
export function useUserIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserIntegrationsQuery, UserIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserIntegrationsQuery, UserIntegrationsQueryVariables>(UserIntegrationsDocument, options);
        }
export type UserIntegrationsQueryHookResult = ReturnType<typeof useUserIntegrationsQuery>;
export type UserIntegrationsLazyQueryHookResult = ReturnType<typeof useUserIntegrationsLazyQuery>;
export type UserIntegrationsSuspenseQueryHookResult = ReturnType<typeof useUserIntegrationsSuspenseQuery>;
export type UserIntegrationsQueryResult = Apollo.QueryResult<UserIntegrationsQuery, UserIntegrationsQueryVariables>;
export const DisableUserIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DisableUserIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"provider"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CombinedIntegrationTypes"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disable_user_integration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"integration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"provider"}}}]}]}}]} as unknown as DocumentNode;
export type DisableUserIntegrationMutationFn = Apollo.MutationFunction<DisableUserIntegrationMutation, DisableUserIntegrationMutationVariables>;

/**
 * __useDisableUserIntegrationMutation__
 *
 * To run a mutation, you first call `useDisableUserIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableUserIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableUserIntegrationMutation, { data, loading, error }] = useDisableUserIntegrationMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useDisableUserIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisableUserIntegrationMutation, DisableUserIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisableUserIntegrationMutation, DisableUserIntegrationMutationVariables>(DisableUserIntegrationDocument, options);
      }
export type DisableUserIntegrationMutationHookResult = ReturnType<typeof useDisableUserIntegrationMutation>;
export type DisableUserIntegrationMutationResult = Apollo.MutationResult<DisableUserIntegrationMutation>;
export type DisableUserIntegrationMutationOptions = Apollo.BaseMutationOptions<DisableUserIntegrationMutation, DisableUserIntegrationMutationVariables>;
export const ExperimentDashboardListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExperimentDashboardList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"experiment_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_staging_dashboard"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"experiment_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useExperimentDashboardListQuery__
 *
 * To run a query within a React component, call `useExperimentDashboardListQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperimentDashboardListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperimentDashboardListQuery({
 *   variables: {
 *   },
 * });
 */
export function useExperimentDashboardListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExperimentDashboardListQuery, ExperimentDashboardListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExperimentDashboardListQuery, ExperimentDashboardListQueryVariables>(ExperimentDashboardListDocument, options);
      }
export function useExperimentDashboardListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExperimentDashboardListQuery, ExperimentDashboardListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExperimentDashboardListQuery, ExperimentDashboardListQueryVariables>(ExperimentDashboardListDocument, options);
        }
export function useExperimentDashboardListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ExperimentDashboardListQuery, ExperimentDashboardListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExperimentDashboardListQuery, ExperimentDashboardListQueryVariables>(ExperimentDashboardListDocument, options);
        }
export type ExperimentDashboardListQueryHookResult = ReturnType<typeof useExperimentDashboardListQuery>;
export type ExperimentDashboardListLazyQueryHookResult = ReturnType<typeof useExperimentDashboardListLazyQuery>;
export type ExperimentDashboardListSuspenseQueryHookResult = ReturnType<typeof useExperimentDashboardListSuspenseQuery>;
export type ExperimentDashboardListQueryResult = Apollo.QueryResult<ExperimentDashboardListQuery, ExperimentDashboardListQueryVariables>;
export const InsertExperimentOneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertExperimentOne"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"experiment_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_experiment_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"experiment_metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export type InsertExperimentOneMutationFn = Apollo.MutationFunction<InsertExperimentOneMutation, InsertExperimentOneMutationVariables>;

/**
 * __useInsertExperimentOneMutation__
 *
 * To run a mutation, you first call `useInsertExperimentOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertExperimentOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertExperimentOneMutation, { data, loading, error }] = useInsertExperimentOneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertExperimentOneMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertExperimentOneMutation, InsertExperimentOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InsertExperimentOneMutation, InsertExperimentOneMutationVariables>(InsertExperimentOneDocument, options);
      }
export type InsertExperimentOneMutationHookResult = ReturnType<typeof useInsertExperimentOneMutation>;
export type InsertExperimentOneMutationResult = Apollo.MutationResult<InsertExperimentOneMutation>;
export type InsertExperimentOneMutationOptions = Apollo.BaseMutationOptions<InsertExperimentOneMutation, InsertExperimentOneMutationVariables>;
export const ExperimentByDashboardIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExperimentByDashboardId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"experiment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dashboard"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"experiment_metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useExperimentByDashboardIdQuery__
 *
 * To run a query within a React component, call `useExperimentByDashboardIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperimentByDashboardIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperimentByDashboardIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExperimentByDashboardIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExperimentByDashboardIdQuery, ExperimentByDashboardIdQueryVariables> & ({ variables: ExperimentByDashboardIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExperimentByDashboardIdQuery, ExperimentByDashboardIdQueryVariables>(ExperimentByDashboardIdDocument, options);
      }
export function useExperimentByDashboardIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExperimentByDashboardIdQuery, ExperimentByDashboardIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExperimentByDashboardIdQuery, ExperimentByDashboardIdQueryVariables>(ExperimentByDashboardIdDocument, options);
        }
export function useExperimentByDashboardIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ExperimentByDashboardIdQuery, ExperimentByDashboardIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExperimentByDashboardIdQuery, ExperimentByDashboardIdQueryVariables>(ExperimentByDashboardIdDocument, options);
        }
export type ExperimentByDashboardIdQueryHookResult = ReturnType<typeof useExperimentByDashboardIdQuery>;
export type ExperimentByDashboardIdLazyQueryHookResult = ReturnType<typeof useExperimentByDashboardIdLazyQuery>;
export type ExperimentByDashboardIdSuspenseQueryHookResult = ReturnType<typeof useExperimentByDashboardIdSuspenseQuery>;
export type ExperimentByDashboardIdQueryResult = Apollo.QueryResult<ExperimentByDashboardIdQuery, ExperimentByDashboardIdQueryVariables>;
export const UpdateExperimentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateExperiment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseChanges"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"experiment_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"experiments"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"experiment_metric_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_experiment_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseChanges"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"experiment_metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"display_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_experiment_metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"experiments"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"experiment_metric_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"primary"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"experiment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"experiment_metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export type UpdateExperimentMutationFn = Apollo.MutationFunction<UpdateExperimentMutation, UpdateExperimentMutationVariables>;

/**
 * __useUpdateExperimentMutation__
 *
 * To run a mutation, you first call `useUpdateExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExperimentMutation, { data, loading, error }] = useUpdateExperimentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      baseChanges: // value for 'baseChanges'
 *      experiments: // value for 'experiments'
 *   },
 * });
 */
export function useUpdateExperimentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateExperimentMutation, UpdateExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateExperimentMutation, UpdateExperimentMutationVariables>(UpdateExperimentDocument, options);
      }
export type UpdateExperimentMutationHookResult = ReturnType<typeof useUpdateExperimentMutation>;
export type UpdateExperimentMutationResult = Apollo.MutationResult<UpdateExperimentMutation>;
export type UpdateExperimentMutationOptions = Apollo.BaseMutationOptions<UpdateExperimentMutation, UpdateExperimentMutationVariables>;
export const DeleteExperimentMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteExperimentMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"experimentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_experiment_metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"experiment_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"experimentId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"metric_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_id"}}]}}]}}]}}]} as unknown as DocumentNode;
export type DeleteExperimentMetricMutationFn = Apollo.MutationFunction<DeleteExperimentMetricMutation, DeleteExperimentMetricMutationVariables>;

/**
 * __useDeleteExperimentMetricMutation__
 *
 * To run a mutation, you first call `useDeleteExperimentMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExperimentMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExperimentMetricMutation, { data, loading, error }] = useDeleteExperimentMetricMutation({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *      metricId: // value for 'metricId'
 *   },
 * });
 */
export function useDeleteExperimentMetricMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteExperimentMetricMutation, DeleteExperimentMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteExperimentMetricMutation, DeleteExperimentMetricMutationVariables>(DeleteExperimentMetricDocument, options);
      }
export type DeleteExperimentMetricMutationHookResult = ReturnType<typeof useDeleteExperimentMetricMutation>;
export type DeleteExperimentMetricMutationResult = Apollo.MutationResult<DeleteExperimentMetricMutation>;
export type DeleteExperimentMetricMutationOptions = Apollo.BaseMutationOptions<DeleteExperimentMetricMutation, DeleteExperimentMetricMutationVariables>;
export const DeleteExperimentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteExperiment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_experiment_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;
export type DeleteExperimentMutationFn = Apollo.MutationFunction<DeleteExperimentMutation, DeleteExperimentMutationVariables>;

/**
 * __useDeleteExperimentMutation__
 *
 * To run a mutation, you first call `useDeleteExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExperimentMutation, { data, loading, error }] = useDeleteExperimentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExperimentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteExperimentMutation, DeleteExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteExperimentMutation, DeleteExperimentMutationVariables>(DeleteExperimentDocument, options);
      }
export type DeleteExperimentMutationHookResult = ReturnType<typeof useDeleteExperimentMutation>;
export type DeleteExperimentMutationResult = Apollo.MutationResult<DeleteExperimentMutation>;
export type DeleteExperimentMutationOptions = Apollo.BaseMutationOptions<DeleteExperimentMutation, DeleteExperimentMutationVariables>;
export const UpdateExperimentMetricManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateExperimentMetricMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"experiment_metric_updates"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_experiment_metric_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sort_order"}}]}}]}}]}}]} as unknown as DocumentNode;
export type UpdateExperimentMetricManyMutationFn = Apollo.MutationFunction<UpdateExperimentMetricManyMutation, UpdateExperimentMetricManyMutationVariables>;

/**
 * __useUpdateExperimentMetricManyMutation__
 *
 * To run a mutation, you first call `useUpdateExperimentMetricManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExperimentMetricManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExperimentMetricManyMutation, { data, loading, error }] = useUpdateExperimentMetricManyMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateExperimentMetricManyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateExperimentMetricManyMutation, UpdateExperimentMetricManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateExperimentMetricManyMutation, UpdateExperimentMetricManyMutationVariables>(UpdateExperimentMetricManyDocument, options);
      }
export type UpdateExperimentMetricManyMutationHookResult = ReturnType<typeof useUpdateExperimentMetricManyMutation>;
export type UpdateExperimentMetricManyMutationResult = Apollo.MutationResult<UpdateExperimentMetricManyMutation>;
export type UpdateExperimentMetricManyMutationOptions = Apollo.BaseMutationOptions<UpdateExperimentMetricManyMutation, UpdateExperimentMetricManyMutationVariables>;
export const FastingMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FastingMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"numberOfPreviousFasts"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"1"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricStreaksFields"}},{"kind":"Field","alias":{"kind":"Name","value":"currentFast"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"IntValue","value":"0"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"previousFasts"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"0"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"numberOfPreviousFasts"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreakFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Streak"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period_start"}},{"kind":"Field","name":{"kind":"Name","value":"period_end"}},{"kind":"Field","name":{"kind":"Name","value":"is_active"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"preference_target"}},{"kind":"Field","name":{"kind":"Name","value":"period"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"weeks"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricStreaksFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"active_streak"},"name":{"kind":"Name","value":"streak"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"end_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreakFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"most_recent_streak"},"name":{"kind":"Name","value":"streak"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}},{"kind":"Argument","name":{"kind":"Name","value":"end_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreakFields"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useFastingMetricQuery__
 *
 * To run a query within a React component, call `useFastingMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useFastingMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFastingMetricQuery({
 *   variables: {
 *      namespace: // value for 'namespace'
 *      key: // value for 'key'
 *      numberOfPreviousFasts: // value for 'numberOfPreviousFasts'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useFastingMetricQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FastingMetricQuery, FastingMetricQueryVariables> & ({ variables: FastingMetricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FastingMetricQuery, FastingMetricQueryVariables>(FastingMetricDocument, options);
      }
export function useFastingMetricLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FastingMetricQuery, FastingMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FastingMetricQuery, FastingMetricQueryVariables>(FastingMetricDocument, options);
        }
export function useFastingMetricSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FastingMetricQuery, FastingMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FastingMetricQuery, FastingMetricQueryVariables>(FastingMetricDocument, options);
        }
export type FastingMetricQueryHookResult = ReturnType<typeof useFastingMetricQuery>;
export type FastingMetricLazyQueryHookResult = ReturnType<typeof useFastingMetricLazyQuery>;
export type FastingMetricSuspenseQueryHookResult = ReturnType<typeof useFastingMetricSuspenseQuery>;
export type FastingMetricQueryResult = Apollo.QueryResult<FastingMetricQuery, FastingMetricQueryVariables>;
export const CreateAndUpdateMetricRecordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAndUpdateMetricRecords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createObjects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MetricRecordCreateInputType"}}}},"defaultValue":{"kind":"ListValue","values":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateObjects"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MetricRecordUpdateWithIdInputType"}}},"defaultValue":{"kind":"ListValue","values":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataSource"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"data_source"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createObjects"}}},{"kind":"Argument","name":{"kind":"Name","value":"data_source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataSource"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateObjects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type CreateAndUpdateMetricRecordsMutationFn = Apollo.MutationFunction<CreateAndUpdateMetricRecordsMutation, CreateAndUpdateMetricRecordsMutationVariables>;

/**
 * __useCreateAndUpdateMetricRecordsMutation__
 *
 * To run a mutation, you first call `useCreateAndUpdateMetricRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAndUpdateMetricRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAndUpdateMetricRecordsMutation, { data, loading, error }] = useCreateAndUpdateMetricRecordsMutation({
 *   variables: {
 *      createObjects: // value for 'createObjects'
 *      updateObjects: // value for 'updateObjects'
 *      dataSource: // value for 'dataSource'
 *   },
 * });
 */
export function useCreateAndUpdateMetricRecordsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAndUpdateMetricRecordsMutation, CreateAndUpdateMetricRecordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAndUpdateMetricRecordsMutation, CreateAndUpdateMetricRecordsMutationVariables>(CreateAndUpdateMetricRecordsDocument, options);
      }
export type CreateAndUpdateMetricRecordsMutationHookResult = ReturnType<typeof useCreateAndUpdateMetricRecordsMutation>;
export type CreateAndUpdateMetricRecordsMutationResult = Apollo.MutationResult<CreateAndUpdateMetricRecordsMutation>;
export type CreateAndUpdateMetricRecordsMutationOptions = Apollo.BaseMutationOptions<CreateAndUpdateMetricRecordsMutation, CreateAndUpdateMetricRecordsMutationVariables>;
export const DeleteFilevaultFileByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFilevaultFileById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_filevault_file_by_id"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type DeleteFilevaultFileByIdMutationFn = Apollo.MutationFunction<DeleteFilevaultFileByIdMutation, DeleteFilevaultFileByIdMutationVariables>;

/**
 * __useDeleteFilevaultFileByIdMutation__
 *
 * To run a mutation, you first call `useDeleteFilevaultFileByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFilevaultFileByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFilevaultFileByIdMutation, { data, loading, error }] = useDeleteFilevaultFileByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFilevaultFileByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFilevaultFileByIdMutation, DeleteFilevaultFileByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFilevaultFileByIdMutation, DeleteFilevaultFileByIdMutationVariables>(DeleteFilevaultFileByIdDocument, options);
      }
export type DeleteFilevaultFileByIdMutationHookResult = ReturnType<typeof useDeleteFilevaultFileByIdMutation>;
export type DeleteFilevaultFileByIdMutationResult = Apollo.MutationResult<DeleteFilevaultFileByIdMutation>;
export type DeleteFilevaultFileByIdMutationOptions = Apollo.BaseMutationOptions<DeleteFilevaultFileByIdMutation, DeleteFilevaultFileByIdMutationVariables>;
export const FileVaultFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FileVaultFiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"files"},"name":{"kind":"Name","value":"user_file_vault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"s3_bucket"}},{"kind":"Field","name":{"kind":"Name","value":"s3_path"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"download"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useFileVaultFilesQuery__
 *
 * To run a query within a React component, call `useFileVaultFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileVaultFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileVaultFilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFileVaultFilesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FileVaultFilesQuery, FileVaultFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FileVaultFilesQuery, FileVaultFilesQueryVariables>(FileVaultFilesDocument, options);
      }
export function useFileVaultFilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FileVaultFilesQuery, FileVaultFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FileVaultFilesQuery, FileVaultFilesQueryVariables>(FileVaultFilesDocument, options);
        }
export function useFileVaultFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FileVaultFilesQuery, FileVaultFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FileVaultFilesQuery, FileVaultFilesQueryVariables>(FileVaultFilesDocument, options);
        }
export type FileVaultFilesQueryHookResult = ReturnType<typeof useFileVaultFilesQuery>;
export type FileVaultFilesLazyQueryHookResult = ReturnType<typeof useFileVaultFilesLazyQuery>;
export type FileVaultFilesSuspenseQueryHookResult = ReturnType<typeof useFileVaultFilesSuspenseQuery>;
export type FileVaultFilesQueryResult = Apollo.QueryResult<FileVaultFilesQuery, FileVaultFilesQueryVariables>;
export const GenerateVaultUploadUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateVaultUploadUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filename"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileUploadType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"enum_file_vault_file_type_enum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filevault_upload_url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filename"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filename"}}},{"kind":"Argument","name":{"kind":"Name","value":"file_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileUploadType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"s3_path"}}]}}]}}]} as unknown as DocumentNode;
export type GenerateVaultUploadUrlMutationFn = Apollo.MutationFunction<GenerateVaultUploadUrlMutation, GenerateVaultUploadUrlMutationVariables>;

/**
 * __useGenerateVaultUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateVaultUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateVaultUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateVaultUploadUrlMutation, { data, loading, error }] = useGenerateVaultUploadUrlMutation({
 *   variables: {
 *      filename: // value for 'filename'
 *      fileUploadType: // value for 'fileUploadType'
 *   },
 * });
 */
export function useGenerateVaultUploadUrlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateVaultUploadUrlMutation, GenerateVaultUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateVaultUploadUrlMutation, GenerateVaultUploadUrlMutationVariables>(GenerateVaultUploadUrlDocument, options);
      }
export type GenerateVaultUploadUrlMutationHookResult = ReturnType<typeof useGenerateVaultUploadUrlMutation>;
export type GenerateVaultUploadUrlMutationResult = Apollo.MutationResult<GenerateVaultUploadUrlMutation>;
export type GenerateVaultUploadUrlMutationOptions = Apollo.BaseMutationOptions<GenerateVaultUploadUrlMutation, GenerateVaultUploadUrlMutationVariables>;
export const GlucoseChartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GlucoseChart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"BODY_MEASUREMENT","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"CGM_BLOOD_GLUCOSE_MG_DL","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference_ranges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"metric_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_id"}},{"kind":"Field","name":{"kind":"Name","value":"targets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"optimal"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric_targets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"preference_target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric_chart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"CGM_BLOOD_GLUCOSE_MG_DL","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"EnumValue","value":"BODY_MEASUREMENT"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"chart"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"interval_type"},"value":{"kind":"EnumValue","value":"none"}},{"kind":"ObjectField","name":{"kind":"Name","value":"interval_count"},"value":{"kind":"IntValue","value":"0"}},{"kind":"ObjectField","name":{"kind":"Name","value":"rollup_type"},"value":{"kind":"EnumValue","value":"none"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"data_sources"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGlucoseChartQuery__
 *
 * To run a query within a React component, call `useGlucoseChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlucoseChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlucoseChartQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useGlucoseChartQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GlucoseChartQuery, GlucoseChartQueryVariables> & ({ variables: GlucoseChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlucoseChartQuery, GlucoseChartQueryVariables>(GlucoseChartDocument, options);
      }
export function useGlucoseChartLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlucoseChartQuery, GlucoseChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlucoseChartQuery, GlucoseChartQueryVariables>(GlucoseChartDocument, options);
        }
export function useGlucoseChartSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GlucoseChartQuery, GlucoseChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlucoseChartQuery, GlucoseChartQueryVariables>(GlucoseChartDocument, options);
        }
export type GlucoseChartQueryHookResult = ReturnType<typeof useGlucoseChartQuery>;
export type GlucoseChartLazyQueryHookResult = ReturnType<typeof useGlucoseChartLazyQuery>;
export type GlucoseChartSuspenseQueryHookResult = ReturnType<typeof useGlucoseChartSuspenseQuery>;
export type GlucoseChartQueryResult = Apollo.QueryResult<GlucoseChartQuery, GlucoseChartQueryVariables>;
export const UserGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"experts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useUserGroupsQuery__
 *
 * To run a query within a React component, call `useUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserGroupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserGroupsQuery, UserGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserGroupsQuery, UserGroupsQueryVariables>(UserGroupsDocument, options);
      }
export function useUserGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserGroupsQuery, UserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserGroupsQuery, UserGroupsQueryVariables>(UserGroupsDocument, options);
        }
export function useUserGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserGroupsQuery, UserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserGroupsQuery, UserGroupsQueryVariables>(UserGroupsDocument, options);
        }
export type UserGroupsQueryHookResult = ReturnType<typeof useUserGroupsQuery>;
export type UserGroupsLazyQueryHookResult = ReturnType<typeof useUserGroupsLazyQuery>;
export type UserGroupsSuspenseQueryHookResult = ReturnType<typeof useUserGroupsSuspenseQuery>;
export type UserGroupsQueryResult = Apollo.QueryResult<UserGroupsQuery, UserGroupsQueryVariables>;
export const InsertUserTaskAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertUserTaskAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"details"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_user_task_assignment_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"details"},"value":{"kind":"Variable","name":{"kind":"Name","value":"details"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type InsertUserTaskAssignmentMutationFn = Apollo.MutationFunction<InsertUserTaskAssignmentMutation, InsertUserTaskAssignmentMutationVariables>;

/**
 * __useInsertUserTaskAssignmentMutation__
 *
 * To run a mutation, you first call `useInsertUserTaskAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUserTaskAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUserTaskAssignmentMutation, { data, loading, error }] = useInsertUserTaskAssignmentMutation({
 *   variables: {
 *      name: // value for 'name'
 *      details: // value for 'details'
 *   },
 * });
 */
export function useInsertUserTaskAssignmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertUserTaskAssignmentMutation, InsertUserTaskAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InsertUserTaskAssignmentMutation, InsertUserTaskAssignmentMutationVariables>(InsertUserTaskAssignmentDocument, options);
      }
export type InsertUserTaskAssignmentMutationHookResult = ReturnType<typeof useInsertUserTaskAssignmentMutation>;
export type InsertUserTaskAssignmentMutationResult = Apollo.MutationResult<InsertUserTaskAssignmentMutation>;
export type InsertUserTaskAssignmentMutationOptions = Apollo.BaseMutationOptions<InsertUserTaskAssignmentMutation, InsertUserTaskAssignmentMutationVariables>;
export const HelpPageFaqDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HelpPageFaq"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"helpPageFaqCms"},"name":{"kind":"Name","value":"cms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"helpPageFaq"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"QA_Item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first"}},{"kind":"Field","name":{"kind":"Name","value":"second"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useHelpPageFaqQuery__
 *
 * To run a query within a React component, call `useHelpPageFaqQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelpPageFaqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHelpPageFaqQuery({
 *   variables: {
 *   },
 * });
 */
export function useHelpPageFaqQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HelpPageFaqQuery, HelpPageFaqQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HelpPageFaqQuery, HelpPageFaqQueryVariables>(HelpPageFaqDocument, options);
      }
export function useHelpPageFaqLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HelpPageFaqQuery, HelpPageFaqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HelpPageFaqQuery, HelpPageFaqQueryVariables>(HelpPageFaqDocument, options);
        }
export function useHelpPageFaqSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HelpPageFaqQuery, HelpPageFaqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HelpPageFaqQuery, HelpPageFaqQueryVariables>(HelpPageFaqDocument, options);
        }
export type HelpPageFaqQueryHookResult = ReturnType<typeof useHelpPageFaqQuery>;
export type HelpPageFaqLazyQueryHookResult = ReturnType<typeof useHelpPageFaqLazyQuery>;
export type HelpPageFaqSuspenseQueryHookResult = ReturnType<typeof useHelpPageFaqSuspenseQuery>;
export type HelpPageFaqQueryResult = Apollo.QueryResult<HelpPageFaqQuery, HelpPageFaqQueryVariables>;
export const UserDevicesTokensDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserDevicesTokens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oauth2_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"}}]}},{"kind":"Field","name":{"kind":"Name","value":"oauth1_token"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useUserDevicesTokensQuery__
 *
 * To run a query within a React component, call `useUserDevicesTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDevicesTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDevicesTokensQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserDevicesTokensQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserDevicesTokensQuery, UserDevicesTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserDevicesTokensQuery, UserDevicesTokensQueryVariables>(UserDevicesTokensDocument, options);
      }
export function useUserDevicesTokensLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserDevicesTokensQuery, UserDevicesTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserDevicesTokensQuery, UserDevicesTokensQueryVariables>(UserDevicesTokensDocument, options);
        }
export function useUserDevicesTokensSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserDevicesTokensQuery, UserDevicesTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserDevicesTokensQuery, UserDevicesTokensQueryVariables>(UserDevicesTokensDocument, options);
        }
export type UserDevicesTokensQueryHookResult = ReturnType<typeof useUserDevicesTokensQuery>;
export type UserDevicesTokensLazyQueryHookResult = ReturnType<typeof useUserDevicesTokensLazyQuery>;
export type UserDevicesTokensSuspenseQueryHookResult = ReturnType<typeof useUserDevicesTokensSuspenseQuery>;
export type UserDevicesTokensQueryResult = Apollo.QueryResult<UserDevicesTokensQuery, UserDevicesTokensQueryVariables>;
export const BackfillEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"BackfillEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integration_backfill_event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"integration"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useBackfillEventSubscription__
 *
 * To run a query within a React component, call `useBackfillEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBackfillEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackfillEventSubscription({
 *   variables: {
 *   },
 * });
 */
export function useBackfillEventSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<BackfillEventSubscription, BackfillEventSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<BackfillEventSubscription, BackfillEventSubscriptionVariables>(BackfillEventDocument, options);
      }
export type BackfillEventSubscriptionHookResult = ReturnType<typeof useBackfillEventSubscription>;
export type BackfillEventSubscriptionResult = Apollo.SubscriptionResult<BackfillEventSubscription>;
export const WorkoutHeartRatesCompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkoutHeartRatesComplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricRecordGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_record_group_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricRecordGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace_key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ACTIVITY:HEART_RATE","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value_time_series"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useWorkoutHeartRatesCompleteQuery__
 *
 * To run a query within a React component, call `useWorkoutHeartRatesCompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkoutHeartRatesCompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkoutHeartRatesCompleteQuery({
 *   variables: {
 *      metricRecordGroupId: // value for 'metricRecordGroupId'
 *   },
 * });
 */
export function useWorkoutHeartRatesCompleteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WorkoutHeartRatesCompleteQuery, WorkoutHeartRatesCompleteQueryVariables> & ({ variables: WorkoutHeartRatesCompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkoutHeartRatesCompleteQuery, WorkoutHeartRatesCompleteQueryVariables>(WorkoutHeartRatesCompleteDocument, options);
      }
export function useWorkoutHeartRatesCompleteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkoutHeartRatesCompleteQuery, WorkoutHeartRatesCompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkoutHeartRatesCompleteQuery, WorkoutHeartRatesCompleteQueryVariables>(WorkoutHeartRatesCompleteDocument, options);
        }
export function useWorkoutHeartRatesCompleteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WorkoutHeartRatesCompleteQuery, WorkoutHeartRatesCompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WorkoutHeartRatesCompleteQuery, WorkoutHeartRatesCompleteQueryVariables>(WorkoutHeartRatesCompleteDocument, options);
        }
export type WorkoutHeartRatesCompleteQueryHookResult = ReturnType<typeof useWorkoutHeartRatesCompleteQuery>;
export type WorkoutHeartRatesCompleteLazyQueryHookResult = ReturnType<typeof useWorkoutHeartRatesCompleteLazyQuery>;
export type WorkoutHeartRatesCompleteSuspenseQueryHookResult = ReturnType<typeof useWorkoutHeartRatesCompleteSuspenseQuery>;
export type WorkoutHeartRatesCompleteQueryResult = Apollo.QueryResult<WorkoutHeartRatesCompleteQuery, WorkoutHeartRatesCompleteQueryVariables>;
export const HydrationTileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HydrationTile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricStreaksFields"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records_rollup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"interval_count"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"interval_type"},"value":{"kind":"EnumValue","value":"day"}},{"kind":"Argument","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"Argument","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"sum"},"name":{"kind":"Name","value":"preference_sum"}},{"kind":"Field","alias":{"kind":"Name","value":"day"},"name":{"kind":"Name","value":"interval_start"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreakFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Streak"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period_start"}},{"kind":"Field","name":{"kind":"Name","value":"period_end"}},{"kind":"Field","name":{"kind":"Name","value":"is_active"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"preference_target"}},{"kind":"Field","name":{"kind":"Name","value":"period"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"weeks"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricStreaksFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"active_streak"},"name":{"kind":"Name","value":"streak"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"end_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreakFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"most_recent_streak"},"name":{"kind":"Name","value":"streak"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}},{"kind":"Argument","name":{"kind":"Name","value":"end_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreakFields"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useHydrationTileQuery__
 *
 * To run a query within a React component, call `useHydrationTileQuery` and pass it any options that fit your needs.
 * When your component renders, `useHydrationTileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHydrationTileQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      namespace: // value for 'namespace'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useHydrationTileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HydrationTileQuery, HydrationTileQueryVariables> & ({ variables: HydrationTileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HydrationTileQuery, HydrationTileQueryVariables>(HydrationTileDocument, options);
      }
export function useHydrationTileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HydrationTileQuery, HydrationTileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HydrationTileQuery, HydrationTileQueryVariables>(HydrationTileDocument, options);
        }
export function useHydrationTileSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HydrationTileQuery, HydrationTileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HydrationTileQuery, HydrationTileQueryVariables>(HydrationTileDocument, options);
        }
export type HydrationTileQueryHookResult = ReturnType<typeof useHydrationTileQuery>;
export type HydrationTileLazyQueryHookResult = ReturnType<typeof useHydrationTileLazyQuery>;
export type HydrationTileSuspenseQueryHookResult = ReturnType<typeof useHydrationTileSuspenseQuery>;
export type HydrationTileQueryResult = Apollo.QueryResult<HydrationTileQuery, HydrationTileQueryVariables>;
export const GarminActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GarminActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_record_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"DAILY_SUMMARY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"ACTIVE_KILOCALORIES","block":false},{"kind":"StringValue","value":"RESTING_KILOCALORIES","block":false},{"kind":"StringValue","value":"DISTANCE","block":false},{"kind":"StringValue","value":"STEPS","block":false}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"unit"},"name":{"kind":"Name","value":"preference_unit"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGarminActivityQuery__
 *
 * To run a query within a React component, call `useGarminActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGarminActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGarminActivityQuery({
 *   variables: {
 *      timestamp: // value for 'timestamp'
 *   },
 * });
 */
export function useGarminActivityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GarminActivityQuery, GarminActivityQueryVariables> & ({ variables: GarminActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GarminActivityQuery, GarminActivityQueryVariables>(GarminActivityDocument, options);
      }
export function useGarminActivityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GarminActivityQuery, GarminActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GarminActivityQuery, GarminActivityQueryVariables>(GarminActivityDocument, options);
        }
export function useGarminActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GarminActivityQuery, GarminActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GarminActivityQuery, GarminActivityQueryVariables>(GarminActivityDocument, options);
        }
export type GarminActivityQueryHookResult = ReturnType<typeof useGarminActivityQuery>;
export type GarminActivityLazyQueryHookResult = ReturnType<typeof useGarminActivityLazyQuery>;
export type GarminActivitySuspenseQueryHookResult = ReturnType<typeof useGarminActivitySuspenseQuery>;
export type GarminActivityQueryResult = Apollo.QueryResult<GarminActivityQuery, GarminActivityQueryVariables>;
export const GarminSleepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GarminSleep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_record_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"GROUPED_DAY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"local_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"group_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"SLEEP","block":false},{"kind":"StringValue","value":"HEALTH_SUMMARY","block":false},{"kind":"StringValue","value":"DAILY_SUMMARY","block":false},{"kind":"StringValue","value":"SLEEP_HRV","block":false}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"garmin"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"local_date"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"local_date"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"SLEEP","block":false},{"kind":"StringValue","value":"BODY_MEASUREMENT","block":false}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"SCORE","block":false},{"kind":"StringValue","value":"DURATION_TOTAL","block":false},{"kind":"StringValue","value":"DURATION_DEEP","block":false},{"kind":"StringValue","value":"DURATION_LIGHT","block":false},{"kind":"StringValue","value":"DURATION_REM","block":false},{"kind":"StringValue","value":"DURATION_AWAKE","block":false}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","alias":{"kind":"Name","value":"unit"},"name":{"kind":"Name","value":"preference_unit"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGarminSleepQuery__
 *
 * To run a query within a React component, call `useGarminSleepQuery` and pass it any options that fit your needs.
 * When your component renders, `useGarminSleepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGarminSleepQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGarminSleepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GarminSleepQuery, GarminSleepQueryVariables> & ({ variables: GarminSleepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GarminSleepQuery, GarminSleepQueryVariables>(GarminSleepDocument, options);
      }
export function useGarminSleepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GarminSleepQuery, GarminSleepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GarminSleepQuery, GarminSleepQueryVariables>(GarminSleepDocument, options);
        }
export function useGarminSleepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GarminSleepQuery, GarminSleepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GarminSleepQuery, GarminSleepQueryVariables>(GarminSleepDocument, options);
        }
export type GarminSleepQueryHookResult = ReturnType<typeof useGarminSleepQuery>;
export type GarminSleepLazyQueryHookResult = ReturnType<typeof useGarminSleepLazyQuery>;
export type GarminSleepSuspenseQueryHookResult = ReturnType<typeof useGarminSleepSuspenseQuery>;
export type GarminSleepQueryResult = Apollo.QueryResult<GarminSleepQuery, GarminSleepQueryVariables>;
export const OuraActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OuraActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"latestActivitySummary"},"name":{"kind":"Name","value":"metric_record_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_ACTIVITY_SUMMARY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","alias":{"kind":"Name","value":"score"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"SCORE_%","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OuraActivityRecord"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"targetCalories"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace_key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_ACTIVITY:TARGET_CALORIES","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OuraActivityRecord"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"inactive"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"INACTIVE_MINUTE","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OuraActivityRecord"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cal_total"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"CAL_TOTAL_KILOCALORIES","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OuraActivityRecord"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"steps"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"STEPS_COUNT","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OuraActivityRecord"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"daily_movement"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"DAILY_MOVEMENT_METERS","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OuraActivityRecord"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"high"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"HIGH_MINUTE","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OuraActivityRecord"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"medium"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"MEDIUM_MINUTE","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OuraActivityRecord"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"low"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"LOW_MINUTE","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OuraActivityRecord"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cal_active"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ACTIVE_KILOCALORIES","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OuraActivityRecord"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OuraActivityRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useOuraActivityQuery__
 *
 * To run a query within a React component, call `useOuraActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useOuraActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOuraActivityQuery({
 *   variables: {
 *      timestamp: // value for 'timestamp'
 *   },
 * });
 */
export function useOuraActivityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OuraActivityQuery, OuraActivityQueryVariables> & ({ variables: OuraActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OuraActivityQuery, OuraActivityQueryVariables>(OuraActivityDocument, options);
      }
export function useOuraActivityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OuraActivityQuery, OuraActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OuraActivityQuery, OuraActivityQueryVariables>(OuraActivityDocument, options);
        }
export function useOuraActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OuraActivityQuery, OuraActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OuraActivityQuery, OuraActivityQueryVariables>(OuraActivityDocument, options);
        }
export type OuraActivityQueryHookResult = ReturnType<typeof useOuraActivityQuery>;
export type OuraActivityLazyQueryHookResult = ReturnType<typeof useOuraActivityLazyQuery>;
export type OuraActivitySuspenseQueryHookResult = ReturnType<typeof useOuraActivitySuspenseQuery>;
export type OuraActivityQueryResult = Apollo.QueryResult<OuraActivityQuery, OuraActivityQueryVariables>;
export const OuraReadinessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OuraReadiness"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oura_sleep_summary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"datetime"}},{"kind":"Field","name":{"kind":"Name","value":"datetime"}},{"kind":"Field","name":{"kind":"Name","value":"readiness_score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"metricId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heart_rate_min"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"metricId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hrv_average"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"metricId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"temperature_deviation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"metricId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"respiratory_rate_average"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"metricId"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useOuraReadinessQuery__
 *
 * To run a query within a React component, call `useOuraReadinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useOuraReadinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOuraReadinessQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useOuraReadinessQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OuraReadinessQuery, OuraReadinessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OuraReadinessQuery, OuraReadinessQueryVariables>(OuraReadinessDocument, options);
      }
export function useOuraReadinessLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OuraReadinessQuery, OuraReadinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OuraReadinessQuery, OuraReadinessQueryVariables>(OuraReadinessDocument, options);
        }
export function useOuraReadinessSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OuraReadinessQuery, OuraReadinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OuraReadinessQuery, OuraReadinessQueryVariables>(OuraReadinessDocument, options);
        }
export type OuraReadinessQueryHookResult = ReturnType<typeof useOuraReadinessQuery>;
export type OuraReadinessLazyQueryHookResult = ReturnType<typeof useOuraReadinessLazyQuery>;
export type OuraReadinessSuspenseQueryHookResult = ReturnType<typeof useOuraReadinessSuspenseQuery>;
export type OuraReadinessQueryResult = Apollo.QueryResult<OuraReadinessQuery, OuraReadinessQueryVariables>;
export const OuraSleepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OuraSleep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oura_sleep_summary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"datetime"}},{"kind":"Field","name":{"kind":"Name","value":"datetime"}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"metricId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"duration"},"name":{"kind":"Name","value":"duration_total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"metricId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"awake"},"name":{"kind":"Name","value":"duration_awake"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"metricId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rem"},"name":{"kind":"Name","value":"duration_rem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"metricId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"light"},"name":{"kind":"Name","value":"duration_light"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"metricId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"deep"},"name":{"kind":"Name","value":"duration_deep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"metricId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"efficiency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"metricId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"hr_average"},"name":{"kind":"Name","value":"heart_rate_average"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"metricId"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useOuraSleepQuery__
 *
 * To run a query within a React component, call `useOuraSleepQuery` and pass it any options that fit your needs.
 * When your component renders, `useOuraSleepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOuraSleepQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useOuraSleepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OuraSleepQuery, OuraSleepQueryVariables> & ({ variables: OuraSleepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OuraSleepQuery, OuraSleepQueryVariables>(OuraSleepDocument, options);
      }
export function useOuraSleepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OuraSleepQuery, OuraSleepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OuraSleepQuery, OuraSleepQueryVariables>(OuraSleepDocument, options);
        }
export function useOuraSleepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OuraSleepQuery, OuraSleepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OuraSleepQuery, OuraSleepQueryVariables>(OuraSleepDocument, options);
        }
export type OuraSleepQueryHookResult = ReturnType<typeof useOuraSleepQuery>;
export type OuraSleepLazyQueryHookResult = ReturnType<typeof useOuraSleepLazyQuery>;
export type OuraSleepSuspenseQueryHookResult = ReturnType<typeof useOuraSleepSuspenseQuery>;
export type OuraSleepQueryResult = Apollo.QueryResult<OuraSleepQuery, OuraSleepQueryVariables>;
export const WithingsMostRecentBodyCompDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WithingsMostRecentBodyComp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weightKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bodyFatPercentageKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"muscleMassKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boneMassKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fatMassKgKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"metric_records"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"withings"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"bodyFatPercentageKey"}},{"kind":"Variable","name":{"kind":"Name","value":"weightKey"}},{"kind":"Variable","name":{"kind":"Name","value":"muscleMassKey"}},{"kind":"Variable","name":{"kind":"Name","value":"boneMassKey"}},{"kind":"Variable","name":{"kind":"Name","value":"fatMassKgKey"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useWithingsMostRecentBodyCompQuery__
 *
 * To run a query within a React component, call `useWithingsMostRecentBodyCompQuery` and pass it any options that fit your needs.
 * When your component renders, `useWithingsMostRecentBodyCompQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWithingsMostRecentBodyCompQuery({
 *   variables: {
 *      namespace: // value for 'namespace'
 *      weightKey: // value for 'weightKey'
 *      bodyFatPercentageKey: // value for 'bodyFatPercentageKey'
 *      muscleMassKey: // value for 'muscleMassKey'
 *      boneMassKey: // value for 'boneMassKey'
 *      fatMassKgKey: // value for 'fatMassKgKey'
 *      timestamp: // value for 'timestamp'
 *   },
 * });
 */
export function useWithingsMostRecentBodyCompQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WithingsMostRecentBodyCompQuery, WithingsMostRecentBodyCompQueryVariables> & ({ variables: WithingsMostRecentBodyCompQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WithingsMostRecentBodyCompQuery, WithingsMostRecentBodyCompQueryVariables>(WithingsMostRecentBodyCompDocument, options);
      }
export function useWithingsMostRecentBodyCompLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WithingsMostRecentBodyCompQuery, WithingsMostRecentBodyCompQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WithingsMostRecentBodyCompQuery, WithingsMostRecentBodyCompQueryVariables>(WithingsMostRecentBodyCompDocument, options);
        }
export function useWithingsMostRecentBodyCompSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WithingsMostRecentBodyCompQuery, WithingsMostRecentBodyCompQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WithingsMostRecentBodyCompQuery, WithingsMostRecentBodyCompQueryVariables>(WithingsMostRecentBodyCompDocument, options);
        }
export type WithingsMostRecentBodyCompQueryHookResult = ReturnType<typeof useWithingsMostRecentBodyCompQuery>;
export type WithingsMostRecentBodyCompLazyQueryHookResult = ReturnType<typeof useWithingsMostRecentBodyCompLazyQuery>;
export type WithingsMostRecentBodyCompSuspenseQueryHookResult = ReturnType<typeof useWithingsMostRecentBodyCompSuspenseQuery>;
export type WithingsMostRecentBodyCompQueryResult = Apollo.QueryResult<WithingsMostRecentBodyCompQuery, WithingsMostRecentBodyCompQueryVariables>;
export const HomePageShopModuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HomePageShopModule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"homePageShopModule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Content_Item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Layout"}},{"kind":"Field","name":{"kind":"Name","value":"Pill_Text"}},{"kind":"Field","name":{"kind":"Name","value":"Name"}},{"kind":"Field","name":{"kind":"Name","value":"Summary"}},{"kind":"Field","name":{"kind":"Name","value":"Mobile_Summary"}},{"kind":"Field","name":{"kind":"Name","value":"Cta_Text"}},{"kind":"Field","name":{"kind":"Name","value":"Link"}},{"kind":"Field","name":{"kind":"Name","value":"Box_Images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Mobile_Box_Images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Background_Image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useHomePageShopModuleQuery__
 *
 * To run a query within a React component, call `useHomePageShopModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageShopModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageShopModuleQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomePageShopModuleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HomePageShopModuleQuery, HomePageShopModuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HomePageShopModuleQuery, HomePageShopModuleQueryVariables>(HomePageShopModuleDocument, options);
      }
export function useHomePageShopModuleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HomePageShopModuleQuery, HomePageShopModuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HomePageShopModuleQuery, HomePageShopModuleQueryVariables>(HomePageShopModuleDocument, options);
        }
export function useHomePageShopModuleSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HomePageShopModuleQuery, HomePageShopModuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HomePageShopModuleQuery, HomePageShopModuleQueryVariables>(HomePageShopModuleDocument, options);
        }
export type HomePageShopModuleQueryHookResult = ReturnType<typeof useHomePageShopModuleQuery>;
export type HomePageShopModuleLazyQueryHookResult = ReturnType<typeof useHomePageShopModuleLazyQuery>;
export type HomePageShopModuleSuspenseQueryHookResult = ReturnType<typeof useHomePageShopModuleSuspenseQuery>;
export type HomePageShopModuleQueryResult = Apollo.QueryResult<HomePageShopModuleQuery, HomePageShopModuleQueryVariables>;
export const GetFeaturedPackagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFeaturedPackages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryAvailability"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"_text"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"advanced"},"name":{"kind":"Name","value":"product_catalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"StringValue","value":"%advanced%","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"country_availability"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryAvailability"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCatalogFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"foundation"},"name":{"kind":"Name","value":"product_catalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"StringValue","value":"%foundation%","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"country_availability"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryAvailability"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCatalogFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCatalogFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StripeProductPriceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_free_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_paid_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetFeaturedPackagesQuery__
 *
 * To run a query within a React component, call `useGetFeaturedPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedPackagesQuery({
 *   variables: {
 *      countryAvailability: // value for 'countryAvailability'
 *   },
 * });
 */
export function useGetFeaturedPackagesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFeaturedPackagesQuery, GetFeaturedPackagesQueryVariables> & ({ variables: GetFeaturedPackagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFeaturedPackagesQuery, GetFeaturedPackagesQueryVariables>(GetFeaturedPackagesDocument, options);
      }
export function useGetFeaturedPackagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeaturedPackagesQuery, GetFeaturedPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFeaturedPackagesQuery, GetFeaturedPackagesQueryVariables>(GetFeaturedPackagesDocument, options);
        }
export function useGetFeaturedPackagesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetFeaturedPackagesQuery, GetFeaturedPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFeaturedPackagesQuery, GetFeaturedPackagesQueryVariables>(GetFeaturedPackagesDocument, options);
        }
export type GetFeaturedPackagesQueryHookResult = ReturnType<typeof useGetFeaturedPackagesQuery>;
export type GetFeaturedPackagesLazyQueryHookResult = ReturnType<typeof useGetFeaturedPackagesLazyQuery>;
export type GetFeaturedPackagesSuspenseQueryHookResult = ReturnType<typeof useGetFeaturedPackagesSuspenseQuery>;
export type GetFeaturedPackagesQueryResult = Apollo.QueryResult<GetFeaturedPackagesQuery, GetFeaturedPackagesQueryVariables>;
export const DeleteUserHomeTilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUserHomeTiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_user_home_tile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode;
export type DeleteUserHomeTilesMutationFn = Apollo.MutationFunction<DeleteUserHomeTilesMutation, DeleteUserHomeTilesMutationVariables>;

/**
 * __useDeleteUserHomeTilesMutation__
 *
 * To run a mutation, you first call `useDeleteUserHomeTilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserHomeTilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserHomeTilesMutation, { data, loading, error }] = useDeleteUserHomeTilesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteUserHomeTilesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserHomeTilesMutation, DeleteUserHomeTilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserHomeTilesMutation, DeleteUserHomeTilesMutationVariables>(DeleteUserHomeTilesDocument, options);
      }
export type DeleteUserHomeTilesMutationHookResult = ReturnType<typeof useDeleteUserHomeTilesMutation>;
export type DeleteUserHomeTilesMutationResult = Apollo.MutationResult<DeleteUserHomeTilesMutation>;
export type DeleteUserHomeTilesMutationOptions = Apollo.BaseMutationOptions<DeleteUserHomeTilesMutation, DeleteUserHomeTilesMutationVariables>;
export const MostRecentAmRecordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MostRecentAmRecord"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"beforeExpression"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"history"},"name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"BODY_MEASUREMENT","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"CGM_BLOOD_GLUCOSE_MG_DL_AM","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"beforeExpression"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMostRecentAmRecordQuery__
 *
 * To run a query within a React component, call `useMostRecentAmRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useMostRecentAmRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMostRecentAmRecordQuery({
 *   variables: {
 *      beforeExpression: // value for 'beforeExpression'
 *   },
 * });
 */
export function useMostRecentAmRecordQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MostRecentAmRecordQuery, MostRecentAmRecordQueryVariables> & ({ variables: MostRecentAmRecordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MostRecentAmRecordQuery, MostRecentAmRecordQueryVariables>(MostRecentAmRecordDocument, options);
      }
export function useMostRecentAmRecordLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MostRecentAmRecordQuery, MostRecentAmRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MostRecentAmRecordQuery, MostRecentAmRecordQueryVariables>(MostRecentAmRecordDocument, options);
        }
export function useMostRecentAmRecordSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MostRecentAmRecordQuery, MostRecentAmRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MostRecentAmRecordQuery, MostRecentAmRecordQueryVariables>(MostRecentAmRecordDocument, options);
        }
export type MostRecentAmRecordQueryHookResult = ReturnType<typeof useMostRecentAmRecordQuery>;
export type MostRecentAmRecordLazyQueryHookResult = ReturnType<typeof useMostRecentAmRecordLazyQuery>;
export type MostRecentAmRecordSuspenseQueryHookResult = ReturnType<typeof useMostRecentAmRecordSuspenseQuery>;
export type MostRecentAmRecordQueryResult = Apollo.QueryResult<MostRecentAmRecordQuery, MostRecentAmRecordQueryVariables>;
export const CurrentBloodGlucoseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentBloodGlucose"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"afterExpression"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"beforeExpression"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"history"},"name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"BODY_MEASUREMENT","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"CGM_BLOOD_GLUCOSE_MG_DL_AM","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"14"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"beforeExpression"}}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"datetime_utc"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"current"},"name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"BODY_MEASUREMENT","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"CGM_BLOOD_GLUCOSE_MG_DL","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"all"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"afterExpression"}},{"kind":"Variable","name":{"kind":"Name","value":"beforeExpression"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"below"},"name":{"kind":"Name","value":"metric_records_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"IntValue","value":"70"}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"afterExpression"}},{"kind":"Variable","name":{"kind":"Name","value":"beforeExpression"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"within"},"name":{"kind":"Name","value":"metric_records_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"IntValue","value":"70"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"IntValue","value":"110"}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"afterExpression"}},{"kind":"Variable","name":{"kind":"Name","value":"beforeExpression"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"above"},"name":{"kind":"Name","value":"metric_records_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"IntValue","value":"110"}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"afterExpression"}},{"kind":"Variable","name":{"kind":"Name","value":"beforeExpression"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCurrentBloodGlucoseQuery__
 *
 * To run a query within a React component, call `useCurrentBloodGlucoseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentBloodGlucoseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentBloodGlucoseQuery({
 *   variables: {
 *      afterExpression: // value for 'afterExpression'
 *      beforeExpression: // value for 'beforeExpression'
 *   },
 * });
 */
export function useCurrentBloodGlucoseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CurrentBloodGlucoseQuery, CurrentBloodGlucoseQueryVariables> & ({ variables: CurrentBloodGlucoseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentBloodGlucoseQuery, CurrentBloodGlucoseQueryVariables>(CurrentBloodGlucoseDocument, options);
      }
export function useCurrentBloodGlucoseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentBloodGlucoseQuery, CurrentBloodGlucoseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentBloodGlucoseQuery, CurrentBloodGlucoseQueryVariables>(CurrentBloodGlucoseDocument, options);
        }
export function useCurrentBloodGlucoseSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CurrentBloodGlucoseQuery, CurrentBloodGlucoseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CurrentBloodGlucoseQuery, CurrentBloodGlucoseQueryVariables>(CurrentBloodGlucoseDocument, options);
        }
export type CurrentBloodGlucoseQueryHookResult = ReturnType<typeof useCurrentBloodGlucoseQuery>;
export type CurrentBloodGlucoseLazyQueryHookResult = ReturnType<typeof useCurrentBloodGlucoseLazyQuery>;
export type CurrentBloodGlucoseSuspenseQueryHookResult = ReturnType<typeof useCurrentBloodGlucoseSuspenseQuery>;
export type CurrentBloodGlucoseQueryResult = Apollo.QueryResult<CurrentBloodGlucoseQuery, CurrentBloodGlucoseQueryVariables>;
export const MostRecentBloodPressureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MostRecentBloodPressure"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"DIASTOLIC_BLOOD_PRESSURE","block":false},{"kind":"StringValue","value":"SYSTOLIC_BLOOD_PRESSURE","block":false},{"kind":"StringValue","value":"HEART_RATE_AVERAGE","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"display_name"}},{"kind":"Field","alias":{"kind":"Name","value":"unit"},"name":{"kind":"Name","value":"preference_unit"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"14"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMostRecentBloodPressureQuery__
 *
 * To run a query within a React component, call `useMostRecentBloodPressureQuery` and pass it any options that fit your needs.
 * When your component renders, `useMostRecentBloodPressureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMostRecentBloodPressureQuery({
 *   variables: {
 *      namespace: // value for 'namespace'
 *      timestamp: // value for 'timestamp'
 *   },
 * });
 */
export function useMostRecentBloodPressureQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MostRecentBloodPressureQuery, MostRecentBloodPressureQueryVariables> & ({ variables: MostRecentBloodPressureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MostRecentBloodPressureQuery, MostRecentBloodPressureQueryVariables>(MostRecentBloodPressureDocument, options);
      }
export function useMostRecentBloodPressureLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MostRecentBloodPressureQuery, MostRecentBloodPressureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MostRecentBloodPressureQuery, MostRecentBloodPressureQueryVariables>(MostRecentBloodPressureDocument, options);
        }
export function useMostRecentBloodPressureSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MostRecentBloodPressureQuery, MostRecentBloodPressureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MostRecentBloodPressureQuery, MostRecentBloodPressureQueryVariables>(MostRecentBloodPressureDocument, options);
        }
export type MostRecentBloodPressureQueryHookResult = ReturnType<typeof useMostRecentBloodPressureQuery>;
export type MostRecentBloodPressureLazyQueryHookResult = ReturnType<typeof useMostRecentBloodPressureLazyQuery>;
export type MostRecentBloodPressureSuspenseQueryHookResult = ReturnType<typeof useMostRecentBloodPressureSuspenseQuery>;
export type MostRecentBloodPressureQueryResult = Apollo.QueryResult<MostRecentBloodPressureQuery, MostRecentBloodPressureQueryVariables>;
export const LEGACY_MostRecentBodyCompDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LEGACY_MostRecentBodyComp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weightKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bodyFatPercentageKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"muscleMassKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boneMassKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fatMassKgKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"weightHistory"},"name":{"kind":"Name","value":"metric_record"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"withings"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weightKey"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"14"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bodyFatHistory"},"name":{"kind":"Name","value":"metric_record"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"withings"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bodyFatPercentageKey"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"14"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"metric_records"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"withings"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"bodyFatPercentageKey"}},{"kind":"Variable","name":{"kind":"Name","value":"weightKey"}},{"kind":"Variable","name":{"kind":"Name","value":"muscleMassKey"}},{"kind":"Variable","name":{"kind":"Name","value":"boneMassKey"}},{"kind":"Variable","name":{"kind":"Name","value":"fatMassKgKey"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"display_name"}},{"kind":"Field","alias":{"kind":"Name","value":"unit"},"name":{"kind":"Name","value":"preference_unit"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useLEGACY_MostRecentBodyCompQuery__
 *
 * To run a query within a React component, call `useLEGACY_MostRecentBodyCompQuery` and pass it any options that fit your needs.
 * When your component renders, `useLEGACY_MostRecentBodyCompQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLEGACY_MostRecentBodyCompQuery({
 *   variables: {
 *      namespace: // value for 'namespace'
 *      weightKey: // value for 'weightKey'
 *      bodyFatPercentageKey: // value for 'bodyFatPercentageKey'
 *      muscleMassKey: // value for 'muscleMassKey'
 *      boneMassKey: // value for 'boneMassKey'
 *      fatMassKgKey: // value for 'fatMassKgKey'
 *      timestamp: // value for 'timestamp'
 *   },
 * });
 */
export function useLEGACY_MostRecentBodyCompQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LEGACY_MostRecentBodyCompQuery, LEGACY_MostRecentBodyCompQueryVariables> & ({ variables: LEGACY_MostRecentBodyCompQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LEGACY_MostRecentBodyCompQuery, LEGACY_MostRecentBodyCompQueryVariables>(LEGACY_MostRecentBodyCompDocument, options);
      }
export function useLEGACY_MostRecentBodyCompLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LEGACY_MostRecentBodyCompQuery, LEGACY_MostRecentBodyCompQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LEGACY_MostRecentBodyCompQuery, LEGACY_MostRecentBodyCompQueryVariables>(LEGACY_MostRecentBodyCompDocument, options);
        }
export function useLEGACY_MostRecentBodyCompSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LEGACY_MostRecentBodyCompQuery, LEGACY_MostRecentBodyCompQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LEGACY_MostRecentBodyCompQuery, LEGACY_MostRecentBodyCompQueryVariables>(LEGACY_MostRecentBodyCompDocument, options);
        }
export type LEGACY_MostRecentBodyCompQueryHookResult = ReturnType<typeof useLEGACY_MostRecentBodyCompQuery>;
export type LEGACY_MostRecentBodyCompLazyQueryHookResult = ReturnType<typeof useLEGACY_MostRecentBodyCompLazyQuery>;
export type LEGACY_MostRecentBodyCompSuspenseQueryHookResult = ReturnType<typeof useLEGACY_MostRecentBodyCompSuspenseQuery>;
export type LEGACY_MostRecentBodyCompQueryResult = Apollo.QueryResult<LEGACY_MostRecentBodyCompQuery, LEGACY_MostRecentBodyCompQueryVariables>;
export const LEGACY_GarminActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LEGACY_GarminActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"history"},"name":{"kind":"Name","value":"metric_record"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"14"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"metric_record_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"DAILY_SUMMARY","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ACTIVE_KILOCALORIES","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric_record_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"DAILY_SUMMARY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"ACTIVE_KILOCALORIES","block":false},{"kind":"StringValue","value":"RESTING_KILOCALORIES","block":false},{"kind":"StringValue","value":"DISTANCE","block":false},{"kind":"StringValue","value":"ACTIVE_DURATION","block":false},{"kind":"StringValue","value":"MODERATE_INTENSITY_DURATION","block":false},{"kind":"StringValue","value":"HIGH_INTENSITY_ACTIVE_DURATION","block":false},{"kind":"StringValue","value":"STEPS","block":false}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","alias":{"kind":"Name","value":"unit"},"name":{"kind":"Name","value":"preference_unit"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useLEGACY_GarminActivityQuery__
 *
 * To run a query within a React component, call `useLEGACY_GarminActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useLEGACY_GarminActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLEGACY_GarminActivityQuery({
 *   variables: {
 *      timestamp: // value for 'timestamp'
 *   },
 * });
 */
export function useLEGACY_GarminActivityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LEGACY_GarminActivityQuery, LEGACY_GarminActivityQueryVariables> & ({ variables: LEGACY_GarminActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LEGACY_GarminActivityQuery, LEGACY_GarminActivityQueryVariables>(LEGACY_GarminActivityDocument, options);
      }
export function useLEGACY_GarminActivityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LEGACY_GarminActivityQuery, LEGACY_GarminActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LEGACY_GarminActivityQuery, LEGACY_GarminActivityQueryVariables>(LEGACY_GarminActivityDocument, options);
        }
export function useLEGACY_GarminActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LEGACY_GarminActivityQuery, LEGACY_GarminActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LEGACY_GarminActivityQuery, LEGACY_GarminActivityQueryVariables>(LEGACY_GarminActivityDocument, options);
        }
export type LEGACY_GarminActivityQueryHookResult = ReturnType<typeof useLEGACY_GarminActivityQuery>;
export type LEGACY_GarminActivityLazyQueryHookResult = ReturnType<typeof useLEGACY_GarminActivityLazyQuery>;
export type LEGACY_GarminActivitySuspenseQueryHookResult = ReturnType<typeof useLEGACY_GarminActivitySuspenseQuery>;
export type LEGACY_GarminActivityQueryResult = Apollo.QueryResult<LEGACY_GarminActivityQuery, LEGACY_GarminActivityQueryVariables>;
export const LEGACY_GarminSleepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LEGACY_GarminSleep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_record_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"GROUPED_DAY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"local_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"group_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"SLEEP","block":false},{"kind":"StringValue","value":"HEALTH_SUMMARY","block":false},{"kind":"StringValue","value":"DAILY_SUMMARY","block":false},{"kind":"StringValue","value":"SLEEP_HRV","block":false}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"garmin"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"local_date"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"14"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"local_date"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"SLEEP","block":false},{"kind":"StringValue","value":"BODY_MEASUREMENT","block":false}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"SCORE","block":false},{"kind":"StringValue","value":"DURATION_TOTAL","block":false},{"kind":"StringValue","value":"DURATION_DEEP","block":false},{"kind":"StringValue","value":"DURATION_LIGHT","block":false},{"kind":"StringValue","value":"DURATION_REM","block":false},{"kind":"StringValue","value":"DURATION_AWAKE","block":false},{"kind":"StringValue","value":"HRV_RMSSD_AVERAGE","block":false},{"kind":"StringValue","value":"HEART_RATE_RESTING","block":false}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","alias":{"kind":"Name","value":"unit"},"name":{"kind":"Name","value":"preference_unit"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useLEGACY_GarminSleepQuery__
 *
 * To run a query within a React component, call `useLEGACY_GarminSleepQuery` and pass it any options that fit your needs.
 * When your component renders, `useLEGACY_GarminSleepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLEGACY_GarminSleepQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useLEGACY_GarminSleepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LEGACY_GarminSleepQuery, LEGACY_GarminSleepQueryVariables> & ({ variables: LEGACY_GarminSleepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LEGACY_GarminSleepQuery, LEGACY_GarminSleepQueryVariables>(LEGACY_GarminSleepDocument, options);
      }
export function useLEGACY_GarminSleepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LEGACY_GarminSleepQuery, LEGACY_GarminSleepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LEGACY_GarminSleepQuery, LEGACY_GarminSleepQueryVariables>(LEGACY_GarminSleepDocument, options);
        }
export function useLEGACY_GarminSleepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LEGACY_GarminSleepQuery, LEGACY_GarminSleepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LEGACY_GarminSleepQuery, LEGACY_GarminSleepQueryVariables>(LEGACY_GarminSleepDocument, options);
        }
export type LEGACY_GarminSleepQueryHookResult = ReturnType<typeof useLEGACY_GarminSleepQuery>;
export type LEGACY_GarminSleepLazyQueryHookResult = ReturnType<typeof useLEGACY_GarminSleepLazyQuery>;
export type LEGACY_GarminSleepSuspenseQueryHookResult = ReturnType<typeof useLEGACY_GarminSleepSuspenseQuery>;
export type LEGACY_GarminSleepQueryResult = Apollo.QueryResult<LEGACY_GarminSleepQuery, LEGACY_GarminSleepQueryVariables>;
export const GarminWorkoutsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GarminWorkouts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workoutSessionKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activitySummaryKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_record_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activitySummaryKey"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"garmin"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"metric_records"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workoutSessionKey"}}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endTime"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGarminWorkoutsQuery__
 *
 * To run a query within a React component, call `useGarminWorkoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGarminWorkoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGarminWorkoutsQuery({
 *   variables: {
 *      endTime: // value for 'endTime'
 *      startTime: // value for 'startTime'
 *      workoutSessionKey: // value for 'workoutSessionKey'
 *      activitySummaryKey: // value for 'activitySummaryKey'
 *   },
 * });
 */
export function useGarminWorkoutsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GarminWorkoutsQuery, GarminWorkoutsQueryVariables> & ({ variables: GarminWorkoutsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GarminWorkoutsQuery, GarminWorkoutsQueryVariables>(GarminWorkoutsDocument, options);
      }
export function useGarminWorkoutsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GarminWorkoutsQuery, GarminWorkoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GarminWorkoutsQuery, GarminWorkoutsQueryVariables>(GarminWorkoutsDocument, options);
        }
export function useGarminWorkoutsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GarminWorkoutsQuery, GarminWorkoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GarminWorkoutsQuery, GarminWorkoutsQueryVariables>(GarminWorkoutsDocument, options);
        }
export type GarminWorkoutsQueryHookResult = ReturnType<typeof useGarminWorkoutsQuery>;
export type GarminWorkoutsLazyQueryHookResult = ReturnType<typeof useGarminWorkoutsLazyQuery>;
export type GarminWorkoutsSuspenseQueryHookResult = ReturnType<typeof useGarminWorkoutsSuspenseQuery>;
export type GarminWorkoutsQueryResult = Apollo.QueryResult<GarminWorkoutsQuery, GarminWorkoutsQueryVariables>;
export const LEGACY_OuraActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LEGACY_OuraActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"latestActivitySummary"},"name":{"kind":"Name","value":"metric_record_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_ACTIVITY_SUMMARY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","alias":{"kind":"Name","value":"score"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"SCORE_%","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LEGACY_OuraActivityRecord"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"inactive"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"INACTIVE_MINUTE","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LEGACY_OuraActivityRecord"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cal_total"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"CAL_TOTAL_KILOCALORIES","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LEGACY_OuraActivityRecord"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"steps"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"STEPS_COUNT","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LEGACY_OuraActivityRecord"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"daily_movement"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"DAILY_MOVEMENT_METERS","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LEGACY_OuraActivityRecord"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"high"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"HIGH_MINUTE","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LEGACY_OuraActivityRecord"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"medium"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"MEDIUM_MINUTE","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LEGACY_OuraActivityRecord"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"low"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"LOW_MINUTE","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LEGACY_OuraActivityRecord"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cal_active"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ACTIVE_KILOCALORIES","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LEGACY_OuraActivityRecord"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"activityScoreHistory"},"name":{"kind":"Name","value":"metric_record"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"14"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamp"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"metric_record_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_ACTIVITY_SUMMARY","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"OURA_ACTIVITY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"SCORE_%","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LEGACY_OuraActivityRecord"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","alias":{"kind":"Name","value":"unit"},"name":{"kind":"Name","value":"preference_unit"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useLEGACY_OuraActivityQuery__
 *
 * To run a query within a React component, call `useLEGACY_OuraActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useLEGACY_OuraActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLEGACY_OuraActivityQuery({
 *   variables: {
 *      timestamp: // value for 'timestamp'
 *   },
 * });
 */
export function useLEGACY_OuraActivityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LEGACY_OuraActivityQuery, LEGACY_OuraActivityQueryVariables> & ({ variables: LEGACY_OuraActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LEGACY_OuraActivityQuery, LEGACY_OuraActivityQueryVariables>(LEGACY_OuraActivityDocument, options);
      }
export function useLEGACY_OuraActivityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LEGACY_OuraActivityQuery, LEGACY_OuraActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LEGACY_OuraActivityQuery, LEGACY_OuraActivityQueryVariables>(LEGACY_OuraActivityDocument, options);
        }
export function useLEGACY_OuraActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LEGACY_OuraActivityQuery, LEGACY_OuraActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LEGACY_OuraActivityQuery, LEGACY_OuraActivityQueryVariables>(LEGACY_OuraActivityDocument, options);
        }
export type LEGACY_OuraActivityQueryHookResult = ReturnType<typeof useLEGACY_OuraActivityQuery>;
export type LEGACY_OuraActivityLazyQueryHookResult = ReturnType<typeof useLEGACY_OuraActivityLazyQuery>;
export type LEGACY_OuraActivitySuspenseQueryHookResult = ReturnType<typeof useLEGACY_OuraActivitySuspenseQuery>;
export type LEGACY_OuraActivityQueryResult = Apollo.QueryResult<LEGACY_OuraActivityQuery, LEGACY_OuraActivityQueryVariables>;
export const LEGACY_OuraReadinessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LEGACY_OuraReadiness"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oura_sleep_summary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"datetime"}},{"kind":"Field","name":{"kind":"Name","value":"datetime"}},{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"readiness_score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heart_rate_min"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hrv_average"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"temperature_deviation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"respiratory_rate_average"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"readiness_score_history"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"14"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"datetime"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useLEGACY_OuraReadinessQuery__
 *
 * To run a query within a React component, call `useLEGACY_OuraReadinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useLEGACY_OuraReadinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLEGACY_OuraReadinessQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useLEGACY_OuraReadinessQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LEGACY_OuraReadinessQuery, LEGACY_OuraReadinessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LEGACY_OuraReadinessQuery, LEGACY_OuraReadinessQueryVariables>(LEGACY_OuraReadinessDocument, options);
      }
export function useLEGACY_OuraReadinessLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LEGACY_OuraReadinessQuery, LEGACY_OuraReadinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LEGACY_OuraReadinessQuery, LEGACY_OuraReadinessQueryVariables>(LEGACY_OuraReadinessDocument, options);
        }
export function useLEGACY_OuraReadinessSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LEGACY_OuraReadinessQuery, LEGACY_OuraReadinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LEGACY_OuraReadinessQuery, LEGACY_OuraReadinessQueryVariables>(LEGACY_OuraReadinessDocument, options);
        }
export type LEGACY_OuraReadinessQueryHookResult = ReturnType<typeof useLEGACY_OuraReadinessQuery>;
export type LEGACY_OuraReadinessLazyQueryHookResult = ReturnType<typeof useLEGACY_OuraReadinessLazyQuery>;
export type LEGACY_OuraReadinessSuspenseQueryHookResult = ReturnType<typeof useLEGACY_OuraReadinessSuspenseQuery>;
export type LEGACY_OuraReadinessQueryResult = Apollo.QueryResult<LEGACY_OuraReadinessQuery, LEGACY_OuraReadinessQueryVariables>;
export const LEGACY_OuraSleepDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LEGACY_OuraSleep"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oura_sleep_summary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"datetime"}},{"kind":"Field","name":{"kind":"Name","value":"datetime"}},{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"duration"},"name":{"kind":"Name","value":"duration_total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"awake"},"name":{"kind":"Name","value":"duration_awake"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rem"},"name":{"kind":"Name","value":"duration_rem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"light"},"name":{"kind":"Name","value":"duration_light"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"deep"},"name":{"kind":"Name","value":"duration_deep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"efficiency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"hr_average"},"name":{"kind":"Name","value":"heart_rate_average"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"score_history"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"14"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"datetime"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useLEGACY_OuraSleepQuery__
 *
 * To run a query within a React component, call `useLEGACY_OuraSleepQuery` and pass it any options that fit your needs.
 * When your component renders, `useLEGACY_OuraSleepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLEGACY_OuraSleepQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useLEGACY_OuraSleepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LEGACY_OuraSleepQuery, LEGACY_OuraSleepQueryVariables> & ({ variables: LEGACY_OuraSleepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LEGACY_OuraSleepQuery, LEGACY_OuraSleepQueryVariables>(LEGACY_OuraSleepDocument, options);
      }
export function useLEGACY_OuraSleepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LEGACY_OuraSleepQuery, LEGACY_OuraSleepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LEGACY_OuraSleepQuery, LEGACY_OuraSleepQueryVariables>(LEGACY_OuraSleepDocument, options);
        }
export function useLEGACY_OuraSleepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LEGACY_OuraSleepQuery, LEGACY_OuraSleepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LEGACY_OuraSleepQuery, LEGACY_OuraSleepQueryVariables>(LEGACY_OuraSleepDocument, options);
        }
export type LEGACY_OuraSleepQueryHookResult = ReturnType<typeof useLEGACY_OuraSleepQuery>;
export type LEGACY_OuraSleepLazyQueryHookResult = ReturnType<typeof useLEGACY_OuraSleepLazyQuery>;
export type LEGACY_OuraSleepSuspenseQueryHookResult = ReturnType<typeof useLEGACY_OuraSleepSuspenseQuery>;
export type LEGACY_OuraSleepQueryResult = Apollo.QueryResult<LEGACY_OuraSleepQuery, LEGACY_OuraSleepQueryVariables>;
export const HomePageFeaturedContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HomePageFeaturedContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"homePageFeaturedContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"related_contents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"entity_id"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useHomePageFeaturedContentQuery__
 *
 * To run a query within a React component, call `useHomePageFeaturedContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageFeaturedContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageFeaturedContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomePageFeaturedContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HomePageFeaturedContentQuery, HomePageFeaturedContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HomePageFeaturedContentQuery, HomePageFeaturedContentQueryVariables>(HomePageFeaturedContentDocument, options);
      }
export function useHomePageFeaturedContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HomePageFeaturedContentQuery, HomePageFeaturedContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HomePageFeaturedContentQuery, HomePageFeaturedContentQueryVariables>(HomePageFeaturedContentDocument, options);
        }
export function useHomePageFeaturedContentSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HomePageFeaturedContentQuery, HomePageFeaturedContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HomePageFeaturedContentQuery, HomePageFeaturedContentQueryVariables>(HomePageFeaturedContentDocument, options);
        }
export type HomePageFeaturedContentQueryHookResult = ReturnType<typeof useHomePageFeaturedContentQuery>;
export type HomePageFeaturedContentLazyQueryHookResult = ReturnType<typeof useHomePageFeaturedContentLazyQuery>;
export type HomePageFeaturedContentSuspenseQueryHookResult = ReturnType<typeof useHomePageFeaturedContentSuspenseQuery>;
export type HomePageFeaturedContentQueryResult = Apollo.QueryResult<HomePageFeaturedContentQuery, HomePageFeaturedContentQueryVariables>;
export const NutrientMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NutrientMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timestamptz"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataSourceFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"enum_data_source_enum_comparison_exp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userProvidedValue"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"external_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateString"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_provided"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataSourceFilter"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric_records_rollup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"interval_count"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"interval_type"},"value":{"kind":"EnumValue","value":"day"}},{"kind":"Argument","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"Argument","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"day"},"name":{"kind":"Name","value":"interval_start"}},{"kind":"Field","alias":{"kind":"Name","value":"sum"},"name":{"kind":"Name","value":"preference_sum"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricStreaksFields"}},{"kind":"Field","name":{"kind":"Name","value":"metric_targets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preference_target"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreakFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Streak"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period_start"}},{"kind":"Field","name":{"kind":"Name","value":"period_end"}},{"kind":"Field","name":{"kind":"Name","value":"is_active"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"preference_target"}},{"kind":"Field","name":{"kind":"Name","value":"period"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"weeks"}},{"kind":"Field","name":{"kind":"Name","value":"months"}},{"kind":"Field","name":{"kind":"Name","value":"years"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricStreaksFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"active_streak"},"name":{"kind":"Name","value":"streak"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"end_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreakFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"most_recent_streak"},"name":{"kind":"Name","value":"streak"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}},{"kind":"Argument","name":{"kind":"Name","value":"end_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreakFields"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useNutrientMetricQuery__
 *
 * To run a query within a React component, call `useNutrientMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useNutrientMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNutrientMetricQuery({
 *   variables: {
 *      timestamptz: // value for 'timestamptz'
 *      dateString: // value for 'dateString'
 *      end: // value for 'end'
 *      namespace: // value for 'namespace'
 *      key: // value for 'key'
 *      dataSourceFilter: // value for 'dataSourceFilter'
 *   },
 * });
 */
export function useNutrientMetricQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NutrientMetricQuery, NutrientMetricQueryVariables> & ({ variables: NutrientMetricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NutrientMetricQuery, NutrientMetricQueryVariables>(NutrientMetricDocument, options);
      }
export function useNutrientMetricLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NutrientMetricQuery, NutrientMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NutrientMetricQuery, NutrientMetricQueryVariables>(NutrientMetricDocument, options);
        }
export function useNutrientMetricSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<NutrientMetricQuery, NutrientMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NutrientMetricQuery, NutrientMetricQueryVariables>(NutrientMetricDocument, options);
        }
export type NutrientMetricQueryHookResult = ReturnType<typeof useNutrientMetricQuery>;
export type NutrientMetricLazyQueryHookResult = ReturnType<typeof useNutrientMetricLazyQuery>;
export type NutrientMetricSuspenseQueryHookResult = ReturnType<typeof useNutrientMetricSuspenseQuery>;
export type NutrientMetricQueryResult = Apollo.QueryResult<NutrientMetricQuery, NutrientMetricQueryVariables>;
export const LabImportJobResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LabImportJobResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_import_job_results"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"user_vault_file_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loincNumber"}},{"kind":"Field","name":{"kind":"Name","value":"markerId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useLabImportJobResultsQuery__
 *
 * To run a query within a React component, call `useLabImportJobResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabImportJobResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabImportJobResultsQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useLabImportJobResultsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LabImportJobResultsQuery, LabImportJobResultsQueryVariables> & ({ variables: LabImportJobResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LabImportJobResultsQuery, LabImportJobResultsQueryVariables>(LabImportJobResultsDocument, options);
      }
export function useLabImportJobResultsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LabImportJobResultsQuery, LabImportJobResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LabImportJobResultsQuery, LabImportJobResultsQueryVariables>(LabImportJobResultsDocument, options);
        }
export function useLabImportJobResultsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LabImportJobResultsQuery, LabImportJobResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LabImportJobResultsQuery, LabImportJobResultsQueryVariables>(LabImportJobResultsDocument, options);
        }
export type LabImportJobResultsQueryHookResult = ReturnType<typeof useLabImportJobResultsQuery>;
export type LabImportJobResultsLazyQueryHookResult = ReturnType<typeof useLabImportJobResultsLazyQuery>;
export type LabImportJobResultsSuspenseQueryHookResult = ReturnType<typeof useLabImportJobResultsSuspenseQuery>;
export type LabImportJobResultsQueryResult = Apollo.QueryResult<LabImportJobResultsQuery, LabImportJobResultsQueryVariables>;
export const LabResultsByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LabResultsById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"beforeDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latestValuesLimit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"6"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipLatestValues"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipRollupValues"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":true}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latestRollupValuesArgs"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"latest_rollup_values_metric_args"}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipMetricRecordRefRanges"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":true}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latestRollupLimit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"5"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataSources"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"enum_data_source_enum"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_result_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recommendationItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entityId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}},{"kind":"Field","name":{"kind":"Name","value":"file_vault"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"download"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lab_order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_result_status"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_number"}},{"kind":"Field","name":{"kind":"Name","value":"receipt_url"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"line_items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"results_pdf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"download"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lab_name"}},{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","name":{"kind":"Name","value":"metric_record_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"phenoAge"},"name":{"kind":"Name","value":"children"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"PHENO_AGE","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhenoAgeFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"derived"},"name":{"kind":"Name","value":"children"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"group_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"DERIVED_METRICS","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LabResultMetricRecordGroupFields"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LabResultMetricRecordGroupFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReferenceRangeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReferenceRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dataSource"}},{"kind":"Field","name":{"kind":"Name","value":"rangeType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"targets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"optimal"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"discreteTargets"}},{"kind":"Field","name":{"kind":"Name","value":"healthEffectsTitle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricMatchedReferenceRangeTargetsV2Fields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matched_reference_range_targets_v2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"include_other_criteria"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReferenceRangeFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricRecordReferenceRangeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference_range"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}},{"kind":"Field","name":{"kind":"Name","value":"range_type"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"targets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"optimal"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"discrete_targets"}},{"kind":"Field","name":{"kind":"Name","value":"health_effects_text"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricReferenceRangeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricMatchedReferenceRangeTargetsV2Fields"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipMetricRecordRefRanges"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricRecordReferenceRangeFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MetricDetailsResultsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"namespace_key"}},{"kind":"Field","name":{"kind":"Name","value":"lab_test_markers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_weekly_rollup_type"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipRollupValues"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"default_rollup_interval_type"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipRollupValues"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"latest_rollup_values"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latestRollupValuesArgs"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latestRollupLimit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"interval_start"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipRollupValues"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval_start"}},{"kind":"Field","name":{"kind":"Name","value":"interval_end"}},{"kind":"Field","name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataSources"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value_type"}},{"kind":"Field","name":{"kind":"Name","value":"lab_result_marker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_optimal"}},{"kind":"Field","name":{"kind":"Name","value":"converted_value"}},{"kind":"Field","name":{"kind":"Name","value":"test"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestValues"},"name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latestValuesLimit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"beforeDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"data_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataSources"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipLatestValues"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"value_string"}},{"kind":"Field","name":{"kind":"Name","value":"value_type"}},{"kind":"Field","name":{"kind":"Name","value":"lab_result_marker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_optimal"}},{"kind":"Field","name":{"kind":"Name","value":"converted_value"}},{"kind":"Field","name":{"kind":"Name","value":"test"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LabResultMetricRecordGroupFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricRecordReferenceRangeFields"}},{"kind":"Field","name":{"kind":"Name","value":"lab_result_markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"converted_value"}},{"kind":"Field","name":{"kind":"Name","value":"is_optimal"}},{"kind":"Field","name":{"kind":"Name","value":"test"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"watched_metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricDetailsResultsFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricReferenceRangeFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhenoAgeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"beforeDate"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MetricRecordReferenceRangeFields"}},{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","name":{"kind":"Name","value":"metric_id"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useLabResultsByIdQuery__
 *
 * To run a query within a React component, call `useLabResultsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabResultsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabResultsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      beforeDate: // value for 'beforeDate'
 *      latestValuesLimit: // value for 'latestValuesLimit'
 *      skipLatestValues: // value for 'skipLatestValues'
 *      skipRollupValues: // value for 'skipRollupValues'
 *      latestRollupValuesArgs: // value for 'latestRollupValuesArgs'
 *      skipMetricRecordRefRanges: // value for 'skipMetricRecordRefRanges'
 *      latestRollupLimit: // value for 'latestRollupLimit'
 *      dataSources: // value for 'dataSources'
 *   },
 * });
 */
export function useLabResultsByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LabResultsByIdQuery, LabResultsByIdQueryVariables> & ({ variables: LabResultsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LabResultsByIdQuery, LabResultsByIdQueryVariables>(LabResultsByIdDocument, options);
      }
export function useLabResultsByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LabResultsByIdQuery, LabResultsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LabResultsByIdQuery, LabResultsByIdQueryVariables>(LabResultsByIdDocument, options);
        }
export function useLabResultsByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LabResultsByIdQuery, LabResultsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LabResultsByIdQuery, LabResultsByIdQueryVariables>(LabResultsByIdDocument, options);
        }
export type LabResultsByIdQueryHookResult = ReturnType<typeof useLabResultsByIdQuery>;
export type LabResultsByIdLazyQueryHookResult = ReturnType<typeof useLabResultsByIdLazyQuery>;
export type LabResultsByIdSuspenseQueryHookResult = ReturnType<typeof useLabResultsByIdSuspenseQuery>;
export type LabResultsByIdQueryResult = Apollo.QueryResult<LabResultsByIdQuery, LabResultsByIdQueryVariables>;
export const LabResultsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LabResultsList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lab_name"}},{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","name":{"kind":"Name","value":"metric_record_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"metric_id"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"lab_test_markers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lab_result_marker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_optimal"}},{"kind":"Field","name":{"kind":"Name","value":"test"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lab_order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lab_result_status"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"line_items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_type"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useLabResultsListQuery__
 *
 * To run a query within a React component, call `useLabResultsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabResultsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabResultsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useLabResultsListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LabResultsListQuery, LabResultsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LabResultsListQuery, LabResultsListQueryVariables>(LabResultsListDocument, options);
      }
export function useLabResultsListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LabResultsListQuery, LabResultsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LabResultsListQuery, LabResultsListQueryVariables>(LabResultsListDocument, options);
        }
export function useLabResultsListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LabResultsListQuery, LabResultsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LabResultsListQuery, LabResultsListQueryVariables>(LabResultsListDocument, options);
        }
export type LabResultsListQueryHookResult = ReturnType<typeof useLabResultsListQuery>;
export type LabResultsListLazyQueryHookResult = ReturnType<typeof useLabResultsListLazyQuery>;
export type LabResultsListSuspenseQueryHookResult = ReturnType<typeof useLabResultsListSuspenseQuery>;
export type LabResultsListQueryResult = Apollo.QueryResult<LabResultsListQuery, LabResultsListQueryVariables>;
export const SubmitLabResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitLabResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LabMetricResultInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_import_submit_results"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type SubmitLabResultsMutationFn = Apollo.MutationFunction<SubmitLabResultsMutation, SubmitLabResultsMutationVariables>;

/**
 * __useSubmitLabResultsMutation__
 *
 * To run a mutation, you first call `useSubmitLabResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitLabResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitLabResultsMutation, { data, loading, error }] = useSubmitLabResultsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitLabResultsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitLabResultsMutation, SubmitLabResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitLabResultsMutation, SubmitLabResultsMutationVariables>(SubmitLabResultsDocument, options);
      }
export type SubmitLabResultsMutationHookResult = ReturnType<typeof useSubmitLabResultsMutation>;
export type SubmitLabResultsMutationResult = Apollo.MutationResult<SubmitLabResultsMutation>;
export type SubmitLabResultsMutationOptions = Apollo.BaseMutationOptions<SubmitLabResultsMutation, SubmitLabResultsMutationVariables>;
export const WatchedMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WatchedMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"watched_metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useWatchedMetricsQuery__
 *
 * To run a query within a React component, call `useWatchedMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchedMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchedMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWatchedMetricsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WatchedMetricsQuery, WatchedMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WatchedMetricsQuery, WatchedMetricsQueryVariables>(WatchedMetricsDocument, options);
      }
export function useWatchedMetricsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WatchedMetricsQuery, WatchedMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WatchedMetricsQuery, WatchedMetricsQueryVariables>(WatchedMetricsDocument, options);
        }
export function useWatchedMetricsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WatchedMetricsQuery, WatchedMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WatchedMetricsQuery, WatchedMetricsQueryVariables>(WatchedMetricsDocument, options);
        }
export type WatchedMetricsQueryHookResult = ReturnType<typeof useWatchedMetricsQuery>;
export type WatchedMetricsLazyQueryHookResult = ReturnType<typeof useWatchedMetricsLazyQuery>;
export type WatchedMetricsSuspenseQueryHookResult = ReturnType<typeof useWatchedMetricsSuspenseQuery>;
export type WatchedMetricsQueryResult = Apollo.QueryResult<WatchedMetricsQuery, WatchedMetricsQueryVariables>;
export const InsertLifeEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertLifeEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"life_event_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_life_event_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}}]}}]} as unknown as DocumentNode;
export type InsertLifeEventMutationFn = Apollo.MutationFunction<InsertLifeEventMutation, InsertLifeEventMutationVariables>;

/**
 * __useInsertLifeEventMutation__
 *
 * To run a mutation, you first call `useInsertLifeEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertLifeEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertLifeEventMutation, { data, loading, error }] = useInsertLifeEventMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertLifeEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertLifeEventMutation, InsertLifeEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InsertLifeEventMutation, InsertLifeEventMutationVariables>(InsertLifeEventDocument, options);
      }
export type InsertLifeEventMutationHookResult = ReturnType<typeof useInsertLifeEventMutation>;
export type InsertLifeEventMutationResult = Apollo.MutationResult<InsertLifeEventMutation>;
export type InsertLifeEventMutationOptions = Apollo.BaseMutationOptions<InsertLifeEventMutation, InsertLifeEventMutationVariables>;
export const UpdateLifeEventByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLifeEventById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"life_event_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_life_event_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}}]}}]} as unknown as DocumentNode;
export type UpdateLifeEventByIdMutationFn = Apollo.MutationFunction<UpdateLifeEventByIdMutation, UpdateLifeEventByIdMutationVariables>;

/**
 * __useUpdateLifeEventByIdMutation__
 *
 * To run a mutation, you first call `useUpdateLifeEventByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLifeEventByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLifeEventByIdMutation, { data, loading, error }] = useUpdateLifeEventByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      changes: // value for 'changes'
 *   },
 * });
 */
export function useUpdateLifeEventByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateLifeEventByIdMutation, UpdateLifeEventByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateLifeEventByIdMutation, UpdateLifeEventByIdMutationVariables>(UpdateLifeEventByIdDocument, options);
      }
export type UpdateLifeEventByIdMutationHookResult = ReturnType<typeof useUpdateLifeEventByIdMutation>;
export type UpdateLifeEventByIdMutationResult = Apollo.MutationResult<UpdateLifeEventByIdMutation>;
export type UpdateLifeEventByIdMutationOptions = Apollo.BaseMutationOptions<UpdateLifeEventByIdMutation, UpdateLifeEventByIdMutationVariables>;
export const LifeEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LifeEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"life_event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useLifeEventsQuery__
 *
 * To run a query within a React component, call `useLifeEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLifeEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLifeEventsQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useLifeEventsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LifeEventsQuery, LifeEventsQueryVariables> & ({ variables: LifeEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LifeEventsQuery, LifeEventsQueryVariables>(LifeEventsDocument, options);
      }
export function useLifeEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LifeEventsQuery, LifeEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LifeEventsQuery, LifeEventsQueryVariables>(LifeEventsDocument, options);
        }
export function useLifeEventsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LifeEventsQuery, LifeEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LifeEventsQuery, LifeEventsQueryVariables>(LifeEventsDocument, options);
        }
export type LifeEventsQueryHookResult = ReturnType<typeof useLifeEventsQuery>;
export type LifeEventsLazyQueryHookResult = ReturnType<typeof useLifeEventsLazyQuery>;
export type LifeEventsSuspenseQueryHookResult = ReturnType<typeof useLifeEventsSuspenseQuery>;
export type LifeEventsQueryResult = Apollo.QueryResult<LifeEventsQuery, LifeEventsQueryVariables>;
export const DeleteLifeEventByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLifeEventById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_life_event_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type DeleteLifeEventByIdMutationFn = Apollo.MutationFunction<DeleteLifeEventByIdMutation, DeleteLifeEventByIdMutationVariables>;

/**
 * __useDeleteLifeEventByIdMutation__
 *
 * To run a mutation, you first call `useDeleteLifeEventByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLifeEventByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLifeEventByIdMutation, { data, loading, error }] = useDeleteLifeEventByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLifeEventByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteLifeEventByIdMutation, DeleteLifeEventByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteLifeEventByIdMutation, DeleteLifeEventByIdMutationVariables>(DeleteLifeEventByIdDocument, options);
      }
export type DeleteLifeEventByIdMutationHookResult = ReturnType<typeof useDeleteLifeEventByIdMutation>;
export type DeleteLifeEventByIdMutationResult = Apollo.MutationResult<DeleteLifeEventByIdMutation>;
export type DeleteLifeEventByIdMutationOptions = Apollo.BaseMutationOptions<DeleteLifeEventByIdMutation, DeleteLifeEventByIdMutationVariables>;
export const LatestMetricEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LatestMetricEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latest_user_provided_metrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_provided"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"NUTRIENT","block":false},{"kind":"StringValue","value":"SUPPLEMENT","block":false}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useLatestMetricEntriesQuery__
 *
 * To run a query within a React component, call `useLatestMetricEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestMetricEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestMetricEntriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLatestMetricEntriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LatestMetricEntriesQuery, LatestMetricEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LatestMetricEntriesQuery, LatestMetricEntriesQueryVariables>(LatestMetricEntriesDocument, options);
      }
export function useLatestMetricEntriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LatestMetricEntriesQuery, LatestMetricEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LatestMetricEntriesQuery, LatestMetricEntriesQueryVariables>(LatestMetricEntriesDocument, options);
        }
export function useLatestMetricEntriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LatestMetricEntriesQuery, LatestMetricEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LatestMetricEntriesQuery, LatestMetricEntriesQueryVariables>(LatestMetricEntriesDocument, options);
        }
export type LatestMetricEntriesQueryHookResult = ReturnType<typeof useLatestMetricEntriesQuery>;
export type LatestMetricEntriesLazyQueryHookResult = ReturnType<typeof useLatestMetricEntriesLazyQuery>;
export type LatestMetricEntriesSuspenseQueryHookResult = ReturnType<typeof useLatestMetricEntriesSuspenseQuery>;
export type LatestMetricEntriesQueryResult = Apollo.QueryResult<LatestMetricEntriesQuery, LatestMetricEntriesQueryVariables>;
export const GetUploadUrlParamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUploadUrlParams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upload_type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"enum_media_upload_type"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_post_upload_params"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"upload_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upload_type"}}},{"kind":"Argument","name":{"kind":"Name","value":"file_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"object_url"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetUploadUrlParamsQuery__
 *
 * To run a query within a React component, call `useGetUploadUrlParamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadUrlParamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadUrlParamsQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      upload_type: // value for 'upload_type'
 *   },
 * });
 */
export function useGetUploadUrlParamsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUploadUrlParamsQuery, GetUploadUrlParamsQueryVariables> & ({ variables: GetUploadUrlParamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUploadUrlParamsQuery, GetUploadUrlParamsQueryVariables>(GetUploadUrlParamsDocument, options);
      }
export function useGetUploadUrlParamsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUploadUrlParamsQuery, GetUploadUrlParamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUploadUrlParamsQuery, GetUploadUrlParamsQueryVariables>(GetUploadUrlParamsDocument, options);
        }
export function useGetUploadUrlParamsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUploadUrlParamsQuery, GetUploadUrlParamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUploadUrlParamsQuery, GetUploadUrlParamsQueryVariables>(GetUploadUrlParamsDocument, options);
        }
export type GetUploadUrlParamsQueryHookResult = ReturnType<typeof useGetUploadUrlParamsQuery>;
export type GetUploadUrlParamsLazyQueryHookResult = ReturnType<typeof useGetUploadUrlParamsLazyQuery>;
export type GetUploadUrlParamsSuspenseQueryHookResult = ReturnType<typeof useGetUploadUrlParamsSuspenseQuery>;
export type GetUploadUrlParamsQueryResult = Apollo.QueryResult<GetUploadUrlParamsQuery, GetUploadUrlParamsQueryVariables>;
export const LabsOnlyMembershipUpgradeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LabsOnlyMembershipUpgrade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labs_only_membership_upgrade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"membership_tier"}}]}}]}}]} as unknown as DocumentNode;
export type LabsOnlyMembershipUpgradeMutationFn = Apollo.MutationFunction<LabsOnlyMembershipUpgradeMutation, LabsOnlyMembershipUpgradeMutationVariables>;

/**
 * __useLabsOnlyMembershipUpgradeMutation__
 *
 * To run a mutation, you first call `useLabsOnlyMembershipUpgradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLabsOnlyMembershipUpgradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [labsOnlyMembershipUpgradeMutation, { data, loading, error }] = useLabsOnlyMembershipUpgradeMutation({
 *   variables: {
 *   },
 * });
 */
export function useLabsOnlyMembershipUpgradeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LabsOnlyMembershipUpgradeMutation, LabsOnlyMembershipUpgradeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LabsOnlyMembershipUpgradeMutation, LabsOnlyMembershipUpgradeMutationVariables>(LabsOnlyMembershipUpgradeDocument, options);
      }
export type LabsOnlyMembershipUpgradeMutationHookResult = ReturnType<typeof useLabsOnlyMembershipUpgradeMutation>;
export type LabsOnlyMembershipUpgradeMutationResult = Apollo.MutationResult<LabsOnlyMembershipUpgradeMutation>;
export type LabsOnlyMembershipUpgradeMutationOptions = Apollo.BaseMutationOptions<LabsOnlyMembershipUpgradeMutation, LabsOnlyMembershipUpgradeMutationVariables>;
export const SelectMetricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SelectMetric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"metric_explorer_selection_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_metric_explorer_selection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}}]}}]}}]}}]} as unknown as DocumentNode;
export type SelectMetricMutationFn = Apollo.MutationFunction<SelectMetricMutation, SelectMetricMutationVariables>;

/**
 * __useSelectMetricMutation__
 *
 * To run a mutation, you first call `useSelectMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectMetricMutation, { data, loading, error }] = useSelectMetricMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useSelectMetricMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SelectMetricMutation, SelectMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SelectMetricMutation, SelectMetricMutationVariables>(SelectMetricDocument, options);
      }
export type SelectMetricMutationHookResult = ReturnType<typeof useSelectMetricMutation>;
export type SelectMetricMutationResult = Apollo.MutationResult<SelectMetricMutation>;
export type SelectMetricMutationOptions = Apollo.BaseMutationOptions<SelectMetricMutation, SelectMetricMutationVariables>;
export const MetricRecordGroupMetricAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MetricRecordGroupMetricAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_record_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMetricRecordGroupMetricAggregateQuery__
 *
 * To run a query within a React component, call `useMetricRecordGroupMetricAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricRecordGroupMetricAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricRecordGroupMetricAggregateQuery({
 *   variables: {
 *      whereClause: // value for 'whereClause'
 *   },
 * });
 */
export function useMetricRecordGroupMetricAggregateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MetricRecordGroupMetricAggregateQuery, MetricRecordGroupMetricAggregateQueryVariables> & ({ variables: MetricRecordGroupMetricAggregateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MetricRecordGroupMetricAggregateQuery, MetricRecordGroupMetricAggregateQueryVariables>(MetricRecordGroupMetricAggregateDocument, options);
      }
export function useMetricRecordGroupMetricAggregateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetricRecordGroupMetricAggregateQuery, MetricRecordGroupMetricAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MetricRecordGroupMetricAggregateQuery, MetricRecordGroupMetricAggregateQueryVariables>(MetricRecordGroupMetricAggregateDocument, options);
        }
export function useMetricRecordGroupMetricAggregateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MetricRecordGroupMetricAggregateQuery, MetricRecordGroupMetricAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MetricRecordGroupMetricAggregateQuery, MetricRecordGroupMetricAggregateQueryVariables>(MetricRecordGroupMetricAggregateDocument, options);
        }
export type MetricRecordGroupMetricAggregateQueryHookResult = ReturnType<typeof useMetricRecordGroupMetricAggregateQuery>;
export type MetricRecordGroupMetricAggregateLazyQueryHookResult = ReturnType<typeof useMetricRecordGroupMetricAggregateLazyQuery>;
export type MetricRecordGroupMetricAggregateSuspenseQueryHookResult = ReturnType<typeof useMetricRecordGroupMetricAggregateSuspenseQuery>;
export type MetricRecordGroupMetricAggregateQueryResult = Apollo.QueryResult<MetricRecordGroupMetricAggregateQuery, MetricRecordGroupMetricAggregateQueryVariables>;
export const MetricRecordGroupMetricRecordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MetricRecordGroupMetricRecords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricRecordGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_record_group_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricRecordGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"preference_value"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMetricRecordGroupMetricRecordsQuery__
 *
 * To run a query within a React component, call `useMetricRecordGroupMetricRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricRecordGroupMetricRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricRecordGroupMetricRecordsQuery({
 *   variables: {
 *      metricRecordGroupId: // value for 'metricRecordGroupId'
 *   },
 * });
 */
export function useMetricRecordGroupMetricRecordsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MetricRecordGroupMetricRecordsQuery, MetricRecordGroupMetricRecordsQueryVariables> & ({ variables: MetricRecordGroupMetricRecordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MetricRecordGroupMetricRecordsQuery, MetricRecordGroupMetricRecordsQueryVariables>(MetricRecordGroupMetricRecordsDocument, options);
      }
export function useMetricRecordGroupMetricRecordsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetricRecordGroupMetricRecordsQuery, MetricRecordGroupMetricRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MetricRecordGroupMetricRecordsQuery, MetricRecordGroupMetricRecordsQueryVariables>(MetricRecordGroupMetricRecordsDocument, options);
        }
export function useMetricRecordGroupMetricRecordsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MetricRecordGroupMetricRecordsQuery, MetricRecordGroupMetricRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MetricRecordGroupMetricRecordsQuery, MetricRecordGroupMetricRecordsQueryVariables>(MetricRecordGroupMetricRecordsDocument, options);
        }
export type MetricRecordGroupMetricRecordsQueryHookResult = ReturnType<typeof useMetricRecordGroupMetricRecordsQuery>;
export type MetricRecordGroupMetricRecordsLazyQueryHookResult = ReturnType<typeof useMetricRecordGroupMetricRecordsLazyQuery>;
export type MetricRecordGroupMetricRecordsSuspenseQueryHookResult = ReturnType<typeof useMetricRecordGroupMetricRecordsSuspenseQuery>;
export type MetricRecordGroupMetricRecordsQueryResult = Apollo.QueryResult<MetricRecordGroupMetricRecordsQuery, MetricRecordGroupMetricRecordsQueryVariables>;
export const PreviewDashboardIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"PreviewDashboardId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_staging_dashboard"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __usePreviewDashboardIdSubscription__
 *
 * To run a query within a React component, call `usePreviewDashboardIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePreviewDashboardIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewDashboardIdSubscription({
 *   variables: {
 *   },
 * });
 */
export function usePreviewDashboardIdSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<PreviewDashboardIdSubscription, PreviewDashboardIdSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<PreviewDashboardIdSubscription, PreviewDashboardIdSubscriptionVariables>(PreviewDashboardIdDocument, options);
      }
export type PreviewDashboardIdSubscriptionHookResult = ReturnType<typeof usePreviewDashboardIdSubscription>;
export type PreviewDashboardIdSubscriptionResult = Apollo.SubscriptionResult<PreviewDashboardIdSubscription>;
export const MetricExplorerSelectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"MetricExplorerSelection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_explorer_selection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"metric_id"}},{"kind":"Field","name":{"kind":"Name","value":"variant"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMetricExplorerSelectionSubscription__
 *
 * To run a query within a React component, call `useMetricExplorerSelectionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMetricExplorerSelectionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricExplorerSelectionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useMetricExplorerSelectionSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<MetricExplorerSelectionSubscription, MetricExplorerSelectionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<MetricExplorerSelectionSubscription, MetricExplorerSelectionSubscriptionVariables>(MetricExplorerSelectionDocument, options);
      }
export type MetricExplorerSelectionSubscriptionHookResult = ReturnType<typeof useMetricExplorerSelectionSubscription>;
export type MetricExplorerSelectionSubscriptionResult = Apollo.SubscriptionResult<MetricExplorerSelectionSubscription>;
export const RemoveMetricExplorerSelectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveMetricExplorerSelection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"metric_explorer_selection_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_metric_explorer_selection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export type RemoveMetricExplorerSelectionMutationFn = Apollo.MutationFunction<RemoveMetricExplorerSelectionMutation, RemoveMetricExplorerSelectionMutationVariables>;

/**
 * __useRemoveMetricExplorerSelectionMutation__
 *
 * To run a mutation, you first call `useRemoveMetricExplorerSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMetricExplorerSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMetricExplorerSelectionMutation, { data, loading, error }] = useRemoveMetricExplorerSelectionMutation({
 *   variables: {
 *      whereClause: // value for 'whereClause'
 *   },
 * });
 */
export function useRemoveMetricExplorerSelectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveMetricExplorerSelectionMutation, RemoveMetricExplorerSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveMetricExplorerSelectionMutation, RemoveMetricExplorerSelectionMutationVariables>(RemoveMetricExplorerSelectionDocument, options);
      }
export type RemoveMetricExplorerSelectionMutationHookResult = ReturnType<typeof useRemoveMetricExplorerSelectionMutation>;
export type RemoveMetricExplorerSelectionMutationResult = Apollo.MutationResult<RemoveMetricExplorerSelectionMutation>;
export type RemoveMetricExplorerSelectionMutationOptions = Apollo.BaseMutationOptions<RemoveMetricExplorerSelectionMutation, RemoveMetricExplorerSelectionMutationVariables>;
export const SaveMetricSelectionToDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveMetricSelectionToDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"save_metric_selection_to_dashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}]}}]} as unknown as DocumentNode;
export type SaveMetricSelectionToDashboardMutationFn = Apollo.MutationFunction<SaveMetricSelectionToDashboardMutation, SaveMetricSelectionToDashboardMutationVariables>;

/**
 * __useSaveMetricSelectionToDashboardMutation__
 *
 * To run a mutation, you first call `useSaveMetricSelectionToDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMetricSelectionToDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMetricSelectionToDashboardMutation, { data, loading, error }] = useSaveMetricSelectionToDashboardMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSaveMetricSelectionToDashboardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveMetricSelectionToDashboardMutation, SaveMetricSelectionToDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveMetricSelectionToDashboardMutation, SaveMetricSelectionToDashboardMutationVariables>(SaveMetricSelectionToDashboardDocument, options);
      }
export type SaveMetricSelectionToDashboardMutationHookResult = ReturnType<typeof useSaveMetricSelectionToDashboardMutation>;
export type SaveMetricSelectionToDashboardMutationResult = Apollo.MutationResult<SaveMetricSelectionToDashboardMutation>;
export type SaveMetricSelectionToDashboardMutationOptions = Apollo.BaseMutationOptions<SaveMetricSelectionToDashboardMutation, SaveMetricSelectionToDashboardMutationVariables>;
export const SaveMetricSelectionToExperimentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveMetricSelectionToExperiment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"save_metric_selection_to_experiment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"start_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"end_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}]}}]} as unknown as DocumentNode;
export type SaveMetricSelectionToExperimentMutationFn = Apollo.MutationFunction<SaveMetricSelectionToExperimentMutation, SaveMetricSelectionToExperimentMutationVariables>;

/**
 * __useSaveMetricSelectionToExperimentMutation__
 *
 * To run a mutation, you first call `useSaveMetricSelectionToExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMetricSelectionToExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMetricSelectionToExperimentMutation, { data, loading, error }] = useSaveMetricSelectionToExperimentMutation({
 *   variables: {
 *      name: // value for 'name'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useSaveMetricSelectionToExperimentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveMetricSelectionToExperimentMutation, SaveMetricSelectionToExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveMetricSelectionToExperimentMutation, SaveMetricSelectionToExperimentMutationVariables>(SaveMetricSelectionToExperimentDocument, options);
      }
export type SaveMetricSelectionToExperimentMutationHookResult = ReturnType<typeof useSaveMetricSelectionToExperimentMutation>;
export type SaveMetricSelectionToExperimentMutationResult = Apollo.MutationResult<SaveMetricSelectionToExperimentMutation>;
export type SaveMetricSelectionToExperimentMutationOptions = Apollo.BaseMutationOptions<SaveMetricSelectionToExperimentMutation, SaveMetricSelectionToExperimentMutationVariables>;
export const ExperimentDashboardIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExperimentDashboardId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"experiment_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useExperimentDashboardIdQuery__
 *
 * To run a query within a React component, call `useExperimentDashboardIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperimentDashboardIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperimentDashboardIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExperimentDashboardIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExperimentDashboardIdQuery, ExperimentDashboardIdQueryVariables> & ({ variables: ExperimentDashboardIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExperimentDashboardIdQuery, ExperimentDashboardIdQueryVariables>(ExperimentDashboardIdDocument, options);
      }
export function useExperimentDashboardIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExperimentDashboardIdQuery, ExperimentDashboardIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExperimentDashboardIdQuery, ExperimentDashboardIdQueryVariables>(ExperimentDashboardIdDocument, options);
        }
export function useExperimentDashboardIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ExperimentDashboardIdQuery, ExperimentDashboardIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExperimentDashboardIdQuery, ExperimentDashboardIdQueryVariables>(ExperimentDashboardIdDocument, options);
        }
export type ExperimentDashboardIdQueryHookResult = ReturnType<typeof useExperimentDashboardIdQuery>;
export type ExperimentDashboardIdLazyQueryHookResult = ReturnType<typeof useExperimentDashboardIdLazyQuery>;
export type ExperimentDashboardIdSuspenseQueryHookResult = ReturnType<typeof useExperimentDashboardIdSuspenseQuery>;
export type ExperimentDashboardIdQueryResult = Apollo.QueryResult<ExperimentDashboardIdQuery, ExperimentDashboardIdQueryVariables>;
export const MetricRecordRowsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MetricRecordRowsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderByClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record_order_by"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_record_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMetricRecordRowsCountQuery__
 *
 * To run a query within a React component, call `useMetricRecordRowsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricRecordRowsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricRecordRowsCountQuery({
 *   variables: {
 *      whereClause: // value for 'whereClause'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderByClause: // value for 'orderByClause'
 *   },
 * });
 */
export function useMetricRecordRowsCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MetricRecordRowsCountQuery, MetricRecordRowsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MetricRecordRowsCountQuery, MetricRecordRowsCountQueryVariables>(MetricRecordRowsCountDocument, options);
      }
export function useMetricRecordRowsCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetricRecordRowsCountQuery, MetricRecordRowsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MetricRecordRowsCountQuery, MetricRecordRowsCountQueryVariables>(MetricRecordRowsCountDocument, options);
        }
export function useMetricRecordRowsCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MetricRecordRowsCountQuery, MetricRecordRowsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MetricRecordRowsCountQuery, MetricRecordRowsCountQueryVariables>(MetricRecordRowsCountDocument, options);
        }
export type MetricRecordRowsCountQueryHookResult = ReturnType<typeof useMetricRecordRowsCountQuery>;
export type MetricRecordRowsCountLazyQueryHookResult = ReturnType<typeof useMetricRecordRowsCountLazyQuery>;
export type MetricRecordRowsCountSuspenseQueryHookResult = ReturnType<typeof useMetricRecordRowsCountSuspenseQuery>;
export type MetricRecordRowsCountQueryResult = Apollo.QueryResult<MetricRecordRowsCountQuery, MetricRecordRowsCountQueryVariables>;
export const MetricRecordGroupRowsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MetricRecordGroupRowsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record_group_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderByClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"metric_record_group_order_by"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_record_group_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderByClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMetricRecordGroupRowsCountQuery__
 *
 * To run a query within a React component, call `useMetricRecordGroupRowsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricRecordGroupRowsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricRecordGroupRowsCountQuery({
 *   variables: {
 *      whereClause: // value for 'whereClause'
 *      limit: // value for 'limit'
 *      orderByClause: // value for 'orderByClause'
 *   },
 * });
 */
export function useMetricRecordGroupRowsCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MetricRecordGroupRowsCountQuery, MetricRecordGroupRowsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MetricRecordGroupRowsCountQuery, MetricRecordGroupRowsCountQueryVariables>(MetricRecordGroupRowsCountDocument, options);
      }
export function useMetricRecordGroupRowsCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetricRecordGroupRowsCountQuery, MetricRecordGroupRowsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MetricRecordGroupRowsCountQuery, MetricRecordGroupRowsCountQueryVariables>(MetricRecordGroupRowsCountDocument, options);
        }
export function useMetricRecordGroupRowsCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MetricRecordGroupRowsCountQuery, MetricRecordGroupRowsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MetricRecordGroupRowsCountQuery, MetricRecordGroupRowsCountQueryVariables>(MetricRecordGroupRowsCountDocument, options);
        }
export type MetricRecordGroupRowsCountQueryHookResult = ReturnType<typeof useMetricRecordGroupRowsCountQuery>;
export type MetricRecordGroupRowsCountLazyQueryHookResult = ReturnType<typeof useMetricRecordGroupRowsCountLazyQuery>;
export type MetricRecordGroupRowsCountSuspenseQueryHookResult = ReturnType<typeof useMetricRecordGroupRowsCountSuspenseQuery>;
export type MetricRecordGroupRowsCountQueryResult = Apollo.QueryResult<MetricRecordGroupRowsCountQuery, MetricRecordGroupRowsCountQueryVariables>;
export const UserDataSourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserDataSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_record"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"data_source"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data_source"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useUserDataSourcesQuery__
 *
 * To run a query within a React component, call `useUserDataSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDataSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDataSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserDataSourcesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserDataSourcesQuery, UserDataSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserDataSourcesQuery, UserDataSourcesQueryVariables>(UserDataSourcesDocument, options);
      }
export function useUserDataSourcesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserDataSourcesQuery, UserDataSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserDataSourcesQuery, UserDataSourcesQueryVariables>(UserDataSourcesDocument, options);
        }
export function useUserDataSourcesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserDataSourcesQuery, UserDataSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserDataSourcesQuery, UserDataSourcesQueryVariables>(UserDataSourcesDocument, options);
        }
export type UserDataSourcesQueryHookResult = ReturnType<typeof useUserDataSourcesQuery>;
export type UserDataSourcesLazyQueryHookResult = ReturnType<typeof useUserDataSourcesLazyQuery>;
export type UserDataSourcesSuspenseQueryHookResult = ReturnType<typeof useUserDataSourcesSuspenseQuery>;
export type UserDataSourcesQueryResult = Apollo.QueryResult<UserDataSourcesQuery, UserDataSourcesQueryVariables>;
export const ProfileAndTosModalDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileAndTosModalData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"has_accepted_latest_terms"}},{"kind":"Field","name":{"kind":"Name","value":"terms_of_service"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLatest"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"me_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date_of_birth"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useProfileAndTosModalDataQuery__
 *
 * To run a query within a React component, call `useProfileAndTosModalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileAndTosModalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileAndTosModalDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileAndTosModalDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProfileAndTosModalDataQuery, ProfileAndTosModalDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfileAndTosModalDataQuery, ProfileAndTosModalDataQueryVariables>(ProfileAndTosModalDataDocument, options);
      }
export function useProfileAndTosModalDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfileAndTosModalDataQuery, ProfileAndTosModalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfileAndTosModalDataQuery, ProfileAndTosModalDataQueryVariables>(ProfileAndTosModalDataDocument, options);
        }
export function useProfileAndTosModalDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProfileAndTosModalDataQuery, ProfileAndTosModalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProfileAndTosModalDataQuery, ProfileAndTosModalDataQueryVariables>(ProfileAndTosModalDataDocument, options);
        }
export type ProfileAndTosModalDataQueryHookResult = ReturnType<typeof useProfileAndTosModalDataQuery>;
export type ProfileAndTosModalDataLazyQueryHookResult = ReturnType<typeof useProfileAndTosModalDataLazyQuery>;
export type ProfileAndTosModalDataSuspenseQueryHookResult = ReturnType<typeof useProfileAndTosModalDataSuspenseQuery>;
export type ProfileAndTosModalDataQueryResult = Apollo.QueryResult<ProfileAndTosModalDataQuery, ProfileAndTosModalDataQueryVariables>;
export const TasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"Tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_task_assignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_dismissed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"is_completed"}},{"kind":"Field","name":{"kind":"Name","value":"is_dismissed"}},{"kind":"Field","name":{"kind":"Name","value":"user_task_id"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useTasksSubscription__
 *
 * To run a query within a React component, call `useTasksSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTasksSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksSubscription({
 *   variables: {
 *   },
 * });
 */
export function useTasksSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<TasksSubscription, TasksSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<TasksSubscription, TasksSubscriptionVariables>(TasksDocument, options);
      }
export type TasksSubscriptionHookResult = ReturnType<typeof useTasksSubscription>;
export type TasksSubscriptionResult = Apollo.SubscriptionResult<TasksSubscription>;
export const MyTimeZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyTimeZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMyTimeZoneQuery__
 *
 * To run a query within a React component, call `useMyTimeZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTimeZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTimeZoneQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyTimeZoneQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyTimeZoneQuery, MyTimeZoneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyTimeZoneQuery, MyTimeZoneQueryVariables>(MyTimeZoneDocument, options);
      }
export function useMyTimeZoneLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyTimeZoneQuery, MyTimeZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyTimeZoneQuery, MyTimeZoneQueryVariables>(MyTimeZoneDocument, options);
        }
export function useMyTimeZoneSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MyTimeZoneQuery, MyTimeZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyTimeZoneQuery, MyTimeZoneQueryVariables>(MyTimeZoneDocument, options);
        }
export type MyTimeZoneQueryHookResult = ReturnType<typeof useMyTimeZoneQuery>;
export type MyTimeZoneLazyQueryHookResult = ReturnType<typeof useMyTimeZoneLazyQuery>;
export type MyTimeZoneSuspenseQueryHookResult = ReturnType<typeof useMyTimeZoneSuspenseQuery>;
export type MyTimeZoneQueryResult = Apollo.QueryResult<MyTimeZoneQuery, MyTimeZoneQueryVariables>;
export const CreateSyncRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSyncRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SyncRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_sync_request"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrations"}}]}}]}}]} as unknown as DocumentNode;
export type CreateSyncRequestMutationFn = Apollo.MutationFunction<CreateSyncRequestMutation, CreateSyncRequestMutationVariables>;

/**
 * __useCreateSyncRequestMutation__
 *
 * To run a mutation, you first call `useCreateSyncRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSyncRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSyncRequestMutation, { data, loading, error }] = useCreateSyncRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSyncRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSyncRequestMutation, CreateSyncRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSyncRequestMutation, CreateSyncRequestMutationVariables>(CreateSyncRequestDocument, options);
      }
export type CreateSyncRequestMutationHookResult = ReturnType<typeof useCreateSyncRequestMutation>;
export type CreateSyncRequestMutationResult = Apollo.MutationResult<CreateSyncRequestMutation>;
export type CreateSyncRequestMutationOptions = Apollo.BaseMutationOptions<CreateSyncRequestMutation, CreateSyncRequestMutationVariables>;
export const ReconnectTaskAssignmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ReconnectTaskAssignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_task_assignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_dismissed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"task"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"StringValue","value":"reconnect-%","block":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useReconnectTaskAssignmentsSubscription__
 *
 * To run a query within a React component, call `useReconnectTaskAssignmentsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useReconnectTaskAssignmentsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReconnectTaskAssignmentsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useReconnectTaskAssignmentsSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<ReconnectTaskAssignmentsSubscription, ReconnectTaskAssignmentsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<ReconnectTaskAssignmentsSubscription, ReconnectTaskAssignmentsSubscriptionVariables>(ReconnectTaskAssignmentsDocument, options);
      }
export type ReconnectTaskAssignmentsSubscriptionHookResult = ReturnType<typeof useReconnectTaskAssignmentsSubscription>;
export type ReconnectTaskAssignmentsSubscriptionResult = Apollo.SubscriptionResult<ReconnectTaskAssignmentsSubscription>;
export const AchievementsByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AchievementsByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"achievements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"achievement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hero"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"animation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1000"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"StringValue","value":"name","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useAchievementsByIdsQuery__
 *
 * To run a query within a React component, call `useAchievementsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAchievementsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAchievementsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAchievementsByIdsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AchievementsByIdsQuery, AchievementsByIdsQueryVariables> & ({ variables: AchievementsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AchievementsByIdsQuery, AchievementsByIdsQueryVariables>(AchievementsByIdsDocument, options);
      }
export function useAchievementsByIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AchievementsByIdsQuery, AchievementsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AchievementsByIdsQuery, AchievementsByIdsQueryVariables>(AchievementsByIdsDocument, options);
        }
export function useAchievementsByIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AchievementsByIdsQuery, AchievementsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AchievementsByIdsQuery, AchievementsByIdsQueryVariables>(AchievementsByIdsDocument, options);
        }
export type AchievementsByIdsQueryHookResult = ReturnType<typeof useAchievementsByIdsQuery>;
export type AchievementsByIdsLazyQueryHookResult = ReturnType<typeof useAchievementsByIdsLazyQuery>;
export type AchievementsByIdsSuspenseQueryHookResult = ReturnType<typeof useAchievementsByIdsSuspenseQuery>;
export type AchievementsByIdsQueryResult = Apollo.QueryResult<AchievementsByIdsQuery, AchievementsByIdsQueryVariables>;
export const IntegrationSyncEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"IntegrationSyncEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integration_sync_event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"success"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integration"}},{"kind":"Field","name":{"kind":"Name","value":"sync_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useIntegrationSyncEventSubscription__
 *
 * To run a query within a React component, call `useIntegrationSyncEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationSyncEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationSyncEventSubscription({
 *   variables: {
 *   },
 * });
 */
export function useIntegrationSyncEventSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<IntegrationSyncEventSubscription, IntegrationSyncEventSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<IntegrationSyncEventSubscription, IntegrationSyncEventSubscriptionVariables>(IntegrationSyncEventDocument, options);
      }
export type IntegrationSyncEventSubscriptionHookResult = ReturnType<typeof useIntegrationSyncEventSubscription>;
export type IntegrationSyncEventSubscriptionResult = Apollo.SubscriptionResult<IntegrationSyncEventSubscription>;
export const SupplementMetricComponentAggregatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupplementMetricComponentAggregates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplement"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplement"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_components"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"display_name"}},{"kind":"Field","alias":{"kind":"Name","value":"unit"},"name":{"kind":"Name","value":"preference_unit"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parent_metric_record"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplement"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useSupplementMetricComponentAggregatesQuery__
 *
 * To run a query within a React component, call `useSupplementMetricComponentAggregatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplementMetricComponentAggregatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplementMetricComponentAggregatesQuery({
 *   variables: {
 *      supplement: // value for 'supplement'
 *   },
 * });
 */
export function useSupplementMetricComponentAggregatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SupplementMetricComponentAggregatesQuery, SupplementMetricComponentAggregatesQueryVariables> & ({ variables: SupplementMetricComponentAggregatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SupplementMetricComponentAggregatesQuery, SupplementMetricComponentAggregatesQueryVariables>(SupplementMetricComponentAggregatesDocument, options);
      }
export function useSupplementMetricComponentAggregatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SupplementMetricComponentAggregatesQuery, SupplementMetricComponentAggregatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SupplementMetricComponentAggregatesQuery, SupplementMetricComponentAggregatesQueryVariables>(SupplementMetricComponentAggregatesDocument, options);
        }
export function useSupplementMetricComponentAggregatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SupplementMetricComponentAggregatesQuery, SupplementMetricComponentAggregatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SupplementMetricComponentAggregatesQuery, SupplementMetricComponentAggregatesQueryVariables>(SupplementMetricComponentAggregatesDocument, options);
        }
export type SupplementMetricComponentAggregatesQueryHookResult = ReturnType<typeof useSupplementMetricComponentAggregatesQuery>;
export type SupplementMetricComponentAggregatesLazyQueryHookResult = ReturnType<typeof useSupplementMetricComponentAggregatesLazyQuery>;
export type SupplementMetricComponentAggregatesSuspenseQueryHookResult = ReturnType<typeof useSupplementMetricComponentAggregatesSuspenseQuery>;
export type SupplementMetricComponentAggregatesQueryResult = Apollo.QueryResult<SupplementMetricComponentAggregatesQuery, SupplementMetricComponentAggregatesQueryVariables>;
export const MetricRecordAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MetricRecordAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metric"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_record_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metric"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMetricRecordAggregateQuery__
 *
 * To run a query within a React component, call `useMetricRecordAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricRecordAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricRecordAggregateQuery({
 *   variables: {
 *      metric: // value for 'metric'
 *   },
 * });
 */
export function useMetricRecordAggregateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MetricRecordAggregateQuery, MetricRecordAggregateQueryVariables> & ({ variables: MetricRecordAggregateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MetricRecordAggregateQuery, MetricRecordAggregateQueryVariables>(MetricRecordAggregateDocument, options);
      }
export function useMetricRecordAggregateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetricRecordAggregateQuery, MetricRecordAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MetricRecordAggregateQuery, MetricRecordAggregateQueryVariables>(MetricRecordAggregateDocument, options);
        }
export function useMetricRecordAggregateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MetricRecordAggregateQuery, MetricRecordAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MetricRecordAggregateQuery, MetricRecordAggregateQueryVariables>(MetricRecordAggregateDocument, options);
        }
export type MetricRecordAggregateQueryHookResult = ReturnType<typeof useMetricRecordAggregateQuery>;
export type MetricRecordAggregateLazyQueryHookResult = ReturnType<typeof useMetricRecordAggregateLazyQuery>;
export type MetricRecordAggregateSuspenseQueryHookResult = ReturnType<typeof useMetricRecordAggregateSuspenseQuery>;
export type MetricRecordAggregateQueryResult = Apollo.QueryResult<MetricRecordAggregateQuery, MetricRecordAggregateQueryVariables>;
export const MySupplementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MySupplements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_supplements"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"disabled"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","alias":{"kind":"Name","value":"nutritionSrc"},"name":{"kind":"Name","value":"nutrition_label_image_url"}},{"kind":"Field","alias":{"kind":"Name","value":"productSrc"},"name":{"kind":"Name","value":"product_image_url"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMySupplementsQuery__
 *
 * To run a query within a React component, call `useMySupplementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySupplementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySupplementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMySupplementsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MySupplementsQuery, MySupplementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MySupplementsQuery, MySupplementsQueryVariables>(MySupplementsDocument, options);
      }
export function useMySupplementsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MySupplementsQuery, MySupplementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MySupplementsQuery, MySupplementsQueryVariables>(MySupplementsDocument, options);
        }
export function useMySupplementsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MySupplementsQuery, MySupplementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MySupplementsQuery, MySupplementsQueryVariables>(MySupplementsDocument, options);
        }
export type MySupplementsQueryHookResult = ReturnType<typeof useMySupplementsQuery>;
export type MySupplementsLazyQueryHookResult = ReturnType<typeof useMySupplementsLazyQuery>;
export type MySupplementsSuspenseQueryHookResult = ReturnType<typeof useMySupplementsSuspenseQuery>;
export type MySupplementsQueryResult = Apollo.QueryResult<MySupplementsQuery, MySupplementsQueryVariables>;
export const NonUserSupplementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NonUserSupplements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userSupplementIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userSupplementIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useNonUserSupplementsQuery__
 *
 * To run a query within a React component, call `useNonUserSupplementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonUserSupplementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonUserSupplementsQuery({
 *   variables: {
 *      userSupplementIds: // value for 'userSupplementIds'
 *   },
 * });
 */
export function useNonUserSupplementsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NonUserSupplementsQuery, NonUserSupplementsQueryVariables> & ({ variables: NonUserSupplementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NonUserSupplementsQuery, NonUserSupplementsQueryVariables>(NonUserSupplementsDocument, options);
      }
export function useNonUserSupplementsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NonUserSupplementsQuery, NonUserSupplementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NonUserSupplementsQuery, NonUserSupplementsQueryVariables>(NonUserSupplementsDocument, options);
        }
export function useNonUserSupplementsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<NonUserSupplementsQuery, NonUserSupplementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NonUserSupplementsQuery, NonUserSupplementsQueryVariables>(NonUserSupplementsDocument, options);
        }
export type NonUserSupplementsQueryHookResult = ReturnType<typeof useNonUserSupplementsQuery>;
export type NonUserSupplementsLazyQueryHookResult = ReturnType<typeof useNonUserSupplementsLazyQuery>;
export type NonUserSupplementsSuspenseQueryHookResult = ReturnType<typeof useNonUserSupplementsSuspenseQuery>;
export type NonUserSupplementsQueryResult = Apollo.QueryResult<NonUserSupplementsQuery, NonUserSupplementsQueryVariables>;
export const SupplementsTextSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupplementsTextSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userSupplementIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_supplements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userSupplementIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useSupplementsTextSearchQuery__
 *
 * To run a query within a React component, call `useSupplementsTextSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplementsTextSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplementsTextSearchQuery({
 *   variables: {
 *      text: // value for 'text'
 *      userSupplementIds: // value for 'userSupplementIds'
 *   },
 * });
 */
export function useSupplementsTextSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SupplementsTextSearchQuery, SupplementsTextSearchQueryVariables> & ({ variables: SupplementsTextSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SupplementsTextSearchQuery, SupplementsTextSearchQueryVariables>(SupplementsTextSearchDocument, options);
      }
export function useSupplementsTextSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SupplementsTextSearchQuery, SupplementsTextSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SupplementsTextSearchQuery, SupplementsTextSearchQueryVariables>(SupplementsTextSearchDocument, options);
        }
export function useSupplementsTextSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SupplementsTextSearchQuery, SupplementsTextSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SupplementsTextSearchQuery, SupplementsTextSearchQueryVariables>(SupplementsTextSearchDocument, options);
        }
export type SupplementsTextSearchQueryHookResult = ReturnType<typeof useSupplementsTextSearchQuery>;
export type SupplementsTextSearchLazyQueryHookResult = ReturnType<typeof useSupplementsTextSearchLazyQuery>;
export type SupplementsTextSearchSuspenseQueryHookResult = ReturnType<typeof useSupplementsTextSearchSuspenseQuery>;
export type SupplementsTextSearchQueryResult = Apollo.QueryResult<SupplementsTextSearchQuery, SupplementsTextSearchQueryVariables>;
export const InsertUserSupplementByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertUserSupplementById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_user_supplement_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"supplement_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplement_id"}}]}}]}}]} as unknown as DocumentNode;
export type InsertUserSupplementByIdMutationFn = Apollo.MutationFunction<InsertUserSupplementByIdMutation, InsertUserSupplementByIdMutationVariables>;

/**
 * __useInsertUserSupplementByIdMutation__
 *
 * To run a mutation, you first call `useInsertUserSupplementByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUserSupplementByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUserSupplementByIdMutation, { data, loading, error }] = useInsertUserSupplementByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInsertUserSupplementByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertUserSupplementByIdMutation, InsertUserSupplementByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InsertUserSupplementByIdMutation, InsertUserSupplementByIdMutationVariables>(InsertUserSupplementByIdDocument, options);
      }
export type InsertUserSupplementByIdMutationHookResult = ReturnType<typeof useInsertUserSupplementByIdMutation>;
export type InsertUserSupplementByIdMutationResult = Apollo.MutationResult<InsertUserSupplementByIdMutation>;
export type InsertUserSupplementByIdMutationOptions = Apollo.BaseMutationOptions<InsertUserSupplementByIdMutation, InsertUserSupplementByIdMutationVariables>;
export const CreateSupplementForUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSupplementForUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imgUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_supplement_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"product_image_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imgUrl"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"metric"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"unit"},"value":{"kind":"StringValue","value":"serving","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_supplements"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type CreateSupplementForUserMutationFn = Apollo.MutationFunction<CreateSupplementForUserMutation, CreateSupplementForUserMutationVariables>;

/**
 * __useCreateSupplementForUserMutation__
 *
 * To run a mutation, you first call `useCreateSupplementForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplementForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplementForUserMutation, { data, loading, error }] = useCreateSupplementForUserMutation({
 *   variables: {
 *      name: // value for 'name'
 *      imgUrl: // value for 'imgUrl'
 *   },
 * });
 */
export function useCreateSupplementForUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSupplementForUserMutation, CreateSupplementForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSupplementForUserMutation, CreateSupplementForUserMutationVariables>(CreateSupplementForUserDocument, options);
      }
export type CreateSupplementForUserMutationHookResult = ReturnType<typeof useCreateSupplementForUserMutation>;
export type CreateSupplementForUserMutationResult = Apollo.MutationResult<CreateSupplementForUserMutation>;
export type CreateSupplementForUserMutationOptions = Apollo.BaseMutationOptions<CreateSupplementForUserMutation, CreateSupplementForUserMutationVariables>;
export const DeleteUserSupplementByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUserSupplementById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_user_supplement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"supplement_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplement_id"}}]}}]}}]}}]} as unknown as DocumentNode;
export type DeleteUserSupplementByIdMutationFn = Apollo.MutationFunction<DeleteUserSupplementByIdMutation, DeleteUserSupplementByIdMutationVariables>;

/**
 * __useDeleteUserSupplementByIdMutation__
 *
 * To run a mutation, you first call `useDeleteUserSupplementByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserSupplementByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserSupplementByIdMutation, { data, loading, error }] = useDeleteUserSupplementByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserSupplementByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserSupplementByIdMutation, DeleteUserSupplementByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserSupplementByIdMutation, DeleteUserSupplementByIdMutationVariables>(DeleteUserSupplementByIdDocument, options);
      }
export type DeleteUserSupplementByIdMutationHookResult = ReturnType<typeof useDeleteUserSupplementByIdMutation>;
export type DeleteUserSupplementByIdMutationResult = Apollo.MutationResult<DeleteUserSupplementByIdMutation>;
export type DeleteUserSupplementByIdMutationOptions = Apollo.BaseMutationOptions<DeleteUserSupplementByIdMutation, DeleteUserSupplementByIdMutationVariables>;
export const GetUploadUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUploadUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_upload_url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"upload_type"},"value":{"kind":"EnumValue","value":"SUPPLEMENT_PRODUCT_IMAGE"}},{"kind":"ObjectField","name":{"kind":"Name","value":"file_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upload_url"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadUrlQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGetUploadUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUploadUrlQuery, GetUploadUrlQueryVariables> & ({ variables: GetUploadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUploadUrlQuery, GetUploadUrlQueryVariables>(GetUploadUrlDocument, options);
      }
export function useGetUploadUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUploadUrlQuery, GetUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUploadUrlQuery, GetUploadUrlQueryVariables>(GetUploadUrlDocument, options);
        }
export function useGetUploadUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUploadUrlQuery, GetUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUploadUrlQuery, GetUploadUrlQueryVariables>(GetUploadUrlDocument, options);
        }
export type GetUploadUrlQueryHookResult = ReturnType<typeof useGetUploadUrlQuery>;
export type GetUploadUrlLazyQueryHookResult = ReturnType<typeof useGetUploadUrlLazyQuery>;
export type GetUploadUrlSuspenseQueryHookResult = ReturnType<typeof useGetUploadUrlSuspenseQuery>;
export type GetUploadUrlQueryResult = Apollo.QueryResult<GetUploadUrlQuery, GetUploadUrlQueryVariables>;
export const PendingLabOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PendingLabOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_order_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lab_order_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"completed"},{"kind":"EnumValue","value":"cancelled"},{"kind":"EnumValue","value":"failed"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __usePendingLabOrdersQuery__
 *
 * To run a query within a React component, call `usePendingLabOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingLabOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingLabOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePendingLabOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PendingLabOrdersQuery, PendingLabOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PendingLabOrdersQuery, PendingLabOrdersQueryVariables>(PendingLabOrdersDocument, options);
      }
export function usePendingLabOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PendingLabOrdersQuery, PendingLabOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PendingLabOrdersQuery, PendingLabOrdersQueryVariables>(PendingLabOrdersDocument, options);
        }
export function usePendingLabOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PendingLabOrdersQuery, PendingLabOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PendingLabOrdersQuery, PendingLabOrdersQueryVariables>(PendingLabOrdersDocument, options);
        }
export type PendingLabOrdersQueryHookResult = ReturnType<typeof usePendingLabOrdersQuery>;
export type PendingLabOrdersLazyQueryHookResult = ReturnType<typeof usePendingLabOrdersLazyQuery>;
export type PendingLabOrdersSuspenseQueryHookResult = ReturnType<typeof usePendingLabOrdersSuspenseQuery>;
export type PendingLabOrdersQueryResult = Apollo.QueryResult<PendingLabOrdersQuery, PendingLabOrdersQueryVariables>;
export const MostRecentLabIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MostRecentLabId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_result"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMostRecentLabIdQuery__
 *
 * To run a query within a React component, call `useMostRecentLabIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMostRecentLabIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMostRecentLabIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useMostRecentLabIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MostRecentLabIdQuery, MostRecentLabIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MostRecentLabIdQuery, MostRecentLabIdQueryVariables>(MostRecentLabIdDocument, options);
      }
export function useMostRecentLabIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MostRecentLabIdQuery, MostRecentLabIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MostRecentLabIdQuery, MostRecentLabIdQueryVariables>(MostRecentLabIdDocument, options);
        }
export function useMostRecentLabIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MostRecentLabIdQuery, MostRecentLabIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MostRecentLabIdQuery, MostRecentLabIdQueryVariables>(MostRecentLabIdDocument, options);
        }
export type MostRecentLabIdQueryHookResult = ReturnType<typeof useMostRecentLabIdQuery>;
export type MostRecentLabIdLazyQueryHookResult = ReturnType<typeof useMostRecentLabIdLazyQuery>;
export type MostRecentLabIdSuspenseQueryHookResult = ReturnType<typeof useMostRecentLabIdSuspenseQuery>;
export type MostRecentLabIdQueryResult = Apollo.QueryResult<MostRecentLabIdQuery, MostRecentLabIdQueryVariables>;
export const AiRecommndationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AiRecommndations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_user_goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserGoalEntityFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ai_recommendations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"audio_text"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"audio_file_url"}},{"kind":"Field","name":{"kind":"Name","value":"recommended_content"}},{"kind":"Field","name":{"kind":"Name","value":"recommendations_lifestyles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recommendation_id"}},{"kind":"Field","name":{"kind":"Name","value":"lifestyle_id"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"reasoning"}},{"kind":"Field","name":{"kind":"Name","value":"lifestyle_name"}},{"kind":"Field","name":{"kind":"Name","value":"action_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name_show_placeholders"}},{"kind":"Field","name":{"kind":"Name","value":"logger_type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hero_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name_plural"}},{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}},{"kind":"Field","name":{"kind":"Name","value":"display_symbol_plural"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_item_inputs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"input_type"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recommendations_supplements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reasoning"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recommendations_metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guidance_custom_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"meta"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cta_link"}},{"kind":"Field","name":{"kind":"Name","value":"cta_text"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"header_img"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric_id"}},{"kind":"Field","name":{"kind":"Name","value":"reasoning"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ai_recommendations_contents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ai_recommendation_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GoalFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"goal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserGoalEntityFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserGoalEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"focus"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"goal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GoalFields"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useAiRecommndationsQuery__
 *
 * To run a query within a React component, call `useAiRecommndationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiRecommndationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiRecommndationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAiRecommndationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AiRecommndationsQuery, AiRecommndationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AiRecommndationsQuery, AiRecommndationsQueryVariables>(AiRecommndationsDocument, options);
      }
export function useAiRecommndationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AiRecommndationsQuery, AiRecommndationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AiRecommndationsQuery, AiRecommndationsQueryVariables>(AiRecommndationsDocument, options);
        }
export function useAiRecommndationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AiRecommndationsQuery, AiRecommndationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AiRecommndationsQuery, AiRecommndationsQueryVariables>(AiRecommndationsDocument, options);
        }
export type AiRecommndationsQueryHookResult = ReturnType<typeof useAiRecommndationsQuery>;
export type AiRecommndationsLazyQueryHookResult = ReturnType<typeof useAiRecommndationsLazyQuery>;
export type AiRecommndationsSuspenseQueryHookResult = ReturnType<typeof useAiRecommndationsSuspenseQuery>;
export type AiRecommndationsQueryResult = Apollo.QueryResult<AiRecommndationsQuery, AiRecommndationsQueryVariables>;
export const GetProfileInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProfileInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"birth_date"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"ship_to_address"}},{"kind":"Field","name":{"kind":"Name","value":"ship_to_city"}},{"kind":"Field","name":{"kind":"Name","value":"ship_to_country"}},{"kind":"Field","name":{"kind":"Name","value":"ship_to_postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"ship_to_state"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetProfileInfoQuery__
 *
 * To run a query within a React component, call `useGetProfileInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProfileInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProfileInfoQuery, GetProfileInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProfileInfoQuery, GetProfileInfoQueryVariables>(GetProfileInfoDocument, options);
      }
export function useGetProfileInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProfileInfoQuery, GetProfileInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProfileInfoQuery, GetProfileInfoQueryVariables>(GetProfileInfoDocument, options);
        }
export function useGetProfileInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetProfileInfoQuery, GetProfileInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProfileInfoQuery, GetProfileInfoQueryVariables>(GetProfileInfoDocument, options);
        }
export type GetProfileInfoQueryHookResult = ReturnType<typeof useGetProfileInfoQuery>;
export type GetProfileInfoLazyQueryHookResult = ReturnType<typeof useGetProfileInfoLazyQuery>;
export type GetProfileInfoSuspenseQueryHookResult = ReturnType<typeof useGetProfileInfoSuspenseQuery>;
export type GetProfileInfoQueryResult = Apollo.QueryResult<GetProfileInfoQuery, GetProfileInfoQueryVariables>;
export const AllGoalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllGoals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"goal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GoalFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GoalFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"goal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useAllGoalsQuery__
 *
 * To run a query within a React component, call `useAllGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllGoalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllGoalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllGoalsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllGoalsQuery, AllGoalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllGoalsQuery, AllGoalsQueryVariables>(AllGoalsDocument, options);
      }
export function useAllGoalsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllGoalsQuery, AllGoalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllGoalsQuery, AllGoalsQueryVariables>(AllGoalsDocument, options);
        }
export function useAllGoalsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllGoalsQuery, AllGoalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllGoalsQuery, AllGoalsQueryVariables>(AllGoalsDocument, options);
        }
export type AllGoalsQueryHookResult = ReturnType<typeof useAllGoalsQuery>;
export type AllGoalsLazyQueryHookResult = ReturnType<typeof useAllGoalsLazyQuery>;
export type AllGoalsSuspenseQueryHookResult = ReturnType<typeof useAllGoalsSuspenseQuery>;
export type AllGoalsQueryResult = Apollo.QueryResult<AllGoalsQuery, AllGoalsQueryVariables>;
export const SubmitSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyResponse"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GoalsSurveyResponse"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"process_goals_survey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"survey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyResponse"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserGoalEntityFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GoalFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"goal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserGoalEntityFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserGoalEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"focus"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"goal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GoalFields"}}]}}]}}]} as unknown as DocumentNode;
export type SubmitSurveyMutationFn = Apollo.MutationFunction<SubmitSurveyMutation, SubmitSurveyMutationVariables>;

/**
 * __useSubmitSurveyMutation__
 *
 * To run a mutation, you first call `useSubmitSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSurveyMutation, { data, loading, error }] = useSubmitSurveyMutation({
 *   variables: {
 *      surveyResponse: // value for 'surveyResponse'
 *   },
 * });
 */
export function useSubmitSurveyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitSurveyMutation, SubmitSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitSurveyMutation, SubmitSurveyMutationVariables>(SubmitSurveyDocument, options);
      }
export type SubmitSurveyMutationHookResult = ReturnType<typeof useSubmitSurveyMutation>;
export type SubmitSurveyMutationResult = Apollo.MutationResult<SubmitSurveyMutation>;
export type SubmitSurveyMutationOptions = Apollo.BaseMutationOptions<SubmitSurveyMutation, SubmitSurveyMutationVariables>;
export const SetUserGoalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetUserGoals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"goals"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserGoalInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"set_user_goals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"goals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"goals"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserGoalEntityFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GoalFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"goal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserGoalEntityFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserGoalEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"focus"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"goal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GoalFields"}}]}}]}}]} as unknown as DocumentNode;
export type SetUserGoalsMutationFn = Apollo.MutationFunction<SetUserGoalsMutation, SetUserGoalsMutationVariables>;

/**
 * __useSetUserGoalsMutation__
 *
 * To run a mutation, you first call `useSetUserGoalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserGoalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserGoalsMutation, { data, loading, error }] = useSetUserGoalsMutation({
 *   variables: {
 *      goals: // value for 'goals'
 *   },
 * });
 */
export function useSetUserGoalsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetUserGoalsMutation, SetUserGoalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetUserGoalsMutation, SetUserGoalsMutationVariables>(SetUserGoalsDocument, options);
      }
export type SetUserGoalsMutationHookResult = ReturnType<typeof useSetUserGoalsMutation>;
export type SetUserGoalsMutationResult = Apollo.MutationResult<SetUserGoalsMutation>;
export type SetUserGoalsMutationOptions = Apollo.BaseMutationOptions<SetUserGoalsMutation, SetUserGoalsMutationVariables>;
export const UserGoalEntitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserGoalEntities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_user_goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserGoalEntityFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GoalFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"goal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserGoalEntityFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserGoalEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"focus"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"goal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GoalFields"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useUserGoalEntitiesQuery__
 *
 * To run a query within a React component, call `useUserGoalEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGoalEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGoalEntitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserGoalEntitiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserGoalEntitiesQuery, UserGoalEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserGoalEntitiesQuery, UserGoalEntitiesQueryVariables>(UserGoalEntitiesDocument, options);
      }
export function useUserGoalEntitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserGoalEntitiesQuery, UserGoalEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserGoalEntitiesQuery, UserGoalEntitiesQueryVariables>(UserGoalEntitiesDocument, options);
        }
export function useUserGoalEntitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserGoalEntitiesQuery, UserGoalEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserGoalEntitiesQuery, UserGoalEntitiesQueryVariables>(UserGoalEntitiesDocument, options);
        }
export type UserGoalEntitiesQueryHookResult = ReturnType<typeof useUserGoalEntitiesQuery>;
export type UserGoalEntitiesLazyQueryHookResult = ReturnType<typeof useUserGoalEntitiesLazyQuery>;
export type UserGoalEntitiesSuspenseQueryHookResult = ReturnType<typeof useUserGoalEntitiesSuspenseQuery>;
export type UserGoalEntitiesQueryResult = Apollo.QueryResult<UserGoalEntitiesQuery, UserGoalEntitiesQueryVariables>;
export const GetUserGuidanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserGuidance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_user_guidance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserGoalEntityFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recommendationItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"impactTotal"}},{"kind":"Field","name":{"kind":"Name","value":"meta"}},{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"namespaceKey"}},{"kind":"Field","name":{"kind":"Name","value":"lab_test_marker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SupplementRecommendation"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LifestyleRecommendation"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MeasureRecommendation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GoalFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"goal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserGoalEntityFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserGoalEntity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"focus"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"goal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GoalFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LifestyleRecommendation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LifestyleRecommendationItemModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_item_config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value_target"}},{"kind":"Field","name":{"kind":"Name","value":"interval_type"}},{"kind":"Field","name":{"kind":"Name","value":"weekly_instance_target"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value_rollup_type"}},{"kind":"Field","name":{"kind":"Name","value":"action_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name_show_placeholders"}},{"kind":"Field","name":{"kind":"Name","value":"logger_type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hero_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name_plural"}},{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}},{"kind":"Field","name":{"kind":"Name","value":"display_symbol_plural"}}]}},{"kind":"Field","name":{"kind":"Name","value":"action_item_inputs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"input_type"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SupplementRecommendation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SupplementRecommendationItemModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmsGuidanceItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CmsContentCustomGuidanceItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cta_link"}},{"kind":"Field","name":{"kind":"Name","value":"cta_text"}},{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"header_img"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LabPackageGuidanceItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LabPackageCustomGuidanceItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productSlug"}},{"kind":"Field","name":{"kind":"Name","value":"lab_package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MeasureRecommendation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeasureRecommendationItemModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"meta"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmsGuidanceItem"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LabPackageGuidanceItem"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetUserGuidanceQuery__
 *
 * To run a query within a React component, call `useGetUserGuidanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserGuidanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserGuidanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserGuidanceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserGuidanceQuery, GetUserGuidanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserGuidanceQuery, GetUserGuidanceQueryVariables>(GetUserGuidanceDocument, options);
      }
export function useGetUserGuidanceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserGuidanceQuery, GetUserGuidanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserGuidanceQuery, GetUserGuidanceQueryVariables>(GetUserGuidanceDocument, options);
        }
export function useGetUserGuidanceSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserGuidanceQuery, GetUserGuidanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserGuidanceQuery, GetUserGuidanceQueryVariables>(GetUserGuidanceDocument, options);
        }
export type GetUserGuidanceQueryHookResult = ReturnType<typeof useGetUserGuidanceQuery>;
export type GetUserGuidanceLazyQueryHookResult = ReturnType<typeof useGetUserGuidanceLazyQuery>;
export type GetUserGuidanceSuspenseQueryHookResult = ReturnType<typeof useGetUserGuidanceSuspenseQuery>;
export type GetUserGuidanceQueryResult = Apollo.QueryResult<GetUserGuidanceQuery, GetUserGuidanceQueryVariables>;
export const SortedAndFilteredRecEntityIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SortedAndFilteredRecEntityIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"goalIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"30"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_user_guidance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recommendationItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"metricIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"goalIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"goalIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entityId"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useSortedAndFilteredRecEntityIdsQuery__
 *
 * To run a query within a React component, call `useSortedAndFilteredRecEntityIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSortedAndFilteredRecEntityIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSortedAndFilteredRecEntityIdsQuery({
 *   variables: {
 *      goalIds: // value for 'goalIds'
 *      metricIds: // value for 'metricIds'
 *   },
 * });
 */
export function useSortedAndFilteredRecEntityIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SortedAndFilteredRecEntityIdsQuery, SortedAndFilteredRecEntityIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SortedAndFilteredRecEntityIdsQuery, SortedAndFilteredRecEntityIdsQueryVariables>(SortedAndFilteredRecEntityIdsDocument, options);
      }
export function useSortedAndFilteredRecEntityIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SortedAndFilteredRecEntityIdsQuery, SortedAndFilteredRecEntityIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SortedAndFilteredRecEntityIdsQuery, SortedAndFilteredRecEntityIdsQueryVariables>(SortedAndFilteredRecEntityIdsDocument, options);
        }
export function useSortedAndFilteredRecEntityIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SortedAndFilteredRecEntityIdsQuery, SortedAndFilteredRecEntityIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SortedAndFilteredRecEntityIdsQuery, SortedAndFilteredRecEntityIdsQueryVariables>(SortedAndFilteredRecEntityIdsDocument, options);
        }
export type SortedAndFilteredRecEntityIdsQueryHookResult = ReturnType<typeof useSortedAndFilteredRecEntityIdsQuery>;
export type SortedAndFilteredRecEntityIdsLazyQueryHookResult = ReturnType<typeof useSortedAndFilteredRecEntityIdsLazyQuery>;
export type SortedAndFilteredRecEntityIdsSuspenseQueryHookResult = ReturnType<typeof useSortedAndFilteredRecEntityIdsSuspenseQuery>;
export type SortedAndFilteredRecEntityIdsQueryResult = Apollo.QueryResult<SortedAndFilteredRecEntityIdsQuery, SortedAndFilteredRecEntityIdsQueryVariables>;
export const OnboardingSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OnboardingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onboardingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Screens"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Question_Text"}},{"kind":"Field","name":{"kind":"Name","value":"Options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Option_Text"}},{"kind":"Field","name":{"kind":"Name","value":"Cardiovascular_Fitness"}},{"kind":"Field","name":{"kind":"Name","value":"Enhanced_Brain_Function"}},{"kind":"Field","name":{"kind":"Name","value":"Improved_Energy"}},{"kind":"Field","name":{"kind":"Name","value":"Libido"}},{"kind":"Field","name":{"kind":"Name","value":"Longevity"}},{"kind":"Field","name":{"kind":"Name","value":"Manage_Stress_Better"}},{"kind":"Field","name":{"kind":"Name","value":"Muscle_Mass_And_More_Strength"}},{"kind":"Field","name":{"kind":"Name","value":"Sleep"}},{"kind":"Field","name":{"kind":"Name","value":"Weight_Loss"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useOnboardingSurveyQuery__
 *
 * To run a query within a React component, call `useOnboardingSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingSurveyQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingSurveyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OnboardingSurveyQuery, OnboardingSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OnboardingSurveyQuery, OnboardingSurveyQueryVariables>(OnboardingSurveyDocument, options);
      }
export function useOnboardingSurveyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OnboardingSurveyQuery, OnboardingSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OnboardingSurveyQuery, OnboardingSurveyQueryVariables>(OnboardingSurveyDocument, options);
        }
export function useOnboardingSurveySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OnboardingSurveyQuery, OnboardingSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OnboardingSurveyQuery, OnboardingSurveyQueryVariables>(OnboardingSurveyDocument, options);
        }
export type OnboardingSurveyQueryHookResult = ReturnType<typeof useOnboardingSurveyQuery>;
export type OnboardingSurveyLazyQueryHookResult = ReturnType<typeof useOnboardingSurveyLazyQuery>;
export type OnboardingSurveySuspenseQueryHookResult = ReturnType<typeof useOnboardingSurveySuspenseQuery>;
export type OnboardingSurveyQueryResult = Apollo.QueryResult<OnboardingSurveyQuery, OnboardingSurveyQueryVariables>;
export const UpdateUserTaskAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserTaskAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_task_assignment_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user_task_assignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export type UpdateUserTaskAssignmentMutationFn = Apollo.MutationFunction<UpdateUserTaskAssignmentMutation, UpdateUserTaskAssignmentMutationVariables>;

/**
 * __useUpdateUserTaskAssignmentMutation__
 *
 * To run a mutation, you first call `useUpdateUserTaskAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserTaskAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserTaskAssignmentMutation, { data, loading, error }] = useUpdateUserTaskAssignmentMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      changes: // value for 'changes'
 *   },
 * });
 */
export function useUpdateUserTaskAssignmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserTaskAssignmentMutation, UpdateUserTaskAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserTaskAssignmentMutation, UpdateUserTaskAssignmentMutationVariables>(UpdateUserTaskAssignmentDocument, options);
      }
export type UpdateUserTaskAssignmentMutationHookResult = ReturnType<typeof useUpdateUserTaskAssignmentMutation>;
export type UpdateUserTaskAssignmentMutationResult = Apollo.MutationResult<UpdateUserTaskAssignmentMutation>;
export type UpdateUserTaskAssignmentMutationOptions = Apollo.BaseMutationOptions<UpdateUserTaskAssignmentMutation, UpdateUserTaskAssignmentMutationVariables>;
export const HasCompletedSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HasCompletedSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"goal_survey_response"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useHasCompletedSurveyQuery__
 *
 * To run a query within a React component, call `useHasCompletedSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasCompletedSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasCompletedSurveyQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasCompletedSurveyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HasCompletedSurveyQuery, HasCompletedSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HasCompletedSurveyQuery, HasCompletedSurveyQueryVariables>(HasCompletedSurveyDocument, options);
      }
export function useHasCompletedSurveyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HasCompletedSurveyQuery, HasCompletedSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HasCompletedSurveyQuery, HasCompletedSurveyQueryVariables>(HasCompletedSurveyDocument, options);
        }
export function useHasCompletedSurveySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HasCompletedSurveyQuery, HasCompletedSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HasCompletedSurveyQuery, HasCompletedSurveyQueryVariables>(HasCompletedSurveyDocument, options);
        }
export type HasCompletedSurveyQueryHookResult = ReturnType<typeof useHasCompletedSurveyQuery>;
export type HasCompletedSurveyLazyQueryHookResult = ReturnType<typeof useHasCompletedSurveyLazyQuery>;
export type HasCompletedSurveySuspenseQueryHookResult = ReturnType<typeof useHasCompletedSurveySuspenseQuery>;
export type HasCompletedSurveyQueryResult = Apollo.QueryResult<HasCompletedSurveyQuery, HasCompletedSurveyQueryVariables>;
export const GetUserGoalIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserGoalIds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_user_guidance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"goals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetUserGoalIdsQuery__
 *
 * To run a query within a React component, call `useGetUserGoalIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserGoalIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserGoalIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserGoalIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserGoalIdsQuery, GetUserGoalIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserGoalIdsQuery, GetUserGoalIdsQueryVariables>(GetUserGoalIdsDocument, options);
      }
export function useGetUserGoalIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserGoalIdsQuery, GetUserGoalIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserGoalIdsQuery, GetUserGoalIdsQueryVariables>(GetUserGoalIdsDocument, options);
        }
export function useGetUserGoalIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserGoalIdsQuery, GetUserGoalIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserGoalIdsQuery, GetUserGoalIdsQueryVariables>(GetUserGoalIdsDocument, options);
        }
export type GetUserGoalIdsQueryHookResult = ReturnType<typeof useGetUserGoalIdsQuery>;
export type GetUserGoalIdsLazyQueryHookResult = ReturnType<typeof useGetUserGoalIdsLazyQuery>;
export type GetUserGoalIdsSuspenseQueryHookResult = ReturnType<typeof useGetUserGoalIdsSuspenseQuery>;
export type GetUserGoalIdsQueryResult = Apollo.QueryResult<GetUserGoalIdsQuery, GetUserGoalIdsQueryVariables>;
export const GetMetricCalculatorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMetricCalculators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_metric_calculators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"inputs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"unitDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"calculatorsContent"},"name":{"kind":"Name","value":"cms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"StringValue","value":"sort_order:asc","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sort_order"}},{"kind":"Field","name":{"kind":"Name","value":"gql_type"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"short_description"}},{"kind":"Field","name":{"kind":"Name","value":"long_description"}},{"kind":"Field","name":{"kind":"Name","value":"html_head_data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"share_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetMetricCalculatorsQuery__
 *
 * To run a query within a React component, call `useGetMetricCalculatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricCalculatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricCalculatorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMetricCalculatorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMetricCalculatorsQuery, GetMetricCalculatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMetricCalculatorsQuery, GetMetricCalculatorsQueryVariables>(GetMetricCalculatorsDocument, options);
      }
export function useGetMetricCalculatorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMetricCalculatorsQuery, GetMetricCalculatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMetricCalculatorsQuery, GetMetricCalculatorsQueryVariables>(GetMetricCalculatorsDocument, options);
        }
export function useGetMetricCalculatorsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetMetricCalculatorsQuery, GetMetricCalculatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMetricCalculatorsQuery, GetMetricCalculatorsQueryVariables>(GetMetricCalculatorsDocument, options);
        }
export type GetMetricCalculatorsQueryHookResult = ReturnType<typeof useGetMetricCalculatorsQuery>;
export type GetMetricCalculatorsLazyQueryHookResult = ReturnType<typeof useGetMetricCalculatorsLazyQuery>;
export type GetMetricCalculatorsSuspenseQueryHookResult = ReturnType<typeof useGetMetricCalculatorsSuspenseQuery>;
export type GetMetricCalculatorsQueryResult = Apollo.QueryResult<GetMetricCalculatorsQuery, GetMetricCalculatorsQueryVariables>;
export const RunCalculationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RunCalculation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RunMetricCalculatorInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"run_calculation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"output"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"preference_unit_details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_symbol"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useRunCalculationQuery__
 *
 * To run a query within a React component, call `useRunCalculationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunCalculationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunCalculationQuery({
 *   variables: {
 *      type: // value for 'type'
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useRunCalculationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunCalculationQuery, RunCalculationQueryVariables> & ({ variables: RunCalculationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunCalculationQuery, RunCalculationQueryVariables>(RunCalculationDocument, options);
      }
export function useRunCalculationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunCalculationQuery, RunCalculationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunCalculationQuery, RunCalculationQueryVariables>(RunCalculationDocument, options);
        }
export function useRunCalculationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunCalculationQuery, RunCalculationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunCalculationQuery, RunCalculationQueryVariables>(RunCalculationDocument, options);
        }
export type RunCalculationQueryHookResult = ReturnType<typeof useRunCalculationQuery>;
export type RunCalculationLazyQueryHookResult = ReturnType<typeof useRunCalculationLazyQuery>;
export type RunCalculationSuspenseQueryHookResult = ReturnType<typeof useRunCalculationSuspenseQuery>;
export type RunCalculationQueryResult = Apollo.QueryResult<RunCalculationQuery, RunCalculationQueryVariables>;
export const AddOnsBySlugsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AddOnsBySlugs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slugs"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryAvailability"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"_text"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_catalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slugs"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"country_availability"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryAvailability"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductDetails"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StripeProductPriceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_free_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_paid_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}}]}}]} as unknown as DocumentNode;

/**
 * __useAddOnsBySlugsQuery__
 *
 * To run a query within a React component, call `useAddOnsBySlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddOnsBySlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddOnsBySlugsQuery({
 *   variables: {
 *      slugs: // value for 'slugs'
 *      countryAvailability: // value for 'countryAvailability'
 *   },
 * });
 */
export function useAddOnsBySlugsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddOnsBySlugsQuery, AddOnsBySlugsQueryVariables> & ({ variables: AddOnsBySlugsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddOnsBySlugsQuery, AddOnsBySlugsQueryVariables>(AddOnsBySlugsDocument, options);
      }
export function useAddOnsBySlugsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddOnsBySlugsQuery, AddOnsBySlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddOnsBySlugsQuery, AddOnsBySlugsQueryVariables>(AddOnsBySlugsDocument, options);
        }
export function useAddOnsBySlugsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddOnsBySlugsQuery, AddOnsBySlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddOnsBySlugsQuery, AddOnsBySlugsQueryVariables>(AddOnsBySlugsDocument, options);
        }
export type AddOnsBySlugsQueryHookResult = ReturnType<typeof useAddOnsBySlugsQuery>;
export type AddOnsBySlugsLazyQueryHookResult = ReturnType<typeof useAddOnsBySlugsLazyQuery>;
export type AddOnsBySlugsSuspenseQueryHookResult = ReturnType<typeof useAddOnsBySlugsSuspenseQuery>;
export type AddOnsBySlugsQueryResult = Apollo.QueryResult<AddOnsBySlugsQuery, AddOnsBySlugsQueryVariables>;
export const UserSexDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserSex"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sex"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useUserSexQuery__
 *
 * To run a query within a React component, call `useUserSexQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSexQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserSexQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserSexQuery, UserSexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserSexQuery, UserSexQueryVariables>(UserSexDocument, options);
      }
export function useUserSexLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserSexQuery, UserSexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserSexQuery, UserSexQueryVariables>(UserSexDocument, options);
        }
export function useUserSexSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserSexQuery, UserSexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserSexQuery, UserSexQueryVariables>(UserSexDocument, options);
        }
export type UserSexQueryHookResult = ReturnType<typeof useUserSexQuery>;
export type UserSexLazyQueryHookResult = ReturnType<typeof useUserSexLazyQuery>;
export type UserSexSuspenseQueryHookResult = ReturnType<typeof useUserSexSuspenseQuery>;
export type UserSexQueryResult = Apollo.QueryResult<UserSexQuery, UserSexQueryVariables>;
export const LabProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LabProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryAvailability"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"_text"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"60"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tests"},"name":{"kind":"Name","value":"product_catalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"LAB_TEST"},{"kind":"EnumValue","value":"LAB_PANEL"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"country_availability"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryAvailability"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"lab_items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lab_test"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"products"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"LAB_TEST"}}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lab_test"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_test"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"LAB_TEST"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"markers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lab_test_marker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"include_in_overview"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_test_marker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metric_id"}},{"kind":"Field","alias":{"kind":"Name","value":"display_name"},"name":{"kind":"Name","value":"display_name_gen"}},{"kind":"Field","name":{"kind":"Name","value":"long_common_name"}},{"kind":"Field","name":{"kind":"Name","value":"synonyms"}},{"kind":"Field","name":{"kind":"Name","value":"loinc_number"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"packages"},"name":{"kind":"Name","value":"product_catalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"PACKAGE"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"metadata"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"featured_package"},"value":{"kind":"StringValue","value":"true","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"country_availability"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryAvailability"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"marker_counts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lab_items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lab_test"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"products"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"LAB_TEST"}}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lab_test"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_test"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"LAB_TEST"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"phenoAge"},"name":{"kind":"Name","value":"get_metric_by_namespace_key"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"namespace"},"value":{"kind":"StringValue","value":"PHENO_AGE","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"PHENO_AGE","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StripeProductPriceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_free_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_paid_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useLabProductsQuery__
 *
 * To run a query within a React component, call `useLabProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabProductsQuery({
 *   variables: {
 *      countryAvailability: // value for 'countryAvailability'
 *   },
 * });
 */
export function useLabProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LabProductsQuery, LabProductsQueryVariables> & ({ variables: LabProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LabProductsQuery, LabProductsQueryVariables>(LabProductsDocument, options);
      }
export function useLabProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LabProductsQuery, LabProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LabProductsQuery, LabProductsQueryVariables>(LabProductsDocument, options);
        }
export function useLabProductsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LabProductsQuery, LabProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LabProductsQuery, LabProductsQueryVariables>(LabProductsDocument, options);
        }
export type LabProductsQueryHookResult = ReturnType<typeof useLabProductsQuery>;
export type LabProductsLazyQueryHookResult = ReturnType<typeof useLabProductsLazyQuery>;
export type LabProductsSuspenseQueryHookResult = ReturnType<typeof useLabProductsSuspenseQuery>;
export type LabProductsQueryResult = Apollo.QueryResult<LabProductsQuery, LabProductsQueryVariables>;
export const LabContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LabContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productSlugs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productLimit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"markerMetricIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"markerLimit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"availableCaFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cms_BooleanFilterInput_content"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"600"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"products"},"name":{"kind":"Name","value":"stripeProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productSlugs"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"available_canada"},"value":{"kind":"Variable","name":{"kind":"Name","value":"availableCaFilter"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productLimit"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"markers"},"name":{"kind":"Name","value":"labTestMarkers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entity_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"markerMetricIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"markerLimit"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metric_id"},"name":{"kind":"Name","value":"entity_id"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"full_description"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useLabContentQuery__
 *
 * To run a query within a React component, call `useLabContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabContentQuery({
 *   variables: {
 *      productSlugs: // value for 'productSlugs'
 *      productLimit: // value for 'productLimit'
 *      markerMetricIds: // value for 'markerMetricIds'
 *      markerLimit: // value for 'markerLimit'
 *      availableCaFilter: // value for 'availableCaFilter'
 *   },
 * });
 */
export function useLabContentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LabContentQuery, LabContentQueryVariables> & ({ variables: LabContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LabContentQuery, LabContentQueryVariables>(LabContentDocument, options);
      }
export function useLabContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LabContentQuery, LabContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LabContentQuery, LabContentQueryVariables>(LabContentDocument, options);
        }
export function useLabContentSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LabContentQuery, LabContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LabContentQuery, LabContentQueryVariables>(LabContentDocument, options);
        }
export type LabContentQueryHookResult = ReturnType<typeof useLabContentQuery>;
export type LabContentLazyQueryHookResult = ReturnType<typeof useLabContentLazyQuery>;
export type LabContentSuspenseQueryHookResult = ReturnType<typeof useLabContentSuspenseQuery>;
export type LabContentQueryResult = Apollo.QueryResult<LabContentQuery, LabContentQueryVariables>;
export const MembershipProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MembershipProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryAvailability"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"_text"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_catalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"MEMBERSHIP"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"enabled"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"country_availability"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryAvailability"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StripeProductPriceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_free_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_paid_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useMembershipProductsQuery__
 *
 * To run a query within a React component, call `useMembershipProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipProductsQuery({
 *   variables: {
 *      countryAvailability: // value for 'countryAvailability'
 *   },
 * });
 */
export function useMembershipProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MembershipProductsQuery, MembershipProductsQueryVariables> & ({ variables: MembershipProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MembershipProductsQuery, MembershipProductsQueryVariables>(MembershipProductsDocument, options);
      }
export function useMembershipProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MembershipProductsQuery, MembershipProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MembershipProductsQuery, MembershipProductsQueryVariables>(MembershipProductsDocument, options);
        }
export function useMembershipProductsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MembershipProductsQuery, MembershipProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MembershipProductsQuery, MembershipProductsQueryVariables>(MembershipProductsDocument, options);
        }
export type MembershipProductsQueryHookResult = ReturnType<typeof useMembershipProductsQuery>;
export type MembershipProductsLazyQueryHookResult = ReturnType<typeof useMembershipProductsLazyQuery>;
export type MembershipProductsSuspenseQueryHookResult = ReturnType<typeof useMembershipProductsSuspenseQuery>;
export type MembershipProductsQueryResult = Apollo.QueryResult<MembershipProductsQuery, MembershipProductsQueryVariables>;
export const PartnerProductsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PartnerProductsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"availableCaFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cms_BooleanFilterInput_content"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"partnerProducts"},"name":{"kind":"Name","value":"cms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_partner_product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"available_canada"},"value":{"kind":"Variable","name":{"kind":"Name","value":"availableCaFilter"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StripeProductPriceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_free_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_paid_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileRelationResponseCollection_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __usePartnerProductsListQuery__
 *
 * To run a query within a React component, call `usePartnerProductsListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerProductsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerProductsListQuery({
 *   variables: {
 *      availableCaFilter: // value for 'availableCaFilter'
 *   },
 * });
 */
export function usePartnerProductsListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PartnerProductsListQuery, PartnerProductsListQueryVariables> & ({ variables: PartnerProductsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PartnerProductsListQuery, PartnerProductsListQueryVariables>(PartnerProductsListDocument, options);
      }
export function usePartnerProductsListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PartnerProductsListQuery, PartnerProductsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PartnerProductsListQuery, PartnerProductsListQueryVariables>(PartnerProductsListDocument, options);
        }
export function usePartnerProductsListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PartnerProductsListQuery, PartnerProductsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PartnerProductsListQuery, PartnerProductsListQueryVariables>(PartnerProductsListDocument, options);
        }
export type PartnerProductsListQueryHookResult = ReturnType<typeof usePartnerProductsListQuery>;
export type PartnerProductsListLazyQueryHookResult = ReturnType<typeof usePartnerProductsListLazyQuery>;
export type PartnerProductsListSuspenseQueryHookResult = ReturnType<typeof usePartnerProductsListSuspenseQuery>;
export type PartnerProductsListQueryResult = Apollo.QueryResult<PartnerProductsListQuery, PartnerProductsListQueryVariables>;
export const CommercePageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CommercePage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commercePages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Header"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MainSecondaryTextGroupFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Header"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MainSecondaryTextGroupFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Rows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DualProductSectionFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SingleProductSectionFields"}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommercePageProductFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_StripeProductEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coming_soon"}},{"kind":"Field","name":{"kind":"Name","value":"out_of_stock"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DualProductSectionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_ComponentDualProductSectionWtfDouble_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"left_product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommercePageProductFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"right_product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommercePageProductFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SingleProductSectionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_ComponentSingleProductSectionWtf_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image_is_on_left"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommercePageProductFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MainSecondaryTextGroupFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_ComponentContentComponentTd_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"short_text"}},{"kind":"Field","name":{"kind":"Name","value":"long_text"}}]}}]} as unknown as DocumentNode;

/**
 * __useCommercePageQuery__
 *
 * To run a query within a React component, call `useCommercePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommercePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommercePageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCommercePageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CommercePageQuery, CommercePageQueryVariables> & ({ variables: CommercePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CommercePageQuery, CommercePageQueryVariables>(CommercePageDocument, options);
      }
export function useCommercePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CommercePageQuery, CommercePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CommercePageQuery, CommercePageQueryVariables>(CommercePageDocument, options);
        }
export function useCommercePageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CommercePageQuery, CommercePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CommercePageQuery, CommercePageQueryVariables>(CommercePageDocument, options);
        }
export type CommercePageQueryHookResult = ReturnType<typeof useCommercePageQuery>;
export type CommercePageLazyQueryHookResult = ReturnType<typeof useCommercePageLazyQuery>;
export type CommercePageSuspenseQueryHookResult = ReturnType<typeof useCommercePageSuspenseQuery>;
export type CommercePageQueryResult = Apollo.QueryResult<CommercePageQuery, CommercePageQueryVariables>;
export const StripeOrderByOrderIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StripeOrderByOrderId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripe_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requisition_pdf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"download"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"order_number"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"receipt_url"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"line_items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"is_purchase_request"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_custom"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useStripeOrderByOrderIdQuery__
 *
 * To run a query within a React component, call `useStripeOrderByOrderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeOrderByOrderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeOrderByOrderIdQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useStripeOrderByOrderIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StripeOrderByOrderIdQuery, StripeOrderByOrderIdQueryVariables> & ({ variables: StripeOrderByOrderIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StripeOrderByOrderIdQuery, StripeOrderByOrderIdQueryVariables>(StripeOrderByOrderIdDocument, options);
      }
export function useStripeOrderByOrderIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StripeOrderByOrderIdQuery, StripeOrderByOrderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StripeOrderByOrderIdQuery, StripeOrderByOrderIdQueryVariables>(StripeOrderByOrderIdDocument, options);
        }
export function useStripeOrderByOrderIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<StripeOrderByOrderIdQuery, StripeOrderByOrderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<StripeOrderByOrderIdQuery, StripeOrderByOrderIdQueryVariables>(StripeOrderByOrderIdDocument, options);
        }
export type StripeOrderByOrderIdQueryHookResult = ReturnType<typeof useStripeOrderByOrderIdQuery>;
export type StripeOrderByOrderIdLazyQueryHookResult = ReturnType<typeof useStripeOrderByOrderIdLazyQuery>;
export type StripeOrderByOrderIdSuspenseQueryHookResult = ReturnType<typeof useStripeOrderByOrderIdSuspenseQuery>;
export type StripeOrderByOrderIdQueryResult = Apollo.QueryResult<StripeOrderByOrderIdQuery, StripeOrderByOrderIdQueryVariables>;
export const LabShopOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LabShopOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripe_order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"payment_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"paid","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_number"}},{"kind":"Field","name":{"kind":"Name","value":"payment_status"}},{"kind":"Field","name":{"kind":"Name","value":"receipt_url"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"line_items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lab_orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"requisition_pdf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"download"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lab_order_status"}},{"kind":"Field","name":{"kind":"Name","value":"lab_result_status"}},{"kind":"Field","name":{"kind":"Name","value":"order_number"}},{"kind":"Field","name":{"kind":"Name","value":"results_pdf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"download"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useLabShopOrderQuery__
 *
 * To run a query within a React component, call `useLabShopOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabShopOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabShopOrderQuery({
 *   variables: {
 *   },
 * });
 */
export function useLabShopOrderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LabShopOrderQuery, LabShopOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LabShopOrderQuery, LabShopOrderQueryVariables>(LabShopOrderDocument, options);
      }
export function useLabShopOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LabShopOrderQuery, LabShopOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LabShopOrderQuery, LabShopOrderQueryVariables>(LabShopOrderDocument, options);
        }
export function useLabShopOrderSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LabShopOrderQuery, LabShopOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LabShopOrderQuery, LabShopOrderQueryVariables>(LabShopOrderDocument, options);
        }
export type LabShopOrderQueryHookResult = ReturnType<typeof useLabShopOrderQuery>;
export type LabShopOrderLazyQueryHookResult = ReturnType<typeof useLabShopOrderLazyQuery>;
export type LabShopOrderSuspenseQueryHookResult = ReturnType<typeof useLabShopOrderSuspenseQuery>;
export type LabShopOrderQueryResult = Apollo.QueryResult<LabShopOrderQuery, LabShopOrderQueryVariables>;
export const PdpContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PdpContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipMedicationFields"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryAvailability"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"_text"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_catalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"country_availability"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryAvailability"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_requirements"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipMedicationFields"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MembershipPurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gettingStarted"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipMedicationFields"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MainSecondaryTextGroupFields"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipMedicationFields"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MainSecondaryTextGroupFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MainSecondaryTextGroupFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"treatments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MainSecondaryTextGroupFields"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"stripeProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coming_soon"}},{"kind":"Field","name":{"kind":"Name","value":"out_of_stock"}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipMedicationFields"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"benefits"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipMedicationFields"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MainSecondaryTextGroupFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"faqs"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipMedicationFields"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MainSecondaryTextGroupFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"safety"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipMedicationFields"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MainSecondaryTextGroupFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Information"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipMedicationFields"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MainSecondaryTextGroupFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StripeProductPriceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_free_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_paid_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MainSecondaryTextGroupFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_ComponentContentComponentTd_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"short_text"}},{"kind":"Field","name":{"kind":"Name","value":"long_text"}}]}}]} as unknown as DocumentNode;

/**
 * __usePdpContentQuery__
 *
 * To run a query within a React component, call `usePdpContentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdpContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdpContentQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      skipMedicationFields: // value for 'skipMedicationFields'
 *      countryAvailability: // value for 'countryAvailability'
 *   },
 * });
 */
export function usePdpContentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PdpContentQuery, PdpContentQueryVariables> & ({ variables: PdpContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PdpContentQuery, PdpContentQueryVariables>(PdpContentDocument, options);
      }
export function usePdpContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PdpContentQuery, PdpContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PdpContentQuery, PdpContentQueryVariables>(PdpContentDocument, options);
        }
export function usePdpContentSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PdpContentQuery, PdpContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PdpContentQuery, PdpContentQueryVariables>(PdpContentDocument, options);
        }
export type PdpContentQueryHookResult = ReturnType<typeof usePdpContentQuery>;
export type PdpContentLazyQueryHookResult = ReturnType<typeof usePdpContentLazyQuery>;
export type PdpContentSuspenseQueryHookResult = ReturnType<typeof usePdpContentSuspenseQuery>;
export type PdpContentQueryResult = Apollo.QueryResult<PdpContentQuery, PdpContentQueryVariables>;
export const NewAccountExistingProfileInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewAccountExistingProfileInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me_v2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date_of_birth"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lab_test_state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lab_profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"birth_date"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"ship_to_address"}},{"kind":"Field","name":{"kind":"Name","value":"ship_to_city"}},{"kind":"Field","name":{"kind":"Name","value":"ship_to_country"}},{"kind":"Field","name":{"kind":"Name","value":"ship_to_postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"ship_to_state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_address"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ship_to_address"}},{"kind":"Field","name":{"kind":"Name","value":"ship_to_city"}},{"kind":"Field","name":{"kind":"Name","value":"ship_to_postal_code"}},{"kind":"Field","name":{"kind":"Name","value":"ship_to_state"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useNewAccountExistingProfileInfoQuery__
 *
 * To run a query within a React component, call `useNewAccountExistingProfileInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewAccountExistingProfileInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewAccountExistingProfileInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useNewAccountExistingProfileInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NewAccountExistingProfileInfoQuery, NewAccountExistingProfileInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NewAccountExistingProfileInfoQuery, NewAccountExistingProfileInfoQueryVariables>(NewAccountExistingProfileInfoDocument, options);
      }
export function useNewAccountExistingProfileInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NewAccountExistingProfileInfoQuery, NewAccountExistingProfileInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NewAccountExistingProfileInfoQuery, NewAccountExistingProfileInfoQueryVariables>(NewAccountExistingProfileInfoDocument, options);
        }
export function useNewAccountExistingProfileInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<NewAccountExistingProfileInfoQuery, NewAccountExistingProfileInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NewAccountExistingProfileInfoQuery, NewAccountExistingProfileInfoQueryVariables>(NewAccountExistingProfileInfoDocument, options);
        }
export type NewAccountExistingProfileInfoQueryHookResult = ReturnType<typeof useNewAccountExistingProfileInfoQuery>;
export type NewAccountExistingProfileInfoLazyQueryHookResult = ReturnType<typeof useNewAccountExistingProfileInfoLazyQuery>;
export type NewAccountExistingProfileInfoSuspenseQueryHookResult = ReturnType<typeof useNewAccountExistingProfileInfoSuspenseQuery>;
export type NewAccountExistingProfileInfoQueryResult = Apollo.QueryResult<NewAccountExistingProfileInfoQuery, NewAccountExistingProfileInfoQueryVariables>;
export const VitalAppointmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VitalAppointments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhlebotomyAppointmentAvailabilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_phlebotomy_appointment_availability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useVitalAppointmentsQuery__
 *
 * To run a query within a React component, call `useVitalAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVitalAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVitalAppointmentsQuery({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useVitalAppointmentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<VitalAppointmentsQuery, VitalAppointmentsQueryVariables> & ({ variables: VitalAppointmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VitalAppointmentsQuery, VitalAppointmentsQueryVariables>(VitalAppointmentsDocument, options);
      }
export function useVitalAppointmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VitalAppointmentsQuery, VitalAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VitalAppointmentsQuery, VitalAppointmentsQueryVariables>(VitalAppointmentsDocument, options);
        }
export function useVitalAppointmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<VitalAppointmentsQuery, VitalAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<VitalAppointmentsQuery, VitalAppointmentsQueryVariables>(VitalAppointmentsDocument, options);
        }
export type VitalAppointmentsQueryHookResult = ReturnType<typeof useVitalAppointmentsQuery>;
export type VitalAppointmentsLazyQueryHookResult = ReturnType<typeof useVitalAppointmentsLazyQuery>;
export type VitalAppointmentsSuspenseQueryHookResult = ReturnType<typeof useVitalAppointmentsSuspenseQuery>;
export type VitalAppointmentsQueryResult = Apollo.QueryResult<VitalAppointmentsQuery, VitalAppointmentsQueryVariables>;
export const AcceptConsentPoliciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptConsentPolicies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"consentPolicyIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AcceptConsentPolicyFields"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AcceptConsentPolicyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"mutation_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accept_consent_policy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"consent_policy_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"consentPolicyIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consentPolicyVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}}]}}]}}]} as unknown as DocumentNode;
export type AcceptConsentPoliciesMutationFn = Apollo.MutationFunction<AcceptConsentPoliciesMutation, AcceptConsentPoliciesMutationVariables>;

/**
 * __useAcceptConsentPoliciesMutation__
 *
 * To run a mutation, you first call `useAcceptConsentPoliciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptConsentPoliciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptConsentPoliciesMutation, { data, loading, error }] = useAcceptConsentPoliciesMutation({
 *   variables: {
 *      consentPolicyIds: // value for 'consentPolicyIds'
 *   },
 * });
 */
export function useAcceptConsentPoliciesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptConsentPoliciesMutation, AcceptConsentPoliciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptConsentPoliciesMutation, AcceptConsentPoliciesMutationVariables>(AcceptConsentPoliciesDocument, options);
      }
export type AcceptConsentPoliciesMutationHookResult = ReturnType<typeof useAcceptConsentPoliciesMutation>;
export type AcceptConsentPoliciesMutationResult = Apollo.MutationResult<AcceptConsentPoliciesMutation>;
export type AcceptConsentPoliciesMutationOptions = Apollo.BaseMutationOptions<AcceptConsentPoliciesMutation, AcceptConsentPoliciesMutationVariables>;
export const CreateSelfdecodeProfileAndAcceptTosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSelfdecodeProfileAndAcceptTos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateLabProfileInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipRealizeTos"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"realizeTosVersion"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isLabAvailableInOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_lab_profile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"isLabAvailableInOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isLabAvailableInOrder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"birthDate"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"validationMsg"}}]}},{"kind":"Field","name":{"kind":"Name","value":"acceptTermsOfService"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"realizeTosVersion"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipRealizeTos"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}}]}}]}}]} as unknown as DocumentNode;
export type CreateSelfdecodeProfileAndAcceptTosMutationFn = Apollo.MutationFunction<CreateSelfdecodeProfileAndAcceptTosMutation, CreateSelfdecodeProfileAndAcceptTosMutationVariables>;

/**
 * __useCreateSelfdecodeProfileAndAcceptTosMutation__
 *
 * To run a mutation, you first call `useCreateSelfdecodeProfileAndAcceptTosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSelfdecodeProfileAndAcceptTosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSelfdecodeProfileAndAcceptTosMutation, { data, loading, error }] = useCreateSelfdecodeProfileAndAcceptTosMutation({
 *   variables: {
 *      input: // value for 'input'
 *      skipRealizeTos: // value for 'skipRealizeTos'
 *      realizeTosVersion: // value for 'realizeTosVersion'
 *      isLabAvailableInOrder: // value for 'isLabAvailableInOrder'
 *   },
 * });
 */
export function useCreateSelfdecodeProfileAndAcceptTosMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSelfdecodeProfileAndAcceptTosMutation, CreateSelfdecodeProfileAndAcceptTosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSelfdecodeProfileAndAcceptTosMutation, CreateSelfdecodeProfileAndAcceptTosMutationVariables>(CreateSelfdecodeProfileAndAcceptTosDocument, options);
      }
export type CreateSelfdecodeProfileAndAcceptTosMutationHookResult = ReturnType<typeof useCreateSelfdecodeProfileAndAcceptTosMutation>;
export type CreateSelfdecodeProfileAndAcceptTosMutationResult = Apollo.MutationResult<CreateSelfdecodeProfileAndAcceptTosMutation>;
export type CreateSelfdecodeProfileAndAcceptTosMutationOptions = Apollo.BaseMutationOptions<CreateSelfdecodeProfileAndAcceptTosMutation, CreateSelfdecodeProfileAndAcceptTosMutationVariables>;
export const LabTestStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LabTestState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_test_state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useLabTestStateQuery__
 *
 * To run a query within a React component, call `useLabTestStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabTestStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabTestStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useLabTestStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LabTestStateQuery, LabTestStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LabTestStateQuery, LabTestStateQueryVariables>(LabTestStateDocument, options);
      }
export function useLabTestStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LabTestStateQuery, LabTestStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LabTestStateQuery, LabTestStateQueryVariables>(LabTestStateDocument, options);
        }
export function useLabTestStateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LabTestStateQuery, LabTestStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LabTestStateQuery, LabTestStateQueryVariables>(LabTestStateDocument, options);
        }
export type LabTestStateQueryHookResult = ReturnType<typeof useLabTestStateQuery>;
export type LabTestStateLazyQueryHookResult = ReturnType<typeof useLabTestStateLazyQuery>;
export type LabTestStateSuspenseQueryHookResult = ReturnType<typeof useLabTestStateSuspenseQuery>;
export type LabTestStateQueryResult = Apollo.QueryResult<LabTestStateQuery, LabTestStateQueryVariables>;
export const UpdateUserDataAcceptTosAndPartiallyUpdateLabProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserDataAcceptTosAndPartiallyUpdateLabProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipRealizeTos"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rmName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rmDateOfBirth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rmSex"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"enum_sex_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"birthDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sex"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"enum_selfdecode_sex_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"consentPolicyIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptTermsOfService"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipRealizeTos"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rmName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"date_of_birth"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rmDateOfBirth"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sex"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rmSex"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"create_lab_profile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"partial"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"birthDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"birthDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sex"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sex"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isComplete"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AcceptConsentPolicyFields"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AcceptConsentPolicyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"mutation_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accept_consent_policy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"consent_policy_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"consentPolicyIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consentPolicyVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}}]}}]}}]} as unknown as DocumentNode;
export type UpdateUserDataAcceptTosAndPartiallyUpdateLabProfileMutationFn = Apollo.MutationFunction<UpdateUserDataAcceptTosAndPartiallyUpdateLabProfileMutation, UpdateUserDataAcceptTosAndPartiallyUpdateLabProfileMutationVariables>;

/**
 * __useUpdateUserDataAcceptTosAndPartiallyUpdateLabProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserDataAcceptTosAndPartiallyUpdateLabProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDataAcceptTosAndPartiallyUpdateLabProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDataAcceptTosAndPartiallyUpdateLabProfileMutation, { data, loading, error }] = useUpdateUserDataAcceptTosAndPartiallyUpdateLabProfileMutation({
 *   variables: {
 *      skipRealizeTos: // value for 'skipRealizeTos'
 *      version: // value for 'version'
 *      id: // value for 'id'
 *      rmName: // value for 'rmName'
 *      rmDateOfBirth: // value for 'rmDateOfBirth'
 *      rmSex: // value for 'rmSex'
 *      birthDate: // value for 'birthDate'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      sex: // value for 'sex'
 *      consentPolicyIds: // value for 'consentPolicyIds'
 *   },
 * });
 */
export function useUpdateUserDataAcceptTosAndPartiallyUpdateLabProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserDataAcceptTosAndPartiallyUpdateLabProfileMutation, UpdateUserDataAcceptTosAndPartiallyUpdateLabProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserDataAcceptTosAndPartiallyUpdateLabProfileMutation, UpdateUserDataAcceptTosAndPartiallyUpdateLabProfileMutationVariables>(UpdateUserDataAcceptTosAndPartiallyUpdateLabProfileDocument, options);
      }
export type UpdateUserDataAcceptTosAndPartiallyUpdateLabProfileMutationHookResult = ReturnType<typeof useUpdateUserDataAcceptTosAndPartiallyUpdateLabProfileMutation>;
export type UpdateUserDataAcceptTosAndPartiallyUpdateLabProfileMutationResult = Apollo.MutationResult<UpdateUserDataAcceptTosAndPartiallyUpdateLabProfileMutation>;
export type UpdateUserDataAcceptTosAndPartiallyUpdateLabProfileMutationOptions = Apollo.BaseMutationOptions<UpdateUserDataAcceptTosAndPartiallyUpdateLabProfileMutation, UpdateUserDataAcceptTosAndPartiallyUpdateLabProfileMutationVariables>;
export const AtHomeLabsDrawProductInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AtHomeLabsDrawProductInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryAvailability"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"_text"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_catalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"home-lab-draw-fee","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"country_availability"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryAvailability"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StripeProductPriceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_free_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_paid_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useAtHomeLabsDrawProductInfoQuery__
 *
 * To run a query within a React component, call `useAtHomeLabsDrawProductInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtHomeLabsDrawProductInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtHomeLabsDrawProductInfoQuery({
 *   variables: {
 *      countryAvailability: // value for 'countryAvailability'
 *   },
 * });
 */
export function useAtHomeLabsDrawProductInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AtHomeLabsDrawProductInfoQuery, AtHomeLabsDrawProductInfoQueryVariables> & ({ variables: AtHomeLabsDrawProductInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AtHomeLabsDrawProductInfoQuery, AtHomeLabsDrawProductInfoQueryVariables>(AtHomeLabsDrawProductInfoDocument, options);
      }
export function useAtHomeLabsDrawProductInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AtHomeLabsDrawProductInfoQuery, AtHomeLabsDrawProductInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AtHomeLabsDrawProductInfoQuery, AtHomeLabsDrawProductInfoQueryVariables>(AtHomeLabsDrawProductInfoDocument, options);
        }
export function useAtHomeLabsDrawProductInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AtHomeLabsDrawProductInfoQuery, AtHomeLabsDrawProductInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AtHomeLabsDrawProductInfoQuery, AtHomeLabsDrawProductInfoQueryVariables>(AtHomeLabsDrawProductInfoDocument, options);
        }
export type AtHomeLabsDrawProductInfoQueryHookResult = ReturnType<typeof useAtHomeLabsDrawProductInfoQuery>;
export type AtHomeLabsDrawProductInfoLazyQueryHookResult = ReturnType<typeof useAtHomeLabsDrawProductInfoLazyQuery>;
export type AtHomeLabsDrawProductInfoSuspenseQueryHookResult = ReturnType<typeof useAtHomeLabsDrawProductInfoSuspenseQuery>;
export type AtHomeLabsDrawProductInfoQueryResult = Apollo.QueryResult<AtHomeLabsDrawProductInfoQuery, AtHomeLabsDrawProductInfoQueryVariables>;
export const SupplementProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupplementProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryAvailability"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"_text"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_catalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"product_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"SUPPLEMENT"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"country_availability"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryAvailability"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"out_of_stock"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StripeProductPriceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_free_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_paid_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useSupplementProductsQuery__
 *
 * To run a query within a React component, call `useSupplementProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplementProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplementProductsQuery({
 *   variables: {
 *      countryAvailability: // value for 'countryAvailability'
 *   },
 * });
 */
export function useSupplementProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SupplementProductsQuery, SupplementProductsQueryVariables> & ({ variables: SupplementProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SupplementProductsQuery, SupplementProductsQueryVariables>(SupplementProductsDocument, options);
      }
export function useSupplementProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SupplementProductsQuery, SupplementProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SupplementProductsQuery, SupplementProductsQueryVariables>(SupplementProductsDocument, options);
        }
export function useSupplementProductsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SupplementProductsQuery, SupplementProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SupplementProductsQuery, SupplementProductsQueryVariables>(SupplementProductsDocument, options);
        }
export type SupplementProductsQueryHookResult = ReturnType<typeof useSupplementProductsQuery>;
export type SupplementProductsLazyQueryHookResult = ReturnType<typeof useSupplementProductsLazyQuery>;
export type SupplementProductsSuspenseQueryHookResult = ReturnType<typeof useSupplementProductsSuspenseQuery>;
export type SupplementProductsQueryResult = Apollo.QueryResult<SupplementProductsQuery, SupplementProductsQueryVariables>;
export const ProductTypeDefaultImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductTypeDefaultImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productTypeDefaultImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"FEE"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"LAB_PANEL"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"LAB_TEST"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"MEMBERSHIP"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"PACKAGE"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"PRESCRIPTION"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"PRODUCT"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"SUPPLEMENT"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAttributes"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_UploadFileEntityResponse_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useProductTypeDefaultImageQuery__
 *
 * To run a query within a React component, call `useProductTypeDefaultImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductTypeDefaultImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductTypeDefaultImageQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductTypeDefaultImageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductTypeDefaultImageQuery, ProductTypeDefaultImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductTypeDefaultImageQuery, ProductTypeDefaultImageQueryVariables>(ProductTypeDefaultImageDocument, options);
      }
export function useProductTypeDefaultImageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductTypeDefaultImageQuery, ProductTypeDefaultImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductTypeDefaultImageQuery, ProductTypeDefaultImageQueryVariables>(ProductTypeDefaultImageDocument, options);
        }
export function useProductTypeDefaultImageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductTypeDefaultImageQuery, ProductTypeDefaultImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductTypeDefaultImageQuery, ProductTypeDefaultImageQueryVariables>(ProductTypeDefaultImageDocument, options);
        }
export type ProductTypeDefaultImageQueryHookResult = ReturnType<typeof useProductTypeDefaultImageQuery>;
export type ProductTypeDefaultImageLazyQueryHookResult = ReturnType<typeof useProductTypeDefaultImageLazyQuery>;
export type ProductTypeDefaultImageSuspenseQueryHookResult = ReturnType<typeof useProductTypeDefaultImageSuspenseQuery>;
export type ProductTypeDefaultImageQueryResult = Apollo.QueryResult<ProductTypeDefaultImageQuery, ProductTypeDefaultImageQueryVariables>;
export const ClaimCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClaimCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cartId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"claim_cart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cart_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cartId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StripeProductPriceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_free_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_paid_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member_discount"}},{"kind":"Field","name":{"kind":"Name","value":"promotion_discount"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}}]}},{"kind":"Field","name":{"kind":"Name","value":"applied_promo_code"}},{"kind":"Field","name":{"kind":"Name","value":"appliedMembershipTier"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsentPurchaseRequirementFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomPurchaseRequirementFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTypePurchaseRequirementFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requires"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiresLineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiredBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiredByLineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMin"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMax"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_custom"}},{"kind":"Field","name":{"kind":"Name","value":"package_products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsentPurchaseRequirementFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomPurchaseRequirementFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConsentPurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConsentPurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"consentPolicyId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"consent_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"policy_type"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"external_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomPurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomPurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTypePurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTypePurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode;
export type ClaimCartMutationFn = Apollo.MutationFunction<ClaimCartMutation, ClaimCartMutationVariables>;

/**
 * __useClaimCartMutation__
 *
 * To run a mutation, you first call `useClaimCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimCartMutation, { data, loading, error }] = useClaimCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useClaimCartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ClaimCartMutation, ClaimCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ClaimCartMutation, ClaimCartMutationVariables>(ClaimCartDocument, options);
      }
export type ClaimCartMutationHookResult = ReturnType<typeof useClaimCartMutation>;
export type ClaimCartMutationResult = Apollo.MutationResult<ClaimCartMutation>;
export type ClaimCartMutationOptions = Apollo.BaseMutationOptions<ClaimCartMutation, ClaimCartMutationVariables>;
export const GetCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cartId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipTos"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"has_accepted_latest_terms"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipTos"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"terms_of_service"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipTos"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLatest"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"get_cart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cart_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cartId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StripeProductPriceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_free_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_paid_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member_discount"}},{"kind":"Field","name":{"kind":"Name","value":"promotion_discount"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}}]}},{"kind":"Field","name":{"kind":"Name","value":"applied_promo_code"}},{"kind":"Field","name":{"kind":"Name","value":"appliedMembershipTier"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsentPurchaseRequirementFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomPurchaseRequirementFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTypePurchaseRequirementFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requires"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiresLineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiredBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiredByLineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMin"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMax"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_custom"}},{"kind":"Field","name":{"kind":"Name","value":"package_products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsentPurchaseRequirementFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomPurchaseRequirementFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConsentPurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConsentPurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"consentPolicyId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"consent_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"policy_type"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"external_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomPurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomPurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTypePurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTypePurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetCartQuery__
 *
 * To run a query within a React component, call `useGetCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      skipTos: // value for 'skipTos'
 *   },
 * });
 */
export function useGetCartQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCartQuery, GetCartQueryVariables> & ({ variables: GetCartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCartQuery, GetCartQueryVariables>(GetCartDocument, options);
      }
export function useGetCartLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCartQuery, GetCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCartQuery, GetCartQueryVariables>(GetCartDocument, options);
        }
export function useGetCartSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCartQuery, GetCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCartQuery, GetCartQueryVariables>(GetCartDocument, options);
        }
export type GetCartQueryHookResult = ReturnType<typeof useGetCartQuery>;
export type GetCartLazyQueryHookResult = ReturnType<typeof useGetCartLazyQuery>;
export type GetCartSuspenseQueryHookResult = ReturnType<typeof useGetCartSuspenseQuery>;
export type GetCartQueryResult = Apollo.QueryResult<GetCartQuery, GetCartQueryVariables>;
export const UpdateCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entries"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CartItemInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cartId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customPackageTests"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomPackageTestInput"}}}},"defaultValue":{"kind":"ListValue","values":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entries"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entries"}}},{"kind":"Argument","name":{"kind":"Name","value":"cart_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cartId"}}},{"kind":"Argument","name":{"kind":"Name","value":"customPackageTests"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customPackageTests"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StripeProductPriceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_free_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_paid_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member_discount"}},{"kind":"Field","name":{"kind":"Name","value":"promotion_discount"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}}]}},{"kind":"Field","name":{"kind":"Name","value":"applied_promo_code"}},{"kind":"Field","name":{"kind":"Name","value":"appliedMembershipTier"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsentPurchaseRequirementFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomPurchaseRequirementFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTypePurchaseRequirementFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requires"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiresLineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiredBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiredByLineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMin"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMax"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_custom"}},{"kind":"Field","name":{"kind":"Name","value":"package_products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsentPurchaseRequirementFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomPurchaseRequirementFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConsentPurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConsentPurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"consentPolicyId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"consent_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"policy_type"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"external_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomPurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomPurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTypePurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTypePurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode;
export type UpdateCartMutationFn = Apollo.MutationFunction<UpdateCartMutation, UpdateCartMutationVariables>;

/**
 * __useUpdateCartMutation__
 *
 * To run a mutation, you first call `useUpdateCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartMutation, { data, loading, error }] = useUpdateCartMutation({
 *   variables: {
 *      entries: // value for 'entries'
 *      cartId: // value for 'cartId'
 *      customPackageTests: // value for 'customPackageTests'
 *   },
 * });
 */
export function useUpdateCartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCartMutation, UpdateCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCartMutation, UpdateCartMutationVariables>(UpdateCartDocument, options);
      }
export type UpdateCartMutationHookResult = ReturnType<typeof useUpdateCartMutation>;
export type UpdateCartMutationResult = Apollo.MutationResult<UpdateCartMutation>;
export type UpdateCartMutationOptions = Apollo.BaseMutationOptions<UpdateCartMutation, UpdateCartMutationVariables>;
export const SetPromoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetPromo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"promoCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cartId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"set_cart_promo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"promo_code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"promoCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"cart_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cartId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StripeProductPriceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_free_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_paid_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member_discount"}},{"kind":"Field","name":{"kind":"Name","value":"promotion_discount"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}}]}},{"kind":"Field","name":{"kind":"Name","value":"applied_promo_code"}},{"kind":"Field","name":{"kind":"Name","value":"appliedMembershipTier"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsentPurchaseRequirementFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomPurchaseRequirementFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTypePurchaseRequirementFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requires"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiresLineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiredBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiredByLineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMin"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMax"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_custom"}},{"kind":"Field","name":{"kind":"Name","value":"package_products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsentPurchaseRequirementFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomPurchaseRequirementFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConsentPurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConsentPurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"consentPolicyId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"consent_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"policy_type"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"external_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomPurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomPurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTypePurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTypePurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode;
export type SetPromoMutationFn = Apollo.MutationFunction<SetPromoMutation, SetPromoMutationVariables>;

/**
 * __useSetPromoMutation__
 *
 * To run a mutation, you first call `useSetPromoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPromoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPromoMutation, { data, loading, error }] = useSetPromoMutation({
 *   variables: {
 *      promoCode: // value for 'promoCode'
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useSetPromoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetPromoMutation, SetPromoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetPromoMutation, SetPromoMutationVariables>(SetPromoDocument, options);
      }
export type SetPromoMutationHookResult = ReturnType<typeof useSetPromoMutation>;
export type SetPromoMutationResult = Apollo.MutationResult<SetPromoMutation>;
export type SetPromoMutationOptions = Apollo.BaseMutationOptions<SetPromoMutation, SetPromoMutationVariables>;
export const EmptyCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EmptyCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cartId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"empty_cart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cart_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cartId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StripeProductPriceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_free_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_paid_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member_discount"}},{"kind":"Field","name":{"kind":"Name","value":"promotion_discount"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}}]}},{"kind":"Field","name":{"kind":"Name","value":"applied_promo_code"}},{"kind":"Field","name":{"kind":"Name","value":"appliedMembershipTier"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsentPurchaseRequirementFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomPurchaseRequirementFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTypePurchaseRequirementFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requires"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiresLineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiredBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiredByLineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMin"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMax"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_custom"}},{"kind":"Field","name":{"kind":"Name","value":"package_products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsentPurchaseRequirementFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomPurchaseRequirementFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConsentPurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConsentPurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"consentPolicyId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"consent_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"policy_type"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"external_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomPurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomPurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTypePurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTypePurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode;
export type EmptyCartMutationFn = Apollo.MutationFunction<EmptyCartMutation, EmptyCartMutationVariables>;

/**
 * __useEmptyCartMutation__
 *
 * To run a mutation, you first call `useEmptyCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmptyCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emptyCartMutation, { data, loading, error }] = useEmptyCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useEmptyCartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EmptyCartMutation, EmptyCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EmptyCartMutation, EmptyCartMutationVariables>(EmptyCartDocument, options);
      }
export type EmptyCartMutationHookResult = ReturnType<typeof useEmptyCartMutation>;
export type EmptyCartMutationResult = Apollo.MutationResult<EmptyCartMutation>;
export type EmptyCartMutationOptions = Apollo.BaseMutationOptions<EmptyCartMutation, EmptyCartMutationVariables>;
export const CheckoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Checkout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"successUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"URL"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cancelUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"URL"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkout_cart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"config"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"success_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"successUrl"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"cancel_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cancelUrl"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode;
export type CheckoutMutationFn = Apollo.MutationFunction<CheckoutMutation, CheckoutMutationVariables>;

/**
 * __useCheckoutMutation__
 *
 * To run a mutation, you first call `useCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutMutation, { data, loading, error }] = useCheckoutMutation({
 *   variables: {
 *      successUrl: // value for 'successUrl'
 *      cancelUrl: // value for 'cancelUrl'
 *   },
 * });
 */
export function useCheckoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CheckoutMutation, CheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CheckoutMutation, CheckoutMutationVariables>(CheckoutDocument, options);
      }
export type CheckoutMutationHookResult = ReturnType<typeof useCheckoutMutation>;
export type CheckoutMutationResult = Apollo.MutationResult<CheckoutMutation>;
export type CheckoutMutationOptions = Apollo.BaseMutationOptions<CheckoutMutation, CheckoutMutationVariables>;
export const RealizeTosDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RealizeTosData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"has_accepted_latest_terms"}},{"kind":"Field","name":{"kind":"Name","value":"terms_of_service"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLatest"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useRealizeTosDataQuery__
 *
 * To run a query within a React component, call `useRealizeTosDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRealizeTosDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRealizeTosDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useRealizeTosDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RealizeTosDataQuery, RealizeTosDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RealizeTosDataQuery, RealizeTosDataQueryVariables>(RealizeTosDataDocument, options);
      }
export function useRealizeTosDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RealizeTosDataQuery, RealizeTosDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RealizeTosDataQuery, RealizeTosDataQueryVariables>(RealizeTosDataDocument, options);
        }
export function useRealizeTosDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RealizeTosDataQuery, RealizeTosDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RealizeTosDataQuery, RealizeTosDataQueryVariables>(RealizeTosDataDocument, options);
        }
export type RealizeTosDataQueryHookResult = ReturnType<typeof useRealizeTosDataQuery>;
export type RealizeTosDataLazyQueryHookResult = ReturnType<typeof useRealizeTosDataLazyQuery>;
export type RealizeTosDataSuspenseQueryHookResult = ReturnType<typeof useRealizeTosDataSuspenseQuery>;
export type RealizeTosDataQueryResult = Apollo.QueryResult<RealizeTosDataQuery, RealizeTosDataQueryVariables>;
export const GetPurchaseRequirementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPurchaseRequirements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_purchase_requirements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"product_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsentPurchaseRequirementFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomPurchaseRequirementFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTypePurchaseRequirementFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConsentPurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConsentPurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"consentPolicyId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"consent_policy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"policy_type"}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"external_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomPurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomPurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTypePurchaseRequirementFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTypePurchaseRequirementModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetPurchaseRequirementsQuery__
 *
 * To run a query within a React component, call `useGetPurchaseRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaseRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaseRequirementsQuery({
 *   variables: {
 *      productIds: // value for 'productIds'
 *   },
 * });
 */
export function useGetPurchaseRequirementsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPurchaseRequirementsQuery, GetPurchaseRequirementsQueryVariables> & ({ variables: GetPurchaseRequirementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPurchaseRequirementsQuery, GetPurchaseRequirementsQueryVariables>(GetPurchaseRequirementsDocument, options);
      }
export function useGetPurchaseRequirementsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPurchaseRequirementsQuery, GetPurchaseRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPurchaseRequirementsQuery, GetPurchaseRequirementsQueryVariables>(GetPurchaseRequirementsDocument, options);
        }
export function useGetPurchaseRequirementsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetPurchaseRequirementsQuery, GetPurchaseRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPurchaseRequirementsQuery, GetPurchaseRequirementsQueryVariables>(GetPurchaseRequirementsDocument, options);
        }
export type GetPurchaseRequirementsQueryHookResult = ReturnType<typeof useGetPurchaseRequirementsQuery>;
export type GetPurchaseRequirementsLazyQueryHookResult = ReturnType<typeof useGetPurchaseRequirementsLazyQuery>;
export type GetPurchaseRequirementsSuspenseQueryHookResult = ReturnType<typeof useGetPurchaseRequirementsSuspenseQuery>;
export type GetPurchaseRequirementsQueryResult = Apollo.QueryResult<GetPurchaseRequirementsQuery, GetPurchaseRequirementsQueryVariables>;
export const ShopPageFeaturedProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ShopPageFeaturedProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"availableCaFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cms_BooleanFilterInput_content"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shopPageFeatured"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lab_tests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Section"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Section"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StripeProductPriceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"stripe_product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_free_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_paid_member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price_current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price_usd"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShopPageStripeProductFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_StripeProductEntity_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StripeProductPriceFields"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"coming_soon"}},{"kind":"Field","name":{"kind":"Name","value":"out_of_stock"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Section"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cms_ComponentShopSectionShopSection_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Title"}},{"kind":"Field","name":{"kind":"Name","value":"Subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"CTA_Text"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"available_canada"},"value":{"kind":"Variable","name":{"kind":"Name","value":"availableCaFilter"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShopPageStripeProductFields"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useShopPageFeaturedProductsQuery__
 *
 * To run a query within a React component, call `useShopPageFeaturedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopPageFeaturedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopPageFeaturedProductsQuery({
 *   variables: {
 *      availableCaFilter: // value for 'availableCaFilter'
 *   },
 * });
 */
export function useShopPageFeaturedProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ShopPageFeaturedProductsQuery, ShopPageFeaturedProductsQueryVariables> & ({ variables: ShopPageFeaturedProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShopPageFeaturedProductsQuery, ShopPageFeaturedProductsQueryVariables>(ShopPageFeaturedProductsDocument, options);
      }
export function useShopPageFeaturedProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShopPageFeaturedProductsQuery, ShopPageFeaturedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShopPageFeaturedProductsQuery, ShopPageFeaturedProductsQueryVariables>(ShopPageFeaturedProductsDocument, options);
        }
export function useShopPageFeaturedProductsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ShopPageFeaturedProductsQuery, ShopPageFeaturedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ShopPageFeaturedProductsQuery, ShopPageFeaturedProductsQueryVariables>(ShopPageFeaturedProductsDocument, options);
        }
export type ShopPageFeaturedProductsQueryHookResult = ReturnType<typeof useShopPageFeaturedProductsQuery>;
export type ShopPageFeaturedProductsLazyQueryHookResult = ReturnType<typeof useShopPageFeaturedProductsLazyQuery>;
export type ShopPageFeaturedProductsSuspenseQueryHookResult = ReturnType<typeof useShopPageFeaturedProductsSuspenseQuery>;
export type ShopPageFeaturedProductsQueryResult = Apollo.QueryResult<ShopPageFeaturedProductsQuery, ShopPageFeaturedProductsQueryVariables>;
export const SupplementSuggestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupplementSuggestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"datetime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplement_suggestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"datetime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"datetime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"mostFrequentServing"},"name":{"kind":"Name","value":"most_frequent_serving"}},{"kind":"Field","alias":{"kind":"Name","value":"servingSize"},"name":{"kind":"Name","value":"serving_size"}},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"supplement_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useSupplementSuggestionQuery__
 *
 * To run a query within a React component, call `useSupplementSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplementSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplementSuggestionQuery({
 *   variables: {
 *      datetime: // value for 'datetime'
 *   },
 * });
 */
export function useSupplementSuggestionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SupplementSuggestionQuery, SupplementSuggestionQueryVariables> & ({ variables: SupplementSuggestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SupplementSuggestionQuery, SupplementSuggestionQueryVariables>(SupplementSuggestionDocument, options);
      }
export function useSupplementSuggestionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SupplementSuggestionQuery, SupplementSuggestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SupplementSuggestionQuery, SupplementSuggestionQueryVariables>(SupplementSuggestionDocument, options);
        }
export function useSupplementSuggestionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SupplementSuggestionQuery, SupplementSuggestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SupplementSuggestionQuery, SupplementSuggestionQueryVariables>(SupplementSuggestionDocument, options);
        }
export type SupplementSuggestionQueryHookResult = ReturnType<typeof useSupplementSuggestionQuery>;
export type SupplementSuggestionLazyQueryHookResult = ReturnType<typeof useSupplementSuggestionLazyQuery>;
export type SupplementSuggestionSuspenseQueryHookResult = ReturnType<typeof useSupplementSuggestionSuspenseQuery>;
export type SupplementSuggestionQueryResult = Apollo.QueryResult<SupplementSuggestionQuery, SupplementSuggestionQueryVariables>;
export const SupplementLogHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupplementLogHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serving_size"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useSupplementLogHistoryQuery__
 *
 * To run a query within a React component, call `useSupplementLogHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplementLogHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplementLogHistoryQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useSupplementLogHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SupplementLogHistoryQuery, SupplementLogHistoryQueryVariables> & ({ variables: SupplementLogHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SupplementLogHistoryQuery, SupplementLogHistoryQueryVariables>(SupplementLogHistoryDocument, options);
      }
export function useSupplementLogHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SupplementLogHistoryQuery, SupplementLogHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SupplementLogHistoryQuery, SupplementLogHistoryQueryVariables>(SupplementLogHistoryDocument, options);
        }
export function useSupplementLogHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SupplementLogHistoryQuery, SupplementLogHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SupplementLogHistoryQuery, SupplementLogHistoryQueryVariables>(SupplementLogHistoryDocument, options);
        }
export type SupplementLogHistoryQueryHookResult = ReturnType<typeof useSupplementLogHistoryQuery>;
export type SupplementLogHistoryLazyQueryHookResult = ReturnType<typeof useSupplementLogHistoryLazyQuery>;
export type SupplementLogHistorySuspenseQueryHookResult = ReturnType<typeof useSupplementLogHistorySuspenseQuery>;
export type SupplementLogHistoryQueryResult = Apollo.QueryResult<SupplementLogHistoryQuery, SupplementLogHistoryQueryVariables>;
export const DeleteSupplementLogRecordByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSupplementLogRecordById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_metric_record_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type DeleteSupplementLogRecordByIdMutationFn = Apollo.MutationFunction<DeleteSupplementLogRecordByIdMutation, DeleteSupplementLogRecordByIdMutationVariables>;

/**
 * __useDeleteSupplementLogRecordByIdMutation__
 *
 * To run a mutation, you first call `useDeleteSupplementLogRecordByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSupplementLogRecordByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSupplementLogRecordByIdMutation, { data, loading, error }] = useDeleteSupplementLogRecordByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSupplementLogRecordByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteSupplementLogRecordByIdMutation, DeleteSupplementLogRecordByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteSupplementLogRecordByIdMutation, DeleteSupplementLogRecordByIdMutationVariables>(DeleteSupplementLogRecordByIdDocument, options);
      }
export type DeleteSupplementLogRecordByIdMutationHookResult = ReturnType<typeof useDeleteSupplementLogRecordByIdMutation>;
export type DeleteSupplementLogRecordByIdMutationResult = Apollo.MutationResult<DeleteSupplementLogRecordByIdMutation>;
export type DeleteSupplementLogRecordByIdMutationOptions = Apollo.BaseMutationOptions<DeleteSupplementLogRecordByIdMutation, DeleteSupplementLogRecordByIdMutationVariables>;
export const CreateSupplementRecordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSupplementRecord"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSupplementRecordInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_supplement_record"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supplementId"}},{"kind":"Field","name":{"kind":"Name","value":"servings"}}]}}]}}]} as unknown as DocumentNode;
export type CreateSupplementRecordMutationFn = Apollo.MutationFunction<CreateSupplementRecordMutation, CreateSupplementRecordMutationVariables>;

/**
 * __useCreateSupplementRecordMutation__
 *
 * To run a mutation, you first call `useCreateSupplementRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplementRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplementRecordMutation, { data, loading, error }] = useCreateSupplementRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSupplementRecordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSupplementRecordMutation, CreateSupplementRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSupplementRecordMutation, CreateSupplementRecordMutationVariables>(CreateSupplementRecordDocument, options);
      }
export type CreateSupplementRecordMutationHookResult = ReturnType<typeof useCreateSupplementRecordMutation>;
export type CreateSupplementRecordMutationResult = Apollo.MutationResult<CreateSupplementRecordMutation>;
export type CreateSupplementRecordMutationOptions = Apollo.BaseMutationOptions<CreateSupplementRecordMutation, CreateSupplementRecordMutationVariables>;
export const TrackedQualitativeMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrackedQualitativeMetrics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dayAfterDateString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tracked_metric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tracked_metric_group"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"qualitative"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sort_order"}},{"kind":"Field","name":{"kind":"Name","value":"metric"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scale_label_low"}},{"kind":"Field","name":{"kind":"Name","value":"scale_label_high"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"display_name"}},{"kind":"Field","alias":{"kind":"Name","value":"unit"},"name":{"kind":"Name","value":"preference_unit"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metric_type"}},{"kind":"Field","name":{"kind":"Name","value":"metric_records"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateString"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"datetime_utc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dayAfterDateString"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_provided"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"preference_value"}},{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"data_source"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useTrackedQualitativeMetricsQuery__
 *
 * To run a query within a React component, call `useTrackedQualitativeMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackedQualitativeMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackedQualitativeMetricsQuery({
 *   variables: {
 *      dateString: // value for 'dateString'
 *      dayAfterDateString: // value for 'dayAfterDateString'
 *   },
 * });
 */
export function useTrackedQualitativeMetricsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TrackedQualitativeMetricsQuery, TrackedQualitativeMetricsQueryVariables> & ({ variables: TrackedQualitativeMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TrackedQualitativeMetricsQuery, TrackedQualitativeMetricsQueryVariables>(TrackedQualitativeMetricsDocument, options);
      }
export function useTrackedQualitativeMetricsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TrackedQualitativeMetricsQuery, TrackedQualitativeMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TrackedQualitativeMetricsQuery, TrackedQualitativeMetricsQueryVariables>(TrackedQualitativeMetricsDocument, options);
        }
export function useTrackedQualitativeMetricsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TrackedQualitativeMetricsQuery, TrackedQualitativeMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TrackedQualitativeMetricsQuery, TrackedQualitativeMetricsQueryVariables>(TrackedQualitativeMetricsDocument, options);
        }
export type TrackedQualitativeMetricsQueryHookResult = ReturnType<typeof useTrackedQualitativeMetricsQuery>;
export type TrackedQualitativeMetricsLazyQueryHookResult = ReturnType<typeof useTrackedQualitativeMetricsLazyQuery>;
export type TrackedQualitativeMetricsSuspenseQueryHookResult = ReturnType<typeof useTrackedQualitativeMetricsSuspenseQuery>;
export type TrackedQualitativeMetricsQueryResult = Apollo.QueryResult<TrackedQualitativeMetricsQuery, TrackedQualitativeMetricsQueryVariables>;
export const UpdateTrackedMetricManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTrackedMetricMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"tracked_metric_updates"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_tracked_metric_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sort_order"}}]}}]}}]}}]} as unknown as DocumentNode;
export type UpdateTrackedMetricManyMutationFn = Apollo.MutationFunction<UpdateTrackedMetricManyMutation, UpdateTrackedMetricManyMutationVariables>;

/**
 * __useUpdateTrackedMetricManyMutation__
 *
 * To run a mutation, you first call `useUpdateTrackedMetricManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackedMetricManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackedMetricManyMutation, { data, loading, error }] = useUpdateTrackedMetricManyMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateTrackedMetricManyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTrackedMetricManyMutation, UpdateTrackedMetricManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTrackedMetricManyMutation, UpdateTrackedMetricManyMutationVariables>(UpdateTrackedMetricManyDocument, options);
      }
export type UpdateTrackedMetricManyMutationHookResult = ReturnType<typeof useUpdateTrackedMetricManyMutation>;
export type UpdateTrackedMetricManyMutationResult = Apollo.MutationResult<UpdateTrackedMetricManyMutation>;
export type UpdateTrackedMetricManyMutationOptions = Apollo.BaseMutationOptions<UpdateTrackedMetricManyMutation, UpdateTrackedMetricManyMutationVariables>;
export const RelatedContentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RelatedContents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedContents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entity_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity_id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useRelatedContentsQuery__
 *
 * To run a query within a React component, call `useRelatedContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedContentsQuery({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useRelatedContentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RelatedContentsQuery, RelatedContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RelatedContentsQuery, RelatedContentsQueryVariables>(RelatedContentsDocument, options);
      }
export function useRelatedContentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RelatedContentsQuery, RelatedContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RelatedContentsQuery, RelatedContentsQueryVariables>(RelatedContentsDocument, options);
        }
export function useRelatedContentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RelatedContentsQuery, RelatedContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RelatedContentsQuery, RelatedContentsQueryVariables>(RelatedContentsDocument, options);
        }
export type RelatedContentsQueryHookResult = ReturnType<typeof useRelatedContentsQuery>;
export type RelatedContentsLazyQueryHookResult = ReturnType<typeof useRelatedContentsLazyQuery>;
export type RelatedContentsSuspenseQueryHookResult = ReturnType<typeof useRelatedContentsSuspenseQuery>;
export type RelatedContentsQueryResult = Apollo.QueryResult<RelatedContentsQuery, RelatedContentsQueryVariables>;